/* Generated by scripts/generate-opening-book.mjs from lichess-org/chess-openings.
 * Source asset revision: 8529502cbd8508d55887daa641a59b0726df75f7; content SHA-256: 2c0f0fe3f6a9a6e08d0e7b264785b9b3f67da9f1134d841fe42e16bad527be70.
 * Dataset license: CC0 1.0; see apps/backend/src/assets/chess-openings/COPYING.txt.
 */
export const BOOK_SOURCE = {
  revision: "8529502cbd8508d55887daa641a59b0726df75f7",
  digest: "2c0f0fe3f6a9a6e08d0e7b264785b9b3f67da9f1134d841fe42e16bad527be70",
  license: "CC0-1.0",
} as const;
export const BOOK_ENTRIES: ReadonlyArray<readonly [string, string | null, string | null]> = [
  ["1nbqkb1r/1ppp1ppp/4pn2/1P6/8/8/1BPPPPPP/rN1QKBNR w Kk - b2a1", "A00", "Polish Opening: Rooks Swap Line"],
  ["1rb2rk1/pp2nppp/2n2q2/3N4/4P3/2P1Q3/PP3PPP/RN2KB1R b KQ - e7d5", null, null],
  ["1rb2rk1/pp3ppp/2n2q2/3n4/4P3/2P1Q3/PP3PPP/RN2KB1R w KQ - e4d5", null, null],
  ["1rb2rk1/pp3ppp/2n2q2/3P4/8/2P1Q3/PP3PPP/RN2KB1R b KQ - c6b4", "C45", "Scotch Game: Gottschall Variation"],
  ["1rb2rk1/ppN1nppp/2n2q2/3p4/4P3/2P1Q3/PP3PPP/RN2KB1R w KQ - c7d5", null, null],
  ["1rbq1rk1/1p2ppbp/p2p1np1/n1pP4/2P5/1PN3P1/P1QNPPBP/R1B2RK1 b - - b7b5", null, null],
  ["1rbq1rk1/1p2ppbp/p2p1np1/n1pP4/2P5/2N3P1/PPQNPPBP/R1B2RK1 w - - b2b3", null, null],
  ["1rbq1rk1/1pp1ppbp/p1np1np1/8/2PP4/2N1BNPP/PP2PPB1/R2Q1RK1 b - - b7b5", null, null],
  ["1rbq1rk1/1pp1ppbp/p1np1np1/8/2PP4/2N2NPP/PP2PPB1/R1BQ1RK1 w - - c1e3", null, null],
  [
    "1rbq1rk1/2p1ppbp/p1np1np1/1p6/2PP4/2N1BNPP/PP2PPB1/R2Q1RK1 w - - f3d2",
    "E63",
    "King's Indian Defense: Fianchetto Variation, Panno Variation, Korchnoi Line",
  ],
  ["1rbq1rk1/4ppbp/p2p1np1/n1pP4/2p5/1PN3P1/PBQNPPBP/R4RK1 w - - b3c4", null, null],
  [
    "1rbq1rk1/4ppbp/p2p1np1/n1pP4/2P5/2N3P1/PBQNPPBP/R4RK1 b - - g7h6",
    "E63",
    "King's Indian Defense: Fianchetto Variation, Panno Variation, Donner Line",
  ],
  ["1rbq1rk1/4ppbp/p2p1np1/nppP4/2P5/1PN3P1/P1QNPPBP/R1B2RK1 w - - c1b2", null, null],
  ["1rbq1rk1/4ppbp/p2p1np1/nppP4/2P5/1PN3P1/PBQNPPBP/R4RK1 b - - b5c4", null, null],
  [
    "2kr1b1r/pppq1ppp/1nn1p3/4Pb2/2PP4/2N1BN2/PP2B1PP/R2Q1RK1 b - - f8e7",
    "B03",
    "Alekhine Defense: Four Pawns Attack, Tartakower Variation",
  ],
  ["2kr1b1r/pppq1ppp/1nn1p3/4Pb2/2PP4/2N1BN2/PP2B1PP/R2QK2R w KQ - e1g1", null, null],
  ["2rq1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/2KR3R w - - c4b3", null, null],
  ["2rq1rk1/pp1bppbp/2np1np1/8/3NP3/1BN1BP2/PPPQ2PP/2KR3R b - - c6d4", null, null],
  [
    "2rq1rk1/pp1bppbp/3p1np1/8/3nP3/1BN1BP2/PPPQ2PP/2KR3R w - - e3d4",
    "B78",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Topalov Variation",
  ],
  ["4rrk1/5ppp/p1pb4/1p1n4/3P2b1/1BPQB1Pq/PP1N1P1P/R3R1K1 b - - e8e6", null, null],
  ["4rrk1/5ppp/p1pb4/1p1n4/3P2b1/1BPQB1Pq/PP3P1P/RN2R1K1 w - - b1d2", null, null],
  ["5rk1/5ppp/p1pbr3/1p1n4/3P2b1/1BPQB1Pq/PP1N1P1P/R3R1K1 w - - a2a4", null, null],
  [
    "5rk1/5ppp/p1pbr3/1p1n4/P2P2b1/1BPQB1Pq/1P1N1P1P/R3R1K1 b - - h3h5",
    "C89",
    "Ruy Lopez: Marshall Attack, Main Line, Spassky Variation",
  ],
  [
    "B2qkbnr/p1pnpppp/8/8/2Pp2b1/8/PP1PPP1P/RNBQK1NR b KQk - d8a8",
    "A00",
    "Grob Opening: Grob Gambit, Fritz Gambit, Romford Countergambit",
  ],
  [
    "N1bk1b1r/pp1pq2p/2nn2p1/3Qpp2/8/1B6/PPPP1PPP/R1B1K1NR b KQ - b7b6",
    "C27",
    "Vienna Game: Stanley Variation, Frankenstein-Dracula Variation",
  ],
  ["r1b1k1nr/1pp1qppp/pbnp4/4p3/P1BPP3/2P2N1P/1P3PP1/RNBQ1RK1 b kq - g8f6", null, null],
  ["r1b1k1nr/1pp1qppp/pbnp4/4p3/P1BPP3/2P2N2/1P3PPP/RNBQ1RK1 w kq - h2h3", null, null],
  ["r1b1k1nr/pp3ppp/2n1p3/q1ppP3/3P4/P1P2N2/2P2PPP/R1BQKB1R w KQkq - c1d2", null, null],
  [
    "r1b1k1nr/pp3ppp/2n1p3/q1ppP3/3P4/P1P2N2/2PB1PPP/R2QKB1R b KQkq - g8e7",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  [
    "r1b1k1nr/pp3ppp/2n5/3qp3/1b1P4/2N2N2/PP3PPP/R1BQKB1R w KQkq - f1e2",
    "B22",
    "Sicilian Defense: Alapin Variation, Barmen Defense, Milner-Barry Attack",
  ],
  ["r1b1k1nr/ppp1qppp/1bnp4/4p3/2BPP3/2P2N2/PP3PPP/RNBQ1RK1 w kq - a2a4", null, null],
  ["r1b1k1nr/ppp1qppp/1bnp4/4p3/P1BPP3/2P2N2/1P3PPP/RNBQ1RK1 b kq - a7a6", null, null],
  [
    "r1b1k1nr/ppp2ppp/2n5/3q4/3p4/2B1P3/PP3PPP/R2QKBNR w KQkq - g1e2",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense, Exchange Variation, Costa's Line",
  ],
  ["r1b1k1nr/ppp2ppp/2n5/3qp3/1b1P4/2N1P3/PP1B1PPP/R2QKBNR b KQkq - b4c3", null, null],
  ["r1b1k1nr/ppp2ppp/2n5/3qp3/1b1P4/2N1P3/PP3PPP/R1BQKBNR w KQkq - c1d2", null, null],
  ["r1b1k1nr/ppp2ppp/2n5/3qp3/3P4/2b1P3/PP1B1PPP/R2QKBNR w KQkq - d2c3", null, null],
  ["r1b1k1nr/ppp2ppp/2n5/3qp3/3P4/2B1P3/PP3PPP/R2QKBNR b KQkq - e5d4", null, null],
  [
    "r1b1k1nr/ppp2ppp/2n5/q3P3/1b6/2N2N2/PPP2PPP/R1BQKB1R w KQkq - c1d2",
    "B01",
    "Scandinavian Defense: Anderssen Counterattack, Orthodox Attack",
  ],
  ["r1b1k1nr/pppp1Bpp/1b6/nP2N1q1/4P3/8/P1PP1PPP/RNBQK2R b KQkq - e8e7", null, null],
  ["r1b1k1nr/pppp1ppp/1b6/nP2N1q1/2B1P3/5Q2/P1PP1PPP/RNB1K2R b KQkq - g5e5", null, null],
  ["r1b1k1nr/pppp1ppp/1b6/nP2N1q1/2B1P3/8/P1PP1PPP/RNBQK2R w KQkq - c4f7", null, null],
  ["r1b1k1nr/pppp1ppp/1b6/nP2N1q1/2B1P3/8/P1PP1PPP/RNBQK2R w KQkq - d1f3", null, null],
  ["r1b1k1nr/pppp1ppp/1b6/nP2q3/2B1P3/5Q2/P1PP1PPP/RNB1K2R w KQkq - f3f7", null, null],
  [
    "r1b1k1nr/pppp1ppp/2n2q2/2b1p3/2B1P1Q1/2N5/PPPP1PPP/R1B1K1NR w KQkq - c3d5",
    "C25",
    "Vienna Game: Stanley Variation, Meitner-Mieses Gambit",
  ],
  [
    "r1b1k1nr/pppp1ppp/2n2q2/2b5/3NP3/2P1B3/PP3PPP/RN1QKB1R b KQkq - f6g6",
    "C45",
    "Scotch Game: Classical Variation, Millennium Variation",
  ],
  ["r1b1k1nr/pppp1ppp/2n2q2/2b5/3NP3/2P1B3/PP3PPP/RN1QKB1R b KQkq - g8e7", null, null],
  ["r1b1k1nr/pppp1ppp/2n2q2/2b5/3NP3/4B3/PPP2PPP/RN1QKB1R w KQkq - c2c3", null, null],
  ["r1b1k1nr/pppp1ppp/2n2q2/2b5/3NP3/4B3/PPP2PPP/RN1QKB1R w KQkq - d4b5", "C45", "Scotch Game: Blumenfeld Attack"],
  ["r1b1k1nr/pppp1ppp/2n2q2/b3P3/2B5/1Qp2N2/P4PPP/RNB2RK1 b kq - f6g6", null, null],
  ["r1b1k1nr/pppp1ppp/2n2q2/b7/2B1P3/1Qp2N2/P4PPP/RNB2RK1 w kq - e4e5", null, null],
  ["r1b1k1nr/pppp1ppp/2n3q1/b3P3/2B5/1QN2N2/P4PPP/R1B2RK1 b kq - g8e7", null, null],
  ["r1b1k1nr/pppp1ppp/2n3q1/b3P3/2B5/1Qp2N2/P4PPP/RNB2RK1 w kq - b1c3", null, null],
  ["r1b1k1nr/pppp1ppp/2n5/1N6/1b2P2q/8/PPP2PPP/RNBQKB1R w KQkq - c1d2", "C45", "Scotch Game"],
  ["r1b1k1nr/pppp1ppp/2n5/1N6/1b2P2q/8/PPPB1PPP/RN1QKB1R b KQkq - h4e4", null, null],
  ["r1b1k1nr/pppp1ppp/2n5/1N6/1b2q3/8/PPPB1PPP/RN1QKB1R w KQkq - f1e2", null, null],
  ["r1b1k1nr/pppp1ppp/2n5/1N6/1b2q3/8/PPPBBPPP/RN1QK2R b KQkq - e8d8", null, null],
  ["r1b1k1nr/pppp1Qpp/1b6/nP2q3/2B1P3/8/P1PP1PPP/RNB1K2R b KQkq - e8d8", null, null],
  ["r1b1k1nr/ppppqppp/1bn5/3Pp3/2B1P3/2P2N2/PP3PPP/RNBQK2R b KQkq - c6b8", null, null],
  ["r1b1k1nr/ppppqppp/1bn5/4p3/2BPP3/2P2N2/PP3PPP/RNBQ1RK1 b kq - d7d6", null, null],
  [
    "r1b1k1nr/ppppqppp/1bn5/4p3/2BPP3/2P2N2/PP3PPP/RNBQK2R w KQkq - c1g5",
    "C53",
    "Italian Game: Classical Variation, Mestel Variation",
  ],
  ["r1b1k1nr/ppppqppp/1bn5/4p3/2BPP3/2P2N2/PP3PPP/RNBQK2R w KQkq - d4d5", null, null],
  ["r1b1k1nr/ppppqppp/1bn5/4p3/2BPP3/2P2N2/PP3PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1b1k1nr/ppppqppp/2n5/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - d2d4", null, null],
  [
    "r1b1k1nr/ppppqppp/2n5/2b1p3/2BPP3/2P2N2/PP3PPP/RNBQK2R b KQkq - c5b6",
    "C53",
    "Italian Game: Classical Variation, Center Holding Variation",
  ],
  [
    "r1b1k1nr/pppq1ppp/1b6/n3p3/2B1P3/BQP2N2/P4PPP/RN3RK1 w kq - f3e5",
    "C52",
    "Italian Game: Evans Gambit, Levenfish Variation",
  ],
  ["r1b1k1nr/pppq1ppp/1bn5/4p3/2B1P3/1QP2N2/P4PPP/RNB2RK1 w kq - c1a3", null, null],
  ["r1b1k1nr/pppq1ppp/1bn5/4p3/2B1P3/BQP2N2/P4PPP/RN3RK1 b kq - c6a5", null, null],
  ["r1b1k1nr/pppq1ppp/2n5/b3p3/2B1P3/1QP2N2/P4PPP/RNB1K2R w KQkq - e1g1", null, null],
  ["r1b1k1nr/pppq1ppp/2n5/b3p3/2B1P3/1QP2N2/P4PPP/RNB2RK1 b kq - a5b6", null, null],
  ["r1b1k1nr/pppq1ppp/2np4/b3P3/2B1P3/1QP2N2/P4PPP/RNB1K2R b KQkq - d6e5", null, null],
  ["r1b1k1nr/pppq1ppp/2np4/b3p3/2BPP3/1QP2N2/P4PPP/RNB1K2R w KQkq - d4e5", null, null],
  [
    "r1b1k2r/1pp1qppp/pbnp1n2/4p3/P1BPP3/2P2N1P/1P3PP1/RNBQ1RK1 w kq - f1e1",
    "C53",
    "Italian Game: Classical Variation, Tarrasch Variation",
  ],
  ["r1b1k2r/1pq1bppp/p1nppn2/8/3NPP2/2N1B3/PPP1B1PP/R2Q1RK1 w kq - d1e1", null, null],
  [
    "r1b1k2r/1pq1bppp/p1nppn2/8/3NPP2/2N1B3/PPP1B1PP/R3QRK1 b kq - e8g8",
    "B85",
    "Sicilian Defense: Scheveningen Variation, Classical Main Line",
  ],
  [
    "r1b1k2r/1pq1bppp/p1nppn2/8/3NPP2/2N5/PPP1B1PP/R1BQ1R1K w kq - a2a4",
    "B85",
    "Sicilian Defense: Scheveningen Variation, Classical Variation, Paulsen Variation",
  ],
  ["r1b1k2r/1pqpbppp/p1n1pn2/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 w kq - f2f4", null, null],
  ["r1b1k2r/1pqpbppp/p1n1pn2/8/3NP3/2N5/PPP1BPPP/R1BQ1R1K w kq - f2f4", null, null],
  ["r1b1k2r/1pqpbppp/p1n1pn2/8/3NPP2/2N1B3/PPP1B1PP/R2Q1RK1 b kq - d7d6", null, null],
  ["r1b1k2r/1pqpbppp/p1n1pn2/8/3NPP2/2N5/PPP1B1PP/R1BQ1R1K b kq - d7d6", null, null],
  ["r1b1k2r/2q1bppp/p1np1n2/1pp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1 w kq - d4d5", null, null],
  ["r1b1k2r/2q1bppp/p1np1n2/1ppPp3/4P3/2P2N1P/PPB2PP1/RNBQR1K1 b kq - c6b8", null, null],
  ["r1b1k2r/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1 b kq - a5c6", null, null],
  [
    "r1b1k2r/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N2/PPB2PPP/RNBQR1K1 w kq - a2a4",
    "C88",
    "Ruy Lopez: Closed, Balla Variation",
  ],
  ["r1b1k2r/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N2/PPB2PPP/RNBQR1K1 w kq - b1d2", null, null],
  ["r1b1k2r/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N2/PPB2PPP/RNBQR1K1 w kq - h2h3", null, null],
  ["r1b1k2r/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N2/PPBN1PPP/R1BQR1K1 b kq - e8g8", null, null],
  [
    "r1b1k2r/p1q2pp1/2pb1n1p/n3N3/3Pp3/8/PPP1BPPP/RNBQK2R w KQkq - c1d2",
    "C59",
    "Italian Game: Two Knights Defense, Knorre Variation",
  ],
  [
    "r1b1k2r/pp1n1ppp/2p1pn2/q2p2B1/1bPP4/2N1P3/PP1N1PPP/R2QKB1R w KQkq - d1c2",
    "D52",
    "Queen's Gambit Declined: Cambridge Springs Defense, Bogoljubow Variation",
  ],
  ["r1b1k2r/pp1n1ppp/2p1pn2/q2p2B1/1bPP4/2N1P3/PPQN1PPP/R3KB1R b KQkq - e8g8", null, null],
  [
    "r1b1k2r/pp2nppp/2n1p3/q1ppP3/P2P4/2P2N2/2P2PPP/R1BQKB1R w KQkq - c1d2",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  [
    "r1b1k2r/pp2nppp/2n1p3/q1ppP3/P2P4/2P2N2/2P2PPP/R1BQKB1R w KQkq - d1d2",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  [
    "r1b1k2r/pp2nppp/2n1p3/q1ppP3/P2P4/2P2N2/2PB1PPP/R2QKB1R b KQkq - c5c4",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  [
    "r1b1k2r/pp2nppp/2n1p3/q1ppP3/P2P4/2P2N2/2PB1PPP/R2QKB1R b KQkq - c8d7",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  [
    "r1b1k2r/pp2nppp/2n1p3/q1ppP3/P2P4/2P2N2/2PQ1PPP/R1B1KB1R b KQkq - c8d7",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  ["r1b1k2r/ppp1nppp/2n2q2/1N1p4/4P3/2P1b3/PP1Q1PPP/RN2KB1R w KQkq - d2e3", null, null],
  ["r1b1k2r/ppp1nppp/2n2q2/1N1p4/4P3/2P1Q3/PP3PPP/RN2KB1R b KQkq - e8g8", null, null],
  ["r1b1k2r/ppp1nppp/2n2q2/1Nbp4/4P3/2P1B3/PP1Q1PPP/RN2KB1R b KQkq - c5e3", null, null],
  ["r1b1k2r/ppp1nppp/2n2q2/2bp4/3NP3/2P1B3/PP1Q1PPP/RN2KB1R w KQkq - d4b5", null, null],
  ["r1b1k2r/ppp1qppp/3p1n2/4P1B1/2BnP3/8/PPP3PP/RN1Q1RK1 b kq - d6e5", null, null],
  ["r1b1k2r/ppp1qppp/3p1n2/4p1B1/2BnPP2/8/PPP3PP/RN1Q1RK1 w kq - f4e5", null, null],
  [
    "r1b1k2r/ppp1qppp/5n2/4p1B1/2BnP3/8/PPP3PP/RN1Q1RK1 w kq - b1c3",
    "C54",
    "Italian Game: Giuoco Piano, Holzhausen Attack",
  ],
  [
    "r1b1k2r/ppppnp1p/2n4b/4q3/2B2p2/2NP1Q2/PPPB2PP/R4RK1 w kq - a1e1",
    "C37",
    "King's Gambit Accepted: Double Muzio Gambit, Paulsen Defense",
  ],
  [
    "r1b1k2r/ppppnppp/2n2q2/1Bb5/3NP3/2P1B3/PP3PPP/RN1QK2R b KQkq - c6d8",
    "C45",
    "Scotch Game: Paulsen, Gunsberg Defense",
  ],
  ["r1b1k2r/ppppnppp/2n2q2/2b5/3NP3/2P1B3/PP1Q1PPP/RN2KB1R b KQkq - d7d5", null, null],
  [
    "r1b1k2r/ppppnppp/2n2q2/2b5/3NP3/2P1B3/PP3PPP/RN1QKB1R w KQkq - d1d2",
    "C45",
    "Scotch Game: Classical Variation, Blackburne Attack",
  ],
  ["r1b1k2r/ppppnppp/2n2q2/2b5/3NP3/2P1B3/PP3PPP/RN1QKB1R w KQkq - d4c2", "C45", "Scotch Game: Meitner Variation"],
  ["r1b1k2r/ppppnppp/2n2q2/2b5/3NP3/2P1B3/PP3PPP/RN1QKB1R w KQkq - f1b5", "C45", "Scotch Game: Paulsen Attack"],
  [
    "r1b1k2r/ppppnppp/2n3q1/b3P3/2B5/1QN2N2/P4PPP/R1B2RK1 w kq - c1a3",
    "C52",
    "Italian Game: Evans Gambit, Compromised Defense, Main Line",
  ],
  [
    "r1b1k2r/ppppnppp/2n3q1/b3P3/2B5/1QN2N2/P4PPP/R1B2RK1 w kq - f1d1",
    "C52",
    "Italian Game: Evans Gambit, Compromised Defense, Potter Variation",
  ],
  ["r1b1kb1r/1p1n1ppp/p2ppn2/q5B1/2BNP3/2N5/PPPQ1PPP/2KR3R b kq - b7b5", null, null],
  ["r1b1kb1r/1p1n1ppp/p2ppn2/q5B1/2BNP3/2N5/PPPQ1PPP/R3K2R w KQkq - e1c1", null, null],
  ["r1b1kb1r/1p1npppp/p2p1n2/q5B1/2BNP3/2N5/PPP2PPP/R2QK2R w KQkq - d1d2", null, null],
  ["r1b1kb1r/1p1npppp/p2p1n2/q5B1/2BNP3/2N5/PPPQ1PPP/R3K2R b KQkq - e7e6", null, null],
  ["r1b1kb1r/1pp2ppp/p1p5/4N3/3qN3/8/PPPP1PPP/R1BQ1RK1 b kq - d4e5", null, null],
  ["r1b1kb1r/1pp2ppp/p1p5/4N3/3qN3/8/PPPP1PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1b1kb1r/1pp2ppp/p1p5/4q3/4N3/8/PPPP1PPP/R1BQ1RK1 w kq - f1e1", null, null],
  ["r1b1kb1r/1pp2ppp/p1p5/4q3/4N3/8/PPPP1PPP/R1BQR1K1 b kq - c8e6", null, null],
  [
    "r1b1kb1r/1pq2ppp/p1nppn2/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 w kq - f2f4",
    "B85",
    "Sicilian Defense: Scheveningen Variation, Classical Variation, Paulsen Variation",
  ],
  ["r1b1kb1r/1pqp1ppp/p1n1pn2/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 b kq - d7d6", null, null],
  ["r1b1kb1r/1pqp1ppp/p1n1pn2/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 b kq - f8e7", null, null],
  ["r1b1kb1r/1pqp1ppp/p1n1pn2/8/3NP3/2N5/PPP1BPPP/R1BQ1R1K b kq - f8e7", null, null],
  ["r1b1kb1r/1pqp1ppp/p1n1pn2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 w kq - c1e3", null, null],
  ["r1b1kb1r/1pqp1ppp/p1n1pn2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 w kq - g1h1", null, null],
  ["r1b1kb1r/3n1ppp/p2ppn2/qp4B1/2BNP3/2N5/PPPQ1PPP/2KR3R w kq - c4b3", null, null],
  ["r1b1kb1r/3n1ppp/p2ppn2/qp4B1/3NP3/1BN5/PPPQ1PPP/2KR3R b kq - c8b7", null, null],
  ["r1b1kb1r/5ppp/4pn2/1p1qN3/3p4/3B4/PP2QPPP/R1B2RK1 b kq - c8a6", null, null],
  ["r1b1kb1r/5ppp/4pn2/1p1qN3/3p4/3B4/PP3PPP/R1BQ1RK1 w kq - d1e2", null, null],
  [
    "r1b1kb1r/p1q2ppp/2p2n2/nB2p1N1/8/5Q2/PPPP1PPP/RNB1K2R w KQkq - b5d3",
    "C58",
    "Italian Game: Two Knights Defense, Paoli Variation",
  ],
  [
    "r1b1kb1r/pp1n1ppp/2p1pn2/q2p2B1/2PP4/2N1P3/PP1N1PPP/R2QKB1R b KQkq - d5c4",
    "D52",
    "Queen's Gambit Declined: Cambridge Springs Defense, Rubinstein Variation",
  ],
  ["r1b1kb1r/pp1n1ppp/2p1pn2/q2p2B1/2PP4/2N1P3/PP1N1PPP/R2QKB1R b KQkq - f8b4", null, null],
  [
    "r1b1kb1r/pp1n1ppp/2p1pn2/q2p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQkq - c4d5",
    "D52",
    "Queen's Gambit Declined: Cambridge Springs Defense",
  ],
  ["r1b1kb1r/pp1n1ppp/2p1pn2/q2p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQkq - f3d2", null, null],
  [
    "r1b1kb1r/pp1n1ppp/2p1pn2/q2p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQkq - g5f6",
    "D52",
    "Queen's Gambit Declined: Cambridge Springs Defense, Capablanca Variation",
  ],
  [
    "r1b1kb1r/pp1n1ppp/2p1pn2/q2p2B1/2PP4/2N2N2/PP2PPPP/2RQKB1R w Kkq - g5d2",
    "D51",
    "Queen's Gambit Declined: Rochlin Variation",
  ],
  [
    "r1b1kb1r/pp1n1ppp/2p1pn2/q2P2B1/3P4/2N1PN2/PP3PPP/R2QKB1R b KQkq - f6d5",
    "D52",
    "Queen's Gambit Declined: Cambridge Springs Defense, Yugoslav Variation",
  ],
  ["r1b1kb1r/pp2pppp/2np4/q2P4/4n3/2N2N2/PP2BPPP/R1BQK2R b KQkq - e4c3", null, null],
  ["r1b1kb1r/pp2pppp/2np4/q2P4/4n3/5N2/PP2BPPP/RNBQK2R w KQkq - b1c3", null, null],
  [
    "r1b1kb1r/pp2pppp/2np4/q2P4/8/2n2N2/PP2BPPP/R1BQK2R w KQkq - b2c3",
    "B50",
    "Sicilian Defense: Delayed Alapin Variation, Basman-Palatnik Double Gambit",
  ],
  ["r1b1kb1r/pp3ppp/2nqpn2/8/2BN4/5N2/PPP2PPP/R1BQ1RK1 b kq - c6d4", null, null],
  ["r1b1kb1r/pp3ppp/2nqpn2/8/2Bp4/1N3N2/PPP2PPP/R1BQ1RK1 w kq - b3d4", null, null],
  ["r1b1kb1r/pp3ppp/3qpn2/8/2Bn4/5N2/PPP2PPP/R1BQ1RK1 w kq - f3d4", null, null],
  [
    "r1b1kb1r/pp3ppp/3qpn2/8/2BN4/8/PPP2PPP/R1BQ1RK1 b kq - a7a6",
    "C07",
    "French Defense: Tarrasch Variation, Chistyakov Defense, Modern Line",
  ],
  ["r1b1kb1r/ppNpq2p/2nn2p1/3Qpp2/8/1B6/PPPP1PPP/R1B1K1NR b KQkq - e8d8", null, null],
  ["r1b1kb1r/ppp2ppp/2n5/3q4/3pn3/2N2N2/PPP2PPP/R1BQR1K1 b kq - d5a5", null, null],
  [
    "r1b1kb1r/ppp2ppp/2n5/3q4/3pn3/5N2/PPP2PPP/RNBQR1K1 w kq - b1c3",
    "C56",
    "Italian Game: Scotch Gambit, Anderssen Attack",
  ],
  ["r1b1kb1r/ppp2ppp/2n5/q7/3pn3/2N2N2/PPP2PPP/R1BQR1K1 w kq - c3e4", null, null],
  ["r1b1kb1r/ppp2ppp/2n5/q7/3pN3/5N2/PPP2PPP/R1BQR1K1 b kq - c8e6", null, null],
  ["r1b1kb1r/ppppq2p/2nn2p1/1N1Qpp2/8/1B6/PPPP1PPP/R1B1K1NR w KQkq - b5c7", null, null],
  [
    "r1b1kb1r/ppppqppp/5n2/1B2N3/3nP3/2N5/PPPP1PPP/R1BQK2R w KQkq - f2f4",
    "C48",
    "Four Knights Game: Spanish Variation, Rubinstein Variation",
  ],
  ["r1b1kb1r/ppqp1ppp/2n1pn2/8/2B1P3/2N2N2/PP2QPPP/R1B1K2R w KQkq - e1g1", null, null],
  [
    "r1b1kb1r/ppqp1ppp/2n1pn2/8/2B1P3/2N2N2/PP2QPPP/R1B2RK1 b kq - f6g4",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Siberian Variation, Siberian Trap",
  ],
  ["r1b1kb1r/ppqppppp/1nn5/4P3/2p5/2P2N2/PPBP1PPP/RNBQK2R w KQkq - d1e2", null, null],
  [
    "r1b1kb1r/ppqppppp/1nn5/4P3/2p5/2P2N2/PPBPQPPP/RNB1K2R b KQkq - g7g5",
    "B22",
    "Sicilian Defense: Alapin Variation, Stoltz Attack, Ivanchuk Line",
  ],
  ["r1b1kbnr/1pp2ppp/p1p5/8/3NP3/8/PPP2PPP/RNB1K2R b KQkq - c8d7", "C68", "Ruy Lopez: Exchange, Alekhine Variation"],
  [
    "r1b1kbnr/1pp2ppp/p1p5/8/3NP3/8/PPP2PPP/RNB1K2R b KQkq - f8d6",
    "C68",
    "Ruy Lopez: Exchange Variation, Alekhine Variation",
  ],
  ["r1b1kbnr/1pp2ppp/p1p5/8/3qP3/5N2/PPP2PPP/RNB1K2R w KQkq - f3d4", null, null],
  ["r1b1kbnr/1pqp1ppp/p1n1p3/8/2B1P3/2N2N2/PP2QPPP/R1B1K2R w KQkq - e1g1", null, null],
  [
    "r1b1kbnr/1pqp1ppp/p1n1p3/8/2B1P3/2N2N2/PP2QPPP/R1B2RK1 b kq - f8d6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Larsen Defense",
  ],
  [
    "r1b1kbnr/1pqp1ppp/p1n1p3/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - f1e2",
    "B49",
    "Sicilian Defense: Taimanov Variation, Bastrikov Variation",
  ],
  ["r1b1kbnr/1pqp1ppp/p1n1p3/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 b kq - g8f6", null, null],
  ["r1b1kbnr/1pqp1ppp/p1n1p3/8/3NP3/2N5/PPP1BPPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1b1kbnr/pp1p1ppp/3P1qn1/1N6/5P2/8/PPP3PP/R1BQKB1R b KQkq - a8b8",
    "C47",
    "Four Knights Game: Halloween Gambit, Plasma Variation",
  ],
  ["r1b1kbnr/pp1p1ppp/3P1qn1/8/5P2/2N5/PPP3PP/R1BQKB1R w KQkq - c3b5", null, null],
  ["r1b1kbnr/pp2pppp/2n5/2pq4/3P4/2P2N2/PP3PPP/RNBQKB1R b KQkq - c5d4", null, null],
  ["r1b1kbnr/pp2pppp/2n5/2pq4/3P4/2P5/PP3PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["r1b1kbnr/pp2pppp/2n5/3q4/3p4/2P2N2/PP3PPP/RNBQKB1R w KQkq - c3d4", null, null],
  [
    "r1b1kbnr/pp2pppp/2n5/3q4/3P4/5N2/PP3PPP/RNBQKB1R b KQkq - c8g4",
    "B22",
    "Sicilian Defense: Alapin Variation, Barmen Defense, Central Exchange",
  ],
  ["r1b1kbnr/pp2pppp/2n5/3q4/3P4/5N2/PP3PPP/RNBQKB1R b KQkq - e7e5", null, null],
  ["r1b1kbnr/pp2pppp/2n5/3q4/3P4/8/PP3PPP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "r1b1kbnr/pp3ppp/1qn1p3/2ppP3/3P4/2P2N2/PP3PPP/RNBQKB1R w KQkq - a2a3",
    "C02",
    "French Defense: Advance Variation, Main Line",
  ],
  [
    "r1b1kbnr/pp3ppp/1qn1p3/2ppP3/3P4/2P2N2/PP3PPP/RNBQKB1R w KQkq - f1d3",
    "C02",
    "French Defense: Advance Variation, Milner-Barry Gambit",
  ],
  ["r1b1kbnr/pp3ppp/1qn1p3/2ppP3/3P4/2PB1N2/PP3PPP/RNBQK2R b KQkq - c5d4", null, null],
  [
    "r1b1kbnr/pp3ppp/1qn1p3/2ppP3/3P4/P1P2N2/1P3PPP/RNBQKB1R b KQkq - g8h6",
    "C02",
    "French Defense: Advance Variation, Lputian Variation",
  ],
  ["r1b1kbnr/pp3ppp/1qn1p3/3pP3/3p4/2PB1N2/PP3PPP/RNBQ1RK1 b kq - c8d7", null, null],
  ["r1b1kbnr/pp3ppp/1qn1p3/3pP3/3p4/2PB1N2/PP3PPP/RNBQK2R w KQkq - c3d4", null, null],
  [
    "r1b1kbnr/pp3ppp/1qn1p3/3pP3/3p4/2PB1N2/PP3PPP/RNBQK2R w KQkq - e1g1",
    "C02",
    "French Defense: Advance Variation, Milner-Barry Gambit, Hector Variation",
  ],
  ["r1b1kbnr/pp3ppp/1qn1p3/3pP3/3P4/3B1N2/PP3PPP/RNBQK2R b KQkq - c8d7", null, null],
  ["r1b1kbnr/pp3ppp/2n5/3qp3/1p6/P4N2/1BPP1PPP/RN1QKB1R w KQkq - c2c4", null, null],
  [
    "r1b1kbnr/pp3ppp/2n5/3qp3/1pP5/P4N2/1B1P1PPP/RN1QKB1R b KQkq c3 d5e6",
    "B20",
    "Sicilian Defense: Wing Gambit, Romanian Defense",
  ],
  ["r1b1kbnr/pp3ppp/2n5/3qp3/3P4/2N2N2/PP3PPP/R1BQKB1R b KQkq - f8b4", null, null],
  ["r1b1kbnr/pp3ppp/2n5/3qp3/3P4/5N2/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["r1b1kbnr/ppp1pppp/2n5/3q4/3P4/4P3/PP3PPP/RNBQKBNR b KQkq - e7e5", null, null],
  ["r1b1kbnr/ppp1pppp/2n5/3q4/3P4/8/PP2PPPP/RNBQKBNR w KQkq - e2e3", null, null],
  [
    "r1b1kbnr/ppp1pppp/2n5/3q4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - b1c3",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Exchange Variation, Marshall Gambit",
  ],
  [
    "r1b1kbnr/ppp2ppp/2n5/1B1pN1q1/4P3/8/PPPP1PPP/RNBQK2R w KQkq - e1g1",
    "C60",
    "Ruy Lopez: Spanish Countergambit, Harding Countergambit, Fricke Gambit",
  ],
  [
    "r1b1kbnr/ppp2ppp/2n5/1B1pN1q1/4P3/8/PPPP1PPP/RNBQK2R w KQkq - e5c6",
    "C60",
    "Ruy Lopez: Spanish Countergambit, Harding Gambit",
  ],
  [
    "r1b1kbnr/ppp2ppp/2n5/1B1qN3/4p3/2P5/PP1P1PPP/RNBQK2R w KQkq - d1a4",
    "C44",
    "Ponziani Opening: Spanish Variation, Harrwitz Attack, Nikitin Gambit",
  ],
  ["r1b1kbnr/ppp2ppp/2n5/3qp3/3P4/2N1P3/PP3PPP/R1BQKBNR b KQkq - f8b4", null, null],
  ["r1b1kbnr/ppp2ppp/2n5/3qp3/3P4/4P3/PP3PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["r1b1kbnr/ppp2ppp/2n5/q3P3/8/2N2N2/PPP2PPP/R1BQKB1R b KQkq - f8b4", null, null],
  ["r1b1kbnr/ppp2ppp/2n5/q3P3/8/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["r1b1kbnr/pppp1ppp/2n5/1N6/4P2q/8/PPP2PPP/RNBQKB1R b KQkq - f8b4", null, null],
  ["r1b1kbnr/pppp1ppp/2n5/8/3NP2q/2N5/PPP2PPP/R1BQKB1R b KQkq - f8b4", "C45", "Scotch Game: Modern Defense"],
  ["r1b1kbnr/pppp1ppp/2n5/8/3NP2q/8/PPP2PPP/RNBQKB1R w KQkq - b1c3", "C45", "Scotch Game: Steinitz Variation"],
  ["r1b1kbnr/pppp1ppp/2n5/8/3NP2q/8/PPP2PPP/RNBQKB1R w KQkq - c1e3", "C45", "Scotch Game: Braune Variation"],
  ["r1b1kbnr/pppp1ppp/2n5/8/3NP2q/8/PPP2PPP/RNBQKB1R w KQkq - d4b5", "C45", "Scotch Game: Horwitz Attack"],
  ["r1b1kbnr/pppp1ppp/2n5/8/3NP2q/8/PPP2PPP/RNBQKB1R w KQkq - d4f3", "C45", "Scotch Game: Fraser Variation"],
  ["r1b1kbnr/pppp1ppp/2n5/8/3NP2q/8/PPP2PPP/RNBQKB1R w KQkq - d4f5", "C45", "Scotch Game: Paulsen Variation"],
  [
    "r1b1kbnr/pppp1ppp/2n5/8/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR b kq - b7b6",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Fraser-Minckwitz Defense",
  ],
  [
    "r1b1kbnr/pppp1ppp/2n5/8/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR b kq - d7d5",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Zukertort Defense",
  ],
  [
    "r1b1kbnr/pppp1ppp/2n5/8/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR b kq - d7d6",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Paulsen Defense",
  ],
  [
    "r1b1kbnr/pppp1ppp/2n5/8/3PPp1q/2N5/PPP1K1PP/R1BQ1BNR b kq - g7g5",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Sörensen Defense",
  ],
  [
    "r1b1kbnr/pppp1ppp/2n5/8/3PPp1q/2N5/PPP3PP/R1BQKBNR w KQkq - e1e2",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Steinitz Gambit, Main Line",
  ],
  ["r1b1kbnr/ppppqppp/2n5/4P3/8/5N2/PPP1PPPP/RNBQKB1R w KQkq - d1d5", "A40", "Englund Gambit: Stockholm Variation"],
  ["r1b1kbnr/ppqp1ppp/2n1p3/1N6/4P3/2N5/PPP2PPP/R1BQKB1R b KQkq - c7b8", null, null],
  ["r1b1kbnr/ppqp1ppp/2n1p3/8/2B1P3/2N2N2/PP2QPPP/R1B1K2R b KQkq - a7a6", null, null],
  ["r1b1kbnr/ppqp1ppp/2n1p3/8/2B1P3/2N2N2/PP2QPPP/R1B1K2R b KQkq - g8f6", null, null],
  ["r1b1kbnr/ppqp1ppp/2n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R w KQkq - d1e2", null, null],
  ["r1b1kbnr/ppqp1ppp/2n1p3/8/3NP3/2N1B3/PPP2PPP/R2QKB1R b KQkq - a7a6", null, null],
  ["r1b1kbnr/ppqp1ppp/2n1p3/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - a7a6", null, null],
  [
    "r1b1kbnr/ppqp1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - c1e3",
    "B48",
    "Sicilian Defense: Taimanov Variation, Bastrikov Variation, English Attack",
  ],
  ["r1b1kbnr/ppqp1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4b5", null, null],
  ["r1b1kbnr/ppqp1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1e2", null, null],
  [
    "r1b2rk1/2q1bppp/p1np1n2/1pp1p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1 w - - d4c5",
    "C98",
    "Ruy Lopez: Closed, Chigorin Defense",
  ],
  [
    "r1b2rk1/2q1bppp/p2p1n2/np2p3/3pP3/2P2N1P/PPBN1PP1/R1BQR1K1 w - - c3d4",
    "C99",
    "Ruy Lopez: Closed, Chigorin Defense, Panov System",
  ],
  ["r1b2rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1 w - - b1d2", null, null],
  [
    "r1b2rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1 b - - a5c6",
    "C98",
    "Ruy Lopez: Closed, Chigorin Defense",
  ],
  ["r1b2rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1 b - - c5d4", null, null],
  ["r1b2rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1 b - - c8d7", null, null],
  ["r1b2rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N2/PPB2PPP/R1BQRNK1 b - - c8g4", null, null],
  ["r1b2rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P2N2/PPBN1PPP/R1BQR1K1 w - - d2f1", null, null],
  [
    "r1b2rk1/5ppp/p1pb4/1p1n4/3P3q/1BP3P1/PP3P1P/RNBQR1K1 b - - h4h3",
    "C89",
    "Ruy Lopez: Marshall Attack, Modern Main Line",
  ],
  ["r1b2rk1/5ppp/p1pb4/1p1n4/3P3q/1BP5/PP3PPP/RNBQR1K1 w - - g2g3", null, null],
  ["r1b2rk1/5ppp/p1pb4/1p1n4/3P4/1BP1B1Pq/PP3P1P/RN1QR1K1 b - - c8g4", null, null],
  ["r1b2rk1/5ppp/p1pb4/1p1n4/3P4/1BP3Pq/PP3P1P/RNBQR1K1 w - - c1e3", null, null],
  [
    "r1b2rk1/pp1n1ppp/2p1pn2/q2p2B1/1bPP4/2N1P3/PPQN1PPP/R3KB1R w KQ - g5h4",
    "D52",
    "Queen's Gambit Declined: Cambridge Springs Defense, Argentine Variation",
  ],
  [
    "r1b2rk1/pp1nqppp/2n1p3/2ppP3/3P1P2/2N2N2/PPPQ2PP/2KR1B1R b - - c5c4",
    "C14",
    "French Defense: Classical Variation, Stahlberg Variation",
  ],
  ["r1b2rk1/pp1nqppp/2n1p3/2ppP3/3P1P2/2N2N2/PPPQ2PP/R3KB1R w KQ - e1c1", null, null],
  ["r1b2rk1/pp1nqppp/2p1p3/3n4/2BP4/2N1PN2/PP3PPP/2RQ1RK1 b - - d5c3", null, null],
  [
    "r1b2rk1/pp1nqppp/2p1p3/3n4/2BP4/2N1PN2/PP3PPP/2RQK2R w K - c3e4",
    "D67",
    "Queen's Gambit Declined: Orthodox Defense, Alekhine Variation",
  ],
  [
    "r1b2rk1/pp1nqppp/2p1p3/3n4/2BP4/2N1PN2/PP3PPP/2RQK2R w K - e1g1",
    "D67",
    "Queen's Gambit Declined: Orthodox Defense, Main Line",
  ],
  ["r1b2rk1/pp1nqppp/2p1p3/8/2BP4/2n1PN2/PP3PPP/2RQ1RK1 w - - c1c3", null, null],
  [
    "r1b2rk1/pp1nqppp/2p1p3/8/2BP4/2R1PN2/PP3PPP/3Q1RK1 b - - e6e5",
    "D68",
    "Queen's Gambit Declined: Orthodox Defense, Classical Variation",
  ],
  ["r1b2rk1/pp1nqppp/2p5/4P3/2B5/2R1PN2/PP3PPP/3Q1RK1 b - - d7e5", null, null],
  [
    "r1b2rk1/pp1nqppp/2p5/4p3/2BP4/2R1PN2/PP3PPP/3Q1RK1 w - - d1b1",
    "D68",
    "Queen's Gambit Declined: Orthodox Defense, Classical Variation",
  ],
  [
    "r1b2rk1/pp1nqppp/2p5/4p3/2BP4/2R1PN2/PP3PPP/3Q1RK1 w - - d1c2",
    "D68",
    "Queen's Gambit Declined: Orthodox Defense, Classical Variation",
  ],
  ["r1b2rk1/pp1nqppp/2p5/4p3/2BP4/2R1PN2/PP3PPP/3Q1RK1 w - - d4e5", null, null],
  ["r1b2rk1/pp1nqppp/2pbpn2/3p4/2PP4/1PN1PN2/PBQ2PPP/R3KB1R w KQ - f1d3", "D46", "Semi-Slav Defense: Chigorin Defense"],
  [
    "r1b2rk1/pp2ppbp/1qnp1np1/8/3NPP2/2N1B3/PPP1B1PP/R2Q1RK1 w - - e4e5",
    "B73",
    "Sicilian Defense: Dragon Variation, Classical Variation, Zollner Gambit",
  ],
  [
    "r1b2rk1/pp2qpp1/2n1pn1p/2p5/2BP4/2N1PN2/PPQ2PPP/R2R2K1 b - - c8d7",
    "D56",
    "Queen's Gambit Declined: Lasker Defense, Russian Variation",
  ],
  ["r1b2rk1/pp2qpp1/2n1pn1p/2p5/2BP4/2N1PN2/PPQ2PPP/R4RK1 w - - f1d1", null, null],
  [
    "r1b2rk1/pp2qppp/2n1pn2/2bp4/2P5/2NBPN2/PP2QPPP/R1B2RK1 w - - e3e4",
    "D40",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Levenfish Variation",
  ],
  ["r1b2rk1/pp2qppp/2nbpn2/2Pp4/2P5/2NBPN2/PP2QPPP/R1B2RK1 b - - d6c5", null, null],
  ["r1b2rk1/pp2qppp/2nbpn2/2pp4/2PP4/2NBPN2/PP2QPPP/R1B2RK1 w - - d4c5", null, null],
  [
    "r1b2rk1/pp2qppp/2p5/4N3/2B5/2R1P3/PP3PPP/3Q1RK1 b - - e7e5",
    "D69",
    "Queen's Gambit Declined: Orthodox Defense, Classical Variation",
  ],
  ["r1b2rk1/pp2qppp/2p5/4n3/2B5/2R1PN2/PP3PPP/3Q1RK1 w - - f3e5", null, null],
  [
    "r1b2rk1/pp3ppp/2n1pn2/q1bp4/2P2B2/2N1PN2/PPQ2PPP/3RKB1R w K - a2a3",
    "D37",
    "Queen's Gambit Declined: Harrwitz Attack",
  ],
  [
    "r1b2rk1/pp3ppp/2n1pn2/q1bp4/2P2B2/P1N1PN2/1PQ2PPP/R3KB1R w KQ - e1c1",
    "D37",
    "Queen's Gambit Declined: Harrwitz Attack",
  ],
  ["r1b2rk1/ppN1nppp/2n2q2/3p4/4P3/2P1Q3/PP3PPP/RN2KB1R b KQ - a8b8", null, null],
  ["r1b2rk1/ppp1nppp/2n2q2/1N1p4/4P3/2P1Q3/PP3PPP/RN2KB1R w KQ - b5c7", null, null],
  ["r1b2rk1/ppp1qppp/2np1n2/1B2p1B1/4P3/2PP1N2/P1P2PPP/R2Q1RK1 w - - f1e1", null, null],
  ["r1b2rk1/ppp1qppp/2np1n2/1B2p1B1/4P3/2PP1N2/P1P2PPP/R2QR1K1 b - - c6d8", null, null],
  ["r1b2rk1/ppppqppp/2n2n2/1B2p3/1b2P3/2NP1N2/PPP2PPP/R1BQ1RK1 w - - c3e2", null, null],
  [
    "r1b2rk1/ppppqppp/2n2n2/1B2p3/1b2P3/3P1N2/PPP1NPPP/R1BQ1RK1 b - - d7d5",
    "C49",
    "Four Knights Game: Spanish Variation, Alatortsev Variation",
  ],
  [
    "r1b2rk1/ppq2ppp/2n1pn2/2p5/2BP4/P1P1PN2/5PPP/R1BQ1RK1 w - - d1c2",
    "E59",
    "Nimzo-Indian Defense: Normal Variation, Bernstein Defense",
  ],
  [
    "r1b3nr/ppppkBpp/1b6/nP2N1q1/4P3/8/P1PP1PPP/RNBQK2R w KQ - d1h5",
    "C51",
    "Italian Game: Evans Gambit Declined, Vasquez Variation",
  ],
  [
    "r1b3r1/ppp2k1p/1b6/nP2B1q1/3PP3/8/P1P2PPP/RN1QK2R w KQ - b1d2",
    "C51",
    "Italian Game: Evans Gambit Declined, Pavlov Variation",
  ],
  ["r1bk1b1r/ppNpq2p/2nn2p1/3Qpp2/8/1B6/PPPP1PPP/R1B1K1NR w KQ - c7a8", null, null],
  ["r1bk1b1r/ppp2ppp/2p5/4Pn2/8/2N2N2/PPP2PPP/R1B2RK1 b - - c8d7", "C67", "Ruy Lopez: Berlin Defense, Berlin Wall"],
  ["r1bk1b1r/ppp2ppp/2p5/4Pn2/8/5N2/PPP2PPP/RNB2RK1 w - - b1c3", null, null],
  ["r1bk2nr/pppp1ppp/2n5/1N6/1b2q3/8/PPPBBPPP/RN1Q1RK1 b - - b4d2", null, null],
  ["r1bk2nr/pppp1ppp/2n5/1N6/1b2q3/8/PPPBBPPP/RN1QK2R w KQ - e1g1", null, null],
  ["r1bk2nr/pppp1ppp/2n5/1N6/4q3/8/PPPbBPPP/RN1Q1RK1 w - - b1d2", null, null],
  [
    "r1bk2nr/pppp1ppp/2n5/1N6/4q3/8/PPPbBPPP/RN1Q1RK1 w - - d1d2",
    "C45",
    "Scotch Game: Horwitz Attack, Blackburne Variation",
  ],
  ["r1bk2nr/pppp1ppp/2n5/1N6/4q3/8/PPPNBPPP/R2Q1RK1 b - - e4g6", "C45", "Scotch Game: Rosenthal Variation"],
  [
    "r1bk2nr/pppp1Qpp/1b6/nP2q3/2B1P3/8/P1PP1PPP/RNB1K2R w KQ - c1b2",
    "C51",
    "Italian Game: Evans Gambit Declined, Hicken Variation",
  ],
  [
    "r1bn1rk1/ppp1qppp/3p1n2/1B2p1B1/3PP3/2P2N2/P1P2PPP/R2QR1K1 b - - c8g4",
    "C49",
    "Four Knights Game: Spanish Variation, Symmetrical Variation",
  ],
  ["r1bn1rk1/ppp1qppp/3p1n2/1B2p1B1/4P3/2PP1N2/P1P2PPP/R2QR1K1 w - - d3d4", null, null],
  ["r1bq1b1r/pp4pp/2p1k3/3np3/1nB1Q3/2N5/PPPP1PPP/R1B1K2R w KQ - a2a3", null, null],
  ["r1bq1b1r/pp4pp/2p1k3/3np3/1nB1Q3/P1N5/1PPP1PPP/R1B1K2R b KQ - b4a6", null, null],
  ["r1bq1b1r/pp4pp/n1p1k3/3np3/2B1Q3/P1N5/1PPP1PPP/R1B1K2R w KQ - d2d4", null, null],
  [
    "r1bq1b1r/pp4pp/n1p1k3/3np3/2BPQ3/P1N5/1PP2PPP/R1B1K2R b KQ - a6c7",
    "C57",
    "Italian Game: Two Knights Defense, Fegatello Attack, Leonhardt Variation",
  ],
  ["r1bq1b1r/ppp2kpp/2n5/3np3/2B5/5Q2/PPPP1PPP/RNB1K2R b KQ - f7e6", null, null],
  ["r1bq1b1r/ppp2kpp/2n5/3np3/2B5/8/PPPP1PPP/RNBQK2R w KQ - d1f3", null, null],
  ["r1bq1b1r/ppp3pp/2n1k3/3np3/2B5/2N2Q2/PPPP1PPP/R1B1K2R b KQ - c6b4", null, null],
  ["r1bq1b1r/ppp3pp/2n1k3/3np3/2B5/5Q2/PPPP1PPP/RNB1K2R w KQ - b1c3", null, null],
  ["r1bq1b1r/ppp3pp/4k3/3np3/1nB1Q3/2N5/PPPP1PPP/R1B1K2R b KQ - c7c6", null, null],
  ["r1bq1b1r/ppp3pp/4k3/3np3/1nB5/2N2Q2/PPPP1PPP/R1B1K2R w KQ - f3e4", null, null],
  [
    "r1bq1bnr/pppp1k2/2n4p/8/4PppP/2N5/PPPP2P1/R1BQKB1R w KQ - d2d4",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Hamppe-Allgaier Gambit, Thorold Variation",
  ],
  ["r1bq1rk1/1p1n1pbp/p2p1np1/2pP4/P7/2N2NP1/1P2PPBP/R1BQ1RK1 w - - f3d2", null, null],
  [
    "r1bq1rk1/1p1n1pbp/p2p1np1/2pP4/P7/2N3P1/1P1NPPBP/R1BQ1RK1 b - - f8e8",
    "A64",
    "Benoni Defense: Fianchetto Variation, Hastings Defense, Main Line",
  ],
  [
    "r1bq1rk1/1p1nbppp/p1p1pn2/3p2B1/2PP4/2N1PN2/PPQ2PPP/2R1KB1R w K - c4d5",
    "D65",
    "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
  ],
  [
    "r1bq1rk1/1p1nbppp/p1p1pn2/3p2B1/2PP4/P1N1PN2/1P3PPP/2RQKB1R w K - d1c2",
    "D64",
    "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
  ],
  [
    "r1bq1rk1/1p2bppp/p1nppn2/8/2P1P3/N1N5/PP2BPPP/R1BQ1RK1 b - - b7b6",
    "B44",
    "Sicilian Defense: Taimanov Variation, Modern Line",
  ],
  ["r1bq1rk1/1p2bppp/p1nppn2/8/2P1P3/N1N5/PP2BPPP/R1BQK2R w KQ - e1g1", null, null],
  ["r1bq1rk1/1p2ppbp/p2p1np1/n1pP4/2P5/2N3P1/PP1NPPBP/R1BQ1RK1 w - c6 d1c2", null, null],
  ["r1bq1rk1/1p2ppbp/p2p1np1/n1pP4/2P5/2N3P1/PPQNPPBP/R1B2RK1 b - - a8b8", null, null],
  [
    "r1bq1rk1/1p2ppbp/p2p1np1/n1pP4/2P5/2N3P1/PPQNPPBP/R1B2RK1 b - - e7e5",
    "E63",
    "King's Indian Defense: Fianchetto Variation, Panno Variation, Blockade Line",
  ],
  ["r1bq1rk1/1pp1ppbp/p1np1np1/3P4/2P5/2N2NP1/PP2PPBP/R1BQ1RK1 b - - c6a5", null, null],
  ["r1bq1rk1/1pp1ppbp/p1np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - d4d5", null, null],
  ["r1bq1rk1/1pp1ppbp/p1np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - h2h3", null, null],
  ["r1bq1rk1/1pp1ppbp/p1np1np1/8/2PP4/2N2NPP/PP2PPB1/R1BQ1RK1 b - - a8b8", null, null],
  [
    "r1bq1rk1/1pp1ppbp/p1np1np1/8/2PPP3/2N1BP2/PP1QN1PP/R3KB1R b KQ - a8b8",
    "E84",
    "King's Indian Defense: Sämisch Variation, Panno Main Line",
  ],
  ["r1bq1rk1/1pp1ppbp/p1np1np1/8/2PPP3/2N1BP2/PP2N1PP/R2QKB1R w KQ - d1d2", null, null],
  ["r1bq1rk1/1pp1ppbp/p2p1np1/n2P4/2P5/2N2NP1/PP2PPBP/R1BQ1RK1 w - - f3d2", null, null],
  ["r1bq1rk1/1pp1ppbp/p2p1np1/n2P4/2P5/2N3P1/PP1NPPBP/R1BQ1RK1 b - - c7c5", null, null],
  ["r1bq1rk1/1pp2ppp/p1np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQR1K1 w - - c4b3", null, null],
  ["r1bq1rk1/1pp2ppp/p1np1n2/2b1p3/4P3/1BPP1N2/PP3PPP/RNBQR1K1 b - - c5a7", null, null],
  [
    "r1bq1rk1/1ppnbppp/p3pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R w K - c4d5",
    "D63",
    "Queen's Gambit Declined: Orthodox Defense, Swiss, Carlsbad Variation",
  ],
  ["r1bq1rk1/2p1bppp/p1n2n2/1p1pp3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 w - - e4d5", null, null],
  [
    "r1bq1rk1/2p1bppp/p1n2n2/1p1pp3/4P3/1BP2N2/PP1PQPPP/RNB2RK1 w - - d2d3",
    "C86",
    "Ruy Lopez: Closed, Worrall Attack, Castling Line",
  ],
  [
    "r1bq1rk1/2p1bppp/p1n2n2/1p1Pp3/8/1BP2N2/PP1P1PPP/RNBQR1K1 b - - e5e4",
    "C89",
    "Ruy Lopez: Marshall Attack, Steiner Variation",
  ],
  ["r1bq1rk1/2p1bppp/p1n2n2/1p1Pp3/8/1BP2N2/PP1P1PPP/RNBQR1K1 b - - f6d5", null, null],
  ["r1bq1rk1/2p1bppp/p1n5/1p1nN3/8/1BP5/PP1P1PPP/RNBQR1K1 b - - c6e5", null, null],
  ["r1bq1rk1/2p1bppp/p1n5/1p1np3/8/1BP2N2/PP1P1PPP/RNBQR1K1 w - - f3e5", null, null],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/3PP3/1BP2N2/PP3PPP/RNBQR1K1 b - - c8g4",
    "C91",
    "Ruy Lopez: Closed, Bogoljubow Variation",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1B1P1N2/PPP2PPP/RNBQR1K1 w - - c2c3",
    "C90",
    "Ruy Lopez: Closed, Pilnik Variation",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 b - - c6a5",
    "C97",
    "Ruy Lopez: Closed, Chigorin Defense",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 b - - c6b8",
    "C94",
    "Ruy Lopez: Closed, Breyer Defense",
  ],
  ["r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 b - - c8b7", "C92", "Ruy Lopez: Closed, Flohr System"],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 b - - c8e6",
    "C92",
    "Ruy Lopez: Closed, Kholmov Variation",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 b - - f6d7",
    "C92",
    "Ruy Lopez: Closed, Karpov Variation",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 b - - f8e8",
    "C92",
    "Ruy Lopez: Closed, Zaitsev System",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 b - - h7h6",
    "C93",
    "Ruy Lopez: Closed, Smyslov Defense",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 w - - a2a3",
    "C90",
    "Ruy Lopez: Closed, Suetin Variation",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 w - - b3c2",
    "C90",
    "Ruy Lopez: Closed, Lutikov Variation",
  ],
  [
    "r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 w - - d2d4",
    "C91",
    "Ruy Lopez: Closed, Yates Variation",
  ],
  ["r1bq1rk1/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 w - - h2h3", "C92", "Ruy Lopez: Closed"],
  [
    "r1bq1rk1/2p1bppp/p2p1n2/np2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 w - - b3c2",
    "C96",
    "Ruy Lopez: Closed, Chigorin Defense",
  ],
  [
    "r1bq1rk1/2p1bppp/p2p1n2/np2p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1 b - - c7c5",
    "C96",
    "Ruy Lopez: Closed, Chigorin Defense",
  ],
  ["r1bq1rk1/2p1bppp/p2p1n2/np2p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1 b - - c7c6", null, null],
  [
    "r1bq1rk1/2p1bppp/p2p1n2/np2p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1 b - - d6d5",
    "C96",
    "Ruy Lopez: Closed, Chigorin Defense, Gajewski Gambit",
  ],
  ["r1bq1rk1/2p1bppp/p7/1p1nn3/8/1BP5/PP1P1PPP/RNBQR1K1 w - - e1e5", null, null],
  [
    "r1bq1rk1/2p1bppp/p7/1p1nR3/8/1BP5/PP1P1PPP/RNBQ2K1 b - - c7c6",
    "C89",
    "Ruy Lopez: Marshall Attack, Modern Variation",
  ],
  [
    "r1bq1rk1/2p1bppp/p7/1p1nR3/8/1BP5/PP1P1PPP/RNBQ2K1 b - - d5f6",
    "C89",
    "Ruy Lopez: Marshall Attack, Original Marshall Attack",
  ],
  ["r1bq1rk1/2pnbppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP1N1PP1/R1BQR1K1 b - - c8b7", null, null],
  ["r1bq1rk1/2pnbppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1 w - - b1d2", null, null],
  ["r1bq1rk1/2pnbppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1 w - - f3h4", "C95", "Ruy Lopez: Closed, Breyer Defense"],
  ["r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B1P1N2/PPP2PPP/RNBQR1K1 b - - d7d6", null, null],
  ["r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1 w - - a2a4", "C88", "Ruy Lopez: Closed, Anti-Marshall"],
  ["r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1 w - - c2c3", null, null],
  ["r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1 w - - d2d3", null, null],
  ["r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPPQPPP/RNB2RK1 w - - c2c3", null, null],
  ["r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 b - - d7d5", "C89", "Ruy Lopez: Marshall Attack"],
  ["r1bq1rk1/2ppbppp/p1n2n2/1p2p3/4P3/1BP2N2/PP1PQPPP/RNB2RK1 b - - d7d5", null, null],
  ["r1bq1rk1/3nbppp/1pp1pn2/p2p4/2PP4/1P3NP1/P1QNPPBP/R1B2RK1 w - - c1b2", null, null],
  [
    "r1bq1rk1/3nbppp/1pp1pn2/p2p4/2PP4/1P3NP1/PBQNPPBP/R4RK1 b - - c8a6",
    "E09",
    "Catalan Opening: Closed, Sokolsky Variation",
  ],
  ["r1bq1rk1/4bppp/p1p5/1p1BR3/8/2P5/PP1P1PPP/RNBQ2K1 b - - c6d5", null, null],
  ["r1bq1rk1/4bppp/p1p5/1p1nR3/3P4/1BP5/PP3PPP/RNBQ2K1 b - - e7d6", null, null],
  ["r1bq1rk1/4bppp/p1p5/1p1nR3/8/1BP5/PP1P1PPP/RNBQ2K1 w - - b3d5", null, null],
  ["r1bq1rk1/4bppp/p1p5/1p1nR3/8/1BP5/PP1P1PPP/RNBQ2K1 w - - d2d4", "C89", "Ruy Lopez: Marshall Attack, Main Line"],
  [
    "r1bq1rk1/4bppp/p1pp1n2/np2p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1 b - - d8c7",
    "C96",
    "Ruy Lopez: Closed, Rossolimo Defense",
  ],
  ["r1bq1rk1/4bppp/p1pp1n2/np2p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1 w - - d2d4", null, null],
  [
    "r1bq1rk1/4bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1 b - - a5c6",
    "C96",
    "Ruy Lopez: Closed, Borisenko Variation",
  ],
  [
    "r1bq1rk1/4bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1 b - - d8c7",
    "C97",
    "Ruy Lopez: Closed, Chigorin Defense",
  ],
  ["r1bq1rk1/4bppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/RNBQR1K1 b - - f6d7", "C96", "Ruy Lopez: Closed, Keres Defense"],
  ["r1bq1rk1/4bppp/p2p1n2/npp1p3/4P3/2P2N1P/PPBP1PP1/RNBQR1K1 w - - d2d4", null, null],
  ["r1bq1rk1/4bppp/p7/1p1pR3/3P4/2P5/PP3PPP/RNBQ2K1 b - - e7d6", null, null],
  ["r1bq1rk1/4bppp/p7/1p1pR3/8/2P5/PP1P1PPP/RNBQ2K1 w - - d2d4", null, null],
  ["r1bq1rk1/5ppp/p1pb4/1p1n4/3P4/1BP5/PP3PPP/RNBQR1K1 b - - d8h4", null, null],
  ["r1bq1rk1/5ppp/p1pb4/1p1nR3/3P4/1BP5/PP3PPP/RNBQ2K1 w - - e5e1", null, null],
  ["r1bq1rk1/5ppp/p2b4/1p1pR3/3P4/2P5/PP3PPP/RNBQ2K1 w - - e5e3", "C89", "Ruy Lopez: Marshall Attack, Re3 Variation"],
  [
    "r1bq1rk1/bpp2ppp/p1np1n2/4p3/4P3/1BPP1N2/PP3PPP/RNBQR1K1 w - - h2h3",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo, Main Line",
  ],
  [
    "r1bq1rk1/p1p2ppp/2p2n2/3P4/1b6/2NB4/PPP2PPP/R1BQK2R w KQ - e1g1",
    "C47",
    "Four Knights Game: Scotch Variation Accepted, Main Line",
  ],
  ["r1bq1rk1/p1pnbppp/1p2pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R w K - c4d5", null, null],
  ["r1bq1rk1/p1pnbppp/1p2pn2/3P2B1/3P4/2N1PN2/PP3PPP/2RQKB1R b K - e6d5", null, null],
  [
    "r1bq1rk1/p1pnbppp/1p3n2/3p2B1/3P4/2N1PN2/PP3PPP/2RQKB1R w K - f1b5",
    "D63",
    "Queen's Gambit Declined: Orthodox Defense, Capablanca Variation",
  ],
  [
    "r1bq1rk1/p1pnbppp/1p3n2/3p2B1/3P4/2N1PN2/PP3PPP/2RQKB1R w K - f1d3",
    "D63",
    "Queen's Gambit Declined: Orthodox Defense, Pillsbury Variation",
  ],
  ["r1bq1rk1/p1ppbppp/2p1n3/4P3/3N4/2N1B3/PPP1QPPP/R3R1K1 b - - e6d4", null, null],
  ["r1bq1rk1/p1ppbppp/2p1n3/4P3/3N4/2N5/PPP1QPPP/R1B1R1K1 w - - c1e3", null, null],
  ["r1bq1rk1/p1ppbppp/2p5/2n1P3/3N4/2N5/PPP1QPPP/R1B1R1K1 b - - c5e6", null, null],
  ["r1bq1rk1/p1ppbppp/2p5/2n1P3/8/2N2N2/PPP1QPPP/R1B1R1K1 w - - f3d4", null, null],
  [
    "r1bq1rk1/p1ppbppp/2p5/4P3/3B4/2N5/PPP1QPPP/R3R1K1 b - - c6c5",
    "C67",
    "Ruy Lopez: Berlin Defense, Rio de Janeiro Variation",
  ],
  ["r1bq1rk1/p1ppbppp/2p5/4P3/3n4/2N1B3/PPP1QPPP/R3R1K1 w - - e3d4", null, null],
  ["r1bq1rk1/p2n1ppp/2pbpn2/1p6/3P4/2NBPN2/PP3PPP/R1BQ1RK1 w - - d1c2", "D46", "Semi-Slav Defense: Chigorin Defense"],
  [
    "r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP1B2/5NP1/PPQ1PPBP/RN3RK1 w - - b1d2",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  [
    "r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP1B2/5NP1/PPQNPPBP/R4RK1 b - - c8a6",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP1B2/5NP1/PPQNPPBP/R4RK1 b - - c8b7", null, null],
  ["r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP4/1P3NP1/P1Q1PPBP/RNB2RK1 w - - f1d1", null, null],
  ["r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP4/1P3NP1/P1Q1PPBP/RNBR2K1 b - - c8b7", null, null],
  ["r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP4/1P3NP1/P1QNPPBP/R1B2RK1 b - - a7a5", null, null],
  [
    "r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNBR2K1 w - - a2a4",
    "E08",
    "Catalan Opening: Closed, Zagoryansky Variation",
  ],
  ["r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNBR2K1 w - - c1f4", "E08", "Catalan Opening: Closed"],
  ["r1bq1rk1/p2nbppp/1pp1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B2RK1 w - - b2b3", null, null],
  ["r1bq1rk1/p2p1ppp/1pn1pn2/2p5/2PP4/P1PBP3/4NPPP/R1BQK2R w KQ - e3e4", null, null],
  [
    "r1bq1rk1/p2p1ppp/1pn1pn2/2p5/2PPP3/P1PB4/4NPPP/R1BQK2R b KQ - f6e8",
    "E29",
    "Nimzo-Indian Defense: Sämisch Variation, Capablanca Variation",
  ],
  ["r1bq1rk1/pnppbppp/2p5/4P3/8/2N2N2/PPP1QPPP/R1B1R1K1 b - - b7c5", null, null],
  ["r1bq1rk1/pnppbppp/2p5/4P3/8/2N2N2/PPP1QPPP/R1B2RK1 w - - f1e1", null, null],
  ["r1bq1rk1/pp1n1pbp/2pp1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQR1K1 w - - e2f1", null, null],
  [
    "r1bq1rk1/pp1n1pbp/2pp1np1/4p3/2PPP3/2N2N2/PP3PPP/R1BQRBK1 b - - a7a5",
    "E96",
    "King's Indian Defense: Orthodox Variation, Positional Defense, Main Line",
  ],
  [
    "r1bq1rk1/pp1n1pbp/2pp1np1/4p3/2PPP3/2N2NP1/PP3PBP/R1BQ1RK1 w - - h2h3",
    "E69",
    "King's Indian Defense: Fianchetto Variation, Classical Main Line",
  ],
  ["r1bq1rk1/pp1n1pp1/2p1pb1p/3p4/2PP4/2NBPN2/PP3PPP/2RQ1RK1 b - - d5c4", null, null],
  ["r1bq1rk1/pp1n1pp1/2p1pb1p/3p4/2PP4/2NBPN2/PP3PPP/2RQK2R w K - e1g1", null, null],
  [
    "r1bq1rk1/pp1n1pp1/2p1pb1p/8/2pP4/2NBPN2/PP3PPP/2RQ1RK1 w - - d3c4",
    "D55",
    "Queen's Gambit Declined: Anti-Tartakower Variation, Petrosian Variation",
  ],
  [
    "r1bq1rk1/pp1n1ppp/2n1p3/2bpP3/5PQ1/P1N2N2/1PP3PP/R1B1KB1R b KQ - f7f6",
    "C11",
    "French Defense: Steinitz Variation, Brodsky-Jones Variation",
  ],
  ["r1bq1rk1/pp1n1ppp/2n1p3/2bpP3/5PQ1/P1N5/1PP3PP/R1B1KBNR w KQ - g1f3", null, null],
  [
    "r1bq1rk1/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/P1Q2PPP/R1B1KB1R w KQ - c1b2",
    "D45",
    "Semi-Slav Defense: Stoltz Variation",
  ],
  [
    "r1bq1rk1/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/PB3PPP/R2QKB1R w KQ - f1d3",
    "D46",
    "Semi-Slav Defense: Chigorin Defense",
  ],
  [
    "r1bq1rk1/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/PB3PPP/R2QKB1R w KQ - f1e2",
    "D45",
    "Semi-Slav Defense: Normal Variation",
  ],
  ["r1bq1rk1/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/PBQ2PPP/R3KB1R b KQ - d8e7", null, null],
  ["r1bq1rk1/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/PBQ2PPP/R3KB1R b KQ - f8e8", null, null],
  [
    "r1bq1rk1/pp1n1ppp/2pbpn2/3p4/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1 w - - b1d2",
    "D05",
    "Rubinstein Opening: Semi-Slav Defense",
  ],
  ["r1bq1rk1/pp1nbppp/2p1p3/3n2B1/2BP4/2N1PN2/PP3PPP/2RQK2R w K - g5e7", null, null],
  [
    "r1bq1rk1/pp1nbppp/2p1p3/3n2B1/2BP4/2N1PN2/PP3PPP/2RQK2R w K - h2h4",
    "D67",
    "Queen's Gambit Declined: Orthodox Defense, Janowski Variation",
  ],
  [
    "r1bq1rk1/pp1nBppp/2p1p3/3n4/2BP4/2N1PN2/PP3PPP/2RQK2R b K - d8e7",
    "D67",
    "Queen's Gambit Declined: Orthodox Defense, Bd3 Line",
  ],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R w K - a2a3", null, null],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R w K - d1c2",
    "D64",
    "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
  ],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R w K - f1d3",
    "D66",
    "Queen's Gambit Declined: Orthodox Defense, Bd3 Line",
  ],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PPQ2PPP/2R1KB1R b K - a7a6",
    "D64",
    "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
  ],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PPQ2PPP/2R1KB1R b K - f6e4",
    "D64",
    "Queen's Gambit Declined: Orthodox Defense, Rubinstein Attack",
  ],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/2NBPN2/PP3PPP/2RQK2R b K - d5c4", null, null],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p2B1/2PP4/P1N1PN2/1P3PPP/2RQKB1R b K - a7a6", null, null],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP1B2/5NP1/PPQ1PPBP/RN3RK1 b - - b7b6", null, null],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/1P3NP1/P1Q1PPBP/RNB2RK1 b - - b7b6", "E08", "Catalan Opening: Closed"],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - d1d3",
    "E07",
    "Catalan Opening: Closed, Botvinnik Variation",
  ],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1 w - - b1d2", "E09", "Catalan Opening: Closed, Main Line"],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1 w - - b2b3", "E08", "Catalan Opening: Closed"],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1 w - - c1f4", null, null],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1 w - - f1d1", null, null],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNBR2K1 b - - b7b6", null, null],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQBPPBP/RN1R2K1 b - - h7h6",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQBPPBP/RN3RK1 w - - b2b3",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQBPPBP/RN3RK1 w - - d2f4", null, null],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQBPPBP/RN3RK1 w - - f1c1",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQBPPBP/RN3RK1 w - - f1d1",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B1K2R w KQ - e1g1", "E09", "Catalan Opening: Closed, Main Line"],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B2RK1 b - - b7b5",
    "E09",
    "Catalan Opening: Closed Variation, Rabinovich Variation",
  ],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B2RK1 b - - b7b6",
    "E09",
    "Catalan Opening: Closed Variation, Traditional Variation",
  ],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/6B1/2BP4/2N1PN2/PP3PPP/2RQK2R b K - b7b5",
    "D66",
    "Queen's Gambit Declined: Orthodox Defense, Fianchetto Variation",
  ],
  [
    "r1bq1rk1/pp1nbppp/2p1pn2/6B1/2BP4/2N1PN2/PP3PPP/2RQK2R b K - f6d5",
    "D67",
    "Queen's Gambit Declined: Orthodox Defense, Capablanca System",
  ],
  ["r1bq1rk1/pp1nbppp/2p1pn2/6B1/2pP4/2NBPN2/PP3PPP/2RQK2R w K - d3c4", null, null],
  ["r1bq1rk1/pp1nbppp/2pp1n2/4p3/2BPP3/2N2N2/PPP1QPPP/R1B2RK1 w - - a2a4", null, null],
  [
    "r1bq1rk1/pp1nbppp/2pp1n2/4p3/P1BPP3/2N2N2/1PP1QPPP/R1B2RK1 b - - e5d4",
    "C41",
    "Philidor Defense: Lion Variation, Sozin Variation",
  ],
  [
    "r1bq1rk1/pp1nbppp/4pn2/2pp2B1/2PP4/2N1PN2/PPQ2PPP/R3KB1R w KQ - c4d5",
    "D62",
    "Queen's Gambit Declined: Orthodox Defense, Rubinstein Variation, Flohr Line",
  ],
  ["r1bq1rk1/pp1p1ppp/2n1pn2/2p5/2PP4/P1PBP3/4NPPP/R1BQK2R b KQ - b7b6", null, null],
  ["r1bq1rk1/pp1p1ppp/2n1pn2/2p5/2PP4/P1PBP3/5PPP/R1BQK1NR w KQ - g1e2", null, null],
  [
    "r1bq1rk1/pp1pppbp/2n2np1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 w - - b2b3",
    "A38",
    "English Opening: Symmetrical Variation, Double Fianchetto",
  ],
  [
    "r1bq1rk1/pp1pppbp/2n2np1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 w - - d2d3",
    "A38",
    "English Opening: Symmetrical Variation, Duchamp Variation",
  ],
  [
    "r1bq1rk1/pp1pppbp/2n2np1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 w - - d2d4",
    "A39",
    "English Opening: Symmetrical Variation, Mecking Variation",
  ],
  ["r1bq1rk1/pp1pppbp/2n2np1/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 b - - d7d6", null, null],
  ["r1bq1rk1/pp1pppbp/2n2np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R w KQ - d4b3", null, null],
  ["r1bq1rk1/pp1pppbp/2n2np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R w KQ - e1g1", null, null],
  ["r1bq1rk1/pp1pppbp/2n2np1/8/4P3/1NN1B3/PPP1BPPP/R2QK2R b KQ - d7d6", null, null],
  ["r1bq1rk1/pp2bpp1/2n2n1p/3p2B1/3N4/2N3P1/PP2PPBP/R2Q1RK1 w - - g5e3", null, null],
  [
    "r1bq1rk1/pp2bpp1/2n2n1p/3p4/3N4/2N1B1P1/PP2PPBP/R2Q1RK1 b - - c8g4",
    "D34",
    "Tarrasch Defense: Classical Variation, Spassky Variation",
  ],
  [
    "r1bq1rk1/pp2bpp1/2n2n1p/3p4/3N4/2N1B1P1/PP2PPBP/R2Q1RK1 b - - f8e8",
    "D34",
    "Tarrasch Defense: Classical Variation, Main Line",
  ],
  [
    "r1bq1rk1/pp2bppp/2n1pn2/2pp4/4P3/3P1NP1/PPPN1PBP/R1BQ1RK1 w - - f1e1",
    "A08",
    "King's Indian Attack: Sicilian Variation",
  ],
  [
    "r1bq1rk1/pp2bppp/2n2n2/2pp2B1/3P4/2N2NP1/PP2PPBP/R2Q1RK1 b - - c5c4",
    "D34",
    "Tarrasch Defense: Classical Variation, Advance Variation",
  ],
  ["r1bq1rk1/pp2bppp/2n2n2/2pp2B1/3P4/2N2NP1/PP2PPBP/R2Q1RK1 b - - c5d4", null, null],
  [
    "r1bq1rk1/pp2bppp/2n2n2/2pp2B1/3P4/2N2NP1/PP2PPBP/R2Q1RK1 b - - c8e6",
    "D34",
    "Tarrasch Defense: Classical Variation, Endgame Variation",
  ],
  [
    "r1bq1rk1/pp2bppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - c1g5",
    "D34",
    "Tarrasch Defense: Classical Variation, Carlsbad Variation",
  ],
  ["r1bq1rk1/pp2bppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - d4c5", null, null],
  [
    "r1bq1rk1/pp2bppp/2n2n2/2Pp4/8/2N2NP1/PP2PPBP/R1BQ1RK1 b - - d5d4",
    "D34",
    "Tarrasch Defense: Classical Variation, Classical Tarrasch Gambit",
  ],
  ["r1bq1rk1/pp2bppp/2n2n2/2Pp4/8/2N2NP1/PP2PPBP/R1BQ1RK1 b - - e7c5", null, null],
  [
    "r1bq1rk1/pp2bppp/2n2n2/3p2B1/3N4/2N3P1/PP2PPBP/R2Q1RK1 b - - f8e8",
    "D34",
    "Tarrasch Defense: Classical Variation, Petursson Variation",
  ],
  ["r1bq1rk1/pp2bppp/2n2n2/3p2B1/3N4/2N3P1/PP2PPBP/R2Q1RK1 b - - h7h6", null, null],
  ["r1bq1rk1/pp2bppp/2n2n2/3p2B1/3p4/2N2NP1/PP2PPBP/R2Q1RK1 w - - f3d4", null, null],
  ["r1bq1rk1/pp2bppp/2np1n2/2p3B1/4P3/2N2N2/PPP1BPPP/R2Q1RK1 b - - c8e6", null, null],
  ["r1bq1rk1/pp2bppp/2np1n2/2p5/4P3/2N2N2/PPP1BPPP/R1BQ1RK1 w - - c1g5", null, null],
  [
    "r1bq1rk1/pp2bppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/2KR1B1R w - - f2f4",
    "B64",
    "Sicilian Defense: Richter-Rauzer Variation, Classical Variation",
  ],
  [
    "r1bq1rk1/pp2bppp/2nppn2/6B1/3NPP2/2N5/PPPQ2PP/2KR1B1R b - - c6d4",
    "B65",
    "Sicilian Defense: Richter-Rauzer Variation, Rauzer Attack",
  ],
  [
    "r1bq1rk1/pp2bppp/2nppn2/6B1/3NPP2/2N5/PPPQ2PP/2KR1B1R b - - e6e5",
    "B64",
    "Sicilian Defense: Richter-Rauzer Variation, Classical Variation",
  ],
  ["r1bq1rk1/pp2bppp/2nppn2/8/3NP3/1BN1B3/PPP2PPP/R2Q1RK1 b - - c6a5", null, null],
  ["r1bq1rk1/pp2bppp/2nppn2/8/3NP3/1BN1B3/PPP2PPP/R2QK2R w KQ - e1g1", null, null],
  [
    "r1bq1rk1/pp2bppp/2nppn2/8/3NP3/1BN1B3/PPP2PPP/R2QK2R w KQ - f2f4",
    "B88",
    "Sicilian Defense: Sozin Attack, Fischer Variation",
  ],
  ["r1bq1rk1/pp2bppp/2nppn2/8/3NPP2/2N1B3/PPP1B1PP/R2Q1RK1 b - - c8d7", null, null],
  [
    "r1bq1rk1/pp2bppp/2nppn2/8/3NPP2/2N5/PPP1B1PP/R1BQ1RK1 w - - c1e3",
    "B83",
    "Sicilian Defense: Scheveningen Variation, Modern Variation",
  ],
  [
    "r1bq1rk1/pp2bppp/3ppn2/6B1/3nPP2/2N5/PPPQ2PP/2KR1B1R w - - d2d4",
    "B65",
    "Sicilian Defense: Richter-Rauzer Variation, Classical Variation",
  ],
  ["r1bq1rk1/pp2bppp/3ppn2/n7/3NP3/1BN1B3/PPP2PPP/R2Q1RK1 w - - f2f4", null, null],
  [
    "r1bq1rk1/pp2bppp/3ppn2/n7/3NPP2/1BN1B3/PPP3PP/R2Q1RK1 b - - b7b6",
    "B89",
    "Sicilian Defense: Sozin Attack, Main Line, Sherbakov Variation",
  ],
  [
    "r1bq1rk1/pp2nppp/2p2n2/3pp1B1/1b2P2N/1BNP4/PPP2PPP/R2Q1RK1 b - - d8d6",
    "C49",
    "Four Knights Game: Spanish Variation, Symmetrical Variation, Blake Variation",
  ],
  ["r1bq1rk1/pp2nppp/2p2n2/3pp1B1/1bB1P2N/2NP4/PPP2PPP/R2Q1RK1 w - - c4b3", null, null],
  ["r1bq1rk1/pp2nppp/2pp1n2/1B2p1B1/1b2P2N/2NP4/PPP2PPP/R2Q1RK1 w - - b5c4", null, null],
  ["r1bq1rk1/pp2nppp/2pp1n2/4p1B1/1bB1P2N/2NP4/PPP2PPP/R2Q1RK1 b - - d6d5", null, null],
  ["r1bq1rk1/pp2ppbp/1nnp2p1/8/2PP4/2N2N1P/PP2BPP1/R1BQ1RK1 b - - c8f5", null, null],
  ["r1bq1rk1/pp2ppbp/1nnp2p1/8/2PP4/2N2N1P/PP2BPP1/R1BQK2R w KQ - e1g1", null, null],
  ["r1bq1rk1/pp2ppbp/2n3p1/2p5/2BPP3/2P1B3/P3NPPP/R2Q1RK1 b - - c5d4", null, null],
  ["r1bq1rk1/pp2ppbp/2n3p1/2p5/2BPP3/2P1B3/P3NPPP/R2Q1RK1 b - - c8g4", null, null],
  ["r1bq1rk1/pp2ppbp/2n3p1/2p5/2BPP3/2P1B3/P3NPPP/R2QK2R w KQ - e1g1", null, null],
  ["r1bq1rk1/pp2ppbp/2n3p1/2p5/2BPP3/2P5/P3NPPP/R1BQ1RK1 w - - c1e3", null, null],
  ["r1bq1rk1/pp2ppbp/2n3p1/2p5/3PP3/2P2N2/P3BPPP/1RBQK2R w K - d4d5", null, null],
  [
    "r1bq1rk1/pp2ppbp/2n3p1/2pP4/4P3/2P2N2/P3BPPP/1RBQK2R b K - g7c3",
    "D85",
    "Grünfeld Defense: Exchange Variation, Modern Exchange Variation, Pawn Grab Line",
  ],
  [
    "r1bq1rk1/pp2ppbp/2n3p1/8/2BpP3/2P1B3/P3NPPP/R2Q1RK1 w - - c3d4",
    "D88",
    "Grünfeld Defense: Exchange Variation, Spassky Variation",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/2P5/2P5/2N2NP1/PP2PPBP/R1BQ1RK1 b - - d6c5",
    "E65",
    "King's Indian Defense: Fianchetto Variation, Yugoslav Variation, Exchange Line",
  ],
  ["r1bq1rk1/pp2ppbp/2np1np1/2p5/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - d4c5", null, null],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/2p5/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - d4d5",
    "E66",
    "King's Indian Defense: Fianchetto Variation, Yugoslav Variation, Advance Line",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R b KQ - a7a5",
    "B77",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Byrne Variation",
  ],
  ["r1bq1rk1/pp2ppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R b KQ - c6d4", null, null],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R b KQ - c8d7",
    "B77",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R b KQ - f6d7",
    "B77",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Sosonko Variation",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/2PNPP2/2N5/PP2B1PP/R1BQK2R w KQ - c1e3",
    "E79",
    "King's Indian Defense: Four Pawns Attack, Exchange Variation",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 w - - d1d2",
    "B73",
    "Sicilian Defense: Dragon Variation, Classical Variation, Battery Variation",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 w - - d4b3",
    "B74",
    "Sicilian Defense: Dragon Variation, Classical Variation, Normal Line",
  ],
  ["r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 w - - f2f4", null, null],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPPQBPPP/R3K2R w KQ - e1c1",
    "B72",
    "Sicilian Defense: Dragon Variation, Classical Variation, Grigoriev Variation",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1BP2/PPPQ2PP/R3KB1R w KQ - e1c1",
    "B76",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Modern Line",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1BP2/PPPQ2PP/R3KB1R w KQ - f1c4",
    "B77",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Main Line",
  ],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/3NP3/2N1BP2/PPPQ2PP/R3KB1R w KQ - g2g4",
    "B76",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Panov Variation",
  ],
  ["r1bq1rk1/pp2ppbp/2np1np1/8/3NPP2/2N1B3/PPP1B1PP/R2Q1RK1 b - - d8b6", null, null],
  ["r1bq1rk1/pp2ppbp/2np1np1/8/3NPP2/2N1B3/PPP1B1PP/R2QK2R w KQ - d4b3", null, null],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/4P3/1NN1B3/PPP1BPPP/R2Q1RK1 b - - a7a5",
    "B74",
    "Sicilian Defense: Dragon Variation, Classical Variation, Alekhine Line",
  ],
  ["r1bq1rk1/pp2ppbp/2np1np1/8/4P3/1NN1B3/PPP1BPPP/R2Q1RK1 b - - c8e6", null, null],
  [
    "r1bq1rk1/pp2ppbp/2np1np1/8/4P3/1NN1B3/PPP1BPPP/R2QK2R w KQ - e1g1",
    "B74",
    "Sicilian Defense: Dragon Variation, Classical Variation, Normal Line",
  ],
  ["r1bq1rk1/pp2ppbp/2np1np1/8/4PP2/1NN1B3/PPP1B1PP/R2QK2R b KQ - c8e6", null, null],
  [
    "r1bq1rk1/pp2ppbp/3p1np1/8/2BBP3/2N2P2/PPPQ2PP/R3K2R b KQ - c8e6",
    "B77",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Czerniak Variation",
  ],
  ["r1bq1rk1/pp2ppbp/3p1np1/8/2BnP3/2N1BP2/PPPQ2PP/R3K2R w KQ - e3d4", null, null],
  ["r1bq1rk1/pp3ppp/2n1pn2/2bp4/2P2B2/2N1PN2/PPQ2PPP/3RKB1R b K - d8a5", null, null],
  ["r1bq1rk1/pp3ppp/2n1pn2/2bp4/2P2B2/2N1PN2/PPQ2PPP/R3KB1R w KQ - a1d1", null, null],
  ["r1bq1rk1/pp3ppp/2n1pn2/2bp4/2P2B2/2N1PN2/PPQ2PPP/R3KB1R w KQ - a2a3", null, null],
  ["r1bq1rk1/pp3ppp/2n1pn2/2bp4/2P2B2/P1N1PN2/1PQ2PPP/R3KB1R b KQ - d8a5", null, null],
  [
    "r1bq1rk1/pp3ppp/2n1pn2/2p5/1bBP4/P1N1PN2/1P3PPP/R1BQ1RK1 b - - c5d4",
    "E57",
    "Nimzo-Indian Defense: Normal Variation, Gligoric System, Bernstein Defense",
  ],
  ["r1bq1rk1/pp3ppp/2n1pn2/2p5/1bpP4/P1NBPN2/1P3PPP/R1BQ1RK1 w - - d3c4", null, null],
  ["r1bq1rk1/pp3ppp/2n1pn2/2p5/2BP4/P1P1PN2/5PPP/R1BQ1RK1 b - - d8c7", null, null],
  [
    "r1bq1rk1/pp3ppp/2n1pn2/2p5/2BP4/P1P1PN2/5PPP/R1BQK2R w KQ - e1g1",
    "E59",
    "Nimzo-Indian Defense: Normal Variation, Bernstein Defense",
  ],
  [
    "r1bq1rk1/pp3ppp/2n1pn2/2p5/2pP4/P1PBPN2/5PPP/R1BQ1RK1 w - - d3c4",
    "E59",
    "Nimzo-Indian Defense: Normal Variation, Bernstein Defense",
  ],
  ["r1bq1rk1/pp3ppp/2n1pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 w - - a2a3", null, null],
  ["r1bq1rk1/pp3ppp/2n1pn2/2pp4/1bPP4/P1NBPN2/1P3PPP/R1BQ1RK1 b - - b4c3", null, null],
  ["r1bq1rk1/pp3ppp/2n1pn2/2pp4/1bPP4/P1NBPN2/1P3PPP/R1BQ1RK1 b - - d5c4", null, null],
  [
    "r1bq1rk1/pp3ppp/2n1pn2/2pp4/2PP4/P1bBPN2/1P3PPP/R1BQ1RK1 w - - b2c3",
    "E58",
    "Nimzo-Indian Defense: Normal Variation, Bernstein Defense, Exchange Line",
  ],
  ["r1bq1rk1/pp3ppp/2n1pn2/2pp4/2PP4/P1PBPN2/5PPP/R1BQ1RK1 b - - d5c4", null, null],
  [
    "r1bq1rk1/pp3ppp/2n2n2/2bp4/8/2N2NP1/PP2PPBP/R1BQ1RK1 w - - c3a4",
    "D34",
    "Tarrasch Defense: Classical Variation, Réti Variation",
  ],
  ["r1bq1rk1/pp3ppp/2nbpn2/2pp4/2PP4/2NBPN2/PP2QPPP/R1B2RK1 b - - d8e7", null, null],
  ["r1bq1rk1/pp3ppp/2nbpn2/2pp4/2PP4/2NBPN2/PP3PPP/R1BQ1RK1 w - - d1e2", null, null],
  [
    "r1bq1rk1/pp4bp/2nppnp1/2p5/2P1PPP1/2N5/PP2B2P/R1BQK1NR w KQ - h2h4",
    "E77",
    "King's Indian Defense: Six Pawns Attack",
  ],
  ["r1bq1rk1/ppp1npbp/3p1np1/3Pp3/1PP1P3/2N2N2/P3BPPP/R1BQ1RK1 b - - f6h5", null, null],
  [
    "r1bq1rk1/ppp1npbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQ1RK1 w - - b2b4",
    "E97",
    "King's Indian Defense: Orthodox Variation, Bayonet Attack",
  ],
  [
    "r1bq1rk1/ppp1npbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQ1RK1 w - - c1d2",
    "E97",
    "King's Indian Defense: Orthodox Variation, Korchnoi Attack",
  ],
  [
    "r1bq1rk1/ppp1npbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQ1RK1 w - - f3d2",
    "E97",
    "King's Indian Defense: Orthodox Variation, Modern System",
  ],
  [
    "r1bq1rk1/ppp1npbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQ1RK1 w - - f3e1",
    "E98",
    "King's Indian Defense: Orthodox Variation, Classical System",
  ],
  ["r1bq1rk1/ppp1npbp/3p1np1/3Pp3/2P1P3/2N5/PP2BPPP/R1BQNRK1 b - - f6d7", null, null],
  [
    "r1bq1rk1/ppp1npbp/3p2p1/3Pp2n/1PP1P3/2N2N2/P3BPPP/R1BQ1RK1 w - - d1c2",
    "E97",
    "King's Indian Defense: Orthodox Variation, Bayonet Attack, Yepishin's Line",
  ],
  [
    "r1bq1rk1/ppp1npbp/3p2p1/3Pp2n/1PP1P3/2N2N2/P3BPPP/R1BQ1RK1 w - - f1e1",
    "E97",
    "King's Indian Defense: Orthodox Variation, Bayonet Attack, Sokolov's Line",
  ],
  ["r1bq1rk1/ppp1nppp/3p1n2/1B2p1B1/1b2P2N/2NP4/PPP2PPP/R2Q1RK1 b - - c7c6", null, null],
  ["r1bq1rk1/ppp1nppp/3p1n2/1B2p1B1/1b2P3/2NP1N2/PPP2PPP/R2Q1RK1 w - - f3h4", null, null],
  [
    "r1bq1rk1/ppp1nppp/3p4/3P2N1/2B1R3/8/PP3PPP/R2Q2K1 w - - g5h7",
    "C54",
    "Italian Game: Giuoco Piano, Therkatz-Herzog Variation",
  ],
  [
    "r1bq1rk1/ppp1ppbp/2np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - a7a6",
    "E63",
    "King's Indian Defense: Fianchetto Variation, Panno Variation",
  ],
  [
    "r1bq1rk1/ppp1ppbp/2np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - c8f5",
    "E62",
    "King's Indian Defense: Fianchetto Variation, Lesser Simagin (Spassky)",
  ],
  [
    "r1bq1rk1/ppp1ppbp/2np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - c8g4",
    "E62",
    "King's Indian Defense: Fianchetto Variation, Simagin Variation",
  ],
  [
    "r1bq1rk1/ppp1ppbp/2np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - e7e5",
    "E62",
    "King's Indian Defense: Fianchetto Variation, Uhlmann-Szabo System",
  ],
  ["r1bq1rk1/ppp1ppbp/2np1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R w KQ - e1g1", null, null],
  ["r1bq1rk1/ppp1ppbp/2np1np1/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3", null, null],
  [
    "r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N1BP2/PP2N1PP/R2QKB1R b KQ - a7a6",
    "E83",
    "King's Indian Defense: Sämisch Variation, Panno Formation",
  ],
  [
    "r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N1BP2/PP2N1PP/R2QKB1R b KQ - a8b8",
    "E83",
    "King's Indian Defense: Sämisch Variation, Ruban Variation",
  ],
  ["r1bq1rk1/ppp1ppbp/2np1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR w KQ - g1e2", null, null],
  [
    "r1bq1rk1/ppp1ppbp/n2p1np1/6B1/2PPP3/2N5/PP1QBPPP/R3K1NR b KQ - c7c6",
    "E73",
    "King's Indian Defense: Averbakh Variation, Modern Defense, Burgess Line",
  ],
  ["r1bq1rk1/ppp1ppbp/n2p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR w KQ - d1d2", null, null],
  ["r1bq1rk1/ppp2pbp/2np1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQ1RK1 b - - c6e7", null, null],
  ["r1bq1rk1/ppp2pbp/2np1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 w - - d4d5", null, null],
  [
    "r1bq1rk1/ppp2ppp/2n1pn2/3p4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - d5c4",
    "E51",
    "Nimzo-Indian Defense: Ragozin Variation",
  ],
  [
    "r1bq1rk1/ppp2ppp/2n1pn2/3p4/1bPP4/2NBPN2/PP3PPP/R1BQK2R w KQ - e1g1",
    "E48",
    "Nimzo-Indian Defense: Ragozin Defense",
  ],
  ["r1bq1rk1/ppp2ppp/2nb1n2/3pp3/8/P2PP1P1/1PPN1PBP/R1BQK1NR w KQ - h2h3", "A00", "Formation: Shy Attack"],
  ["r1bq1rk1/ppp2ppp/2nb1n2/3pp3/8/PPPPPP2/6PP/RNBQKBNR w KQ - g2g3", "A00", "Formation: Hippopotamus Attack"],
  ["r1bq1rk1/ppp2ppp/2np1n2/1B2p1B1/1b2P3/2NP1N2/PPP2PPP/R2Q1RK1 b - - b4c3", null, null],
  [
    "r1bq1rk1/ppp2ppp/2np1n2/1B2p1B1/1b2P3/2NP1N2/PPP2PPP/R2Q1RK1 b - - c6e7",
    "C49",
    "Four Knights Game: Spanish Variation, Symmetrical Variation",
  ],
  [
    "r1bq1rk1/ppp2ppp/2np1n2/1B2p1B1/1b2P3/2NP1N2/PPP2PPP/R2Q1RK1 b - - c8e6",
    "C49",
    "Four Knights Game: Spanish Variation, Symmetrical Variation, Tarrasch Variation",
  ],
  ["r1bq1rk1/ppp2ppp/2np1n2/1B2p1B1/4P3/2bP1N2/PPP2PPP/R2Q1RK1 w - - b2c3", null, null],
  [
    "r1bq1rk1/ppp2ppp/2np1n2/1B2p1B1/4P3/2PP1N2/P1P2PPP/R2Q1RK1 b - - d8e7",
    "C49",
    "Four Knights Game: Spanish Variation, Symmetrical Variation, Metger Unpin",
  ],
  ["r1bq1rk1/ppp2ppp/2np1n2/1B2p3/1b2P3/2NP1N2/PPP2PPP/R1BQ1RK1 w - - c1g5", null, null],
  [
    "r1bq1rk1/ppp2ppp/2np1n2/1B2p3/1b2P3/2NP1N2/PPP2PPP/R1BQ1RK1 w - - c3e2",
    "C49",
    "Four Knights Game: Spanish Variation, Symmetrical Variation",
  ],
  [
    "r1bq1rk1/ppp2ppp/2np1n2/1B2p3/4P3/2PP1N2/P1P2PPP/R1BQ1RK1 w - - f1e1",
    "C49",
    "Four Knights Game: Spanish Variation, Janowski Variation",
  ],
  [
    "r1bq1rk1/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP1N1PPP/R1BQK2R w KQ - e1g1",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  ["r1bq1rk1/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 w - - a2a4", null, null],
  ["r1bq1rk1/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 w - - f1e1", null, null],
  ["r1bq1rk1/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQR1K1 b - - a7a6", null, null],
  [
    "r1bq1rk1/ppp2ppp/2np1n2/2b1p3/2P5/2NP1NP1/PP2PPBP/R1BQK2R w KQ - e1g1",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line, with .. d6",
  ],
  [
    "r1bq1rk1/ppp2ppp/2np1n2/2b1p3/P1B1P3/2PP1N2/1P3PPP/RNBQ1RK1 b - - a7a5",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo, with a4 a5",
  ],
  ["r1bq1rk1/ppp2ppp/3p1n2/2b1p3/4P3/2NP1B2/PPP2PPP/R1BQ1RK1 w - - c3a4", null, null],
  [
    "r1bq1rk1/ppp2ppp/3p1n2/2b1p3/N3P3/3P1B2/PPP2PPP/R1BQ1RK1 b - - c5b6",
    "C48",
    "Four Knights Game: Spanish Variation, Rubinstein Variation, Maróczy Variation",
  ],
  ["r1bq1rk1/pppn1pb1/3p1n1p/3Pp1p1/2P1P2B/2N2N2/PP2BPPP/R2QK2R w KQ - h4g3", null, null],
  ["r1bq1rk1/pppn1pb1/3p1n1p/3Pp1p1/2P1P3/2N2NB1/PP2BPPP/R2QK2R b KQ - f6h5", null, null],
  ["r1bq1rk1/pppn1pb1/3p1npp/3Pp1B1/2P1P3/2N2N2/PP2BPPP/R2QK2R w KQ - g5h4", null, null],
  ["r1bq1rk1/pppn1pb1/3p1npp/3Pp3/2P1P2B/2N2N2/PP2BPPP/R2QK2R b KQ - g6g5", null, null],
  [
    "r1bq1rk1/pppn1pb1/3p3p/3Pp1pn/2P1P3/2N2NB1/PP2BPPP/R2QK2R w KQ - h2h4",
    "E93",
    "King's Indian Defense: Petrosian Variation, Keres Defense",
  ],
  ["r1bq1rk1/pppn1pbp/3p1np1/3Pp1B1/2P1P3/2N2N2/PP2BPPP/R2QK2R b KQ - h7h6", null, null],
  ["r1bq1rk1/pppn1pbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQK2R w KQ - c1g5", null, null],
  [
    "r1bq1rk1/pppn1pbp/3p1np1/4P3/2P5/2N1PN2/PP2BPPP/R1BQ1RK1 b - - d6e5",
    "E61",
    "King's Indian Defense: Semi-Classical Variation, Exchange Variation",
  ],
  [
    "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PP4/2N1PN2/PP2BPPP/R1BQ1RK1 w - - b2b4",
    "E61",
    "King's Indian Defense: Semi-Classical Variation, Queenside Storm Line",
  ],
  ["r1bq1rk1/pppn1pbp/3p1np1/4p3/2PP4/2N1PN2/PP2BPPP/R1BQ1RK1 w - - d4e5", null, null],
  [
    "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - b2b3",
    "E64",
    "King's Indian Defense: Fianchetto Variation, Double Fianchetto Attack",
  ],
  [
    "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - e2e4",
    "E68",
    "King's Indian Defense: Fianchetto Variation, Classical Variation",
  ],
  [
    "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 w - - d4d5",
    "E94",
    "King's Indian Defense: Orthodox Variation, Positional Defense, Closed Line",
  ],
  [
    "r1bq1rk1/pppn1pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 w - - f1e1",
    "E95",
    "King's Indian Defense: Orthodox Variation",
  ],
  ["r1bq1rk1/pppn1pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQR1K1 b - - c7c6", null, null],
  ["r1bq1rk1/pppn1pbp/3p1np1/4p3/2PPP3/2N2NP1/PP3PBP/R1BQ1RK1 b - - c7c6", null, null],
  ["r1bq1rk1/pppn1pbp/3p1np1/4p3/2PPP3/2N2NP1/PP3PBP/R1BQ1RK1 b - - f8e8", null, null],
  [
    "r1bq1rk1/pppn1ppp/3bpn2/3p4/3P4/1P1BPN2/P1P2PPP/RNBQ1RK1 w - - c1b2",
    "D05",
    "Rubinstein Opening: Semi-Slav Defense",
  ],
  [
    "r1bq1rk1/pppn1ppp/3bpn2/3p4/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1 b - - c7c6",
    "D05",
    "Rubinstein Opening: Semi-Slav Defense",
  ],
  [
    "r1bq1rk1/pppn2bp/3p2n1/3Pp1p1/2P1Pp2/2N2P2/PP2BBPP/2RQNRK1 w - - c4c5",
    "E98",
    "King's Indian Defense: Orthodox Variation, Classical System, Kozul Gambit",
  ],
  ["r1bq1rk1/pppnbBpp/3p1n2/4p1N1/3PP3/2N5/PPP2PPP/R1BQK2R b KQ - f8f7", null, null],
  [
    "r1bq1rk1/pppnbppp/3p1n2/4p1N1/2BPP3/2N5/PPP2PPP/R1BQK2R w KQ - c4f7",
    "C41",
    "Philidor Defense: Nimzowitsch, Larobok Variation",
  ],
  ["r1bq1rk1/pppnbppp/3p1n2/4p3/2BPP3/2N2N2/PPP1QPPP/R1B2RK1 b - - c7c6", null, null],
  ["r1bq1rk1/pppnbppp/3p1n2/4p3/2BPP3/2N2N2/PPP2PPP/R1BQ1RK1 w - - d1e2", null, null],
  [
    "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R b K - a7a6",
    "D63",
    "Queen's Gambit Declined: Orthodox Defense, Henneberger Variation",
  ],
  ["r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R b K - b7b6", null, null],
  [
    "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R b K - c7c6",
    "D63",
    "Queen's Gambit Declined: Orthodox Defense, Main Line",
  ],
  [
    "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQ - a1c1",
    "D63",
    "Queen's Gambit Declined: Orthodox Defense, Main Line",
  ],
  [
    "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQ - d1b3",
    "D60",
    "Queen's Gambit Declined: Orthodox Defense, Rauzer Variation",
  ],
  [
    "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQ - d1c2",
    "D61",
    "Queen's Gambit Declined: Orthodox Defense, Rubinstein Variation",
  ],
  [
    "r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQ - f1d3",
    "D60",
    "Queen's Gambit Declined: Orthodox Defense, Botvinnik Variation",
  ],
  ["r1bq1rk1/pppnbppp/4pn2/3p2B1/2PP4/2N1PN2/PPQ2PPP/R3KB1R b KQ - c7c5", null, null],
  [
    "r1bq1rk1/pppnbppp/4pn2/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R w KQ - c4c5",
    "D37",
    "Queen's Gambit Declined: Harrwitz Attack, Two Knights Defense, Blockade Line",
  ],
  ["r1bq1rk1/pppnbppp/4pn2/3p4/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - c7c6", null, null],
  ["r1bq1rk1/pppnbppp/4pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1Q1RK1 w - - d1c2", null, null],
  ["r1bq1rk1/pppnbppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3", null, null],
  ["r1bq1rk1/pppnbppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - d1c2", "E08", "Catalan Opening: Closed"],
  ["r1bq1rk1/pppnbppp/4pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1 b - - c7c6", null, null],
  ["r1bq1rk1/pppnbppp/4pn2/3p4/2PP4/5NP1/PPQBPPBP/RN3RK1 b - - c7c6", "E11", "Bogo-Indian Defense: Retreat Variation"],
  ["r1bq1rk1/pppnbppp/5n2/3p2B1/3P4/2NBP3/PP3PPP/R2QK1NR w KQ - d1c2", null, null],
  ["r1bq1rk1/pppnbppp/5n2/3p2B1/3P4/2NBP3/PPQ2PPP/R3K1NR b KQ - f8e8", null, null],
  ["r1bq1rk1/pppnn1bp/3p2p1/3Pp3/2P1Pp2/2N1BP2/PP2B1PP/R2QNRK1 w - - e3f2", null, null],
  ["r1bq1rk1/pppnn1bp/3p2p1/3Pp3/2P1Pp2/2N2P2/PP2BBPP/R2QNRK1 b - - g6g5", null, null],
  ["r1bq1rk1/pppnn1bp/3p2p1/3Ppp2/2P1P3/2N1B3/PP2BPPP/R2QNRK1 w - - f2f3", null, null],
  ["r1bq1rk1/pppnn1bp/3p2p1/3Ppp2/2P1P3/2N1BP2/PP2B1PP/R2QNRK1 b - - f5f4", null, null],
  [
    "r1bq1rk1/pppnn1bp/3p2p1/3Ppp2/2P1P3/2N2P2/PP2B1PP/R1BQNRK1 w - - g2g4",
    "E99",
    "King's Indian Defense: Orthodox Variation, Classical System, Benko Attack",
  ],
  ["r1bq1rk1/pppnn1bp/3p4/3Pp1p1/2P1Pp2/2N2P2/PP2BBPP/2RQNRK1 b - - e7g6", null, null],
  ["r1bq1rk1/pppnn1bp/3p4/3Pp1p1/2P1Pp2/2N2P2/PP2BBPP/R2QNRK1 w - - a1c1", null, null],
  ["r1bq1rk1/pppnnpbp/3p2p1/3Pp3/2P1P3/2N1B3/PP2BPPP/R2QNRK1 b - - f7f5", null, null],
  [
    "r1bq1rk1/pppnnpbp/3p2p1/3Pp3/2P1P3/2N2P2/PP2B1PP/R1BQNRK1 b - - f7f5",
    "E99",
    "King's Indian Defense: Orthodox Variation, Classical System, Traditional Line",
  ],
  [
    "r1bq1rk1/pppnnpbp/3p2p1/3Pp3/2P1P3/2N5/PP2BPPP/R1BQNRK1 w - - c1e3",
    "E98",
    "King's Indian Defense: Orthodox Variation, Classical System, Neo-Classical Line",
  ],
  ["r1bq1rk1/pppnnpbp/3p2p1/3Pp3/2P1P3/2N5/PP2BPPP/R1BQNRK1 w - - f2f3", null, null],
  ["r1bq1rk1/pppnppbp/3p1np1/8/2PP4/2N1PN2/PP2BPPP/R1BQ1RK1 b - - e7e5", null, null],
  ["r1bq1rk1/pppnppbp/3p1np1/8/2PP4/2N1PN2/PP2BPPP/R1BQK2R w KQ - e1g1", null, null],
  [
    "r1bq1rk1/pppnppbp/3p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - a7a6",
    "E64",
    "King's Indian Defense: Fianchetto Variation, Hungarian Variation",
  ],
  [
    "r1bq1rk1/pppnppbp/3p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - e7e5",
    "E67",
    "King's Indian Defense: Fianchetto Variation, Classical Fianchetto",
  ],
  ["r1bq1rk1/pppnppbp/3p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R w KQ - e1g1", null, null],
  ["r1bq1rk1/pppnppbp/3p1np1/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3", null, null],
  [
    "r1bq1rk1/pppnppbp/3p1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b - - e7e5",
    "E94",
    "King's Indian Defense: Orthodox Variation, Positional Defense",
  ],
  ["r1bq1rk1/pppnppbp/3p1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQK2R w KQ - e1g1", null, null],
  ["r1bq1rk1/pppnppbp/5np1/8/2BP4/1QN1PN2/PP3PPP/R1B1K2R w KQ - f3g5", "D95", "Grünfeld Defense: Pachman Variation"],
  [
    "r1bq1rk1/pppp1ppp/1bn2n2/1B2p3/3PP3/2P2N2/PP3PPP/RNBQ1RK1 w - - c1g5",
    "C64",
    "Ruy Lopez: Classical Variation, Modern Main Line",
  ],
  ["r1bq1rk1/pppp1ppp/2n2n2/1B1Np3/1b2P3/5N2/PPPP1PPP/R1BQ1RK1 b - - f6d5", null, null],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/1B2p3/1b2P3/2N2N2/PPPP1PPP/R1BQ1RK1 w - - b5c6",
    "C49",
    "Four Knights Game: Spanish Variation, Nimzowitsch Variation",
  ],
  ["r1bq1rk1/pppp1ppp/2n2n2/1B2p3/1b2P3/2N2N2/PPPP1PPP/R1BQ1RK1 w - - c3d5", null, null],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/1B2p3/1b2P3/2N2N2/PPPP1PPP/R1BQ1RK1 w - - d2d3",
    "C49",
    "Four Knights Game: Spanish Variation, Double Spanish",
  ],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/1B2p3/1b2P3/2NP1N2/PPP2PPP/R1BQ1RK1 b - - b4c3",
    "C49",
    "Four Knights Game: Spanish Variation",
  ],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/1B2p3/1b2P3/2NP1N2/PPP2PPP/R1BQ1RK1 b - - d7d6",
    "C49",
    "Four Knights Game: Spanish Variation, Symmetrical Variation",
  ],
  ["r1bq1rk1/pppp1ppp/2n2n2/1B2p3/1b2P3/2NP1N2/PPP2PPP/R1BQ1RK1 b - - d8e7", null, null],
  ["r1bq1rk1/pppp1ppp/2n2n2/1B2p3/4P3/2bP1N2/PPP2PPP/R1BQ1RK1 w - - b2c3", null, null],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/1B2p3/4P3/2PP1N2/P1P2PPP/R1BQ1RK1 b - - d7d5",
    "C49",
    "Four Knights Game: Spanish Variation, Svenonius Variation",
  ],
  ["r1bq1rk1/pppp1ppp/2n2n2/1B2p3/4P3/2PP1N2/P1P2PPP/R1BQ1RK1 b - - d7d6", null, null],
  ["r1bq1rk1/pppp1ppp/2n2n2/1Bb1N3/4P3/2N5/PPPP1PPP/R1BQ1RK1 b - - c6e5", null, null],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/1Bb1p3/3PP3/2P2N2/PP3PPP/RNBQ1RK1 b - - c5b6",
    "C64",
    "Ruy Lopez: Classical Defense, Benelux Variation",
  ],
  ["r1bq1rk1/pppp1ppp/2n2n2/1Bb1p3/4P3/2N2N2/PPPP1PPP/R1BQ1RK1 w - - f3e5", null, null],
  ["r1bq1rk1/pppp1ppp/2n2n2/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 w - - d2d4", null, null],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 b - - d7d5",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 b - - d7d6",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  ["r1bq1rk1/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 w - - c2c3", null, null],
  ["r1bq1rk1/pppp1ppp/2n2n2/3Np3/1bP5/4PN2/PPQP1PPP/R1B1KB1R b KQ - f8e8", null, null],
  ["r1bq1rk1/pppp1ppp/2n2n2/4P1N1/1bB5/8/PB3PPP/RN1Q1RK1 b - - c6e5", "C44", "Scotch Game: Hanneken Variation"],
  ["r1bq1rk1/pppp1ppp/2n2n2/4p3/1bP5/2N1PN2/PPQP1PPP/R1B1KB1R w KQ - c3d5", null, null],
  ["r1bq1rk1/pppp1ppp/2n2n2/6N1/1bB1P3/8/PB3PPP/RN1Q1RK1 w - - e4e5", null, null],
  ["r1bq1rk1/pppp1ppp/2n2n2/8/1b2P3/2N1Q3/PPPB1PPP/2KR1BNR b - - f8e8", null, null],
  ["r1bq1rk1/pppp1ppp/2n2n2/8/1b2P3/2N1Q3/PPPB1PPP/R3KBNR w KQ - e1c1", null, null],
  [
    "r1bq1rk1/pppp1ppp/2n2n2/b3p3/2BPP3/2P2N2/P4PPP/RNBQ1RK1 w - - f3e5",
    "C52",
    "Italian Game: Evans Gambit, Richardson Attack",
  ],
  ["r1bq1rk1/pppp1ppp/2n5/1B1np3/1b2P3/5N2/PPPP1PPP/R1BQ1RK1 w - - e4d5", null, null],
  [
    "r1bq1rk1/pppp1ppp/2n5/1B1Pp3/1b6/5N2/PPPP1PPP/R1BQ1RK1 b - - e5e4",
    "C49",
    "Four Knights Game: Spanish Variation, Gunsberg Counterattack",
  ],
  [
    "r1bq1rk1/pppp1ppp/2nb1n2/1B2P3/3P1P2/2N5/PPP3PP/R1BQ1RK1 b - - d6b4",
    "C48",
    "Four Knights Game: Spanish Variation, Bardeleben Variation",
  ],
  ["r1bq1rk1/pppp1ppp/2nb1n2/1B6/3PPP2/2N5/PPP3PP/R1BQ1RK1 w - - e4e5", null, null],
  ["r1bq1rk1/pppp1ppp/3b1n2/1B2n3/3PP3/2N5/PPP2PPP/R1BQ1RK1 w - - f2f4", null, null],
  ["r1bq1rk1/pppp1ppp/3b1n2/1B2n3/3PPP2/2N5/PPP3PP/R1BQ1RK1 b - - e5c6", null, null],
  ["r1bq1rk1/pppp1ppp/5n2/1Bb1n3/3PP3/2N5/PPP2PPP/R1BQ1RK1 b - - c5d6", null, null],
  ["r1bq1rk1/pppp1ppp/5n2/1Bb1n3/4P3/2N5/PPPP1PPP/R1BQ1RK1 w - - d2d4", null, null],
  ["r1bq1rk1/pppp1ppp/5n2/2b1p3/4P3/2N2B2/PPPP1PPP/R1BQ1RK1 w - - d2d3", null, null],
  ["r1bq1rk1/pppp1ppp/5n2/2b1p3/4P3/2NP1B2/PPP2PPP/R1BQ1RK1 b - - d7d6", null, null],
  ["r1bq1rk1/ppppnpbp/2n3p1/1B6/3NP3/2N1B3/PPP2PPP/R2QK2R w KQ - d1d2", null, null],
  [
    "r1bq1rk1/ppppnpbp/2n3p1/1B6/3NP3/2N1B3/PPPQ1PPP/R3K2R b KQ - d7d5",
    "C60",
    "Ruy Lopez: Cozio Defense, Tartakower Gambit",
  ],
  [
    "r1bq2k1/pppnbrpp/3p1n2/4p1N1/3PP3/2N5/PPP2PPP/R1BQK2R w KQ - g5e6",
    "C41",
    "Philidor Defense: Lion Variation, Forcing Line",
  ],
  ["r1bq2r1/ppp2k1p/1b6/nP2B3/3PP3/8/P1P2PPP/RN1QK2R b KQ - d8g5", null, null],
  ["r1bq2r1/ppp2kBp/1b6/nP2p3/3PP3/8/P1P2PPP/RN1QK2R w KQ - g7e5", null, null],
  ["r1bq3r/ppp2kpp/8/3p4/1n1Pn3/1Q3N2/PP3PPP/RN2K2R w KQ - f3e5", null, null],
  ["r1bq3r/ppp2kpp/8/3pN3/1n1Pn3/1Q6/PP3PPP/RN2K2R b KQ - f7f6", null, null],
  [
    "r1bq3r/ppp3pp/5k2/3pN3/1n1Pn3/1Q6/PP3PPP/RN2K2R w KQ - f2f3",
    "C54",
    "Italian Game: Giuoco Piano, Krause Variation",
  ],
  ["r1bq3r/pppp1k1p/2n3p1/2b4Q/3pP3/8/PPP2PPP/RNB1K2R w KQ - h5c5", null, null],
  ["r1bq3r/pppp1k1p/2n3p1/2Q5/3pP3/8/PPP2PPP/RNB1K2R b KQ - d7d5", "C44", "Scotch Game: Cochrane-Shumov Defense"],
  ["r1bq3r/pppp1kpp/2n5/2b4Q/3pP3/8/PPP2PPP/RNB1K2R b KQ - g7g6", null, null],
  ["r1bq3r/pppp1kpp/2n5/2b5/3pP3/8/PPP2PPP/RNBQK2R w KQ - d1h5", null, null],
  ["r1bq3r/pppp1kpp/8/8/1n1Pn3/1Q3N2/PP3PPP/RN2K2R b KQ - d7d5", null, null],
  ["r1bq3r/pppp1kpp/8/8/1n1Pn3/5N2/PP3PPP/RN1QK2R w KQ - d1b3", null, null],
  [
    "r1bq3r/ppppkBpp/2n2n2/2b1p1N1/4P3/8/PPPP1PPP/RNBQK2R w KQ - d2d4",
    "C57",
    "Italian Game: Two Knights Defense, Traxler Variation, Trencianske-Teplice Gambit",
  ],
  [
    "r1bqk1nr/1ppp1ppp/pbn5/4p3/PPB1P3/5N2/2PP1PPP/RNBQK2R w KQkq - b1c3",
    "C51",
    "Italian Game: Evans Gambit Declined, Showalter Variation",
  ],
  [
    "r1bqk1nr/pp1nbppp/2pp4/4p3/2BPP3/5N2/PPP2PPP/RNBQ1RK1 w kq - d4e5",
    "C41",
    "Philidor Defense: Hanham Variation, Steiner Variation",
  ],
  [
    "r1bqk1nr/pp1p1pbp/2n1p1p1/2p5/2B1PP2/2N2N2/PPPP2PP/R1BQK2R w KQkq - f4f5",
    "B23",
    "Sicilian Defense: Grand Prix Attack, Schofman Variation",
  ],
  ["r1bqk1nr/pp1p1pbp/2n1p1p1/2p5/4P3/2NP2P1/PPP2PBP/R1BQK1NR w KQkq - c1e3", null, null],
  ["r1bqk1nr/pp1p1pbp/2n1p1p1/2p5/4P3/2NPB1P1/PPP2PBP/R2QK1NR b KQkq - c6d4", null, null],
  [
    "r1bqk1nr/pp1p1pbp/2n3p1/1Bp1p3/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 w kq - d2d4",
    "B31",
    "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Fianchetto Variation, Gufeld Gambit",
  ],
  [
    "r1bqk1nr/pp1p1pbp/2n3p1/1Bp1p3/4P3/5N2/PPPP1PPP/RNBQR1K1 w kq - b2b4",
    "B31",
    "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Gurgenidze Variation",
  ],
  [
    "r1bqk1nr/pp1p1pbp/2n3p1/2p1p3/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 b kq - d7d6",
    "A37",
    "English Opening: Symmetrical Variation, Botvinnik System Reversed, with Nf3",
  ],
  [
    "r1bqk1nr/pp1p1pbp/2n3p1/2p1p3/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 b kq - g8e7",
    "A37",
    "English Opening: Symmetrical Variation, Botvinnik System Reversed, with Nf3",
  ],
  ["r1bqk1nr/pp1p1pbp/2n3p1/2p1p3/2P5/2N2NP1/PP1PPPBP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1bqk1nr/pp1p1pbp/4p1p1/2p5/3nP3/2NPB1P1/PPP2PBP/R2QK1NR w KQkq - c3e2",
    "B24",
    "Sicilian Defense: Closed, Smyslov Variation",
  ],
  ["r1bqk1nr/pp1pbppp/2n5/2p1p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - d2d3", null, null],
  [
    "r1bqk1nr/pp1pbppp/2n5/2p1p3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R b KQkq - d7d6",
    "B30",
    "Sicilian Defense: Closed, Anti-Sveshnikov Variation, with d6",
  ],
  [
    "r1bqk1nr/pp1pbppp/2n5/2p1p3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R b KQkq - g8f6",
    "B30",
    "Sicilian Defense: Closed, Anti-Sveshnikov Variation, with Nf6",
  ],
  ["r1bqk1nr/pp1pppbp/2n3p1/1Bp5/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 b kq - e7e5", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/1Bp5/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 b kq - g8f6", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/1Bp5/4P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - c2c3", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/1Bp5/4P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/1Bp5/4P3/5N2/PPPP1PPP/RNBQR1K1 b kq - e7e5", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/2p5/2B1PP2/2N2N2/PPPP2PP/R1BQK2R b KQkq - e7e6", null, null],
  [
    "r1bqk1nr/pp1pppbp/2n3p1/2p5/2P1P3/2N3P1/PP1P1P1P/R1BQKBNR w KQkq - f1g2",
    "A36",
    "English Opening: Symmetrical Variation, Botvinnik System",
  ],
  [
    "r1bqk1nr/pp1pppbp/2n3p1/2p5/2P5/2N1P1P1/PP1P1PBP/R1BQK1NR b KQkq - e7e5",
    "A36",
    "English Opening: Symmetrical Variation, Botvinnik System Reversed, with e3",
  ],
  [
    "r1bqk1nr/pp1pppbp/2n3p1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQK2R b KQkq - e7e5",
    "A37",
    "English Opening: Symmetrical Variation, Botvinnik System Reversed, with Nf3",
  ],
  [
    "r1bqk1nr/pp1pppbp/2n3p1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQK2R b KQkq - g8f6",
    "A38",
    "English Opening: Symmetrical Variation, Full Symmetry Line",
  ],
  ["r1bqk1nr/pp1pppbp/2n3p1/2p5/2P5/2N3P1/PP1PPPBP/R1BQK1NR w KQkq - e2e3", null, null],
  [
    "r1bqk1nr/pp1pppbp/2n3p1/2p5/2P5/2N3P1/PP1PPPBP/R1BQK1NR w KQkq - g1f3",
    "A37",
    "English Opening: Symmetrical Variation, Three Knights, Fianchetto Variation",
  ],
  ["r1bqk1nr/pp1pppbp/2n3p1/2p5/4P3/2N3P1/PPPP1PBP/R1BQK1NR w KQkq - d2d3", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/2p5/4P3/2NP2P1/PPP2PBP/R1BQK1NR b KQkq - d7d6", "B25", "Sicilian Defense: Closed"],
  ["r1bqk1nr/pp1pppbp/2n3p1/2p5/4P3/2NP2P1/PPP2PBP/R1BQK1NR b KQkq - e7e6", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/2p5/4PP2/2N2N2/PPPP2PP/R1BQKB1R w KQkq - f1c4", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/8/2P1P3/8/PPN2PPP/RNBQKB1R b KQkq - d7d6", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/8/2PNP3/4B3/PP3PPP/RN1QKB1R b KQkq - g8f6", null, null],
  [
    "r1bqk1nr/pp1pppbp/2n3p1/8/2PNP3/8/PP3PPP/RNBQKB1R w KQkq - c1e3",
    "B38",
    "Sicilian Defense: Accelerated Dragon, Maróczy Bind",
  ],
  ["r1bqk1nr/pp1pppbp/2n3p1/8/2PNP3/8/PP3PPP/RNBQKB1R w KQkq - d4c2", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R b KQkq - g8f6", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - c1e3", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/8/3NP3/4B3/PPP1BPPP/RN1QK2R b KQkq - g8f6", null, null],
  ["r1bqk1nr/pp1pppbp/2n3p1/8/3NP3/4B3/PPP2PPP/RN1QKB1R w KQkq - f1e2", null, null],
  ["r1bqk1nr/pp2bppp/2np4/2p1p3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R w KQkq - f3d2", null, null],
  [
    "r1bqk1nr/pp2bppp/2np4/2p1p3/2B1P3/2NP4/PPPN1PPP/R1BQK2R b KQkq - e7g5",
    "B30",
    "Sicilian Defense: Closed, Anti-Sveshnikov Variation, Kharlov-Kramnik Line",
  ],
  [
    "r1bqk1nr/pp2ppbp/2np2p1/2p5/4P3/2NP2P1/PPP1NPBP/R1BQK2R b KQkq - e7e5",
    "B25",
    "Sicilian Defense: Closed, Botvinnik Defense, with Nge2",
  ],
  ["r1bqk1nr/pp2ppbp/2np2p1/2p5/4P3/2NP2P1/PPP2PBP/R1BQK1NR w KQkq - c1e3", "B26", "Sicilian Defense: Closed"],
  ["r1bqk1nr/pp2ppbp/2np2p1/2p5/4P3/2NP2P1/PPP2PBP/R1BQK1NR w KQkq - f2f4", "B25", "Sicilian Defense: Closed"],
  ["r1bqk1nr/pp2ppbp/2np2p1/2p5/4P3/2NP2P1/PPP2PBP/R1BQK1NR w KQkq - g1e2", null, null],
  [
    "r1bqk1nr/pp2ppbp/2np2p1/2p5/4PP2/2NP2P1/PPP3BP/R1BQK1NR b KQkq - e7e5",
    "B25",
    "Sicilian Defense: Closed, Botvinnik Defense, with f4",
  ],
  [
    "r1bqk1nr/pp2ppbp/2np2p1/8/2P1P3/8/PPN1BPPP/RNBQK2R b KQkq - g8h6",
    "B37",
    "Sicilian Defense: Accelerated Dragon, Simagin Variation",
  ],
  ["r1bqk1nr/pp2ppbp/2np2p1/8/2P1P3/8/PPN2PPP/RNBQKB1R w KQkq - f1e2", null, null],
  ["r1bqk1nr/pp2ppbp/2np2p1/8/3NPP2/2N1B3/PPP3PP/R2QKB1R b KQkq - g8f6", null, null],
  ["r1bqk1nr/pp2ppbp/2np2p1/8/3NPP2/2N5/PPP3PP/R1BQKB1R w KQkq - c1e3", null, null],
  ["r1bqk1nr/pp3pbp/2np2p1/2p1p3/4PP2/2NP2P1/PPP3BP/R1BQK1NR w KQkq - g1h3", null, null],
  [
    "r1bqk1nr/pp3pbp/2np2p1/2p1p3/4PP2/2NP2PN/PPP3BP/R1BQK2R b KQkq - g8e7",
    "B25",
    "Sicilian Defense: Closed, Botvinnik Defense, Edge Variation",
  ],
  ["r1bqk1nr/pp3ppp/2n1p3/2ppP3/3P4/P1P2N2/2P2PPP/R1BQKB1R b KQkq - d8a5", null, null],
  [
    "r1bqk1nr/pp3ppp/2n1p3/2ppP3/3P4/P1P2N2/2P2PPP/R1BQKB1R b KQkq - g8e7",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  ["r1bqk1nr/pp3ppp/2n1p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["r1bqk1nr/ppp2pbp/2np2p1/4p3/2P5/2N1P1P1/PP1P1PBP/R1BQK1NR w KQkq - g1e2", null, null],
  [
    "r1bqk1nr/ppp2pbp/2np2p1/4p3/2P5/2N1P1P1/PP1PNPBP/R1BQK2R b KQkq - c8e6",
    "A25",
    "English Opening: King's English Variation, Bremen-Hort Variation",
  ],
  [
    "r1bqk1nr/ppp2pbp/2np2p1/4p3/2P5/2N1P1P1/PP1PNPBP/R1BQK2R b KQkq - g8h6",
    "A25",
    "English Opening: Closed, Taimanov Variation",
  ],
  [
    "r1bqk1nr/ppp2pbp/2np2p1/4p3/2P5/2NP2P1/PP2PPBP/R1BQK1NR w KQkq - e2e4",
    "A26",
    "English Opening: King's English Variation, Botvinnik System",
  ],
  [
    "r1bqk1nr/ppp2ppp/1b1p4/n2P4/2B1P3/5N2/P4PPP/RNBQ1RK1 w kq - c1b2",
    "C51",
    "Italian Game: Evans Gambit, Ulvestad Variation",
  ],
  [
    "r1bqk1nr/ppp2ppp/1b1p4/n2P4/2B1P3/5N2/PB3PPP/RN1Q1RK1 b kq - g8e7",
    "C51",
    "Italian Game: Evans Gambit, Paulsen Variation",
  ],
  ["r1bqk1nr/ppp2ppp/1b1p4/n5B1/2BPP3/2N2N2/P4PPP/R2Q1RK1 b kq - f7f6", null, null],
  [
    "r1bqk1nr/ppp2ppp/1b1p4/n7/2BPP3/2N2N2/P4PPP/R1BQ1RK1 w kq - c1g5",
    "C51",
    "Italian Game: Evans Gambit, Göring Attack",
  ],
  ["r1bqk1nr/ppp2ppp/1bnp4/3P4/2B1P3/5N2/P4PPP/RNBQ1RK1 b kq - c6a5", null, null],
  ["r1bqk1nr/ppp2ppp/1bnp4/8/2BPP3/2N2N2/P4PPP/R1BQ1RK1 b kq - c6a5", null, null],
  ["r1bqk1nr/ppp2ppp/1bnp4/8/2BPP3/2N2N2/P4PPP/R1BQ1RK1 b kq - c8g4", "C51", "Italian Game: Evans Gambit"],
  ["r1bqk1nr/ppp2ppp/1bnp4/8/2BPP3/5N2/P4PPP/RNBQ1RK1 w kq - b1c3", "C51", "Italian Game: Evans Gambit, Morphy Attack"],
  ["r1bqk1nr/ppp2ppp/1bnp4/8/2BPP3/5N2/P4PPP/RNBQ1RK1 w kq - d4d5", null, null],
  ["r1bqk1nr/ppp2ppp/2np4/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r1bqk1nr/ppp2ppp/2np4/2b1p3/2BPP3/2P2N2/PP3PPP/RNBQK2R b KQkq - e5d4", null, null],
  ["r1bqk1nr/ppp2ppp/2np4/2b5/2BpP3/2P2N2/P4PPP/RNBQ1RK1 w kq - c3d4", null, null],
  [
    "r1bqk1nr/ppp2ppp/2np4/2b5/2BpP3/2P2N2/PP3PPP/RNBQ1RK1 b kq - c8g4",
    "C44",
    "Scotch Game: Scotch Gambit, Cochrane-Anderssen Variation",
  ],
  ["r1bqk1nr/ppp2ppp/2np4/2b5/2BpP3/2P2N2/PP3PPP/RNBQK2R w KQkq - c3d4", null, null],
  [
    "r1bqk1nr/ppp2ppp/2np4/2b5/2BPP3/5N2/P4PPP/RNBQ1RK1 b kq - c5b6",
    "C51",
    "Italian Game: Evans Gambit, McDonnell Defense, Main Line",
  ],
  [
    "r1bqk1nr/ppp2ppp/2np4/2b5/2BPP3/5N2/PP3PPP/RNBQK2R b KQkq - c5b6",
    "C53",
    "Italian Game: Classical Variation, La Bourdonnais Variation",
  ],
  ["r1bqk1nr/ppp2ppp/2np4/2b5/2BpP3/5N2/PPP2PPP/RNBQ1RK1 w kq - c2c3", null, null],
  ["r1bqk1nr/ppp2ppp/2np4/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQ1RK1 w kq - d2d4", null, null],
  ["r1bqk1nr/ppp2ppp/2np4/b3p3/2BPP3/1QP2N2/P4PPP/RNB1K2R b KQkq - d8d7", null, null],
  [
    "r1bqk1nr/ppp2ppp/2np4/b3p3/2BPP3/2P2N2/P4PPP/RNBQ1RK1 b kq - a5b6",
    "C52",
    "Italian Game: Evans Gambit, Lasker Defense",
  ],
  [
    "r1bqk1nr/ppp2ppp/2np4/b3p3/2BPP3/2P2N2/P4PPP/RNBQ1RK1 b kq - c8d7",
    "C52",
    "Italian Game: Evans Gambit, Sanders-Alapin Variation",
  ],
  [
    "r1bqk1nr/ppp2ppp/2np4/b3p3/2BPP3/2P2N2/P4PPP/RNBQ1RK1 b kq - c8g4",
    "C52",
    "Italian Game: Evans Gambit, Alapin-Steinitz Variation",
  ],
  [
    "r1bqk1nr/ppp2ppp/2np4/b3p3/2BPP3/2P2N2/P4PPP/RNBQK2R w KQkq - c1g5",
    "C52",
    "Italian Game: Evans Gambit, Sokolsky Variation",
  ],
  [
    "r1bqk1nr/ppp2ppp/2np4/b3p3/2BPP3/2P2N2/P4PPP/RNBQK2R w KQkq - d1b3",
    "C52",
    "Italian Game: Evans Gambit, Tartakower Attack",
  ],
  ["r1bqk1nr/ppp2ppp/2np4/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1 w kq - c3d4", null, null],
  [
    "r1bqk1nr/ppp2ppp/2np4/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1 w kq - d1b3",
    "C52",
    "Italian Game: Evans Gambit, Waller Attack",
  ],
  [
    "r1bqk1nr/ppp2ppp/2np4/b7/2BPP3/5N2/P4PPP/RNBQ1RK1 b kq - a5b6",
    "C51",
    "Italian Game: Evans Gambit, McDonnell Defense, Main Line",
  ],
  [
    "r1bqk1nr/ppp3pp/1b1p1p2/n5B1/2BPP3/2N2N2/P4PPP/R2Q1RK1 w kq - g5e3",
    "C51",
    "Italian Game: Evans Gambit, Steinitz Variation",
  ],
  ["r1bqk1nr/pppp1pbp/2n3p1/1B6/3NP3/4B3/PPP2PPP/RN1QK2R b KQkq - g8e7", null, null],
  ["r1bqk1nr/pppp1pbp/2n3p1/1B6/3NP3/8/PPP2PPP/RNBQK2R w KQkq - c1e3", null, null],
  ["r1bqk1nr/pppp1pbp/2n3p1/4p3/2P5/2N1P1P1/PP1P1PBP/R1BQK1NR b KQkq - d7d6", null, null],
  [
    "r1bqk1nr/pppp1pbp/2n3p1/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR w KQkq - a1b1",
    "A25",
    "English Opening: King's English Variation, Hungarian Attack",
  ],
  [
    "r1bqk1nr/pppp1pbp/2n3p1/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR w KQkq - d2d3",
    "A25",
    "English Opening: King's English Variation, Closed System",
  ],
  ["r1bqk1nr/pppp1pbp/2n3p1/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR w KQkq - e2e3", null, null],
  [
    "r1bqk1nr/pppp1pbp/2n3p1/4p3/2P5/2NP2P1/PP2PPBP/R1BQK1NR b KQkq - d7d6",
    "A26",
    "English Opening: King's English Variation, Closed System, Full Symmetry",
  ],
  [
    "r1bqk1nr/pppp1pp1/2n5/2b1p2p/4P3/2N2NP1/PPPP1PBP/R1BQK2R b KQkq - h5h4",
    "C25",
    "Vienna Game: Paulsen Variation, Mariotti Gambit",
  ],
  ["r1bqk1nr/pppp1pp1/2n5/2b1p2p/4P3/2N3P1/PPPP1PBP/R1BQK1NR w KQkq - g1f3", null, null],
  [
    "r1bqk1nr/pppp1ppp/1b6/nP2N3/2B1P3/8/P1PP1PPP/RNBQK2R b KQkq - d8g5",
    "C51",
    "Italian Game: Evans Gambit Declined, Hirschbach Variation",
  ],
  [
    "r1bqk1nr/pppp1ppp/1b6/nP2N3/2B1P3/8/P1PP1PPP/RNBQK2R b KQkq - g8h6",
    "C51",
    "Italian Game: Evans Gambit Declined, Lange Variation",
  ],
  ["r1bqk1nr/pppp1ppp/1b6/nP2p3/2B1P3/5N2/P1PP1PPP/RNBQK2R w KQkq - f3e5", null, null],
  ["r1bqk1nr/pppp1ppp/1bn5/1P2p3/2B1P3/5N2/P1PP1PPP/RNBQK2R b KQkq - c6a5", null, null],
  [
    "r1bqk1nr/pppp1ppp/1bn5/4p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R w KQkq - a2a4",
    "C51",
    "Italian Game: Evans Gambit Declined",
  ],
  ["r1bqk1nr/pppp1ppp/1bn5/4p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R w KQkq - b4b5", null, null],
  [
    "r1bqk1nr/pppp1ppp/1bn5/4p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R w KQkq - c1b2",
    "C51",
    "Italian Game: Evans Gambit Declined, Cordel Variation",
  ],
  ["r1bqk1nr/pppp1ppp/1bn5/4p3/PPB1P3/5N2/2PP1PPP/RNBQK2R b KQkq - a7a6", null, null],
  [
    "r1bqk1nr/pppp1ppp/2B5/b3p3/4P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - d7c6",
    "C60",
    "Ruy Lopez: Alapin Defense, Alapin Gambit",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/1B2p3/1b2P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - b4a5", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/1B2p3/1b2P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c3", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - c5b6",
    "C64",
    "Ruy Lopez: Classical Variation, Charousek Variation",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - d7d5",
    "C64",
    "Ruy Lopez: Classical Variation, Konikowski Gambit",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - d8e7",
    "C64",
    "Ruy Lopez: Classical Defense, Boden Variation",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - f7f5",
    "C64",
    "Ruy Lopez: Classical Variation, Cordel Gambit",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - c6d4", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b2b4",
    "C64",
    "Ruy Lopez: Classical Variation, Spanish Wing Gambit",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c3",
    "C64",
    "Ruy Lopez: Classical Variation, Central Variation",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R b KQkq - b7b5",
    "C51",
    "Italian Game: Evans Gambit, Fontaine Countergambit",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R b KQkq - c5b4",
    "C51",
    "Italian Game: Evans Gambit Accepted",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R b KQkq - c5b6",
    "C51",
    "Italian Game: Evans Gambit Declined",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/1PB1P3/5N2/P1PP1PPP/RNBQK2R b KQkq - d7d5",
    "C51",
    "Italian Game: Evans Gambit, Hein Countergambit",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P1Q1/2N5/PPPP1PPP/R1B1K1NR b KQkq - d8f6", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - g8f6",
    "C50",
    "Four Knights Game: Italian Variation",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR w KQkq - d1g4", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - d7d6", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - d8e7",
    "C53",
    "Italian Game: Classical Variation, Closed Variation",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - g8f6",
    "C54",
    "Italian Game: Classical Variation",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/2P5/PP1PQPPP/RNB1K1NR b KQkq - g8f6", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - f7f5",
    "C50",
    "Italian Game: Giuoco Pianissimo, Lucchini Gambit",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - g8f6",
    "C50",
    "Italian Game: Giuoco Pianissimo, Normal",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - g8f6", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b1c3", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b2b4", "C51", "Italian Game: Evans Gambit"],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c3", "C53", "Italian Game: Classical Variation"],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c4f7", "C50", "Italian Game: Jerome Gambit"],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d3", "C50", "Italian Game: Giuoco Pianissimo"],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4", "C50", "Italian Game: Rosentreter Gambit"],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2B1P3/8/PPPPQPPP/RNB1K1NR w KQkq - c2c3", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/2BPP3/2P2N2/P4PPP/RNBQK2R b KQkq - e5d4", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/4P3/2N3P1/PPPP1PBP/R1BQK1NR b KQkq - h7h5", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b1P3/4P3/2N5/PPPP2PP/R1BQKBNR b KQkq - d7d6",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Quelle Gambit",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/2b1p3/4PP2/2N5/PPPP2PP/R1BQKBNR w KQkq - f4e5", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b3N1/2BpP3/8/PPP2PPP/RNBQK2R b KQkq - g8h6", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/2BpP3/2P2N2/P4PPP/RNBQ1RK1 b kq - d7d6", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/2BpP3/2P2N2/P4PPP/RNBQK2R w KQkq - c3d4", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/2BpP3/2P2N2/P4PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/2BPP3/5N2/P4PPP/RNBQK2R b KQkq - c5b4", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/2BpP3/5N2/PPP2PPP/RNBQ1RK1 b kq - d7d6", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b5/2BpP3/5N2/PPP2PPP/RNBQ1RK1 b kq - g8f6",
    "C56",
    "Italian Game: Scotch Gambit, Max Lange Attack",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b5/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - f3g5",
    "C44",
    "Scotch Game: Scotch Gambit, Sarratt Variation",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/3NP3/4B3/PPP2PPP/RN1QKB1R b KQkq - d8f6", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - c1e3", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - d4b3", "C45", "Scotch Game: Potter Variation"],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - d4c6", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/2b5/3pPP2/5N2/PPP3PP/RNBQKB1R w KQkq - c2c3",
    "C21",
    "Center Game: Halasz-McDonnell Gambit, Crocodile Variation",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/2b5/4P3/1N6/PPP2PPP/RNBQKB1R b KQkq - c5b4", "C45", "Scotch Game: Romanishin Variation"],
  [
    "r1bqk1nr/pppp1ppp/2N5/2b5/4P3/8/PPP2PPP/RNBQKB1R b KQkq - d8f6",
    "C45",
    "Scotch Game: Classical Variation, Intermezzo Variation",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/3Np3/1b2P3/5N2/PPPP1PPP/R1BQKB1R b KQkq - g8f6",
    "C46",
    "Three Knights Opening: Schlechter Variation",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/4p3/1b2P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - c3d5", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/4p3/1bB1P3/2P2N2/P2P1PPP/RNBQK2R b KQkq - b4a5",
    "C52",
    "Italian Game: Evans Gambit, Main Line",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/4p3/1bB1P3/2P2N2/P2P1PPP/RNBQK2R b KQkq - b4c5",
    "C51",
    "Italian Game: Evans Gambit, McDonnell Defense",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/4p3/1bB1P3/2P2N2/P2P1PPP/RNBQK2R b KQkq - b4d6",
    "C51",
    "Italian Game: Evans Gambit, Stone-Ware Variation",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/4p3/1bB1P3/2P2N2/P2P1PPP/RNBQK2R b KQkq - b4e7",
    "C51",
    "Italian Game: Evans Gambit, Anderssen Variation",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/4p3/1bB1P3/2P2N2/P2P1PPP/RNBQK2R b KQkq - b4f8",
    "C51",
    "Italian Game: Evans Gambit, Mayet Defense",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/4p3/1bB1P3/5N2/P1PP1PPP/RNBQK2R w KQkq - c2c3", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/8/1b2P3/2P1Q3/PP3PPP/RNB1KBNR b KQkq - b4e7", "C22", "Center Game: Charousek Variation"],
  ["r1bqk1nr/pppp1ppp/2n5/8/1b2P3/4Q3/PPP2PPP/RNB1KBNR w KQkq - c2c3", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/8/1bB1P3/2P2N2/P4PPP/RNBQK2R b KQkq - b4a5", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/8/1bB1P3/2p2N2/PP3PPP/RNBQ1RK1 b kq - c3b2", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/8/1bB1P3/2p2N2/PP3PPP/RNBQK2R w KQkq - b2c3", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/8/1bB1P3/2p2N2/PP3PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/8/1bB1P3/5N2/PB3PPP/RN1Q1RK1 b kq - g8f6", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/8/1bB1P3/5N2/Pp3PPP/RNBQ1RK1 w kq - c1b2", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/8/1bBpP3/2P2N2/PP3PPP/RNBQK2R b KQkq - d4c3", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/8/1bBPP3/5N2/P4PPP/RNBQK2R w KQkq - c1d2",
    "C51",
    "Italian Game: Evans Gambit, Harding Variation",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/8/1bBpP3/5N2/PPP2PPP/RNBQK2R w KQkq - c2c3", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQ1RK1 b kq - d7d6", "C52", "Italian Game: Evans Gambit"],
  ["r1bqk1nr/pppp1ppp/2n5/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQ1RK1 b kq - g8f6", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R w KQkq - d2d4", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R w KQkq - e1g1",
    "C52",
    "Italian Game: Evans Gambit, Slow Variation",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/b3p3/2BPP3/2P2N2/P4PPP/RNBQK2R b KQkq - b7b5",
    "C52",
    "Italian Game: Evans Gambit, Leonhardt Countergambit",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/b3p3/2BPP3/2P2N2/P4PPP/RNBQK2R b KQkq - d7d6",
    "C52",
    "Italian Game: Evans Gambit, Bronstein Defense",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/b3p3/2BPP3/2P2N2/P4PPP/RNBQK2R b KQkq - e5d4",
    "C52",
    "Italian Game: Evans Gambit, Pierce Defense",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/b3p3/2BPP3/2P2N2/P4PPP/RNBQK2R b KQkq - g8f6",
    "C52",
    "Italian Game: Evans Gambit, Laroche Variation",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/b7/2B1P3/1Qp2N2/P4PPP/RNB2RK1 b kq - d8f6", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/b7/2B1P3/2p2N2/P4PPP/RNBQ1RK1 w kq - d1b3", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/b7/2B1P3/2P2N2/P4PPP/RNBQK2R w KQkq - e4e5", "C44", "Scotch Game: Cochrane Variation"],
  [
    "r1bqk1nr/pppp1ppp/2n5/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1 b kq - b7b5",
    "C52",
    "Italian Game: Evans Gambit, Johner Defense",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1 b kq - d4c3",
    "C52",
    "Italian Game: Evans Gambit, Compromised Defense",
  ],
  [
    "r1bqk1nr/pppp1ppp/2n5/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1 b kq - d4d3",
    "C52",
    "Italian Game: Evans Gambit, Dufresne Defense",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1 b kq - d7d6", null, null],
  [
    "r1bqk1nr/pppp1ppp/2n5/b7/2BpP3/2P2N2/P4PPP/RNBQ1RK1 b kq - g8e7",
    "C52",
    "Italian Game: Evans Gambit, Mieses Defense",
  ],
  ["r1bqk1nr/pppp1ppp/2n5/b7/2BpP3/2P2N2/P4PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqk1nr/pppp1ppp/2n5/bB2p3/4P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - b5c6", null, null],
  [
    "r1bqk1nr/pppp1ppp/6n1/4P3/1bBP4/2N2Q2/PPP2PPP/R1B1K2R b KQkq - f7f5",
    "C47",
    "Four Knights Game: Halloween Gambit, Oldtimer Variation",
  ],
  ["r1bqk1nr/pppp1ppp/6n1/4P3/1bBP4/2N5/PPP2PPP/R1BQK2R w KQkq - d1f3", null, null],
  [
    "r1bqk1nr/pppp1ppp/8/1Bb1p3/3nP3/5N2/PPPP1PPP/RNBQ1RK1 w kq - b2b4",
    "C64",
    "Ruy Lopez: Classical Defense, Zaitsev Variation",
  ],
  ["r1bqk1nr/pppp2pp/2n5/2b1pp2/2B1P3/3P1N2/PPP2PPP/RNBQK2R w KQkq - f3g5", null, null],
  [
    "r1bqk1nr/pppp2pp/2n5/2b1ppN1/2B1P3/3P4/PPP2PPP/RNBQK2R b KQkq - f5f4",
    "C50",
    "Italian Game: Giuoco Pianissimo, Dubois Variation",
  ],
  ["r1bqk1nr/ppppbppp/2n5/4p3/2B1P3/2P2N2/P2P1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r1bqk1nr/ppppbppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4", null, null],
  [
    "r1bqk1nr/ppppbppp/2n5/4p3/2BPP3/2P2N2/P4PPP/RNBQK2R b KQkq - c6a5",
    "C51",
    "Italian Game: Evans Gambit, Anderssen Variation, Cordel Line",
  ],
  ["r1bqk1nr/ppppbppp/2n5/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R b KQkq - e5d4", "C44", "Scotch Game: Benima Defense"],
  ["r1bqk1nr/ppppbppp/2n5/8/2BpP3/2P2N2/PP3PPP/RNBQK2R b KQkq - g8f6", null, null],
  ["r1bqk1nr/ppppbppp/2n5/8/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - c2c3", null, null],
  ["r1bqk1r1/ppp2BBp/1b6/nP2p3/3PP3/8/P1P2PPP/RN1QK2R b KQq - e8f7", null, null],
  ["r1bqk1r1/ppp2pBp/1b6/nP2p3/2BPP3/8/P1P2PPP/RN1QK2R w KQq - c4f7", null, null],
  [
    "r1bqk2r/1p1p1ppp/p1n1pn2/8/1bPNP3/2NB4/PP3PPP/R1BQK2R w KQkq - d3c2",
    "B41",
    "Sicilian Defense: Kan Variation, Maróczy Bind, Bronstein Variation",
  ],
  ["r1bqk2r/1p2bppp/p1nppn2/8/2P1P3/N1N5/PP2BPPP/R1BQK2R b KQkq - e8g8", null, null],
  ["r1bqk2r/1p2bppp/p1nppn2/8/2P1P3/N1N5/PP3PPP/R1BQKB1R w KQkq - f1e2", null, null],
  ["r1bqk2r/1p2bppp/p2ppn2/6B1/3QP3/2N5/PPP2PPP/2KR1B1R w kq - f2f4", null, null],
  [
    "r1bqk2r/1p2bppp/p2ppn2/6B1/3QPP2/2N5/PPP3PP/2KR1B1R b kq - b7b5",
    "B63",
    "Sicilian Defense: Richter-Rauzer Variation, Classical Variation, Kantscher Line",
  ],
  ["r1bqk2r/1p3ppp/p1n1pn2/2b5/2B1P3/5N2/PP2QPPP/RNB2RK1 b kq - b7b5", null, null],
  ["r1bqk2r/1p3ppp/p1n1pn2/2b5/2B5/4PN2/PP2QPPP/RNB2RK1 w kq - e3e4", null, null],
  [
    "r1bqk2r/1pp2ppp/p1np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 w kq - a2a4",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/1pp2ppp/p1np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 w kq - f1e1",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/1pp2ppp/p1np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQR1K1 b kq - c5a7",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/1pp2ppp/p1np1n2/2b1p3/P1B1P3/2PP1N2/1P3PPP/RNBQ1RK1 b kq - c5a7",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/1pp2ppp/p1np1n2/2b1p3/P1B1P3/2PP1N2/1P3PPP/RNBQ1RK1 b kq - e8g8",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/1ppp1ppp/2n2n2/p1b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 w kq - c2c3",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo, with a5",
  ],
  ["r1bqk2r/1pppbppp/p1n2n2/4P3/B2p4/5N2/PPP2PPP/RNBQ1RK1 b kq - f6e4", null, null],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B2PP3/5N2/PPP2PPP/RNBQ1RK1 b kq - e5d4", null, null],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - a4c6", "C85", "Ruy Lopez: Closed, Delayed Exchange"],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - b1c3", "C84", "Ruy Lopez: Closed, Morphy Attack"],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d1e2", "C86", "Ruy Lopez: Closed, Worrall Attack"],
  [
    "r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d2d3",
    "C84",
    "Ruy Lopez: Closed, Martinez Variation",
  ],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d2d4", "C84", "Ruy Lopez: Closed, Center Attack"],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQR1K1 b kq - b7b5", null, null],
  [
    "r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQR1K1 b kq - d7d6",
    "C87",
    "Ruy Lopez: Closed, Averbakh Variation",
  ],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPPQPPP/RNB1K2R w KQkq - e1g1", "C86", "Ruy Lopez: Closed, Worrall Attack"],
  ["r1bqk2r/1pppbppp/p1n2n2/4p3/B3P3/5N2/PPPPQPPP/RNB2RK1 b kq - b7b5", null, null],
  ["r1bqk2r/1pppbppp/p1n2n2/8/B2pP3/5N2/PPP2PPP/RNBQ1RK1 w kq - e4e5", null, null],
  [
    "r1bqk2r/1pppbppp/p1n5/4P3/B2pn3/2P2N2/PP3PPP/RNBQ1RK1 b kq - d4c3",
    "C84",
    "Ruy Lopez: Closed, Center Attack, Basque Gambit",
  ],
  ["r1bqk2r/1pppbppp/p1n5/4P3/B2pn3/5N2/PPP2PPP/RNBQ1RK1 w kq - c2c3", "C84", "Ruy Lopez: Closed, Basque Gambit"],
  ["r1bqk2r/1pppbppp/p1n5/4p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r1bqk2r/1pppbppp/p1n5/4p3/B2Pn3/5N2/PPP2PPP/RNBQR1K1 b kq - b7b5", null, null],
  ["r1bqk2r/2p1bppp/p1n5/1p1pp3/3Pn3/1B3N2/PPP2PPP/RNBQR1K1 w kq - d4e5", null, null],
  ["r1bqk2r/2p1bppp/p1n5/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQR1K1 b kq - c8e6", null, null],
  ["r1bqk2r/2p1bppp/p1np1n2/1p2p3/3PP3/1B3N2/PPP1QPPP/RNB1K2R w KQkq - c2c3", null, null],
  ["r1bqk2r/2p1bppp/p1np1n2/1p2p3/3PP3/1B3N2/PPP2PPP/RNBQR1K1 b kq - c6d4", null, null],
  [
    "r1bqk2r/2p1bppp/p1np1n2/1p2p3/3PP3/1BP2N2/PP2QPPP/RNB1K2R b KQkq - c8g4",
    "C77",
    "Ruy Lopez: Wormald Attack, Grünfeld Variation",
  ],
  ["r1bqk2r/2p1bppp/p1np1n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1 w kq - c2c3", null, null],
  ["r1bqk2r/2p1bppp/p1np1n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1 w kq - d2d4", "C88", "Ruy Lopez: Closed, Rosen Attack"],
  ["r1bqk2r/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 b kq - c6a5", null, null],
  ["r1bqk2r/2p1bppp/p1np1n2/1p2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 b kq - e8g8", "C90", "Ruy Lopez: Closed"],
  ["r1bqk2r/2p1bppp/p2p1n2/1p2p3/3nP3/1B3N2/PPP2PPP/RNBQR1K1 w kq - f3d4", null, null],
  ["r1bqk2r/2p1bppp/p2p1n2/1p2p3/3NP3/1B6/PPP2PPP/RNBQR1K1 b kq - e5d4", null, null],
  ["r1bqk2r/2p1bppp/p2p1n2/1p6/3pP3/1B6/PPP2PPP/RNBQR1K1 w kq - d1d4", null, null],
  ["r1bqk2r/2p1bppp/p2p1n2/1p6/3QP3/1B6/PPP2PPP/RNB1R1K1 b kq - c7c5", "C88", "Ruy Lopez: Noah's Ark Trap"],
  ["r1bqk2r/2p1bppp/p2p1n2/np2p3/4P3/1BP2N2/PP1P1PPP/RNBQR1K1 w kq - b3c2", null, null],
  ["r1bqk2r/2p1bppp/p2p1n2/np2p3/4P3/2P2N2/PPBP1PPP/RNBQR1K1 b kq - c7c5", null, null],
  ["r1bqk2r/2p2ppp/p4n2/1pbPp1N1/3n4/1B6/PPPP1PPP/RNBQR1K1 w kq - e1e5", null, null],
  ["r1bqk2r/2p2ppp/p4n2/1pbPR1N1/3n4/1B6/PPPP1PPP/RNBQ2K1 b kq - e8f8", "C78", "Ruy Lopez: Rabinovich Variation"],
  ["r1bqk2r/2ppbppp/p1n2n2/1p2p3/3PP3/1B3N2/PPP1QPPP/RNB1K2R b KQkq - d7d6", null, null],
  [
    "r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQ1RK1 w kq - a2a4",
    "C78",
    "Ruy Lopez: Morphy Defense, Wing Attack",
  ],
  [
    "r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1 b kq - c8b7",
    "C88",
    "Ruy Lopez: Closed, Trajkovic Counterattack",
  ],
  ["r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1 b kq - d7d6", null, null],
  ["r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQR1K1 b kq - e8g8", "C88", "Ruy Lopez: Closed"],
  ["r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPPQPPP/RNB1K2R w KQkq - d2d4", null, null],
  [
    "r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPPQPPP/RNB2RK1 b kq - d7d6",
    "C86",
    "Ruy Lopez: Closed, Worrall Attack, Delayed Castling Line",
  ],
  [
    "r1bqk2r/2ppbppp/p1n2n2/1p2p3/4P3/1B3N2/PPPPQPPP/RNB2RK1 b kq - e8g8",
    "C86",
    "Ruy Lopez: Closed, Worrall Attack, Castling Line",
  ],
  ["r1bqk2r/2ppbppp/p1n2n2/1p2p3/B3P3/5N2/PPPP1PPP/RNBQR1K1 w kq - a4b3", "C88", "Ruy Lopez: Closed"],
  ["r1bqk2r/2ppbppp/p1n2n2/1p2p3/B3P3/5N2/PPPPQPPP/RNB2RK1 w kq - a4b3", null, null],
  ["r1bqk2r/2ppbppp/p1n5/1p2p3/3Pn3/1B3N2/PPP2PPP/RNBQR1K1 b kq - d7d5", null, null],
  ["r1bqk2r/2ppbppp/p1n5/1p2p3/B2Pn3/5N2/PPP2PPP/RNBQR1K1 w kq - a4b3", null, null],
  ["r1bqk2r/4bppp/p2p1n2/npp1p3/3PP3/2P2N2/PPB2PPP/RNBQR1K1 b kq - d8c7", null, null],
  ["r1bqk2r/4bppp/p2p1n2/npp1p3/4P3/2P2N2/PPBP1PPP/RNBQR1K1 w kq - d2d4", null, null],
  [
    "r1bqk2r/5ppp/p1n1pn2/1pb5/2B1P3/5N2/PP2QPPP/RNB2RK1 w kq - e4e5",
    "D26",
    "Queen's Gambit Accepted: Classical, Furman Variation",
  ],
  ["r1bqk2r/p1p2ppp/2p2n2/3p4/1b2P3/2NB4/PPP2PPP/R1BQK2R w KQkq - e4d5", null, null],
  ["r1bqk2r/p1p2ppp/2p2n2/3P4/1b6/2NB4/PPP2PPP/R1BQK2R b KQkq - e8g8", null, null],
  ["r1bqk2r/p1pp1ppp/2p2n2/8/1b2P3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1d3", null, null],
  ["r1bqk2r/p1pp1ppp/2p2n2/8/1b2P3/2NB4/PPP2PPP/R1BQK2R b KQkq - d7d5", null, null],
  ["r1bqk2r/p1ppbppp/2pn4/4p3/3P4/5N2/PPP1QPPP/RNB2RK1 w kq - d4e5", null, null],
  ["r1bqk2r/p1ppbppp/2pn4/4P3/8/5N2/PPP1QPPP/RNB2RK1 b kq - d6b7", null, null],
  [
    "r1bqk2r/p1ppbppp/2pn4/4P3/8/5N2/PPP1QPPP/RNB2RK1 b kq - d6f5",
    "C67",
    "Ruy Lopez: Berlin Defense, Cordel Variation",
  ],
  ["r1bqk2r/p2n1ppp/2pbpn2/1p6/3P4/2NBPN2/PP3PPP/R1BQ1RK1 b kq - c8b7", null, null],
  ["r1bqk2r/p2n1ppp/2pbpn2/1p6/3P4/2NBPN2/PP3PPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/p2n1ppp/2pbpn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/p4pp1/2pb1n1p/n3N3/3Pp3/8/PPP1BPPP/RNBQK2R b KQkq d3 d8c7", null, null],
  ["r1bqk2r/p4pp1/2pb1n1p/n3N3/4p3/8/PPPPBPPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r1bqk2r/pnppbppp/2p5/4P3/8/2N2N2/PPP1QPPP/R1B2RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pnppbppp/2p5/4P3/8/5N2/PPP1QPPP/RNB2RK1 w kq - b1c3", null, null],
  [
    "r1bqk2r/pnppbppp/2p5/4P3/8/5N2/PPP1QPPP/RNB2RK1 w kq - b2b3",
    "C67",
    "Ruy Lopez: Berlin Defense, Pillsbury Variation",
  ],
  [
    "r1bqk2r/pnppbppp/2p5/4P3/8/5N2/PPP1QPPP/RNB2RK1 w kq - c2c4",
    "C67",
    "Ruy Lopez: Berlin Defense, Zukertort Variation",
  ],
  ["r1bqk2r/pnppbppp/2p5/4P3/8/5N2/PPP1QPPP/RNB2RK1 w kq - f3d4", "C67", "Ruy Lopez: Berlin Defense, Winawer Attack"],
  [
    "r1bqk2r/pp1n1pp1/2pbp2p/8/3Pn3/3B1N2/PPP1QPPP/R1B1K2R w KQkq - e2e4",
    "B17",
    "Caro-Kann Defense: Karpov Variation, Modern Main Line",
  ],
  ["r1bqk2r/pp1n1pp1/2pbpn1p/6N1/3P4/3B1N2/PPP1QPPP/R1B1K2R w KQkq - g5e4", null, null],
  ["r1bqk2r/pp1n1pp1/2pbpn1p/8/3PN3/3B1N2/PPP1QPPP/R1B1K2R b KQkq - f6e4", null, null],
  ["r1bqk2r/pp1n1ppp/2n1p3/2bpP3/5P2/P1N5/1PP3PP/R1BQKBNR w KQkq - d1g4", null, null],
  ["r1bqk2r/pp1n1ppp/2n1p3/2bpP3/5PQ1/P1N5/1PP3PP/R1B1KBNR b KQkq - e8g8", null, null],
  [
    "r1bqk2r/pp1n1ppp/2pb4/4p3/2PPQ3/5N2/PP3PPP/R1B1KB1R w KQkq - d4e5",
    "D45",
    "Semi-Slav Defense: Stoltz Variation, Center Variation, Mikhalchishin Line",
  ],
  ["r1bqk2r/pp1n1ppp/2pbp3/8/2PPn3/5N2/PPQ2PPP/R1B1KB1R w KQkq - c2e4", null, null],
  ["r1bqk2r/pp1n1ppp/2pbp3/8/2PPQ3/5N2/PP3PPP/R1B1KB1R b KQkq - e6e5", null, null],
  ["r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/P1Q2PPP/R1B1KB1R b KQkq - e8g8", null, null],
  ["r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/P4PPP/R1BQKB1R w KQkq - c1b2", null, null],
  [
    "r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/PB3PPP/R2QKB1R b KQkq - e8g8",
    "D45",
    "Semi-Slav Defense: Normal Variation",
  ],
  [
    "r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP4/2N1PN2/PPQ2PPP/R1B1KB1R w KQkq - b2b3",
    "D45",
    "Semi-Slav Defense: Stoltz Variation",
  ],
  [
    "r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP4/2N1PN2/PPQ2PPP/R1B1KB1R w KQkq - e3e4",
    "D45",
    "Semi-Slav Defense: Stoltz Variation, Center Variation",
  ],
  [
    "r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP4/2N1PN2/PPQ2PPP/R1B1KB1R w KQkq - g2g4",
    "D45",
    "Semi-Slav Defense: Stoltz Variation, Shabalov Attack",
  ],
  [
    "r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R w KQkq - d1c2",
    "D46",
    "Semi-Slav Defense: Chigorin Defense",
  ],
  ["r1bqk2r/pp1n1ppp/2pbpn2/3p4/2PPP3/2N2N2/PPQ2PPP/R1B1KB1R b KQkq - d5e4", null, null],
  ["r1bqk2r/pp1n1ppp/2pbpn2/6N1/3P4/3B1N2/PPP1QPPP/R1B1K2R b KQkq - h7h6", null, null],
  ["r1bqk2r/pp1n1ppp/2pbpn2/6N1/3P4/3B1N2/PPP2PPP/R1BQK2R w KQkq - d1e2", null, null],
  ["r1bqk2r/pp1n1ppp/2pbpn2/8/2PPN3/5N2/PPQ2PPP/R1B1KB1R b KQkq - f6e4", null, null],
  ["r1bqk2r/pp1n1ppp/2pbpn2/8/2PPp3/2N2N2/PPQ2PPP/R1B1KB1R w KQkq - c3e4", null, null],
  [
    "r1bqk2r/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/2RQKB1R b Kkq - e8g8",
    "D63",
    "Queen's Gambit Declined: Orthodox Defense, Main Line",
  ],
  ["r1bqk2r/pp1nbppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQkq - a1c1", null, null],
  ["r1bqk2r/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQNPP1P/R1B1KB1R w KQkq - f1g2", null, null],
  ["r1bqk2r/pp1nbppp/2p1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B1K2R b KQkq - e8g8", null, null],
  [
    "r1bqk2r/pp1nbppp/2p2n2/3p2B1/3P4/2N1P3/PPQ2PPP/R3KBNR w KQkq - f1d3",
    "D36",
    "Queen's Gambit Declined: Exchange Variation, Reshevsky Variation",
  ],
  ["r1bqk2r/pp1p1ppp/2n1p3/2n5/1bP5/1QN2N2/PP1BPPPP/R3KB1R w KQkq - b3c2", null, null],
  ["r1bqk2r/pp1p1ppp/2n1p3/2n5/1bP5/2N2N2/PPQBPPPP/R3KB1R b KQkq - f7f5", null, null],
  [
    "r1bqk2r/pp1p1ppp/2n1p3/2P5/1bP1n3/1QN2N2/PP1BPPPP/R3KB1R b KQkq - e4c5",
    "E23",
    "Nimzo-Indian Defense: Spielmann Variation, Stahlberg Variation",
  ],
  [
    "r1bqk2r/pp1p1ppp/2n1p3/2P5/1bP1n3/1QN2N2/PP1BPPPP/R3KB1R b KQkq - e4d2",
    "E23",
    "Nimzo-Indian Defense: Spielmann Variation, Carlsbad Variation",
  ],
  ["r1bqk2r/pp1p1ppp/2n1p3/2P5/1bP1n3/1QN2N2/PP2PPPP/R1B1KB1R w KQkq - c1d2", null, null],
  [
    "r1bqk2r/pp1p1ppp/2n1pn2/1N6/1b2P3/2N5/PPP2PPP/R1BQKB1R w KQkq - b5d6",
    "B45",
    "Sicilian Defense: Four Knights Variation, American Attack",
  ],
  ["r1bqk2r/pp1p1ppp/2n1pn2/2P5/1bP5/1QN2N2/PP2PPPP/R1B1KB1R b KQkq - f6e4", null, null],
  ["r1bqk2r/pp1p1ppp/2n1pn2/2P5/1bP5/1QN5/PP2PPPP/R1B1KBNR w KQkq - g1f3", null, null],
  ["r1bqk2r/pp1p1ppp/2n1pn2/2p5/1bPP4/2NBP3/PP3PPP/R1BQK1NR w KQkq - a2a3", null, null],
  ["r1bqk2r/pp1p1ppp/2n1pn2/2p5/1bPP4/2NBP3/PP3PPP/R1BQK1NR w KQkq - g1f3", null, null],
  ["r1bqk2r/pp1p1ppp/2n1pn2/2p5/1bPP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - b4c3", null, null],
  ["r1bqk2r/pp1p1ppp/2n1pn2/2p5/1bPP4/P1NBP3/1P3PPP/R1BQK1NR b KQkq - b4c3", null, null],
  ["r1bqk2r/pp1p1ppp/2n1pn2/2p5/2PP4/2bBPN2/PP3PPP/R1BQK2R w KQkq - b2c3", null, null],
  [
    "r1bqk2r/pp1p1ppp/2n1pn2/2p5/2PP4/2PBPN2/P4PPP/R1BQK2R b KQkq - d7d6",
    "E41",
    "Nimzo-Indian Defense: Rubinstein System, Hübner Variation",
  ],
  ["r1bqk2r/pp1p1ppp/2n1pn2/2p5/2PP4/P1bBP3/1P3PPP/R1BQK1NR w KQkq - b2c3", null, null],
  [
    "r1bqk2r/pp1p1ppp/2n1pn2/2p5/2PP4/P1PBP3/5PPP/R1BQK1NR b KQkq - e8g8",
    "E29",
    "Nimzo-Indian Defense: Sämisch Variation",
  ],
  [
    "r1bqk2r/pp1p2pp/2n1p3/2n2p2/1bP5/2N2N2/PPQBPPPP/R3KB1R w KQkq - g2g3",
    "E23",
    "Nimzo-Indian Defense: Spielmann Variation, Stahlberg Variation",
  ],
  [
    "r1bqk2r/pp1pnpbp/2n3p1/2p1p3/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 w kq - a2a3",
    "A37",
    "English Opening: Symmetrical Variation, Botvinnik System Reversed, with Nf3",
  ],
  [
    "r1bqk2r/pp1pnpbp/2n3p1/2p1p3/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 w kq - d2d3",
    "A37",
    "English Opening: Symmetrical Variation, Botvinnik System Reversed, with Nf3",
  ],
  [
    "r1bqk2r/pp1pnpbp/2n3p1/2p1p3/2P5/2NP1NP1/PP2PPBP/R1BQ1RK1 b kq - d7d6",
    "A37",
    "English Opening: Symmetrical Variation, Botvinnik System Reversed, with Nf3",
  ],
  [
    "r1bqk2r/pp1pppbp/2n2np1/1Bp5/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 w kq - d1a4",
    "B31",
    "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Fianchetto Variation, Totsky Attack",
  ],
  [
    "r1bqk2r/pp1pppbp/2n2np1/1Bp5/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 w kq - d2d4",
    "B31",
    "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Fianchetto Variation, Lutikov Gambit",
  ],
  ["r1bqk2r/pp1pppbp/2n2np1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pp1pppbp/2n2np1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1bqk2r/pp1pppbp/2n2np1/8/2BNP3/2N1B3/PPP2PPP/R2QK2R b KQkq - d7d6",
    "B35",
    "Sicilian Defense: Dragon Variation, Modern Bc4 Variation",
  ],
  [
    "r1bqk2r/pp1pppbp/2n2np1/8/2PNP3/2N1B3/PP3PPP/R2QKB1R b KQkq - f6g4",
    "B39",
    "Sicilian Defense: Accelerated Dragon, Maróczy Bind, Breyer Variation",
  ],
  ["r1bqk2r/pp1pppbp/2n2np1/8/2PNP3/4B3/PP3PPP/RN1QKB1R w KQkq - b1c3", null, null],
  ["r1bqk2r/pp1pppbp/2n2np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R b KQkq - e8g8", null, null],
  [
    "r1bqk2r/pp1pppbp/2n2np1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - f1c4",
    "B35",
    "Sicilian Defense: Accelerated Dragon, Modern Bc4 Variation",
  ],
  ["r1bqk2r/pp1pppbp/2n2np1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - f1e2", null, null],
  ["r1bqk2r/pp1pppbp/2n2np1/8/3NP3/4B3/PPP1BPPP/RN1QK2R w KQkq - b1c3", null, null],
  ["r1bqk2r/pp2bppp/2n1pn2/2pp4/3P4/1P1BPN2/P1P2PPP/RNBQ1RK1 w kq - c1b2", null, null],
  [
    "r1bqk2r/pp2bppp/2n1pn2/2pp4/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1 b kq - e8g8",
    "D05",
    "Rubinstein Opening: Classical Defense",
  ],
  ["r1bqk2r/pp2bppp/2n1pn2/2pp4/4P3/3P1NP1/PPPN1PBP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pp2bppp/2n1pn2/2pp4/4P3/3P1NP1/PPPN1PBP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1bqk2r/pp2bppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQ1RK1 b kq - e8g8",
    "D34",
    "Tarrasch Defense: Classical Variation",
  ],
  ["r1bqk2r/pp2bppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/pp2bppp/2n2n2/2pp4/3P4/5NP1/PP2PPBP/RNBQ1RK1 w kq - b1c3", null, null],
  ["r1bqk2r/pp2bppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/2KR1B1R b kq - c6d4", null, null],
  ["r1bqk2r/pp2bppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/2KR1B1R b kq - e8g8", null, null],
  ["r1bqk2r/pp2bppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R w KQkq - e1c1", null, null],
  ["r1bqk2r/pp2bppp/2nppn2/8/2BNP3/2N1B3/PPP2PPP/R2QK2R w KQkq - c4b3", null, null],
  ["r1bqk2r/pp2bppp/2nppn2/8/2BNP3/2N1B3/PPP2PPP/R2QK2R w KQkq - d1e2", "B89", "Sicilian Defense: Velimirovic Attack"],
  ["r1bqk2r/pp2bppp/2nppn2/8/3NP3/1BN1B3/PPP2PPP/R2QK2R b KQkq - e8g8", null, null],
  ["r1bqk2r/pp2bppp/2nppn2/8/3NP3/1BN5/PPP2PPP/R1BQK2R w KQkq - c1e3", null, null],
  [
    "r1bqk2r/pp2bppp/2nppn2/8/3NPP2/2N1B3/PPP3PP/R2QKB1R w KQkq - d1f3",
    "B82",
    "Sicilian Defense: Scheveningen Variation, Tal Variation",
  ],
  ["r1bqk2r/pp2bppp/3ppn2/6B1/3nP3/2N5/PPPQ1PPP/2KR1B1R w kq - d2d4", null, null],
  ["r1bqk2r/pp2bppp/3ppn2/6B1/3QP3/2N5/PPP2PPP/2KR1B1R b kq - a7a6", null, null],
  [
    "r1bqk2r/pp2nppp/2n1p3/2ppP3/3P4/P1PB4/2P2PPP/R1BQK1NR w KQkq - g1f3",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  ["r1bqk2r/pp2nppp/2n1p3/2ppP3/P2P4/2P2N2/2P2PPP/R1BQKB1R b KQkq - d8a5", null, null],
  [
    "r1bqk2r/pp2nppp/2n1p3/2ppP3/P2P4/2P5/2P2PPP/R1BQKBNR w KQkq - g1f3",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  ["r1bqk2r/pp2ppbp/2n3p1/2p5/2BPP3/2P1B3/P3NPPP/R2QK2R b KQkq - e8g8", null, null],
  ["r1bqk2r/pp2ppbp/2n3p1/2p5/2BPP3/2P5/P3NPPP/R1BQK2R w KQkq - c1e3", null, null],
  [
    "r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R w KQkq - d1d2",
    "B72",
    "Sicilian Defense: Dragon Variation, Classical Variation, Amsterdam Variation",
  ],
  [
    "r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R w KQkq - d4b3",
    "B72",
    "Sicilian Defense: Dragon Variation, Classical Variation",
  ],
  ["r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1B3/PPPQBPPP/R3K2R b KQkq - e8g8", null, null],
  ["r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1BP2/PPP3PP/R2QKB1R w KQkq - d1d2", null, null],
  [
    "r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N1BP2/PPPQ2PP/R3KB1R b KQkq - e8g8",
    "B76",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack",
  ],
  [
    "r1bqk2r/pp2ppbp/2np1np1/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 w kq - c1e3",
    "B73",
    "Sicilian Defense: Dragon Variation, Classical Variation",
  ],
  ["r1bqk2r/pp2ppbp/2np1np1/8/3NPP2/2N1B3/PPP1B1PP/R2QK2R b KQkq - e8g8", null, null],
  ["r1bqk2r/pp2ppbp/2np1np1/8/3NPP2/2N1B3/PPP3PP/R2QKB1R w KQkq - f1e2", null, null],
  [
    "r1bqk2r/pp3ppp/2nbpn2/2pp4/2PP4/2NBPN2/PP3PPP/R1BQ1RK1 b kq - e8g8",
    "D40",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Symmetrical Variation",
  ],
  ["r1bqk2r/pp3ppp/2nbpn2/2pp4/2PP4/2NBPN2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/pp3ppp/2nbpn2/2pp4/3P4/1P1BPN2/P1P2PPP/RNBQ1RK1 w kq - c1b2", null, null],
  [
    "r1bqk2r/pp3ppp/2nbpn2/2pp4/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1 b kq - e8g8",
    "D05",
    "Rubinstein Opening: Bogoljubow Defense",
  ],
  [
    "r1bqk2r/pp3ppp/2nppn2/2p5/2PP4/2PBPN2/P4PPP/R1BQ1RK1 b kq - e8g8",
    "E41",
    "Nimzo-Indian Defense: Rubinstein System, Hübner Variation",
  ],
  ["r1bqk2r/pp3ppp/2nppn2/2p5/2PP4/2PBPN2/P4PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/ppp1bppp/2n1pn2/6B1/3P4/2NB1N2/PPP3PP/R2Q1RK1 b kq - c6d4", null, null],
  ["r1bqk2r/ppp1bppp/2n1pn2/6B1/3P4/2NB1N2/PPP3PP/R2QK2R w KQkq - e1g1", null, null],
  [
    "r1bqk2r/ppp1bppp/2n5/3np3/8/3P1NP1/PP2PPBP/RNBQ1RK1 b kq - e8g8",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line",
  ],
  ["r1bqk2r/ppp1bppp/2n5/3np3/8/3P1NP1/PP2PPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/ppp1bppp/2n5/3p4/2PPn3/3B1N2/PP3PPP/RNBQ1RK1 b kq - c6b4", null, null],
  [
    "r1bqk2r/ppp1bppp/2n5/3p4/3Pn3/3B1N2/PPP2PPP/RNBQ1RK1 w kq - c2c4",
    "C42",
    "Petrov's Defense: Classical Attack, Jaenisch Variation",
  ],
  [
    "r1bqk2r/ppp1bppp/2n5/3p4/3Pn3/3B1N2/PPP2PPP/RNBQ1RK1 w kq - f1e1",
    "C42",
    "Petrov's Defense: Classical Attack, Chigorin Variation",
  ],
  ["r1bqk2r/ppp1bppp/2n5/3p4/3Pn3/3B1N2/PPP2PPP/RNBQR1K1 b kq - c8g4", null, null],
  [
    "r1bqk2r/ppp1bppp/2np1n2/4p3/2P5/2NP1NP1/PP2PPBP/R1BQK2R b KQkq - e8g8",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line, with .. d6, Be7",
  ],
  ["r1bqk2r/ppp1bppp/2np1n2/4p3/2P5/2NP2P1/PP2PPBP/R1BQK1NR w KQkq - g1f3", null, null],
  [
    "r1bqk2r/ppp1bppp/4pn2/6B1/3n4/2NB1N2/PPP3PP/R2Q1RK1 w kq - g1h1",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Euwe Defense, Zilbermints Gambit",
  ],
  [
    "r1bqk2r/ppp1bppp/8/3p4/1nPPn3/3B1N2/PP3PPP/RNBQ1RK1 w kq - c4d5",
    "C42",
    "Petrov's Defense: Classical Attack, Chigorin Variation, Browne Attack",
  ],
  [
    "r1bqk2r/ppp1bppp/8/3p4/1nPPn3/3B1N2/PP3PPP/RNBQ1RK1 w kq - d3e2",
    "C42",
    "Petrov's Defense: Classical Attack, Chigorin Variation, Main Line",
  ],
  ["r1bqk2r/ppp1nppp/3p1b2/3P2B1/2B1R3/5N2/PP3PPP/R2Q2K1 b kq - f6g5", null, null],
  ["r1bqk2r/ppp1nppp/3p1b2/3P4/2B1R3/5N2/PP3PPP/R1BQ2K1 w kq - c1g5", null, null],
  [
    "r1bqk2r/ppp1nppp/3p1b2/3P4/2B1R3/5N2/PP3PPP/R1BQ2K1 w kq - g2g4",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Moeller-Bayonet Attack",
  ],
  ["r1bqk2r/ppp1nppp/3p4/3P2b1/2B1R3/5N2/PP3PPP/R2Q2K1 w kq - f3g5", null, null],
  ["r1bqk2r/ppp1nppp/3p4/3P2N1/2B1R3/8/PP3PPP/R2Q2K1 b kq - e8g8", null, null],
  ["r1bqk2r/ppp2pBp/1b6/nP2p3/2BPP3/8/P1P2PPP/RN1QK2R b KQkq - h8g8", null, null],
  [
    "r1bqk2r/ppp2pp1/2np1n1p/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 w kq - b1d2",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/ppp2pp1/2np1n1p/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 w kq - f1e1",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/ppp2pp1/5n1p/2bP4/2P1p3/5N2/PPP1QPPP/RNB1K2R w KQkq - f3d2",
    "C58",
    "Italian Game: Two Knights Defense, Polerio Defense, Yankovich Variation",
  ],
  ["r1bqk2r/ppp2ppp/1b1p3B/nP2N3/2BPP3/8/P1P2PPP/RN1QK2R b KQkq - d6e5", null, null],
  ["r1bqk2r/ppp2ppp/1b1p3n/nP2N3/2BPP3/8/P1P2PPP/RNBQK2R w KQkq - c1h6", null, null],
  ["r1bqk2r/ppp2ppp/1b5B/nP2p3/2BPP3/8/P1P2PPP/RN1QK2R w KQkq - h6g7", null, null],
  [
    "r1bqk2r/ppp2ppp/2n1p3/3p4/2PPn3/P3P3/1PQ2PPP/R1B1KBNR b KQkq - e6e5",
    "E37",
    "Nimzo-Indian Defense: Classical Variation, Noa Variation, San Remo Variation",
  ],
  ["r1bqk2r/ppp2ppp/2n1p3/3p4/2PPn3/P7/1PQ1PPPP/R1B1KBNR w KQkq - e2e3", null, null],
  ["r1bqk2r/ppp2ppp/2n2n2/1BbpP3/3p4/2P2N2/PP3PPP/RNBQK2R b KQkq - f6e4", null, null],
  ["r1bqk2r/ppp2ppp/2n2n2/2bpP3/2Bp4/2P2N2/PP3PPP/RNBQK2R w KQkq d6 c4b5", null, null],
  ["r1bqk2r/ppp2ppp/2n2n2/2bpP3/2Bp4/5N2/PPP2PPP/RNBQ1RK1 w kq d6 e5f6", null, null],
  [
    "r1bqk2r/ppp2ppp/2n2n2/2bpp3/4P3/2N3P1/PPPPNPBP/R1BQK2R w KQkq - e4d5",
    "C26",
    "Vienna Game: Paulsen Variation, Pollock Gambit",
  ],
  ["r1bqk2r/ppp2ppp/2n2P2/2b5/2pp4/5N2/PPP2PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r1bqk2r/ppp2ppp/2n2P2/2b5/2pp4/5N2/PPP2PPP/RNBQR1K1 b kq - c8e6", null, null],
  ["r1bqk2r/ppp2ppp/2n2P2/2bp4/2Bp4/5N2/PPP2PPP/RNBQ1RK1 b kq - d5c4", null, null],
  [
    "r1bqk2r/ppp2ppp/2N5/1B1pP3/4n3/8/PPP2bPP/RNBQ1K1R b kq - d8h4",
    "C56",
    "Italian Game: Two Knights Defense, Keidansky Variation",
  ],
  ["r1bqk2r/ppp2ppp/2N5/1B1pP3/4n3/8/PPP2bPP/RNBQK2R w KQkq - e1f1", null, null],
  ["r1bqk2r/ppp2ppp/2n5/1BbpP3/3Nn3/8/PPP2PPP/RNBQK2R w KQkq - d4c6", null, null],
  ["r1bqk2r/ppp2ppp/2n5/1BbpP3/3pn3/2P2N2/PP3PPP/RNBQK2R w KQkq - c3d4", null, null],
  [
    "r1bqk2r/ppp2ppp/2n5/1BbpP3/3Pn3/5N2/PP3PPP/RNBQK2R b KQkq - c5b4",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Anderssen Variation",
  ],
  ["r1bqk2r/ppp2ppp/2N5/1BbpP3/4n3/8/PPP2PPP/RNBQK2R b KQkq - c5f2", null, null],
  [
    "r1bqk2r/ppp2ppp/2n5/3p4/2BPn3/2P2N2/P4PPP/R1BQ1RK1 w kq - c1a3",
    "C54",
    "Italian Game: Giuoco Piano, Steinitz Variation",
  ],
  ["r1bqk2r/ppp2ppp/2nb1n2/3pp3/8/P2P2P1/1PPNPPBP/R1BQK1NR w KQkq - e2e3", null, null],
  ["r1bqk2r/ppp2ppp/2nb1n2/3pp3/8/P2PP1P1/1PPN1PBP/R1BQK1NR b KQkq - e8g8", null, null],
  ["r1bqk2r/ppp2ppp/2nb1n2/3pp3/8/PPPPP3/5PPP/RNBQKBNR w KQkq - f2f3", null, null],
  ["r1bqk2r/ppp2ppp/2nb1n2/3pp3/8/PPPPPP2/6PP/RNBQKBNR b KQkq - e8g8", null, null],
  ["r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2N2N2/PPPP1PPP/R1BQ1RK1 w kq - d2d3", "C50", "Italian Game: Giuoco Pianissimo"],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R w KQkq - c1g5",
    "C50",
    "Italian Game: Giuoco Pianissimo, Canal Variation",
  ],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP1N1PPP/R1BQK2R b KQkq - a7a6",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo, with a6",
  ],
  ["r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP1N1PPP/R1BQK2R b KQkq - e8g8", null, null],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 b kq - a7a6",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 b kq - e8g8",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQ1RK1 b kq - h7h6",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo, with h6",
  ],
  ["r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R w KQkq - b1d2", null, null],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R w KQkq - b2b4",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo, Albin Variation",
  ],
  ["r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 w kq - c2c3", null, null],
  ["r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1PP2/2NP1N2/PPP3PP/R1BQK2R b KQkq - c8g4", null, null],
  ["r1bqk2r/ppp2ppp/2np1n2/2b1p3/2B1PP2/2NP4/PPP3PP/R1BQK1NR w KQkq - g1f3", null, null],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2P5/2NP1NP1/PP2PP1P/R1BQKB1R w KQkq - f1g2",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line, with .. d6",
  ],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2P5/2NP1NP1/PP2PPBP/R1BQK2R b KQkq - a7a6",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line, with .. d6, a6",
  ],
  ["r1bqk2r/ppp2ppp/2np1n2/2b1p3/2P5/2NP1NP1/PP2PPBP/R1BQK2R b KQkq - e8g8", null, null],
  [
    "r1bqk2r/ppp2ppp/2np1n2/2b1p3/2P5/2NP1NP1/PP2PPBP/R1BQK2R b KQkq - h7h6",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line, with .. d6, h6",
  ],
  ["r1bqk2r/ppp2ppp/3p1n2/4p1B1/2BnP3/8/PPP2PPP/RN1Q1RK1 w kq - f2f4", null, null],
  ["r1bqk2r/ppp2ppp/3p1n2/4p1B1/2BnPP2/8/PPP3PP/RN1Q1RK1 b kq - d8e7", null, null],
  [
    "r1bqk2r/pppn1pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b kq - e8g8",
    "E94",
    "King's Indian Defense: Orthodox Variation, Positional Defense",
  ],
  ["r1bqk2r/pppn1pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1bqk2r/pppn1ppp/4pn2/3p2B1/1bPP4/2N1PN2/PP3PPP/R2QKB1R b KQkq - c7c5",
    "D38",
    "Queen's Gambit Declined: Westphalian Variation",
  ],
  ["r1bqk2r/pppn1ppp/4pn2/3p2B1/1bPP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - e2e3", null, null],
  ["r1bqk2r/pppnbppp/3p1n2/4p1N1/2BPP3/2N5/PPP2PPP/R1BQK2R b KQkq - e8g8", null, null],
  ["r1bqk2r/pppnbppp/3p1n2/4P3/2B1P3/2N2N2/PPP2PPP/R1BQK2R b KQkq - d6e5", null, null],
  ["r1bqk2r/pppnbppp/3p1n2/4p3/2BPP3/2N2N2/PPP2PPP/R1BQ1RK1 b kq - e8g8", null, null],
  [
    "r1bqk2r/pppnbppp/3p1n2/4p3/2BPP3/2N2N2/PPP2PPP/R1BQ1RK1 b kq - h7h6",
    "C41",
    "Philidor Defense: Lion Variation, Lion's Claw, with Bc4 and h6",
  ],
  [
    "r1bqk2r/pppnbppp/3p1n2/4p3/2BPP3/2N2N2/PPP2PPP/R1BQK2R w KQkq - c4f7",
    "C41",
    "Philidor Defense: Lion Variation, Bishop Sacrifice",
  ],
  ["r1bqk2r/pppnbppp/3p1n2/4p3/2BPP3/2N2N2/PPP2PPP/R1BQK2R w KQkq - d4e5", null, null],
  ["r1bqk2r/pppnbppp/3p1n2/4p3/2BPP3/2N2N2/PPP2PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/pppnbppp/3p1n2/4p3/2BPP3/2N2N2/PPP2PPP/R1BQK2R w KQkq - f3g5", null, null],
  [
    "r1bqk2r/pppnbppp/3p1n2/4p3/3PP3/2N2N2/PPP1BPPP/R1BQ1RK1 b kq - c7c6",
    "C41",
    "Philidor Defense: Lion Variation, Lion's Claw, with Be2 and c6",
  ],
  ["r1bqk2r/pppnbppp/3p1n2/4p3/3PP3/2N2N2/PPP1BPPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/pppnbppp/4pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1Q1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pppnbppp/4pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1QK2R w KQkq - e1g1", null, null],
  [
    "r1bqk2r/pppnbppp/5n2/4p3/2B1P3/2N2N2/PPP2PPP/R1BQK2R w KQkq - c4f7",
    "C41",
    "Philidor Defense: Lion Variation, Delayed Bishop Sacrifice",
  ],
  ["r1bqk2r/pppp1Bpp/2n2n2/2b1p1N1/4P3/8/PPPP1PPP/RNBQK2R b KQkq - e8e7", null, null],
  ["r1bqk2r/pppp1Bpp/2n5/2b5/3pP3/8/PPP2PPP/RNBQK2R b KQkq - e8f7", null, null],
  ["r1bqk2r/pppp1Bpp/8/8/1n1Pn3/5N2/PP3PPP/RN1QK2R b KQkq - e8f7", null, null],
  ["r1bqk2r/pppp1Npp/2n2n2/2b1p3/2B1P3/8/PPPP1PPP/RNBQK2R b KQkq - c5f2", null, null],
  ["r1bqk2r/pppp1Npp/2n2n2/4p3/2B1P3/8/PPPP1bPP/RNBQK2R w KQkq - e1f2", null, null],
  ["r1bqk2r/pppp1Npp/2n2n2/4p3/2B1P3/8/PPPP1KPP/RNBQ3R b kq - f6e4", null, null],
  ["r1bqk2r/pppp1Npp/2n4n/2b5/2BpP3/8/PPP2PPP/RNBQK2R b KQkq - h6f7", null, null],
  ["r1bqk2r/pppp1npp/2n5/2b5/2BpP3/8/PPP2PPP/RNBQK2R w KQkq - c4f7", null, null],
  [
    "r1bqk2r/pppp1Npp/2n5/4p3/2B1n3/8/PPPP1KPP/RNBQ3R w kq - f2e3",
    "C57",
    "Italian Game: Two Knights Defense, Traxler Counterattack, King March Line",
  ],
  [
    "r1bqk2r/pppp1p2/5n1p/4p1p1/2BnP2B/8/PPP2PPP/RN1Q1RK1 w kq - f2f4",
    "C54",
    "Italian Game: Giuoco Piano, Rosentreter Variation",
  ],
  [
    "r1bqk2r/pppp1pp1/2n2n1p/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 w kq - c2c3",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  ["r1bqk2r/pppp1pp1/2n2n1p/6B1/1bPN4/2N5/PP2PPPP/R2QKB1R w KQkq - g5h4", null, null],
  ["r1bqk2r/pppp1pp1/2n2n1p/8/1bPN3B/2N5/PP2PPPP/R2QKB1R b KQkq - b4c3", null, null],
  ["r1bqk2r/pppp1pp1/2n2n1p/8/2PN3B/2b5/PP2PPPP/R2QKB1R w KQkq - b2c3", null, null],
  [
    "r1bqk2r/pppp1pp1/2n2n1p/8/2PN3B/2P5/P3PPPP/R2QKB1R b KQkq - c6e5",
    "A28",
    "English Opening: King's English Variation, Four Knights Variation",
  ],
  ["r1bqk2r/pppp1pp1/5n1p/4p1B1/2BnP3/8/PPP2PPP/RN1Q1RK1 w kq - g5h4", null, null],
  ["r1bqk2r/pppp1pp1/5n1p/4p3/2BnP2B/8/PPP2PPP/RN1Q1RK1 b kq - g7g5", null, null],
  ["r1bqk2r/pppp1ppp/1b5n/nP2N3/2B1P3/8/P1PP1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r1bqk2r/pppp1ppp/1b5n/nP2N3/2BPP3/8/P1P2PPP/RNBQK2R b KQkq - d7d6", null, null],
  [
    "r1bqk2r/pppp1ppp/2n1pn2/8/1bPP4/2N2N2/PPQ1PPPP/R1B1KB1R b KQkq - d7d6",
    "E33",
    "Nimzo-Indian Defense: Classical Variation, Milner-Barry Variation",
  ],
  ["r1bqk2r/pppp1ppp/2n1pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR w KQkq - g1f3", null, null],
  ["r1bqk2r/pppp1ppp/2n2b2/3P4/2B1n3/5N2/PP3PPP/R1BQ1RK1 w kq - f1e1", null, null],
  ["r1bqk2r/pppp1ppp/2n2b2/3P4/2B1n3/5N2/PP3PPP/R1BQR1K1 b kq - c6e7", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/1B2p3/1b2P3/2N2N2/PPPP1PPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/1B2p3/1b2P3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/2N2N2/PPPP1PPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 b kq - e8g8", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/3P1N2/PPP2PPP/RNBQK2R w KQkq - c1e3",
    "C65",
    "Ruy Lopez: Berlin Defense, Anti-Berlin Variation, Kaufmann Variation",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/1Bb1p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - c2c3",
    "C65",
    "Ruy Lopez: Classical Variation, Zukertort Gambit",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p1N1/2B1P3/8/PPPP1PPP/RNBQK2R w KQkq - c4f7",
    "C57",
    "Italian Game: Two Knights Defense, Traxler Counterattack, Bishop Sacrifice Line",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p1N1/2B1P3/8/PPPP1PPP/RNBQK2R w KQkq - g5f7",
    "C57",
    "Italian Game: Two Knights Defense, Traxler Counterattack, Knight Sacrifice Line",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2N2N2/PPPP1PPP/R1BQ1RK1 b kq - d7d6", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2NP1N2/PPP2PPP/R1BQK2R b KQkq - d7d6", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR w KQkq - f2f4", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - b2b4", "C53", "Italian Game: Bird's Attack"],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - d2d3",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - d2d4",
    "C54",
    "Italian Game: Classical Variation, Center Attack",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2P5/PP1PQPPP/RNB1K1NR w KQkq - f2f4", "C23", "Bishop's Opening: Lopez Gambit"],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R b KQkq - a7a6",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo, with a6",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R b KQkq - d7d5",
    "C54",
    "Italian Game: Classical Variation, with d5",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/2PP1N2/PP3PPP/RNBQK2R b KQkq - d7d6",
    "C54",
    "Italian Game: Classical Variation, Giuoco Pianissimo",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 b kq - a7a5", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 b kq - d7d6", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQ1RK1 b kq - h7h6", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R w KQkq - b1c3",
    "C50",
    "Italian Game: Giuoco Pianissimo, Italian Four Knights Variation",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - b1c3", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - c2c3",
    "C50",
    "Italian Game: Classical Variation, Albin Gambit",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d2d3", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d2d4", "C50", "Italian Game: Deutz Gambit"],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1P3/5P2/PPPPN1PP/RNBQK2R w KQkq - b2b4", "C24", "Bishop's Opening: Krejcik Gambit"],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2B1PP2/2NP4/PPP3PP/R1BQK1NR b KQkq - d7d6", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1P3/2Bp4/2P2N2/PP3PPP/RNBQK2R b KQkq - d7d5",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Modern Line",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1P3/2Bp4/2P2N2/PP3PPP/RNBQK2R b KQkq - f6e4", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1P3/2Bp4/5N2/PPP2PPP/RNBQ1RK1 b kq - d7d5", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1P3/2Bp4/5N2/PPP2PPP/RNBQ1RK1 b kq - f6g4",
    "C56",
    "Italian Game: Scotch Gambit, Max Lange Attack, Spielmann Defense",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2BPP3/2P2N2/PP3PPP/RNBQK2R b KQkq - e5d4", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2BPP3/5N2/PPP2PPP/RNBQ1RK1 b kq - c5d4", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b1p3/2BPP3/5N2/PPP2PPP/RNBQ1RK1 b kq - e5d4",
    "C56",
    "Italian Game: Scotch Gambit, Max Lange Attack",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2P5/2N2NP1/PP1PPP1P/R1BQKB1R w KQkq - d2d3", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/2P5/2NP1NP1/PP2PP1P/R1BQKB1R b KQkq - d7d6", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/3PP3/2P2N2/PP2QPPP/RNB1KB1R b KQkq - e5d4", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/4P3/2N3P1/PPPP1PBP/R1BQK1NR w KQkq - g1e2", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/4P3/2N3P1/PPPPNPBP/R1BQK2R b KQkq - d7d5", "C25", "Vienna Game: Paulsen Variation"],
  ["r1bqk2r/pppp1ppp/2n2n2/2b1p3/4P3/2P2N2/PP1PQPPP/RNB1KB1R w KQkq - d2d4", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b5/2BpP3/2P2N2/PP3PPP/RNBQK2R w KQkq - b2b4",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Dubov Italian",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b5/2BpP3/2P2N2/PP3PPP/RNBQK2R w KQkq - c3d4",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Traditional Line",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b5/2BpP3/2P2N2/PP3PPP/RNBQK2R w KQkq - e1g1",
    "C56",
    "Italian Game: Scotch Gambit, Walbrodt-Baird Gambit",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b5/2BpP3/2P2N2/PP3PPP/RNBQK2R w KQkq - e4e5",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Modern Line",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b5/2BPP3/5N2/PP3PPP/RNBQK2R b KQkq - c5b4", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b5/2BpP3/5N2/PPP2PPP/RNBQ1RK1 w kq - e4e5",
    "C56",
    "Italian Game: Two Knights Defense, Max Lange Attack",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/2b5/3pP3/2P2N2/PP2QPPP/RNB1KB1R w KQkq - c3d4", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/2b5/3PP3/5N2/PP2QPPP/RNB1KB1R b KQkq - c6d4",
    "C20",
    "King's Pawn Opening: Van Hooydoon Gambit",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/3Pp3/1b2P3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - c6d4",
    "C47",
    "Four Knights Game: Scotch Variation, Oxford Gambit",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/4N3/1b1PP3/2N5/PPP2PPP/R1BQKB1R b KQkq - d8e7",
    "C47",
    "Four Knights Game: Scotch Variation, Krause Gambit, Leonhardt Defense",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/4p3/1b1PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - d4d5", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/4p3/1b1PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f3e5",
    "C47",
    "Four Knights Game: Scotch Variation, Krause Gambit",
  ],
  [
    "r1bqk2r/pppp1ppp/2n2n2/4p3/1bB1P3/2NP4/PPP2PPP/R1BQK1NR w KQkq - g1e2",
    "C28",
    "Bishop's Opening: Vienna Hybrid, Hromádka Variation",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/4p3/1bP5/2N1PN2/PP1P1PPP/R1BQKB1R w KQkq - d1c2", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/4p3/1bP5/2N1PN2/PPQP1PPP/R1B1KB1R b KQkq - b4c3",
    "A28",
    "English Opening: King's English Variation, Four Knights Variation, Quiet Line",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/4p3/1bP5/2N1PN2/PPQP1PPP/R1B1KB1R b KQkq - e8g8", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/4p3/2BbP3/5N2/PPP2PPP/RNBQ1RK1 w kq - f3d4", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/4p3/2BNP3/8/PPP2PPP/RNBQ1RK1 b kq - c6d4", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/6B1/1bPN4/2N5/PP2PPPP/R2QKB1R b KQkq - h7h6", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/6N1/1bB1P3/8/PB3PPP/RN1Q1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/8/1b1NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4c6", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/8/1b2P3/2N1Q3/PPP2PPP/R1B1KBNR w KQkq - c1d2", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/8/1b2P3/2N1Q3/PPPB1PPP/R3KBNR b KQkq - e8g8", null, null],
  ["r1bqk2r/pppp1ppp/2N2n2/8/1b2P3/2N5/PPP2PPP/R1BQKB1R b KQkq - b7c6", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/8/1bB1P3/5N2/PB3PPP/RN1Q1RK1 w kq - f3g5", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/8/1bBPP3/2N2N2/PP3PPP/R1BQK2R b KQkq - f6e4", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/8/1bBPP3/5N2/PP1B1PPP/RN1QK2R b KQkq - f6e4", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/8/1bBPP3/5N2/PP3PPP/RNBQK2R w KQkq - b1c3",
    "C54",
    "Italian Game: Giuoco Piano, Greco's Attack",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/8/1bBPP3/5N2/PP3PPP/RNBQK2R w KQkq - c1d2", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/8/1bBPP3/5N2/PP3PPP/RNBQK2R w KQkq - e1f1",
    "C54",
    "Italian Game: Giuoco Piano, Cracow Variation",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/8/1bPN4/2N5/PP2PPPP/R1BQKB1R w KQkq - c1g5", null, null],
  ["r1bqk2r/pppp1ppp/2n2n2/b3p3/2B1P3/2P2N2/P2P1PPP/RNBQ1RK1 w kq - d2d4", null, null],
  [
    "r1bqk2r/pppp1ppp/2n2n2/b3p3/2BPP3/2P2N2/P4PPP/RNBQ1RK1 b kq - e5d4",
    "C52",
    "Italian Game: Evans Gambit, Anderssen Defense",
  ],
  ["r1bqk2r/pppp1ppp/2n2n2/b3p3/2BPP3/2P2N2/P4PPP/RNBQ1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pppp1ppp/2n4n/2b3N1/2BpP3/8/PPP2PPP/RNBQK2R w KQkq - d1h5", "C44", "Scotch Game: Vitzthum Attack"],
  ["r1bqk2r/pppp1ppp/2n4n/2b3N1/2BpP3/8/PPP2PPP/RNBQK2R w KQkq - g5f7", null, null],
  [
    "r1bqk2r/pppp1ppp/2n5/2b1P3/2Bp2n1/5N2/PPP2PPP/RNBQ1RK1 w kq - c2c3",
    "C56",
    "Italian Game: Two Knights Defense, Max Lange Attack, Krause Variation",
  ],
  ["r1bqk2r/pppp1ppp/2n5/2b1P3/2Bpn3/2P2N2/PP3PPP/RNBQK2R w KQkq - c4d5", null, null],
  ["r1bqk2r/pppp1ppp/2n5/2bBP3/3p4/2P2N2/PP3KPP/RNBQ3R b kq - d4c3", null, null],
  ["r1bqk2r/pppp1ppp/2n5/2bBP3/3p4/2P2N2/PP3nPP/RNBQK2R w KQkq - e1f2", null, null],
  ["r1bqk2r/pppp1ppp/2n5/2bBP3/3pn3/2P2N2/PP3PPP/RNBQK2R b KQkq - e4f2", null, null],
  [
    "r1bqk2r/pppp1ppp/2n5/2bBP3/8/2p2N2/PP3KPP/RNBQ3R w kq - f2g3",
    "C54",
    "Italian Game: Classical Variation, Ghulam-Kassim Variation",
  ],
  ["r1bqk2r/pppp1ppp/2n5/3P4/2B1n3/2b2N2/PP3PPP/R1BQ1RK1 b kq - c3f6", null, null],
  ["r1bqk2r/pppp1ppp/2n5/8/1bBP4/2n2N2/PP3PPP/R1BQ1RK1 w kq - b2c3", null, null],
  ["r1bqk2r/pppp1ppp/2n5/8/1bBP4/2P2N2/P4PPP/R1BQ1RK1 b kq - b4c3", null, null],
  [
    "r1bqk2r/pppp1ppp/2n5/8/1bBPn3/2N2N2/PP3PPP/R1BQ1RK1 b kq - b4c3",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Main Line",
  ],
  [
    "r1bqk2r/pppp1ppp/2n5/8/1bBPn3/2N2N2/PP3PPP/R1BQ1RK1 b kq - e4c3",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Greco Variation",
  ],
  ["r1bqk2r/pppp1ppp/2n5/8/1bBPn3/2N2N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/pppp1ppp/2n5/8/1bBPn3/5N2/PP1B1PPP/RN1QK2R w KQkq - d2b4", null, null],
  ["r1bqk2r/pppp1ppp/2n5/8/1BBPn3/5N2/PP3PPP/RN1QK2R b KQkq - c6b4", null, null],
  [
    "r1bqk2r/pppp1ppp/2n5/8/2BP4/1Qb2N2/P4PPP/R1B2RK1 b kq - d7d5",
    "C54",
    "Italian Game: Giuoco Piano, Bernstein Variation",
  ],
  [
    "r1bqk2r/pppp1ppp/2n5/8/2BP4/2b2N2/P4PPP/R1BQ1RK1 w kq - c1a3",
    "C54",
    "Italian Game: Giuoco Piano, Aitken Variation",
  ],
  ["r1bqk2r/pppp1ppp/2n5/8/2BP4/2b2N2/P4PPP/R1BQ1RK1 w kq - d1b3", null, null],
  ["r1bqk2r/pppp1ppp/2n5/8/2BPn3/2b2N2/PP3PPP/R1BQ1RK1 w kq - b2c3", null, null],
  [
    "r1bqk2r/pppp1ppp/2n5/8/2BPn3/2b2N2/PP3PPP/R1BQ1RK1 w kq - d4d5",
    "C54",
    "Italian Game: Classical Variation, Greco Gambit, Moeller-Therkatz Attack",
  ],
  ["r1bqk2r/pppp1ppp/2n5/8/2BPn3/2P2N2/P4PPP/R1BQ1RK1 b kq - d7d5", null, null],
  [
    "r1bqk2r/pppp1ppp/5n2/1Bb1N3/3nP3/2N5/PPPP1PPP/R1BQ1RK1 b kq - e8g8",
    "C48",
    "Four Knights Game: Spanish Variation, Rubinstein Variation, Marshall Variation",
  ],
  ["r1bqk2r/pppp1ppp/5n2/1Bb1N3/3nP3/2N5/PPPP1PPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1bqk2r/pppp1ppp/5n2/2b1N3/B2nP3/2N5/PPPP1PPP/R1BQK2R b KQkq - e8g8",
    "C48",
    "Four Knights Game: Spanish Variation, Rubinstein Variation, Marshall Gambit",
  ],
  ["r1bqk2r/pppp1ppp/5n2/2b1p3/4P3/2N2B2/PPPP1PPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r1bqk2r/pppp1ppp/5n2/2b1p3/4P3/2N2B2/PPPP1PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqk2r/pppp1ppp/5n2/2b1p3/B2nP3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - f3e5", null, null],
  ["r1bqk2r/pppp1ppp/5n2/4p1B1/2BnP3/8/PPP2PPP/RN1Q1RK1 b kq - d7d6", "C55", "Italian Game: Two Knights Defense"],
  ["r1bqk2r/pppp1ppp/5n2/4p1B1/2BnP3/8/PPP2PPP/RN1Q1RK1 b kq - h7h6", null, null],
  ["r1bqk2r/pppp1ppp/5n2/4p3/2BnP3/8/PPP2PPP/RNBQ1RK1 w kq - c1g5", null, null],
  ["r1bqk2r/pppp1ppp/8/8/1nBPn3/5N2/PP3PPP/RN1QK2R w KQkq - c4f7", null, null],
  ["r1bqk2r/ppppbppp/2Bn4/4p3/3P4/5N2/PPP1QPPP/RNB2RK1 b kq - b7c6", null, null],
  [
    "r1bqk2r/ppppbppp/2n2n2/4P3/2Bp4/2P2N2/PP3PPP/RNBQK2R b KQkq - f6e4",
    "C50",
    "Italian Game: Hungarian Defense, Tartakower Variation",
  ],
  ["r1bqk2r/ppppbppp/2n2n2/8/2BpP3/2P2N2/PP3PPP/RNBQK2R w KQkq - e4e5", null, null],
  [
    "r1bqk2r/ppppbppp/2n5/1B2p3/3Pn3/5N2/PPP1QPPP/RNB2RK1 b kq - d7d5",
    "C67",
    "Ruy Lopez: Berlin Defense, Trifunovic Variation",
  ],
  ["r1bqk2r/ppppbppp/2n5/1B2p3/3Pn3/5N2/PPP1QPPP/RNB2RK1 b kq - e4d6", null, null],
  ["r1bqk2r/ppppbppp/2n5/1B2p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1 w kq - d1e2", null, null],
  [
    "r1bqk2r/ppppbppp/2n5/1B2p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1 w kq - d4e5",
    "C67",
    "Ruy Lopez: Berlin Defense, Minckwitz Variation",
  ],
  ["r1bqk2r/ppppbppp/2nn4/1B2p3/3P4/5N2/PPP1QPPP/RNB2RK1 w kq - b5c6", null, null],
  [
    "r1bqk2r/ppppbppp/2nn4/4p2Q/8/1BN2N2/PPPP1PPP/R1B1K2R w KQkq - f3e5",
    "C27",
    "Vienna Game: Stanley Variation, Alekhine Variation",
  ],
  ["r1bqk2r/ppppnpbp/2n3p1/1B6/3NP3/2N1B3/PPP2PPP/R2QK2R b KQkq - e8g8", null, null],
  ["r1bqk2r/ppppnpbp/2n3p1/1B6/3NP3/4B3/PPP2PPP/RN1QK2R w KQkq - b1c3", null, null],
  ["r1bqk2r/ppppnppp/5b2/3P4/2B1n3/5N2/PP3PPP/R1BQR1K1 w kq - e1e4", null, null],
  ["r1bqk2r/ppppnppp/5b2/3P4/2B1R3/5N2/PP3PPP/R1BQ2K1 b kq - d7d6", null, null],
  ["r1bqkb1r/1p1npppp/p2p1n2/6B1/2BNP3/2N5/PPP2PPP/R2QK2R b KQkq - d8a5", null, null],
  ["r1bqkb1r/1p1npppp/p2p1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R w KQkq - f1c4", null, null],
  ["r1bqkb1r/1p3ppp/p1np1n2/1N2p1B1/4P3/2N5/PPP2PPP/R2QKB1R w KQkq - b5a3", null, null],
  [
    "r1bqkb1r/1p3ppp/p1np1n2/4p1B1/4P3/N1N5/PPP2PPP/R2QKB1R b KQkq - b7b5",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation",
  ],
  [
    "r1bqkb1r/1p3ppp/p1np1n2/4p1B1/4P3/N1N5/PPP2PPP/R2QKB1R b KQkq - c8e6",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Bird Variation",
  ],
  ["r1bqkb1r/1p3ppp/p1nppn2/1N6/2P1P3/2N5/PP3PPP/R1BQKB1R w KQkq - b5a3", null, null],
  [
    "r1bqkb1r/1p3ppp/p1nppn2/6B1/3NP3/2N5/PPPQ1PPP/2KR1B1R b kq - c8d7",
    "B67",
    "Sicilian Defense: Richter-Rauzer Variation, Neo-Modern Variation",
  ],
  ["r1bqkb1r/1p3ppp/p1nppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R w KQkq - e1c1", null, null],
  [
    "r1bqkb1r/1p3ppp/p1nppn2/8/2P1P3/N1N5/PP3PPP/R1BQKB1R b KQkq - d6d5",
    "B44",
    "Sicilian Defense: Taimanov Variation, Gary Gambit",
  ],
  ["r1bqkb1r/1p3ppp/p1nppn2/8/2P1P3/N1N5/PP3PPP/R1BQKB1R b KQkq - f8e7", null, null],
  ["r1bqkb1r/1pp2ppp/p1Bp1n2/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - b7c6", null, null],
  [
    "r1bqkb1r/1pp2ppp/p1np1n2/4p3/B3P3/3P1N2/PPP2PPP/RNBQK2R w KQkq - c2c4",
    "C77",
    "Ruy Lopez: Morphy Defense, Duras Variation",
  ],
  ["r1bqkb1r/1pp2ppp/p1np1n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - a4c6", null, null],
  ["r1bqkb1r/1pp2ppp/p1p2n2/4N3/4P3/2N5/PPPP1PPP/R1BQK2R b KQkq - f6e4", null, null],
  ["r1bqkb1r/1pp2ppp/p1p2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - f3e5", null, null],
  ["r1bqkb1r/1pp2ppp/p1p5/4N3/4n3/2N5/PPPP1PPP/R1BQK2R w KQkq - c3e4", null, null],
  ["r1bqkb1r/1pp2ppp/p1p5/4N3/4N3/8/PPPP1PPP/R1BQK2R b KQkq - d8d4", null, null],
  [
    "r1bqkb1r/1ppn1ppp/p3pn2/8/2QP4/6P1/PP2PPBP/RNB1K1NR w KQkq - c4c2",
    "E03",
    "Catalan Opening: Open Defense, Alekhine Variation",
  ],
  ["r1bqkb1r/1ppp1ppp/p1B2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - d7c6", null, null],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/1B2p3/4P3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - b5c6",
    "C48",
    "Four Knights Game: Spanish Variation, Ranken Variation",
  ],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - d7d6", null, null],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - b7b5", null, null],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - d7d5", "C78", "Ruy Lopez: Central Countergambit"],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - d7d6",
    "C79",
    "Ruy Lopez: Morphy Defense, Steinitz Deferred",
  ],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f6e4", "C80", "Ruy Lopez: Open"],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f8c5",
    "C78",
    "Ruy Lopez: Morphy Defense, Neo-Arkhangelsk Variation",
  ],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f8e7", "C84", "Ruy Lopez: Closed"],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - g7g6", "C78", "Ruy Lopez: Brix Variation"],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - a4c6",
    "C77",
    "Ruy Lopez: Morphy Defense, Bayreuth Variation",
  ],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b1c3",
    "C77",
    "Ruy Lopez: Morphy Defense, Tarrasch Variation",
  ],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c3",
    "C77",
    "Ruy Lopez: Morphy Defense, Jaffe Gambit",
  ],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d1e2",
    "C77",
    "Ruy Lopez: Morphy Defense, Wormald Attack",
  ],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d3",
    "C77",
    "Ruy Lopez: Morphy Defense, Anderssen Variation",
  ],
  [
    "r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4",
    "C77",
    "Ruy Lopez: Morphy Defense, Mackenzie Variation",
  ],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1", "C78", "Ruy Lopez: Morphy Defense"],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPPQPPP/RNB1K2R b KQkq - b7b5", null, null],
  ["r1bqkb1r/1ppp1ppp/p1n2n2/4p3/B3P3/5N2/PPPPQPPP/RNB1K2R b KQkq - f8e7", null, null],
  ["r1bqkb1r/1ppp1ppp/p1n5/4p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1 b kq - b7b5", null, null],
  ["r1bqkb1r/1ppp1ppp/p1n5/4p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1 b kq - e5d4", "C80", "Ruy Lopez: Open, Riga Variation"],
  ["r1bqkb1r/1ppp1ppp/p1n5/4p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1 b kq - f8e7", null, null],
  ["r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/5N2/PPPP1PPP/RNBQ1RK1 w kq - b1c3", "C80", "Ruy Lopez: Open, Knorre Variation"],
  [
    "r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d1e2",
    "C80",
    "Ruy Lopez: Morphy Defense, Tartakower Variation",
  ],
  ["r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d2d4", "C80", "Ruy Lopez: Open"],
  ["r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/5N2/PPPP1PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r1bqkb1r/1ppp1ppp/p1n5/4p3/B3n3/5N2/PPPP1PPP/RNBQR1K1 b kq - d7d5", "C80", "Ruy Lopez: Open, Skipworth Gambit"],
  ["r1bqkb1r/2p2ppp/p1n2n2/1p1pp1N1/4P3/1B6/PPPP1PPP/RNBQ1RK1 w kq - e4d5", null, null],
  ["r1bqkb1r/2p2ppp/p1n2n2/1p1Pp1N1/8/1B6/PPPP1PPP/RNBQ1RK1 b kq - c6d4", null, null],
  ["r1bqkb1r/2p2ppp/p1n5/1p1pp3/3Pn3/1B3N2/PPP2PPP/RNBQ1RK1 w kq - a2a4", null, null],
  ["r1bqkb1r/2p2ppp/p1n5/1p1pp3/3Pn3/1B3N2/PPP2PPP/RNBQ1RK1 w kq - c2c4", "C80", "Ruy Lopez: Open, Harksen Gambit"],
  ["r1bqkb1r/2p2ppp/p1n5/1p1pp3/3Pn3/1B3N2/PPP2PPP/RNBQ1RK1 w kq - d4e5", "C80", "Ruy Lopez: Open"],
  ["r1bqkb1r/2p2ppp/p1n5/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1 b kq - c6e7", "C80", "Ruy Lopez: Open, Zukertort Variation"],
  ["r1bqkb1r/2p2ppp/p1n5/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1 b kq - c8e6", "C80", "Ruy Lopez: Open, Main Line"],
  [
    "r1bqkb1r/2p2ppp/p1n5/1p1pp3/P2Pn3/1B3N2/1PP2PPP/RNBQ1RK1 b kq - c6d4",
    "C80",
    "Ruy Lopez: Open, Schlechter Defense",
  ],
  ["r1bqkb1r/2p2ppp/p1np1n2/1p2p1N1/4P3/1B6/PPPP1PPP/RNBQ1RK1 b kq - d6d5", null, null],
  ["r1bqkb1r/2p2ppp/p1np1n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQ1RK1 w kq - f3g5", null, null],
  [
    "r1bqkb1r/2p2ppp/p1pp1n2/4p3/3PP3/5N2/PPP2PPP/RNBQ1RK1 b kq - c8g4",
    "C79",
    "Ruy Lopez: Steinitz Defense Deferred, Lipnitsky Variation",
  ],
  [
    "r1bqkb1r/2p2ppp/p1pp1n2/4p3/3PP3/5N2/PPP2PPP/RNBQ1RK1 b kq - f6e4",
    "C79",
    "Ruy Lopez: Morphy Defense, Steinitz Deferred",
  ],
  ["r1bqkb1r/2p2ppp/p1pp1n2/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d2d4", null, null],
  ["r1bqkb1r/2p2ppp/p1pp4/4p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r1bqkb1r/2p2ppp/p1pp4/4p3/3Pn3/5N2/PPP2PPP/RNBQR1K1 b kq - f7f5", null, null],
  ["r1bqkb1r/2p2ppp/p4n2/1p1Pp1N1/3n4/1B6/PPPP1PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r1bqkb1r/2p2ppp/p4n2/1p1Pp1N1/3n4/1B6/PPPP1PPP/RNBQR1K1 b kq - f8c5", null, null],
  ["r1bqkb1r/2p2ppp/p7/1p1p4/P2pn3/1B6/1PP2PPP/RNBQ1RK1 w kq - b1c3", "C80", "Ruy Lopez: Open, Berger Variation"],
  ["r1bqkb1r/2p2ppp/p7/1p1pp3/P2nn3/1B3N2/1PP2PPP/RNBQ1RK1 w kq - f3d4", null, null],
  ["r1bqkb1r/2p2ppp/p7/1p1pp3/P2Nn3/1B6/1PP2PPP/RNBQ1RK1 b kq - e5d4", null, null],
  [
    "r1bqkb1r/2p3pp/p1p5/3pPp2/4n3/5N2/PPP2PPP/RNBQR1K1 w kq - b1c3",
    "C79",
    "Ruy Lopez: Steinitz Defense Deferred, Boleslavsky Variation",
  ],
  ["r1bqkb1r/2p3pp/p1pp4/4pp2/3Pn3/5N2/PPP2PPP/RNBQR1K1 w kq - d4e5", null, null],
  ["r1bqkb1r/2p3pp/p1pp4/4Pp2/4n3/5N2/PPP2PPP/RNBQR1K1 b kq - d6d5", null, null],
  [
    "r1bqkb1r/2pp1ppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQ1RK1 b kq - c8b7",
    "C78",
    "Ruy Lopez: Morphy Defense, Arkhangelsk Variation",
  ],
  ["r1bqkb1r/2pp1ppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQ1RK1 b kq - d7d6", "C78", "Ruy Lopez: Morphy Defense"],
  ["r1bqkb1r/2pp1ppp/p1n2n2/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQ1RK1 b kq - f8e7", null, null],
  ["r1bqkb1r/2pp1ppp/p1n2n2/1p2p3/4P3/1B3N2/PPPPQPPP/RNB1K2R b KQkq - f8e7", null, null],
  ["r1bqkb1r/2pp1ppp/p1n2n2/1p2p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - a4b3", null, null],
  ["r1bqkb1r/2pp1ppp/p1n2n2/1p2p3/B3P3/5N2/PPPPQPPP/RNB1K2R w KQkq - a4b3", null, null],
  ["r1bqkb1r/2pp1ppp/p1n5/1p2p3/3Pn3/1B3N2/PPP2PPP/RNBQ1RK1 b kq - d7d5", null, null],
  ["r1bqkb1r/2pp1ppp/p1n5/1p2p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1 w kq - a4b3", "C80", "Ruy Lopez: Open"],
  ["r1bqkb1r/2pp1ppp/p1n5/1p2p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1 w kq - d4d5", "C80", "Ruy Lopez: Open, Richter Variation"],
  ["r1bqkb1r/2pp1ppp/p1n5/1p2p3/B2Pn3/5N2/PPP2PPP/RNBQ1RK1 w kq - f3e5", "C80", "Ruy Lopez: Open, Friess Attack"],
  ["r1bqkb1r/3n1ppp/p1p1pn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R w KQkq - e3e4", null, null],
  [
    "r1bqkb1r/3n1ppp/p1p1pn2/1p6/3PP3/2NB1N2/PP3PPP/R1BQK2R b KQkq - b5b4",
    "D48",
    "Semi-Slav Defense: Meran Variation, Pirc Variation",
  ],
  ["r1bqkb1r/3n1ppp/p1p1pn2/1p6/3PP3/2NB1N2/PP3PPP/R1BQK2R b KQkq - c6c5", "D48", "Semi-Slav Defense: Meran Variation"],
  [
    "r1bqkb1r/3n1ppp/p3pn2/1N2P3/3p4/3B1N2/PP3PPP/R1BQK2R b KQkq - d7e5",
    "D49",
    "Semi-Slav Defense: Meran Variation, Sozin Variation",
  ],
  [
    "r1bqkb1r/3n1ppp/p3pn2/1N2P3/3p4/3B1N2/PP3PPP/R1BQK2R b KQkq - f6g4",
    "D49",
    "Semi-Slav Defense: Meran Variation, Rabinovich Variation",
  ],
  [
    "r1bqkb1r/3n1ppp/p3pn2/1p2P3/3p4/2NB1N2/PP3PPP/R1BQK2R w KQkq - c3b5",
    "D49",
    "Semi-Slav Defense: Meran Variation, Blumenfeld Variation",
  ],
  ["r1bqkb1r/3n1ppp/p3pn2/1pp1P3/3P4/2NB1N2/PP3PPP/R1BQK2R b KQkq - c5d4", null, null],
  [
    "r1bqkb1r/3n1ppp/p3pn2/1pp5/3PP3/2NB1N2/PP3PPP/R1BQK2R w KQkq - d4d5",
    "D48",
    "Semi-Slav Defense: Meran Variation, Reynolds' Variation",
  ],
  [
    "r1bqkb1r/3n1ppp/p3pn2/1pp5/3PP3/2NB1N2/PP3PPP/R1BQK2R w KQkq - e4e5",
    "D48",
    "Semi-Slav Defense: Meran Variation, Old Variation",
  ],
  [
    "r1bqkb1r/5p1p/p1np1p2/1p1Np3/4P3/N7/PPP2PPP/R2QKB1R b KQkq - f6f5",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation",
  ],
  [
    "r1bqkb1r/5p1p/p1np1p2/1p1Np3/4P3/N7/PPP2PPP/R2QKB1R b KQkq - f8g7",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation, Novosibirsk Variation",
  ],
  ["r1bqkb1r/5p1p/p1np1p2/1p2p3/4P3/N1N5/PPP2PPP/R2QKB1R w KQkq - c3d5", null, null],
  [
    "r1bqkb1r/5p1p/p1np4/1p1Npp2/4P3/N7/PPP2PPP/R2QKB1R w KQkq - f1b5",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation, Peresypkin's Sacrifice",
  ],
  ["r1bqkb1r/5ppp/4pn2/1p2N3/3p4/3B4/PP3PPP/R1BQ1RK1 b kq - d8d5", null, null],
  [
    "r1bqkb1r/5ppp/4pn2/1p2N3/3p4/3B4/PP3PPP/R1BQK2R w KQkq - d1f3",
    "D49",
    "Semi-Slav Defense: Meran Variation, Stahlberg Variation",
  ],
  [
    "r1bqkb1r/5ppp/4pn2/1p2N3/3p4/3B4/PP3PPP/R1BQK2R w KQkq - e1g1",
    "D49",
    "Semi-Slav Defense: Meran Variation, Sozin Variation",
  ],
  ["r1bqkb1r/5ppp/p1n1pn2/1p6/2pP4/1B2PN2/PP2QPPP/RNBR2K1 w kq - b3c2", null, null],
  ["r1bqkb1r/5ppp/p1n1pn2/1p6/2pP4/4PN2/PPB1QPPP/RNBR2K1 b kq - c6b4", null, null],
  ["r1bqkb1r/5ppp/p1n1pn2/1pp5/3P4/1B2PN2/PP2QPPP/RNB2RK1 w kq - f1d1", null, null],
  ["r1bqkb1r/5ppp/p1n1pn2/1pp5/3P4/1B2PN2/PP2QPPP/RNBR2K1 b kq - c5c4", null, null],
  ["r1bqkb1r/5ppp/p1np1B2/1p2p3/4P3/N1N5/PPP2PPP/R2QKB1R b KQkq - g7f6", null, null],
  [
    "r1bqkb1r/5ppp/p1np1n2/1p2p1B1/4P3/N1N5/PPP2PPP/R2QKB1R w KQkq - c3d5",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Sveshnikov Variation, Chelyabinsk Variation",
  ],
  ["r1bqkb1r/5ppp/p1np1n2/1p2p1B1/4P3/N1N5/PPP2PPP/R2QKB1R w KQkq - g5f6", null, null],
  ["r1bqkb1r/5ppp/p3pn2/1N2n3/3p4/3B1N2/PP3PPP/R1BQK2R w KQkq - f3e5", null, null],
  ["r1bqkb1r/5ppp/p3pn2/1N2N3/3p4/3B4/PP3PPP/R1BQK2R b KQkq - a6b5", null, null],
  ["r1bqkb1r/5ppp/p3pn2/1p6/1npP4/2N1PN2/PPB1QPPP/R1BR2K1 b kq - b4c2", null, null],
  ["r1bqkb1r/5ppp/p3pn2/1p6/1npP4/4PN2/PPB1QPPP/RNBR2K1 w kq - b1c3", null, null],
  ["r1bqkb1r/5ppp/p3pn2/1p6/2pP4/2N1PN2/PPn1QPPP/R1BR2K1 w kq - e2c2", null, null],
  ["r1bqkb1r/5ppp/p3pn2/1p6/2pP4/2N1PN2/PPQ2PPP/R1BR2K1 b kq - c8b7", null, null],
  [
    "r1bqkb1r/p1p2pp1/2n2n1p/1p1Pp1N1/8/8/PPPP1PPP/RNBQKB1R w KQkq - g5f7",
    "C57",
    "Italian Game: Two Knights Defense, Ulvestad Variation, Kurkin Gambit",
  ],
  ["r1bqkb1r/p1p2ppp/2n2n2/1p1Pp1N1/2B5/8/PPPP1PPP/RNBQK2R w KQkq - c4f1", null, null],
  ["r1bqkb1r/p1p2ppp/2n2n2/1p1Pp1N1/8/8/PPPP1PPP/RNBQKB1R b KQkq - h7h6", null, null],
  ["r1bqkb1r/p1p2ppp/5n2/1p1Pp1N1/2Bn4/2P5/PP1P1PPP/RNBQK2R w KQkq - c4f1", null, null],
  ["r1bqkb1r/p1p2ppp/5n2/1p1Pp1N1/3n4/2P5/PP1P1PPP/RNBQKB1R b KQkq - f6d5", null, null],
  [
    "r1bqkb1r/p1p2ppp/8/1p1np1N1/3n4/2P5/PP1P1PPP/RNBQKB1R w KQkq - g5e4",
    "C57",
    "Italian Game: Two Knights Defense, Fritz, Gruber Variation",
  ],
  ["r1bqkb1r/p1pp1ppp/2p2n2/8/4P3/8/PPP2PPP/RNBQKB1R w KQkq - b1d2", "C45", "Scotch Game: Tartakower Variation"],
  ["r1bqkb1r/p1pp1ppp/2p2n2/8/4P3/8/PPP2PPP/RNBQKB1R w KQkq - e4e5", "C45", "Scotch Game: Mieses Variation"],
  [
    "r1bqkb1r/p2n1p2/2p1pn2/1p2P1B1/2pP4/2N5/PP3PPP/R2QKB1R w KQkq - d1f3",
    "D44",
    "Semi-Slav Defense: Botvinnik Variation, Szabo Variation",
  ],
  [
    "r1bqkb1r/p2n1p2/2p1pn2/1p2P1B1/2pP4/2N5/PP3PPP/R2QKB1R w KQkq - g2g3",
    "D44",
    "Semi-Slav Defense: Botvinnik Variation, Lilienthal Variation",
  ],
  [
    "r1bqkb1r/p2n1ppp/1pp1pn2/3p4/2PP4/1PN1PN2/P1Q2PPP/R1B1KB1R b KQkq - c8b7",
    "D45",
    "Semi-Slav Defense: Stoltz Variation",
  ],
  [
    "r1bqkb1r/p2n1ppp/1pp1pn2/3p4/2PP4/2N1PN2/PPQ2PPP/R1B1KB1R w KQkq - b2b3",
    "D45",
    "Semi-Slav Defense: Stoltz Variation",
  ],
  ["r1bqkb1r/p2n1ppp/2p1pn2/1p6/2BP4/2N1PN2/PP3PPP/R1BQK2R w KQkq - c4d3", null, null],
  ["r1bqkb1r/p2n1ppp/2p1pn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R b KQkq - a7a6", "D48", "Semi-Slav Defense: Meran Variation"],
  [
    "r1bqkb1r/p2n1ppp/2p1pn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R b KQkq - b5b4",
    "D47",
    "Semi-Slav Defense: Meran Variation, Lundin Variation",
  ],
  [
    "r1bqkb1r/p2n1ppp/2p1pn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R b KQkq - c8b7",
    "D47",
    "Semi-Slav Defense: Meran Variation, Wade Variation",
  ],
  ["r1bqkb1r/p2n1ppp/2p1pn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R b KQkq - f8d6", null, null],
  ["r1bqkb1r/p3pp1p/2pp1np1/8/2B1P3/2N5/PPP2PPP/R1BQK2R w KQkq - e4e5", "B57", "Sicilian Defense: Magnus Smith Trap"],
  [
    "r1bqkb1r/p4pp1/2p2n1p/n3N3/4p3/8/PPPPBPPP/RNBQK2R b KQkq - d8c7",
    "C59",
    "Italian Game: Two Knights Defense, Polerio Defense, Göring Variation",
  ],
  ["r1bqkb1r/p4pp1/2p2n1p/n3N3/4p3/8/PPPPBPPP/RNBQK2R b KQkq - f8d6", null, null],
  ["r1bqkb1r/p4pp1/2p2n1p/n3p1N1/8/8/PPPPBPPP/RNBQK2R w KQkq - g5f3", null, null],
  [
    "r1bqkb1r/p4pp1/2p2n1p/n3p1N1/8/8/PPPPBPPP/RNBQK2R w KQkq - g5h3",
    "C59",
    "Italian Game: Two Knights Defense, Steinitz Variation",
  ],
  ["r1bqkb1r/p4pp1/2p2n1p/n3p3/8/5N2/PPPPBPPP/RNBQK2R b KQkq - e5e4", null, null],
  ["r1bqkb1r/p4pp1/2p2n1p/n7/4p3/5N2/PPPPBPPP/RNBQK2R w KQkq - f3e5", null, null],
  [
    "r1bqkb1r/p4ppp/2p2n2/n3p1N1/8/8/PPPPBPPP/RNBQK2R b KQkq - h7h6",
    "C59",
    "Italian Game: Two Knights Defense, Polerio Defense, Suhle Defense",
  ],
  [
    "r1bqkb1r/p4ppp/2p2n2/nB2p1N1/8/5Q2/PPPP1PPP/RNB1K2R b KQkq - a8b8",
    "C58",
    "Italian Game: Two Knights Defense, Colman Variation",
  ],
  [
    "r1bqkb1r/p4ppp/2p2n2/nB2p1N1/8/5Q2/PPPP1PPP/RNB1K2R b KQkq - c6b5",
    "C58",
    "Italian Game: Two Knights Defense, Blackburne Variation",
  ],
  ["r1bqkb1r/p4ppp/2p2n2/nB2p1N1/8/5Q2/PPPP1PPP/RNB1K2R b KQkq - d8c7", null, null],
  ["r1bqkb1r/p4ppp/2p2n2/nB2p1N1/8/8/PPPP1PPP/RNBQK2R w KQkq - b5e2", "C58", "Italian Game: Two Knights Defense"],
  [
    "r1bqkb1r/p4ppp/2p2n2/nB2p1N1/8/8/PPPP1PPP/RNBQK2R w KQkq - d1f3",
    "C58",
    "Italian Game: Two Knights Defense, Polerio Defense, Bogoljubow Variation",
  ],
  [
    "r1bqkb1r/pp1n1ppp/2n1p3/2ppP3/3P1P2/2N2N2/PPP3PP/R1BQKB1R w KQkq - c1e3",
    "C11",
    "French Defense: Steinitz Variation, Boleslavsky Variation",
  ],
  ["r1bqkb1r/pp1n1ppp/2n1p3/2ppP3/3P4/2PB4/PP1N1PPP/R1BQK1NR w KQkq - g1e2", null, null],
  ["r1bqkb1r/pp1n1ppp/2n1p3/2ppP3/3P4/2PB4/PP1NNPPP/R1BQK2R b KQkq - c5d4", null, null],
  ["r1bqkb1r/pp1n1ppp/2n1p3/2PpP3/5P2/2N5/PPP3PP/R1BQKBNR w KQkq - a2a3", null, null],
  ["r1bqkb1r/pp1n1ppp/2n1p3/2PpP3/5P2/P1N5/1PP3PP/R1BQKBNR b KQkq - f8c5", null, null],
  [
    "r1bqkb1r/pp1n1ppp/2n1p3/3pP3/3p4/2PB4/PP1NNPPP/R1BQK2R w KQkq - c3d4",
    "C06",
    "French Defense: Tarrasch Variation, Closed Variation, Main Line",
  ],
  [
    "r1bqkb1r/pp1n1ppp/2n1p3/3pP3/3P4/3B4/PP1NNPPP/R1BQK2R b KQkq - d7b6",
    "C06",
    "French Defense: Tarrasch Variation, Leningrad Variation",
  ],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR w KQkq - a2a3",
    "D51",
    "Queen's Gambit Declined: Capablanca Variation, Anti-Cambridge Springs Variation",
  ],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR w KQkq - g1f3", "D52", "Queen's Gambit Declined"],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R b KQkq - d8a5",
    "D52",
    "Queen's Gambit Declined: Cambridge Springs Defense",
  ],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/2RQKB1R b Kkq - d8a5", null, null],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - a1c1", null, null],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - e2e3", "D52", "Queen's Gambit Declined"],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - e2e4",
    "D51",
    "Queen's Gambit Declined: Alekhine Variation",
  ],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p2B1/2PP4/5N2/PP1NPPPP/R2QKB1R w KQkq - e2e3",
    "D30",
    "Queen's Gambit Declined: Capablanca Variation",
  ],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/1PN1PN2/P4PPP/R1BQKB1R b KQkq - f8d6", null, null],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - b2b3", null, null],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - d1c2",
    "D45",
    "Semi-Slav Defense: Stoltz Variation",
  ],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f1d3", "D46", "Semi-Slav Defense: Main Line"],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f3e5",
    "D45",
    "Semi-Slav Defense: Rubinstein System",
  ],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2N1PN2/PPQ2PPP/R1B1KB1R b KQkq - b7b6", null, null],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2N1PN2/PPQ2PPP/R1B1KB1R b KQkq - f8d6", null, null],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - d5c4", null, null],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - f8b4",
    "D46",
    "Semi-Slav Defense: Romih Variation",
  ],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - f8d6",
    "D46",
    "Semi-Slav Defense: Chigorin Defense",
  ],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - f8e7",
    "D46",
    "Semi-Slav Defense: Bogoljubow Variation",
  ],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/3BPN2/PP1N1PPP/R1BQK2R b KQkq - c6c5",
    "D30",
    "Queen's Gambit Declined: Semmering Variation",
  ],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/3p4/2PP4/4PN2/PP1N1PPP/R1BQKB1R w KQkq - f1d3", null, null],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/6N1/2BP4/8/PPP1QPPP/R1B1K1NR b KQkq - d7b6",
    "B17",
    "Caro-Kann Defense: Karpov Variation, Smyslov Variation",
  ],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/6N1/2BP4/8/PPP2PPP/R1BQK1NR w KQkq - d1e2", null, null],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/6N1/3P4/3B1N2/PPP2PPP/R1BQK2R b KQkq - f8d6", null, null],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/6N1/3P4/3B4/PPP2PPP/R1BQK1NR w KQkq - g1f3", null, null],
  ["r1bqkb1r/pp1n1ppp/2p1pn2/8/2BP4/2N1PN2/PP3PPP/R1BQK2R b KQkq - b7b5", "D47", "Semi-Slav Defense: Meran Variation"],
  [
    "r1bqkb1r/pp1n1ppp/2p1pn2/8/2pP4/2NBPN2/PP3PPP/R1BQK2R w KQkq - d3c4",
    "D47",
    "Semi-Slav Defense: Semi-Meran Variation",
  ],
  [
    "r1bqkb1r/pp1n1ppp/2pp1n2/8/2BQPP2/2N2N2/PPP3PP/R1B1K2R b KQkq - d6d5",
    "B07",
    "Lion Defense: Anti-Philidor, Lion's Cave, Lion Claw Gambit",
  ],
  ["r1bqkb1r/pp1n1ppp/2pp1n2/8/3QPP2/2N2N2/PPP3PP/R1B1KB1R w KQkq - f1c4", null, null],
  [
    "r1bqkb1r/pp1npppp/2p2n2/3p4/2P5/1PN1PN2/P2P1PPP/R1BQKB1R b KQkq - e7e5",
    "A11",
    "Réti Opening: Anglo-Slav Variation, Gurevich System",
  ],
  ["r1bqkb1r/pp1npppp/2p2n2/3p4/2P5/2N1PN2/PP1P1PPP/R1BQKB1R w KQkq - b2b3", null, null],
  [
    "r1bqkb1r/pp1npppp/2p2n2/3p4/2P5/2N1PN2/PP1P1PPP/R1BQKB1R w KQkq - d1c2",
    "A11",
    "Réti Opening: Anglo-Slav Variation, Gurevich System",
  ],
  ["r1bqkb1r/pp1npppp/2p2n2/6N1/2BP4/8/PPP2PPP/R1BQK1NR b KQkq - e7e6", null, null],
  ["r1bqkb1r/pp1npppp/2p2n2/6N1/3P4/3B4/PPP2PPP/R1BQK1NR b KQkq - e7e6", null, null],
  ["r1bqkb1r/pp1npppp/2p2n2/6N1/3P4/8/PPP2PPP/R1BQKBNR w KQkq - f1d3", null, null],
  [
    "r1bqkb1r/pp1npppp/2p2N2/8/2BP4/8/PPP2PPP/R1BQK1NR b KQkq - d7f6",
    "B17",
    "Caro-Kann Defense: Karpov Variation, Tiviakov-Fischer Attack",
  ],
  ["r1bqkb1r/pp1npppp/2p2n2/8/2BPN3/8/PPP2PPP/R1BQK1NR w KQkq - e4f6", null, null],
  ["r1bqkb1r/pp1npppp/2p2n2/8/2BPN3/8/PPP2PPP/R1BQK1NR w KQkq - e4g5", null, null],
  [
    "r1bqkb1r/pp1npppp/2p2n2/8/3PN3/5N2/PPP2PPP/R1BQKB1R w KQkq - e4g3",
    "B17",
    "Caro-Kann Defense: Karpov Variation, Modern Variation, Kasparov Attack",
  ],
  [
    "r1bqkb1r/pp1p1ppp/2n1pn2/1N6/4P3/2N5/PPP2PPP/R1BQKB1R b KQkq - d7d6",
    "B45",
    "Sicilian Defense: Four Knights Variation, Sveshnikov Transfer",
  ],
  ["r1bqkb1r/pp1p1ppp/2n1pn2/1N6/4P3/2N5/PPP2PPP/R1BQKB1R b KQkq - f8b4", null, null],
  [
    "r1bqkb1r/pp1p1ppp/2n1pn2/1N6/4P3/2N5/PPP2PPP/R1BQKB1R b KQkq - f8c5",
    "B45",
    "Sicilian Defense: Four Knights Variation, Cobra Variation",
  ],
  ["r1bqkb1r/pp1p1ppp/2n1pn2/2p5/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["r1bqkb1r/pp1p1ppp/2n1pn2/2p5/2PP4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - c5d4", null, null],
  [
    "r1bqkb1r/pp1p1ppp/2n1pn2/8/2PN4/2N3P1/PP2PP1P/R1BQKB1R b KQkq - d8b6",
    "A33",
    "English Opening: Symmetrical Variation, Anti-Benoni Variation, Geller Variation",
  ],
  ["r1bqkb1r/pp1p1ppp/2n1pn2/8/2Pp4/2N2NP1/PP2PP1P/R1BQKB1R w KQkq - f3d4", null, null],
  ["r1bqkb1r/pp1p1ppp/2n1pn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4b5", null, null],
  [
    "r1bqkb1r/pp1p1ppp/2n1pn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4c6",
    "B45",
    "Sicilian Defense: Four Knights Variation, Exchange Variation",
  ],
  ["r1bqkb1r/pp1p1ppp/2n2n2/1N2p3/4P3/2N5/PPP2PPP/R1BQKB1R b KQkq - d7d6", null, null],
  [
    "r1bqkb1r/pp1p1ppp/2n2n2/4p3/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4b3",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Schlechter Variation",
  ],
  ["r1bqkb1r/pp1p1ppp/2n2n2/4p3/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4b5", null, null],
  [
    "r1bqkb1r/pp1p1ppp/2n2n2/4p3/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4c6",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Exchange Variation",
  ],
  [
    "r1bqkb1r/pp1p1ppp/2n2n2/4p3/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4f3",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation, Retreat Variation",
  ],
  ["r1bqkb1r/pp1ppp1p/2n2np1/2p5/2P5/2N2NP1/PP1PPP1P/R1BQKB1R w KQkq - f1g2", null, null],
  [
    "r1bqkb1r/pp1ppp1p/2n2np1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQK2R b KQkq - f8g7",
    "A38",
    "English Opening: Symmetrical Variation, Full Symmetry Line",
  ],
  ["r1bqkb1r/pp1ppp1p/2n2np1/8/2PNP3/2N5/PP3PPP/R1BQKB1R b KQkq - c6d4", null, null],
  ["r1bqkb1r/pp1ppp1p/2n2np1/8/2PNP3/8/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["r1bqkb1r/pp1ppp1p/5np1/8/2PnP3/2N5/PP3PPP/R1BQKB1R w KQkq - d1d4", null, null],
  [
    "r1bqkb1r/pp1ppp1p/5np1/8/2PQP3/2N5/PP3PPP/R1B1KB1R b KQkq - d7d6",
    "B36",
    "Sicilian Defense: Accelerated Dragon, Maróczy Bind, Gurgenidze Variation",
  ],
  [
    "r1bqkb1r/pp1ppppp/1nn5/2p1P3/2B5/2P2N2/PP1P1PPP/RNBQK2R w KQkq - c4b3",
    "B22",
    "Sicilian Defense: Alapin Variation, Stoltz Attack",
  ],
  ["r1bqkb1r/pp1ppppp/1nn5/2p1P3/8/1BP2N2/PP1P1PPP/RNBQK2R b KQkq - c5c4", null, null],
  ["r1bqkb1r/pp1ppppp/1nn5/4P3/2p5/1BP2N2/PP1P1PPP/RNBQK2R w KQkq - b3c2", null, null],
  ["r1bqkb1r/pp1ppppp/1nn5/4P3/2p5/2P2N2/PPBP1PPP/RNBQK2R b KQkq - d8c7", null, null],
  ["r1bqkb1r/pp1ppppp/2n2n2/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["r1bqkb1r/pp1ppppp/2n2n2/2p5/2P5/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - d7d5", null, null],
  ["r1bqkb1r/pp1ppppp/2n2n2/2p5/2P5/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - g7g6", null, null],
  ["r1bqkb1r/pp1ppppp/2n2n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - d7d6", "B56", "Sicilian Defense: Classical Variation"],
  [
    "r1bqkb1r/pp1ppppp/2n2n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - e7e5",
    "B33",
    "Sicilian Defense: Lasker-Pelikan Variation",
  ],
  ["r1bqkb1r/pp1ppppp/2n2n2/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["r1bqkb1r/pp1ppppp/2n2n2/8/4P3/8/PPP2PPP/RNBQKBNR w KQkq - f1c4", "B21", "Sicilian Defense: Coles Sicilian Gambit"],
  ["r1bqkb1r/pp1ppppp/2n5/2pnP3/2B5/2P2N2/PP1P1PPP/RNBQK2R b KQkq - d5b6", null, null],
  [
    "r1bqkb1r/pp1ppppp/2n5/2pnP3/8/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - b1a3",
    "B22",
    "Sicilian Defense: Heidenfeld Variation",
  ],
  ["r1bqkb1r/pp1ppppp/2n5/2pnP3/8/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - f1c4", null, null],
  ["r1bqkb1r/pp2pp1p/2Np1np1/8/2B1P3/2N5/PPP2PPP/R1BQK2R b KQkq - b7c6", null, null],
  ["r1bqkb1r/pp2pp1p/2np1np1/8/2BNP3/2N5/PPP2PPP/R1BQK2R w KQkq - d4c6", null, null],
  [
    "r1bqkb1r/pp2pp1p/2np1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R b KQkq - f8g7",
    "B72",
    "Sicilian Defense: Dragon Variation, Classical Variation",
  ],
  ["r1bqkb1r/pp2pp1p/2np1np1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - f2f3", null, null],
  [
    "r1bqkb1r/pp2pp1p/2np1np1/8/3NP3/2N1BP2/PPP3PP/R2QKB1R b KQkq - h7h5",
    "B75",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Hungarian Dragon",
  ],
  ["r1bqkb1r/pp2pp1p/2np1np1/8/3NP3/2N5/PPP1BPPP/R1BQK2R w KQkq - c1e3", null, null],
  ["r1bqkb1r/pp2pppp/2n2n2/2pp4/2P5/2N2NP1/PP1PPP1P/R1BQKB1R w KQkq - d2d4", null, null],
  [
    "r1bqkb1r/pp2pppp/2n2n2/2pp4/2PP4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - c5d4",
    "A34",
    "English Opening: Symmetrical Variation",
  ],
  [
    "r1bqkb1r/pp2pppp/2n2n2/2pp4/2PP4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - e7e6",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense",
  ],
  [
    "r1bqkb1r/pp2pppp/2n2n2/2pp4/3P4/5NP1/PPP1PPBP/RNBQK2R w KQkq - e1g1",
    "A08",
    "Zukertort Opening: Reversed Grünfeld",
  ],
  [
    "r1bqkb1r/pp2pppp/2n2n2/3P2B1/2p5/2N5/PP3PPP/R2QKBNR b KQkq - c6a5",
    "B13",
    "Caro-Kann Defense: Panov-Botvinnik, Herzog Defense",
  ],
  ["r1bqkb1r/pp2pppp/2n2n2/3p2B1/2PP4/2N5/PP3PPP/R2QKBNR b KQkq - d5c4", null, null],
  [
    "r1bqkb1r/pp2pppp/2n2n2/3p2B1/2PP4/2N5/PP3PPP/R2QKBNR b KQkq - d8a5",
    "B13",
    "Caro-Kann Defense: Panov Attack, Modern Defense, Czerniak Line",
  ],
  [
    "r1bqkb1r/pp2pppp/2n2n2/3p2B1/2PP4/2N5/PP3PPP/R2QKBNR b KQkq - d8b6",
    "B13",
    "Caro-Kann Defense: Panov Attack, Modern Defense, Reifir-Spielmann Line",
  ],
  [
    "r1bqkb1r/pp2pppp/2n2n2/3p2B1/2PP4/2N5/PP3PPP/R2QKBNR b KQkq - e7e6",
    "B13",
    "Caro-Kann Defense: Panov Attack, Modern Defense, Carlsbad Line",
  ],
  [
    "r1bqkb1r/pp2pppp/2n2n2/3p4/2PP4/2N2N2/PP3PPP/R1BQKB1R b KQkq - c8g4",
    "B13",
    "Caro-Kann Defense: Panov Attack, Modern Defense, Mieses Line",
  ],
  ["r1bqkb1r/pp2pppp/2n2n2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR w KQkq - c1g5", null, null],
  ["r1bqkb1r/pp2pppp/2n2n2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "r1bqkb1r/pp2pppp/2n2n2/3p4/3P1B2/2N2N2/PP2PPPP/R2QKB1R b KQkq - c8f5",
    "D14",
    "Slav Defense: Exchange Variation, Symmetrical Line",
  ],
  ["r1bqkb1r/pp2pppp/2n2n2/3p4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1f4", null, null],
  [
    "r1bqkb1r/pp2pppp/2n2n2/3p4/3P4/2PB4/PP3PPP/RNBQK1NR w KQkq - c1f4",
    "B13",
    "Caro-Kann Defense: Exchange Variation, Rubinstein Variation",
  ],
  ["r1bqkb1r/pp2pppp/2n2n2/6B1/2pP4/2N5/PP3PPP/R2QKBNR w KQkq - d4d5", null, null],
  ["r1bqkb1r/pp2pppp/2n5/2pn4/8/2N2NP1/PP1PPP1P/R1BQKB1R w KQkq - f1g2", null, null],
  [
    "r1bqkb1r/pp2pppp/2n5/2pn4/8/2N2NP1/PP1PPPBP/R1BQK2R b KQkq - d5c7",
    "A34",
    "English Opening: Symmetrical Variation, Rubinstein Variation",
  ],
  ["r1bqkb1r/pp2pppp/2np1n2/2p5/3PP3/2P2N2/PP2BPPP/RNBQK2R b KQkq - c5d4", null, null],
  ["r1bqkb1r/pp2pppp/2np1n2/2p5/4P3/2P2N2/PP1PBPPP/RNBQK2R w KQkq - d2d4", null, null],
  [
    "r1bqkb1r/pp2pppp/2np1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R b KQkq - c8d7",
    "B60",
    "Sicilian Defense: Richter-Rauzer Variation, Modern Variation",
  ],
  [
    "r1bqkb1r/pp2pppp/2np1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R b KQkq - e7e6",
    "B62",
    "Sicilian Defense: Richter-Rauzer Variation",
  ],
  [
    "r1bqkb1r/pp2pppp/2np1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R b KQkq - g7g6",
    "B60",
    "Sicilian Defense: Richter-Rauzer Variation, Dragon Variation",
  ],
  [
    "r1bqkb1r/pp2pppp/2np1n2/8/2BNP3/2N5/PPP2PPP/R1BQK2R b KQkq - d8b6",
    "B57",
    "Sicilian Defense: Classical Variation, Anti-Sozin Variation",
  ],
  [
    "r1bqkb1r/pp2pppp/2np1n2/8/2BNP3/2N5/PPP2PPP/R1BQK2R b KQkq - e7e6",
    "B88",
    "Sicilian Defense: Sozin Attack, Leonhardt Variation",
  ],
  ["r1bqkb1r/pp2pppp/2np1n2/8/2BNP3/2N5/PPP2PPP/R1BQK2R b KQkq - g7g6", null, null],
  ["r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - c6d4", null, null],
  [
    "r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - e7e5",
    "B58",
    "Sicilian Defense: Boleslavsky Variation",
  ],
  ["r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - g7g6", null, null],
  [
    "r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - c1g5",
    "B60",
    "Sicilian Defense: Richter-Rauzer Variation",
  ],
  ["r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4e2", "B56", "Sicilian Defense: Spielmann Variation"],
  [
    "r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1c4",
    "B57",
    "Sicilian Defense: Classical Variation, Sozin Attack",
  ],
  ["r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1d3", "B56", "Sicilian Defense: Yates Variation"],
  ["r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1e2", "B58", "Sicilian Defense: Classical Variation"],
  [
    "r1bqkb1r/pp2pppp/2np1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - g2g3",
    "B56",
    "Sicilian Defense: Classical Variation, Fianchetto Variation",
  ],
  ["r1bqkb1r/pp2pppp/2np1n2/8/3pP3/2P2N2/PP2BPPP/RNBQK2R w KQkq - c3d4", null, null],
  [
    "r1bqkb1r/pp2pppp/2np1n2/8/3PP3/5N2/PP2BPPP/RNBQK2R b KQkq - f6e4",
    "B50",
    "Sicilian Defense: Delayed Alapin Variation, Basman-Palatnik Gambit",
  ],
  ["r1bqkb1r/pp2pppp/2np4/3P4/4n3/5N2/PP2BPPP/RNBQK2R b KQkq - d8a5", null, null],
  ["r1bqkb1r/pp2pppp/2np4/8/3Pn3/5N2/PP2BPPP/RNBQK2R w KQkq - d4d5", null, null],
  ["r1bqkb1r/pp2pppp/3p1n2/8/3nP3/2N5/PPP1BPPP/R1BQK2R w KQkq - d1d4", null, null],
  [
    "r1bqkb1r/pp2pppp/3p1n2/8/3QP3/2N5/PPP1BPPP/R1B1K2R b KQkq - g7g6",
    "B58",
    "Sicilian Defense: Classical Variation, Dragon Transfer",
  ],
  [
    "r1bqkb1r/pp3ppp/1np1pn2/6N1/2BP4/8/PPP1QPPP/R1B1K1NR w KQkq - c4b3",
    "B17",
    "Caro-Kann Defense: Karpov Variation, Smyslov Variation, Main Line",
  ],
  [
    "r1bqkb1r/pp3ppp/2n1p3/2pn4/3P4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f1d3",
    "D42",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Main Line",
  ],
  [
    "r1bqkb1r/pp3ppp/2n1pn2/2pp4/2P5/1P3NP1/P2PPPBP/RNBQ1RK1 b kq - f8e7",
    "A13",
    "English Opening: Agincourt Defense, Tarrasch Defense",
  ],
  ["r1bqkb1r/pp3ppp/2n1pn2/2pp4/2P5/1P3NP1/P2PPPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqkb1r/pp3ppp/2n1pn2/2pp4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f1d3", null, null],
  ["r1bqkb1r/pp3ppp/2n1pn2/2pp4/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - f8d6", null, null],
  ["r1bqkb1r/pp3ppp/2n1pn2/2pp4/3P4/1P1BPN2/P1P2PPP/RNBQ1RK1 b kq - f8d6", null, null],
  ["r1bqkb1r/pp3ppp/2n1pn2/2pp4/3P4/1P1BPN2/P1P2PPP/RNBQ1RK1 b kq - f8e7", null, null],
  ["r1bqkb1r/pp3ppp/2n1pn2/2pp4/3P4/1P1BPN2/P1P2PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqkb1r/pp3ppp/2n1pn2/2pp4/4P3/3P1NP1/PPPN1P1P/R1BQKB1R w KQkq - f1g2", null, null],
  ["r1bqkb1r/pp3ppp/2n1pn2/2pp4/4P3/3P1NP1/PPPN1PBP/R1BQK2R b KQkq - f8e7", null, null],
  ["r1bqkb1r/pp3ppp/2n2n2/2pp4/3P4/2N2NP1/PP2PP1P/R1BQKB1R w KQkq - f1g2", null, null],
  ["r1bqkb1r/pp3ppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQK2R b KQkq - c5d4", null, null],
  ["r1bqkb1r/pp3ppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQK2R b KQkq - c8g4", "D33", "Tarrasch Defense: Wagner Variation"],
  [
    "r1bqkb1r/pp3ppp/2n2n2/2pp4/3P4/2N2NP1/PP2PPBP/R1BQK2R b KQkq - f8e7",
    "D34",
    "Tarrasch Defense: Prague Variation, Main Line",
  ],
  ["r1bqkb1r/pp3ppp/2n2n2/2pp4/3P4/5NP1/PP2PPBP/RNBQ1RK1 b kq - f8e7", null, null],
  ["r1bqkb1r/pp3ppp/2n2n2/2pp4/3P4/5NP1/PP2PPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqkb1r/pp3ppp/2n2n2/3p4/3N4/2N3P1/PP2PPBP/R1BQK2R b KQkq - f8c5", "D33", "Tarrasch Defense: Dubov Tarrasch"],
  ["r1bqkb1r/pp3ppp/2n2n2/3p4/3p4/2N2NP1/PP2PPBP/R1BQK2R w KQkq - f3d4", null, null],
  ["r1bqkb1r/pp3ppp/2np1n2/1N2p1B1/4P3/2N5/PPP2PPP/R2QKB1R b KQkq - a7a6", null, null],
  ["r1bqkb1r/pp3ppp/2np1n2/1N2p3/4P3/2N5/PPP2PPP/R1BQKB1R w KQkq - c1g5", null, null],
  [
    "r1bqkb1r/pp3ppp/2np1n2/4p3/3NP3/2N5/PPP1BPPP/R1BQK2R w KQkq - d4b3",
    "B59",
    "Sicilian Defense: Boleslavsky Variation",
  ],
  [
    "r1bqkb1r/pp3ppp/2np1n2/4p3/3NP3/2N5/PPP1BPPP/R1BQK2R w KQkq - d4c6",
    "B58",
    "Sicilian Defense: Boleslavsky Variation, Louma Variation",
  ],
  ["r1bqkb1r/pp3ppp/2nppn2/1N6/2P1P3/2N5/PP3PPP/R1BQKB1R b KQkq - a7a6", null, null],
  ["r1bqkb1r/pp3ppp/2nppn2/1N6/2P1P3/8/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R w KQkq - d1d2",
    "B63",
    "Sicilian Defense: Richter-Rauzer Variation, Traditional Variation",
  ],
  [
    "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R w KQkq - d1d3",
    "B62",
    "Sicilian Defense: Richter-Rauzer Variation",
  ],
  [
    "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R w KQkq - d4b3",
    "B62",
    "Sicilian Defense: Richter-Rauzer Variation, Podebrady Variation",
  ],
  [
    "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R w KQkq - d4c6",
    "B62",
    "Sicilian Defense: Richter-Rauzer Variation, Exchange Variation",
  ],
  [
    "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R w KQkq - f1b5",
    "B62",
    "Sicilian Defense: Richter-Rauzer Variation, Vitolins Variation",
  ],
  [
    "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R b KQkq - a7a6",
    "B66",
    "Sicilian Defense: Richter-Rauzer Variation, Neo-Modern Variation, Early Deviations",
  ],
  [
    "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R b KQkq - d8b6",
    "B63",
    "Sicilian Defense: Richter-Rauzer Variation, Ivanov Variation",
  ],
  [
    "r1bqkb1r/pp3ppp/2nppn2/6B1/3NP3/2N5/PPPQ1PPP/R3KB1R b KQkq - f8e7",
    "B63",
    "Sicilian Defense: Richter-Rauzer Variation, Classical Variation",
  ],
  ["r1bqkb1r/pp3ppp/2nppn2/8/2BNP3/2N1B3/PPP2PPP/R2QK2R b KQkq - f8e7", null, null],
  [
    "r1bqkb1r/pp3ppp/2nppn2/8/2BNP3/2N5/PPP2PPP/R1BQK2R w KQkq - c1e3",
    "B89",
    "Sicilian Defense: Sozin Attack, Main Line",
  ],
  ["r1bqkb1r/pp3ppp/2nppn2/8/2BNP3/2N5/PPP2PPP/R1BQK2R w KQkq - c4b3", null, null],
  ["r1bqkb1r/pp3ppp/2nppn2/8/3NP3/1BN5/PPP2PPP/R1BQK2R b KQkq - f8e7", null, null],
  ["r1bqkb1r/pp3ppp/2nppn2/8/3NPP2/2N1B3/PPP3PP/R2QKB1R b KQkq - f8e7", null, null],
  ["r1bqkb1r/pp3ppp/2nppn2/8/3NPP2/2N5/PPP3PP/R1BQKB1R w KQkq - c1e3", null, null],
  ["r1bqkb1r/pp3ppp/2p2n2/nB1Pp1N1/8/8/PPPP1PPP/RNBQK2R w KQkq - d5c6", null, null],
  ["r1bqkb1r/pp3ppp/2P2n2/nB2p1N1/8/8/PPPP1PPP/RNBQK2R b KQkq - b7c6", null, null],
  ["r1bqkb1r/ppp1pppp/1nn5/4P3/2PP4/4B3/PP4PP/RN1QKBNR b KQkq - c8f5", null, null],
  ["r1bqkb1r/ppp1pppp/1nn5/4P3/2PP4/5N2/PP4PP/RNBQKB1R b KQkq - c8g4", null, null],
  [
    "r1bqkb1r/ppp1pppp/1nn5/4P3/2PP4/8/PP4PP/RNBQKBNR w KQkq - c1e3",
    "B03",
    "Alekhine Defense: Four Pawns Attack, Main Line",
  ],
  ["r1bqkb1r/ppp1pppp/1nn5/4P3/2PP4/8/PP4PP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "r1bqkb1r/ppp1pppp/2np3n/4P3/3P4/5N1P/PPP2PP1/RNBQKB1R w KQkq - e5d6",
    "B00",
    "Nimzowitsch Defense: El Columpio Defense, Exchange Variation",
  ],
  [
    "r1bqkb1r/ppp1pppp/2np3n/4P3/3P4/5N1P/PPP2PP1/RNBQKB1R w KQkq - e5e6",
    "B00",
    "Nimzowitsch Defense: El Columpio Defense, El Columpio Gambit",
  ],
  [
    "r1bqkb1r/ppp1pppp/2np3n/4P3/3P4/5N1P/PPP2PP1/RNBQKB1R w KQkq - f1b5",
    "B00",
    "Nimzowitsch Defense: El Columpio Defense, Pin Variation",
  ],
  ["r1bqkb1r/ppp1pppp/2np4/4P3/3P2n1/5N1P/PPP2PP1/RNBQKB1R b KQkq - g4h6", null, null],
  ["r1bqkb1r/ppp1pppp/2np4/4P3/3P2n1/5N2/PPP2PPP/RNBQKB1R w KQkq - h2h3", null, null],
  ["r1bqkb1r/ppp2Npp/2n5/3np3/2B5/8/PPPP1PPP/RNBQK2R b KQkq - e8f7", null, null],
  ["r1bqkb1r/ppp2pp1/5n1p/3P4/2n1p3/3P1N2/PPP1QPPP/RNB1K2R w KQkq - d3c4", null, null],
  ["r1bqkb1r/ppp2pp1/5n1p/3P4/2P1p3/5N2/PPP1QPPP/RNB1K2R b KQkq - f8c5", null, null],
  [
    "r1bqkb1r/ppp2pp1/5n1p/3P4/2P1p3/5N2/PPP1QPPP/RNB1K2R b KQkq - f8e7",
    "C58",
    "Italian Game: Two Knights Defense, Maróczy Variation",
  ],
  ["r1bqkb1r/ppp2pp1/5n1p/n2P4/2B1p3/3P1N2/PPP1QPPP/RNB1K2R b KQkq - a5c4", null, null],
  ["r1bqkb1r/ppp2pp1/5n1p/n2P4/2B1p3/3P1N2/PPP2PPP/RNBQK2R w KQkq - d1e2", null, null],
  ["r1bqkb1r/ppp2pp1/5n1p/n2Pp1N1/2B5/3P4/PPP2PPP/RNBQK2R w KQkq - g5f3", null, null],
  ["r1bqkb1r/ppp2pp1/5n1p/n2Pp3/2B5/3P1N2/PPP2PPP/RNBQK2R b KQkq - e5e4", null, null],
  [
    "r1bqkb1r/ppp2ppp/2n1pn2/3p4/4P3/3P1N2/PPPN1PPP/R1BQKB1R w KQkq - f1e2",
    "C00",
    "French Defense: Reversed Philidor Formation",
  ],
  ["r1bqkb1r/ppp2ppp/2n1pn2/8/2pP4/5NP1/PP2PPBP/RNBQK2R w KQkq - d1a4", null, null],
  [
    "r1bqkb1r/ppp2ppp/2n1pn2/8/Q1pP4/5NP1/PP2PPBP/RNB1K2R b KQkq - f8b4",
    "E04",
    "Catalan Opening: Open Defense, Modern Sharp Variation",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n2n2/1B1pP3/3p4/5N2/PPP2PPP/RNBQK2R b KQkq - f6e4",
    "C56",
    "Italian Game: Scotch Gambit, Max Lange Attack",
  ],
  ["r1bqkb1r/ppp2ppp/2n2n2/3pp1N1/2B1P3/8/PPPP1PPP/RNBQK2R w KQkq - e4d5", null, null],
  [
    "r1bqkb1r/ppp2ppp/2n2n2/3Pp1N1/2B5/8/PPPP1PPP/RNBQK2R b KQkq - b7b5",
    "C57",
    "Italian Game: Two Knights Defense, Ulvestad Variation",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n2n2/3Pp1N1/2B5/8/PPPP1PPP/RNBQK2R b KQkq - c6a5",
    "C58",
    "Italian Game: Two Knights Defense, Polerio Defense",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n2n2/3Pp1N1/2B5/8/PPPP1PPP/RNBQK2R b KQkq - c6b4",
    "C57",
    "Italian Game: Two Knights Defense, Kloss Gambit",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n2n2/3Pp1N1/2B5/8/PPPP1PPP/RNBQK2R b KQkq - c6d4",
    "C57",
    "Italian Game: Two Knights Defense, Fritz Variation",
  ],
  ["r1bqkb1r/ppp2ppp/2n2n2/3Pp1N1/2B5/8/PPPP1PPP/RNBQK2R b KQkq - f6d5", null, null],
  ["r1bqkb1r/ppp2ppp/2n2n2/3pP3/2Bp4/5N2/PPP2PPP/RNBQK2R w KQkq d6 c4b5", null, null],
  ["r1bqkb1r/ppp2ppp/2n2n2/3pp3/2P5/2N2NP1/PP1PPP1P/R1BQKB1R w KQkq - c4d5", null, null],
  ["r1bqkb1r/ppp2ppp/2n2n2/3pp3/4P3/2N2NP1/PPPP1P1P/R1BQKB1R w KQkq - e4d5", null, null],
  [
    "r1bqkb1r/ppp2ppp/2n2n2/3pp3/4P3/2PP1N2/PP3PPP/RNBQKB1R w KQkq - b1d2",
    "C44",
    "Ponziani Opening: Jaenisch Counterattack",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n2n2/3pp3/4P3/3P1N2/PPP1BPPP/RNBQK2R w KQkq - b1d2",
    "C44",
    "King's Pawn Game: Tayler Opening, Inverted Hanham",
  ],
  ["r1bqkb1r/ppp2ppp/2n2n2/3Pp3/8/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - f6d5", null, null],
  ["r1bqkb1r/ppp2ppp/2n2n2/3Pp3/8/2N2NP1/PPPP1P1P/R1BQKB1R b KQkq - f6d5", null, null],
  ["r1bqkb1r/ppp2ppp/2n2n2/3pp3/8/P2P2P1/1PP1PPBP/RNBQK1NR w KQkq - b1d2", null, null],
  ["r1bqkb1r/ppp2ppp/2n2n2/3pp3/8/P2P2P1/1PPNPPBP/R1BQK1NR b KQkq - f8d6", null, null],
  ["r1bqkb1r/ppp2ppp/2n2n2/3pp3/8/PPPP4/4PPPP/RNBQKBNR w KQkq - e2e3", null, null],
  ["r1bqkb1r/ppp2ppp/2n2n2/3pp3/8/PPPPP3/5PPP/RNBQKBNR b KQkq - f8d6", null, null],
  ["r1bqkb1r/ppp2ppp/2n5/1B1pP3/3Nn3/8/PPP2PPP/RNBQK2R b KQkq - f8c5", null, null],
  ["r1bqkb1r/ppp2ppp/2n5/1B1pP3/3pn3/5N2/PPP2PPP/RNBQK2R w KQkq - f3d4", null, null],
  ["r1bqkb1r/ppp2ppp/2n5/3B4/3pn3/5N2/PPP2PPP/RNBQR1K1 b kq - d8d5", null, null],
  [
    "r1bqkb1r/ppp2ppp/2n5/3np1N1/2B5/8/PPPP1PPP/RNBQK2R w KQkq - d2d4",
    "C57",
    "Italian Game: Two Knights Defense, Lolli Attack",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n5/3np1N1/2B5/8/PPPP1PPP/RNBQK2R w KQkq - g5f7",
    "C57",
    "Italian Game: Two Knights Defense, Fried Liver Attack",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n5/3np1N1/2BP4/8/PPP2PPP/RNBQK2R b KQkq - f8b4",
    "C57",
    "Italian Game: Two Knights Defense, Pincus Variation",
  ],
  ["r1bqkb1r/ppp2ppp/2n5/3np3/8/2N2NP1/PP1PPP1P/R1BQKB1R w KQkq - f1g2", null, null],
  [
    "r1bqkb1r/ppp2ppp/2n5/3np3/8/2N2NP1/PP1PPPBP/R1BQK2R b KQkq - d5b6",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line, with Nb6",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n5/3np3/8/2N2NP1/PP1PPPBP/R1BQK2R b KQkq - f8c5",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line, with Bc5",
  ],
  ["r1bqkb1r/ppp2ppp/2n5/3np3/8/2N2NP1/PPPP1P1P/R1BQKB1R w KQkq - f1g2", null, null],
  ["r1bqkb1r/ppp2ppp/2n5/3np3/8/2N2NP1/PPPP1PBP/R1BQK2R b KQkq - d5c3", null, null],
  ["r1bqkb1r/ppp2ppp/2n5/3np3/8/3P1NP1/PP2PPBP/RNBQK2R b KQkq - f8e7", null, null],
  [
    "r1bqkb1r/ppp2ppp/2n5/3np3/8/5NP1/PP1PPPBP/RNBQK2R w KQkq - d2d3",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line",
  ],
  [
    "r1bqkb1r/ppp2ppp/2n5/3p4/2Bpn3/5N2/PPP2PPP/RNBQR1K1 w kq - b1c3",
    "C56",
    "Italian Game: Scotch Gambit, Canal Variation",
  ],
  ["r1bqkb1r/ppp2ppp/2n5/3p4/2Bpn3/5N2/PPP2PPP/RNBQR1K1 w kq - c4d5", null, null],
  ["r1bqkb1r/ppp2ppp/2n5/3p4/3Pn3/3B1N2/PPP2PPP/RNBQ1RK1 b kq - f8e7", null, null],
  ["r1bqkb1r/ppp2ppp/2n5/3p4/3Pn3/3B1N2/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqkb1r/ppp2ppp/2n5/4p3/8/2n2NP1/PPPP1PBP/R1BQK2R w KQkq - b2c3", "C47", "Four Knights Game: Glek System"],
  ["r1bqkb1r/ppp2ppp/2np1n2/1B2p3/3PP3/5N2/PPP2PPP/RNBQ1RK1 b kq - c8d7", null, null],
  [
    "r1bqkb1r/ppp2ppp/2np1n2/1B2p3/3PP3/5N2/PPP2PPP/RNBQ1RK1 b kq - f6d7",
    "C66",
    "Ruy Lopez: Closed Berlin Defense, Chigorin Variation",
  ],
  [
    "r1bqkb1r/ppp2ppp/2np1n2/1B2p3/4P3/3P1N2/PPP2PPP/RNBQK2R w KQkq - b5c6",
    "C65",
    "Ruy Lopez: Berlin Defense, Anti-Berlin Variation, Anderssen Variation",
  ],
  [
    "r1bqkb1r/ppp2ppp/2np1n2/1B2p3/4P3/3P1N2/PPP2PPP/RNBQK2R w KQkq - c2c4",
    "C65",
    "Ruy Lopez: Berlin Defense, Anti-Berlin Variation, Duras Variation",
  ],
  ["r1bqkb1r/ppp2ppp/2np1n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d2d4", null, null],
  ["r1bqkb1r/ppp2ppp/2np1n2/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR w KQkq - d2d3", null, null],
  ["r1bqkb1r/ppp2ppp/2np1n2/4p3/2P5/2NP2P1/PP2PPBP/R1BQK1NR b KQkq - f8e7", null, null],
  [
    "r1bQkb1r/ppp2ppp/2p5/4Pn2/8/5N2/PPP2PPP/RNB2RK1 b kq - e8d8",
    "C67",
    "Ruy Lopez: Berlin Defense, l'Hermet Variation, Berlin Wall Defense",
  ],
  ["r1bqkb1r/ppp2ppp/2p5/4Pn2/8/5N2/PPP2PPP/RNBQ1RK1 w kq - d1d8", null, null],
  ["r1bqkb1r/ppp2ppp/2pn4/4p3/3P4/5N2/PPP2PPP/RNBQ1RK1 w kq - d4e5", null, null],
  [
    "r1bqkb1r/ppp2ppp/2pn4/4P3/8/5N2/PPP2PPP/RNBQ1RK1 b kq - d6e4",
    "C67",
    "Ruy Lopez: Berlin Defense, l'Hermet Variation, Westerinen Line",
  ],
  ["r1bqkb1r/ppp2ppp/2pn4/4P3/8/5N2/PPP2PPP/RNBQ1RK1 b kq - d6f5", null, null],
  [
    "r1bqkb1r/ppp2ppp/4pn2/8/3P4/5N2/PPP2PPP/R1BQKB1R w KQkq - c2c3",
    "C10",
    "French Defense: Rubinstein Variation, Kasparov Attack",
  ],
  [
    "r1bqkb1r/ppp2ppp/4pn2/8/3P4/5N2/PPP2PPP/R1BQKB1R w KQkq - f3e5",
    "C10",
    "French Defense: Rubinstein Variation, Capablanca Line",
  ],
  ["r1bqkb1r/ppp2ppp/5n2/3Pp1N1/2Bn4/2P5/PP1P1PPP/RNBQK2R b KQkq - b7b5", null, null],
  ["r1bqkb1r/ppp2ppp/5n2/3Pp1N1/2Bn4/8/PPPP1PPP/RNBQK2R w KQkq - c2c3", null, null],
  ["r1bqkb1r/ppp2ppp/5n2/n2Pp1N1/2B5/3P4/PPP2PPP/RNBQK2R b KQkq - h7h6", null, null],
  [
    "r1bqkb1r/ppp2ppp/5n2/n2Pp1N1/2B5/8/PPPP1PPP/RNBQK2R w KQkq - c4b5",
    "C58",
    "Italian Game: Two Knights Defense, Polerio Defense, Bishop Check Line",
  ],
  [
    "r1bqkb1r/ppp2ppp/5n2/n2Pp1N1/2B5/8/PPPP1PPP/RNBQK2R w KQkq - d2d3",
    "C58",
    "Italian Game: Two Knights Defense, Polerio Defense, Kieseritzky Variation",
  ],
  ["r1bqkb1r/ppp2ppp/5n2/nB1Pp1N1/8/8/PPPP1PPP/RNBQK2R b KQkq - c7c6", null, null],
  ["r1bqkb1r/pppn1p1p/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQK2R b KQkq - f8g7", null, null],
  ["r1bqkb1r/pppn1p1p/3p1np1/4p3/2PPP3/2N2N2/PP3PPP/R1BQKB1R w KQkq - f1e2", null, null],
  ["r1bqkb1r/pppn1pp1/4pn1p/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - g5h4", null, null],
  [
    "r1bqkb1r/pppn1pp1/4pn1p/3p4/2PP3B/2N2N2/PP2PPPP/R2QKB1R b KQkq - d5c4",
    "D37",
    "Queen's Gambit Declined: Knight Defense, Alekhine Gambit",
  ],
  ["r1bqkb1r/pppn1ppp/3p1n2/4p3/2BPP3/2N2N2/PPP2PPP/R1BQK2R b KQkq - f8e7", null, null],
  [
    "r1bqkb1r/pppn1ppp/3p1n2/4p3/2PP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - f1d3",
    "A54",
    "Old Indian Defense: Duz-Khotimirsky Variation",
  ],
  ["r1bqkb1r/pppn1ppp/3p1n2/4p3/2PPP3/2N2N2/PP3PPP/R1BQKB1R b KQkq - g7g6", null, null],
  [
    "r1bqkb1r/pppn1ppp/3p1n2/4p3/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3",
    "A55",
    "Old Indian Defense: Normal Variation",
  ],
  ["r1bqkb1r/pppn1ppp/3p1n2/4p3/3PP3/2N2N2/PPP1BPPP/R1BQK2R b KQkq - f8e7", null, null],
  ["r1bqkb1r/pppn1ppp/3p1n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f1c4", null, null],
  ["r1bqkb1r/pppn1ppp/3p1n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f1e2", null, null],
  [
    "r1bqkb1r/pppn1ppp/3p1n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - g2g4",
    "C41",
    "Philidor Defense: Lion Variation, Shirov Gambit",
  ],
  ["r1bqkb1r/pppn1ppp/3p1n2/4p3/3PPP2/2N2N2/PPP3PP/R1BQKB1R b KQkq - e5d4", null, null],
  ["r1bqkb1r/pppn1ppp/3p1n2/4p3/3PPP2/2N5/PPP3PP/R1BQKBNR w KQkq - g1f3", null, null],
  ["r1bqkb1r/pppn1ppp/3p1n2/8/3pPP2/2N2N2/PPP3PP/R1BQKB1R w KQkq - d1d4", null, null],
  ["r1bqkb1r/pppn1ppp/3p1n2/8/3QPP2/2N2N2/PPP3PP/R1B1KB1R b KQkq - c7c6", null, null],
  [
    "r1bqkb1r/pppn1ppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR b KQkq - c7c6",
    "D51",
    "Queen's Gambit Declined: Modern Variation, Knight Defense",
  ],
  [
    "r1bqkb1r/pppn1ppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR b KQkq - f8b4",
    "D51",
    "Queen's Gambit Declined: Manhattan Variation",
  ],
  ["r1bqkb1r/pppn1ppp/4pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - c7c6", null, null],
  ["r1bqkb1r/pppn1ppp/4pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - h7h6", null, null],
  [
    "r1bqkb1r/pppn1ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR w KQkq - e2e3",
    "D51",
    "Queen's Gambit Declined: Modern Variation, Knight Defense",
  ],
  ["r1bqkb1r/pppn1ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR w KQkq - g1f3", null, null],
  ["r1bqkb1r/pppn1ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5", null, null],
  ["r1bqkb1r/pppn1ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c4d5", null, null],
  ["r1bqkb1r/pppn1ppp/4pn2/3P4/3P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e6d5", null, null],
  ["r1bqkb1r/pppn1ppp/4pn2/8/2QP4/6P1/PP2PPBP/RNB1K1NR b KQkq - a7a6", null, null],
  ["r1bqkb1r/pppn1ppp/4pN2/8/3P4/5N2/PPP2PPP/R1BQKB1R b KQkq - d7f6", null, null],
  ["r1bqkb1r/pppn1ppp/4pn2/8/3PN3/5N2/PPP2PPP/R1BQKB1R w KQkq - e4f6", null, null],
  ["r1bqkb1r/pppn1ppp/4pn2/8/Q1pP4/6P1/PP2PPBP/RNB1K1NR w KQkq - a4c4", "E03", "Catalan Opening: Open Defense"],
  [
    "r1bqkb1r/pppn1ppp/5n2/3p4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1f4",
    "D35",
    "Queen's Gambit Declined: Exchange Variation, Sämisch Variation",
  ],
  ["r1bqkb1r/pppnpppp/3p1n2/8/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["r1bqkb1r/pppnpppp/3p1n2/8/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - e7e5", null, null],
  ["r1bqkb1r/pppnpppp/3p1n2/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - e7e5", "C41", "Philidor Defense: Lion Variation"],
  ["r1bqkb1r/pppnpppp/3p1n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f4", "B07", "Lion Defense: Anti-Philidor"],
  ["r1bqkb1r/pppnpppp/3p1n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["r1bqkb1r/pppnpppp/3p1n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g2g4", "B07", "Lion Defense: Bayonet Attack"],
  [
    "r1bqkb1r/pppnpppp/3p1n2/8/3PPP2/2N5/PPP3PP/R1BQKBNR b KQkq - e7e5",
    "B07",
    "Lion Defense: Anti-Philidor, Lion's Cave",
  ],
  [
    "r1bqkb1r/pppnpppp/5n2/3p2B1/3P4/2N2N2/PPP1PPPP/R2QKB1R b KQkq - g7g6",
    "D01",
    "Richter-Veresov Attack: Two Knights System, Grünfeld Defense",
  ],
  [
    "r1bqkb1r/pppnpppp/5n2/3p2B1/3P4/2N5/PPP1PPPP/R2QKBNR w KQkq - g1f3",
    "D01",
    "Richter-Veresov Attack: Two Knights System",
  ],
  ["r1bqkb1r/pppp1p1p/2n3pn/4p2Q/2B1P3/3P4/PPP2PPP/RNB1K1NR w KQkq - h5f3", null, null],
  ["r1bqkb1r/pppp1p1p/2n3pn/4p3/2B1P3/3P1Q2/PPP2PPP/RNB1K1NR b KQkq - f7f6", null, null],
  ["r1bqkb1r/pppp1p1p/2n3pn/4p3/2P5/2N3P1/PP1PPP1P/1RBQKBNR w Kkq - f1g2", null, null],
  [
    "r1bqkb1r/pppp1p1p/2n3pn/4p3/2P5/2N3P1/PP1PPPBP/1RBQK1NR b Kkq - f8g7",
    "A25",
    "English Opening: Closed, Taimanov Variation",
  ],
  ["r1bqkb1r/pppp1p1p/2nn2p1/1N2p2Q/8/1B6/PPPP1PPP/R1B1K1NR w KQkq - h5f3", null, null],
  ["r1bqkb1r/pppp1p1p/2nn2p1/1N2p3/8/1B3Q2/PPPP1PPP/R1B1K1NR b KQkq - f7f5", null, null],
  ["r1bqkb1r/pppp1ppp/2Bn4/4p3/3P4/5N2/PPP2PPP/RNBQ1RK1 b kq - d7c6", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/1B2p3/3PP3/5N2/PPP2PPP/RNBQK2R b KQkq - e5d4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - a7a6", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - c6d4",
    "C48",
    "Four Knights Game: Spanish Variation, Rubinstein Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - f8b4",
    "C49",
    "Four Knights Game: Spanish Variation, Double Spanish",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - f8c5",
    "C48",
    "Four Knights Game: Spanish Variation, Classical Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - c6e7",
    "C65",
    "Ruy Lopez: Berlin Defense, Anti-Berlin Variation, Mortimer Variation",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - d7d6", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - f8c5", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - d7d6",
    "C66",
    "Ruy Lopez: Berlin Defense, Improved Steinitz Defense",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f6e4",
    "C67",
    "Ruy Lopez: Berlin Defense, Rio Gambit Accepted",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f6g4",
    "C65",
    "Ruy Lopez: Berlin Defense, Fishing Pole Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f8c5",
    "C65",
    "Ruy Lopez: Berlin Defense, Beverwijk Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d3",
    "C65",
    "Ruy Lopez: Berlin Defense, Anti-Berlin Variation",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1", "C65", "Ruy Lopez: Berlin Defense"],
  ["r1bqkb1r/pppp1ppp/2n2n2/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - f3e5", "C65", "Ruy Lopez: Halloween Attack"],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/1B6/3pP3/5N2/PPP2PPP/RNBQK2R w KQkq - e1g1",
    "C65",
    "Ruy Lopez: Berlin Defense, Nyholm Attack",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/3N4/3pP3/5N2/PPP2PPP/R1BQKB1R b KQkq - f6e4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/3P4/4P3/2N5/PPP2PPP/R1BQKB1R b KQkq - c6e5", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4N3/4P3/2N5/PPPP1PPP/R1BQKB1R b KQkq - c6e5", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - e5c6", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p1N1/2B1P3/8/PPPP1PPP/RNBQK2R b KQkq - d7d5",
    "C57",
    "Italian Game: Two Knights Defense, Knight Attack, Normal Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p1N1/2B1P3/8/PPPP1PPP/RNBQK2R b KQkq - f6e4",
    "C57",
    "Italian Game: Two Knights Defense, Ponziani-Steinitz Gambit",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p1N1/2B1P3/8/PPPP1PPP/RNBQK2R b KQkq - f8c5",
    "C57",
    "Italian Game: Two Knights Defense, Traxler Counterattack",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - f6e4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR w KQkq - d2d3", "C24", "Bishop's Opening: Vienna Hybrid"],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR w KQkq - f2f4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR b KQkq - f8b4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/2NP4/PPP2PPP/R1BQK1NR b KQkq - f8c5", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - f8c5",
    "C50",
    "Italian Game: Giuoco Pianissimo, Normal",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - f8e7",
    "C55",
    "Italian Game: Two Knights Defense, Modern Bishop's Opening",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/3P4/PPP2PPP/RNBQK1NR w KQkq - b1c3", "C24", "Bishop's Opening: Vienna Hybrid"],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f8c5", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b1c3",
    "C47",
    "Four Knights Game: Italian Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d3",
    "C55",
    "Italian Game: Two Knights Defense, Modern Bishop's Opening",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4",
    "C56",
    "Italian Game: Two Knights Defense, Open Variation",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - f3g5",
    "C57",
    "Italian Game: Two Knights Defense, Knight Attack",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2B1PP2/2N5/PPPP2PP/R1BQK1NR b KQkq - f6e4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4P3/2Bp4/5N2/PPP2PPP/RNBQK2R b KQkq - d7d5", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4P3/2Bp4/5N2/PPP2PPP/RNBQK2R b KQkq - f6g4",
    "C44",
    "Scotch Game: Scotch Gambit, Kingside Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R b KQkq - d7d6",
    "C56",
    "Italian Game: Scotch Invitation Declined",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R b KQkq - e5d4",
    "C44",
    "Scotch Game: Scotch Gambit, Dubois Réti Defense",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2P1P3/5N2/PP1P1PPP/RNBQKB1R w KQkq - f3e5", "C44", "Dresden Opening: The Goblin"],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N1PN2/PP1P1PPP/R1BQKB1R b KQkq - f8b4", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - a2a3",
    "A28",
    "English Opening: King's English Variation, Four Knights Variation, Korchnoi Line",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - d2d3",
    "A28",
    "English Opening: King's English Variation, Four Knights Variation, Flexible Line",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - d2d4", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - e2e3",
    "A28",
    "English Opening: King's English Variation, Four Knights Variation, Quiet Line",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - e2e4",
    "A28",
    "English Opening: Four Knights System, Nimzowitsch Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - g2g3",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - d7d5", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - f8c5", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - d7d6", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e5d4", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e5e4",
    "A28",
    "English Opening: King's English Variation, Four Knights Variation, Bradley Beach Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - e5d4",
    "C47",
    "Four Knights Game: Scotch Variation Accepted",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - f8b4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/3PP3/2P2N2/PP3PPP/RNBQKB1R b KQkq - f6e4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/3PP3/5N2/PPP1BPPP/RNBQK2R b KQkq - e5d4", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - a2a3",
    "C47",
    "Four Knights Game: Gunsberg Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - c3d5",
    "C47",
    "Four Knights Game: Naroditsky Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - d2d4",
    "C47",
    "Four Knights Game: Scotch Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - f1b5",
    "C48",
    "Four Knights Game: Spanish Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - f3e5",
    "C47",
    "Four Knights Game: Halloween Gambit",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - g2g3", "C47", "Four Knights Game: Glek System"],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N2NP1/PPPP1P1P/R1BQKB1R b KQkq - d7d5", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2N3P1/PPPP1PBP/R1BQK1NR b KQkq - f8c5", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - d2d3",
    "C44",
    "Ponziani Opening: Jaenisch Counterattack",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - f1c4", "C44", "Ponziani Opening: Neumann Gambit"],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2P2N2/PP1PQPPP/RNB1KB1R b KQkq - f8c5", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2P5/PP1PQPPP/RNB1KBNR w KQkq - g1f3", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/2PP1N2/PP3PPP/RNBQKB1R b KQkq - d7d5",
    "C44",
    "Ponziani Opening: Jaenisch Counterattack",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/3P1N2/PPP1BPPP/RNBQK2R b KQkq - d7d5", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/5N2/PPPPBPPP/RNBQK2R w KQkq - d2d3", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/5N2/PPPPBPPP/RNBQK2R w KQkq - d2d4", "C44", "King's Pawn Game: Tayler Opening"],
  ["r1bqkb1r/pppp1ppp/2n2n2/4p3/4P3/5N2/PPPPQPPP/RNB1KB1R w KQkq - d2d4", "C42", "Petrov's Defense: Moody Gambit"],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - f8b4",
    "C44",
    "Scotch Game: Göring Gambit, Bardeleben Variation",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/2B1P3/2p2N2/PP3PPP/RNBQK2R w KQkq - b1c3", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQ1RK1 b kq - d7d6",
    "C56",
    "Italian Game: Scotch Gambit, Janowski Defense",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQ1RK1 b kq - f6e4",
    "C56",
    "Italian Game: Scotch Gambit, Double Gambit Accepted",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQ1RK1 b kq - f8c5",
    "C56",
    "Italian Game: Scotch Gambit, Max Lange Attack",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQ1RK1 b kq - f8e7",
    "C56",
    "Italian Game: Scotch Gambit, de Riviere Defense",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - e1g1", "C56", "Italian Game: Scotch Gambit"],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - e4e5",
    "C44",
    "Scotch Game: Scotch Gambit, Advance Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - f3g5",
    "C56",
    "Italian Game: Two Knights Defense, Perreux Variation",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/2PN4/2N5/PP2PPPP/R1BQKB1R b KQkq - f8b4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/2Pp4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - f3d4", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - f6e4",
    "C47",
    "Four Knights Game: Scotch Variation, Schmid Defense",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - f8b4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - d4c6", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - e4e5", "C45", "Scotch Game: Alekhine Gambit"],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/3pP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - c3d5",
    "C47",
    "Four Knights Game: Scotch Variation, Belgrade Gambit",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/3pP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f3d4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/3PP3/2N5/PPP2PPP/R1BQKB1R w KQkq - d4d5", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n2n2/8/3pP3/5N2/PPP1BPPP/RNBQK2R w KQkq - e4e5",
    "C44",
    "King's Pawn Game: Tayler Opening, Basman Gambit",
  ],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/4P3/2N1Q3/PPP2PPP/R1B1KBNR b KQkq - f8b4", null, null],
  ["r1bqkb1r/pppp1ppp/2n2n2/8/4P3/4Q3/PPP2PPP/RNB1KBNR w KQkq - b1c3", null, null],
  ["r1bqkb1r/pppp1ppp/2N2n2/8/4P3/8/PPP2PPP/RNBQKB1R b KQkq - b7c6", null, null],
  ["r1bqkb1r/pppp1ppp/2N2n2/8/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - d7c6", "C42", "Petrov's Defense: Stafford Gambit"],
  ["r1bqkb1r/pppp1ppp/2n4n/4p2Q/2B1P3/3P4/PPP2PPP/RNB1K1NR b KQkq - g7g6", null, null],
  ["r1bqkb1r/pppp1ppp/2n4n/4p2Q/2B1P3/8/PPPP1PPP/RNB1K1NR w KQkq - d2d3", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n5/1B2p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1 b kq - a7a6",
    "C67",
    "Ruy Lopez: Berlin Defense, Rosenthal Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n5/1B2p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1 b kq - e4d6",
    "C67",
    "Ruy Lopez: Berlin Defense, l'Hermet Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/2n5/1B2p3/3Pn3/5N2/PPP2PPP/RNBQ1RK1 b kq - f8e7",
    "C67",
    "Ruy Lopez: Berlin Defense, Rio de Janeiro Variation",
  ],
  ["r1bqkb1r/pppp1ppp/2n5/1B2p3/4n3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d2d4", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n5/3N4/3pn3/5N2/PPP1QPPP/R1B1KB1R b KQkq - f7f5",
    "C47",
    "Four Knights Game: Scotch Variation, Belgrade Gambit, Modern Defense",
  ],
  ["r1bqkb1r/pppp1ppp/2n5/3N4/3pn3/5N2/PPP2PPP/R1BQKB1R w KQkq - d1e2", null, null],
  ["r1bqkb1r/pppp1ppp/2n5/3Pp3/4n3/2P2N2/PP3PPP/RNBQKB1R b KQkq - f8c5", "C44", "Ponziani Opening: Vukovic Gambit"],
  ["r1bqkb1r/pppp1ppp/2n5/4p3/2B1n3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - c3e4", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n5/4p3/2B1n3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - c4f7",
    "C47",
    "Four Knights Game: Italian Variation, Noa Gambit",
  ],
  ["r1bqkb1r/pppp1ppp/2n5/4p3/2B1N3/5N2/PPPP1PPP/R1BQK2R b KQkq - d7d5", "C55", "Italian Game: Two Knights Defense"],
  [
    "r1bqkb1r/pppp1ppp/2n5/4p3/2B1nP2/2N5/PPPP2PP/R1BQK1NR w KQkq - g1f3",
    "C28",
    "Vienna Game: Stanley Variation, Bronstein Gambit",
  ],
  ["r1bqkb1r/pppp1ppp/2n5/4p3/3Pn3/2P2N2/PP3PPP/RNBQKB1R w KQkq - d4d5", null, null],
  [
    "r1bqkb1r/pppp1ppp/2n5/8/2Bpn3/5N2/PPP2PPP/RNBQ1RK1 w kq - b1c3",
    "C56",
    "Italian Game: Scotch Gambit, Nakhmanson Gambit",
  ],
  ["r1bqkb1r/pppp1ppp/2n5/8/2Bpn3/5N2/PPP2PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r1bqkb1r/pppp1ppp/2n5/8/2Bpn3/5N2/PPP2PPP/RNBQR1K1 b kq - d7d5", null, null],
  [
    "r1bqkb1r/pppp1ppp/2nn4/1B2p3/3P4/5N2/PPP2PPP/RNBQ1RK1 w kq - b5a4",
    "C67",
    "Ruy Lopez: Open Berlin Defense, Showalter Variation",
  ],
  ["r1bqkb1r/pppp1ppp/2nn4/1B2p3/3P4/5N2/PPP2PPP/RNBQ1RK1 w kq - b5c6", null, null],
  [
    "r1bqkb1r/pppp1ppp/2nn4/1B2p3/3P4/5N2/PPP2PPP/RNBQ1RK1 w kq - d4e5",
    "C67",
    "Ruy Lopez: Open Berlin Defense, l'Hermet Variation",
  ],
  ["r1bqkb1r/pppp1ppp/2nn4/1N2p2Q/8/1B6/PPPP1PPP/R1B1K1NR b KQkq - g7g6", null, null],
  ["r1bqkb1r/pppp1ppp/2nn4/4p2Q/8/1BN5/PPPP1PPP/R1B1K1NR w KQkq - c3b5", null, null],
  ["r1bqkb1r/pppp1ppp/2nn4/4p2Q/8/1BN5/PPPP1PPP/R1B1K1NR w KQkq - d2d4", "C27", "Vienna Game: Adams' Gambit"],
  ["r1bqkb1r/pppp1ppp/5n2/1B2N3/3nP3/2N5/PPPP1PPP/R1BQK2R b KQkq - d8e7", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/1B2N3/3nP3/2N5/PPPP1PPP/R1BQK2R b KQkq - f8c5", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/1B2p3/3nP3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - b5a4", null, null],
  [
    "r1bqkb1r/pppp1ppp/5n2/1B2p3/3nP3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - b5e2",
    "C48",
    "Four Knights Game: Spanish Variation, Rubinstein Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/5n2/1B2p3/3nP3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - e1g1",
    "C48",
    "Four Knights Game: Spanish Variation, Rubinstein Variation, Henneberger Variation",
  ],
  [
    "r1bqkb1r/pppp1ppp/5n2/1B2p3/3nP3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - f3d4",
    "C48",
    "Four Knights Game: Spanish Variation, Rubinstein Variation Accepted",
  ],
  ["r1bqkb1r/pppp1ppp/5n2/1B2p3/3nP3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - f3e5", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/3Pn3/4P3/2N5/PPP2PPP/R1BQKB1R w KQkq - f2f4", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/3Pn3/4PP2/2N5/PPP3PP/R1BQKB1R b KQkq - e5g6", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/4n3/3PP3/2N5/PPP2PPP/R1BQKB1R b KQkq - e5c6", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/4n3/3PP3/2N5/PPP2PPP/R1BQKB1R b KQkq - e5g6", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/4n3/4P3/2N5/PPPP1PPP/R1BQKB1R w KQkq - d2d4", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/4p3/3nP3/2N2N2/PPPPBPPP/R1BQK2R b KQkq - d4f3", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/4p3/4P3/2N2B2/PPPP1PPP/R1BQK2R b KQkq - f8c5", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/4p3/4P3/2N2n2/PPPPBPPP/R1BQK2R w KQkq - e2f3", null, null],
  ["r1bqkb1r/pppp1ppp/5n2/4p3/B2nP3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - f8c5", null, null],
  ["r1bqkb1r/pppp1ppp/5nn1/3P4/4PP2/2N5/PPP3PP/R1BQKB1R w KQkq - e4e5", null, null],
  ["r1bqkb1r/pppp1ppp/5nn1/3PP3/5P2/2N5/PPP3PP/R1BQKB1R b KQkq - f6g8", null, null],
  ["r1bqkb1r/pppp1ppp/5nn1/4P3/3P4/2N5/PPP2PPP/R1BQKB1R b KQkq - f6g8", null, null],
  ["r1bqkb1r/pppp1ppp/5nn1/8/3PP3/2N5/PPP2PPP/R1BQKB1R w KQkq - e4e5", null, null],
  [
    "r1bqkb1r/pppp3p/2n2ppn/4p3/2B1P3/3P1Q2/PPP1NPPP/RNB1K2R b KQkq - d7d5",
    "C20",
    "King's Pawn Game: Wayward Queen Attack, Mellon Gambit",
  ],
  ["r1bqkb1r/pppp3p/2n2ppn/4p3/2B1P3/3P1Q2/PPP2PPP/RNB1K1NR w KQkq - g1e2", null, null],
  ["r1bqkb1r/pppp3p/2nn2p1/1N1Qpp2/8/1B6/PPPP1PPP/R1B1K1NR b KQkq - d8e7", null, null],
  ["r1bqkb1r/pppp3p/2nn2p1/1N2pp2/8/1B3Q2/PPPP1PPP/R1B1K1NR w KQkq - f3d5", null, null],
  [
    "r1bqkb1r/ppppnppp/2n5/1B2p3/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - g7g6",
    "C60",
    "Ruy Lopez: Cozio Defense, Paulsen Variation",
  ],
  ["r1bqkb1r/ppppnppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b1c3", null, null],
  [
    "r1bqkb1r/ppppnppp/5n2/1B2N3/4P3/3P4/PPP2PPP/RNBQK2R b KQkq - c7c6",
    "C65",
    "Ruy Lopez: Berlin Defense, Anti-Berlin Variation, Mortimer Trap",
  ],
  ["r1bqkb1r/ppppnppp/5n2/1B2p3/4P3/3P1N2/PPP2PPP/RNBQK2R w KQkq - f3e5", null, null],
  ["r1bqkb1r/pppppppp/2n2n2/3P4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - c6e5", null, null],
  [
    "r1bqkb1r/pppppppp/2n2n2/4P3/8/5N2/PPPP1PPP/RNBQKB1R b KQkq - f6g4",
    "B00",
    "Nimzowitsch Defense: El Columpio Defense",
  ],
  ["r1bqkb1r/pppppppp/2n2n2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4d5", null, null],
  ["r1bqkb1r/pppppppp/2n2n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - e7e5", "B00", "Nimzowitsch Defense: Breyer Variation"],
  ["r1bqkb1r/pppppppp/2n2n2/8/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d4", null, null],
  ["r1bqkb1r/pppppppp/2n2n2/8/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - e4e5", null, null],
  ["r1bqkb1r/pppppppp/2n5/4P3/3P2n1/5N2/PPP2PPP/RNBQKB1R b KQkq - d7d6", null, null],
  ["r1bqkb1r/pppppppp/2n5/4P3/6n1/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["r1bqkb1r/pppppppp/5n2/3Pn3/2P5/8/PP2PPPP/RNBQKBNR w KQkq - f2f4", "A50", "Mexican Defense: Horsefly Gambit"],
  ["r1bqkbnr/1p1p1ppp/p1n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1 b kq - b7b5", null, null],
  ["r1bqkbnr/1p1p1ppp/p1n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1bqkbnr/1p1ppppp/p1n5/8/2PNP3/8/PP3PPP/RNBQKB1R b KQkq - e7e5",
    "B32",
    "Sicilian Defense: O'Kelly Variation, Maróczy Bind, Geller Line",
  ],
  ["r1bqkbnr/1p1ppppp/p1n5/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - c2c4", null, null],
  [
    "r1bqkbnr/1p2pppp/p1np4/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1 b kq - g8f6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Classical Formation",
  ],
  ["r1bqkbnr/1p2pppp/p1np4/8/2B1P3/2N2N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1bqkbnr/1p3ppp/p1npp3/8/2B1P3/2N2N2/PP2QPPP/R1B2RK1 b kq - b7b5",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Sozin Formation",
  ],
  ["r1bqkbnr/1p3ppp/p1npp3/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1 w kq - d1e2", null, null],
  [
    "r1bqkbnr/1pp2p1p/p1np2p1/4p3/B2PP3/2P2N2/PP3PPP/RNBQK2R b KQkq - c8d7",
    "C76",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense, Fianchetto Variation",
  ],
  ["r1bqkbnr/1pp2p1p/p1np2p1/4p3/B3P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r1bqkbnr/1pp2ppp/p1Bp4/4p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - b7c6", null, null],
  [
    "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - c8d7",
    "C75",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  [
    "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - f7f5",
    "C74",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense, Siesta Variation",
  ],
  ["r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - c8d7", null, null],
  ["r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - a4c6", null, null],
  [
    "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b1c3",
    "C71",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  [
    "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c3",
    "C74",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  [
    "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c4",
    "C71",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  [
    "r1bqkbnr/1pp2ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1",
    "C72",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  ["r1bqkbnr/1pp2ppp/p1p5/4p3/3PP3/5N2/PPP2PPP/RNBQK2R b KQkq - e5d4", null, null],
  ["r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - f7f6", null, null],
  ["r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - c8g4", null, null],
  [
    "r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - d8d6",
    "C69",
    "Ruy Lopez: Exchange Variation, Bronstein Variation",
  ],
  [
    "r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f7f6",
    "C69",
    "Ruy Lopez: Exchange Variation, Gligoric Variation",
  ],
  [
    "r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f8d6",
    "C69",
    "Ruy Lopez: Exchange Variation, King's Bishop Variation",
  ],
  [
    "r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b1c3",
    "C68",
    "Ruy Lopez: Exchange Variation, Keres Variation",
  ],
  ["r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4", null, null],
  [
    "r1bqkbnr/1pp2ppp/p1p5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1",
    "C69",
    "Ruy Lopez: Exchange Variation, Normal Variation",
  ],
  ["r1bqkbnr/1pp2ppp/p1p5/8/3pP3/5N2/PPP2PPP/RNBQK2R w KQkq - d1d4", null, null],
  ["r1bqkbnr/1pp2ppp/p1p5/8/3QP3/5N2/PPP2PPP/RNB1K2R b KQkq - d8d4", null, null],
  ["r1bqkbnr/1pp3pp/p1np4/4pp2/B3P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - e4f5", null, null],
  ["r1bqkbnr/1pp3pp/p1np4/4pP2/B7/2P2N2/PP1P1PPP/RNBQK2R b KQkq - c8f5", null, null],
  [
    "r1bqkbnr/1pp3pp/p1p2p2/4p3/4P3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - d2d3",
    "C68",
    "Ruy Lopez: Exchange Variation, Romanovsky Variation",
  ],
  ["r1bqkbnr/1ppp1p1p/p1n3p1/1B2p3/4P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - b5a4", null, null],
  ["r1bqkbnr/1ppp1p1p/p1n3p1/4p3/B3P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - d7d6", null, null],
  [
    "r1bqkbnr/1ppp1ppp/p1B5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - b7c6",
    "C68",
    "Ruy Lopez: Exchange Variation, Lutikov Variation",
  ],
  ["r1bqkbnr/1ppp1ppp/p1B5/4p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - d7c6", null, null],
  ["r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b5a4", null, null],
  ["r1bqkbnr/1ppp1ppp/p1n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b5c6", "C68", "Ruy Lopez: Exchange Variation"],
  [
    "r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - b7b5",
    "C70",
    "Ruy Lopez: Morphy Defense, Caro Variation",
  ],
  ["r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - c6d4", "C70", "Ruy Lopez: Bird's Defense Deferred"],
  [
    "r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - d7d6",
    "C71",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  [
    "r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f7f5",
    "C70",
    "Ruy Lopez: Morphy Defense, Schliemann Defense Deferred",
  ],
  [
    "r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f8b4",
    "C70",
    "Ruy Lopez: Morphy Defense, Alapin's Defense Deferred",
  ],
  [
    "r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f8c5",
    "C70",
    "Ruy Lopez: Morphy Defense, Classical Defense Deferred",
  ],
  [
    "r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g7g6",
    "C70",
    "Ruy Lopez: Morphy Defense, Fianchetto Defense Deferred",
  ],
  [
    "r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g8e7",
    "C70",
    "Ruy Lopez: Morphy Defense, Cozio Defense",
  ],
  ["r1bqkbnr/1ppp1ppp/p1n5/4p3/B3P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g8f6", null, null],
  [
    "r1bqkbnr/1ppp2pp/p1n5/4pp2/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e4f5",
    "C70",
    "Ruy Lopez: Morphy Defense, Schliemann Defense Deferred, Jaenisch Gambit Deferred",
  ],
  ["r1bqkbnr/2p2ppp/p1np4/1p2p3/3PP3/1B3N2/PPP2PPP/RNBQK2R b KQkq - c6d4", null, null],
  ["r1bqkbnr/2p2ppp/p1np4/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQK2R w KQkq - d2d4", null, null],
  [
    "r1bqkbnr/2p2ppp/p1pp4/4p3/3PP3/5N2/PPP2PPP/RNBQK2R b KQkq - f7f6",
    "C73",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  [
    "r1bqkbnr/2p2ppp/p1pp4/4p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4",
    "C73",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  ["r1bqkbnr/2p2ppp/p2p4/1p2p3/3nP3/1B3N2/PPP2PPP/RNBQK2R w KQkq - f3d4", null, null],
  ["r1bqkbnr/2p2ppp/p2p4/1p2p3/3NP3/1B6/PPP2PPP/RNBQK2R b KQkq - e5d4", null, null],
  ["r1bqkbnr/2p2ppp/p2p4/1p6/3pP3/1B6/PPP2PPP/RNBQK2R w KQkq - d1d4", null, null],
  ["r1bqkbnr/2p2ppp/p2p4/1p6/3QP3/1B6/PPP2PPP/RNB1K2R b KQkq - c7c5", "C71", "Ruy Lopez: Noah's Ark Trap"],
  [
    "r1bqkbnr/2pp1ppp/p1n5/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQK2R b KQkq - c6a5",
    "C70",
    "Ruy Lopez: Morphy Defense, Norwegian Variation",
  ],
  ["r1bqkbnr/2pp1ppp/p1n5/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQK2R b KQkq - d7d6", null, null],
  [
    "r1bqkbnr/2pp1ppp/p1n5/1p2p3/4P3/1B3N2/PPPP1PPP/RNBQK2R b KQkq - f8c5",
    "C70",
    "Ruy Lopez: Morphy Defense, Graz Variation",
  ],
  ["r1bqkbnr/2pp1ppp/p1n5/1p2p3/B3P3/5N2/PPPP1PPP/RNBQK2R w KQkq - a4b3", null, null],
  [
    "r1bqkbnr/2pp1ppp/p7/np2p3/4P3/1B3N2/PPPP1PPP/RNBQK2R w KQkq - b3f7",
    "C70",
    "Ruy Lopez: Morphy Defense, Norwegian Variation, Nightingale Gambit",
  ],
  ["r1bqkbnr/3p1ppp/p1n1p3/1p6/2B1P3/2N2N2/PP3PPP/R1BQ1RK1 w kq - c4b3", null, null],
  [
    "r1bqkbnr/3p1ppp/p1n1p3/1p6/4P3/1BN2N2/PP3PPP/R1BQ1RK1 b kq - f8c5",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Morphy Defense Deferred",
  ],
  ["r1bqkbnr/5ppp/p1npp3/1p6/2B1P3/2N2N2/PP2QPPP/R1B2RK1 w kq - c4b3", null, null],
  [
    "r1bqkbnr/5ppp/p1npp3/1p6/4P3/1BN2N2/PP2QPPP/R1B2RK1 b kq - a8a7",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Chicago Defense",
  ],
  ["r1bqkbnr/pp1n1ppp/2pp4/4p3/2BPP3/5N2/PPP2PPP/RNBQ1RK1 b kq - f8e7", null, null],
  [
    "r1bqkbnr/pp1n1ppp/2pp4/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R w KQkq - b1c3",
    "C41",
    "Philidor Defense: Hanham Variation, Schlechter Variation",
  ],
  [
    "r1bqkbnr/pp1n1ppp/2pp4/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R w KQkq - c2c3",
    "C41",
    "Philidor Defense: Hanham Variation, Delmar Variation",
  ],
  [
    "r1bqkbnr/pp1n1ppp/2pp4/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R w KQkq - e1g1",
    "C41",
    "Philidor Defense: Hanham Variation, Krause Variation",
  ],
  [
    "r1bqkbnr/pp1n1ppp/2pp4/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R w KQkq - f3g5",
    "C41",
    "Philidor Defense: Hanham, Kmoch Variation",
  ],
  [
    "r1bqkbnr/pp1npppp/2p5/6N1/3P4/8/PPP2PPP/R1BQKBNR b KQkq - d7f6",
    "B17",
    "Caro-Kann Defense: Karpov Variation, Modern Variation, Ivanchuk Defense",
  ],
  ["r1bqkbnr/pp1npppp/2p5/6N1/3P4/8/PPP2PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["r1bqkbnr/pp1npppp/2p5/8/2BPN3/8/PPP2PPP/R1BQK1NR b KQkq - g8f6", null, null],
  ["r1bqkbnr/pp1npppp/2p5/8/3PN3/5N2/PPP2PPP/R1BQKB1R b KQkq - g8f6", null, null],
  [
    "r1bqkbnr/pp1npppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - e4g5",
    "B17",
    "Caro-Kann Defense: Karpov Variation, Modern Variation",
  ],
  ["r1bqkbnr/pp1npppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - f1c4", null, null],
  ["r1bqkbnr/pp1npppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["r1bqkbnr/pp1p1ppp/2n1p3/1N6/4P3/8/PPP2PPP/RNBQKB1R b KQkq - d7d6", null, null],
  [
    "r1bqkbnr/pp1p1ppp/2n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - a7a6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Paulsen Formation",
  ],
  [
    "r1bqkbnr/pp1p1ppp/2n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - d7d6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Scheveningen Formation",
  ],
  [
    "r1bqkbnr/pp1p1ppp/2n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - d8c7",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Siberian Variation",
  ],
  [
    "r1bqkbnr/pp1p1ppp/2n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - f8b4",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Pin Defense",
  ],
  [
    "r1bqkbnr/pp1p1ppp/2n1p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - f8c5",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Morphy Defense",
  ],
  ["r1bqkbnr/pp1p1ppp/2n1p3/8/2B1P3/2N5/PP3PPP/R1BQK1NR w KQkq - g1f3", null, null],
  ["r1bqkbnr/pp1p1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - a7a6", "B46", "Sicilian Defense: Taimanov Variation"],
  ["r1bqkbnr/pp1p1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - d7d6", null, null],
  [
    "r1bqkbnr/pp1p1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - d8c7",
    "B47",
    "Sicilian Defense: Taimanov Variation, Bastrikov Variation",
  ],
  [
    "r1bqkbnr/pp1p1ppp/2n1p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - g8f6",
    "B45",
    "Sicilian Defense: Four Knights Variation",
  ],
  ["r1bqkbnr/pp1p1ppp/2n1p3/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3", "B45", "Sicilian Defense: Taimanov Variation"],
  [
    "r1bqkbnr/pp1p1ppp/2n1p3/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - d4b5",
    "B44",
    "Sicilian Defense: Taimanov Variation, Szén Variation",
  ],
  ["r1bqkbnr/pp1p1ppp/2n1p3/8/4P3/2N2N2/PP3PPP/R1BQKB1R w KQkq - f1c4", null, null],
  [
    "r1bqkbnr/pp1p1ppp/2n5/1N2p3/4P3/8/PPP2PPP/RNBQKB1R b KQkq - d7d6",
    "B32",
    "Sicilian Defense: Kalashnikov Variation",
  ],
  ["r1bqkbnr/pp1p1ppp/2n5/2p1p3/2B1P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - f8e7", null, null],
  ["r1bqkbnr/pp1p1ppp/2n5/2p1p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - f1c4", null, null],
  ["r1bqkbnr/pp1p1ppp/2n5/4p3/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - d4b5", null, null],
  ["r1bqkbnr/pp1p1ppp/3p2n1/4P3/5P2/2N5/PPP3PP/R1BQKB1R w KQkq - e5d6", null, null],
  ["r1bqkbnr/pp1p1ppp/3P2n1/8/5P2/2N5/PPP3PP/R1BQKB1R b KQkq - d8f6", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/1Bp5/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - f8g7", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/2p5/2P1P3/2N3P1/PP1P1P1P/R1BQKBNR b KQkq - f8g7", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/2p5/2P1P3/2N5/PP1P1PPP/R1BQKBNR w KQkq - g2g3", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/2p5/2P5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  [
    "r1bqkbnr/pp1ppp1p/2n3p1/2p5/2P5/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - f8g7",
    "A36",
    "English Opening: Symmetrical Variation, Ultra-Symmetrical Variation",
  ],
  ["r1bqkbnr/pp1ppp1p/2n3p1/2p5/4P3/2N3P1/PPPP1P1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/2p5/4P3/2N3P1/PPPP1PBP/R1BQK1NR b KQkq - f8g7", "B24", "Sicilian Defense: Closed"],
  [
    "r1bqkbnr/pp1ppp1p/2n3p1/2p5/4P3/2NP4/PPP2PPP/R1BQKBNR w KQkq - g2g4",
    "B23",
    "Sicilian Defense: Closed, Portland Attack",
  ],
  ["r1bqkbnr/pp1ppp1p/2n3p1/2p5/4PP2/2N2N2/PPPP2PP/R1BQKB1R b KQkq - f8g7", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/2p5/4PP2/2N5/PPPP2PP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "r1bqkbnr/pp1ppp1p/2n3p1/8/2PNP3/8/PP3PPP/RNBQKB1R b KQkq - f8g7",
    "B37",
    "Sicilian Defense: Accelerated Dragon, Maróczy Bind",
  ],
  ["r1bqkbnr/pp1ppp1p/2n3p1/8/2PNP3/8/PP3PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - f8g7", null, null],
  ["r1bqkbnr/pp1ppp1p/2n3p1/8/3NP3/4B3/PPP2PPP/RN1QKB1R b KQkq - f8g7", null, null],
  [
    "r1bqkbnr/pp1ppp1p/2n3p1/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3",
    "B34",
    "Sicilian Defense: Accelerated Dragon, Modern Variation",
  ],
  ["r1bqkbnr/pp1ppp1p/2n3p1/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - c1e3", null, null],
  [
    "r1bqkbnr/pp1ppp1p/2n3p1/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - c2c4",
    "B36",
    "Sicilian Defense: Accelerated Dragon, Maróczy Bind",
  ],
  [
    "r1bqkbnr/pp1ppp1p/2n3p1/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - d4c6",
    "B34",
    "Sicilian Defense: Accelerated Dragon, Exchange Variation",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - c6a5", null, null],
  [
    "r1bqkbnr/pp1ppppp/2n5/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - c6b8",
    "B30",
    "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Brooklyn Retreat Defense",
  ],
  [
    "r1bqkbnr/pp1ppppp/2n5/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g7g6",
    "B31",
    "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, Fianchetto Variation",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/2P1P3/2N5/PP1P1PPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/2P1P3/8/PP1P1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - g7g6", null, null],
  [
    "r1bqkbnr/pp1ppppp/2n5/2p5/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g2g3",
    "A36",
    "English Opening: Symmetrical Variation, Two Knights, Fianchetto Variation",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/3P4/2N2N2/PPP1PPPP/R1BQKB1R b KQkq - c5d4", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c5d4", "B32", "Sicilian Defense: Open"],
  [
    "r1bqkbnr/pp1ppppp/2n5/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - e7e6",
    "B32",
    "Sicilian Defense: Franco-Sicilian Variation",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/3PP3/N7/PPP2PPP/R1BQKBNR b KQkq - c5d4", null, null],
  [
    "r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - e7e5",
    "B30",
    "Sicilian Defense: Closed, Anti-Sveshnikov Variation",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N3P1/PPPP1P1P/R1BQKBNR b KQkq - g7g6", "B24", "Sicilian Defense: Closed"],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d3", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f2f4", "B23", "Sicilian Defense: Grand Prix Attack"],
  [
    "r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - g1e2",
    "B23",
    "Sicilian Defense: Closed, Chameleon Variation",
  ],
  [
    "r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - g2g3",
    "B24",
    "Sicilian Defense: Closed, Fianchetto Variation",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - g2g4", "B23", "Sicilian Defense: Closed, Grob Attack"],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2NP4/PPP2PPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/2PP4/PP3PPP/RNBQKBNR b KQkq - d7d6", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/3P4/PPP2PPP/RNBQKBNR w KQkq - c2c3", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b4", "B30", "Sicilian Defense: Portsmouth Gambit"],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "B32", "Sicilian Defense: Open"],
  [
    "r1bqkbnr/pp1ppppp/2n5/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1b5",
    "B30",
    "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4P3/N7/PPPP1PPP/R1BQKBNR w KQkq - d2d4", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/4PP2/2N5/PPPP2PP/R1BQKBNR b KQkq - g7g6", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/8/2N2N2/PPPPPPPP/R1BQKB1R w KQkq - d2d4", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/2p5/8/2NP4/PPP1PPPP/R1BQKBNR w KQkq - g2g3", "A00", "Mieses Opening: Venezolana Variation"],
  ["r1bqkbnr/pp1ppppp/2n5/8/2B1P3/2N5/PP3PPP/R1BQK1NR b KQkq - e7e6", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - a7a6", null, null],
  [
    "r1bqkbnr/pp1ppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - d7d5",
    "B32",
    "Sicilian Defense: Nimzo-American Variation",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - d8b6", "B32", "Sicilian Defense: Godiva Variation"],
  ["r1bqkbnr/pp1ppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - d8c7", "B32", "Sicilian Defense: Flohr Variation"],
  ["r1bqkbnr/pp1ppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - e7e5", "B32", "Sicilian Defense: Löwenthal Variation"],
  ["r1bqkbnr/pp1ppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g7g6", "B32", "Sicilian Defense: Accelerated Dragon"],
  ["r1bqkbnr/pp1ppppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g8f6", "B33", "Sicilian Defense: Open"],
  [
    "r1bqkbnr/pp1ppppp/2n5/8/3p4/2N2N2/PPP1PPPP/R1BQKB1R w KQkq - f3d4",
    "A00",
    "Van Geet Opening: Sicilian Two Knights",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3d4", "B32", "Sicilian Defense: Open"],
  [
    "r1bqkbnr/pp1ppppp/2n5/8/3pP3/N7/PPP2PPP/R1BQKBNR w KQkq - f1c4",
    "B20",
    "Sicilian Defense: Kronberger Variation, Nemeth Gambit",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/8/3Q4/2N5/PPP1PPPP/R1B1KBNR w KQkq - d4h4", "A00", "Van Geet Opening: Novosibirsk Variation"],
  ["r1bqkbnr/pp1ppppp/2n5/8/3QP3/8/PPP2PPP/RNB1KBNR w KQkq - d4d1", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/8/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - d7d6", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/8/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - e7e6", null, null],
  [
    "r1bqkbnr/pp1ppppp/2n5/8/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - g7g6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Fianchetto Defense",
  ],
  ["r1bqkbnr/pp1ppppp/2n5/8/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - f1c4", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/8/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["r1bqkbnr/pp1ppppp/2n5/8/4P3/8/PPP2PPP/RNBQKBNR b KQkq - g8f6", null, null],
  [
    "r1bqkbnr/pp1ppppp/8/nBp5/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b2b4",
    "B30",
    "Sicilian Defense: Nyezhmetdinov-Rossolimo Attack, San Francisco Gambit",
  ],
  ["r1bqkbnr/pp1ppppp/n1p5/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - a6c7", "B12", "Caro-Kann Defense: De Bruycker Defense"],
  ["r1bqkbnr/pp1ppppp/n1p5/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["r1bqkbnr/pp2pp1p/2np2p1/2p5/3PPP2/2N2N2/PPP3PP/R1BQKB1R b KQkq - c5d4", null, null],
  ["r1bqkbnr/pp2pp1p/2np2p1/2p5/4PP2/2N2N2/PPPP2PP/R1BQKB1R w KQkq - d2d4", null, null],
  ["r1bqkbnr/pp2pp1p/2np2p1/8/3NPP2/2N5/PPP3PP/R1BQKB1R b KQkq - f8g7", null, null],
  ["r1bqkbnr/pp2pp1p/2np2p1/8/3pPP2/2N2N2/PPP3PP/R1BQKB1R w KQkq - f3d4", null, null],
  ["r1bqkbnr/pp2pppp/2n5/2pp4/3P4/5NP1/PPP1PPBP/RNBQK2R b KQkq - e7e6", null, null],
  ["r1bqkbnr/pp2pppp/2n5/2pp4/3P4/5NP1/PPP1PPBP/RNBQK2R b KQkq - g8f6", "A08", "Zukertort Opening: Reversed Grünfeld"],
  ["r1bqkbnr/pp2pppp/2n5/2pp4/8/5NP1/PPPPPPBP/RNBQK2R w KQkq - d2d4", "A08", "Zukertort Opening: Reversed Grünfeld"],
  ["r1bqkbnr/pp2pppp/2n5/3p4/3P4/2PB4/PP3PPP/RNBQK1NR b KQkq - g8f6", null, null],
  ["r1bqkbnr/pp2pppp/2n5/3p4/3P4/3B4/PPP2PPP/RNBQK1NR w KQkq - c2c3", null, null],
  [
    "r1bqkbnr/pp2pppp/2np4/1B6/3QP3/5N2/PPP2PPP/RNB1K2R b KQkq - d8d7",
    "B53",
    "Sicilian Defense: Chekhover Variation, Zaitsev Defense",
  ],
  ["r1bqkbnr/pp2pppp/2np4/1Bp5/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - c8d7", null, null],
  ["r1bqkbnr/pp2pppp/2np4/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "r1bqkbnr/pp2pppp/2np4/2p5/2P1P3/2N3P1/PP1P1P1P/R1BQKBNR b KQkq - h7h5",
    "B20",
    "Sicilian Defense: Gloria Variation",
  ],
  ["r1bqkbnr/pp2pppp/2np4/2p5/2P1P3/2N5/PP1P1PPP/R1BQKBNR w KQkq - g2g3", null, null],
  ["r1bqkbnr/pp2pppp/2np4/2p5/4P3/2PP4/PP3PPP/RNBQKBNR w KQkq - f2f4", "B20", "Sicilian Defense: Big Clamp Formation"],
  ["r1bqkbnr/pp2pppp/2np4/2p5/4PP2/2N2N2/PPPP2PP/R1BQKB1R b KQkq - g7g6", null, null],
  ["r1bqkbnr/pp2pppp/2np4/2p5/4PP2/2N5/PPPP2PP/R1BQKBNR w KQkq - g1f3", null, null],
  ["r1bqkbnr/pp2pppp/2np4/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - a7a6", null, null],
  [
    "r1bqkbnr/pp2pppp/2np4/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - e7e6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Scheveningen Formation",
  ],
  [
    "r1bqkbnr/pp2pppp/2np4/8/3QP3/2N5/PPP2PPP/R1B1KBNR w KQkq - d4d2",
    "B23",
    "Sicilian Defense: Closed, Carlsen Variation",
  ],
  ["r1bqkbnr/pp2pppp/2np4/8/3QP3/5N2/PPP2PPP/RNB1KB1R w KQkq - f1b5", null, null],
  ["r1bqkbnr/pp2pppp/2np4/8/4P3/2N2N2/PP3PPP/R1BQKB1R w KQkq - f1c4", null, null],
  ["r1bqkbnr/pp3ppp/2n1p3/2pp4/3P4/5NP1/PPP1PPBP/RNBQK2R w KQkq - e1g1", "A08", "Zukertort Opening: Reversed Grünfeld"],
  [
    "r1bqkbnr/pp3ppp/2n1p3/2ppP3/3P4/2P2N2/PP3PPP/RNBQKB1R b KQkq - c8d7",
    "C02",
    "French Defense: Advance Variation, Euwe Variation",
  ],
  ["r1bqkbnr/pp3ppp/2n1p3/2ppP3/3P4/2P2N2/PP3PPP/RNBQKB1R b KQkq - d8b6", null, null],
  [
    "r1bqkbnr/pp3ppp/2n1p3/2ppP3/3P4/2P5/PP3PPP/RNBQKBNR w KQkq - c1e3",
    "C02",
    "French Defense: Advance Variation, Kupreichik Variation",
  ],
  [
    "r1bqkbnr/pp3ppp/2n1p3/2ppP3/3P4/2P5/PP3PPP/RNBQKBNR w KQkq - g1f3",
    "C02",
    "French Defense: Advance Variation, Paulsen Attack",
  ],
  ["r1bqkbnr/pp3ppp/2n1p3/3P4/3Q4/2N5/PP2PPPP/R1B1KBNR w KQkq - d4d1", null, null],
  ["r1bqkbnr/pp3ppp/2n1p3/3P4/8/2N5/PP2PPPP/R1BQKBNR b KQkq - e6d5", null, null],
  ["r1bqkbnr/pp3ppp/2n5/2P5/3p4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c3a4", null, null],
  ["r1bqkbnr/pp3ppp/2n5/2P5/N2p4/5N2/PP2PPPP/R1BQKB1R b KQkq - b7b5", "D32", "Tarrasch Defense: Grünfeld Gambit"],
  ["r1bqkbnr/pp3ppp/2n5/2pp4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - d4c5", null, null],
  ["r1bqkbnr/pp3ppp/2n5/2pp4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - g2g3", "D33", "Tarrasch Defense: Rubinstein System"],
  ["r1bqkbnr/pp3ppp/2n5/2pp4/3P4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - c5c4", "D33", "Tarrasch Defense: Swedish Variation"],
  ["r1bqkbnr/pp3ppp/2n5/2pp4/3P4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - g8f6", "D33", "Tarrasch Defense: Prague Variation"],
  ["r1bqkbnr/pp3ppp/2n5/2pp4/3P4/5NP1/PP2PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["r1bqkbnr/pp3ppp/2n5/2pp4/3P4/5NP1/PP2PPBP/RNBQK2R b KQkq - g8f6", null, null],
  ["r1bqkbnr/pp3ppp/2n5/2Pp4/8/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d5d4", null, null],
  [
    "r1bqkbnr/pp3ppp/2n5/3p4/2pP4/2N2NP1/PP2PP1P/R1BQKB1R w KQkq - e2e4",
    "D33",
    "Tarrasch Defense: Swedish Variation, Central Break",
  ],
  ["r1bqkbnr/pp3ppp/2n5/3p4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - d1d5", null, null],
  ["r1bqkbnr/pp3ppp/2n5/3Q4/8/2N5/PP2PPPP/R1B1KBNR b KQkq - c8e6", "D32", "Tarrasch Defense: von Hennig Gambit"],
  ["r1bqkbnr/pp3ppp/2npp3/1N6/2P1P3/8/PP3PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["r1bqkbnr/pp3ppp/2npp3/1N6/4P3/8/PPP2PPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["r1bqkbnr/pp3ppp/2npp3/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1 b kq - a7a6", null, null],
  ["r1bqkbnr/pp3ppp/2npp3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r1bqkbnr/pp3ppp/2npp3/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - g8f6",
    "B83",
    "Sicilian Defense: Scheveningen Variation, Modern Variation",
  ],
  ["r1bqkbnr/pp3ppp/2npp3/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1e2", null, null],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - d5c4",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - e7e5",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense, Tartakower Gambit",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c8g4",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense, Main Line",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - e7e5",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense, Lazard Gambit",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense",
  ],
  ["r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - c4d5", null, null],
  ["r1bqkbnr/ppp1pppp/2n5/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["r1bqkbnr/ppp1pppp/2n5/3p4/3P4/2N3P1/PPP1PP1P/R1BQKBNR b KQkq - e7e5", null, null],
  [
    "r1bqkbnr/ppp1pppp/2n5/3P4/3P4/8/PP2PPPP/RNBQKBNR b KQkq - d8d5",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense, Exchange Variation",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3P4/3P4/8/PPP2PPP/RNBQKBNR b KQkq - c6b4",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Aachen Gambit",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3P4/3P4/8/PPP2PPP/RNBQKBNR b KQkq - d8d5",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Exchange Variation",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - a7a6",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Bogoljubow Variation, Brandics Gambit",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - d5e4",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Bogoljubow Variation",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - e7e5",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Bogoljubow Variation, Heinola-Deppe Gambit",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - g7g6",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Bogoljubow Variation, Erben Gambit",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Bogoljubow Variation, Vehre Variation",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Bogoljubow Variation",
  ],
  ["r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c1e3", "B00", "Nimzowitsch Defense: Hornung Gambit"],
  ["r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - e4d5", null, null],
  [
    "r1bqkbnr/ppp1pppp/2n5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - e4e5",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Advance Variation",
  ],
  ["r1bqkbnr/ppp1pppp/2n5/3P4/4p3/2N5/PPP2PPP/R1BQKBNR b KQkq - c6b8", null, null],
  [
    "r1bqkbnr/ppp1pppp/2n5/3P4/4p3/2N5/PPP2PPP/R1BQKBNR b KQkq - c6e5",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Bogoljubow Variation, Nimzowitsch Gambit",
  ],
  ["r1bqkbnr/ppp1pppp/2n5/3p4/8/2N3P1/PPPPPP1P/R1BQKBNR w KQkq - d2d4", null, null],
  [
    "r1bqkbnr/ppp1pppp/2n5/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - g8f6",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense, Modern Gambit",
  ],
  [
    "r1bqkbnr/ppp1pppp/2n5/8/2pP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense, Janowski Variation",
  ],
  ["r1bqkbnr/ppp1pppp/2n5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - d4d5", "B00", "Van Geet Opening: Berlin Gambit"],
  ["r1bqkbnr/ppp2p1p/2n5/3P4/2BP1p2/2N2p2/PPP3PP/R1BQ1RK1 b kq - c8g4", null, null],
  ["r1bqkbnr/ppp2p1p/2n5/3p4/2BPPp2/2N2p2/PPP3PP/R1BQ1RK1 w kq - e4d5", null, null],
  ["r1bqkbnr/ppp2ppp/2n1p3/3p4/3PP3/2P5/PP1N1PPP/R1BQKBNR b KQkq - d5e4", null, null],
  [
    "r1bqkbnr/ppp2ppp/2n1p3/3p4/3PP3/5N2/PPPN1PPP/R1BQKB1R b KQkq - g8f6",
    "C04",
    "French Defense: Tarrasch Variation, Guimard Defense, Main Line",
  ],
  ["r1bqkbnr/ppp2ppp/2n1p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR w KQkq - c2c3", null, null],
  ["r1bqkbnr/ppp2ppp/2n1p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "r1bqkbnr/ppp2ppp/2n1p3/8/3PN3/2P5/PP3PPP/R1BQKBNR b KQkq - e6e5",
    "C03",
    "French Defense: Tarrasch Variation, Guimard Defense, Thunderbunny Variation",
  ],
  ["r1bqkbnr/ppp2ppp/2n1p3/8/3Pp3/2P5/PP1N1PPP/R1BQKBNR w KQkq - d2e4", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/1B1pN3/4P3/8/PPPP1PPP/RNBQK2R b KQkq - d8g5", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/1B1pp3/4P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - d5e4", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/1B1pp3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - f3e5", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/1B2N3/4p3/2P5/PP1P1PPP/RNBQK2R b KQkq - d8d5", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/1B2p3/4p3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - f3e5", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/3pp3/3P4/2N3P1/PPP1PP1P/R1BQKBNR w KQkq - d4e5", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/3pp3/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - d1a4", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/3pp3/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - f1b5", "C44", "Ponziani Opening: Spanish Variation"],
  ["r1bqkbnr/ppp2ppp/2n5/3pP3/8/2N3P1/PPP1PP1P/R1BQKBNR b KQkq - d5d4", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/3pp3/Q3P3/2P2N2/PP1P1PPP/RNB1KB1R b KQkq - c8d7", "C44", "Ponziani Opening: Caro Gambit"],
  [
    "r1bqkbnr/ppp2ppp/2n5/3pp3/Q3P3/2P2N2/PP1P1PPP/RNB1KB1R b KQkq - f7f6",
    "C44",
    "Ponziani Opening: Steinitz Variation",
  ],
  [
    "r1bqkbnr/ppp2ppp/2n5/3pp3/Q3P3/2P2N2/PP1P1PPP/RNB1KB1R b KQkq - g8f6",
    "C44",
    "Ponziani Opening: Leonhardt Variation",
  ],
  ["r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5N2/PP1NPPPP/R1BQKB1R b KQkq - c8g4", null, null],
  [
    "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5N2/PP1NPPPP/R1BQKB1R b KQkq - d8e7",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit, Balogh Variation",
  ],
  [
    "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5N2/PP1NPPPP/R1BQKB1R b KQkq - f7f6",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit, Janowski Variation",
  ],
  [
    "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1d2",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit, Modern Line",
  ],
  [
    "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5N2/PP2PPPP/RNBQKB1R w KQkq - g2g3",
    "D09",
    "Queen's Gambit Declined: Albin Countergambit, Fianchetto Variation",
  ],
  [
    "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5NP1/PP2PP1P/RNBQKB1R b KQkq - c8e6",
    "D09",
    "Queen's Gambit Declined: Albin Countergambit, Fianchetto Variation, Be6 Line",
  ],
  [
    "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5NP1/PP2PP1P/RNBQKB1R b KQkq - c8f5",
    "D09",
    "Queen's Gambit Declined: Albin Countergambit, Fianchetto Variation, Bf5 Line",
  ],
  [
    "r1bqkbnr/ppp2ppp/2n5/4P3/2Pp4/5NP1/PP2PP1P/RNBQKB1R b KQkq - c8g4",
    "D09",
    "Queen's Gambit Declined: Albin Countergambit, Fianchetto Variation, Bg4 Line",
  ],
  ["r1bqkbnr/ppp2ppp/2n5/4P3/3p4/2N3P1/PPP1PP1P/R1BQKBNR w KQkq - c3e4", null, null],
  ["r1bqkbnr/ppp2ppp/2n5/4P3/3pN3/6P1/PPP1PP1P/R1BQKBNR b KQkq - f7f5", "A00", "Hungarian Opening: Asten Gambit"],
  ["r1bqkbnr/ppp2ppp/2np4/1B2p3/3PP3/5N2/PPP2PPP/RNBQK2R b KQkq - c8d7", null, null],
  ["r1bqkbnr/ppp2ppp/2np4/1B2p3/3PP3/5N2/PPP2PPP/RNBQK2R b KQkq - e5d4", null, null],
  ["r1bqkbnr/ppp2ppp/2np4/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4", "C62", "Ruy Lopez: Steinitz Defense"],
  [
    "r1bqkbnr/ppp2ppp/2np4/1B6/3pP3/5N2/PPP2PPP/RNBQK2R w KQkq - e1g1",
    "C62",
    "Ruy Lopez: Steinitz Defense, Center Gambit",
  ],
  ["r1bqkbnr/ppp2ppp/2np4/4p3/2P5/1PN1P3/P2P1PPP/R1BQKBNR b KQkq - g8f6", "A00", "Amsterdam Attack"],
  ["r1bqkbnr/ppp2ppp/2np4/4p3/2P5/2N1P3/PP1P1PPP/R1BQKBNR w KQkq - b2b3", null, null],
  ["r1bqkbnr/ppp2ppp/2np4/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  [
    "r1bqkbnr/ppp2ppp/2np4/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - c8e6",
    "A21",
    "English Opening: King's English Variation, Troger Defense",
  ],
  ["r1bqkbnr/ppp2ppp/2np4/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - c8g4", null, null],
  ["r1bqkbnr/ppp2ppp/2np4/8/4P3/2N2N2/PP3PPP/R1BQKB1R w KQkq - f1c4", null, null],
  ["r1bqkbnr/ppp2ppp/3p4/8/3QP3/8/PPP2PPP/RNB1KB1R w KQkq - f1d3", "C45", "Scotch Game: Ghulam-Kassim Variation"],
  ["r1bqkbnr/ppp3pp/2n5/1B1pN3/4N3/8/PPPP1PPP/R1BQK2R b KQkq - d5e4", null, null],
  ["r1bqkbnr/ppp3pp/2n5/1B1pp3/4N3/5N2/PPPP1PPP/R1BQK2R w KQkq - f3e5", null, null],
  ["r1bqkbnr/ppp3pp/2n5/1B2N3/4p3/8/PPPP1PPP/R1BQK2R w KQkq - e5c6", null, null],
  [
    "r1bqkbnr/ppp3pp/2N5/1B6/4p3/8/PPPP1PPP/R1BQK2R b KQkq - d8d5",
    "C63",
    "Ruy Lopez: Schliemann Defense, Möhring Variation",
  ],
  [
    "r1bqkbnr/ppp3pp/2N5/1B6/4p3/8/PPPP1PPP/R1BQK2R b KQkq - d8g5",
    "C63",
    "Ruy Lopez: Schliemann Defense, Classical Variation",
  ],
  [
    "r1bqkbnr/ppp3pp/2np4/4pp2/3PP3/2P2N2/PP3PPP/RNBQKB1R w KQkq - d4d5",
    "C44",
    "Ponziani Opening: Ponziani Countergambit, Schmidt Attack",
  ],
  ["r1bqkbnr/pppn1ppp/3p4/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R b KQkq - c7c6", null, null],
  [
    "r1bqkbnr/pppn1ppp/3p4/4p3/2BPP3/5N2/PPP2PPP/RNBQK2R b KQkq - d7b6",
    "C41",
    "Philidor Defense: Hanham Variation, Sharp Variation",
  ],
  ["r1bqkbnr/pppn1ppp/3p4/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - g8f6", "C41", "Philidor Defense: Lion Variation"],
  ["r1bqkbnr/pppn1ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["r1bqkbnr/pppn1ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4", null, null],
  ["r1bqkbnr/pppn1ppp/4p3/8/3PN3/5N2/PPP2PPP/R1BQKB1R b KQkq - g8f6", null, null],
  ["r1bqkbnr/pppn1ppp/4p3/8/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["r1bqkbnr/pppp1N2/2n4p/8/4PppP/2N5/PPPP2P1/R1BQKB1R b KQkq - e8f7", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/1B2p3/3PP3/5N2/PPP2PPP/RNBQK2R b KQkq - e5d4", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/1B2p3/4P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - a7a6", null, null],
  [
    "r1bqkbnr/pppp1p1p/2n3p1/1B2p3/4P3/2P2N2/PP1P1PPP/RNBQK2R b KQkq - f7f5",
    "C60",
    "Ruy Lopez: Fianchetto Defense, Kevitz Gambit",
  ],
  ["r1bqkbnr/pppp1p1p/2n3p1/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c3", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/1B6/3NP3/8/PPP2PPP/RNBQK2R b KQkq - f8g7", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/1B6/3pP3/5N2/PPP2PPP/RNBQK2R w KQkq - f3d4", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/4p3/2P5/2N3P1/PP1PPP1P/1RBQKBNR b Kkq - g8h6", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - a1b1", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  [
    "r1bqkbnr/pppp1p1p/2n3p1/4p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - f8g7",
    "A25",
    "English Opening: King's English Variation, Taimanov Variation",
  ],
  ["r1bqkbnr/pppp1p1p/2n3p1/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - e5d4", null, null],
  ["r1bqkbnr/pppp1p1p/2n3p1/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - d2d4", null, null],
  [
    "r1bqkbnr/pppp1p1p/2n3p1/8/3pP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - c3d5",
    "C46",
    "Three Knights Opening: Steinitz-Rosenthal Variation",
  ],
  [
    "r1bqkbnr/pppp1p1p/2n5/4p1P1/4P3/5N2/PPPP2PP/RNBQKB1R b KQkq - h7h6",
    "C30",
    "King's Gambit Declined: Hobbs-Zilbermints Gambit",
  ],
  ["r1bqkbnr/pppp1p1p/2n5/4p1p1/4PP2/5N2/PPPP2PP/RNBQKB1R w KQkq - f4g5", null, null],
  [
    "r1bqkbnr/pppp1p1p/2n5/6N1/4PppP/2N5/PPPP2P1/R1BQKB1R b KQkq - d7d6",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Hamppe-Allgaier Gambit, Alapin Variation",
  ],
  ["r1bqkbnr/pppp1p1p/2n5/6N1/4PppP/2N5/PPPP2P1/R1BQKB1R b KQkq - h7h6", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/6p1/2B1Pp2/2N2N2/PPPP2PP/R1BQK2R b KQkq - g5g4", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/6p1/3PPp2/2N2N2/PPP3PP/R1BQKB1R b KQkq - g5g4", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/6p1/4Pp1P/2N2N2/PPPP2P1/R1BQKB1R b KQkq - g5g4", null, null],
  [
    "r1bqkbnr/pppp1p1p/2n5/6p1/4Pp2/2N2N2/PPPP2PP/R1BQKB1R w KQkq - d2d4",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Pierce Gambit",
  ],
  ["r1bqkbnr/pppp1p1p/2n5/6p1/4Pp2/2N2N2/PPPP2PP/R1BQKB1R w KQkq - f1c4", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/6p1/4Pp2/2N2N2/PPPP2PP/R1BQKB1R w KQkq - h2h4", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/8/2B1Pp2/2N2p2/PPPP2PP/R1BQ1RK1 w kq - d1f3", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/8/2B1Pp2/2N2Q2/PPPP2PP/R1B2RK1 b kq - c6e5", null, null],
  [
    "r1bqkbnr/pppp1p1p/2n5/8/2B1Ppp1/2N2N2/PPPP2PP/R1BQ1RK1 b kq - g4f3",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Hamppe-Muzio Gambit",
  ],
  ["r1bqkbnr/pppp1p1p/2n5/8/2B1Ppp1/2N2N2/PPPP2PP/R1BQK2R w KQkq - e1g1", "C25", "Vienna Game: Hamppe-Muzio Gambit"],
  ["r1bqkbnr/pppp1p1p/2n5/8/2BPPp2/2N2p2/PPP3PP/R1BQ1RK1 b kq - d7d5", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/8/2BPPp2/2N2p2/PPP3PP/R1BQK2R w KQkq - e1g1", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/8/2BPPpp1/2N2N2/PPP3PP/R1BQK2R b KQkq - g4f3", null, null],
  ["r1bqkbnr/pppp1p1p/2n5/8/3PPpp1/2N2N2/PPP3PP/R1BQKB1R w KQkq - f1c4", null, null],
  [
    "r1bqkbnr/pppp1p1p/2n5/8/4PppP/2N2N2/PPPP2P1/R1BQKB1R w KQkq - f3g5",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Hamppe-Allgaier Gambit",
  ],
  ["r1bqkbnr/pppp1p1p/8/4n3/2B1Pp2/2N2Q2/PPPP2PP/R1B2RK1 w kq - f3f4", null, null],
  [
    "r1bqkbnr/pppp1p1p/8/4n3/2B1PQ2/2N5/PPPP2PP/R1B2RK1 b kq - d8f6",
    "C25",
    "Vienna Game: Hamppe-Muzio, Dubois Variation",
  ],
  ["r1bqkbnr/pppp1p2/2n4p/6N1/4PppP/2N5/PPPP2P1/R1BQKB1R w KQkq - g5f7", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - a7a5", "C60", "Ruy Lopez: Bulgarian Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - a7a6", "C70", "Ruy Lopez: Morphy Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - b7b6", "C60", "Ruy Lopez: Rotary-Albany Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - c6a5", "C60", "Ruy Lopez: Pollock Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - c6b8", "C60", "Ruy Lopez: Retreat Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - c6d4", "C61", "Ruy Lopez: Bird Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - d7d5", "C60", "Ruy Lopez: Spanish Countergambit"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - d7d6", "C62", "Ruy Lopez: Steinitz Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - d8e7", "C60", "Ruy Lopez: Vinogradov Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f7f5", "C63", "Ruy Lopez: Schliemann Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f7f6", "C60", "Ruy Lopez: Nürnberg Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f8b4", "C60", "Ruy Lopez: Alapin Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f8c5", "C64", "Ruy Lopez: Classical Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f8e7", "C60", "Ruy Lopez: Lucena Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g7g5", "C60", "Ruy Lopez: Brentano Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g7g6", "C60", "Ruy Lopez: Fianchetto Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g8e7", "C60", "Ruy Lopez: Cozio Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g8f6", "C65", "Ruy Lopez: Berlin Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/3Pp3/2P5/8/PP2PPPP/RNBQKBNR b KQkq - c6d4", "A40", "Mikenas Defense: Cannstatter Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/3Pp3/2P5/8/PP2PPPP/RNBQKBNR b KQkq - c6e7", "A40", "Mikenas Defense: Lithuanian Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/4N3/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - c6e5", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4N3/8/8/PPPPPPPP/RNBQKB1R w KQkq - e5c6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p2Q/2B1P3/8/PPPP1PPP/RNB1K1NR b KQkq - g8h6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p2Q/4P3/8/PPPP1PPP/RNB1KBNR w KQkq - f1c4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR b KQkq - f8c5", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR b KQkq - g8f6",
    "C28",
    "Vienna Game: Stanley Variation, Three Knights Variation",
  ],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - c6d4",
    "C50",
    "Italian Game: Blackburne-Kostić Gambit",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - d7d6", "C50", "Italian Game: Paris Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f7f5", "C50", "Italian Game: Rousseau Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f8c5", "C50", "Italian Game: Giuoco Piano"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f8e7", "C50", "Italian Game: Hungarian Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g8f6", "C55", "Italian Game: Two Knights Defense"],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - h7h6",
    "C50",
    "Italian Game: Anti-Fried Liver Defense",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - b1c3", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2N1P3/8/PPPP1PPP/R1BQKBNR b KQkq - f7f5", "A00", "Sodium Attack: Durkin Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2N5/8/PPPPPPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2P1P3/5N2/PP1P1PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2P5/1P6/PB1PPPPP/RN1QKBNR b KQkq - g8f6", "A01", "Nimzo-Larsen Attack: Modern Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - d7d6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - g7g6", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g1f3",
    "A27",
    "English Opening: King's English Variation, Three Knights System",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g2g3", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4P3/2P5/8/PP2PPPP/RNBQKBNR b KQkq - c6e5", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4d5", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4e5", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - f7f5", "C25", "Vienna Game: Philidor Countergambit"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c6d4", "C44", "Scotch Game: Lolli Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - e5d4", "C44", "Scotch Game"],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - d4d5",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, Linksspringer Variation",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - d4e5", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - f7f5",
    "C46",
    "Three Knights Opening: Winawer Defense",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - f8b4", "C46", "Three Knights Opening"],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - g7g6",
    "C46",
    "Three Knights Opening: Steinitz Defense",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - g8f6", "C47", "Four Knights Game"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR b KQkq - f8c5", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR b KQkq - g8f6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d4", "C25", "Vienna Game: Fyfe Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f1c4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f2f4", "C25", "Vienna Gambit, with Max Lange Defense"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - g2g3", "C25", "Vienna Game: Paulsen Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - d7d5", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - f7f5",
    "C44",
    "Ponziani Opening: Ponziani Countergambit",
  ],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - f8e7",
    "C44",
    "Ponziani Opening: Romanishin Variation",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - g8e7", "C44", "Ponziani Opening: Réti Variation"],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - g8f6",
    "C44",
    "Ponziani Opening: Jaenisch Counterattack",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/2P5/PP1PQPPP/RNB1KBNR b KQkq - g8f6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/3P1N2/PPP2PPP/RNBQKB1R b KQkq - f7f5", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3", "C46", "Three Knights Opening"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b4", "C44", "King's Pawn Game: Pachman Wing Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c3", "C44", "Ponziani Opening"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c4", "C44", "King's Pawn Game: Dresden Opening"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d3", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "C44", "Scotch Game"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1b5", "C60", "Ruy Lopez"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1c4", "C50", "Italian Game"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1e2", "C44", "King's Pawn Game: Tayler Opening"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f3e5", "C44", "Irish Gambit"],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - g2g3",
    "C44",
    "King's Knight Opening: Konstantinopolsky",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPPBPPP/RNBQK2R b KQkq - g8f6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4P3/4P3/8/PPP2PPP/RNBQKBNR b KQkq - c6e5", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/4P3/4P3/8/PPP2PPP/RNBQKBNR b KQkq - d7d6",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, de Smet Gambit",
  ],
  [
    "r1bqkbnr/pppp1ppp/2n5/4P3/4P3/8/PPP2PPP/RNBQKBNR b KQkq - d8h4",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, Herford Gambit",
  ],
  [
    "r1bqkbnr/pppp1ppp/2n5/4P3/4P3/8/PPP2PPP/RNBQKBNR b KQkq - f7f6",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, Hammer Gambit",
  ],
  [
    "r1bqkbnr/pppp1ppp/2n5/4P3/4P3/8/PPP2PPP/RNBQKBNR b KQkq - f8c5",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, Bielefelder Gambit",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4P3/8/PPPPQPPP/RNB1KBNR w KQkq - c2c3", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4PP2/2N5/PPPP2PP/R1BQKBNR b KQkq - e5f4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4PP2/2N5/PPPP2PP/R1BQKBNR b KQkq - f8c5", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4PP2/5N2/PPPP2PP/RNBQKB1R b KQkq - f7f5", "C30", "King's Gambit Declined: Miles Defense"],
  [
    "r1bqkbnr/pppp1ppp/2n5/4p3/4PP2/5N2/PPPP2PP/RNBQKB1R b KQkq - g7g5",
    "C30",
    "King's Gambit Declined: Zilbermints Double Gambit",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - g1f3", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/5P2/2N1P3/PPPP2PP/R1BQKBNR b KQkq - e5f4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/8/1P6/PBPPPPPP/RN1QKBNR w KQkq - c2c4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/8/1P6/PBPPPPPP/RN1QKBNR w KQkq - e2e3", "A01", "Nimzo-Larsen Attack: Modern Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/8/1P6/PBPPPPPP/RN1QKBNR w KQkq - f2f4", "A01", "Nimzo-Larsen Attack: Pachman Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/8/2N1P3/PPPP1PPP/R1BQKBNR w KQkq - f2f4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/4p3/8/2N2N2/PPPPPPPP/R1BQKB1R w KQkq - d2d4", "A00", "Van Geet Opening: Napoleon Attack"],
  ["r1bqkbnr/pppp1ppp/2n5/4P3/8/5N2/PPP1PPPP/RNBQKB1R b KQkq - d8e7", "A40", "Englund Gambit: Main Line"],
  ["r1bqkbnr/pppp1ppp/2n5/4P3/8/5N2/PPP1PPPP/RNBQKB1R b KQkq - f7f6", "A40", "Englund Gambit: Soller Gambit Deferred"],
  ["r1bqkbnr/pppp1ppp/2n5/4P3/8/5N2/PPP1PPPP/RNBQKB1R b KQkq - f8c5", "A40", "Englund Gambit: Felbecker Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/4P3/8/5N2/PPP1PPPP/RNBQKB1R b KQkq - g8e7", "A40", "Englund Gambit: Zilbermints Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/4P3/8/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/8/2B1P3/2p2N2/PP3PPP/RNBQK2R b KQkq - g8f6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/8/2B1Pp2/5N2/PPPP2PP/RNBQK2R b KQkq - g7g5", "C37", "King's Gambit Accepted: Blachly Gambit"],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/2BpP3/5N2/PPP2PPP/RNBQK2R b KQkq - f8b4",
    "C44",
    "Scotch Game: Scotch Gambit, London Defense",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/8/2BpP3/5N2/PPP2PPP/RNBQK2R b KQkq - f8c5", "C44", "Scotch Game: Haxo Gambit"],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/2BpP3/5N2/PPP2PPP/RNBQK2R b KQkq - g8f6",
    "C44",
    "Scotch Game: Scotch Gambit, Dubois Réti Defense",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - c6d4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - d8h4", "C45", "Scotch Game: Steinitz Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - f8b4", "C45", "Scotch Game: Malaniuk Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - f8c5", "C45", "Scotch Game: Classical Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g8f6", "C45", "Scotch Game: Schmidt Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3pP3/2P2N2/PP3PPP/RNBQKB1R b KQkq - d4c3", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/3pP3/2P2N2/PP3PPP/RNBQKB1R b KQkq - d7d5",
    "C44",
    "Scotch Game: Scotch Gambit, Göring Gambit Declined",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c3", "C44", "Scotch Game: Göring Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1b5", "C44", "Scotch Game: Relfsson Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4", "C44", "Scotch Game: Scotch Gambit"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3d4", "C45", "Scotch Game"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3PPp2/2N5/PPP3PP/R1BQKBNR b KQkq - d8h4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/8/3Q4/2N5/PPP1PPPP/R1B1KBNR w KQkq - d4a4", "A00", "Van Geet Opening: Reversed Scandinavian"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3QP3/8/PPP2PPP/RNB1KBNR w KQkq - d4c4", "C22", "Center Game: Hall Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/8/3QP3/8/PPP2PPP/RNB1KBNR w KQkq - d4e3", "C22", "Center Game: Paulsen Attack Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/8/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - d7d6", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/8/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - f8b4", "C44", "Scotch Game: Göring Gambit, Main Line"],
  ["r1bqkbnr/pppp1ppp/2n5/8/4P3/2p2N2/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/4P3/2p2N2/PP3PPP/RNBQKB1R w KQkq - f1c4",
    "C44",
    "Scotch Game: Göring Gambit, Double Pawn Sacrifice",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/8/4P3/4Q3/PPP2PPP/RNB1KBNR b KQkq - f7f5", "C22", "Center Game: l'Hermet Variation"],
  ["r1bqkbnr/pppp1ppp/2n5/8/4P3/4Q3/PPP2PPP/RNB1KBNR b KQkq - f8b4", null, null],
  ["r1bqkbnr/pppp1ppp/2n5/8/4P3/4Q3/PPP2PPP/RNB1KBNR b KQkq - g8f6", "C22", "Center Game: Berger Variation"],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/4Pp2/2N2N2/PPPP2PP/R1BQKB1R b KQkq - f8e7",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Cunningham Defense",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/8/4Pp2/2N2N2/PPPP2PP/R1BQKB1R b KQkq - g7g5", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/4Pp2/2N5/PPPP2PP/R1BQKBNR w KQkq - d2d4",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Steinitz Gambit",
  ],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/4Pp2/2N5/PPPP2PP/R1BQKBNR w KQkq - g1f3",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Knight Variation",
  ],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - b1c3",
    "C25",
    "Vienna Gambit, with Max Lange Defense: Knight Variation",
  ],
  ["r1bqkbnr/pppp1ppp/2n5/8/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - f1c4", null, null],
  [
    "r1bqkbnr/pppp1ppp/2n5/8/5p2/2N1P3/PPPP2PP/R1BQKBNR w KQkq - g1f3",
    "A00",
    "Van't Kruijs Opening: Keoni-Hiva Gambit, Alua Variation",
  ],
  ["r1bqkbnr/pppp1ppp/2N5/8/8/8/PPPPPPPP/RNBQKB1R b KQkq - d7c6", "A04", "Zukertort Opening: The Walrus"],
  ["r1bqkbnr/pppp1ppp/3P2n1/4P3/5P2/2N5/PPP3PP/R1BQKB1R b KQkq - c7d6", null, null],
  ["r1bqkbnr/pppp1ppp/6n1/3PP3/5P2/2N5/PPP3PP/R1BQKB1R w KQkq - d5d6", null, null],
  ["r1bqkbnr/pppp1ppp/6n1/4P3/2BP4/2N5/PPP2PPP/R1BQK2R b KQkq - f8b4", null, null],
  ["r1bqkbnr/pppp1ppp/6n1/4P3/3P4/2N5/PPP2PPP/R1BQKB1R w KQkq - f1c4", null, null],
  ["r1bqkbnr/pppp1ppp/8/1B2p3/3nP3/5N2/PPPP1PPP/RNBQK2R w KQkq - f3d4", null, null],
  ["r1bqkbnr/pppp1ppp/8/1B2p3/3NP3/8/PPPP1PPP/RNBQK2R b KQkq - e5d4", null, null],
  [
    "r1bqkbnr/pppp1ppp/8/1B6/3pP3/8/PPPP1PPP/RNBQ1RK1 b kq - g8e7",
    "C61",
    "Ruy Lopez: Bird Variation, Paulsen Variation",
  ],
  ["r1bqkbnr/pppp1ppp/8/1B6/3pP3/8/PPPP1PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["r1bqkbnr/pppp1ppp/8/4n3/2P5/2N5/PP2PPPP/R1BQKBNR b KQkq - e5c4", "A40", "Mikenas Defense: Pozarek Gambit"],
  ["r1bqkbnr/pppp1ppp/8/4n3/2P5/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "r1bqkbnr/pppp1ppp/8/4n3/4P3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, Keres Attack",
  ],
  ["r1bqkbnr/pppp1ppp/8/4n3/4P3/8/PPP2PPP/RNBQKBNR w KQkq - f2f4", null, null],
  [
    "r1bqkbnr/pppp1ppp/8/4n3/4P3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, Paulsen Attack",
  ],
  ["r1bqkbnr/pppp1ppp/8/4n3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "C44", "King's Pawn Game: Schulze-Müller Gambit"],
  [
    "r1bqkbnr/pppp1ppp/8/4n3/4PP2/8/PPP3PP/RNBQKBNR b KQkq - e5c6",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, Riemann Defense",
  ],
  [
    "r1bqkbnr/pppp1ppp/8/4n3/4PP2/8/PPP3PP/RNBQKBNR b KQkq - e5g6",
    "B00",
    "Nimzowitsch Defense: Kennedy Variation, Main Line",
  ],
  ["r1bqkbnr/pppp1ppp/8/4p3/3nP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3d4", null, null],
  ["r1bqkbnr/pppp1ppp/8/4p3/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - e5d4", null, null],
  ["r1bqkbnr/pppp1ppp/8/8/3nP3/8/PPP2PPP/RNBQKB1R w KQkq - d1d4", "C44", "Scotch Game: Lolli Variation"],
  ["r1bqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKB1R w KQkq - d1d4", "C44", "Scotch Game: Lolli Variation"],
  ["r1bqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKB1R w KQkq - f1c4", "C44", "Scotch Game: Napoleon Gambit"],
  ["r1bqkbnr/pppp1ppp/8/8/3QP3/8/PPP2PPP/RNB1KB1R b KQkq - d7d6", null, null],
  ["r1bqkbnr/pppp2pp/2n5/1B2p3/4N3/5N2/PPPP1PPP/R1BQK2R b KQkq - d7d5", null, null],
  [
    "r1bqkbnr/pppp2pp/2n5/1B2p3/4N3/5N2/PPPP1PPP/R1BQK2R b KQkq - f8e7",
    "C63",
    "Ruy Lopez: Schliemann Defense, Kostić Defense",
  ],
  [
    "r1bqkbnr/pppp2pp/2n5/1B2p3/4N3/5N2/PPPP1PPP/R1BQK2R b KQkq - g8f6",
    "C63",
    "Ruy Lopez: Schliemann Defense, Tartakower Variation",
  ],
  ["r1bqkbnr/pppp2pp/2n5/1B2p3/4p3/2N2N2/PPPP1PPP/R1BQK2R w KQkq - c3e4", null, null],
  ["r1bqkbnr/pppp2pp/2n5/1B2pp2/4P3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - f5e4", null, null],
  [
    "r1bqkbnr/pppp2pp/2n5/1B2pp2/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b1c3",
    "C63",
    "Ruy Lopez: Schliemann Defense, Dyckhoff Variation",
  ],
  [
    "r1bqkbnr/pppp2pp/2n5/1B2pp2/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b5c6",
    "C63",
    "Ruy Lopez: Schliemann Defense, Exchange Variation",
  ],
  [
    "r1bqkbnr/pppp2pp/2n5/1B2pp2/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - d2d4",
    "C63",
    "Ruy Lopez: Schliemann Defense, Schönemann Attack",
  ],
  [
    "r1bqkbnr/pppp2pp/2n5/1B2pp2/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e4f5",
    "C63",
    "Ruy Lopez: Schliemann Defense, Jaenisch Gambit Accepted",
  ],
  ["r1bqkbnr/pppp2pp/2n5/4pp2/3PP3/2P2N2/PP3PPP/RNBQKB1R b KQkq - d7d6", null, null],
  ["r1bqkbnr/pppp2pp/2n5/4pp2/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["r1bqkbnr/pppp2pp/2n5/4pp2/4P3/3P1N2/PPP2PPP/RNBQKB1R w KQkq - e4f5", "C44", "Latvian Gambit: Clam Gambit"],
  [
    "r1bqkbnr/ppppp1pp/2n5/5p2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - e4f5",
    "B00",
    "Nimzowitsch Defense: Colorado Countergambit Accepted",
  ],
  ["r1bqkbnr/pppppppp/2n5/3P4/8/8/PPP1PPPP/RNBQKBNR b KQkq - c6b8", "A40", "Montevideo Defense"],
  ["r1bqkbnr/pppppppp/2n5/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e7e5", null, null],
  ["r1bqkbnr/pppppppp/2n5/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["r1bqkbnr/pppppppp/2n5/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - d4d5", null, null],
  ["r1bqkbnr/pppppppp/2n5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - a7a6", "B00", "Nimzowitsch Defense: Woodchuck Variation"],
  [
    "r1bqkbnr/pppppppp/2n5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d7d5",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation",
  ],
  ["r1bqkbnr/pppppppp/2n5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d7d6", "B00", "Nimzowitsch Defense: Mikenas Variation"],
  ["r1bqkbnr/pppppppp/2n5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - e7e5", "B00", "Nimzowitsch Defense: Kennedy Variation"],
  [
    "r1bqkbnr/pppppppp/2n5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f7f6",
    "B00",
    "Nimzowitsch Defense: Neo-Mongoloid Defense",
  ],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - e7e6", "B00", "Nimzowitsch Defense: French Connection"],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - g7g6", "B00", "Nimzowitsch Defense: Pirc Connection"],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d7d6", "B00", "Nimzowitsch Defense: Williams Variation"],
  [
    "r1bqkbnr/pppppppp/2n5/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - e7e6",
    "B00",
    "Nimzowitsch Defense: Franco-Nimzowitsch Variation",
  ],
  [
    "r1bqkbnr/pppppppp/2n5/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - f7f5",
    "B00",
    "Nimzowitsch Defense: Colorado Countergambit",
  ],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b4", "B00", "Nimzowitsch Defense: Wheeler Gambit"],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", "B00", "Nimzowitsch Defense"],
  [
    "r1bqkbnr/pppppppp/2n5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1b5",
    "B00",
    "Nimzowitsch Defense: Pseudo-Spanish Variation",
  ],
  ["r1bqkbnr/pppppppp/2n5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1f3", "B00", "Nimzowitsch Defense: Declined Variation"],
  ["r1bqkbnr/pppppppp/2n5/8/8/2N3P1/PPPPPP1P/R1BQKBNR b KQkq - d7d5", null, null],
  ["r1bqkbnr/pppppppp/2n5/8/8/6P1/PPPPPP1P/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "r1bqkbnr/pppppppp/n7/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - c7c5",
    "A04",
    "Zukertort Defense: Sicilian Knight Variation",
  ],
  [
    "r1bqkbnr/pppppppp/n7/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - g8h6",
    "A04",
    "Zukertort Opening: Drunken Cavalry Variation",
  ],
  ["r1bqkbnr/pppppppp/n7/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - e2e4", null, null],
  [
    "r1bqr1k1/pp1n1ppp/2pbpn2/3p4/2PP4/1PN1PN2/PBQ2PPP/R3KB1R w KQ - f1d3",
    "D46",
    "Semi-Slav Defense: Chigorin Defense",
  ],
  [
    "r1bqr1k1/pp2bpp1/2n2n1p/3p4/3N4/2N1B1P1/PP2PPBP/2RQ1RK1 b - - c8e6",
    "D34",
    "Tarrasch Defense: Classical Variation, Chandler Variation",
  ],
  ["r1bqr1k1/pp2bpp1/2n2n1p/3p4/3N4/2N1B1P1/PP2PPBP/R2Q1RK1 w - - a1c1", null, null],
  [
    "r1bqr1k1/pp3pbp/n2p1np1/2pP4/4P3/2N5/PP1NBPPP/R1BQ1RK1 w - - f2f3",
    "A79",
    "Benoni Defense: Classical Variation, Czerniak Defense",
  ],
  ["r1bqr1k1/ppp2pbp/3p1np1/2n5/2PNP3/2N3PP/PP3PB1/R1BQ1RK1 w - - f1e1", null, null],
  [
    "r1bqr1k1/ppp2pbp/3p1np1/2n5/2PNP3/2N3PP/PP3PB1/R1BQR1K1 b - - a7a5",
    "E68",
    "King's Indian Defense: Fianchetto Variation, Long Variation",
  ],
  ["r1bqr1k1/ppp2ppp/2np1n2/8/1bB1P3/2N1Q3/PPPB1PPP/2KR2NR w - - g1h3", "C22", "Center Game: Kupreichik Variation"],
  ["r1bqr1k1/pppn1pbp/3p1np1/4p3/2PPP3/2N2NP1/PP3PBP/R1BQ1RK1 w - - h2h3", null, null],
  ["r1bqr1k1/pppn1pbp/3p1np1/4p3/2PPP3/2N2NPP/PP3PB1/R1BQ1RK1 b - - e5d4", null, null],
  ["r1bqr1k1/pppn1pbp/3p1np1/8/2PNP3/2N3PP/PP3PB1/R1BQ1RK1 b - - d7c5", null, null],
  ["r1bqr1k1/pppn1pbp/3p1np1/8/2PpP3/2N2NPP/PP3PB1/R1BQ1RK1 w - - f3d4", null, null],
  ["r1bqr1k1/pppnbppp/5n2/3p2B1/3P4/2NBP3/PPQ1NPPP/R3K2R b KQ - d7f8", null, null],
  ["r1bqr1k1/pppnbppp/5n2/3p2B1/3P4/2NBP3/PPQ2PPP/R3K1NR w KQ - g1e2", null, null],
  [
    "r1bqr1k1/pppp1ppp/2n2n2/3Np3/1bP5/4PN2/PPQP1PPP/R1B1KB1R w KQ - c2f5",
    "A28",
    "English Opening: King's English Variation, Four Knights Variation, Quiet Line",
  ],
  ["r1bqr1k1/pppp1ppp/2n2n2/8/1b2P3/2N1Q3/PPPB1PPP/2KR1BNR w - - f1c4", null, null],
  ["r1bqr1k1/pppp1ppp/2n2n2/8/1bB1P3/2N1Q3/PPPB1PPP/2KR2NR b - - d7d6", null, null],
  [
    "r1bqrnk1/ppp1bppp/5n2/3p2B1/3P4/2NBP3/PPQ1NPPP/R3K2R w KQ - e1c1",
    "D35",
    "Queen's Gambit Declined: Exchange Variation, Chameleon Variation",
  ],
  [
    "r1r3k1/pp1bppbp/2np1np1/q7/2BNP2P/2N1BP2/PPPQ2P1/2KR3R w - - c4b3",
    "B79",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack",
  ],
  [
    "r1r3k1/pp1bppbp/2np1np1/q7/3NP2P/1BN1BP2/PPPQ2P1/2KR3R b - - h7h5",
    "B79",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Soltis Variation",
  ],
  ["r2q1bnr/ppp1kBpp/3p4/4N3/4P3/2N5/PP3PPP/R1Bb1RK1 w - - c3d5", "C44", "Scotch Game: Sea-Cadet Mate"],
  [
    "r2q1knr/pppb1Bpp/1b1p4/n7/3PP3/1QN2N2/P4PPP/R1B2RK1 w - - b3c2",
    "C51",
    "Italian Game: Evans Gambit, Fraser-Mortimer Attack",
  ],
  [
    "r2q1knr/pppb1Bpp/1b1p4/n7/3PP3/2N2N2/P1Q2PPP/R1B2RK1 b - - f8f7",
    "C51",
    "Italian Game: Evans Gambit, Mortimer-Evans Gambit",
  ],
  ["r2q1rk1/1bp1bppp/p1np1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1 b - - f8e8", null, null],
  ["r2q1rk1/1bp1bppp/p1np1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 w - - d2d4", null, null],
  ["r2q1rk1/1bpnbppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP1N1PP1/R1BQR1K1 w - - b3c2", null, null],
  [
    "r2q1rk1/1bpnbppp/p2p1n2/1p2p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1 b - - c7c5",
    "C95",
    "Ruy Lopez: Closed, Breyer Defense",
  ],
  ["r2q1rk1/1ppbbppp/p1np1n2/4p3/B2PP3/2P2N2/PP1N1PPP/R1BQ1RK1 w - - f1e1", null, null],
  [
    "r2q1rk1/1ppbbppp/p1np1n2/4p3/B2PP3/2P2N2/PP1N1PPP/R1BQR1K1 b - - d7e8",
    "C72",
    "Ruy Lopez: Closed, Kecskemet Variation",
  ],
  ["r2q1rk1/2p1bppp/p1n1b3/1p1pP3/2P1n3/1B3N2/PP2QPPP/RNBR2K1 b - - b5c4", null, null],
  ["r2q1rk1/2p1bppp/p1n1b3/1p1pP3/3Nn3/1BP5/PP3PPP/RNBQR1K1 b - - c6e5", "C83", "Ruy Lopez: Open, Breslau Variation"],
  ["r2q1rk1/2p1bppp/p1n1b3/1p1pP3/3Nn3/1BP5/PP3PPP/RNBQR1K1 b - - d8d7", null, null],
  ["r2q1rk1/2p1bppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNBR2K1 w - - c2c4", null, null],
  ["r2q1rk1/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP1N1PPP/R1BQ1RK1 w - - d1e2", "C83", "Ruy Lopez: Open, Malkin Variation"],
  ["r2q1rk1/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQR1K1 w - - f3d4", null, null],
  [
    "r2q1rk1/2p1bppp/p1n1b3/3pP3/2B1n3/5N2/PP2QPPP/RNBR2K1 b - - d8d7",
    "C81",
    "Ruy Lopez: Open, Howell Attack, Ekstrom Variation",
  ],
  ["r2q1rk1/2p1bppp/p1n1b3/3pP3/2p1n3/1B3N2/PP2QPPP/RNBR2K1 w - - b3c4", null, null],
  [
    "r2q1rk1/2p1bppp/p1np1n2/1p2p3/3PP1b1/1BP2N2/PP3PPP/RNBQR1K1 w - - a2a4",
    "C91",
    "Ruy Lopez: Closed, Yates Variation, Short Attack",
  ],
  ["r2q1rk1/2p2ppp/p1n1b3/1pbpP3/4n3/1BP2N2/PP1N1PPP/R1BQ1RK1 w - - b3c2", null, null],
  ["r2q1rk1/2p2ppp/p1n1b3/1pbpP3/4n3/2P2N2/PPBN1PPP/R1BQ1RK1 b - - e4f2", "C82", "Ruy Lopez: Open, Dilworth Variation"],
  ["r2q1rk1/pb1n1ppp/2pbpn2/1p6/3P4/P1NBPN2/1P3PPP/R1BQ1RK1 w - - d1c2", "D46", "Semi-Slav Defense: Chigorin Defense"],
  ["r2q1rk1/pb1nbppp/1pp1p3/8/2PPnB2/5NP1/PPQ2PBP/R4RK1 w - - c2e4", "E09", "Catalan Opening: Closed, Main Line"],
  ["r2q1rk1/pb1nbppp/1pp1pn2/3p4/2PP1B2/5NP1/PPQNPPBP/R4RK1 w - - e2e4", "E08", "Catalan Opening: Closed"],
  ["r2q1rk1/pb1nbppp/1pp1pn2/3p4/2PP4/1P3NP1/P1Q1PPBP/RNBR2K1 w - - b1c3", null, null],
  [
    "r2q1rk1/pb1nbppp/1pp1pn2/3p4/2PP4/1PN2NP1/P1Q1PPBP/R1BR2K1 b - - b6b5",
    "E08",
    "Catalan Opening: Closed, Spassky Gambit",
  ],
  ["r2q1rk1/pb1nbppp/1pp1pn2/3p4/2PP4/1PNBPN2/P1Q2PPP/R1B2RK1 w - - c1b2", "D46", "Semi-Slav Defense: Main Line"],
  ["r2q1rk1/pb1nbppp/1pp1pn2/3p4/2PPPB2/5NP1/PPQN1PBP/R4RK1 b - - d5e4", null, null],
  ["r2q1rk1/pb1nbppp/1pp1pn2/8/2PPNB2/5NP1/PPQ2PBP/R4RK1 b - - f6e4", null, null],
  ["r2q1rk1/pb1nbppp/1pp1pn2/8/2PPpB2/5NP1/PPQN1PBP/R4RK1 w - - d2e4", null, null],
  [
    "r2q1rk1/pp1bbppp/2nppn2/8/3NPP2/2N1B3/PPP1B1PP/R2Q1RK1 w - - d4b3",
    "B83",
    "Sicilian Defense: Scheveningen Variation, Modern Variation",
  ],
  ["r2q1rk1/pp1bppbp/2np1np1/8/2BNP2P/2N1BP2/PPPQ2P1/R3K2R b KQ - d8a5", null, null],
  [
    "r2q1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/2KR3R b - - a8b8",
    "B78",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Chinese Dragon",
  ],
  [
    "r2q1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/2KR3R b - - a8c8",
    "B78",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Old Line",
  ],
  ["r2q1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/2KR3R b - - d8a5", null, null],
  [
    "r2q1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R w KQ - c4b3",
    "B77",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Main Line",
  ],
  [
    "r2q1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R w KQ - e1c1",
    "B78",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack",
  ],
  ["r2q1rk1/pp1bppbp/2np1np1/8/2BNP3/2N1BP2/PPPQ2PP/R3K2R w KQ - h2h4", null, null],
  [
    "r2q1rk1/pp2bppp/2n1bn2/2pp2B1/3P4/2N2NP1/PP2PPBP/2RQ1RK1 b - - b7b6",
    "D34",
    "Queen's Gambit Declined: Tarrasch Defense, Stoltz Variation",
  ],
  [
    "r2q1rk1/pp2bppp/2n1bn2/2pp2B1/3P4/2N2NP1/PP2PPBP/2RQ1RK1 b - - c5c4",
    "D34",
    "Tarrasch Defense: Classical Variation, Bogoljubow Variation",
  ],
  ["r2q1rk1/pp2bppp/2n1bn2/2pp2B1/3P4/2N2NP1/PP2PPBP/R2Q1RK1 w - - a1c1", null, null],
  ["r2q1rk1/pp2bppp/2npbn2/2p3B1/4P3/2N2N2/PPP1BPPP/R2Q1RK1 w - - f1e1", "C41", "Philidor Defense: Berger Variation"],
  [
    "r2q1rk1/pp2ppbp/1nnp2p1/5b2/2PP4/2N2N1P/PP2BPP1/R1BQ1RK1 w - - c1f4",
    "B03",
    "Alekhine Defense: Exchange Variation, Karpov Variation",
  ],
  ["r2q1rk1/pp2ppbp/2n3p1/2p5/2BPP1b1/2P1B3/P3NPPP/R2Q1RK1 w - - f2f3", null, null],
  ["r2q1rk1/pp2ppbp/2n3p1/2p5/2BPP1b1/2P1BP2/P3N1PP/R2Q1RK1 b - - c6a5", null, null],
  ["r2q1rk1/pp2ppbp/2npbnp1/8/4P3/1NN1B3/PPP1BPPP/R2Q1RK1 w - - f2f4", null, null],
  [
    "r2q1rk1/pp2ppbp/2npbnp1/8/4PP2/1NN1B3/PPP1B1PP/R2Q1RK1 b - - c6a5",
    "B74",
    "Sicilian Defense: Dragon Variation, Classical Variation, Maróczy Line",
  ],
  [
    "r2q1rk1/pp2ppbp/2npbnp1/8/4PP2/1NN1B3/PPP1B1PP/R2Q1RK1 b - - d8c8",
    "B74",
    "Sicilian Defense: Dragon Variation, Classical Variation, Tartakower Line",
  ],
  ["r2q1rk1/pp2ppbp/2npbnp1/8/4PP2/1NN1B3/PPP1B1PP/R2QK2R w KQ - e1g1", null, null],
  ["r2q1rk1/pp2ppbp/3p1np1/n4P2/2b1P3/1NN1B3/PPP1B1PP/R2Q1RK1 w - - b3a5", null, null],
  [
    "r2q1rk1/pp2ppbp/3p1np1/n4P2/2b1P3/1NN1B3/PPP1B1PP/R2Q1RK1 w - - e2d3",
    "B74",
    "Sicilian Defense: Dragon Variation, Classical Variation, Spielmann Variation",
  ],
  ["r2q1rk1/pp2ppbp/3p1np1/n4P2/2b1P3/1NNBB3/PPP3PP/R2Q1RK1 b - - c4d3", null, null],
  ["r2q1rk1/pp2ppbp/3p1np1/N4P2/2b1P3/2N1B3/PPP1B1PP/R2Q1RK1 b - - c4e2", null, null],
  ["r2q1rk1/pp2ppbp/3p1np1/n4P2/4P3/1NNbB3/PPP3PP/R2Q1RK1 w - - c2d3", null, null],
  [
    "r2q1rk1/pp2ppbp/3p1np1/n4P2/4P3/1NNPB3/PP4PP/R2Q1RK1 b - - d6d5",
    "B74",
    "Sicilian Defense: Dragon Variation, Classical Variation, Bernard Defense",
  ],
  ["r2q1rk1/pp2ppbp/3p1np1/N4P2/4P3/2N1B3/PPP1b1PP/R2Q1RK1 w - - d1e2", null, null],
  ["r2q1rk1/pp2ppbp/3p1np1/N4P2/4P3/2N1B3/PPP1Q1PP/R4RK1 b - - d8a5", null, null],
  ["r2q1rk1/pp2ppbp/3pbnp1/n4P2/4P3/1NN1B3/PPP1B1PP/R2Q1RK1 b - - e6c4", null, null],
  ["r2q1rk1/pp2ppbp/3pbnp1/n7/4PP2/1NN1B3/PPP1B1PP/R2Q1RK1 w - - f4f5", null, null],
  [
    "r2q1rk1/pp2ppbp/4b1p1/n7/3PP3/3BBP2/P3N1PP/R2Q1RK1 w - - d4d5",
    "D89",
    "Grünfeld Defense: Exchange Variation, Sokolsky Variation",
  ],
  ["r2q1rk1/pp2ppbp/6p1/n1p5/2BPP1b1/2P1BP2/P3N1PP/R2Q1RK1 w - - c4d3", null, null],
  [
    "r2q1rk1/pp2ppbp/6p1/n1p5/2BPP1b1/2P1BP2/P3N1PP/R2Q1RK1 w - - c4f7",
    "D87",
    "Grünfeld Defense: Exchange Variation, Seville Variation",
  ],
  ["r2q1rk1/pp2ppbp/6p1/n1p5/3PP1b1/2PBBP2/P3N1PP/R2Q1RK1 b - - c5d4", null, null],
  ["r2q1rk1/pp2ppbp/6p1/n7/3pP1b1/2PBBP2/P3N1PP/R2Q1RK1 w - - c3d4", null, null],
  [
    "r2q1rk1/pp2ppbp/6p1/n7/3PP1b1/3BBP2/P3N1PP/R2Q1RK1 b - - g4e6",
    "D89",
    "Grünfeld Defense: Exchange Variation, Spassky Variation",
  ],
  [
    "r2q1rk1/ppp1ppbp/1nn3p1/8/3PP1b1/2NQBN2/PP2BPPP/R3K2R w KQ - e1c1",
    "D98",
    "Grünfeld Defense: Russian Variation, Keres Variation",
  ],
  [
    "r2qk1nr/ppp2ppp/1bnp4/8/2BPP1b1/2N2N2/P4PPP/R1BQ1RK1 w kq - d1a4",
    "C51",
    "Italian Game: Evans Gambit, Fraser Attack",
  ],
  ["r2qk1nr/ppp2ppp/1bnp4/8/Q1BPP1b1/2N2N2/P4PPP/R1B2RK1 b kq - g4d7", null, null],
  [
    "r2qk1nr/ppp2ppp/2n5/4P3/1bPp4/5N1P/PP1BPPP1/R2QKB1R b KQkq - d8e7",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit, Krenosz Variation",
  ],
  ["r2qk1nr/ppp2ppp/2n5/4P3/1bPp4/5N1P/PP2PPP1/R1BQKB1R w KQkq - c1d2", null, null],
  ["r2qk1nr/pppb1Bpp/1b1p4/n7/3PP3/1QN2N2/P4PPP/R1B2RK1 b kq - e8f8", null, null],
  ["r2qk1nr/pppb1ppp/1b1p4/n7/2BPP3/1QN2N2/P4PPP/R1B2RK1 w kq - c4f7", null, null],
  ["r2qk1nr/pppb1ppp/1bnp4/8/2BPP3/1QN2N2/P4PPP/R1B2RK1 b kq - c6a5", null, null],
  ["r2qk1nr/pppb1ppp/1bnp4/8/Q1BPP3/2N2N2/P4PPP/R1B2RK1 w kq - a4b3", null, null],
  ["r2qk2r/1p1bbppp/p1nppn2/6B1/3NPP2/2N5/PPPQ2PP/2KR1B1R w kq - d4f3", null, null],
  ["r2qk2r/1p1bbppp/p1nppn2/6B1/4PP2/2N2N2/PPPQ2PP/2KR1B1R b kq - b7b5", null, null],
  ["r2qk2r/1ppbbppp/p1np1n2/4p3/B2PP3/2P2N2/PP1N1PPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r2qk2r/1ppbbppp/p1np1n2/4p3/B2PP3/2P2N2/PP3PPP/RNBQ1RK1 w kq - b1d2", null, null],
  ["r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNB2RK1 w kq - c2c4", "C81", "Ruy Lopez: Open, Howell Attack"],
  ["r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNB2RK1 w kq - f1d1", null, null],
  ["r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNBR2K1 b kq - e8g8", null, null],
  [
    "r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQR1K1 w kq - c2c3",
    "C83",
    "Ruy Lopez: Open, Classical Defense, Main Line",
  ],
  ["r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP1N1PPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1 w kq - b1d2", null, null],
  [
    "r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1 w kq - f1e1",
    "C83",
    "Ruy Lopez: Open, Classical Defense, Main Line",
  ],
  ["r2qk2r/2p1bppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQR1K1 b kq - e8g8", null, null],
  [
    "r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1B3N2/PPPN1PPP/R1BQ1RK1 w kq - d1e1",
    "C80",
    "Ruy Lopez: Open, Bernstein Variation, Luther Line",
  ],
  ["r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1BP2N2/PP1N1PPP/R1BQ1RK1 b kq - e8g8", null, null],
  [
    "r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1 w kq - b1d2",
    "C82",
    "Ruy Lopez: Open, St. Petersburg Variation",
  ],
  ["r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1 w kq - d1d3", "C82", "Ruy Lopez: Open, Motzko Attack"],
  [
    "r2qk2r/2p2ppp/p1n1b3/1pbpP3/4n3/1BPQ1N2/PP3PPP/RNB2RK1 b kq - c6e7",
    "C82",
    "Ruy Lopez: Open, Motzko Attack, Nenarokov Variation",
  ],
  [
    "r2qk2r/3bbppp/p1nppn2/1p4B1/4PP2/2N2N2/PPPQ2PP/2KR1B1R w kq - g5f6",
    "B69",
    "Sicilian Defense: Richter-Rauzer Variation, Neo-Modern Variation, Nyezhmetdinov Attack",
  ],
  ["r2qk2r/pb1n1ppp/2pbpn2/1p6/3P4/2NBPN2/PP3PPP/R1BQ1RK1 w kq - a2a3", null, null],
  ["r2qk2r/pb1n1ppp/2pbpn2/1p6/3P4/P1NBPN2/1P3PPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["r2qk2r/pb1nbppp/1pp1pn2/3p4/2PP4/1PNBPN2/P1Q2PPP/R1B1K2R w KQkq - e1g1", null, null],
  ["r2qk2r/pb1nbppp/1pp1pn2/3p4/2PP4/1PNBPN2/P1Q2PPP/R1B2RK1 b kq - e8g8", null, null],
  [
    "r2qk2r/ppp1b1pp/2n5/3p1p2/2PPn1b1/3B1N2/PP3PPP/RNBQR1K1 b kq - e7h4",
    "C42",
    "Petrov's Defense: Classical Attack, Maróczy Variation",
  ],
  [
    "r2qk2r/ppp1b1pp/2n5/3p1p2/3Pn1b1/2PB1N2/PP3PPP/RNBQR1K1 w kq - b1d2",
    "C42",
    "Petrov's Defense: Classical Attack, Berger Variation",
  ],
  [
    "r2qk2r/ppp1b1pp/2n5/3p1p2/3Pn1b1/2PB1N2/PP3PPP/RNBQR1K1 w kq - c3c4",
    "C42",
    "Petrov's Defense: Classical Attack, Krause Variation",
  ],
  ["r2qk2r/ppp1bppp/2n5/3p4/3Pn1b1/2PB1N2/PP3PPP/RNBQR1K1 b kq - f7f5", null, null],
  ["r2qk2r/ppp1bppp/2n5/3p4/3Pn1b1/3B1N2/PPP2PPP/RNBQR1K1 w kq - c2c3", null, null],
  ["r2qk2r/ppp2ppp/2n1bP2/2b3N1/2pp4/8/PPP2PPP/RNBQR1K1 b kq - d8d5", null, null],
  [
    "r2qk2r/ppp2ppp/2n1bP2/2b3N1/2pp4/8/PPP2PPP/RNBQR1K1 b kq - g7g6",
    "C56",
    "Italian Game: Two Knights Defense, Max Lange Attack, Loman Defense",
  ],
  ["r2qk2r/ppp2ppp/2n1bP2/2b5/2pp4/5N2/PPP2PPP/RNBQR1K1 w kq - f3g5", null, null],
  [
    "r2qk2r/ppp2ppp/2n1bP2/2b5/2pp4/5N2/PPP2PPP/RNBQR1K1 w kq - f6g7",
    "C56",
    "Italian Game: Scotch Gambit, Max Lange Attack Accepted",
  ],
  ["r2qk2r/ppp2ppp/2np1n2/2b1p3/2B1PP2/2NP1b1P/PPP3P1/R1BQK2R w KQkq - d1f3", null, null],
  [
    "r2qk2r/ppp2ppp/2np1n2/2b1p3/2B1PP2/2NP1Q1P/PPP3P1/R1B1K2R b KQkq - e5f4",
    "C30",
    "King's Gambit Declined: Classical, Svenonius Variation",
  ],
  ["r2qk2r/ppp2ppp/2np1n2/2b1p3/2B1PPb1/2NP1N1P/PPP3P1/R1BQK2R b KQkq - g4f3", null, null],
  ["r2qk2r/ppp2ppp/2np1n2/2b1p3/2B1PPb1/2NP1N2/PPP3PP/R1BQK2R w KQkq - h2h3", null, null],
  [
    "r2qk2r/pppbbppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQ1RK1 w kq - b5c6",
    "C66",
    "Ruy Lopez: Berlin Defense, Closed Showalter Variation",
  ],
  [
    "r2qk2r/pppbbppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQ1RK1 w kq - c1g5",
    "C66",
    "Ruy Lopez: Berlin Defense, Closed Bernstein Variation",
  ],
  ["r2qk2r/pppbbppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQ1RK1 w kq - f1e1", null, null],
  [
    "r2qk2r/pppbbppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQR1K1 b kq - e8g8",
    "C66",
    "Ruy Lopez: Berlin Defense, Tarrasch Trap",
  ],
  ["r2qkb1r/1b1n1ppp/p3pn2/1pp5/3P4/1B2PN2/PP2QPPP/RNBR2K1 w kq - b1c3", null, null],
  [
    "r2qkb1r/1b1n1ppp/p3pn2/1pp5/3P4/1BN1PN2/PP2QPPP/R1BR2K1 b kq - f8d6",
    "D29",
    "Queen's Gambit Accepted: Classical Defense, Alekhine System, Smyslov Variation",
  ],
  [
    "r2qkb1r/1b3ppp/p3pn2/1p1P4/2p5/2N1PN2/PPQ2PPP/R1BR2K1 b kq - d8c7",
    "D28",
    "Queen's Gambit Accepted: Classical, Flohr Variation",
  ],
  ["r2qkb1r/1b3ppp/p3pn2/1p6/2pP4/2N1PN2/PPQ2PPP/R1BR2K1 w kq - d4d5", null, null],
  ["r2qkb1r/1p1b1ppp/p1nppn2/6B1/3NP3/2N5/PPPQ1PPP/2KR1B1R w kq - f2f4", null, null],
  [
    "r2qkb1r/1p1b1ppp/p1nppn2/6B1/3NPP2/2N5/PPPQ2PP/2KR1B1R b kq - f8e7",
    "B68",
    "Sicilian Defense: Richter-Rauzer Variation, Neo-Modern Variation",
  ],
  ["r2qkb1r/1p1bpppp/p1Bp1n2/2p5/4P3/2P2N2/PP1P1PPP/RNBQR1K1 b kq - d7c6", null, null],
  ["r2qkb1r/1p1bpppp/p1np1n2/1Bp5/4P3/2P2N2/PP1P1PPP/RNBQR1K1 w kq - b5c6", null, null],
  ["r2qkb1r/1p2pppp/p1bp1n2/2p5/3PP3/2P2N2/PP3PPP/RNBQR1K1 b kq - c6e4", null, null],
  ["r2qkb1r/1p2pppp/p1bp1n2/2p5/4P3/2P2N2/PP1P1PPP/RNBQR1K1 w kq - d2d4", null, null],
  [
    "r2qkb1r/1p2pppp/p2p1n2/2p5/3Pb3/2P2N2/PP3PPP/RNBQR1K1 w kq - c1g5",
    "B51",
    "Sicilian Defense: Moscow Variation, Moscow Gambit",
  ],
  ["r2qkb1r/1ppb1ppp/p1np1n2/4p3/B2PP3/2P2N2/PP3PPP/RNBQ1RK1 b kq - f8e7", null, null],
  ["r2qkb1r/1ppb1ppp/p1np1n2/4p3/B3P3/2P2N2/PP1P1PPP/RNBQ1RK1 w kq - d2d4", null, null],
  ["r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP1QPPP/RNB2RK1 b kq - f8e7", null, null],
  [
    "r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1 w kq - b1d2",
    "C80",
    "Ruy Lopez: Open, Bernstein Variation",
  ],
  ["r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1 w kq - c2c3", "C82", "Ruy Lopez: Open"],
  ["r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPP2PPP/RNBQ1RK1 w kq - d1e2", "C81", "Ruy Lopez: Open, Howell Attack"],
  ["r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPPN1PPP/R1BQ1RK1 b kq - e4c5", null, null],
  ["r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1B3N2/PPPN1PPP/R1BQ1RK1 b kq - f8c5", null, null],
  ["r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1 b kq - e4c5", "C82", "Ruy Lopez: Open, Berlin Variation"],
  ["r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1 b kq - f8c5", "C82", "Ruy Lopez: Open, Italian Variation"],
  ["r2qkb1r/2p2ppp/p1n1b3/1p1pP3/4n3/1BP2N2/PP3PPP/RNBQ1RK1 b kq - f8e7", "C83", "Ruy Lopez: Open, Classical Defense"],
  ["r2qkb1r/2p2ppp/p1n1b3/1pn1P3/3p4/1BP2N2/PP1N1PPP/R1BQ1RK1 w kq - f3g5", "C80", "Ruy Lopez: Open, Karpov Gambit"],
  ["r2qkb1r/2p2ppp/p1n1b3/1pnpP3/8/1B3N2/PPPN1PPP/R1BQ1RK1 w kq - c2c3", null, null],
  ["r2qkb1r/2p2ppp/p1n1b3/1pnpP3/8/1BP2N2/PP1N1PPP/R1BQ1RK1 b kq - d5d4", null, null],
  ["r2qkb1r/2p2ppp/p1n1b3/1pnpP3/8/1BP2N2/PP1N1PPP/R1BQ1RK1 b kq - f8e7", "C83", "Ruy Lopez: Open, Classical Defense"],
  [
    "r2qkb1r/pb1n1ppp/1pp1pn2/3p4/2PP4/1PN1PN2/P1Q2PPP/R1B1KB1R w KQkq - f1d3",
    "D46",
    "Semi-Slav Defense: Chigorin Defense",
  ],
  ["r2qkb1r/pb1n1ppp/1pp1pn2/3p4/2PP4/1PNBPN2/P1Q2PPP/R1B1K2R b KQkq - f8e7", null, null],
  ["r2qkb1r/pb1n1ppp/2p1pn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R w KQkq - e3e4", null, null],
  ["r2qkb1r/pb1n1ppp/2p1pn2/1p6/3PP3/2NB1N2/PP3PPP/R1BQK2R b KQkq - b5b4", null, null],
  ["r2qkb1r/pb1n1ppp/2p1pn2/8/1p1PP3/2NB1N2/PP3PPP/R1BQK2R w KQkq - c3a4", null, null],
  ["r2qkb1r/pb1n1ppp/2p1pn2/8/Np1PP3/3B1N2/PP3PPP/R1BQK2R b KQkq - c6c5", null, null],
  ["r2qkb1r/pb1n1ppp/4p3/2pnP3/Np1P4/3B1N2/PP3PPP/R1BQ1RK1 b kq - c5d4", null, null],
  ["r2qkb1r/pb1n1ppp/4p3/2pnP3/Np1P4/3B1N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "r2qkb1r/pb1n1ppp/4p3/3nP3/Np1p4/3B1N2/PP3PPP/R1BQ1RK1 w kq - f3d4",
    "D47",
    "Semi-Slav Defense: Meran Variation, Wade Variation, Kaidanov Gambit",
  ],
  [
    "r2qkb1r/pb1n1ppp/4pn2/2p1P3/Np1P4/3B1N2/PP3PPP/R1BQK2R b KQkq - f6d5",
    "D47",
    "Semi-Slav Defense: Meran Variation, Wade Variation, Larsen Variation",
  ],
  ["r2qkb1r/pb1n1ppp/4pn2/2p5/Np1PP3/3B1N2/PP3PPP/R1BQK2R w KQkq - e4e5", null, null],
  ["r2qkb1r/pp1bpppp/2np1n2/1Bp5/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 w kq - f1e1", null, null],
  ["r2qkb1r/pp1bpppp/2np1n2/1Bp5/4P3/2P2N2/PP1P1PPP/RNBQR1K1 b kq - a7a6", null, null],
  [
    "r2qkb1r/pp1bpppp/2np1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R w KQkq - d1d2",
    "B61",
    "Sicilian Defense: Richter-Rauzer Variation, Modern Variation",
  ],
  [
    "r2qkb1r/pp1n1pp1/2p1pn1p/7P/3P4/3Q1NN1/PPPB1PP1/2KR3R b kq - f8d6",
    "B19",
    "Caro-Kann Defense: Classical Variation, Seirawan Variation",
  ],
  [
    "r2qkb1r/pp1n1pp1/2p1pn1p/7P/3P4/3Q1NN1/PPPB1PP1/2KR3R b kq - f8e7",
    "B19",
    "Caro-Kann Defense: Classical Variation, Lobron System",
  ],
  ["r2qkb1r/pp1n1pp1/2p1pn1p/7P/3P4/3Q1NN1/PPPB1PP1/R3K2R w KQkq - e1c1", null, null],
  ["r2qkb1r/pp1nppp1/2p2n1p/7P/3P4/3Q1NN1/PPP2PP1/R1B1K2R w KQkq - c1d2", null, null],
  ["r2qkb1r/pp1nppp1/2p2n1p/7P/3P4/3Q1NN1/PPPB1PP1/R3K2R b KQkq - e7e6", null, null],
  ["r2qkb1r/pp1npppp/2p2n2/4Nb2/P1pP4/2N5/1P2PPPP/R1BQKB1R w KQkq - e5c4", null, null],
  ["r2qkb1r/pp1npppp/2p2n2/5b2/P1NP4/2N5/1P2PPPP/R1BQKB1R b KQkq - d8c7", null, null],
  ["r2qkb1r/pp2pppp/2n2n2/3p1b2/3P1B2/2N1PN2/PP3PPP/R2QKB1R b KQkq - e7e6", null, null],
  ["r2qkb1r/pp2pppp/2n2n2/3p1b2/3P1B2/2N2N2/PP2PPPP/R2QKB1R w KQkq - e2e3", null, null],
  [
    "r2qkb1r/pp2pppp/n1p2n2/4Nb2/P1pP4/2N5/1P2PPPP/R1BQKB1R w KQkq - e2e4",
    "D17",
    "Slav Defense: Czech Variation, Krause Attack, Fazekas Gambit",
  ],
  [
    "r2qkb1r/pp3ppp/2n1pn2/3p1b2/3P1B2/1QN1PN2/PP3PPP/R3KB1R b KQkq - f8b4",
    "D14",
    "Slav Defense: Exchange Variation, Trifunovic Variation",
  ],
  ["r2qkb1r/pp3ppp/2n1pn2/3p1b2/3P1B2/2N1PN2/PP3PPP/R2QKB1R w KQkq - d1b3", null, null],
  [
    "r2qkb1r/ppp1p1pp/1nn1p3/8/2PP2b1/5N2/PP4PP/RNBQKB1R w KQkq - c4c5",
    "B03",
    "Alekhine Defense: Four Pawns Attack, Ilyin-Zhenevsky Variation",
  ],
  ["r2qkb1r/ppp1pppp/1nn1P3/8/2PP2b1/5N2/PP4PP/RNBQKB1R b KQkq - f7e6", null, null],
  ["r2qkb1r/ppp1pppp/1nn5/4P3/2PP2b1/5N2/PP4PP/RNBQKB1R w KQkq - e5e6", null, null],
  ["r2qkb1r/ppp1pppp/1nn5/4Pb2/2PP4/2N1B3/PP4PP/R2QKBNR b KQkq - e7e6", null, null],
  ["r2qkb1r/ppp1pppp/1nn5/4Pb2/2PP4/4B3/PP4PP/RN1QKBNR w KQkq - b1c3", null, null],
  ["r2qkb1r/ppp2ppp/1nn1p3/4Pb2/2PP4/2N1B3/PP4PP/R2QKBNR w KQkq - g1f3", null, null],
  ["r2qkb1r/ppp2ppp/1nn1p3/4Pb2/2PP4/2N1BN2/PP4PP/R2QKB1R b KQkq - d8d7", null, null],
  [
    "r2qkb1r/pppb1ppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQ1RK1 b kq - e5d4",
    "C66",
    "Ruy Lopez: Berlin Defense, Closed Wolf Variation",
  ],
  [
    "r2qkb1r/pppb1ppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQ1RK1 b kq - f8e7",
    "C66",
    "Ruy Lopez: Berlin Defense, Hedgehog Variation",
  ],
  [
    "r2qkb1r/pppb1ppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQK2R w KQkq - b5c6",
    "C62",
    "Ruy Lopez: Steinitz Defense, Nimzowitsch Attack",
  ],
  ["r2qkb1r/pppb1ppp/2np1n2/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r2qkb1r/pppb1ppp/2np1n2/1B2p3/3PP3/5N2/PPP2PPP/RNBQ1RK1 w kq - b1c3", null, null],
  [
    "r2qkb1r/pppnpppp/5n2/1B1P1b2/3P4/5P2/PPP3PP/RNBQK1NR w KQkq - b1c3",
    "B01",
    "Scandinavian Defense: Portuguese Gambit, Melbourne Shuffle Variation",
  ],
  [
    "r2qkb1r/pppnpppp/5n2/1B1P1b2/3P4/5P2/PPP3PP/RNBQK1NR w KQkq - c2c4",
    "B01",
    "Scandinavian Defense: Portuguese Gambit, Jadoul Variation",
  ],
  [
    "r2qkb1r/pppnpppp/5n2/1B1P4/3P2b1/8/PPP2PPP/RNBQK1NR w KQkq - b5e2",
    "B01",
    "Scandinavian Defense: Portuguese Gambit, Lusophobe Variation",
  ],
  [
    "r2qkbnr/1pp2ppp/p1p5/4p3/4P1b1/5N1P/PPPP1PP1/RNBQ1RK1 b kq - h7h5",
    "C69",
    "Ruy Lopez: Exchange Variation, Alapin Gambit",
  ],
  ["r2qkbnr/1pp2ppp/p1p5/4p3/4P1b1/5N2/PPPP1PPP/RNBQ1RK1 w kq - h2h3", null, null],
  [
    "r2qkbnr/1pp3pp/p1np4/4pb2/B7/2P2N2/PP1P1PPP/RNBQK2R w KQkq - e1g1",
    "C74",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  [
    "r2qkbnr/1ppb1ppp/p1np4/4p3/B2PP3/2P2N2/PP3PPP/RNBQK2R b KQkq - g8e7",
    "C75",
    "Ruy Lopez: Morphy Defense, Modern Steinitz Defense",
  ],
  ["r2qkbnr/1ppb1ppp/p1np4/4p3/B3P3/2P2N2/PP1P1PPP/RNBQ1RK1 b kq - g8f6", null, null],
  ["r2qkbnr/1ppb1ppp/p1np4/4p3/B3P3/2P2N2/PP1P1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["r2qkbnr/1ppb1ppp/p1np4/4p3/B3P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - c2c3", null, null],
  ["r2qkbnr/pBpnpppp/8/8/2Pp2b1/8/PP1PPP1P/RNBQK1NR w KQkq - b7a8", null, null],
  [
    "r2qkbnr/pp1bpp1p/2np2p1/1Bp5/4P3/5N2/PPPPQPPP/RNB2RK1 w kq - e4e5",
    "B51",
    "Sicilian Defense: Moscow Variation, Dorfman Gambit",
  ],
  ["r2qkbnr/pp1bpppp/2np4/1Bp5/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 b kq - g8f6", null, null],
  ["r2qkbnr/pp1bpppp/2np4/1Bp5/4P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - c2c3", null, null],
  ["r2qkbnr/pp1bpppp/2np4/1Bp5/4P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - d1e2", null, null],
  ["r2qkbnr/pp1bpppp/2np4/1Bp5/4P3/5N2/PPPPQPPP/RNB2RK1 b kq - g7g6", null, null],
  ["r2qkbnr/pp1n1pp1/2p1p2p/7P/3P4/3Q1NN1/PPP2PP1/R1B1K2R w KQkq - c1d2", null, null],
  ["r2qkbnr/pp1n1pp1/2p1p2p/7P/3P4/3Q1NN1/PPPB1PP1/R3K2R b KQkq - g8f6", null, null],
  ["r2qkbnr/pp1n1ppp/8/3pp3/3P4/8/PPP2PPP/RNBQK1NR w KQkq - d4e5", null, null],
  ["r2qkbnr/pp1n1ppp/8/3pP3/8/8/PPP2PPP/RNBQK1NR b KQkq - d7e5", null, null],
  ["r2qkbnr/pp1nppp1/2p3bp/7P/3P4/5NN1/PPP2PP1/R1BQKB1R b KQkq - g6h7", null, null],
  [
    "r2qkbnr/pp1nppp1/2p3bp/8/3P3P/5NN1/PPP2PP1/R1BQKB1R w KQkq - h4h5",
    "B19",
    "Caro-Kann Defense: Classical Variation, Spassky Variation",
  ],
  ["r2qkbnr/pp1nppp1/2p4p/7P/3P4/3b1NN1/PPP2PP1/R1BQK2R w KQkq - d1d3", null, null],
  ["r2qkbnr/pp1nppp1/2p4p/7P/3P4/3Q1NN1/PPP2PP1/R1B1K2R b KQkq - e7e6", null, null],
  ["r2qkbnr/pp1nppp1/2p4p/7P/3P4/3Q1NN1/PPP2PP1/R1B1K2R b KQkq - g8f6", null, null],
  ["r2qkbnr/pp1npppb/2p4p/7P/3P4/3B1NN1/PPP2PP1/R1BQK2R b KQkq - h7d3", null, null],
  ["r2qkbnr/pp1npppb/2p4p/7P/3P4/5NN1/PPP2PP1/R1BQKB1R w KQkq - f1d3", null, null],
  ["r2qkbnr/pp3ppp/8/3pn3/8/8/PPP2PPP/RNBQK1NR w KQkq - g1e2", "C23", "Bishop's Opening: Lisitsyn Variation"],
  [
    "r2qkbnr/ppp1pppp/2n5/3p4/2PP2b1/5N2/PP2PPPP/RNBQKB1R w KQkq - d1a4",
    "D07",
    "Queen's Gambit Declined: Chigorin Defense, Main Line, Alekhine Variation",
  ],
  ["r2qkbnr/ppp2Bpp/3p4/4N3/4P3/2N5/PP3PPP/R1Bb1RK1 b kq - e8e7", null, null],
  [
    "r2qkbnr/ppp2p1p/2n5/3P4/2BP1pb1/2N2p2/PPP3PP/R1BQ1RK1 w kq - d5c6",
    "C25",
    "Vienna Game: Pierce Gambit, Rushmere Attack",
  ],
  ["r2qkbnr/ppp2ppp/2n5/4P3/2Pp2b1/5N1P/PP1NPPP1/R1BQKB1R b KQkq - g4f3", null, null],
  ["r2qkbnr/ppp2ppp/2n5/4P3/2Pp2b1/5N2/PP1NPPPP/R1BQKB1R w KQkq - h2h3", null, null],
  ["r2qkbnr/ppp2ppp/2n5/4P3/2Pp4/5b1P/PP1NPPP1/R1BQKB1R w KQkq - d2f3", null, null],
  ["r2qkbnr/ppp2ppp/2n5/4P3/2Pp4/5N1P/PP2PPP1/R1BQKB1R b KQkq - f8b4", null, null],
  ["r2qkbnr/ppp2ppp/2np4/8/2B1P1b1/2N2N2/PP3PPP/R1BQ1RK1 b kq - c6e5", null, null],
  ["r2qkbnr/ppp2ppp/2np4/8/2B1P1b1/2N2N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["r2qkbnr/ppp2ppp/3p4/4n3/2B1P1b1/2N2N2/PP3PPP/R1BQ1RK1 w kq - f3e5", null, null],
  ["r2qkbnr/ppp2ppp/3p4/4N3/2B1P1b1/2N5/PP3PPP/R1BQ1RK1 b kq - g4d1", null, null],
  ["r2qkbnr/ppp2ppp/3p4/4N3/2B1P3/2N5/PP3PPP/R1Bb1RK1 w kq - c4f7", null, null],
  ["r2qkbnr/pppb1ppp/2np4/1B2p3/3PP3/2N2N2/PPP2PPP/R1BQK2R b KQkq - g8f6", null, null],
  ["r2qkbnr/pppb1ppp/2np4/1B2p3/3PP3/5N2/PPP2PPP/RNBQK2R w KQkq - b1c3", null, null],
  [
    "r2qkbnr/pppb1ppp/2np4/1B2p3/3PP3/5N2/PPP2PPP/RNBQK2R w KQkq - c2c4",
    "C62",
    "Ruy Lopez: Steinitz Defense, Semi-Duras Variation",
  ],
  [
    "r2qkbnr/pppnpppp/3p4/8/2PP2b1/1Q3N2/PP2PPPP/RNB1KB1R b KQkq - a8b8",
    "A41",
    "Zukertort Opening: Wade Defense, Chigorin Plan",
  ],
  ["r2qkbnr/pppnpppp/3p4/8/2PP2b1/5N2/PP2PPPP/RNBQKB1R w KQkq - d1b3", null, null],
  ["r2qr1k1/1bp1bppp/p1np1n2/1p2p3/3PP3/1BP2N1P/PP1N1PP1/R1BQR1K1 b - - e7f8", null, null],
  ["r2qr1k1/1bp1bppp/p1np1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1 w - - b1d2", null, null],
  ["r2qrbk1/1bp2ppp/p1np1n2/1p2p3/3PP3/1BP2N1P/PP1N1PP1/R1BQR1K1 w - - a2a3", null, null],
  [
    "r2qrbk1/1bp2ppp/p1np1n2/1p2p3/3PP3/PBP2N1P/1P1N1PP1/R1BQR1K1 b - - h7h6",
    "C92",
    "Ruy Lopez: Closed, Smyslov-Breyer-Zaitsev Hybrid",
  ],
  ["r3k2r/ppp2ppp/1bn1bPq1/6N1/2ppN1P1/8/PPP2P1P/R1BQR1K1 w kq - f2f4", null, null],
  [
    "r3k2r/ppp2ppp/1bn1bPq1/6N1/2ppNPP1/8/PPP4P/R1BQR1K1 b kq - e8c8",
    "C56",
    "Italian Game: Two Knights Defense, Max Lange Attack, Berger Variation",
  ],
  ["r3k2r/ppp2ppp/2n1bP2/2b2qN1/2pp2P1/2N5/PPP2P1P/R1BQR1K1 b kq - f5g6", null, null],
  [
    "r3k2r/ppp2ppp/2n1bP2/2b2qN1/2pp4/2N5/PPP2PPP/R1BQR1K1 w kq - c3e4",
    "C56",
    "Italian Game: Scotch Gambit, Max Lange Attack, Long Variation",
  ],
  ["r3k2r/ppp2ppp/2n1bP2/2b2qN1/2pp4/2N5/PPP2PPP/R1BQR1K1 w kq - g2g4", null, null],
  [
    "r3k2r/ppp2ppp/2n1bP2/2b2qN1/2ppN3/8/PPP2PPP/R1BQR1K1 b kq - c5f8",
    "C56",
    "Italian Game: Two Knights Defense, Max Lange Attack, Rubinstein Variation",
  ],
  ["r3k2r/ppp2ppp/2n1bP2/2bq2N1/2pp4/2N5/PPP2PPP/R1BQR1K1 b kq - d5f5", null, null],
  ["r3k2r/ppp2ppp/2n1bP2/2bq2N1/2pp4/8/PPP2PPP/RNBQR1K1 w kq - b1c3", null, null],
  ["r3k2r/ppp2ppp/2n1bPq1/2b3N1/2pp2P1/2N5/PPP2P1P/R1BQR1K1 w kq - c3e4", null, null],
  ["r3k2r/ppp2ppp/2n1bPq1/2b3N1/2ppN1P1/8/PPP2P1P/R1BQR1K1 b kq - c5b6", null, null],
  ["r3kb1r/1b1n1ppp/p2ppn2/qp4B1/3NP3/1BN5/PPPQ1PPP/2KR3R w kq - h1e1", null, null],
  ["r3kb1r/1b1n1ppp/p2ppn2/qp4B1/3NP3/1BN5/PPPQ1PPP/2KRR3 b kq - d7c5", null, null],
  [
    "r3kb1r/1b3ppp/p2ppn2/qpn3B1/3NP3/1BN5/PPPQ1PPP/2KRR3 w kq - e4e5",
    "B94",
    "Sicilian Defense: Najdorf Variation, Ivkov Variation",
  ],
  [
    "r3kb1r/1pp2ppp/p1p1b3/4q3/3PN3/8/PPP2PPP/R1BQR1K1 b kq - e5d5",
    "C48",
    "Four Knights Game: Spanish Variation, Spielmann Variation",
  ],
  ["r3kb1r/1pp2ppp/p1p1b3/4q3/4N3/8/PPPP1PPP/R1BQR1K1 w kq - d2d4", null, null],
  [
    "r3kb1r/5ppp/b3pn2/1p1qN3/3p4/3B4/PP2QPPP/R1B2RK1 w kq - c1g5",
    "D49",
    "Semi-Slav Defense: Meran Variation, Rellstab Attack",
  ],
  [
    "r3kb1r/pp1qpppp/2np1n2/2p5/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 w kq - d2d4",
    "B52",
    "Sicilian Defense: Moscow Variation, Haag Gambit",
  ],
  ["r3kb1r/ppp2p2/2n1b2p/q5p1/3pN2B/5N2/PPP2PPP/R2QR1K1 w kq - e4f6", null, null],
  ["r3kb1r/ppp2p2/2n1bN1p/q5p1/3p3B/5N2/PPP2PPP/R2QR1K1 b kq - e8e7", null, null],
  ["r3kb1r/ppp2pp1/2n1b2p/q5B1/3pN3/5N2/PPP2PPP/R2QR1K1 w kq - g5h4", null, null],
  ["r3kb1r/ppp2pp1/2n1b2p/q7/3pN2B/5N2/PPP2PPP/R2QR1K1 b kq - g7g5", null, null],
  [
    "r3kb1r/ppp2ppp/2n1b3/3q4/3pN3/5N2/PPPB1PPP/R2QR1K1 w kq - d2g5",
    "C56",
    "Italian Game: Scotch Gambit, Anderssen Attack, Main Line",
  ],
  ["r3kb1r/ppp2ppp/2n1b3/q5B1/3pN3/5N2/PPP2PPP/R2QR1K1 b kq - h7h6", null, null],
  ["r3kb1r/ppp2ppp/2n1b3/q7/3pN3/5N2/PPP2PPP/R1BQR1K1 w kq - c1d2", null, null],
  ["r3kb1r/ppp2ppp/2n1b3/q7/3pN3/5N2/PPP2PPP/R1BQR1K1 w kq - c1g5", null, null],
  ["r3kb1r/ppp2ppp/2n1b3/q7/3pN3/5N2/PPPB1PPP/R2QR1K1 b kq - a5d5", null, null],
  ["r3kb1r/pppq1ppp/1nn1p3/4Pb2/2PP4/2N1BN2/PP2B1PP/R2QK2R b KQkq - e8c8", null, null],
  ["r3kb1r/pppq1ppp/1nn1p3/4Pb2/2PP4/2N1BN2/PP4PP/R2QKB1R w KQkq - f1e2", null, null],
  ["r3kb1r/ppq2ppp/2p2n2/4nb2/P1N2B2/2N3P1/1P2PP1P/R2QKB1R b KQkq - f6d7", null, null],
  ["r3kb1r/ppq2ppp/2p2n2/4nb2/P1N5/2N3P1/1P2PP1P/R1BQKB1R w KQkq - c1f4", null, null],
  ["r3kb1r/ppqn1ppp/2p2n2/4Pb2/P1N5/2N3P1/1P2PP1P/R1BQKB1R b KQkq - d7e5", null, null],
  ["r3kb1r/ppqn1ppp/2p2n2/4pb2/P1NP4/2N3P1/1P2PP1P/R1BQKB1R w KQkq - d4e5", null, null],
  ["r3kb1r/ppqn1ppp/2p5/4nb2/P1N2B2/2N3P1/1P2PP1P/R2QKB1R w KQkq - f1g2", null, null],
  [
    "r3kb1r/ppqn1ppp/2p5/4nb2/P1N2B2/2N3P1/1P2PPBP/R2QK2R b KQkq - g7g5",
    "D17",
    "Slav Defense: Czech Variation, Carlsbad Variation, Morozevich Variation",
  ],
  [
    "r3kb1r/ppqnpppp/2p2n2/5b2/P1NP4/2N3P1/1P2PP1P/R1BQKB1R b KQkq - e7e5",
    "D17",
    "Slav Defense: Czech Variation, Carlsbad Variation",
  ],
  ["r3kb1r/ppqnpppp/2p2n2/5b2/P1NP4/2N5/1P2PPPP/R1BQKB1R w KQkq - g2g3", null, null],
  [
    "r3kbnr/pp1b1ppp/1q2p3/3pP3/3n4/3B1N2/PP3PPP/RNBQ1RK1 w kq - f3g5",
    "C02",
    "French Defense: Advance Variation, Milner-Barry Gambit, Sørensen Variation",
  ],
  [
    "r3kbnr/pp1b1ppp/1qn1p3/3pP3/3p4/2PB1N2/PP3PPP/RNBQ1RK1 w kq - f1e1",
    "C02",
    "French Defense: Advance Variation, Milner-Barry Gambit, Hector Variation",
  ],
  ["r3kbnr/pp1b1ppp/1qn1p3/3pP3/3P4/3B1N2/PP3PPP/RNBQ1RK1 b kq - c6d4", null, null],
  [
    "r3kbnr/pp1b1ppp/1qn1p3/3pP3/3P4/3B1N2/PP3PPP/RNBQK2R w KQkq - e1g1",
    "C02",
    "French Defense: Advance Variation, Milner-Barry Gambit, Main Line",
  ],
  ["r3kbnr/pp1qpppp/2np4/2p5/4P3/2P2N2/PP1P1PPP/RNBQ1RK1 b kq - g8f6", null, null],
  ["r3kbnr/pp1qpppp/2np4/2p5/4P3/5N2/PPPP1PPP/RNBQ1RK1 w kq - c2c3", null, null],
  ["r3kbnr/pp2pppp/2n5/3q4/3P2b1/2N2N2/PP3PPP/R1BQKB1R b KQkq - g4f3", null, null],
  ["r3kbnr/pp2pppp/2n5/3q4/3P2b1/5N2/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["r3kbnr/pp2pppp/2n5/3q4/3P4/2N2b2/PP3PPP/R1BQKB1R w KQkq - g2f3", null, null],
  ["r3kbnr/pp2pppp/2n5/3q4/3P4/2N2P2/PP3P1P/R1BQKB1R b KQkq - d5d4", null, null],
  [
    "r3kbnr/pp2pppp/2n5/8/3Q4/2N2P2/PP3P1P/R1B1KB1R b KQkq - c6d4",
    "B22",
    "Sicilian Defense: Alapin Variation, Barmen Defense, Endgame Variation",
  ],
  ["r3kbnr/pp2pppp/2n5/8/3q4/2N2P2/PP3P1P/R1BQKB1R w KQkq - d1d4", null, null],
  [
    "r3r1k1/2qbbppp/p2p1n2/npp1p3/3PP3/2P1NN1P/PPB2PP1/R1BQR1K1 b - - g7g6",
    "C97",
    "Ruy Lopez: Closed, Chigorin, Yugoslav System",
  ],
  ["r3r1k1/2qbbppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/R1BQRNK1 w - - f1e3", null, null],
  [
    "r4b1r/ppp1kp2/2n1bN1p/q5p1/3p3B/5N2/PPP2PPP/R2QR1K1 w - - b2b4",
    "C56",
    "Italian Game: Two Knights Defense, Yurdansky Attack",
  ],
  ["r4rk1/2pqb1pp/p1n1p3/1p1pP3/4n3/1BP5/PP3PPP/RNBQR1K1 w - - e1e4", "C83", "Ruy Lopez: Open, Tarrasch Trap"],
  ["r4rk1/2pqbppp/p1n1b3/1p1pP3/3Nn3/1BP5/PP3PPP/RNBQR1K1 w - - d4e6", null, null],
  ["r4rk1/2pqbppp/p1n1N3/1p1pP3/4n3/1BP5/PP3PPP/RNBQR1K1 b - - f7e6", null, null],
  ["r4rk1/2q1bppp/p2p1n2/npp1p3/3PP1b1/2P1NN2/PPB2PPP/R1BQR1K1 b - - g4f3", null, null],
  ["r4rk1/2q1bppp/p2p1n2/npp1p3/3PP1b1/2P2N2/PPB2PPP/R1BQRNK1 w - - f1e3", null, null],
  ["r4rk1/2q1bppp/p2p1n2/npp1p3/3PP3/2P1Nb2/PPB2PPP/R1BQR1K1 w - - d1f3", "C88", "Ruy Lopez: Closed, Alekhine Gambit"],
  ["r4rk1/2qbbppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPB2PP1/R1BQRNK1 b - - f8e8", null, null],
  ["r4rk1/2qbbppp/p2p1n2/npp1p3/3PP3/2P2N1P/PPBN1PP1/R1BQR1K1 w - - d2f1", null, null],
  ["r4rk1/5ppp/p1pb4/1p1n4/3P2b1/1BP1B1Pq/PP3P1P/RN1QR1K1 w - - d1d3", null, null],
  ["r4rk1/5ppp/p1pb4/1p1n4/3P2b1/1BPQB1Pq/PP3P1P/RN2R1K1 b - - a8e8", null, null],
  ["r4rk1/pp1bppbp/2np1np1/q7/2BNP2P/2N1BP2/PPPQ2P1/2KR3R b - - f8c8", null, null],
  ["r4rk1/pp1bppbp/2np1np1/q7/2BNP2P/2N1BP2/PPPQ2P1/R3K2R w KQ - e1c1", null, null],
  ["r4rk1/pp1bppbp/2np1np1/q7/2BNP3/2N1BP2/PPPQ2PP/2KR3R w - - h2h4", null, null],
  [
    "r4rk1/pp2ppbp/3p1np1/q4P2/4P3/2N1B3/PPP1Q1PP/R4RK1 w - - g2g4",
    "B74",
    "Sicilian Defense: Dragon Variation, Classical Variation, Stockholm Attack",
  ],
  [
    "rn1q1rk1/4ppbp/3p1np1/2pP4/4P3/2N2NP1/PP3P1P/R1BQ1K1R w - - f1g2",
    "A59",
    "Benko Gambit Accepted: King Walk Variation",
  ],
  ["rn1q1rk1/pb1p1ppp/1p2pn2/2p5/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 w - - c3a4", null, null],
  ["rn1q1rk1/pb1p1ppp/1p2pn2/2p5/NbPP4/3BPN2/PP3PPP/R1BQ1RK1 b - - c5d4", null, null],
  [
    "rn1q1rk1/pb1p1ppp/1p2pn2/2p5/NbPP4/3BPN2/PP3PPP/R1BQ1RK1 b - - d8e7",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  ["rn1q1rk1/pb1p1ppp/1p2pn2/8/NbPp4/3BPN2/PP3PPP/R1BQ1RK1 w - - a2a3", null, null],
  [
    "rn1q1rk1/pb1p1ppp/1p2pn2/8/NbPp4/P2BPN2/1P3PPP/R1BQ1RK1 b - - b4e7",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  ["rn1q1rk1/pb1pbppp/1p2pn2/2p5/2PP4/1P1BPN2/P4PPP/RNBQ1RK1 w - - c1b2", null, null],
  ["rn1q1rk1/pb1pbppp/1p2pn2/2p5/2PP4/1P1BPN2/PB3PPP/RN1Q1RK1 b - - c5d4", null, null],
  ["rn1q1rk1/pb1pbppp/1p2pn2/2p5/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1 w - - b1d2", null, null],
  ["rn1q1rk1/pb1pbppp/1p2pn2/2p5/3P4/1P1BPN2/PBPN1PPP/R2Q1RK1 b - - d7d5", "D05", "Queen's Pawn Game: Colle System"],
  [
    "rn1q1rk1/pb1pbppp/1p2pn2/8/2Pp4/1P1BPN2/PB3PPP/RN1Q1RK1 w - - f3d4",
    "E14",
    "Queen's Indian Defense: Averbakh Variation",
  ],
  ["rn1q1rk1/pb2bppp/1p1ppn2/2p5/3P4/1P1BPN2/PBPN1PPP/R2Q1RK1 w - - c2c4", "E14", "Queen's Indian Defense, with e3"],
  ["rn1q1rk1/pb2bppp/1pp1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B2RK1 w - - e2e4", null, null],
  ["rn1q1rk1/pb2bppp/1pp1pn2/3p4/2PPP3/5NP1/PPQN1PBP/R1B2RK1 b - - b8a6", "E06", "Catalan Opening: Closed"],
  ["rn1q1rk1/pb2bppp/1pp1pn2/3p4/2PPP3/5NP1/PPQN1PBP/R1B2RK1 b - - b8d7", "E09", "Catalan Opening: Closed, Main Line"],
  ["rn1q1rk1/pbp1bppp/1p2pn2/3p4/2PP4/1P2PN2/PB1N1PPP/R2QKB1R w KQ - f1d3", "E14", "Queen's Indian Defense, with e3"],
  [
    "rn1q1rk1/pbp1bppp/1p3n2/3p2B1/3P4/2NBPN2/PP3PPP/R2QK2R w KQ - f3e5",
    "D55",
    "Queen's Gambit Declined: Pillsbury Attack",
  ],
  ["rn1q1rk1/pbp1bppp/1p3n2/3p4/3P4/1PN1PN2/PB3PPP/R2QKB1R w KQ - f1d3", "E14", "Queen's Indian Defense, with e3"],
  ["rn1q1rk1/pbpp1ppp/1p2p3/8/2PP4/2n2NP1/PPQ1PPBP/R3K2R w KQ - f3g5", "E11", "Bogo-Indian Defense: Monticelli Trap"],
  ["rn1q1rk1/pbpp1ppp/1p2p3/8/2PPn3/2N2NP1/PP1QPPBP/R3K2R w KQ - d2c2", null, null],
  ["rn1q1rk1/pbpp1ppp/1p2p3/8/2PPn3/2N2NP1/PPQ1PPBP/R3K2R b KQ - e4c3", null, null],
  [
    "rn1q1rk1/pbpp1ppp/1p2pn2/8/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - c7c5",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  [
    "rn1q1rk1/pbpp1ppp/1p2pn2/8/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - d7d5",
    "E52",
    "Nimzo-Indian Defense: Normal Variation, Schlechter Defense",
  ],
  [
    "rn1q1rk1/pbpp1ppp/1p2pn2/8/1bPP4/2NBPN2/PP3PPP/R1BQK2R w KQ - e1g1",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  ["rn1q1rk1/pbpp1ppp/1p2pn2/8/2PP4/2N2NP1/PP1QPPBP/R3K2R b KQ - f6e4", null, null],
  [
    "rn1q1rk1/pbpp1ppp/1p2pn2/8/2PP4/2PBPN2/P4PPP/R1BQK2R w KQ - e1g1",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  ["rn1q1rk1/pbpp1ppp/1p2pn2/8/2PP4/5NP1/PP1QPPBP/RN2K2R w KQ - b1c3", null, null],
  [
    "rn1q1rk1/pbppbppp/1p2p3/8/2PP4/2n2NP1/PPQ1PPBP/R1B2RK1 w - - c2c3",
    "E19",
    "Queen's Indian Defense: Classical Variation, Traditional Variation, Main Line",
  ],
  ["rn1q1rk1/pbppbppp/1p2p3/8/2PPn3/2N2NP1/PP2PPBP/R1BQ1RK1 w - - d1c2", null, null],
  ["rn1q1rk1/pbppbppp/1p2p3/8/2PPn3/2N2NP1/PPQ1PPBP/R1B2RK1 b - - e4c3", null, null],
  ["rn1q1rk1/pbppbppp/1p2pn2/3P4/2P5/5NP1/PP2PPBP/RNBQ1RK1 b - - e6d5", null, null],
  [
    "rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - b8a6",
    "E18",
    "Queen's Indian Defense: Classical Variation, Tiviakov Defense",
  ],
  [
    "rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - d7d5",
    "E18",
    "Queen's Indian Defense: Classical Variation, Traditional Variation, Nimzowitsch Line",
  ],
  ["rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - f6e4", null, null],
  ["rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/3BPN2/PP3PPP/RNBQ1RK1 w - - b1c3", "E14", "Queen's Indian Defense, with e3"],
  [
    "rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3",
    "E18",
    "Queen's Indian Defense: Classical Variation, Traditional Variation",
  ],
  ["rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b2b3", "E17", "Queen's Indian Defense: Euwe Variation"],
  ["rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - d4d5", null, null],
  [
    "rn1q1rk1/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - f1e1",
    "E17",
    "Queen's Indian Defense: Fianchetto Variation, Kramnik Variation",
  ],
  [
    "rn1q1rk1/pbppbppp/1p3n2/3p4/2P5/5NP1/PP2PPBP/RNBQ1RK1 w - - f3d4",
    "E17",
    "Queen's Indian Defense: Classical Variation, Taimanov Gambit",
  ],
  [
    "rn1q1rk1/pbppbppp/1p3n2/3p4/2P5/5NP1/PP2PPBP/RNBQ1RK1 w - - f3h4",
    "E17",
    "Queen's Indian Defense: Classical Variation, Polugaevsky Gambit",
  ],
  [
    "rn1q1rk1/pp3ppp/2p1p3/5b2/PbBPn3/2N1PN2/1P2QPPP/R1B2RK1 w - - g2g4",
    "D19",
    "Slav Defense: Czech Variation, Dutch Variation, Sämisch Variation",
  ],
  ["rn1q1rk1/pp3ppp/2p1pn2/5b2/PbBP4/2N1PN2/1P2QPPP/R1B2RK1 b - - f6e4", null, null],
  [
    "rn1q1rk1/pp3ppp/2p1pn2/5b2/PbBP4/2N1PN2/1P3PPP/R1BQ1RK1 w - - d1e2",
    "D19",
    "Slav Defense: Czech Variation, Classical System, Main Line",
  ],
  [
    "rn1q1rk1/ppp1bppp/1n2p3/4Pb2/2PP4/2N2N2/PP2B1PP/R1BQ1RK1 b - - f7f6",
    "B03",
    "Alekhine Defense: Four Pawns Attack, Korchnoi Variation",
  ],
  ["rn1q1rk1/ppp1bppp/1n2p3/4Pb2/2PP4/2N2N2/PP2B1PP/R1BQK2R w KQ - e1g1", null, null],
  ["rn1q1rk1/ppp1ppbp/1n4p1/8/2QPP1b1/2N1BN2/PP2BPPP/R3K2R w KQ - c4d3", null, null],
  ["rn1q1rk1/ppp1ppbp/1n4p1/8/3PP1b1/2NQBN2/PP2BPPP/R3K2R b KQ - b8c6", null, null],
  ["rn1q1rk1/ppp1ppbp/5np1/8/2QPP1b1/2N1BN2/PP3PPP/R3KB1R b KQ - f6d7", null, null],
  ["rn1q1rk1/ppp1ppbp/5np1/8/2QPP1b1/2N2N2/PP3PPP/R1B1KB1R w KQ - c1e3", null, null],
  ["rn1q1rk1/ppp2ppp/3b4/3p4/2PPn1b1/3B1N2/PP3PPP/RNBQ1RK1 w - - c4d5", null, null],
  ["rn1q1rk1/ppp2ppp/3b4/3P4/3Pn1b1/3B1N2/PP3PPP/RNBQ1RK1 b - - f7f5", null, null],
  ["rn1q1rk1/ppp3pp/3b4/3P1p2/3Pn1b1/3B1N2/PP3PPP/RNBQ1RK1 w - - f1e1", null, null],
  [
    "rn1q1rk1/ppp3pp/3b4/3P1p2/3Pn1b1/3B1N2/PP3PPP/RNBQR1K1 b - - d6h2",
    "C42",
    "Petrov's Defense: Classical Attack, Marshall Trap",
  ],
  ["rn1q1rk1/pppnppbp/6p1/8/2QPP1b1/2N1BN2/PP2BPPP/R3K2R b KQ - d7b6", null, null],
  [
    "rn1q1rk1/pppnppbp/6p1/8/2QPP1b1/2N1BN2/PP3PPP/R3KB1R w KQ - c4b3",
    "D99",
    "Grünfeld Defense: Russian Variation, Smyslov Variation",
  ],
  ["rn1q1rk1/pppnppbp/6p1/8/2QPP1b1/2N1BN2/PP3PPP/R3KB1R w KQ - f1e2", null, null],
  [
    "rn1q1rk1/pppnppbp/6p1/8/3PP1b1/1QN1BN2/PP3PPP/R3KB1R b KQ - c7c5",
    "D99",
    "Grünfeld Defense: Russian Variation, Yugoslav Variation",
  ],
  ["rn1qk1nr/ppp2ppp/3p4/2b1P3/4P1b1/2P2N2/PP1P2PP/RNBQKB1R b KQkq - d6e5", null, null],
  ["rn1qk1nr/ppp2ppp/3p4/2b1p3/4PPb1/2P2N2/PP1P2PP/RNBQKB1R w KQkq - f4e5", null, null],
  [
    "rn1qk1nr/ppp2ppp/8/2b1p3/4P1b1/2P2N2/PP1P2PP/RNBQKB1R w KQkq - d1a4",
    "C30",
    "King's Gambit Declined: Classical Variation, Euwe Attack",
  ],
  [
    "rn1qk2r/1b2bppp/pp1ppn2/8/2PQ4/1PN2NP1/P3PPBP/R1BR2K1 b kq - b8d7",
    "A30",
    "English Opening: Symmetrical, Hedgehog, Flexible Formation",
  ],
  ["rn1qk2r/1b2bppp/pp1ppn2/8/2PQ4/2N2NP1/PP2PPBP/R1BR2K1 w kq - b2b3", null, null],
  ["rn1qk2r/4ppbp/3p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQ1K1R w kq - g2g3", null, null],
  ["rn1qk2r/4ppbp/3p1np1/2pP4/4P3/2N2NP1/PP3P1P/R1BQ1K1R b kq - e8g8", null, null],
  [
    "rn1qk2r/4ppbp/b2p1np1/2pP4/8/2N3P1/PP2PPBP/R1BQK1NR w KQkq - g1f3",
    "A58",
    "Benko Gambit Accepted: Fianchetto Variation",
  ],
  [
    "rn1qk2r/p1pp1ppp/bp2pn2/8/1bPP4/1P3NP1/P2BPP1P/RN1QKB1R b KQkq - b4e7",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Check Variation, Intermezzo Line",
  ],
  [
    "rn1qk2r/p1pp1ppp/bp2pn2/8/1bPP4/1P3NP1/P2BPP1P/RN1QKB1R b KQkq - d8e7",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Check Variation, Modern Line",
  ],
  ["rn1qk2r/p1pp1ppp/bp2pn2/8/1bPP4/1P3NP1/P3PP1P/RNBQKB1R w KQkq - c1d2", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/2p5/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 w kq - d2d4", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/2p5/2PP4/1P1BPN2/P4PPP/RNBQ1RK1 b kq - e8g8", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/2p5/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b kq - c5d4", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/2p5/2PP4/3BPN2/PP3PPP/RNBQ1RK1 w kq - b2b3", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/2p5/3P4/1P1BPN2/P1P2PPP/RNBQ1RK1 w kq - c1b2", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/2p5/3P4/1P1BPN2/P1PN1PPP/R1BQK2R w KQkq - c1b2", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/2p5/3P4/1P1BPN2/PBP2PPP/RN1Q1RK1 b kq - e8g8", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/2p5/3P4/1P1BPN2/PBPN1PPP/R2QK2R b KQkq - d7d6", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/8/2Pp4/2N2NP1/PP2PPBP/R1BQ1RK1 w kq - d1d4", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/8/2PP4/2NB1N2/PP3PPP/R1BQ1RK1 b kq - d7d5", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/8/2PP4/2NB1N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["rn1qk2r/pb1pbppp/1p2pn2/8/2PQ4/2N2NP1/PP2PPBP/R1B2RK1 b kq - d7d6", null, null],
  ["rn1qk2r/pb2bppp/1p1ppn2/2p5/3P4/1P1BPN2/PBPN1PPP/R2Q1RK1 b kq - e8g8", null, null],
  ["rn1qk2r/pb2bppp/1p1ppn2/2p5/3P4/1P1BPN2/PBPN1PPP/R2QK2R w KQkq - e1g1", null, null],
  ["rn1qk2r/pb2bppp/1p1ppn2/8/2PQ4/2N2NP1/PP2PPBP/R1B2RK1 w kq - f1d1", null, null],
  ["rn1qk2r/pb2bppp/1p1ppn2/8/2PQ4/2N2NP1/PP2PPBP/R1BR2K1 b kq - a7a6", null, null],
  ["rn1qk2r/pb2bppp/1p2pn2/3p4/2PP4/2NB1N2/PP3PPP/R1BQ1RK1 w kq - c4d5", null, null],
  [
    "rn1qk2r/pb2bppp/1p2pn2/3P4/3P4/2NB1N2/PP3PPP/R1BQ1RK1 b kq - f6d5",
    "E14",
    "Queen's Indian Defense: Spassky System3",
  ],
  ["rn1qk2r/pbpp1ppp/1p2p3/8/1bPPn3/2N1PN2/PPQ2PPP/R1B1KB1R w KQkq - f1d3", null, null],
  ["rn1qk2r/pbpp1ppp/1p2p3/8/1bPPn3/2NBPN2/PPQ2PPP/R1B1K2R b KQkq - b4c3", null, null],
  ["rn1qk2r/pbpp1ppp/1p2p3/8/2PPn3/2bBPN2/PPQ2PPP/R1B1K2R w KQkq - b2c3", null, null],
  ["rn1qk2r/pbpp1ppp/1p2p3/8/2PPn3/2PBPN2/P1Q2PPP/R1B1K2R b KQkq - f7f5", null, null],
  [
    "rn1qk2r/pbpp1ppp/1p2pn2/8/1bPP4/2NBP3/PP3PPP/R1BQK1NR w KQkq - g1f3",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  [
    "rn1qk2r/pbpp1ppp/1p2pn2/8/1bPP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - e8g8",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  [
    "rn1qk2r/pbpp1ppp/1p2pn2/8/1bPP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - f6e4",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation, with Ne4",
  ],
  ["rn1qk2r/pbpp1ppp/1p2pn2/8/1bPP4/5NP1/PP1BPPBP/RN1QK2R b KQkq - b4d2", null, null],
  [
    "rn1qk2r/pbpp1ppp/1p2pn2/8/1bPP4/5NP1/PP1BPPBP/RN1QK2R b KQkq - b4e7",
    "E16",
    "Queen's Indian Defense: Riumin Variation",
  ],
  ["rn1qk2r/pbpp1ppp/1p2pn2/8/1bPP4/5NP1/PP2PPBP/RNBQK2R w KQkq - c1d2", null, null],
  ["rn1qk2r/pbpp1ppp/1p2pn2/8/2PP4/2P1PN2/P4PPP/R1BQKB1R w KQkq - f1d3", null, null],
  ["rn1qk2r/pbpp1ppp/1p2pn2/8/2PP4/2PBPN2/P4PPP/R1BQK2R b KQkq - e8g8", null, null],
  ["rn1qk2r/pbpp1ppp/1p2pn2/8/2PP4/5NP1/PP1bPPBP/RN1QK2R w KQkq - d1d2", null, null],
  ["rn1qk2r/pbpp1ppp/1p2pn2/8/2PP4/5NP1/PP1QPPBP/RN2K2R b KQkq - e8g8", null, null],
  ["rn1qk2r/pbpp1ppp/1p2pn2/8/2PP4/P4N2/1P1QPPPP/R1B1KB1R w KQkq - e2e3", "E14", "Queen's Indian Defense, with e3"],
  [
    "rn1qk2r/pbpp2pp/1p2p3/5p2/2PPn3/2PBPN2/P1Q2PPP/R1B1K2R w KQkq - e1g1",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  [
    "rn1qk2r/pbppbppp/1p2p3/8/2PPn3/2N2NP1/PP2PPBP/R1BQK2R w KQkq - c1d2",
    "E17",
    "Queen's Indian Defense: Opocensky Variation",
  ],
  ["rn1qk2r/pbppbppp/1p2pn2/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R b KQkq - f6e4", null, null],
  ["rn1qk2r/pbppbppp/1p2pn2/8/2PP4/3BPN2/PP3PPP/RNBQ1RK1 b kq - e8g8", null, null],
  ["rn1qk2r/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b kq - e8g8", null, null],
  [
    "rn1qk2r/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQK2R w KQkq - b1c3",
    "E17",
    "Queen's Indian Defense: Anti-Queen's Indian System",
  ],
  [
    "rn1qk2r/pbppbppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQK2R w KQkq - e1g1",
    "E17",
    "Queen's Indian Defense: Classical Variation",
  ],
  ["rn1qk2r/pbppbppp/1p2pn2/8/3P4/3BPN2/PPP2PPP/RNBQ1RK1 w kq - c2c4", null, null],
  [
    "rn1qk2r/pp3ppp/2p1pn2/4Nb2/PbpP4/2N2P2/1P2P1PP/R1BQKB1R w KQkq - e2e4",
    "D17",
    "Slav Defense: Czech Variation, Wiesbaden Variation, Sharp Line",
  ],
  ["rn1qk2r/pp3ppp/2p1pn2/5b2/PbBP4/2N1PN2/1P3PPP/R1BQ1RK1 b kq - e8g8", null, null],
  [
    "rn1qk2r/pp3ppp/2p1pn2/5b2/PbBP4/2N1PN2/1P3PPP/R1BQK2R w KQkq - e1g1",
    "D19",
    "Slav Defense: Czech Variation, Dutch Variation",
  ],
  ["rn1qk2r/ppp1bppp/1n2p3/4Pb2/2PP4/2N2N2/PP2B1PP/R1BQK2R b KQkq - e8g8", null, null],
  ["rn1qk2r/ppp1bppp/1n2p3/4Pb2/2PP4/2N2N2/PP4PP/R1BQKB1R w KQkq - f1e2", null, null],
  [
    "rn1qk2r/ppp2ppp/5pb1/8/1b1Pp1P1/2N5/PPP1QP1P/R3KBNR w KQkq - e2b5",
    "D00",
    "Blackmar-Diemer Gambit: von Popiel Gambit, Zilbermints Variation",
  ],
  ["rn1qk2r/ppp2ppp/8/2bP1b2/4nP2/5N2/PPP1Q1PP/RNB1KB1R w KQkq - g2g4", null, null],
  [
    "rn1qk2r/ppp2ppp/8/2bP1b2/4nPP1/5N2/PPP1Q2P/RNB1KB1R b KQkq - e8g8",
    "C32",
    "King's Gambit Declined: Falkbeer Countergambit, Tarrasch Variation",
  ],
  ["rn1qkb1r/1b3ppp/p3pn2/1pp5/3P4/1B2PN2/PP2QPPP/RNB2RK1 w kq - f1d1", null, null],
  ["rn1qkb1r/1b3ppp/p3pn2/1pp5/3P4/1B2PN2/PP2QPPP/RNBR2K1 b kq - b8d7", null, null],
  [
    "rn1qkb1r/1p3ppp/p2pbn2/4p3/4P3/1NN5/PPP1BPPP/R1BQK2R w KQkq - c1e3",
    "B92",
    "Sicilian Defense: Najdorf Variation, Opocensky Variation",
  ],
  ["rn1qkb1r/3ppp1p/5np1/2pP4/4P3/2N5/PP3PPP/R1BQ1KNR b kq - d7d6", null, null],
  ["rn1qkb1r/3ppp1p/5np1/2pP4/4P3/2N5/PP3PPP/R1BQKbNR w KQkq - e1f1", null, null],
  ["rn1qkb1r/3ppp1p/b4np1/2pP4/4P3/2N5/PP3PPP/R1BQKBNR b KQkq - a6f1", null, null],
  ["rn1qkb1r/3ppp1p/b4np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d7d6", null, null],
  ["rn1qkb1r/3ppp1p/b4np1/2pP4/8/2N3P1/PP2PP1P/R1BQKBNR b KQkq - d7d6", null, null],
  ["rn1qkb1r/3ppp1p/b4np1/2pP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  [
    "rn1qkb1r/3ppp1p/b4np1/2pP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - f2f4",
    "A58",
    "Benko Gambit Accepted: Central Storming Variation",
  ],
  ["rn1qkb1r/3ppp1p/b4np1/2pP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rn1qkb1r/3ppp1p/b4np1/2pP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - g2g3", null, null],
  ["rn1qkb1r/3ppppp/b4n2/2pP4/8/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rn1qkb1r/3ppppp/b4n2/2pP4/8/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rn1qkb1r/4pp1p/3p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQ1K1R b kq - f8g7", null, null],
  ["rn1qkb1r/4pp1p/3p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQKb1R w KQkq - e1f1", null, null],
  ["rn1qkb1r/4pp1p/3p1np1/2pP4/4P3/2N5/PP3PPP/R1BQ1KNR w kq - g1e2", "A59", "Benko Gambit Accepted: Yugoslav"],
  ["rn1qkb1r/4pp1p/3p1np1/2pP4/4P3/2N5/PP3PPP/R1BQ1KNR w kq - g2g3", "A59", "Benko Gambit"],
  ["rn1qkb1r/4pp1p/b2p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - a6f1", null, null],
  ["rn1qkb1r/4pp1p/b2p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e4", null, null],
  ["rn1qkb1r/4pp1p/b2p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R w KQkq - f3d2", "A58", "Benko Gambit: Nd2 Variation"],
  ["rn1qkb1r/4pp1p/b2p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R w KQkq - g2g3", "A58", "Benko Gambit: Fianchetto Variation"],
  ["rn1qkb1r/4pp1p/b2p1np1/2pP4/8/2N3P1/PP2PP1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["rn1qkb1r/4pp1p/b2p1np1/2pP4/8/2N3P1/PP2PPBP/R1BQK1NR b KQkq - f8g7", null, null],
  ["rn1qkb1r/4pppp/b2p1n2/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R b KQkq - g7g6", null, null],
  ["rn1qkb1r/4pppp/b2p1n2/2pP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", "A59", "Benko Gambit Accepted: Yugoslav"],
  ["rn1qkb1r/4pppp/b2p1n2/2pP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/1P3NP1/P3PP1P/RNBQKB1R b KQkq - f8b4",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Check Variation",
  ],
  [
    "rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - b2b3",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Nimzowitsch Variation, Quiet Line",
  ],
  [
    "rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - d1a4",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Nimzowitsch Variation, Nimzowitsch Attack",
  ],
  [
    "rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - d1b3",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Nimzowitsch Variation, Timman's Line",
  ],
  ["rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/P4N2/1P2PPPP/RNBQKB1R w KQkq - d1c2", null, null],
  [
    "rn1qkb1r/p1pp1ppp/bp2pn2/8/2PP4/P4N2/1PQ1PPPP/RNB1KB1R b KQkq - a6b7",
    "E12",
    "Queen's Indian Defense: Petrosian Variation, Farago Defense",
  ],
  [
    "rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 b kq - f8e7",
    "A30",
    "English Opening: Symmetrical Variation, Hedgehog Defense",
  ],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2P5/2N2NP1/PP1PPPBP/R1BQK2R w KQkq - e1g1", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - c5d4", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2PP4/3BPN2/PP3PPP/RNBQ1RK1 b kq - f8e7", "E14", "Queen's Indian Defense, with e3"],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2PP4/3BPN2/PP3PPP/RNBQ1RK1 b kq - g7g6", "E14", "Queen's Indian Defense, with e3"],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2PP4/3BPN2/PP3PPP/RNBQK2R w KQkq - b1c3", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2PP4/3BPN2/PP3PPP/RNBQK2R w KQkq - e1g1", "E14", "Queen's Indian Defense, with e3"],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/2PP4/5NP1/PP2PPBP/RNBQK2R w KQkq - d4d5", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/3P4/1P1BPN2/P1P2PPP/RNBQ1RK1 b kq - f8e7", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/3P4/1P1BPN2/P1PN1PPP/R1BQK2R b KQkq - f8e7", "A47", "Pseudo Queen's Indian Defense"],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/3P4/3BPN2/PPP2PPP/RNBQ1RK1 w kq - b2b3", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/3P4/3BPN2/PPP2PPP/RNBQ1RK1 w kq - c2c4", "E14", "Queen's Indian Defense, with e3"],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2p5/3P4/3BPN2/PPPN1PPP/R1BQK2R w KQkq - b2b3", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/2pP4/2P5/5NP1/PP2PPBP/RNBQK2R b KQkq - e6d5", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/8/2PP4/2NB1N2/PP3PPP/R1BQK2R b KQkq - f8e7", null, null],
  ["rn1qkb1r/pb1p1ppp/1p2pn2/8/2Pp4/2NBPN2/PP3PPP/R1BQK2R w KQkq - e3d4", null, null],
  [
    "rn1qkb1r/pb1p1ppp/1p3n2/2pp4/2P5/5NP1/PP2PPBP/RNBQK2R w KQkq - f3g5",
    "E15",
    "Queen's Indian Defense: Buerger Variation",
  ],
  [
    "rn1qkb1r/pb1p1ppp/1p3n2/2pp4/2P5/5NP1/PP2PPBP/RNBQK2R w KQkq - f3h4",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Rubinstein Variation",
  ],
  ["rn1qkb1r/pb1ppppp/1p3n2/2p5/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - c5d4", null, null],
  ["rn1qkb1r/pb1ppppp/1p3n2/2p5/3P4/5NP1/PPP1PPBP/RNBQK2R w KQkq - c2c4", null, null],
  ["rn1qkb1r/pb1ppppp/1p3n2/8/2Pp4/5NP1/PP2PPBP/RNBQK2R w KQkq - d1d4", "A47", "Marienbad System: Berg Variation"],
  [
    "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N2N2/1P2PPPP/R1BQKB1R w KQkq - c1d2",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Romanishin Attack",
  ],
  [
    "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N2N2/1P2PPPP/R1BQKB1R w KQkq - d1a4",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Rashkovsky Attack",
  ],
  [
    "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N2N2/1P2PPPP/R1BQKB1R w KQkq - d1c2",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Kasparov Attack",
  ],
  [
    "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N2N2/1P2PPPP/R1BQKB1R w KQkq - e2e3",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Petrosian Attack",
  ],
  [
    "rn1qkb1r/pbp2ppp/1p2p3/3n4/3P4/P1N2N2/1P2PPPP/R1BQKB1R w KQkq - e2e4",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Polovodin Gambit",
  ],
  ["rn1qkb1r/pbp2ppp/1p2pn2/3p4/2PP4/P1N2N2/1P2PPPP/R1BQKB1R w KQkq - c4d5", null, null],
  [
    "rn1qkb1r/pbp2ppp/1p2pn2/3P4/3P4/P1N2N2/1P2PPPP/R1BQKB1R b KQkq - e6d5",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Classical Variation",
  ],
  [
    "rn1qkb1r/pbp2ppp/1p2pn2/3P4/3P4/P1N2N2/1P2PPPP/R1BQKB1R b KQkq - f6d5",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Modern Variation",
  ],
  ["rn1qkb1r/pbpp1p2/1p2pn1p/6p1/2PP3B/2N2N2/PP2PPPP/R2QKB1R w KQkq - h4g3", null, null],
  [
    "rn1qkb1r/pbpp1p2/1p2pn1p/6p1/2PP4/2N2NB1/PP2PPPP/R2QKB1R b KQkq - f6h5",
    "E12",
    "Queen's Indian Defense: Kasparov Variation, Botvinnik Attack",
  ],
  ["rn1qkb1r/pbpp1pp1/1p2pn1p/6B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - g5h4", null, null],
  ["rn1qkb1r/pbpp1pp1/1p2pn1p/8/2PP3B/2N2N2/PP2PPPP/R2QKB1R b KQkq - g7g5", null, null],
  ["rn1qkb1r/pbpp1ppp/1p2pn2/6B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - h7h6", null, null],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2P1P3/2N2N2/PP1P1PPP/R1BQKB1R w KQkq - f1d3",
    "A17",
    "English Opening: Anglo-Indian Defense, Queen's Indian Variation",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - a2a3",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation",
  ],
  ["rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5", null, null],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/3BPN2/PP3PPP/RNBQK2R b KQkq - c7c5",
    "E14",
    "Queen's Indian Defense: Spassky System3",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/3BPN2/PP3PPP/RNBQK2R b KQkq - d7d5",
    "E14",
    "Queen's Indian Defense: Spassky System",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/4PN2/PP3PPP/RNBQKB1R w KQkq - f1d3",
    "E14",
    "Queen's Indian Defense: Spassky System",
  ],
  ["rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - c7c5",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Sämisch Variation",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - f8b4",
    "E16",
    "Queen's Indian Defense: Capablanca Variation",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - f8e7",
    "E17",
    "Queen's Indian Defense: Traditional Variation",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/P1N2N2/1P2PPPP/R1BQKB1R b KQkq - d7d5",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Main Line",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/P1N2N2/1P2PPPP/R1BQKB1R b KQkq - f6e4",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Andersson Variation",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/P1N2N2/1P2PPPP/R1BQKB1R b KQkq - f8e7",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Marco Defense",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/P1N2N2/1P2PPPP/R1BQKB1R b KQkq - g7g6",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation, Hedgehog Variation",
  ],
  [
    "rn1qkb1r/pbpp1ppp/1p2pn2/8/2PP4/P4N2/1P2PPPP/RNBQKB1R w KQkq - b1c3",
    "E12",
    "Queen's Indian Defense: Kasparov-Petrosian Variation",
  ],
  ["rn1qkb1r/pbpp1ppp/1p2pn2/8/3P4/3BPN2/PPP2PPP/RNBQ1RK1 b kq - c7c5", null, null],
  ["rn1qkb1r/pbpp1ppp/1p2pn2/8/3P4/3BPN2/PPP2PPP/RNBQ1RK1 b kq - f8e7", null, null],
  ["rn1qkb1r/pbpp1ppp/1p2pn2/8/3P4/3BPN2/PPP2PPP/RNBQK2R w KQkq - b1d2", null, null],
  ["rn1qkb1r/pbpp1ppp/1p2pn2/8/3P4/3BPN2/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["rn1qkb1r/pbpp1ppp/1p2pn2/8/3P4/3BPN2/PPPN1PPP/R1BQK2R b KQkq - c7c5", null, null],
  ["rn1qkb1r/pbpppppp/1p3n2/8/3P4/3BPN2/PPP2PPP/RNBQK2R b KQkq - e7e6", null, null],
  ["rn1qkb1r/pbpppppp/1p3n2/8/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  ["rn1qkb1r/pbpppppp/1p3n2/8/3P4/5NP1/PPP1PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rn1qkb1r/pbpppppp/1p3n2/8/3P4/5NP1/PPP1PPBP/RNBQK2R b KQkq - c7c5", "A47", "Marienbad System"],
  ["rn1qkb1r/pp2ppp1/2p2n1p/3p1b2/2P5/3P1NP1/PP2PPBP/RNBQ1RK1 b kq - d5c4", "A07", "King's Indian Attack, with Bf5"],
  [
    "rn1qkb1r/pp2ppp1/2p2n1p/3p1b2/2P5/3P1NP1/PP2PPBP/RNBQ1RK1 b kq - e7e6",
    "A11",
    "Réti Opening: Anglo-Slav Variation, with g3",
  ],
  ["rn1qkb1r/pp2ppp1/2p2n1p/3p1b2/8/3P1NP1/PPP1PPBP/RNBQ1RK1 w kq - c2c4", null, null],
  ["rn1qkb1r/pp2pppp/2p2n2/3p1b2/2P5/5NP1/PP1PPPBP/RNBQ1RK1 b kq - e7e6", null, null],
  ["rn1qkb1r/pp2pppp/2p2n2/3p1b2/2P5/5NP1/PP1PPPBP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "rn1qkb1r/pp2pppp/2p2n2/3p1b2/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - e7e6",
    "D12",
    "Slav Defense: Quiet Variation, Schallopp Defense",
  ],
  ["rn1qkb1r/pp2pppp/2p2n2/3p1b2/2PP4/4PN2/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rn1qkb1r/pp2pppp/2p2n2/3p1b2/2PP4/4PN2/PP3PPP/RNBQKB1R w KQkq - c4d5", null, null],
  ["rn1qkb1r/pp2pppp/2p2n2/3P1b2/3P4/4PN2/PP3PPP/RNBQKB1R b KQkq - c6d5", null, null],
  ["rn1qkb1r/pp2pppp/2p2n2/3p1b2/8/3P1NP1/PPP1PPBP/RNBQ1RK1 b kq - e7e6", null, null],
  ["rn1qkb1r/pp2pppp/2p2n2/3p1b2/8/3P1NP1/PPP1PPBP/RNBQ1RK1 b kq - h7h6", "A07", "King's Indian Attack, with Bf5"],
  ["rn1qkb1r/pp2pppp/2p2n2/3p1b2/8/5NP1/PPPPPPBP/RNBQ1RK1 w kq - d2d3", null, null],
  ["rn1qkb1r/pp2pppp/2p2n2/4Nb2/P1pP4/2N5/1P2PPPP/R1BQKB1R b KQkq - b8a6", null, null],
  ["rn1qkb1r/pp2pppp/2p2n2/4Nb2/P1pP4/2N5/1P2PPPP/R1BQKB1R b KQkq - b8d7", null, null],
  [
    "rn1qkb1r/pp2pppp/2p2n2/4Nb2/P1pP4/2N5/1P2PPPP/R1BQKB1R b KQkq - e7e6",
    "D17",
    "Slav Defense: Czech Variation, Wiesbaden Variation",
  ],
  [
    "rn1qkb1r/pp2pppp/2p2n2/5b2/P1pP4/2N1PN2/1P3PPP/R1BQKB1R b KQkq - b8a6",
    "D18",
    "Slav Defense: Czech Variation, Lasker Variation",
  ],
  ["rn1qkb1r/pp2pppp/2p2n2/5b2/P1pP4/2N1PN2/1P3PPP/R1BQKB1R b KQkq - e7e6", null, null],
  [
    "rn1qkb1r/pp2pppp/2p2n2/5b2/P1pP4/2N2N2/1P2PPPP/R1BQKB1R w KQkq - e2e3",
    "D18",
    "Slav Defense: Czech Variation, Classical System",
  ],
  [
    "rn1qkb1r/pp2pppp/2p2n2/5b2/P1pP4/2N2N2/1P2PPPP/R1BQKB1R w KQkq - f3e5",
    "D17",
    "Slav Defense: Czech Variation, Krause Attack",
  ],
  [
    "rn1qkb1r/pp2pppp/2p2n2/5b2/P1pP4/2N2N2/1P2PPPP/R1BQKB1R w KQkq - f3h4",
    "D17",
    "Slav Defense: Czech Variation, Bled Attack",
  ],
  [
    "rn1qkb1r/pp2pppp/2p2n2/8/3P4/2N2Q1P/PPP3P1/R1B1KB1R w KQkq - c1e3",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Teichmann Defense, Classical Variation",
  ],
  [
    "rn1qkb1r/pp2pppp/2p2n2/8/3P4/2N2Q1P/PPP3P1/R1B1KB1R w KQkq - f3f2",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Teichmann Defense, Ciesielski Variation",
  ],
  [
    "rn1qkb1r/pp2pppp/2p2n2/8/3P4/2N2Q1P/PPP3P1/R1B1KB1R w KQkq - g2g4",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Teichmann Defense, Seidel-Hall Attack",
  ],
  ["rn1qkb1r/pp2pppp/5n2/3p1b2/3P4/1Q2PN2/PP3PPP/RNB1KB1R b KQkq - d8c8", null, null],
  ["rn1qkb1r/pp2pppp/5n2/3p1b2/3P4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - e7e6", null, null],
  [
    "rn1qkb1r/pp2pppp/5n2/3p1b2/3P4/4PN2/PP3PPP/RNBQKB1R w KQkq - b1c3",
    "D13",
    "Slav Defense: Exchange Variation, Schallopp Variation",
  ],
  ["rn1qkb1r/pp2pppp/5n2/3p1b2/3P4/4PN2/PP3PPP/RNBQKB1R w KQkq - d1b3", null, null],
  [
    "rn1qkb1r/pp3ppp/2p1pn2/3p1b2/2P5/5NP1/PP1PPPBP/RNBQ1RK1 w kq - d2d3",
    "A11",
    "Réti Opening: Anglo-Slav Variation, with g3",
  ],
  ["rn1qkb1r/pp3ppp/2p1pn2/3p1b2/8/3P1NP1/PPP1PPBP/RNBQ1RK1 w kq - b1d2", "A07", "King's Indian Attack, with Bf5"],
  ["rn1qkb1r/pp3ppp/2p1pn2/3p1b2/8/3P1NP1/PPP1PPBP/RNBQ1RK1 w kq - f3h4", "A07", "King's Indian Attack, with Bf5"],
  ["rn1qkb1r/pp3ppp/2p1pn2/4Nb2/P1pP4/2N2P2/1P2P1PP/R1BQKB1R b KQkq - f8b4", null, null],
  ["rn1qkb1r/pp3ppp/2p1pn2/4Nb2/P1pP4/2N5/1P2PPPP/R1BQKB1R w KQkq - f2f3", null, null],
  ["rn1qkb1r/pp3ppp/2p1pn2/5b2/P1BP4/2N1PN2/1P3PPP/R1BQK2R b KQkq - f8b4", null, null],
  ["rn1qkb1r/pp3ppp/2p1pn2/5b2/P1pP4/2N1PN2/1P3PPP/R1BQKB1R w KQkq - f1c4", null, null],
  ["rn1qkb1r/pp3ppp/4pn2/3p1b2/3P4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f3e5", null, null],
  [
    "rn1qkb1r/pp3ppp/4pn2/3pNb2/3P4/2N1P3/PP3PPP/R1BQKB1R b KQkq - f6d7",
    "D12",
    "Slav Defense: Quiet Variation, Amsterdam Variation",
  ],
  [
    "rn1qkb1r/ppp1pppp/1n1p4/4P3/2PP2b1/5N2/PP3PPP/RNBQKB1R w KQkq - d4d5",
    "B05",
    "Alekhine Defense: Modern Variation, Vitolins Attack",
  ],
  [
    "rn1qkb1r/ppp1pppp/1n1p4/4P3/2PP2b1/5N2/PP3PPP/RNBQKB1R w KQkq - f1e2",
    "B03",
    "Alekhine Defense: Modern Variation, Alekhine Gambit",
  ],
  ["rn1qkb1r/ppp1pppp/1n6/4Pb2/2PP4/2N5/PP4PP/R1BQKBNR b KQkq - e7e6", null, null],
  ["rn1qkb1r/ppp1pppp/1n6/4Pb2/2PP4/8/PP4PP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rn1qkb1r/ppp1pppp/3p1n2/5b2/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4",
    "A53",
    "Old Indian Defense: Janowski Variation, Grinberg Gambit",
  ],
  [
    "rn1qkb1r/ppp1pppp/3p1n2/5b2/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - f2f3",
    "A53",
    "Old Indian Defense: Janowski Variation, Main Line",
  ],
  [
    "rn1qkb1r/ppp1pppp/3p1n2/5b2/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g2g3",
    "A53",
    "Old Indian Defense: Janowski Variation, Fianchetto Variation",
  ],
  ["rn1qkb1r/ppp1pppp/3p4/3nP3/2PP2b1/5N2/PP3PPP/RNBQKB1R b KQkq - d5b6", null, null],
  [
    "rn1qkb1r/ppp1pppp/3p4/3nP3/3P2b1/5N2/PPP1BPPP/RNBQK2R b KQkq - c7c6",
    "B05",
    "Alekhine Defense: Modern Variation, Flohr Variation",
  ],
  [
    "rn1qkb1r/ppp1pppp/3p4/3nP3/3P2b1/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c4",
    "B05",
    "Alekhine Defense: Modern Variation, Alekhine Variation",
  ],
  ["rn1qkb1r/ppp1pppp/3p4/3nP3/3P2b1/5N2/PPP2PPP/RNBQKB1R w KQkq - f1e2", null, null],
  [
    "rn1qkb1r/ppp1pppp/3p4/3nP3/3P2b1/5N2/PPP2PPP/RNBQKB1R w KQkq - h2h3",
    "B05",
    "Alekhine Defense: Modern Variation, Panov Variation",
  ],
  ["rn1qkb1r/ppp1pppp/5B2/5b2/3Pp3/2N5/PPP2PPP/R2QKBNR b KQkq - e7f6", null, null],
  ["rn1qkb1r/ppp1pppp/5n2/1B1P1b2/3P4/5P2/PPP3PP/RNBQK1NR b KQkq - b8d7", null, null],
  ["rn1qkb1r/ppp1pppp/5n2/1B1P4/3P2b1/8/PPP2PPP/RNBQK1NR b KQkq - b8d7", null, null],
  [
    "rn1qkb1r/ppp1pppp/5n2/1B1P4/3P2b1/8/PPP2PPP/RNBQK1NR b KQkq - c7c6",
    "B01",
    "Scandinavian Defense: Portuguese Gambit, Elbow Variation",
  ],
  [
    "rn1qkb1r/ppp1pppp/5n2/3p1b2/3P3B/2N2P2/PPP1P1PP/R2QKBNR w KQkq - e2e4",
    "A45",
    "Trompowsky Attack: Edge Variation, Hergert Gambit",
  ],
  [
    "rn1qkb1r/ppp1pppp/5n2/3P1b2/3P4/5P2/PPP3PP/RNBQKBNR w KQkq - c2c4",
    "B01",
    "Scandinavian Defense: Portuguese Gambit, Banker Variation",
  ],
  ["rn1qkb1r/ppp1pppp/5n2/3P1b2/3P4/5P2/PPP3PP/RNBQKBNR w KQkq - f1b5", null, null],
  [
    "rn1qkb1r/ppp1pppp/5n2/3P1b2/3P4/5P2/PPP3PP/RNBQKBNR w KQkq - g2g4",
    "B01",
    "Scandinavian Defense: Portuguese Gambit, Correspondence Refutation",
  ],
  [
    "rn1qkb1r/ppp1pppp/5n2/3p1bB1/3P4/2N5/PPP1PPPP/R2QKBNR w KQkq - f2f3",
    "D01",
    "Richter-Veresov Attack: Richter Variation",
  ],
  [
    "rn1qkb1r/ppp1pppp/5n2/3p1bB1/3P4/2N5/PPP1PPPP/R2QKBNR w KQkq - g5f6",
    "D01",
    "Richter-Veresov Attack: Veresov Variation",
  ],
  ["rn1qkb1r/ppp1pppp/5n2/3P4/3P2b1/5P2/PPP3PP/RNBQKBNR b KQkq - g4f5", null, null],
  ["rn1qkb1r/ppp1pppp/5n2/3P4/3P2b1/8/PPP2PPP/RNBQKBNR w KQkq - f1b5", null, null],
  [
    "rn1qkb1r/ppp1pppp/5n2/3P4/3P2b1/8/PPP2PPP/RNBQKBNR w KQkq - f1e2",
    "B01",
    "Scandinavian Defense: Portuguese Gambit, Wuss Variation",
  ],
  ["rn1qkb1r/ppp1pppp/5n2/3P4/3P2b1/8/PPP2PPP/RNBQKBNR w KQkq - f2f3", null, null],
  [
    "rn1qkb1r/ppp1pppp/5n2/3P4/3P2b1/8/PPP2PPP/RNBQKBNR w KQkq - g1f3",
    "B01",
    "Scandinavian Defense: Portuguese Gambit, Classical Variation",
  ],
  ["rn1qkb1r/ppp1pppp/5n2/4Nb2/3P4/2N5/PPP3PP/R1BQKB1R b KQkq - e7e6", null, null],
  ["rn1qkb1r/ppp1pppp/5n2/5b2/3P4/2N2N2/PPP3PP/R1BQKB1R w KQkq - f3e5", null, null],
  [
    "rn1qkb1r/ppp1pppp/5n2/5b2/3Pp3/2N2P2/PPP3PP/R1BQKBNR w KQkq - f1c4",
    "D00",
    "Blackmar-Diemer Gambit: Zeller Defense, Soller Attack",
  ],
  ["rn1qkb1r/ppp1pppp/5n2/5bB1/3Pp3/2N5/PPP2PPP/R2QKBNR w KQkq - g5f6", null, null],
  ["rn1qkb1r/ppp1pppp/5n2/5bN1/4p3/2N5/PPPP1PPP/R1BQKB1R w KQkq - d1e2", null, null],
  [
    "rn1qkb1r/ppp1pppp/5n2/5bN1/4p3/2N5/PPPPQPPP/R1B1KB1R b KQkq - d8d4",
    "A06",
    "Zukertort Opening: Tennison Gambit, Brigg's Trap",
  ],
  ["rn1qkb1r/ppp1pppp/5n2/8/3P2b1/2N2N1P/PPP3P1/R1BQKB1R b KQkq - g4f3", null, null],
  ["rn1qkb1r/ppp1pppp/5n2/8/3P2b1/2N2N2/PPP3PP/R1BQKB1R w KQkq - h2h3", null, null],
  ["rn1qkb1r/ppp1pppp/5n2/8/3P4/2N2b1P/PPP3P1/R1BQKB1R w KQkq - d1f3", null, null],
  ["rn1qkb1r/ppp1pppp/5n2/8/3P4/2N2Q1P/PPP3P1/R1B1KB1R b KQkq - c7c6", null, null],
  ["rn1qkb1r/ppp2ppp/1n2p3/4Pb2/2PP4/2N2N2/PP4PP/R1BQKB1R b KQkq - f8e7", null, null],
  ["rn1qkb1r/ppp2ppp/1n2p3/4Pb2/2PP4/2N5/PP4PP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rn1qkb1r/ppp2ppp/4pn2/4Nb2/3P2P1/2N5/PPP4P/R1BQKB1R b KQkq - f5e4",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Gunderam Defense, Stader Variation",
  ],
  ["rn1qkb1r/ppp2ppp/4pn2/4Nb2/3P4/2N5/PPP3PP/R1BQKB1R w KQkq - g2g4", null, null],
  ["rn1qkb1r/ppp2ppp/5p2/5b2/3Pp1P1/2N5/PPP2P1P/R2QKBNR b KQkq - f5g6", null, null],
  ["rn1qkb1r/ppp2ppp/5p2/5b2/3Pp3/2N5/PPP2PPP/R2QKBNR w KQkq - g2g4", null, null],
  ["rn1qkb1r/ppp2ppp/5pb1/8/3Pp1P1/2N5/PPP1QP1P/R3KBNR b KQkq - f8b4", null, null],
  ["rn1qkb1r/ppp2ppp/5pb1/8/3Pp1P1/2N5/PPP2P1P/R2QKBNR w KQkq - d1e2", null, null],
  [
    "rn1qkb1r/ppp2ppp/8/3pP3/4n1b1/2N2N2/PPPP2PP/R1BQKB1R w KQkq - d1e2",
    "C29",
    "Vienna Game: Vienna Gambit, Kaufmann Variation",
  ],
  [
    "rn1qkbnr/1b1p1ppp/p3p3/1pp5/3PP3/2PB1N2/PP3PPP/RNBQ1RK1 b kq - g8f6",
    "C00",
    "French Defense: St. George Defense, Traditional Line",
  ],
  ["rn1qkbnr/1b1p1ppp/p3p3/1pp5/3PP3/2PB1N2/PP3PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "rn1qkbnr/1bp1pp1p/p2p2p1/1p6/3PP3/2PB1N2/PP3PPP/RNBQ1RK1 b kq - f8g7",
    "B00",
    "St. George Defense: San Jorge Variation",
  ],
  ["rn1qkbnr/1bp1pp1p/p2p2p1/1p6/3PP3/3B1N2/PPP2PPP/RNBQ1RK1 w kq - c2c3", null, null],
  ["rn1qkbnr/1bp1pppp/p2p4/1p6/3PP3/3B1N2/PPP2PPP/RNBQ1RK1 b kq - g7g6", null, null],
  ["rn1qkbnr/1bp1pppp/p2p4/1p6/3PP3/3B1N2/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["rn1qkbnr/1bpppppp/p7/1p6/3PP3/3B1N2/PPP2PPP/RNBQK2R b KQkq - d7d6", null, null],
  ["rn1qkbnr/1bpppppp/p7/1p6/3PP3/3B1N2/PPP2PPP/RNBQK2R b KQkq - e7e6", "B00", "St. George Defense: Polish Variation"],
  ["rn1qkbnr/1bpppppp/p7/1p6/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  ["rn1qkbnr/1pp1pppp/p7/8/2BP2b1/4PN2/PP3PPP/RNBQK2R b KQkq - e7e6", null, null],
  ["rn1qkbnr/1pp1pppp/p7/8/2pP2b1/4PN2/PP3PPP/RNBQKB1R w KQkq - f1c4", null, null],
  [
    "rn1qkbnr/1pp2ppp/p3p3/8/2BP2b1/4PN2/PP3PPP/RNBQK2R w KQkq - d4d5",
    "D22",
    "Queen's Gambit Accepted: Alekhine Defense, Alatortsev Variation",
  ],
  ["rn1qkbnr/p1ppp1pp/1p6/5P1Q/3P4/3B4/PPP2PbP/RNB1K1NR b KQkq - g7g6", "B00", "Owen Defense: Matovinsky Gambit"],
  ["rn1qkbnr/p1ppp1pp/1p6/5P2/3P4/3B4/PPP2PbP/RNBQK1NR w KQkq - d1h5", null, null],
  ["rn1qkbnr/pBp1pppp/8/8/2Pp2b1/8/PP1PPP1P/RNBQK1NR b KQkq - b8d7", null, null],
  [
    "rn1qkbnr/pbp2ppp/1p2p3/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R w KQkq - e1g1",
    "A13",
    "English Opening: Agincourt Defense, Catalan Defense",
  ],
  ["rn1qkbnr/pbpp1ppp/1p2p3/8/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rn1qkbnr/pbpp1ppp/1p2p3/8/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - f7f5", null, null],
  ["rn1qkbnr/pbpp1ppp/1p2p3/8/2PPP3/3B4/PP3PPP/RNBQK1NR b KQkq - b8c6", "A40", "English Defense: Perrin Variation"],
  ["rn1qkbnr/pbpp1ppp/1p2p3/8/2PPP3/5P2/PP4PP/RNBQKBNR b KQkq - f7f5", null, null],
  ["rn1qkbnr/pbpp1ppp/1p2p3/8/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - f1d3", null, null],
  ["rn1qkbnr/pbpp1ppp/1p2p3/8/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - f2f3", null, null],
  [
    "rn1qkbnr/pbpp2pp/1p2p3/5P2/2PP4/2N5/PP3PPP/R1BQKBNR b KQkq - g8f6",
    "A40",
    "English Defense: Hartlaub Gambit Accepted",
  ],
  ["rn1qkbnr/pbpp2pp/1p2p3/5P2/2PP4/5P2/PP4PP/RNBQKBNR b KQkq - g8h6", "A40", "English Defense: Poli Gambit"],
  [
    "rn1qkbnr/pbpp2pp/1p2p3/5p2/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - d4d5",
    "A40",
    "English Defense: Hartlaub Gambit Declined",
  ],
  ["rn1qkbnr/pbpp2pp/1p2p3/5p2/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - e4f5", null, null],
  ["rn1qkbnr/pbpp2pp/1p2p3/5p2/2PPP3/5P2/PP4PP/RNBQKBNR w KQkq - e4f5", null, null],
  ["rn1qkbnr/pbppp1pp/1p6/5P2/3P4/3B4/PPP2PPP/RNBQK1NR b KQkq - b7g2", null, null],
  ["rn1qkbnr/pbppp1pp/1p6/5p2/3PP3/3B4/PPP2PPP/RNBQK1NR w KQkq - e4f5", null, null],
  ["rn1qkbnr/pbpppppp/1p6/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - e7e5", "A40", "English Defense: Eastbourne Gambit"],
  ["rn1qkbnr/pbpppppp/1p6/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rn1qkbnr/pbpppppp/1p6/8/3PP3/3B4/PPP2PPP/RNBQK1NR b KQkq - f7f5", null, null],
  ["rn1qkbnr/pbpppppp/1p6/8/3PP3/5P2/PPP3PP/RNBQKBNR b KQkq - e7e5", "B00", "Owen Defense: Wind Gambit"],
  ["rn1qkbnr/pbpppppp/1p6/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c1g5", "B00", "Owen Defense: Naselwaus Gambit"],
  ["rn1qkbnr/pbpppppp/1p6/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f1d3", null, null],
  ["rn1qkbnr/pbpppppp/1p6/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f2f3", null, null],
  ["rn1qkbnr/pbpppppp/1p6/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", "B00", "Owen Defense: Smith Gambit"],
  ["rn1qkbnr/pbpppppp/8/1p6/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f1b5", "A40", "Polish Defense: Spassky Gambit Accepted"],
  ["rn1qkbnr/pp1b1ppp/8/1B1pp3/3P4/8/PPP2PPP/RNBQK1NR w KQkq - b5d7", null, null],
  ["rn1qkbnr/pp1B1ppp/8/3pp3/3P4/8/PPP2PPP/RNBQK1NR b KQkq - b8d7", null, null],
  ["rn1qkbnr/pp1bpppp/3p4/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - b5d7", null, null],
  ["rn1qkbnr/pp1Bpppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - d8d7", null, null],
  ["rn1qkbnr/pp2ppp1/2p3bp/6N1/3P4/5N2/PPP2PPP/R1BQKB1R w KQkq - g5e6", "B18", "Caro-Kann Defense: Martian Gambit"],
  [
    "rn1qkbnr/pp2ppp1/2p3bp/8/3P3P/5NN1/PPP2PP1/R1BQKB1R b KQkq - b8d7",
    "B19",
    "Caro-Kann Defense: Classical Variation",
  ],
  ["rn1qkbnr/pp2ppp1/2p3bp/8/3P3P/6N1/PPP2PP1/R1BQKBNR w KQkq - g1f3", null, null],
  ["rn1qkbnr/pp2pppp/2p3b1/6N1/3P4/5N2/PPP2PPP/R1BQKB1R b KQkq - h7h6", null, null],
  ["rn1qkbnr/pp2pppp/2p3b1/6N1/3P4/8/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rn1qkbnr/pp2pppp/2p3b1/8/3P3P/6N1/PPP2PP1/R1BQKBNR b KQkq - h7h6", null, null],
  [
    "rn1qkbnr/pp2pppp/2p3b1/8/3P4/6N1/PPP2PPP/R1BQKBNR w KQkq - f2f4",
    "B18",
    "Caro-Kann Defense: Classical Variation, Maróczy Attack",
  ],
  [
    "rn1qkbnr/pp2pppp/2p3b1/8/3P4/6N1/PPP2PPP/R1BQKBNR w KQkq - g1h3",
    "B18",
    "Caro-Kann Defense: Classical Variation, Flohr Variation",
  ],
  [
    "rn1qkbnr/pp2pppp/2p3b1/8/3P4/6N1/PPP2PPP/R1BQKBNR w KQkq - h2h4",
    "B18",
    "Caro-Kann Defense: Classical Variation, Main Line",
  ],
  [
    "rn1qkbnr/pp2pppp/2p5/3p1b2/2P5/1P3N2/P2PPPPP/RNBQKB1R w KQkq - c1b2",
    "A12",
    "Réti Opening: Anglo-Slav Variation, Bogoljubow Variation",
  ],
  [
    "rn1qkbnr/pp2pppp/2p5/3p4/4P1b1/2N2N1P/PPPP1PP1/R1BQKB1R b KQkq - g4f3",
    "B11",
    "Caro-Kann Defense: Two Knights Attack, Mindeno Variation, Exchange Line",
  ],
  [
    "rn1qkbnr/pp2pppp/2p5/3p4/4P1b1/2N2N1P/PPPP1PP1/R1BQKB1R b KQkq - g4h5",
    "B11",
    "Caro-Kann Defense: Two Knights Attack, Mindeno Variation, Retreat Line",
  ],
  ["rn1qkbnr/pp2pppp/2p5/3p4/4P1b1/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - h2h3", null, null],
  ["rn1qkbnr/pp2pppp/2p5/3p4/6b1/5NP1/PPPPPPBP/RNBQ1RK1 b kq - b8d7", "A07", "King's Indian Attack: Keres Variation"],
  ["rn1qkbnr/pp2pppp/2p5/3p4/6b1/5NP1/PPPPPPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["rn1qkbnr/pp2pppp/2p5/3P4/Q2P4/8/PP2PPPP/RbB1KBNR w KQkq - d5c6", null, null],
  [
    "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - d8b6",
    "B12",
    "Caro-Kann Defense: Advance Variation, Van der Wiel Attack, Dreyev Defense",
  ],
  ["rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - e7e6", null, null],
  ["rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/2P5/PP3PPP/RNBQKBNR b KQkq - e7e6", null, null],
  [
    "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/8/PPP2PPP/RNBQKBNR w KQkq - b1c3",
    "B12",
    "Caro-Kann Defense: Advance Variation, Van der Wiel Attack",
  ],
  [
    "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/8/PPP2PPP/RNBQKBNR w KQkq - b2b4",
    "B12",
    "Caro-Kann Defense: Advance Variation, Prins Attack",
  ],
  ["rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/8/PPP2PPP/RNBQKBNR w KQkq - c2c3", null, null],
  [
    "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g1e2",
    "B12",
    "Caro-Kann Defense: Advance Variation, Bronstein Variation",
  ],
  [
    "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g1f3",
    "B12",
    "Caro-Kann Defense: Advance Variation, Short Variation",
  ],
  [
    "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g2g4",
    "B12",
    "Caro-Kann Defense: Advance Variation, Bayonet Attack",
  ],
  [
    "rn1qkbnr/pp2pppp/2p5/3pPb2/3P4/8/PPP2PPP/RNBQKBNR w KQkq - h2h4",
    "B12",
    "Caro-Kann Defense: Advance Variation, Tal Variation",
  ],
  ["rn1qkbnr/pp2pppp/2p5/5b2/3P4/6N1/PPP2PPP/R1BQKBNR b KQkq - f5g6", null, null],
  ["rn1qkbnr/pp2pppp/2p5/5b2/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - e4g3", null, null],
  ["rn1qkbnr/pp2pppp/2p5/5b2/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - e4g5", null, null],
  ["rn1qkbnr/pp2pppp/2p5/5bN1/3P4/8/PPP2PPP/R1BQKBNR b KQkq - f5g6", null, null],
  [
    "rn1qkbnr/pp2pppp/2P5/8/Q2P4/8/PP2PPPP/RbB1KBNR b KQkq - b8c6",
    "D06",
    "Queen's Gambit Declined: Baltic Defense, Argentinian Gambit",
  ],
  ["rn1qkbnr/pp3ppp/2p1p1b1/3pP3/3P2P1/2N5/PPP1NP1P/R1BQKB1R b KQkq - c6c5", null, null],
  ["rn1qkbnr/pp3ppp/2p1p1b1/3pP3/3P2P1/2N5/PPP2P1P/R1BQKBNR w KQkq - g1e2", null, null],
  ["rn1qkbnr/pp3ppp/2p1p3/3pPb2/3P2P1/2N5/PPP2P1P/R1BQKBNR b KQkq - f5g6", null, null],
  ["rn1qkbnr/pp3ppp/2p1p3/3pPb2/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - g2g4", null, null],
  [
    "rn1qkbnr/pp3ppp/2p1p3/3pPb2/3P4/2P5/PP3PPP/RNBQKBNR w KQkq - f1e2",
    "B12",
    "Caro-Kann Defense: Advance, Short Variation",
  ],
  [
    "rn1qkbnr/pp3ppp/4p1b1/2ppP3/3P2P1/2N5/PPP1NP1P/R1BQKB1R w KQkq - h2h4",
    "B12",
    "Caro-Kann Defense: Advance Variation, Van der Wiel Attack",
  ],
  ["rn1qkbnr/ppp1pppp/3p4/8/2PP2b1/5N2/PP2PPPP/RNBQKB1R b KQkq - b8d7", null, null],
  ["rn1qkbnr/ppp1pppp/3p4/8/3P2b1/5N2/PPP1PPPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rn1qkbnr/ppp1pppp/8/3p1b2/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - e7e6", null, null],
  ["rn1qkbnr/ppp1pppp/8/3p1b2/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - e7e6", null, null],
  ["rn1qkbnr/ppp1pppp/8/3p1b2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rn1qkbnr/ppp1pppp/8/3p1b2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - c4d5", null, null],
  [
    "rn1qkbnr/ppp1pppp/8/3p1b2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d1b3",
    "D06",
    "Queen's Gambit Declined: Baltic Defense, Queen Attack",
  ],
  ["rn1qkbnr/ppp1pppp/8/3p1b2/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rn1qkbnr/ppp1pppp/8/3P1b2/3P4/8/PP2PPPP/RNBQKBNR b KQkq - f5b1", null, null],
  ["rn1qkbnr/ppp1pppp/8/3p4/2P3b1/8/PP1PPPBP/RNBQK1NR b KQkq - d5d4", "A00", "Grob Opening: Romford Countergambit"],
  ["rn1qkbnr/ppp1pppp/8/3P4/3P4/8/PP2PPPP/RbBQKBNR w KQkq - d1a4", null, null],
  ["rn1qkbnr/ppp1pppp/8/3p4/6b1/5NP1/PPPPPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rn1qkbnr/ppp1pppp/8/3p4/6b1/5NP1/PPPPPPBP/RNBQK2R b KQkq - b8d7", "A07", "King's Indian Attack: Keres Variation"],
  ["rn1qkbnr/ppp1pppp/8/3p4/6b1/8/PPPPPPBP/RNBQK1NR w KQkq - c2c4", "A00", "Grob Opening: Grob Gambit, Fritz Gambit"],
  ["rn1qkbnr/ppp1pppp/8/3P4/Q2P4/8/PP2PPPP/RbB1KBNR b KQkq - c7c6", null, null],
  [
    "rn1qkbnr/ppp1pppp/8/5b2/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - g8f6",
    "D00",
    "Blackmar-Diemer Gambit Declined: Vienna Defense",
  ],
  ["rn1qkbnr/ppp1pppp/8/5b2/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f3", null, null],
  ["rn1qkbnr/ppp1pppp/8/8/2Pp2b1/8/PP1PPPBP/RNBQK1NR w KQkq - g2b7", null, null],
  ["rn1qkbnr/ppp2p1p/3p4/6p1/2B1Ppb1/5N1P/PPPP2P1/RNBQ1RK1 b kq - h7h5", null, null],
  ["rn1qkbnr/ppp2p1p/3p4/6p1/2B1Ppb1/5N2/PPPP2PP/RNBQ1RK1 w kq - h2h3", null, null],
  ["rn1qkbnr/ppp2p2/3p4/6pp/2B1Ppb1/5N1P/PPPP2P1/RNBQ1RK1 w kq - h3g4", null, null],
  [
    "rn1qkbnr/ppp2p2/3p4/6pp/2B1PpP1/5N2/PPPP2P1/RNBQ1RK1 b kq - h5g4",
    "C37",
    "King's Gambit Accepted: Middleton Countergambit",
  ],
  ["rn1qkbnr/ppp2ppp/3p4/4p3/3PP1b1/5N2/PPP2PPP/RNBQKB1R w KQkq - d4e5", null, null],
  [
    "rn1qkbnr/ppp2ppp/3p4/4P3/4P1b1/5N2/PPP2PPP/RNBQKB1R b KQkq - b8d7",
    "C41",
    "Philidor Defense: Albin-Blackburne Gambit",
  ],
  [
    "rn1qkbnr/ppp2ppp/4p3/3p1b2/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b8c6",
    "D06",
    "Queen's Gambit Declined: Baltic Defense, Pseudo-Chigorin",
  ],
  [
    "rn1qkbnr/ppp2ppp/4p3/3p1b2/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - c7c6",
    "D02",
    "Queen's Gambit Declined: Baltic Defense, Pseudo-Slav",
  ],
  [
    "rn1qkbnr/ppp2ppp/4p3/3p1b2/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - d1b3",
    "D06",
    "Queen's Gambit Declined: Baltic Defense, Queen Attack Deferred",
  ],
  ["rn1qkbnr/ppp2ppp/4p3/3p1b2/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rn1qkbnr/ppp2ppp/4p3/3p1b2/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rn1qkbnr/ppp2ppp/8/3p4/5p2/6PB/PPPPP2P/RNBQ1RK1 b kq - f4g3", null, null],
  ["rn1qkbnr/ppp2ppp/8/3p4/5p2/6PB/PPPPP2P/RNBQK2R w KQkq - e1g1", "A00", "Hungarian Opening: Paris Gambit"],
  ["rn1qkbnr/ppp2ppp/8/3p4/8/6pB/PPPPP2P/RNBQ1RK1 w kq - h2g3", "A00", "Amar Opening: Paris Gambit, Gent Gambit"],
  ["rn1qkbnr/ppp2ppp/8/3pp3/5P2/6PB/PPPPP2P/RNBQK2R b KQkq - e5f4", null, null],
  ["rn1qkbnr/ppp2ppp/8/3pp3/5P2/6Pb/PPPPP2P/RNBQKB1R w KQkq - f1h3", null, null],
  [
    "rn1qkbnr/pppb1ppp/4p3/8/3PN3/5N2/PPP2PPP/R1BQKB1R b KQkq - d7c6",
    "C10",
    "French Defense: Rubinstein Variation, Fort Knox Variation",
  ],
  ["rn1qkbnr/pppb1ppp/4p3/8/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rn2kb1r/pp2pppp/2p2n2/q3Nb2/3P4/2N5/PPP2PPP/R1BQKB1R w KQkq - g2g4",
    "B01",
    "Scandinavian Defense: Grünfeld Variation",
  ],
  [
    "rn2kb1r/pp2pppp/2pq1n2/5b2/2BP1B2/2N5/PPP1NPPP/R2QK2R b KQkq - d6b4",
    "B01",
    "Scandinavian Defense: Schiller-Pytel Variation, Modern Variation",
  ],
  ["rn2kb1r/pp2pppp/2pq1n2/5b2/2BP4/2N5/PPP1NPPP/R1BQK2R w KQkq - c1f4", null, null],
  ["rn2kb1r/ppp1pppp/5n2/q3Nb2/3P4/2N5/PPP2PPP/R1BQKB1R b KQkq - c7c6", null, null],
  ["rn2kb1r/ppp1pppp/5n2/q4b2/3P4/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f3e5", null, null],
  [
    "rn2kb1r/ppp1pppp/5n2/q7/3P2b1/2N2N2/PPP2PPP/R1BQKB1R w KQkq - h2h3",
    "B01",
    "Scandinavian Defense: Lasker Variation",
  ],
  ["rn2kbnr/pp1qpppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQ1RK1 b kq - b8c6", null, null],
  [
    "rn2kbnr/pp1qpppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c4",
    "B52",
    "Sicilian Defense: Moscow Variation, Sokolsky Variation",
  ],
  ["rn2kbnr/pp1qpppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "rnb1k1nr/3p1ppp/pq2p3/1pb5/3NP3/2NBB3/PPP2PPP/R2QK2R w KQkq - d1g4",
    "B43",
    "Sicilian Defense: Kan Variation, Wing Attack, Christiansen's Dream",
  ],
  [
    "rnb1k1nr/pp1ppp1p/6p1/q1P5/4P3/2b2N2/PPP2PPP/R1BQKB1R w KQkq - b2c3",
    "B27",
    "Pterodactyl Defense: Sicilian, Pteranodon",
  ],
  [
    "rnb1k1nr/pp1ppp1p/6p1/q1P5/4P3/2P2N2/P1P2PPP/R1BQKB1R b KQkq - a5c3",
    "B27",
    "Sicilian Defense: Hyperaccelerated Pterodactyl, Exchange Variation",
  ],
  ["rnb1k1nr/pp1pppbp/6p1/q1p5/2PPP3/2N2N2/PP3PPP/R1BQKB1R b KQkq - d7d6", "A42", "Pterodactyl Defense"],
  ["rnb1k1nr/pp1pppbp/6p1/q1p5/2PPP3/5N2/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N2N2/PPP1BPPP/R1BQK2R b KQkq - d7d6",
    "B06",
    "Pterodactyl Defense: Sicilian, Quetzalcoatlus",
  ],
  [
    "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - c1d2",
    "B27",
    "Pterodactyl Defense: Sicilian, Unpin",
  ],
  [
    "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - c1e3",
    "B27",
    "Pterodactyl Defense: Sicilian, Anhanguera",
  ],
  [
    "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - d4d5",
    "B27",
    "Pterodactyl Defense: Sicilian, Benoni Gambit",
  ],
  [
    "rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f1c4",
    "B06",
    "Pterodactyl Defense: Sicilian, Siroccopteryx",
  ],
  ["rnb1k1nr/pp1pppbp/6p1/q1p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f1e2", null, null],
  ["rnb1k1nr/pp1pppbp/6p1/q1P5/4P3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - g7c3", null, null],
  [
    "rnb1k1nr/pp1pppbp/6p1/q1P5/4P3/5N2/PPP2PPP/RNBQKB1R w KQkq - b1c3",
    "B27",
    "Pterodactyl Defense: Sicilian, Rhamphorhynchus",
  ],
  ["rnb1k1nr/pp2ppbp/1qpp2p1/6B1/3PP3/2N2N2/PPP2PPP/R2QKB1R w KQkq - d1d2", null, null],
  [
    "rnb1k1nr/pp2ppbp/1qpp2p1/6B1/3PP3/2N2N2/PPPQ1PPP/R3KB1R b KQkq - b6b2",
    "B06",
    "Modern Defense: Two Knights Variation, Suttles Variation, Tal Gambit",
  ],
  ["rnb1k1nr/pp3ppp/2p1p3/8/1BP1q3/8/PP2BPPP/R2QK1NR b KQkq - c6c5", null, null],
  ["rnb1k1nr/pp3ppp/2p1p3/8/1BP1q3/8/PP3PPP/R2QKBNR w KQkq - f1e2", null, null],
  ["rnb1k1nr/pp3ppp/2p1p3/8/1bPqN3/8/PP1B1PPP/R2QKBNR w KQkq - d2b4", null, null],
  ["rnb1k1nr/pp3ppp/2p1p3/8/1BPqN3/8/PP3PPP/R2QKBNR b KQkq - d4e4", null, null],
  [
    "rnb1k1nr/pp3ppp/4p3/2B5/2P1q3/8/PP2BPPP/R2QK1NR b KQkq - e4g2",
    "D31",
    "Semi-Slav Defense: Marshall Gambit, Tolush Variation",
  ],
  ["rnb1k1nr/pp3ppp/4p3/2p5/1BP1q3/8/PP2BPPP/R2QK1NR w KQkq - b4c5", null, null],
  [
    "rnb1k1nr/pp3ppp/4p3/2pq4/1b1P4/2NB4/PPP2PPP/R1BQK1NR w KQkq - c1d2",
    "C15",
    "French Defense: Winawer Variation, Kondratiyev Variation",
  ],
  [
    "rnb1k1nr/ppp2pbp/3p4/6p1/2BPPp1q/2N5/PPP3PP/R1BQ1KNR w kq - e4e5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Grimm Attack",
  ],
  ["rnb1k1nr/pppp1p1p/7b/4q3/2B2p2/2NP1Q2/PPP3PP/R1B2RK1 b kq - g8e7", null, null],
  ["rnb1k1nr/pppp1p1p/7b/4q3/2B2p2/3P1Q2/PPP3PP/RNB2RK1 w kq - b1c3", null, null],
  [
    "rnb1k1nr/pppp1pbp/8/6p1/2B1P2q/2N3p1/PPPP3P/R1BQ1KNR w kq - d1f3",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Fraser Variation",
  ],
  ["rnb1k1nr/pppp1pbp/8/6p1/2B1Pp1q/2N3P1/PPPP3P/R1BQ1KNR b kq - f4g3", null, null],
  ["rnb1k1nr/pppp1pbp/8/6p1/2B1Pp1q/2N5/PPPP2PP/R1BQ1KNR w kq - d2d4", null, null],
  [
    "rnb1k1nr/pppp1pbp/8/6p1/2B1Pp1q/2N5/PPPP2PP/R1BQ1KNR w kq - g2g3",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, McDonnell Attack",
  ],
  ["rnb1k1nr/pppp1pbp/8/6p1/2BPPp1q/2N5/PPP3PP/R1BQ1KNR b kq - d7d6", null, null],
  [
    "rnb1k1nr/pppp1pbp/8/6p1/2BPPp1q/2N5/PPP3PP/R1BQ1KNR b kq - g8e7",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Classical Defense",
  ],
  [
    "rnb1k1nr/pppp1ppp/8/4p3/1b2Pq2/2N2N2/PPPP2PP/R1BQKB1R w KQkq - f1c4",
    "C30",
    "King's Gambit Declined: Norwalde Variation, Bücker Gambit",
  ],
  [
    "rnb1k1nr/ppppqppp/1b6/3Pp3/2B1P3/2P2N2/PP3PPP/RNBQK2R w KQkq - d5d6",
    "C53",
    "Italian Game: Classical Variation, Eisinger Variation",
  ],
  ["rnb1k1r1/ppq1np1Q/4p3/2ppP3/3P4/P1P5/2P2PPP/R1B1KBNR b KQq - c5d4", null, null],
  [
    "rnb1k1r1/ppq1np1Q/4p3/3pP3/3p4/P1P5/2P2PPP/R1B1KBNR w KQq - e1d1",
    "C18",
    "French Defense: Winawer Variation, Poisoned Pawn Variation, Paoli Variation",
  ],
  [
    "rnb1k1r1/ppq1np1Q/4p3/3pP3/3p4/P1P5/2P2PPP/R1B1KBNR w KQq - g1e2",
    "C18",
    "French Defense: Winawer Variation, Poisoned Pawn Variation, Main Line",
  ],
  ["rnb1k1r1/ppq1npQp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1B1KBNR w KQq - g7h7", null, null],
  [
    "rnb1k2r/1pq1bppp/p2ppn2/6B1/3NPP2/2N2Q2/PPP3PP/2KR1B1R b kq - b8d7",
    "B99",
    "Sicilian Defense: Najdorf Variation, Main Line",
  ],
  ["rnb1k2r/1pq1bppp/p2ppn2/6B1/3NPP2/2N2Q2/PPP3PP/R3KB1R w KQkq - e1c1", null, null],
  ["rnb1k2r/2q1bppp/p2p1n2/1ppPp3/4P3/2P2N1P/PPB2PP1/RNBQR1K1 w kq - b1d2", null, null],
  [
    "rnb1k2r/2q1bppp/p2p1n2/1ppPp3/4P3/2P2N1P/PPBN1PP1/R1BQR1K1 b kq - g7g5",
    "C88",
    "Ruy Lopez: Closed, Leonhardt Variation",
  ],
  ["rnb1k2r/ppp2p1p/4pp2/3q4/1b1P4/2N5/PPP2PPP/R2QKBNR w KQkq - d1d2", null, null],
  [
    "rnb1k2r/ppp2p1p/4pp2/3q4/1b1P4/2N5/PPPQ1PPP/R3KBNR b KQkq - d5a5",
    "C12",
    "French Defense: McCutcheon Variation, Bogoljubow Variation",
  ],
  ["rnb1k2r/ppp2ppp/4pB2/3q4/1b1P4/2N5/PPP2PPP/R2QKBNR b KQkq - g7f6", null, null],
  ["rnb1k2r/ppp2ppp/4pn2/3q2B1/1b1P4/2N5/PPP2PPP/R2QKBNR w KQkq - g5f6", null, null],
  ["rnb1k2r/ppp2ppp/4pn2/3q4/1b1P4/2N2N2/PPQ1PPPP/R1B1KB1R b KQkq - d5f5", null, null],
  ["rnb1k2r/ppp2ppp/4pn2/3q4/1b1P4/2N5/PPQ1PPPP/R1B1KBNR w KQkq - g1f3", null, null],
  [
    "rnb1k2r/ppp2ppp/4pn2/5q2/1b1P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e6e5",
    "E34",
    "Nimzo-Indian Defense: Classical Variation, Belyavsky Gambit",
  ],
  ["rnb1k2r/ppp2ppp/4pn2/5q2/1b1P4/2N2N2/PPQ1PPPP/R1B1KB1R w KQkq - c2d1", null, null],
  [
    "rnb1k2r/ppp2ppp/8/3q4/4nP2/5N2/PPP1QbPP/RNBK1B1R w kq - f3d2",
    "C32",
    "King's Gambit Declined: Falkbeer Countergambit, Alapin Variation",
  ],
  ["rnb1k2r/pppnqppp/4p3/3pP3/3P1P2/2N5/PPP3PP/R2QKBNR b KQkq - e8g8", null, null],
  [
    "rnb1k2r/pppnqppp/4p3/3pP3/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - c3b5",
    "C14",
    "French Defense: Classical Variation, Alapin Variation",
  ],
  [
    "rnb1k2r/pppnqppp/4p3/3pP3/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - d1d2",
    "C14",
    "French Defense: Classical Variation, Rubinstein Variation",
  ],
  [
    "rnb1k2r/pppnqppp/4p3/3pP3/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - d1g4",
    "C14",
    "French Defense: Classical Variation, Pollock Variation",
  ],
  [
    "rnb1k2r/pppnqppp/4p3/3pP3/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - f1d3",
    "C14",
    "French Defense: Classical Variation, Tarrasch Variation",
  ],
  [
    "rnb1k2r/pppnqppp/4p3/3pP3/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - f2f4",
    "C14",
    "French Defense: Classical Variation, Steinitz Variation",
  ],
  ["rnb1k2r/ppppnp1p/7b/4q3/2B2p2/2NP1Q2/PPP3PP/R1B2RK1 w kq - c1d2", null, null],
  ["rnb1k2r/ppppnp1p/7b/4q3/2B2p2/2NP1Q2/PPPB2PP/R4RK1 b kq - b8c6", null, null],
  [
    "rnb1k2r/ppppnpbp/8/6p1/2BPPp1q/2N5/PPP3PP/R1BQ1KNR w kq - g2g3",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, McDonnell Attack",
  ],
  [
    "rnb1k2r/ppq1nppp/4p3/2ppP3/3P2Q1/P1P5/2P2PPP/R1B1KBNR w KQkq - f1d3",
    "C18",
    "French Defense: Winawer Variation, Poisoned Pawn Variation Declined",
  ],
  ["rnb1k2r/ppq1nppp/4p3/2ppP3/3P2Q1/P1P5/2P2PPP/R1B1KBNR w KQkq - g4g7", null, null],
  [
    "rnb1k2r/ppq1nppp/4p3/2ppP3/3P4/P1P2N2/2P2PPP/R1BQKB1R w KQkq - h2h4",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  ["rnb1k2r/ppq1npQp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1B1KBNR b KQkq - h8g8", null, null],
  ["rnb1kb1N/ppppq1pp/5n2/8/2B1p3/8/PPPP1PPP/RNBQK2R b KQq - d7d5", "C40", "Latvian Gambit: Corkscrew Gambit"],
  [
    "rnb1kb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PqPQ2PP/1R2KB1R b Kkq - b2a3",
    "B97",
    "Sicilian Defense: Najdorf Variation, Poisoned Pawn Accepted",
  ],
  ["rnb1kb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PqPQ2PP/R3KB1R w KQkq - a1b1", null, null],
  ["rnb1kb1r/1p3ppp/pq1ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R w KQkq - d1d2", null, null],
  ["rnb1kb1r/1p3ppp/pq1ppn2/6B1/3NPP2/2N5/PPPQ2PP/R3KB1R b KQkq - b6b2", null, null],
  [
    "rnb1kb1r/1pq2ppp/p2ppn2/8/3NPP2/2N5/PPP1B1PP/R1BQ1RK1 b kq - b8c6",
    "B85",
    "Sicilian Defense: Scheveningen Variation, Classical Variation, Paulsen Variation",
  ],
  ["rnb1kb1r/1pq2ppp/p2ppn2/8/3NPP2/2N5/PPP1B1PP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "rnb1kb1r/2q2ppp/p3pn2/1p2P1B1/3N4/2N5/PPP3PP/R2QKB1R w KQkq - d1e2",
    "B96",
    "Sicilian Defense: Najdorf Variation, Polugaevsky Variation, Simagin Line",
  ],
  [
    "rnb1kb1r/pp1ppppp/1q3n2/2pP2B1/8/8/PPP1PPPP/RN1QKBNR w KQkq - b1c3",
    "A45",
    "Trompowsky Attack: Poisoned Pawn Variation",
  ],
  ["rnb1kb1r/pp1ppppp/2p5/q7/3P3B/2P5/PP1nPPPP/R2QKBNR w KQkq - d1d2", null, null],
  ["rnb1kb1r/pp1ppppp/2p5/q7/3P3B/2P5/PP1QPPPP/R3KBNR b KQkq - d7d5", null, null],
  ["rnb1kb1r/pp1ppppp/2p5/q7/3Pn2B/2P5/PP1NPPPP/R2QKBNR b KQkq - e4d2", null, null],
  ["rnb1kb1r/pp1ppppp/2p5/q7/3Pn2B/8/PPPNPPPP/R2QKBNR w KQkq - c2c3", null, null],
  [
    "rnb1kb1r/pp2pppp/1q3n2/2pp4/3P1B2/4PN2/PPP2PPP/RN1QKB1R w KQkq - b1c3",
    "D02",
    "London System: Poisoned Pawn Variation",
  ],
  [
    "rnb1kb1r/pp2pppp/2p5/q2p4/3P3B/2P5/PP1QPPPP/R3KBNR w KQkq - e2e4",
    "A45",
    "Trompowsky Attack: Edge Variation, Hergert Gambit",
  ],
  ["rnb1kb1r/pp2pppp/2pq1n2/8/2BP4/2N5/PPP1NPPP/R1BQK2R b KQkq - c8f5", null, null],
  ["rnb1kb1r/pp2pppp/2pq1n2/8/2BP4/2N5/PPP2PPP/R1BQK1NR w KQkq - g1e2", null, null],
  [
    "rnb1kb1r/pp2pppp/5n2/2pq4/3P4/2P2N2/PP3PPP/RNBQKB1R b KQkq - c8g4",
    "B22",
    "Sicilian Defense: Alapin Variation, Barmen Defense, Modern Line",
  ],
  ["rnb1kb1r/pp2pppp/5n2/2pq4/3P4/2P5/PP3PPP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnb1kb1r/pp3pp1/2p1pq1p/3p4/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - d1b3",
    "D43",
    "Semi-Slav Defense: Hastings Variation",
  ],
  ["rnb1kb1r/pp3ppp/3qpn2/8/2Bp4/1N3N2/PPP2PPP/R1BQ1RK1 b kq - b8c6", null, null],
  ["rnb1kb1r/pp3ppp/3qpn2/8/2Bp4/5N2/PPPN1PPP/R1BQ1RK1 w kq - d2b3", null, null],
  ["rnb1kb1r/ppp1pppp/3q1n2/8/2BP4/2N5/PPP2PPP/R1BQK1NR b KQkq - c7c6", null, null],
  [
    "rnb1kb1r/ppp1pppp/3q1n2/8/3P4/2N2N2/PPP2PPP/R1BQKB1R b KQkq - a7a6",
    "B01",
    "Scandinavian Defense: Bronstein Variation",
  ],
  ["rnb1kb1r/ppp1pppp/3q1n2/8/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - f1c4", null, null],
  ["rnb1kb1r/ppp1pppp/3q1n2/8/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rnb1kb1r/ppp1pppp/5n2/q7/3P4/2N2N2/PPP2PPP/R1BQKB1R b KQkq - c8f5",
    "B01",
    "Scandinavian Defense: Classical Variation",
  ],
  ["rnb1kb1r/ppp1pppp/5n2/q7/3P4/2N2N2/PPP2PPP/R1BQKB1R b KQkq - c8g4", null, null],
  ["rnb1kb1r/ppp1pppp/5n2/q7/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rnb1kb1r/ppp2ppp/8/3pP2q/8/2NP1Nn1/PPP4P/R1BQKB1R w KQkq - c3d5",
    "C29",
    "Vienna Game: Vienna Gambit, Wurzburger Trap",
  ],
  ["rnb1kb1r/ppp2ppp/8/3pP3/4n2q/2NP2P1/PPP4P/R1BQKBNR b KQkq - e4g3", null, null],
  ["rnb1kb1r/ppp2ppp/8/3pP3/4n2q/2NP4/PPP3PP/R1BQKBNR w KQkq - g2g3", null, null],
  ["rnb1kb1r/ppp2ppp/8/3pP3/7q/2NP1Nn1/PPP4P/R1BQKB1R b KQkq - h4h5", null, null],
  ["rnb1kb1r/ppp2ppp/8/3pP3/7q/2NP2n1/PPP4P/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnb1kb1r/ppp2ppp/8/3q4/4nP2/8/PPP1Q1PP/RNB1KBNR w KQkq - b1d2", null, null],
  ["rnb1kb1r/ppp2ppp/8/3q4/4nP2/8/PPPNQ1PP/R1B1KBNR b KQkq - f7f5", null, null],
  [
    "rnb1kb1r/ppp3pp/8/3q1p2/4nP2/8/PPPNQ1PP/R1B1KBNR w KQkq - g2g4",
    "C32",
    "King's Gambit Declined: Falkbeer Countergambit, Charousek Variation",
  ],
  ["rnb1kb1r/pppp1p1p/7n/4N3/2B1Pppq/8/PPPP2PP/RNBQ1K1R w kq - d2d4", null, null],
  [
    "rnb1kb1r/pppp1p1p/7n/4N3/2BPPppq/8/PPP3PP/RNBQ1K1R b kq - d7d6",
    "C37",
    "King's Gambit Accepted: Salvio Gambit, Anderssen Counterattack",
  ],
  [
    "rnb1kb1r/pppp1p1p/7n/4N3/2BPPppq/8/PPP3PP/RNBQ1K1R b kq - f4f3",
    "C37",
    "King's Gambit Accepted: Silberschmidt Gambit",
  ],
  ["rnb1kb1r/ppppnp1p/8/6p1/2B1Pp1q/2N5/PPPP2PP/R1BQ1KNR w kq - d2d4", null, null],
  [
    "rnb1kb1r/ppppnp1p/8/6p1/2BPPp1q/2N5/PPP3PP/R1BQ1KNR b kq - f8g7",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Classical Defense",
  ],
  ["rnb1kb1r/ppppnppp/8/8/2B1Pp1q/2N5/PPPP2PP/R1BQ1KNR b kq - g7g5", null, null],
  ["rnb1kb1r/ppppnppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR w kq - b1c3", null, null],
  ["rnb1kb1r/ppppqNpp/5n2/8/2B1p3/8/PPPP1PPP/RNBQK2R w KQkq - f7h8", null, null],
  ["rnb1kbnN/ppp3pp/8/3p4/2B1p3/8/PPPP1PqP/RNBQKR2 b Qq - g8f6", "C40", "Latvian Gambit: Behting Variation"],
  ["rnb1kbnr/3p1ppp/pq2p3/1p6/3NP3/2NB4/PPP2PPP/R1BQK2R w KQkq - c1e3", null, null],
  [
    "rnb1kbnr/3p1ppp/pq2p3/1p6/3NP3/2NB4/PPP2PPP/R1BQK2R w KQkq - d4f3",
    "B43",
    "Sicilian Defense: Kan Variation, Wing Attack, Spraggett Attack",
  ],
  ["rnb1kbnr/3p1ppp/pq2p3/1p6/3NP3/2NBB3/PPP2PPP/R2QK2R b KQkq - f8c5", null, null],
  ["rnb1kbnr/pp2pppp/2p5/8/4P3/5N2/PPP2PPP/RNBqKB1R w KQkq - e1d1", "B10", "Caro-Kann Defense: Endgame Variation"],
  ["rnb1kbnr/pp2pppp/8/2pq4/3P4/2P5/PP3PPP/RNBQKBNR b KQkq - b8c6", null, null],
  ["rnb1kbnr/pp2pppp/8/2pq4/3P4/2P5/PP3PPP/RNBQKBNR b KQkq - c5d4", null, null],
  ["rnb1kbnr/pp2pppp/8/2pq4/3P4/2P5/PP3PPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnb1kbnr/pp2pppp/8/2pq4/8/2P5/PP1P1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnb1kbnr/pp2pppp/8/3q4/1p6/P4N2/2PP1PPP/RNBQKB1R b KQkq - e7e5", null, null],
  [
    "rnb1kbnr/pp2pppp/8/3q4/1p6/P7/2PP1PPP/RNBQKBNR w KQkq - c1b2",
    "B20",
    "Sicilian Defense: Wing Gambit, Marienbad Variation",
  ],
  ["rnb1kbnr/pp2pppp/8/3q4/1p6/P7/2PP1PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnb1kbnr/pp2pppp/8/3q4/3p4/2P5/PP3PPP/RNBQKBNR w KQkq - c3d4", null, null],
  ["rnb1kbnr/pp2pppp/8/3q4/3P4/8/PP3PPP/RNBQKBNR b KQkq - b8c6", null, null],
  [
    "rnb1kbnr/pp3ppp/1q2p3/2ppP3/3P4/2P2N2/PP3PPP/RNBQKB1R b KQkq - c8d7",
    "C02",
    "French Defense: Advance Variation, Wade Variation",
  ],
  ["rnb1kbnr/pp3ppp/1q2p3/2ppP3/3P4/2P5/PP3PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnb1kbnr/pp3ppp/3qp3/8/2Bp4/5N2/PPPN1PPP/R1BQ1RK1 b kq - g8f6", null, null],
  ["rnb1kbnr/pp3ppp/3qp3/8/2Bp4/5N2/PPPN1PPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "rnb1kbnr/pp3ppp/4p3/2pq4/3P4/2P2N2/PP3PPP/RNBQKB1R b KQkq - g8f6",
    "B22",
    "Sicilian Defense: Delayed Alapin Variation",
  ],
  ["rnb1kbnr/pp3ppp/4p3/2pq4/3P4/5N2/PPPN1PPP/R1BQKB1R b KQkq - c5d4", null, null],
  ["rnb1kbnr/pp3ppp/4p3/2pq4/3P4/8/PPPN1PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnb1kbnr/pp3ppp/4p3/2pq4/8/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnb1kbnr/pp3ppp/4p3/3q4/2Bp4/5N2/PPPN1PPP/R1BQK2R b KQkq - d5d6", null, null],
  [
    "rnb1kbnr/pp3ppp/4p3/3q4/2Bp4/5N2/PPPN1PPP/R1BQK2R b KQkq - d5d8",
    "C07",
    "French Defense: Tarrasch Variation, Eliskases Variation",
  ],
  ["rnb1kbnr/pp3ppp/4p3/3q4/3p4/5N2/PPPN1PPP/R1BQKB1R w KQkq - f1c4", null, null],
  [
    "rnb1kbnr/pp3ppp/4q3/4p3/1pP5/P4N2/3P1PPP/RNBQKB1R w KQkq - f1d3",
    "B20",
    "Sicilian Defense: Wing Gambit, Nanu Gambit",
  ],
  ["rnb1kbnr/pp3ppp/8/3qp3/1p6/P4N2/1BPP1PPP/RN1QKB1R b KQkq - b8c6", null, null],
  ["rnb1kbnr/pp3ppp/8/3qp3/1p6/P4N2/2PP1PPP/RNBQKB1R w KQkq - c1b2", null, null],
  ["rnb1kbnr/pp3ppp/8/3qp3/1p6/P4N2/2PP1PPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rnb1kbnr/pp3ppp/8/3qp3/1pP5/P4N2/3P1PPP/RNBQKB1R b KQkq c3 d5e6", null, null],
  [
    "rnb1kbnr/ppp1pppp/3q4/8/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - c7c6",
    "B01",
    "Scandinavian Defense: Schiller-Pytel Variation",
  ],
  ["rnb1kbnr/ppp1pppp/3q4/8/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnb1kbnr/ppp1pppp/3q4/8/8/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d4", null, null],
  [
    "rnb1kbnr/ppp1pppp/8/3q4/8/2N5/PP1PPPPP/R1BQKBNR b KQkq - d5a5",
    "A10",
    "English Opening: Anglo-Scandinavian Defense, Malvinas Variation",
  ],
  ["rnb1kbnr/ppp1pppp/8/3q4/8/2N5/PPPP1PPP/R1BQKBNR b KQkq - d5a5", "B01", "Scandinavian Defense: Main Line"],
  [
    "rnb1kbnr/ppp1pppp/8/3q4/8/2N5/PPPP1PPP/R1BQKBNR b KQkq - d5d6",
    "B01",
    "Scandinavian Defense: Gubinsky-Melts Defense",
  ],
  ["rnb1kbnr/ppp1pppp/8/3q4/8/2N5/PPPP1PPP/R1BQKBNR b KQkq - d5d8", "B01", "Scandinavian Defense: Valencian Variation"],
  ["rnb1kbnr/ppp1pppp/8/3q4/8/8/PP1PPPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnb1kbnr/ppp1pppp/8/3q4/8/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnb1kbnr/ppp1pppp/8/q7/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - e7e5",
    "B01",
    "Scandinavian Defense: Anderssen Counterattack",
  ],
  [
    "rnb1kbnr/ppp1pppp/8/q7/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6",
    "B01",
    "Scandinavian Defense: Main Line, Mieses Variation",
  ],
  [
    "rnb1kbnr/ppp1pppp/8/q7/8/2N5/PPPP1PPP/R1BQKBNR w KQkq - b2b4",
    "B01",
    "Scandinavian Defense: Main Line, Leonhardt Gambit",
  ],
  ["rnb1kbnr/ppp1pppp/8/q7/8/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d4", null, null],
  [
    "rnb1kbnr/ppp1qppp/8/8/2Bp4/1Q2P3/PP3PPP/RNB1K1NR w KQkq - a2a3",
    "D20",
    "Queen's Gambit Accepted: Old Variation, Billinger Gambit",
  ],
  [
    "rnb1kbnr/ppp1qppp/8/8/2Bp4/1Q2P3/PP3PPP/RNB1K1NR w KQkq - b1d2",
    "D20",
    "Queen's Gambit Accepted: Old Variation, Novikov Gambit",
  ],
  [
    "rnb1kbnr/ppp1qppp/8/8/2Bp4/1Q2P3/PP3PPP/RNB1K1NR w KQkq - e1f1",
    "D20",
    "Queen's Gambit Accepted: Old Variation, Korchnoi Gambit",
  ],
  [
    "rnb1kbnr/ppp1qppp/8/8/2Bp4/1Q2P3/PP3PPP/RNB1K1NR w KQkq - g1f3",
    "D20",
    "Queen's Gambit Accepted: Old Variation, Christensen Gambit",
  ],
  ["rnb1kbnr/ppp2Npp/8/3p4/2B1p3/8/PPPP1PqP/RNBQKR2 w Qkq - f7h8", null, null],
  [
    "rnb1kbnr/ppp2p1p/8/3B2p1/4Pp1q/8/PPPP2PP/RNBQ1KNR w kq - g2g3",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Chigorin's Attack",
  ],
  [
    "rnb1kbnr/ppp2ppp/8/3B4/4Pp1q/8/PPPP2PP/RNBQ1KNR b kq - f8d6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Boren-Svenonius Variation",
  ],
  ["rnb1kbnr/ppp2ppp/8/3B4/4Pp1q/8/PPPP2PP/RNBQ1KNR b kq - g7g5", null, null],
  ["rnb1kbnr/ppp2ppp/8/3B4/4Pp1q/8/PPPP2PP/RNBQK1NR w KQkq - e1f1", null, null],
  ["rnb1kbnr/ppp2ppp/8/3p4/2B1Pp1q/8/PPPP2PP/RNBQ1KNR w kq - c4d5", null, null],
  [
    "rnb1kbnr/ppp2ppp/8/q3p3/3P4/2N2N2/PPP2PPP/R1BQKB1R b KQkq - c8g4",
    "B01",
    "Scandinavian Defense: Anderssen Counterattack, Collijn Variation",
  ],
  ["rnb1kbnr/ppp2ppp/8/q3p3/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - d4e5", null, null],
  [
    "rnb1kbnr/ppp2ppp/8/q3p3/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3",
    "B01",
    "Scandinavian Defense: Anderssen Counterattack, Goteborg System",
  ],
  ["rnb1kbnr/ppp2ppp/8/q3P3/8/2N5/PPP2PPP/R1BQKBNR b KQkq - b8c6", null, null],
  [
    "rnb1kbnr/ppp3pp/3p1q2/4Np2/3PP3/8/PPP2PPP/RNBQKB1R w KQkq - e5c4",
    "C40",
    "Latvian Gambit Accepted: Bilguer Variation",
  ],
  ["rnb1kbnr/ppp3pp/3p1q2/5p2/2NPP3/8/PPP2PPP/RNBQKB1R b KQkq - f5e4", null, null],
  ["rnb1kbnr/ppp3pp/3p1q2/7Q/2NPp3/8/PPP2PPP/RNB1KB1R b KQkq - g7g6", null, null],
  [
    "rnb1kbnr/ppp3pp/3p1q2/8/2NPp3/8/PPP2PPP/RNBQKB1R w KQkq - c4e3",
    "C40",
    "Latvian Gambit Accepted: Nimzowitsch Attack",
  ],
  ["rnb1kbnr/ppp3pp/3p1q2/8/2NPp3/8/PPP2PPP/RNBQKB1R w KQkq - d1h5", null, null],
  [
    "rnb1kbnr/ppp3pp/3p1q2/8/2NPp3/8/PPP2PPP/RNBQKB1R w KQkq - f1e2",
    "C40",
    "Latvian Gambit Accepted: Bronstein Attack",
  ],
  [
    "rnb1kbnr/ppp4p/3p1qp1/7Q/2NPp3/8/PPP2PPP/RNB1KB1R w KQkq - h5e2",
    "C40",
    "Latvian Gambit Accepted: Bronstein Gambit",
  ],
  ["rnb1kbnr/pppp1B1p/5q2/8/4Pp2/5Q2/PPPP2PP/RNB2RK1 b kq - e8f7", null, null],
  ["rnb1kbnr/pppp1Npp/8/6q1/2B1p3/8/PPPP1PPP/RNBQK2R b KQkq - g5g2", null, null],
  ["rnb1kbnr/pppp1Npp/8/8/2B1p3/8/PPPP1PqP/RNBQK2R w KQkq - h1f1", null, null],
  ["rnb1kbnr/pppp1Npp/8/8/2B1p3/8/PPPP1PqP/RNBQKR2 b Qkq - d7d5", null, null],
  ["rnb1kbnr/pppp1p1p/5q2/4P3/2B2p2/5Q2/PPPP2PP/RNB2RK1 b kq - f6e5", null, null],
  ["rnb1kbnr/pppp1p1p/5q2/8/2B1Pp2/2N2Q2/PPPP2PP/R1B2RK1 b kq - f6d4", null, null],
  [
    "rnb1kbnr/pppp1p1p/5q2/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1 w kq - b1c3",
    "C37",
    "King's Gambit Accepted: Double Muzio Gambit, Bello Gambit",
  ],
  ["rnb1kbnr/pppp1p1p/5q2/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1 w kq - c4f7", null, null],
  ["rnb1kbnr/pppp1p1p/5q2/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1 w kq - e4e5", null, null],
  [
    "rnb1kbnr/pppp1p1p/8/4N3/2B1Pppq/8/PPPP2PP/RNBQ1K1R b kq - b8c6",
    "C37",
    "King's Gambit Accepted: Salvio Gambit, Viennese Variation",
  ],
  [
    "rnb1kbnr/pppp1p1p/8/4N3/2B1Pppq/8/PPPP2PP/RNBQ1K1R b kq - f4f3",
    "C37",
    "King's Gambit Accepted: Salvio Gambit, Cochrane Gambit",
  ],
  [
    "rnb1kbnr/pppp1p1p/8/4N3/2B1Pppq/8/PPPP2PP/RNBQ1K1R b kq - g8f6",
    "C37",
    "King's Gambit Accepted: Salvio Gambit, Santa Maria Defense",
  ],
  [
    "rnb1kbnr/pppp1p1p/8/4N3/2B1Pppq/8/PPPP2PP/RNBQ1K1R b kq - g8h6",
    "C37",
    "King's Gambit Accepted: Salvio Gambit, Silberschmidt Defense",
  ],
  ["rnb1kbnr/pppp1p1p/8/4N3/2B1Pppq/8/PPPP2PP/RNBQK2R w KQkq - e1f1", null, null],
  [
    "rnb1kbnr/pppp1p1p/8/4N3/3PPppq/8/PPP3PP/RNBQKB1R w KQkq - g2g3",
    "C37",
    "King's Gambit Accepted: Rosentreter Gambit, Bird Gambit",
  ],
  ["rnb1kbnr/pppp1p1p/8/4q3/2B2p2/3P1Q2/PPP3PP/RNB2RK1 b kq - f8h6", null, null],
  [
    "rnb1kbnr/pppp1p1p/8/4q3/2B2p2/5Q2/PPPP2PP/RNB2RK1 w kq - c4f7",
    "C37",
    "King's Gambit Accepted: Double Muzio Gambit",
  ],
  ["rnb1kbnr/pppp1p1p/8/4q3/2B2p2/5Q2/PPPP2PP/RNB2RK1 w kq - d2d3", null, null],
  ["rnb1kbnr/pppp1p1p/8/6p1/2B1Pp1q/2N5/PPPP2PP/R1BQ1KNR b kq - f8g7", null, null],
  ["rnb1kbnr/pppp1p1p/8/6p1/2B1Pp1q/8/PPPP2PP/RNBQ1KNR w kq - b1c3", null, null],
  [
    "rnb1kbnr/pppp1p1p/8/6p1/2B1Pp1q/8/PPPP2PP/RNBQ1KNR w kq - d1f3",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Classical Defense, Cozio Attack",
  ],
  ["rnb1kbnr/pppp1p1p/8/8/2BqPp2/2N2Q2/PPPP2PP/R1B2R1K b kq - d4c4", null, null],
  ["rnb1kbnr/pppp1p1p/8/8/2BqPp2/2N2Q2/PPPP2PP/R1B2RK1 w kq - g1h1", null, null],
  [
    "rnb1kbnr/pppp1p1p/8/8/2q1Pp2/2N2Q2/PPPP2PP/R1B2R1K w kq - c3d5",
    "C37",
    "King's Gambit Accepted: Double Muzio Gambit, Baldwin Gambit",
  ],
  ["rnb1kbnr/pppp1ppp/5q2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f6g6", null, null],
  ["rnb1kbnr/pppp1ppp/5q2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnb1kbnr/pppp1ppp/5q2/4p3/4PP2/2N5/PPPP2PP/R1BQKBNR b KQkq - f6f4", null, null],
  ["rnb1kbnr/pppp1ppp/5q2/4p3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnb1kbnr/pppp1ppp/6q1/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - e1g1",
    "C40",
    "King's Pawn Game: La Bourdonnais Gambit",
  ],
  ["rnb1kbnr/pppp1ppp/8/4p3/4PP1q/6P1/PPPP3P/RNBQKBNR b KQkq - h4e7", "C30", "King's Gambit Declined: Keene Defense"],
  ["rnb1kbnr/pppp1ppp/8/4p3/4PP1q/8/PPPP2PP/RNBQKBNR w KQkq - g2g3", "C30", "King's Gambit Declined: Keene's Defense"],
  ["rnb1kbnr/pppp1ppp/8/4p3/4Pq2/2N2N2/PPPP2PP/R1BQKB1R b KQkq - f8b4", null, null],
  [
    "rnb1kbnr/pppp1ppp/8/4p3/4Pq2/2N5/PPPP2PP/R1BQKBNR w KQkq - d2d4",
    "C30",
    "King's Gambit Declined: Norwalde Variation, Schubert Variation",
  ],
  ["rnb1kbnr/pppp1ppp/8/4p3/4Pq2/2N5/PPPP2PP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR b kq - b7b5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Bryan Countergambit",
  ],
  [
    "rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR b kq - b8c6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Boden Variation",
  ],
  ["rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR b kq - d7d5", null, null],
  [
    "rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR b kq - d7d6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Cozio Variation",
  ],
  [
    "rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR b kq - f8c5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Greco Variation",
  ],
  [
    "rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR b kq - g7g5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Lopez Variation",
  ],
  ["rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR b kq - g8e7", null, null],
  [
    "rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQ1KNR b kq - g8f6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, First Jaenisch Variation",
  ],
  ["rnb1kbnr/pppp1ppp/8/8/2B1Pp1q/8/PPPP2PP/RNBQK1NR w KQkq - e1f1", null, null],
  ["rnb1kbnr/pppp2pp/5q2/4Np2/3PP3/8/PPP2PPP/RNBQKB1R b KQkq - d7d6", null, null],
  ["rnb1kbnr/pppp2pp/5q2/4Np2/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "C40", "Latvian Gambit Accepted: Main Line"],
  [
    "rnb1kbnr/pppp2pp/5q2/4Np2/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - e5c4",
    "C40",
    "Latvian Gambit Accepted: Foltys-Leonhardt Variation",
  ],
  ["rnb1kbnr/pppp2pp/5q2/5p2/2N1P3/8/PPPP1PPP/RNBQKB1R b KQkq - f5e4", null, null],
  [
    "rnb1kbnr/pppp2pp/5q2/8/2N1p3/8/PPPP1PPP/RNBQKB1R w KQkq - b1c3",
    "C40",
    "Latvian Gambit Accepted: Leonhardt Variation",
  ],
  [
    "rnb1kbnr/pppp2pp/5q2/8/2N1p3/8/PPPP1PPP/RNBQKB1R w KQkq - d2d3",
    "C40",
    "Latvian Gambit Accepted: Foltys Variation",
  ],
  ["rnb1kbnr/pppp2pp/8/4N1q1/2B1p3/8/PPPP1PPP/RNBQK2R w KQkq - d2d4", null, null],
  ["rnb1kbnr/pppp2pp/8/4N1q1/2B1p3/8/PPPP1PPP/RNBQK2R w KQkq - e5f7", null, null],
  [
    "rnb1kbnr/pppp2pp/8/4N1q1/2BPp3/8/PPP2PPP/RNBQK2R b KQkq d3 g5g2",
    "C40",
    "Latvian Gambit: Mayet Attack, Poisoned Pawn Variation",
  ],
  ["rnb1kbnr/pppp2pp/8/5p2/2B1Pp1q/8/PPPPQ1PP/RNB1K1NR w KQkq - e1d1", null, null],
  ["rnb1kbnr/pppp2pp/8/5p2/2B1Pp1q/8/PPPPQ1PP/RNBK2NR b kq - f5e4", null, null],
  [
    "rnb1kbnr/pppp2pp/8/8/2B1pp1q/2N5/PPPPQ1PP/R1BK2NR b kq - e8d8",
    "C33",
    "King's Gambit Accepted: Lopez-Gianutio Countergambit, Hein Variation",
  ],
  ["rnb1kbnr/pppp2pp/8/8/2B1pp1q/8/PPPPQ1PP/RNBK2NR w kq - b1c3", null, null],
  ["rnb1kbnr/ppppq1pp/5p2/4N3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - e5f3", null, null],
  [
    "rnb1kbnr/ppppq1pp/5p2/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d7d5",
    "C40",
    "King's Pawn Game: Damiano Defense, Damiano Gambit, Chigorin Gambit",
  ],
  [
    "rnb1kbnr/ppppq2p/6p1/4Q3/4P3/8/PPPP1PPP/RNB1KB1R w KQkq - e5h8",
    "C40",
    "King's Pawn Game: Damiano Defense, Damiano Gambit",
  ],
  [
    "rnb1kbnr/ppppq2p/6P1/7Q/5p2/8/PPPP2PP/RNB1KBNR w KQkq - e1d1",
    "C30",
    "King's Gambit Declined: Panteldakis Countergambit, Pawn Sacrifice Line",
  ],
  [
    "rnb1kbnr/ppppq2p/8/4Np2/3PPppP/8/PPP3P1/RNBQKB1R w KQkq - f1c4",
    "C39",
    "King's Gambit Accepted: Kieseritzky, Salvio Defense, Cozio Variation",
  ],
  ["rnb1kbnr/ppppqp1p/8/4N3/3PPppP/8/PPP3P1/RNBQKB1R b KQkq - f7f5", null, null],
  ["rnb1kbnr/ppppqp1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R w KQkq - d2d4", null, null],
  [
    "rnb1kbnr/ppppqppp/8/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f7f5",
    "C40",
    "King's Pawn Game: Gunderam Defense, Gunderam Gambit",
  ],
  ["rnb1kbnr/ppppqppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1c4", null, null],
  [
    "rnb1qrk1/pp2b1pp/2p1pn2/3p1p2/2PP4/2N2NP1/PPQ1PPBP/R1B2RK1 w - - c1g5",
    "A95",
    "Dutch Defense: Stonewall Variation, Chekhover Variation",
  ],
  [
    "rnb1qrk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - b2b3",
    "A99",
    "Dutch Defense: Classical Variation, Ilyin-Zhenevsky Variation, Modern Main Line",
  ],
  [
    "rnb1qrk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - d1c2",
    "A98",
    "Dutch Defense: Classical Variation, Ilyin-Zhenevsky Variation, Alatortsev-Lisitsyn Line",
  ],
  [
    "rnb1qrk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - f1e1",
    "A97",
    "Dutch Defense: Classical Variation, Ilyin-Zhenevsky Variation, Winter Variation",
  ],
  ["rnb2bnr/pppp1k1p/5q2/8/3PPp2/5Q2/PPP3PP/RNB2RK1 b - - f6d4", null, null],
  [
    "rnb2bnr/pppp1k1p/5q2/8/4Pp2/2N1BQ2/PPP3PP/R4RK1 b - - f4e3",
    "C37",
    "King's Gambit Accepted: Double Muzio Gambit, Young Gambit",
  ],
  [
    "rnb2bnr/pppp1k1p/5q2/8/4Pp2/4BQ2/PPP3PP/RN3RK1 w - - b1c3",
    "C37",
    "King's Gambit Accepted: Lolli Gambit, Young Variation",
  ],
  ["rnb2bnr/pppp1k1p/5q2/8/4Pp2/5Q2/PPPP2PP/RNB2RK1 w - - d2d4", null, null],
  ["rnb2bnr/pppp1k1p/8/8/3qPp2/4BQ2/PPP3PP/RN3RK1 b - - d4f6", null, null],
  ["rnb2bnr/pppp1k1p/8/8/3qPp2/5Q2/PPP3PP/RNB2RK1 w - - c1e3", null, null],
  ["rnb2rk1/p1p1qpp1/1p2p2p/3n4/3P4/2N1PN2/PP3PPP/R2QKB1R w KQ - c3d5", null, null],
  ["rnb2rk1/p1p1qpp1/1p2p2p/3N4/3P4/4PN2/PP3PPP/R2QKB1R b KQ - e6d5", null, null],
  [
    "rnb2rk1/p1p1qpp1/1p5p/3p4/3P4/4PN2/PP3PPP/2RQKB1R b K - c8e6",
    "D59",
    "Queen's Gambit Declined: Tartakower Defense",
  ],
  ["rnb2rk1/p1p1qpp1/1p5p/3p4/3P4/4PN2/PP3PPP/R2QKB1R w KQ - a1c1", null, null],
  ["rnb2rk1/pp1nqppp/4p3/2ppP3/3P1P2/2N2N2/PPP3PP/R2QKB1R w KQ - d1d2", null, null],
  ["rnb2rk1/pp1nqppp/4p3/2ppP3/3P1P2/2N2N2/PPPQ2PP/R3KB1R b KQ - b8c6", null, null],
  ["rnb2rk1/pp2qpp1/4pn1p/2p5/2BP4/2N1PN2/PPQ2PPP/R3K2R w KQ - e1g1", null, null],
  ["rnb2rk1/pp2qpp1/4pn1p/2p5/2BP4/2N1PN2/PPQ2PPP/R4RK1 b - - b8c6", null, null],
  [
    "rnb2rk1/ppp1ppbp/6p1/3q4/3P1B2/4P3/PP3PPP/R2QKBNR w KQ - f4c7",
    "D84",
    "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit Accepted",
  ],
  ["rnb2rk1/ppp1qpp1/4p2p/3p4/2PPn3/2N1PN2/PP3PPP/R2QKB1R w KQ - c4d5", null, null],
  [
    "rnb2rk1/ppp1qpp1/4p2p/3p4/2PPn3/2N1PN2/PP3PPP/R2QKB1R w KQ - d1c2",
    "D56",
    "Queen's Gambit Declined: Lasker Defense, Teichmann Variation",
  ],
  ["rnb2rk1/ppp1qpp1/4p2p/3p4/2PPn3/2N1PN2/PPQ2PPP/R3KB1R b KQ - e4f6", null, null],
  [
    "rnb2rk1/ppp1qpp1/4p2p/3P4/3P4/2n1PN2/PP3PPP/R2QKB1R w KQ - b2c3",
    "D57",
    "Queen's Gambit Declined: Lasker Defense, Main Line",
  ],
  ["rnb2rk1/ppp1qpp1/4p2p/3P4/3P4/2P1PN2/P4PPP/R2QKB1R b KQ - e6d5", null, null],
  ["rnb2rk1/ppp1qpp1/4p2p/3P4/3Pn3/2N1PN2/PP3PPP/R2QKB1R b KQ - e4c3", null, null],
  ["rnb2rk1/ppp1qpp1/4pn1p/3p4/2PP4/2N1PN2/PPQ2PPP/R3KB1R w KQ - f1d3", null, null],
  ["rnb2rk1/ppp1qpp1/4pn1p/3p4/2PP4/2NBPN2/PPQ2PPP/R3K2R b KQ - d5c4", null, null],
  ["rnb2rk1/ppp1qpp1/4pn1p/8/2BP4/2N1PN2/PPQ2PPP/R3K2R b KQ - c7c5", null, null],
  ["rnb2rk1/ppp1qpp1/4pn1p/8/2pP4/2NBPN2/PPQ2PPP/R3K2R w KQ - d3c4", null, null],
  [
    "rnb2rk1/ppp1qpp1/7p/3p4/3P4/1QP1PN2/P4PPP/R3KB1R b KQ - e7d6",
    "D57",
    "Queen's Gambit Declined: Lasker Defense, Bernstein Variation",
  ],
  ["rnb2rk1/ppp1qpp1/7p/3p4/3P4/1QP1PN2/P4PPP/R3KB1R b KQ - f8d8", null, null],
  ["rnb2rk1/ppp1qpp1/7p/3p4/3P4/2P1PN2/P4PPP/R2QKB1R w KQ - d1b3", null, null],
  ["rnb2rk1/ppp2pbp/3p2p1/3Pp2n/2P1P2q/2N1BP2/PP1Q2PP/R3KBNR w KQ - g2g3", null, null],
  ["rnb2rk1/ppp2pbp/3p2p1/3Pp2n/2P1P2q/2N1BPP1/PP1Q3P/R3KBNR b KQ - h5g3", null, null],
  ["rnb2rk1/ppp2pbp/3p2p1/3Pp3/2P1P2q/2N1BP2/PP3Q1P/R3KnNR w KQ - f2h4", null, null],
  ["rnb2rk1/ppp2pbp/3p2p1/3Pp3/2P1P2Q/2N1BP2/PP5P/R3KnNR b KQ - f1e3", null, null],
  ["rnb2rk1/ppp2pbp/3p2p1/3Pp3/2P1P2q/2N1BPn1/PP1Q3P/R3KBNR w KQ - d2f2", null, null],
  ["rnb2rk1/ppp2pbp/3p2p1/3Pp3/2P1P2q/2N1BPn1/PP3Q1P/R3KBNR b KQ - g3f1", null, null],
  [
    "rnb2rk1/ppp2pbp/3p2p1/3Pp3/2P1P2Q/2N1nP2/PP2K2P/R5NR b - - e3c4",
    "E87",
    "King's Indian Defense: Sämisch Variation, Orthodox Variation, Bronstein Variation",
  ],
  [
    "rnb2rk1/ppp2pbp/3p2p1/3Pp3/2P1P2Q/2N1nP2/PP5P/R3K1NR w KQ - e1e2",
    "E87",
    "King's Indian Defense: Sämisch Variation, Bronstein Defense",
  ],
  ["rnb2rk1/pppnqppp/4p3/3pP3/3P1P2/2N2N2/PPP3PP/R2QKB1R b KQ - c7c5", null, null],
  ["rnb2rk1/pppnqppp/4p3/3pP3/3P1P2/2N5/PPP3PP/R2QKBNR w KQ - g1f3", null, null],
  [
    "rnb2rk1/pppqppbp/6p1/8/2BPP3/2P5/P3NPPP/R1BQ1RK1 b - - b7b6",
    "D86",
    "Grünfeld Defense: Exchange Variation, Larsen Variation",
  ],
  ["rnb2rk1/pppqppbp/6p1/8/2BPP3/2P5/P3NPPP/R1BQK2R w KQ - e1g1", null, null],
  [
    "rnbq1b1r/ppp2kpp/3p1n2/8/4P3/8/PPPP1PPP/RNBQKB1R w KQ - d2d4",
    "C42",
    "Petrov's Defense: Cochrane Gambit, Center Variation",
  ],
  [
    "rnbq1b1r/ppp2kpp/3p1n2/8/4P3/8/PPPP1PPP/RNBQKB1R w KQ - f1c4",
    "C42",
    "Petrov's Defense: Cochrane Gambit, Bishop Check Line",
  ],
  ["rnbq1b1r/pppp1k2/5n1p/8/4PpQP/8/PPPP2P1/RNB1KB1R w KQ - g4f4", null, null],
  [
    "rnbq1b1r/pppp1k2/5n1p/8/4PQ1P/8/PPPP2P1/RNB1KB1R b KQ - f8d6",
    "C39",
    "King's Gambit Accepted: Allgaier, Horny Defense",
  ],
  ["rnbq1bnr/ppp2k2/7p/3B4/4PppP/8/PPPP2P1/RNBQK2R b KQ - f7g7", null, null],
  ["rnbq1bnr/ppp2k2/7p/3p4/2B1PppP/8/PPPP2P1/RNBQK2R w KQ - c4d5", null, null],
  ["rnbq1bnr/ppp2k2/7p/3p4/3PPBpP/8/PPP3P1/RN1QKB1R b KQ - d5e4", null, null],
  ["rnbq1bnr/ppp2k2/7p/3p4/3PPppP/8/PPP3P1/RNBQKB1R w KQ - c1f4", null, null],
  ["rnbq1bnr/ppp2k2/7p/8/2BPpBpP/8/PPP3P1/RN1QK2R b KQ - f7g7", null, null],
  ["rnbq1bnr/ppp2k2/7p/8/3PpBpP/8/PPP3P1/RN1QKB1R w KQ - f1c4", null, null],
  [
    "rnbq1bnr/ppp3k1/7p/3B4/4PppP/8/PPPP2P1/RNBQK2R w KQ - d2d4",
    "C39",
    "King's Gambit Accepted: Allgaier, Urusov Attack",
  ],
  [
    "rnbq1bnr/ppp3k1/7p/8/2BPpBpP/8/PPP3P1/RN1QK2R w KQ - f4e5",
    "C39",
    "King's Gambit Accepted: Allgaier, Cook Variation",
  ],
  ["rnbq1bnr/pppp1k1p/8/8/4Pp2/5p2/PPPP2PP/RNBQ1RK1 w - - d1f3", null, null],
  ["rnbq1bnr/pppp1k1p/8/8/4Pp2/5Q2/PPPP2PP/RNB2RK1 b - - d8f6", null, null],
  ["rnbq1bnr/pppp1k1p/8/8/4Ppp1/5N2/PPPP2PP/RNBQ1RK1 b - - g4f3", null, null],
  ["rnbq1bnr/pppp1k1p/8/8/4Ppp1/5N2/PPPP2PP/RNBQK2R w KQ - e1g1", null, null],
  ["rnbq1bnr/pppp1k2/7p/8/2B1PppP/8/PPPP2P1/RNBQK2R b KQ - d7d5", null, null],
  ["rnbq1bnr/pppp1k2/7p/8/3PPppP/8/PPP3P1/RNBQKB1R b KQ - d7d5", null, null],
  [
    "rnbq1bnr/pppp1k2/7p/8/4PppP/8/PPPP2P1/RNBQKB1R w KQ - b1c3",
    "C39",
    "King's Gambit Accepted: Allgaier, Blackburne Gambit",
  ],
  ["rnbq1bnr/pppp1k2/7p/8/4PppP/8/PPPP2P1/RNBQKB1R w KQ - d1g4", null, null],
  [
    "rnbq1bnr/pppp1k2/7p/8/4PppP/8/PPPP2P1/RNBQKB1R w KQ - d2d4",
    "C39",
    "King's Gambit Accepted: Allgaier Gambit, Thorold Attack",
  ],
  [
    "rnbq1bnr/pppp1k2/7p/8/4PppP/8/PPPP2P1/RNBQKB1R w KQ - f1c4",
    "C39",
    "King's Gambit Accepted: Allgaier Gambit, Urusov Attack",
  ],
  ["rnbq1bnr/pppp1k2/7p/8/4PpQP/8/PPPP2P1/RNB1KB1R b KQ - g8f6", null, null],
  [
    "rnbq1k1r/ppp2pp1/4p2p/3pP3/3Pn1Q1/2P5/P1PB1PPP/R3KBNR w KQ - d2c1",
    "C12",
    "French Defense: McCutcheon Variation, Duras Variation",
  ],
  [
    "rnbq1rk1/1p3pbp/p2p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQ1RK1 w - - a2a4",
    "A74",
    "Benoni Defense: Classical Variation, Full Line",
  ],
  ["rnbq1rk1/1p3pbp/p2p1np1/2pP4/8/2N2NP1/PP2PPBP/R1BQ1RK1 w - - a2a4", null, null],
  [
    "rnbq1rk1/1p3pbp/p2p1np1/2pP4/P3P3/2N2N2/1P2BPPP/R1BQ1RK1 b - - c8g4",
    "A75",
    "Benoni Defense: Classical Variation, Argentine Counterattack",
  ],
  ["rnbq1rk1/1p3pbp/p2p1np1/2pP4/P7/2N2NP1/1P2PPBP/R1BQ1RK1 b - - b8d7", null, null],
  [
    "rnbq1rk1/2p1bppp/p2p1n2/1p2p3/3PP3/1BP2N1P/PP3PP1/RNBQR1K1 b - - b8d7",
    "C95",
    "Ruy Lopez: Closed, Breyer Defense, Zaitsev Hybrid",
  ],
  [
    "rnbq1rk1/2p1bppp/p2p1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 w - - d2d3",
    "C94",
    "Ruy Lopez: Closed, Breyer Defense, Quiet Variation",
  ],
  ["rnbq1rk1/2p1bppp/p2p1n2/1p2p3/4P3/1BP2N1P/PP1P1PP1/RNBQR1K1 w - - d2d4", "C95", "Ruy Lopez: Closed, Breyer"],
  ["rnbq1rk1/p1p1bpp1/1p2p2p/3n4/3P3B/2N1PN2/PP3PPP/R2QKB1R w KQ - h4e7", null, null],
  ["rnbq1rk1/p1p1Bpp1/1p2p2p/3n4/3P4/2N1PN2/PP3PPP/R2QKB1R b KQ - d8e7", null, null],
  ["rnbq1rk1/p1p1bpp1/1p2pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R w KQ - c4d5", null, null],
  [
    "rnbq1rk1/p1p1bpp1/1p2pn1p/3P4/3P3B/2N1PN2/PP3PPP/R2QKB1R b KQ - e6d5",
    "D58",
    "Queen's Gambit Declined: Tartakower Defense, Exchange Variation",
  ],
  [
    "rnbq1rk1/p1p1bpp1/1p2pn1p/3P4/3P3B/2N1PN2/PP3PPP/R2QKB1R b KQ - f6d5",
    "D59",
    "Queen's Gambit Declined: Tartakower Defense, Makogonov Exchange Variation",
  ],
  ["rnbq1rk1/p1p1bppp/1p2pn2/3p4/2PP4/1P2PN2/PB1N1PPP/R2QKB1R b KQ - c8b7", null, null],
  ["rnbq1rk1/p1p1bppp/1p2pn2/3p4/2PP4/1P2PN2/PB3PPP/RN1QKB1R w KQ - b1d2", null, null],
  ["rnbq1rk1/p1p1bppp/1p2pn2/3p4/2PP4/1PN1PN2/P4PPP/R1BQKB1R w KQ - c4d5", null, null],
  ["rnbq1rk1/p1p1bppp/1p2pn2/3P4/3P4/1PN1PN2/P4PPP/R1BQKB1R b KQ - e6d5", null, null],
  ["rnbq1rk1/p1p1bppp/1p3n2/3p2B1/3P4/2N1PN2/PP3PPP/R2QKB1R w KQ - f1d3", null, null],
  ["rnbq1rk1/p1p1bppp/1p3n2/3p2B1/3P4/2NBPN2/PP3PPP/R2QK2R b KQ - c8b7", null, null],
  ["rnbq1rk1/p1p1bppp/1p3n2/3p4/3P4/1PN1PN2/P4PPP/R1BQKB1R w KQ - c1b2", null, null],
  ["rnbq1rk1/p1p1bppp/1p3n2/3p4/3P4/1PN1PN2/PB3PPP/R2QKB1R b KQ - c8b7", null, null],
  ["rnbq1rk1/p1p2ppp/1p1bpn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - c8b7", "E14", "Queen's Indian Defense, with e3"],
  ["rnbq1rk1/p1p2ppp/1p1bpn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R w KQ - e1g1", null, null],
  [
    "rnbq1rk1/p2p1ppp/1p2pn2/2p5/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - c8b7",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  ["rnbq1rk1/p2p1ppp/1p2pn2/2p5/1bPP4/2NBPN2/PP3PPP/R1BQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/p3bppp/1pp1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1 w - - b1d2", null, null],
  ["rnbq1rk1/p3bppp/1pp1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1 w - - f1d1", null, null],
  ["rnbq1rk1/p3bppp/1pp1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNBR2K1 b - - b8d7", null, null],
  ["rnbq1rk1/p3bppp/1pp1pn2/3p4/2PP4/5NP1/PPQNPPBP/R1B2RK1 b - - c8b7", null, null],
  [
    "rnbq1rk1/pp1p1ppp/4pn2/2b5/2P5/P1N2N2/1PQ1PPPP/R1B1KB1R b KQ - b7b6",
    "E39",
    "Nimzo-Indian Defense: Classical Variation, Berlin Variation, Macieja System",
  ],
  ["rnbq1rk1/pp1p1ppp/4pn2/2b5/2P5/P1N5/1PQ1PPPP/R1B1KBNR w KQ - g1f3", null, null],
  ["rnbq1rk1/pp1p1ppp/4pn2/2P5/1bP5/2N5/PPQ1PPPP/R1B1KBNR w KQ - a2a3", null, null],
  ["rnbq1rk1/pp1p1ppp/4pn2/2P5/1bP5/P1N5/1PQ1PPPP/R1B1KBNR b KQ - b4c5", null, null],
  [
    "rnbq1rk1/pp1p1ppp/4pn2/2p5/1bPP4/2N2NP1/PP2PP1P/R1BQKB1R w KQ - f1g2",
    "E20",
    "Nimzo-Indian Defense: Romanishin Variation",
  ],
  ["rnbq1rk1/pp1p1ppp/4pn2/2p5/1bPP4/2NBP3/PP3PPP/R1BQK1NR w KQ - g1f3", null, null],
  ["rnbq1rk1/pp1p1ppp/4pn2/2p5/1bPP4/2NBPN2/PP3PPP/R1BQK2R b KQ - b7b6", null, null],
  ["rnbq1rk1/pp1p1ppp/4pn2/8/1bPN4/2N3P1/PP2PP1P/R1BQKB1R w KQ - f1g2", null, null],
  ["rnbq1rk1/pp1p1ppp/4pn2/8/1bPN4/2N3P1/PP2PPBP/R1BQK2R b KQ - d7d5", null, null],
  [
    "rnbq1rk1/pp1p1ppp/4pn2/8/1bPP4/2N5/PP2NPPP/R1BQKB1R w KQ - a2a3",
    "E42",
    "Nimzo-Indian Defense: Rubinstein System, Rubinstein Variation, Main Line",
  ],
  [
    "rnbq1rk1/pp1p1ppp/4pn2/8/1bPP4/2N5/PP2NPPP/R1BQKB1R w KQ - c4c5",
    "E42",
    "Nimzo-Indian Defense: Rubinstein System, Rubinstein Variation, Sherbakov Attack",
  ],
  [
    "rnbq1rk1/pp1pppbp/2p2np1/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - d7d5",
    "D78",
    "Neo-Grünfeld Defense: Classical Variation, Original Defense",
  ],
  ["rnbq1rk1/pp1pppbp/2p2np1/8/2PP4/5NP1/PP2PPBP/RNBQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/pp1pppbp/5np1/2p5/2P5/2N2NP1/PP1PPPBP/R1BQ1RK1 b - - b8c6", null, null],
  ["rnbq1rk1/pp1pppbp/5np1/2p5/2P5/5NP1/PP1PPPBP/RNBQ1RK1 w - - b1c3", null, null],
  ["rnbq1rk1/pp1pppbp/5np1/2p5/2PP4/2N1PN2/PP2BPPP/R1BQK2R b KQ - c5d4", null, null],
  ["rnbq1rk1/pp1pppbp/5np1/2p5/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQ - f1e2", null, null],
  ["rnbq1rk1/pp1pppbp/5np1/8/2Pp4/2N1PN2/PP2BPPP/R1BQK2R w KQ - e3d4", null, null],
  ["rnbq1rk1/pp1pppbp/5np1/8/2PP4/2N2N2/PP2BPPP/R1BQK2R b KQ - d7d5", null, null],
  ["rnbq1rk1/pp2b1pp/2p1pn2/3p1p2/2PP4/1P3NP1/P3PPBP/RNBQ1RK1 w - - c1a3", "A94", "Dutch Defense: Stonewall Variation"],
  ["rnbq1rk1/pp2b1pp/2p1pn2/3p1p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 w - - d1c2", null, null],
  ["rnbq1rk1/pp2b1pp/2p1pn2/3p1p2/2PP4/2N2NP1/PPQ1PPBP/R1B2RK1 b - - d8e8", null, null],
  [
    "rnbq1rk1/pp2bpp1/2p2n1p/3p2B1/3P4/2NBP3/PPQ2PPP/R3K1NR w KQ - g5h4",
    "D36",
    "Queen's Gambit Declined: Exchange Variation, Reshevsky Variation",
  ],
  [
    "rnbq1rk1/pp2bppp/2p1pn2/3p4/2P5/1P3NP1/P2PPPBP/RNBQ1RK1 w - - c1b2",
    "A14",
    "Réti Opening: Anglo-Slav Variation, Bogoljubow Variation, Stonewall Line",
  ],
  ["rnbq1rk1/pp2bppp/2p1pn2/3p4/2PP1B2/5NP1/PP2PPBP/RN1Q1RK1 b - - b7b6", "E06", "Catalan Opening: Closed"],
  [
    "rnbq1rk1/pp2bppp/2p1pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1Q1RK1 w - - d1c2",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["rnbq1rk1/pp2bppp/2p1pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1Q1RK1 w - - d2f4", null, null],
  ["rnbq1rk1/pp2bppp/2p1pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - d1c2", null, null],
  ["rnbq1rk1/pp2bppp/2p1pn2/3p4/2PP4/5NP1/PPQ1PPBP/RNB2RK1 b - - b7b6", null, null],
  [
    "rnbq1rk1/pp2bppp/2p1pn2/3p4/2PP4/5NP1/PPQBPPBP/RN2K2R w KQ - e1g1",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["rnbq1rk1/pp2bppp/2p1pn2/3p4/2PP4/5NP1/PPQBPPBP/RN3RK1 b - - b8d7", "E11", "Bogo-Indian Defense: Retreat Variation"],
  [
    "rnbq1rk1/pp2bppp/2p2n2/3p2B1/3P4/2N1P3/PPQ2PPP/R3KBNR w KQ - f1d3",
    "D36",
    "Queen's Gambit Declined: Exchange Variation, Reshevsky Variation",
  ],
  ["rnbq1rk1/pp2bppp/2p2n2/3p2B1/3P4/2NBP3/PPQ2PPP/R3K1NR b KQ - h7h6", null, null],
  ["rnbq1rk1/pp2bppp/3p1n2/2p5/3NP3/2N5/PPP1BPPP/R1BQ1RK1 w - - d4f3", null, null],
  ["rnbq1rk1/pp2bppp/3p1n2/2p5/4P3/2N2N2/PPP1BPPP/R1BQ1RK1 b - - b8c6", null, null],
  ["rnbq1rk1/pp2bppp/3ppn2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 w - - f2f4", null, null],
  ["rnbq1rk1/pp2bppp/3ppn2/8/3NPP2/2N5/PPP1B1PP/R1BQ1RK1 b - - b8c6", null, null],
  [
    "rnbq1rk1/pp2bppp/4pn2/2Pp4/2P2B2/2N1PN2/PP3PPP/R2QKB1R b KQ - e7c5",
    "D37",
    "Queen's Gambit Declined: Harrwitz Attack, Main Line",
  ],
  [
    "rnbq1rk1/pp2bppp/4pn2/2pp4/2P5/1P2PNP1/P2P1PBP/RNBQ1RK1 b - - b8c6",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined",
  ],
  [
    "rnbq1rk1/pp2bppp/4pn2/2pp4/2P5/1P2PNP1/P2P1PBP/RNBQ1RK1 b - - d5d4",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined",
  ],
  [
    "rnbq1rk1/pp2bppp/4pn2/2pp4/2P5/1P3NP1/P2PPPBP/RNBQ1RK1 w - - e2e3",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined",
  ],
  ["rnbq1rk1/pp2bppp/4pn2/2pp4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R w KQ - d4c5", null, null],
  [
    "rnbq1rk1/pp2npbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQ1RK1 w - - b2b4",
    "B10",
    "Caro-Kann Defense: Breyer Variation, Stein Attack",
  ],
  [
    "rnbq1rk1/pp2ppb1/3p1npp/2pP2B1/2P1P3/2N2P2/PP4PP/R2QKBNR w KQ - g5f4",
    "E81",
    "King's Indian Defense: Steiner Attack",
  ],
  [
    "rnbq1rk1/pp2ppbp/1n1p2p1/8/2PP4/2N1B3/PP3PPP/2RQKBNR w K - b2b3",
    "B03",
    "Alekhine Defense: Exchange Variation, Voronezh Variation",
  ],
  ["rnbq1rk1/pp2ppbp/1n1p2p1/8/2PP4/2N2N1P/PP2BPP1/R1BQK2R b KQ - b8c6", null, null],
  ["rnbq1rk1/pp2ppbp/1n1p2p1/8/2PP4/2N2N1P/PP3PP1/R1BQKB1R w KQ - f1e2", null, null],
  ["rnbq1rk1/pp2ppbp/2p2np1/3p4/2PP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - c8f5", "D94", "Grünfeld Defense: Flohr Defense"],
  ["rnbq1rk1/pp2ppbp/2p2np1/3p4/2PP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - c8g4", "D94", "Grünfeld Defense: Smyslov Defense"],
  ["rnbq1rk1/pp2ppbp/2p2np1/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/pp2ppbp/2p2np1/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - c4d5", null, null],
  [
    "rnbq1rk1/pp2ppbp/2p2np1/3P4/3P4/5NP1/PP2PPBP/RNBQ1RK1 b - - c6d5",
    "D79",
    "Neo-Grünfeld Defense: Ultra-Delayed Exchange Variation",
  ],
  [
    "rnbq1rk1/pp2ppbp/2pp1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - c8f5",
    "E62",
    "King's Indian Defense: Fianchetto Variation, Larsen Defense",
  ],
  [
    "rnbq1rk1/pp2ppbp/2pp1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - d8a5",
    "E62",
    "King's Indian Defense: Fianchetto Variation, Kavalek Defense",
  ],
  [
    "rnbq1rk1/pp2ppbp/2pp1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - d8b6",
    "E61",
    "King's Indian Defense: Fianchetto Variation, Benjamin Defense",
  ],
  ["rnbq1rk1/pp2ppbp/2pp1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/pp2ppbp/2pp1np1/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3", null, null],
  ["rnbq1rk1/pp2ppbp/2pp1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR w KQ - f1d3", null, null],
  [
    "rnbq1rk1/pp2ppbp/2pp1np1/8/2PPP3/2NBBP2/PP4PP/R2QK1NR b KQ - a7a6",
    "E81",
    "King's Indian Defense: Sämisch Variation, Byrne Defense",
  ],
  [
    "rnbq1rk1/pp2ppbp/3p1np1/2p3B1/2PPP3/2N2P2/PP4PP/R2QKBNR w KQ - d4d5",
    "A65",
    "Benoni Defense: King's Pawn Line, with Bg5",
  ],
  [
    "rnbq1rk1/pp2ppbp/3p1np1/2p3B1/2PPP3/2N5/PP2BPPP/R2QK1NR w KQ - d4c5",
    "E74",
    "King's Indian Defense: Averbakh Variation, Benoni Defense, Exchange Variation",
  ],
  [
    "rnbq1rk1/pp2ppbp/3p1np1/2p3B1/2PPP3/2N5/PP2BPPP/R2QK1NR w KQ - d4d5",
    "E74",
    "King's Indian Defense: Averbakh Variation, Benoni Defense, Advance Variation",
  ],
  ["rnbq1rk1/pp2ppbp/3p1np1/2P5/2P1P3/2N1BP2/PP4PP/R2QKBNR b KQ - d6c5", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/2p5/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - b8c6", null, null],
  [
    "rnbq1rk1/pp2ppbp/3p1np1/2p5/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3",
    "E65",
    "King's Indian Defense: Fianchetto Variation, Yugoslav Variation",
  ],
  ["rnbq1rk1/pp2ppbp/3p1np1/2p5/2PPP3/2N1BP2/PP4PP/R2QKBNR w KQ - d4c5", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/2p5/2PPP3/2N2P2/PP2N1PP/R1BQKB1R w KQ - d4d5", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/2p5/2PPPP2/2N2N2/PP2B1PP/R1BQK2R b KQ - c5d4", null, null],
  [
    "rnbq1rk1/pp2ppbp/3p1np1/2p5/2PPPP2/2N2N2/PP4PP/R1BQKB1R w KQ - d4d5",
    "E76",
    "King's Indian Defense: Four Pawns Attack, Dynamic Attack",
  ],
  [
    "rnbq1rk1/pp2ppbp/3p1np1/2p5/2PPPP2/2N2N2/PP4PP/R1BQKB1R w KQ - f1e2",
    "E78",
    "King's Indian Defense: Four Pawns Attack, Fluid Attack",
  ],
  ["rnbq1rk1/pp2ppbp/3p1np1/2p5/2PPPP2/2N5/PP2B1PP/R1BQK1NR w KQ - d4d5", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/2pP2B1/2P1P3/2N2P2/PP4PP/R2QKBNR b KQ - e7e6", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/2pP2B1/2P1P3/2N2P2/PP4PP/R2QKBNR b KQ - h7h6", null, null],
  [
    "rnbq1rk1/pp2ppbp/3p1np1/2pP2B1/2P1P3/2N5/PP2BPPP/R2QK1NR b KQ - e7e6",
    "E75",
    "King's Indian Defense: Averbakh Variation, Main Line",
  ],
  ["rnbq1rk1/pp2ppbp/3p1np1/2pP4/2P1P3/2N2P2/PP2N1PP/R1BQKB1R b KQ - e7e6", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/2pP4/2P1PP2/2N2N2/PP4PP/R1BQKB1R b KQ - e7e6", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/2pP4/2P1PP2/2N5/PP2B1PP/R1BQK1NR b KQ - e7e6", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/8/2PNPP2/2N5/PP2B1PP/R1BQK2R b KQ - b8c6", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/8/2PpPP2/2N2N2/PP2B1PP/R1BQK2R w KQ - f3d4", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/8/3NP3/2N1B3/PPP1BPPP/R2Q1RK1 b - - b8c6", null, null],
  ["rnbq1rk1/pp2ppbp/3p1np1/8/3NP3/2N1BP2/PPP3PP/R2QKB1R w KQ - d1d2", null, null],
  [
    "rnbq1rk1/pp2ppbp/3p1np1/8/3NP3/2N1BP2/PPPQ2PP/R3KB1R b KQ - b8c6",
    "B76",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack",
  ],
  ["rnbq1rk1/pp2ppbp/3p1np1/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 w - - c1e3", null, null],
  ["rnbq1rk1/pp2ppbp/5np1/2p5/2P1P3/2N1BP2/PP4PP/R2QKBNR w KQ - d1d8", null, null],
  ["rnbQ1rk1/pp2ppbp/5np1/2p5/2P1P3/2N1BP2/PP4PP/R3KBNR b KQ - f8d8", null, null],
  [
    "rnbq1rk1/pp2ppbp/5np1/2Pp4/2P2B2/2N1P3/PP3PPP/2RQKBNR b K - c8e6",
    "D83",
    "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit, Botvinnik Variation",
  ],
  [
    "rnbq1rk1/pp2ppbp/5np1/2Pp4/2P2B2/2N1P3/PP3PPP/2RQKBNR b K - d8a5",
    "D83",
    "Grünfeld Defense: Brinckmann Attack, Reshevsky Gambit",
  ],
  ["rnbq1rk1/pp2ppbp/5np1/2pp4/2PP1B2/2N1P3/PP3PPP/2RQKBNR w K - d4c5", null, null],
  [
    "rnbq1rk1/pp2ppbp/5np1/3p4/2PP4/2N2N2/PP2BPPP/R1BQ1RK1 b - - b8c6",
    "A56",
    "Grünfeld Defense: Three Knights Variation, Burille Variation, Reversed Tarrasch",
  ],
  ["rnbq1rk1/pp2ppbp/5np1/3p4/2PP4/2N2N2/PP2BPPP/R1BQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/pp2ppbp/6p1/2p5/2BPP3/2P5/P3NPPP/R1BQ1RK1 b - - b8c6", null, null],
  ["rnbq1rk1/pp2ppbp/6p1/2p5/2BPP3/2P5/P3NPPP/R1BQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/pp2ppbp/6p1/2p5/3PP3/2P2N2/P3BPPP/1RBQK2R b K - b8c6", null, null],
  ["rnbq1rk1/pp2ppbp/6p1/2p5/3PP3/2P2N2/P4PPP/1RBQKB1R w K - f1e2", null, null],
  [
    "rnbq1rk1/pp2ppbp/6p1/2pn4/3P4/2N2NP1/PP2PPBP/R1BQK2R w KQ - e1g1",
    "D75",
    "Neo-Grünfeld Defense: Delayed Exchange Variation",
  ],
  [
    "rnbq1rk1/pp2ppbp/6p1/2pn4/3P4/5NP1/PP2PPBP/RNBQ1RK1 w - - d4c5",
    "D75",
    "Neo-Grünfeld Defense: Delayed Exchange Variation",
  ],
  [
    "rnbq1rk1/pp3pb1/3ppnpp/2pP2B1/2P1P3/2N2P2/PP1Q2PP/R3KBNR w KQ - g5h6",
    "E81",
    "King's Indian Defense: Steiner Attack",
  ],
  [
    "rnbq1rk1/pp3pbp/2pp1np1/3Pp3/2P1P3/2N1BP2/PP2N1PP/R2QKB1R b KQ - c6d5",
    "E89",
    "King's Indian Defense: Sämisch Variation, Closed Variation, Main Line",
  ],
  ["rnbq1rk1/pp3pbp/2pp1np1/4p3/2P1P3/2N3P1/PP1PNPBP/R1BQ1RK1 w - - d2d3", null, null],
  [
    "rnbq1rk1/pp3pbp/2pp1np1/4p3/2P1P3/2NP2P1/PP2NPBP/R1BQ1RK1 b - - a7a6",
    "A10",
    "English Opening: King's English Variation, Botvinnik System, Prickly Pawn Pass System",
  ],
  ["rnbq1rk1/pp3pbp/2pp1np1/4p3/2PPP3/2N1BP2/PP2N1PP/R2QKB1R w KQ - d4d5", null, null],
  [
    "rnbq1rk1/pp3pbp/3p1np1/2pp2B1/2P1P3/2N2P2/PP1Q2PP/R3KBNR w KQ - c3d5",
    "E81",
    "King's Indian Defense: Steiner Attack",
  ],
  [
    "rnbq1rk1/pp3pbp/3p1np1/2pp2B1/2P1P3/2N2P2/PP1Q2PP/R3KBNR w KQ - e4d5",
    "A65",
    "Benoni Defense: King's Pawn Line, with Bg5",
  ],
  ["rnbq1rk1/pp3pbp/3p1np1/2pp4/2P1P3/2N1BP2/PP1Q2PP/R3KBNR w KQ - c4d5", "A65", "Benoni Defense: King's Pawn Line"],
  [
    "rnbq1rk1/pp3pbp/3p1np1/2pp4/2P1P3/2N2PN1/PP4PP/R1BQKB1R w KQ - c4d5",
    "A65",
    "Benoni Defense: King's Pawn Line, with Nge2",
  ],
  [
    "rnbq1rk1/pp3pbp/3p1np1/2pp4/2P1PP2/2N2N2/PP2B1PP/R1BQK2R w KQ - e4e5",
    "E77",
    "King's Indian Defense: Four Pawns Attack, Florentine Gambit",
  ],
  ["rnbq1rk1/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQ1RK1 b - - a7a6", null, null],
  [
    "rnbq1rk1/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQ1RK1 b - - f8e8",
    "A76",
    "Benoni Defense: Classical Variation, Czerniak Defense",
  ],
  [
    "rnbq1rk1/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQK2R w KQ - e1g1",
    "A73",
    "Benoni Defense: Classical Variation, Main Line",
  ],
  [
    "rnbq1rk1/pp3pbp/3p1np1/2pP4/4PP2/2N2N2/PP2B1PP/R1BQK2R b KQ - f8e8",
    "A69",
    "Benoni Defense: Four Pawns Attack, Main Line",
  ],
  ["rnbq1rk1/pp3pbp/3p1np1/2pP4/4PP2/2N2N2/PP4PP/R1BQKB1R w KQ - f1e2", null, null],
  ["rnbq1rk1/pp3pbp/3p1np1/2pP4/8/2N2NP1/PP2PPBP/R1BQ1RK1 b - - a7a6", null, null],
  [
    "rnbq1rk1/pp3pbp/3p1np1/2pP4/8/2N2NP1/PP2PPBP/R1BQ1RK1 b - - b8d7",
    "A63",
    "Benoni Defense: Fianchetto Variation, Hastings Defense",
  ],
  ["rnbq1rk1/pp3pbp/3p1np1/2pP4/8/2N2NP1/PP2PPBP/R1BQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/pp3pbp/3pPnp1/2p5/2P1PP2/2N5/PP2B1PP/R1BQK1NR b KQ - f7e6", null, null],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP2B1/2P1P3/2N2P2/PP1Q2PP/R3KBNR b KQ - e6d5", null, null],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP2B1/2P1P3/2N2P2/PP1Q2PP/R3KBNR b KQ - h7h6", null, null],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP2B1/2P1P3/2N2P2/PP4PP/R2QKBNR w KQ - d1d2", null, null],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP4/2P1P3/2N1BP2/PP1Q2PP/R3KBNR b KQ - e6d5", null, null],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP4/2P1P3/2N1BP2/PP4PP/R2QKBNR w KQ - d1d2", null, null],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP4/2P1P3/2N2P2/PP2N1PP/R1BQKB1R w KQ - e2g3", null, null],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP4/2P1P3/2N2PN1/PP4PP/R1BQKB1R b KQ - e6d5", null, null],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP4/2P1PP2/2N2N2/PP2B1PP/R1BQK2R b KQ - e6d5", null, null],
  [
    "rnbq1rk1/pp3pbp/3ppnp1/2pP4/2P1PP2/2N2N2/PP4PP/R1BQKB1R w KQ - f1e2",
    "E77",
    "King's Indian Defense: Four Pawns Attack, Normal Attack",
  ],
  ["rnbq1rk1/pp3pbp/3ppnp1/2pP4/2P1PP2/2N5/PP2B1PP/R1BQK1NR w KQ - d5e6", null, null],
  ["rnbq1rk1/pp3pp1/2p1pb1p/3p4/2PP4/2N1PN2/PP3PPP/2RQKB1R w K - f1d3", null, null],
  ["rnbq1rk1/pp3pp1/2p1pb1p/3p4/2PP4/2NBPN2/PP3PPP/2RQK2R b K - b8d7", null, null],
  ["rnbq1rk1/pp3ppp/2pb1p2/8/3P4/2PB4/PP3PPP/R1BQK1NR w KQ - d1c2", null, null],
  [
    "rnbq1rk1/pp3ppp/2pb1p2/8/3P4/2PB4/PPQ2PPP/R1B1K1NR b KQ - h7h6",
    "B15",
    "Caro-Kann Defense: Tartakower Variation, Perlis Line",
  ],
  ["rnbq1rk1/pp3ppp/2pb4/3p4/2PPn3/3B1N2/PP3PPP/RNBQ1RK1 w - - f1e1", null, null],
  [
    "rnbq1rk1/pp3ppp/2pb4/3p4/2PPn3/3B1N2/PP3PPP/RNBQR1K1 b - - c8g4",
    "C42",
    "Petrov's Defense: Classical Attack, Marshall Variation, Chinese Gambit",
  ],
  ["rnbq1rk1/pp3ppp/2pbpn2/3p4/2P5/1PN1PN2/PB1P1PPP/R2QKB1R w KQ - d2d4", null, null],
  ["rnbq1rk1/pp3ppp/2pbpn2/3p4/2PP4/1PN1PN2/PB3PPP/R2QKB1R b KQ - b8d7", "D45", "Semi-Slav Defense: Normal Variation"],
  [
    "rnbq1rk1/pp3ppp/4p3/8/3PP3/5N2/P2Q1PPP/R3KB1R w KQ - f1b5",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Kmoch Variation",
  ],
  ["rnbq1rk1/pp3ppp/4pn2/2bp4/2P2B2/2N1PN2/PP3PPP/R2QKB1R w KQ - d1c2", null, null],
  ["rnbq1rk1/pp3ppp/4pn2/2bp4/2P2B2/2N1PN2/PPQ2PPP/R3KB1R b KQ - b8c6", null, null],
  [
    "rnbq1rk1/pp3ppp/4pn2/2p5/1bBP4/2N1PN2/PP3PPP/R1BQ1RK1 b - - b8d7",
    "E55",
    "Nimzo-Indian Defense: Normal Variation, Gligoric System, Bronstein Variation",
  ],
  [
    "rnbq1rk1/pp3ppp/4pn2/2p5/1bBP4/2N1PN2/PP3PPP/R1BQ1RK1 b - - d8e7",
    "E54",
    "Nimzo-Indian Defense: Normal Variation, Gligoric System, Smyslov Variation",
  ],
  [
    "rnbq1rk1/pp3ppp/4pn2/2p5/1bpP4/2NBPN2/PP3PPP/R1BQ1RK1 w - - d3c4",
    "E54",
    "Nimzo-Indian Defense: Normal Variation, Gligoric System, Exchange Variation",
  ],
  ["rnbq1rk1/pp3ppp/4pn2/2p5/2BP4/P1P1P3/5PPP/R1BQK1NR w KQ - g1f3", null, null],
  ["rnbq1rk1/pp3ppp/4pn2/2p5/2BP4/P1P1PN2/5PPP/R1BQK2R b KQ - b8c6", null, null],
  [
    "rnbq1rk1/pp3ppp/4pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - b7b6",
    "E53",
    "Nimzo-Indian Defense: Normal Variation, Gligoric System, Keres Variation",
  ],
  [
    "rnbq1rk1/pp3ppp/4pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - b8c6",
    "E56",
    "Nimzo-Indian Defense: Normal Variation, Gligoric System, Bernstein Defense",
  ],
  [
    "rnbq1rk1/pp3ppp/4pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - b8d7",
    "E53",
    "Nimzo-Indian Defense: Normal Variation, Gligoric System",
  ],
  ["rnbq1rk1/pp3ppp/4pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQ1RK1 b - - d5c4", null, null],
  ["rnbq1rk1/pp3ppp/4pn2/2pp4/1bPP4/2NBPN2/PP3PPP/R1BQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/pp3ppp/4pn2/2pp4/2PP4/P1P1PP2/6PP/R1BQKBNR w KQ - c4d5", null, null],
  [
    "rnbq1rk1/pp3ppp/4pn2/2pP4/3P4/P1P1PP2/6PP/R1BQKBNR b KQ - f6d5",
    "E24",
    "Nimzo-Indian Defense: Sämisch Variation, Botvinnik Variation",
  ],
  [
    "rnbq1rk1/pp3ppp/4pn2/3P4/1b1N4/2N3P1/PP2PPBP/R1BQK2R b KQ - f6d5",
    "E20",
    "Nimzo-Indian Defense: Romanishin Variation, English Hybrid",
  ],
  ["rnbq1rk1/pp3ppp/4pn2/3p4/1bPN4/2N3P1/PP2PPBP/R1BQK2R w KQ - c4d5", null, null],
  ["rnbq1rk1/pp4bp/3ppnp1/2p5/2P1PP2/2N5/PP2B1PP/R1BQK1NR w KQ - g2g4", null, null],
  ["rnbq1rk1/pp4bp/3ppnp1/2p5/2P1PPP1/2N5/PP2B2P/R1BQK1NR b KQ - b8c6", null, null],
  [
    "rnbq1rk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - a7a5",
    "A96",
    "Dutch Defense: Classical Variation, Buenos Aires Variation",
  ],
  [
    "rnbq1rk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - d8e8",
    "A97",
    "Dutch Defense: Classical Variation, Ilyin-Zhenevsky Variation",
  ],
  [
    "rnbq1rk1/ppp1b1pp/3ppn2/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - f6e4",
    "A96",
    "Dutch Defense: Classical Variation, Huisl Variation",
  ],
  ["rnbq1rk1/ppp1b1pp/3ppn2/5p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3", null, null],
  ["rnbq1rk1/ppp1b1pp/4pn2/3p1p2/2PP4/1P3NP1/P3PPBP/RNBQ1RK1 b - - c7c6", null, null],
  ["rnbq1rk1/ppp1b1pp/4pn2/3p1p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - c7c6", "A95", "Dutch Defense: Stonewall Variation"],
  ["rnbq1rk1/ppp1b1pp/4pn2/3p1p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3", "A92", "Dutch Defense: Stonewall Variation"],
  [
    "rnbq1rk1/ppp1b1pp/4pn2/3p1p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b2b3",
    "A93",
    "Dutch Defense: Stonewall Variation, Botvinnik Variation",
  ],
  ["rnbq1rk1/ppp1bpp1/4p2p/3p4/2PPn2B/2N1PN2/PP3PPP/R2QKB1R w KQ - h4e7", null, null],
  ["rnbq1rk1/ppp1Bpp1/4p2p/3p4/2PPn3/2N1PN2/PP3PPP/R2QKB1R b KQ - d8e7", null, null],
  [
    "rnbq1rk1/ppp1bpp1/4pn1p/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQ - g5f6",
    "D55",
    "Queen's Gambit Declined: Anti-Tartakower Variation",
  ],
  [
    "rnbq1rk1/ppp1bpp1/4pn1p/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQ - g5h4",
    "D55",
    "Queen's Gambit Declined: Neo-Orthodox Variation, Main Line",
  ],
  [
    "rnbq1rk1/ppp1bpp1/4pn1p/3p4/2PP3B/2N1P3/PP3PPP/R2QKBNR w KQ - g1f3",
    "D55",
    "Queen's Gambit Declined: Neo-Orthodox Variation, Main Line",
  ],
  [
    "rnbq1rk1/ppp1bpp1/4pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R b KQ - b7b6",
    "D58",
    "Queen's Gambit Declined: Tartakower Defense",
  ],
  [
    "rnbq1rk1/ppp1bpp1/4pn1p/3p4/2PP3B/2N1PN2/PP3PPP/R2QKB1R b KQ - f6e4",
    "D56",
    "Queen's Gambit Declined: Lasker Defense",
  ],
  [
    "rnbq1rk1/ppp1bpp1/4pn1p/3p4/2PP3B/2N2N2/PP2PPPP/2RQKB1R b K - d5c4",
    "D53",
    "Queen's Gambit Declined: Uhlmann Variation",
  ],
  ["rnbq1rk1/ppp1bpp1/4pn1p/3p4/2PP3B/2N2N2/PP2PPPP/R2QKB1R w KQ - a1c1", null, null],
  [
    "rnbq1rk1/ppp1bpp1/4pn1p/3p4/2PP3B/2N2N2/PP2PPPP/R2QKB1R w KQ - e2e3",
    "D55",
    "Queen's Gambit Declined: Neo-Orthodox Variation, Main Line",
  ],
  ["rnbq1rk1/ppp1bppp/3p1n2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 b - - c7c5", null, null],
  ["rnbq1rk1/ppp1bppp/3p1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R w KQ - e1g1", null, null],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR w KQ - a1c1",
    "D54",
    "Queen's Gambit Declined: Neo-Orthodox Variation",
  ],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR w KQ - g1f3",
    "D55",
    "Queen's Gambit Declined: Modern Variation, Normal Line",
  ],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R b KQ - b8d7",
    "D60",
    "Queen's Gambit Declined: Orthodox Defense",
  ],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R b KQ - h7h6",
    "D55",
    "Queen's Gambit Declined: Neo-Orthodox Variation",
  ],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQ - d1c2",
    "D37",
    "Queen's Gambit Declined: Miles Variation",
  ],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQ - e2e3",
    "D55",
    "Queen's Gambit Declined: Modern Variation, Normal Line",
  ],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2P5/1P2PN2/PB1P1PPP/RN1QKB1R w KQ - d2d4", "A13", "English Opening: Agincourt Defense"],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p4/2P5/1P3NP1/P2PPPBP/RNBQ1RK1 b - - c7c5",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined",
  ],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2P5/1P3NP1/P2PPPBP/RNBQ1RK1 b - - c7c6", null, null],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQ1RK1 w - - b2b3",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined",
  ],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R b KQ - b7b6",
    "D37",
    "Queen's Gambit Declined: Harrwitz Attack, Fianchetto Defense",
  ],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R b KQ - b8d7",
    "D37",
    "Queen's Gambit Declined: Harrwitz Attack, Two Knights Defense",
  ],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R b KQ - c7c5", null, null],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p4/2PP1B2/2N1PN2/PP3PPP/R2QKB1R b KQ - c7c6",
    "D37",
    "Queen's Gambit Declined: Harrwitz Attack, Orthodox Defense",
  ],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP1B2/2N2N2/PP2PPPP/R2QKB1R w KQ - e2e3", null, null],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/1P1BPN2/P4PPP/RNBQK2R b KQ - b7b6", "E14", "Queen's Indian Defense, with e3"],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/1P2PN2/P4PPP/RNBQKB1R w KQ - c1b2", "A13", "English Opening: Agincourt Defense"],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/1P2PN2/P4PPP/RNBQKB1R w KQ - f1d3", null, null],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/1P2PN2/PB3PPP/RN1QKB1R b KQ - b7b6", null, null],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/1PN1PN2/P4PPP/R1BQKB1R b KQ - b7b6", "E14", "Queen's Indian Defense, with e3"],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQ - b2b3", null, null],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1Q1RK1 b - - c7c6", null, null],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1QK2R w KQ - d1c2", null, null],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1QK2R w KQ - e1g1",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - b8d7", "E07", "Catalan Opening: Closed"],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - c7c6", null, null],
  [
    "rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - d5c4",
    "E05",
    "Catalan Opening: Open Defense, Classical Line",
  ],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/ppp1bppp/4pn2/3p4/2PP4/5NP1/PPQBPPBP/RN2K2R b KQ - c7c6", null, null],
  [
    "rnbq1rk1/ppp1bppp/4pn2/8/3PN3/P5N1/1PP1BPPP/R1BQK2R b KQ - b8c6",
    "C15",
    "French Defense: Winawer Variation, Alekhine Gambit, Alatortsev Variation",
  ],
  ["rnbq1rk1/ppp1bppp/4pn2/8/3PN3/P5N1/1PP2PPP/R1BQKB1R w KQ - f1e2", null, null],
  ["rnbq1rk1/ppp1bppp/5n2/3p2B1/3P4/2N1P3/PP3PPP/R2QKBNR w KQ - f1d3", null, null],
  ["rnbq1rk1/ppp1bppp/5n2/3p2B1/3P4/2NBP3/PP3PPP/R2QK1NR b KQ - b8d7", null, null],
  [
    "rnbq1rk1/ppp1p1bp/3p1np1/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - b8c6",
    "A89",
    "Dutch Defense: Leningrad Variation, Matulovic Variation",
  ],
  [
    "rnbq1rk1/ppp1p1bp/3p1np1/5p2/2PP4/2N2NP1/PP2PPBP/R1BQ1RK1 b - - c7c6",
    "A88",
    "Dutch Defense: Leningrad Variation, Warsaw Variation",
  ],
  ["rnbq1rk1/ppp1p1bp/3p1np1/5p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 w - - b1c3", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/4P3/3P1P2/2N2N2/PPP3PP/R1BQKB1R b KQ - f6d7", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N2P2/PP4PP/R2QKBNR b KQ - c7c5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR b KQ - a7a6",
    "E73",
    "King's Indian Defense: Averbakh Variation, Spanish Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR b KQ - b8a6",
    "E73",
    "King's Indian Defense: Averbakh Variation, Modern Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR b KQ - b8c6",
    "E73",
    "King's Indian Defense: Averbakh Variation, Nc6 Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR b KQ - b8d7",
    "E73",
    "King's Indian Defense: Averbakh Variation, Geller Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR b KQ - c7c5",
    "E74",
    "King's Indian Defense: Averbakh Variation, Benoni Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/6B1/2PPP3/2N5/PP2BPPP/R2QK1NR b KQ - h7h6",
    "E73",
    "King's Indian Defense: Averbakh Variation, Flexible Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/1PP5/4PN2/PB1P1PPP/RN1QKB1R w KQ - d2d4",
    "A00",
    "Polish Opening: King's Indian Variation, Sokolsky Attack",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2P1P3/2N3P1/PP1P1PBP/R1BQK1NR w KQ - g1e2", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2P1P3/2N3P1/PP1PNPBP/R1BQK2R b KQ - e7e5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N1PN2/PP2BPPP/R1BQK2R b KQ - b8c6",
    "E60",
    "King's Indian Defense: Semi-Classical Variation, Hollywood Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N1PN2/PP2BPPP/R1BQK2R b KQ - b8d7", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N1PN2/PP2BPPP/R1BQK2R b KQ - c7c6",
    "E60",
    "King's Indian Defense: Semi-Classical Variation, Benoni Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQ - f1e2",
    "E61",
    "King's Indian Defense: Semi-Classical Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N2NP1/PP2PP1P/R1BQKB1R w KQ - f1g2", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R b KQ - b8c6",
    "E62",
    "King's Indian Defense: Fianchetto Variation, Carlsbad Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R b KQ - b8d7",
    "E67",
    "King's Indian Defense: Fianchetto Variation, Debrecen Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R b KQ - c7c5",
    "E64",
    "King's Indian Defense: Fianchetto Variation, Yugoslav Variation, Rare Line",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N2NP1/PP2PPBP/R1BQK2R b KQ - c7c6", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/2N3P1/PP2PPBP/R1BQK1NR w KQ - g1f3", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - b8c6", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - b8d7", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - c7c5",
    "E64",
    "King's Indian Defense: Fianchetto Variation, Yugoslav System",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - c7c6", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PP4/5NP1/PP2PPBP/RNBQK2R w KQ - e1g1", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR b KQ - b7b6",
    "E82",
    "King's Indian Defense: Sämisch Variation, Double Fianchetto",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR b KQ - b8c6",
    "E83",
    "King's Indian Defense: Sämisch Variation, Yates Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR b KQ - c7c5",
    "E81",
    "King's Indian Defense: Sämisch Variation, Sämisch Gambit",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR b KQ - c7c6", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N1BP2/PP4PP/R2QKBNR b KQ - e7e5",
    "E85",
    "King's Indian Defense: Sämisch Variation, Orthodox Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQK2R b KQ - b8a6",
    "E91",
    "King's Indian Defense: Kazakh Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQK2R b KQ - b8d7", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP2BPPP/R1BQK2R b KQ - e7e5",
    "E92",
    "King's Indian Defense: Orthodox Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP3PPP/R1BQKB1R w KQ - c1e3",
    "E90",
    "King's Indian Defense: Larsen Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP3PPP/R1BQKB1R w KQ - c1g5",
    "E90",
    "King's Indian Defense: Zinnowitz Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP3PPP/R1BQKB1R w KQ - f1e2",
    "E91",
    "King's Indian Defense: Orthodox Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP2N1PP/R1BQKB1R b KQ - c7c5", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP4PP/R1BQKBNR w KQ - c1e3", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP4PP/R1BQKBNR w KQ - c1g5", "E81", "King's Indian Defense: Steiner Attack"],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP4PP/R1BQKBNR w KQ - g1e2",
    "E81",
    "King's Indian Defense: Sämisch Variation, Bobotsov-Korchnoi-Petrosian Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N3P1/PP3P1P/R1BQKBNR w KQ - f1g2", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N3P1/PP3PBP/R1BQK1NR b KQ - e7e5", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N4P/PP3PP1/R1BQKBNR w KQ - c1e3", "E71", "King's Indian Defense: Karpov System"],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP2BPPP/R1BQK1NR w KQ - c1e3",
    "E73",
    "King's Indian Defense: Semi-Averbakh System",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP2BPPP/R1BQK1NR w KQ - c1g5",
    "E73",
    "King's Indian Defense: Averbakh Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP2BPPP/R1BQK1NR w KQ - f2f4",
    "E77",
    "King's Indian Defense: Four Pawns Attack",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPPP2/2N2N2/PP4PP/R1BQKB1R b KQ - c7c5", null, null],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPPP2/2N5/PP2B1PP/R1BQK1NR b KQ - c7c5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/2PPPP2/2N5/PP4PP/R1BQKBNR w KQ - f1e2",
    "E77",
    "King's Indian Defense: Four Pawns Attack",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/2PPPP2/2N5/PP4PP/R1BQKBNR w KQ - g1f3", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP1BPPP/R1BQ1RK1 b - - b8c6",
    "B08",
    "Pirc Defense: Classical Variation, Quiet System, Chigorin Line",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP1BPPP/R1BQ1RK1 b - - c7c6",
    "B08",
    "Pirc Defense: Classical Variation, Quiet System, Czech Defense",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP1BPPP/R1BQ1RK1 b - - c8g4",
    "B08",
    "Pirc Defense: Classical Variation, Quiet System, Parma Defense",
  ],
  ["rnbq1rk1/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP1BPPP/R1BQK2R w KQ - e1g1", null, null],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/3PPP2/2N2N2/PPP3PP/R1BQKB1R w KQ - c1e3",
    "B09",
    "Pirc Defense: Austrian Attack, Kurajica Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/3PPP2/2N2N2/PPP3PP/R1BQKB1R w KQ - e4e5",
    "B09",
    "Pirc Defense: Austrian Attack, Unzicker Attack",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/3PPP2/2N2N2/PPP3PP/R1BQKB1R w KQ - f1d3",
    "B09",
    "Pirc Defense: Austrian Attack, Weiss Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/3p1np1/8/8/1P3NP1/PBPPPPBP/RN1QK2R w KQ - e1g1",
    "A05",
    "Zukertort Opening: Double Fianchetto Attack",
  ],
  ["rnbq1rk1/ppp1ppbp/5np1/3p4/2PP1B2/2N1P3/PP3PPP/2RQKBNR b K - c7c5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP1B2/2N1P3/PP3PPP/R2QKBNR w KQ - a1c1",
    "D83",
    "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit, Capablanca Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/5np1/3p4/2PP1B2/2N1P3/PP3PPP/R2QKBNR w KQ - c4d5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP1B2/2N2N2/PP2PPPP/R2QKB1R w KQ - e2e3",
    "D93",
    "Grünfeld Defense: Three Knights Variation, Hungarian Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP1B2/2N5/PP2PPPP/2RQKBNR w K - e2e3",
    "D83",
    "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit, Capablanca Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/1QN1PN2/PP3PPP/R1B1KB1R b KQ - e7e6",
    "D95",
    "Grünfeld Defense: Botvinnik Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQ - b2b4",
    "D94",
    "Grünfeld Defense: Makogonov Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQ - c1d2",
    "D94",
    "Grünfeld Defense: Opocensky Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQ - d1b3",
    "D95",
    "Grünfeld Defense: Three Knights Variation, Vienna Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQ - f1d3",
    "D94",
    "Grünfeld Defense: Three Knights Variation, Paris Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/2N2NP1/PP2PP1P/R1BQKB1R w KQ - c4d5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - b8c6",
    "D77",
    "Neo-Grünfeld Defense: Classical Variation, Polgar Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - d5c4",
    "D77",
    "Neo-Grünfeld Defense: Classical Variation, Modern Defense",
  ],
  ["rnbq1rk1/ppp1ppbp/5np1/3p4/2PP4/5NP1/PP2PPBP/RNBQK2R w KQ - c4d5", null, null],
  ["rnbq1rk1/ppp1ppbp/5np1/3P4/3P1B2/2N1P3/PP3PPP/R2QKBNR b KQ - f6d5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/3P1B2/2N1PN2/PPP2PPP/R2QKB1R w KQ - f1e2",
    "A48",
    "Queen's Pawn Game: Barry Attack, Grünfeld Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/5np1/3P4/3P4/2N2NP1/PP2PP1P/R1BQKB1R b KQ - f6d5", null, null],
  ["rnbq1rk1/ppp1ppbp/5np1/3P4/3P4/5NP1/PP2PPBP/RNBQK2R b KQ - f6d5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/5np1/3p4/3P4/5NP1/PPP1PPBP/RNBQ1RK1 w - - c2c4",
    "D77",
    "Neo-Grünfeld Defense: Classical Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/5np1/8/2BP4/1QN1P3/PP3PPP/R1B1K1NR w KQ - g1f3", null, null],
  ["rnbq1rk1/ppp1ppbp/5np1/8/2BP4/1QN1PN2/PP3PPP/R1B1K2R b KQ - b8d7", null, null],
  [
    "rnbq1rk1/ppp1ppbp/5np1/8/2BP4/2N2N2/PPP3PP/R1BQ1RK1 w - - d1e1",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense, Studier Attack",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/8/2BP4/2N2N2/PPP3PP/R1BQ1RK1 w - - g1h1",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense, Kloss Attack",
  ],
  ["rnbq1rk1/ppp1ppbp/5np1/8/2QP4/2N2N2/PP2PPPP/R1B1KB1R w KQ - e2e4", "D97", "Grünfeld Defense: Russian Variation"],
  [
    "rnbq1rk1/ppp1ppbp/5np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R b KQ - a7a6",
    "D97",
    "Grünfeld Defense: Russian Variation, Hungarian Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R b KQ - b7b6",
    "D97",
    "Grünfeld Defense: Russian Variation, Levenfish Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R b KQ - b8a6",
    "D97",
    "Grünfeld Defense: Russian Variation, Prins Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R b KQ - b8c6",
    "D97",
    "Grünfeld Defense: Russian Variation, Byrne Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R b KQ - c7c6",
    "D97",
    "Grünfeld Defense: Russian Variation, Szabo Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/5np1/8/2QPP3/2N2N2/PP3PPP/R1B1KB1R b KQ - c8g4",
    "D98",
    "Grünfeld Defense: Russian Variation, Smyslov Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/6p1/3n4/3P1B2/2N1P3/PP3PPP/R2QKBNR w KQ - c3d5", null, null],
  ["rnbq1rk1/ppp1ppbp/6p1/3N4/3P1B2/4P3/PP3PPP/R2QKBNR b KQ - d8d5", null, null],
  ["rnbq1rk1/ppp1ppbp/6p1/3n4/3P4/2N2NP1/PP2PP1P/R1BQKB1R w KQ - f1g2", null, null],
  ["rnbq1rk1/ppp1ppbp/6p1/3n4/3P4/2N2NP1/PP2PPBP/R1BQK2R b KQ - c7c5", null, null],
  ["rnbq1rk1/ppp1ppbp/6p1/3n4/3P4/5NP1/PP2PPBP/RNBQ1RK1 b - - c7c5", null, null],
  [
    "rnbq1rk1/ppp1ppbp/6p1/3n4/3P4/5NP1/PP2PPBP/RNBQ1RK1 b - - d5b6",
    "D76",
    "Neo-Grünfeld Defense: Delayed Exchange Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/6p1/3n4/3P4/5NP1/PP2PPBP/RNBQK2R w KQ - e1g1",
    "D74",
    "Neo-Grünfeld Defense: Delayed Exchange Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/6p1/8/2BPP3/2P5/P3NPPP/R1BQK2R b KQ - b7b6",
    "D86",
    "Grünfeld Defense: Exchange Variation, Simagin's Lesser Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/6p1/8/2BPP3/2P5/P3NPPP/R1BQK2R b KQ - b8c6",
    "D86",
    "Grünfeld Defense: Exchange Variation, Simagin's Improved Variation",
  ],
  [
    "rnbq1rk1/ppp1ppbp/6p1/8/2BPP3/2P5/P3NPPP/R1BQK2R b KQ - d8d7",
    "D86",
    "Grünfeld Defense: Exchange Variation, Larsen Variation",
  ],
  ["rnbq1rk1/ppp1ppbp/6p1/8/2BPP3/2P5/P4PPP/R1BQK1NR w KQ - g1e2", null, null],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/3Pp3/2P1P3/2N1BP2/PP4PP/R2QKBNR b KQ - c7c6",
    "E88",
    "King's Indian Defense: Sämisch Variation, Closed Variation",
  ],
  ["rnbq1rk1/ppp2pbp/3p1np1/3Pp3/2P1P3/2N1BP2/PP4PP/R2QKBNR b KQ - f6h5", null, null],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQK2R b KQ - a7a5",
    "E92",
    "King's Indian Defense: Petrosian Variation, Stein Defense",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/3Pp3/2P1P3/2N2N2/PP2BPPP/R1BQK2R b KQ - b8d7",
    "E93",
    "King's Indian Defense: Petrosian Variation, Normal Defense",
  ],
  ["rnbq1rk1/ppp2pbp/3p1np1/4p3/2P1P3/2N3P1/PP1PNPBP/R1BQ1RK1 b - - c7c6", null, null],
  ["rnbq1rk1/ppp2pbp/3p1np1/4p3/2P1P3/2N3P1/PP1PNPBP/R1BQK2R w KQ - e1g1", null, null],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N1BP2/PP2N1PP/R2QKB1R b KQ - c7c6",
    "E86",
    "King's Indian Defense: Sämisch Variation",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N1BP2/PP4PP/R2QKBNR w KQ - d4d5",
    "E87",
    "King's Indian Defense: Sämisch Variation, Closed Variation",
  ],
  ["rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N1BP2/PP4PP/R2QKBNR w KQ - g1e2", null, null],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b - - a7a5",
    "E94",
    "King's Indian Defense: Orthodox Variation, Ukrainian Defense",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b - - b8a6",
    "E94",
    "King's Indian Defense: Orthodox Variation, Glek Defense",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b - - b8c6",
    "E97",
    "King's Indian Defense: Orthodox Variation, Aronin-Taimanov Defense",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b - - b8d7",
    "E94",
    "King's Indian Defense: Orthodox Variation, Positional Defense",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQ1RK1 b - - c7c6",
    "E94",
    "King's Indian Defense: Orthodox Variation, Donner Defense",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQK2R w KQ - c1e3",
    "E92",
    "King's Indian Defense: Orthodox Variation, Gligoric-Taimanov System",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQK2R w KQ - d4d5",
    "E92",
    "King's Indian Defense: Petrosian Variation",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQK2R w KQ - d4e5",
    "E92",
    "King's Indian Defense: Exchange Variation",
  ],
  [
    "rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N2N2/PP2BPPP/R1BQK2R w KQ - e1g1",
    "E94",
    "King's Indian Defense: Orthodox Variation",
  ],
  ["rnbq1rk1/ppp2pbp/3p1np1/4p3/2PPP3/2N3P1/PP3PBP/R1BQK1NR w KQ - g1e2", "E72", "King's Indian Defense: Pomar System"],
  ["rnbq1rk1/ppp2pbp/3p2p1/3Pp2n/2P1P3/2N1BP2/PP1Q2PP/R3KBNR b KQ - d8h4", null, null],
  ["rnbq1rk1/ppp2pbp/3p2p1/3Pp2n/2P1P3/2N1BP2/PP4PP/R2QKBNR w KQ - d1d2", null, null],
  ["rnbq1rk1/ppp2pp1/4pb1p/3p4/2PP4/2N1PN2/PP3PPP/2RQKB1R b K - c7c6", null, null],
  ["rnbq1rk1/ppp2pp1/4pb1p/3p4/2PP4/2N1PN2/PP3PPP/R2QKB1R w KQ - a1c1", null, null],
  [
    "rnbq1rk1/ppp2ppp/3b4/3p4/2PPn3/3B1N2/PP3PPP/RNBQ1RK1 b - - c7c6",
    "C42",
    "Petrov's Defense: Classical Attack, Staunton Variation",
  ],
  [
    "rnbq1rk1/ppp2ppp/3b4/3p4/2PPn3/3B1N2/PP3PPP/RNBQ1RK1 b - - c8g4",
    "C42",
    "Petrov's Defense: Classical Attack, Tarrasch Variation",
  ],
  ["rnbq1rk1/ppp2ppp/3b4/3p4/3Pn3/3B1N2/PPP2PPP/RNBQ1RK1 w - - c2c4", null, null],
  [
    "rnbq1rk1/ppp2ppp/3b4/3pN3/2PPn3/3B4/PP3PPP/RNBQ1RK1 b - - d6e5",
    "C43",
    "Petrov's Defense: Modern Attack, Trifunovic Variation",
  ],
  ["rnbq1rk1/ppp2ppp/3b4/3pN3/3Pn3/3B4/PPP2PPP/RNBQ1RK1 w - - c2c4", null, null],
  ["rnbq1rk1/ppp2ppp/3bpn2/3p4/3P4/1P1BPN2/P1P2PPP/RNBQ1RK1 b - - b8d7", null, null],
  ["rnbq1rk1/ppp2ppp/3bpn2/3p4/3P4/3BPN2/PPP2PPP/RNBQ1RK1 w - - b2b3", null, null],
  ["rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2N1P3/PP2NPPP/R1BQKB1R w KQ - a2a3", null, null],
  ["rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2N1P3/PPQ2PPP/R1B1KBNR w KQ - g1f3", null, null],
  [
    "rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2N1PN2/PP3PPP/R1BQKB1R w KQ - a2a3",
    "E51",
    "Nimzo-Indian Defense: Normal Variation, Sämisch Deferred",
  ],
  [
    "rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2N1PN2/PPQ2PPP/R1B1KB1R b KQ - c7c5",
    "E38",
    "Nimzo-Indian Defense: Classical Variation, Berlin Variation",
  ],
  ["rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2NBP3/PP3PPP/R1BQK1NR w KQ - a2a3", null, null],
  ["rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2NBP3/PP3PPP/R1BQK1NR w KQ - g1f3", null, null],
  [
    "rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2NBPN2/PP3PPP/R1BQK2R b KQ - b7b6",
    "E52",
    "Nimzo-Indian Defense: Normal Variation, Schlechter Defense",
  ],
  ["rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2NBPN2/PP3PPP/R1BQK2R b KQ - b8c6", null, null],
  [
    "rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/2NBPN2/PP3PPP/R1BQK2R b KQ - c7c5",
    "E53",
    "Nimzo-Indian Defense: Normal Variation, Gligoric System",
  ],
  [
    "rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/P1N1P3/1P2NPPP/R1BQKB1R b KQ - b4d6",
    "E46",
    "Nimzo-Indian Defense: Simagin Variation",
  ],
  ["rnbq1rk1/ppp2ppp/4pn2/3p4/1bPP4/P1NBP3/1P3PPP/R1BQK1NR b KQ - b4c3", null, null],
  [
    "rnbq1rk1/ppp2ppp/4pn2/3p4/2PP4/P1bBP3/1P3PPP/R1BQK1NR w KQ - b2c3",
    "E49",
    "Nimzo-Indian Defense: Normal Variation, Botvinnik System",
  ],
  ["rnbq1rk1/ppp2ppp/4pn2/3p4/2PP4/P1PBP3/5PPP/R1BQK1NR b KQ - d5c4", null, null],
  ["rnbq1rk1/ppp2ppp/4pn2/8/2BP4/P1P1P3/5PPP/R1BQK1NR b KQ - c7c5", null, null],
  ["rnbq1rk1/ppp2ppp/4pn2/8/2pP4/P1PBP3/5PPP/R1BQK1NR w KQ - d3c4", null, null],
  [
    "rnbq1rk1/pppnppbp/3p2p1/4P3/3P1P2/2N2N2/PPP3PP/R1BQKB1R w KQ - h2h4",
    "B09",
    "Pirc Defense: Austrian Attack, Unzicker Attack, Bronstein Variation",
  ],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP2NPPP/R1BQKB1R b KQ - d7d5", null, null],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR w KQ - a2a3", null, null],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR w KQ - f1d3", "E47", "Nimzo-Indian Defense: Normal Variation"],
  [
    "rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR w KQ - g1e2",
    "E46",
    "Nimzo-Indian Defense: Reshevsky Variation",
  ],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR w KQ - g1f3", "E50", "Nimzo-Indian Defense"],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1P3/PPQ2PPP/R1B1KBNR b KQ - d7d5", null, null],
  [
    "rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N1PN2/PP3PPP/R1BQKB1R b KQ - d7d5",
    "E51",
    "Nimzo-Indian Defense: Normal Variation, Ragozin Variation",
  ],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR w KQ - a2a3", null, null],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR w KQ - e2e3", null, null],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2NBP3/PP3PPP/R1BQK1NR b KQ - c7c5", null, null],
  [
    "rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/2NBP3/PP3PPP/R1BQK1NR b KQ - d7d5",
    "E48",
    "Nimzo-Indian Defense: Normal Variation, Classical Defense",
  ],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/P1N1P3/1P3PPP/R1BQKBNR b KQ - b4c3", null, null],
  ["rnbq1rk1/pppp1ppp/4pn2/8/1bPP4/P1N5/1PQ1PPPP/R1B1KBNR b KQ - b4c3", null, null],
  [
    "rnbq1rk1/pppp1ppp/4pn2/8/2PP4/P1b1P3/1P3PPP/R1BQKBNR w KQ - b2c3",
    "E28",
    "Nimzo-Indian Defense: Sämisch Variation",
  ],
  ["rnbq1rk1/pppp1ppp/4pn2/8/2PP4/P1b5/1PQ1PPPP/R1B1KBNR w KQ - c2c3", null, null],
  [
    "rnbq1rk1/pppp1ppp/4pn2/8/2PP4/P1Q5/1P2PPPP/R1B1KBNR b KQ - b7b5",
    "E32",
    "Nimzo-Indian Defense: Classical Variation, Vitolins-Adorjan Gambit",
  ],
  [
    "rnbq1rk1/pppp1ppp/4pn2/8/2PP4/P1Q5/1P2PPPP/R1B1KBNR b KQ - b7b6",
    "E32",
    "Nimzo-Indian Defense: Classical Variation, Keres Defense",
  ],
  ["rnbq1rk1/pppp1ppp/5n2/4p3/1bP5/2N2NP1/PP1PPPBP/R1BQK2R b KQ - f8e8", null, null],
  ["rnbq1rk1/pppp1ppp/5n2/4p3/1bP5/2N3P1/PP1PPPBP/R1BQK1NR w KQ - g1f3", null, null],
  ["rnbq1rk1/ppppb1pp/4pn2/5p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - d7d5", "A92", "Dutch Defense: Stonewall Variation"],
  ["rnbq1rk1/ppppb1pp/4pn2/5p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - d7d6", "A96", "Dutch Defense: Classical Variation"],
  ["rnbq1rk1/ppppb1pp/4pn2/5p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - f6e4", "A92", "Dutch Defense: Alekhine Variation"],
  ["rnbq1rk1/ppppb1pp/4pn2/5p2/2PP4/5NP1/PP2PPBP/RNBQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/ppppp1bp/5np1/5p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b - - d7d6", null, null],
  ["rnbq1rk1/ppppp1bp/5np1/5p2/3P4/5NP1/PPP1PPBP/RNBQ1RK1 w - - c2c4", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2P1P3/2N3P1/PP1P1PBP/R1BQK1NR b KQ - d7d6", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2P5/2N3P1/PP1PPPBP/R1BQK1NR w KQ - e2e4", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2P5/5NP1/PP1PPPBP/RNBQ1RK1 b - - c7c5", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2P5/5NP1/PP1PPPBP/RNBQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQ - d7d6", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQ - e2e3", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQ - g2g3", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/2N2NP1/PP2PP1P/R1BQKB1R b KQ - d7d5", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/2N3P1/PP2PPBP/R1BQK1NR b KQ - d7d6", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQ - f1g2", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/5NP1/PP2PPBP/RNBQK2R b KQ - c7c6", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/5NP1/PP2PPBP/RNBQK2R b KQ - d7d5", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/5NP1/PP2PPBP/RNBQK2R b KQ - d7d6", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/2PP4/6P1/PP2PPBP/RNBQK1NR w KQ - b1c3", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/3P4/5NP1/PPP1PPBP/RNBQ1RK1 b - - d7d5", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/3P4/5NP1/PPP1PPBP/RNBQK2R w KQ - e1g1", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/8/1P3NP1/PBPPPP1P/RN1QKB1R w KQ - f1g2", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/8/1P3NP1/PBPPPPBP/RN1QK2R b KQ - d7d6", null, null],
  ["rnbq1rk1/ppppppbp/5np1/8/8/3P1NP1/PPP1PPBP/RNBQ1RK1 b - - d7d5", "A05", "King's Indian Attack: Wahls Defense"],
  ["rnbq1rk1/ppppppbp/5np1/8/8/5NP1/PPPPPPBP/RNBQ1RK1 w - - d2d3", null, null],
  [
    "rnbqk1n1/pppp1p1r/7b/4N2p/2BPPppP/8/PPP3P1/RNBQK2R w KQq - b1c3",
    "C39",
    "King's Gambit Accepted: Kieseritzky, Long Whip Defense, Jaenisch Variation",
  ],
  ["rnbqk1nb/pp3p2/2pp4/6p1/2BPPp2/2N2N2/PPP3P1/R1BQK3 w Qq - f3e5", "C38", "King's Gambit Accepted: Greco Gambit"],
  [
    "rnbqk1nr/1p2bppp/p2pp3/8/2B1P3/2N2N2/PP2QPPP/R1B2RK1 b kq - g8f6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Finegold Defense",
  ],
  ["rnbqk1nr/1p2bppp/p2pp3/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1 w kq - d1e2", null, null],
  [
    "rnbqk1nr/p4ppp/2p1p3/1P6/2pP4/2P1PN2/5PPP/R1BQKB1R b KQkq - c6b5",
    "D31",
    "Semi-Slav Defense: Noteboom Variation, Abrahams Variation",
  ],
  ["rnbqk1nr/p4ppp/2p1p3/1p6/P1pP4/2P1PN2/5PPP/R1BQKB1R w KQkq - a4b5", null, null],
  [
    "rnbqk1nr/p4ppp/2p1p3/1p6/PbpP4/2N1PN2/1P1B1PPP/R2QKB1R b KQkq - a7a5",
    "D31",
    "Queen's Gambit Declined: Semi-Slav, Abrahams Variation",
  ],
  [
    "rnbqk1nr/p4ppp/2p1p3/1p6/PbpP4/2N1PN2/1P1B1PPP/R2QKB1R b KQkq - d8b6",
    "D31",
    "Queen's Gambit Declined: Semi-Slav, Junge Variation",
  ],
  [
    "rnbqk1nr/p4ppp/2p1p3/1p6/PbpP4/2N1PN2/1P1B1PPP/R2QKB1R b KQkq - d8e7",
    "D31",
    "Queen's Gambit Declined: Semi-Slav, Koomen Variation",
  ],
  ["rnbqk1nr/p4ppp/2p1p3/1p6/PbpP4/2N1PN2/1P3PPP/R1BQKB1R w KQkq - c1d2", null, null],
  [
    "rnbqk1nr/pp1pp1bp/2p3p1/5p2/3P4/5NP1/PPP1PPBP/RNBQ1RK1 b kq - g8h6",
    "A81",
    "Dutch Defense: Leningrad, Basman System",
  ],
  ["rnbqk1nr/pp1pp1bp/2p3p1/5p2/3P4/5NP1/PPP1PPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqk1nr/pp1ppp1p/6p1/2P5/4P3/2b5/PPP2PPP/R1BQKBNR w KQkq - b2c3", null, null],
  [
    "rnbqk1nr/pp1ppp1p/6p1/2P5/4P3/2P5/P1P2PPP/R1BQKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Eastern, Pteranodon",
  ],
  ["rnbqk1nr/pp1ppp1p/6p1/2pP4/2P5/2b5/PP2PPPP/R1BQKBNR w KQkq - b2c3", null, null],
  [
    "rnbqk1nr/pp1ppp1p/6p1/2pP4/2P5/2P5/P3PPPP/R1BQKBNR b KQkq - d8a5",
    "A40",
    "Pterodactyl Defense: Fianchetto, Queen Pteranodon",
  ],
  ["rnbqk1nr/pp1ppp1p/6p1/2pP4/2P5/2P5/P3PPPP/R1BQKBNR b KQkq - f7f5", "A40", "Modern Defense: Beefeater Variation"],
  ["rnbqk1nr/pp1ppp1p/6p1/2pP4/4P3/2b5/PPP2PPP/R1BQKBNR w KQkq - b2c3", null, null],
  [
    "rnbqk1nr/pp1ppp1p/6p1/2pP4/4P3/2P5/P1P2PPP/R1BQKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Eastern, Benoni Pteranodon",
  ],
  ["rnbqk1nr/pp1pppbp/2p3p1/8/2BPP3/2N5/PPP2PPP/R1BQK1NR b KQkq - d7d6", null, null],
  [
    "rnbqk1nr/pp1pppbp/2p3p1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - d7d6",
    "B06",
    "Modern Defense: Two Knights Variation, Suttles Variation",
  ],
  ["rnbqk1nr/pp1pppbp/2p3p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f1c4", null, null],
  ["rnbqk1nr/pp1pppbp/2p3p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f4", null, null],
  ["rnbqk1nr/pp1pppbp/2p3p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqk1nr/pp1pppbp/2p3p1/8/3PPP2/2N5/PPP3PP/R1BQKBNR b KQkq - d7d5", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2BPP3/5N2/PPP2PPP/RNBQK2R b KQkq - c5d4", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/2P5/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - b8c6",
    "A36",
    "English Opening: Symmetrical Variation, Ultra-Symmetrical Variation",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2P5/6P1/PP1PPPBP/RNBQK1NR w KQkq - b1c3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - d4d5", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e3",
    "A40",
    "Pterodactyl Defense: Queen Pterodactyl, Quiet Line",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e4", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2PPP3/5N2/PP3PPP/RNBQKB1R b KQkq - d7d6", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/2PPP3/5N2/PP3PPP/RNBQKB1R b KQkq - d8a5",
    "A04",
    "Modern Defense: Semi-Averbakh Variation, Pterodactyl Variation",
  ],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/2PPP3/5N2/PP3PPP/RNBQKB1R b KQkq - d8b6",
    "A04",
    "Modern Defense: Semi-Averbakh Variation, Polish Variation",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - d4d5", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3P1B2/2P2N2/PP2PPPP/RN1QKB1R b KQkq - c5d4", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3P1B2/5N2/PPP1PPPP/RN1QKB1R w KQkq - c2c3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3P4/3BPN2/PPP2PPP/RNBQK2R b KQkq - c5d4", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3P4/3BPN2/PPP2PPP/RNBQK2R b KQkq - d8a5", "A40", "Colle System: Pterodactyl Variation"],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - d4c5", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3P4/5NP1/PPP1PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3P4/5NP1/PPP1PPBP/RNBQK2R b KQkq - d8a5",
    "A40",
    "Pterodactyl Defense: Fianchetto, Queen Pterodactyl",
  ],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - d8a5",
    "B27",
    "Modern Defense: Pterodactyl Variation",
  ],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1e3",
    "B06",
    "Pterodactyl Defense: Eastern, Anhanguera",
  ],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - d4c5",
    "B06",
    "Pterodactyl Defense: Eastern, Rhamphorhynchus",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - d4d5", "B06", "Pterodactyl Defense: Eastern, Benoni"],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/2P2N2/PP3PPP/RNBQKB1R b KQkq - d8a5",
    "B27",
    "Pterodactyl Defense: Western, Pterodactyl",
  ],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/4BN2/PPP2PPP/RN1QKB1R b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Western, Anhanguera",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c1e3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - d4c5", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/5NP1/PPP2P1P/RNBQKB1R b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Fianchetto, King Pterodactyl",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/6P1/PPP2P1P/RNBQKBNR w KQkq - d4c5", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PP3/6P1/PPP2P1P/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3PPP2/2P5/PP4PP/RNBQKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Austrian, Pteranodon",
  ],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/3PPP2/5N2/PPP3PP/RNBQKB1R b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Austrian, Austriadactylus Western",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PPP2/8/PPP3PP/RNBQKBNR w KQkq - c2c3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/3PPP2/8/PPP3PP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2P5/4P3/2N5/PPP2PPP/R1BQKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Eastern, Pterodactyl",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2P5/4P3/2N5/PPP2PPP/R1BQKBNR b KQkq - g7c3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2P5/4P3/5N2/PPP2PPP/RNBQKB1R b KQkq - d8a5",
    "B27",
    "Pterodactyl Defense: Western, Rhamphorhynchus",
  ],
  [
    "rnbqk1nr/pp1pppbp/6p1/2P5/4P3/6P1/PPP2P1P/RNBQKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Fianchetto, Rhamphorhynchus",
  ],
  [
    "rnbqk1nr/pp1pppbp/6p1/2p5/4PP2/2N2N2/PPPP2PP/R1BQKB1R b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Austrian, Grand Prix Pterodactyl",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2p5/4PP2/2N5/PPPP2PP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/2P5/8/4PN2/PPP2PPP/RNBQKB1R b KQkq - d8a5", "A04", "Colle System: Rhamphorhynchus Variation"],
  ["rnbqk1nr/pp1pppbp/6p1/2pP4/2P1P3/8/PP3PPP/RNBQKBNR b KQkq - d7d6", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2pP4/2P1P3/8/PP3PPP/RNBQKBNR b KQkq - d8a5",
    "A40",
    "Pterodactyl Defense: Central, Benoni Pterodactyl",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2pP4/2P5/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d6", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2pP4/2P5/2N5/PP2PPPP/R1BQKBNR b KQkq - d8a5",
    "A40",
    "Pterodactyl Defense: Fianchetto, Queen Benoni Pterodactyl",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2pP4/2P5/2N5/PP2PPPP/R1BQKBNR b KQkq - g7c3", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/2pP4/4P3/2N5/PPP2PPP/R1BQKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Eastern, Benoni Pterodactyl",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/2pP4/4P3/2N5/PPP2PPP/R1BQKBNR b KQkq - g7c3", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/8/2BNP3/8/PPP2PPP/RNBQK2R b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Western, Siroccopteryx",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/8/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - f3d4", null, null],
  ["rnbqk1nr/pp1pppbp/6p1/8/3N4/3BP3/PPP2PPP/RNBQK2R b KQkq - d8a5", "A40", "Colle System: Siroccopteryx Variation"],
  ["rnbqk1nr/pp1pppbp/6p1/8/3p1B2/2P2N2/PP2PPPP/RN1QKB1R w KQkq - c3d4", null, null],
  [
    "rnbqk1nr/pp1pppbp/6p1/8/3P1B2/5N2/PP2PPPP/RN1QKB1R b KQkq - d8a5",
    "D02",
    "Queen's Pawn Game: London System, Pterodactyl Variation",
  ],
  ["rnbqk1nr/pp1pppbp/6p1/8/3p4/3BPN2/PPP2PPP/RNBQK2R w KQkq - f3d4", null, null],
  ["rnbqk1nr/pp2pp1p/3p2p1/2pP4/2P1P3/2b5/PP3PPP/R1BQKBNR w KQkq - b2c3", null, null],
  [
    "rnbqk1nr/pp2pp1p/3p2p1/2pP4/2P1P3/2P5/P4PPP/R1BQKBNR b KQkq - d8a5",
    "A40",
    "Pterodactyl Defense: Central, Benoni Beefeater Pterodactyl",
  ],
  ["rnbqk1nr/pp2ppbp/2p3p1/3P4/2PP4/8/PP3PPP/RNBQKBNR w KQkq - d5c6", null, null],
  ["rnbqk1nr/pp2ppbp/2p3p1/3p4/3PPP2/2N5/PPP3PP/R1BQKBNR w KQkq - e4e5", null, null],
  ["rnbqk1nr/pp2ppbp/2p3p1/3p4/4P3/3P1N2/PPPN1PPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["rnbqk1nr/pp2ppbp/2p3p1/3p4/4P3/3P1NP1/PPPN1P1P/R1BQKB1R b KQkq - e7e5", null, null],
  ["rnbqk1nr/pp2ppbp/2p3p1/3pP3/3P1P2/2N5/PPP3PP/R1BQKBNR b KQkq - h7h5", "B06", "Modern Defense: Gurgenidze Defense"],
  ["rnbqk1nr/pp2ppbp/2P3p1/8/2PP4/8/PP3PPP/RNBQKBNR b KQkq - g7d4", "B06", "Modern Defense: Dunworthy Variation"],
  ["rnbqk1nr/pp2ppbp/2pp2p1/6B1/3PP3/2N2N2/PPP2PPP/R2QKB1R b KQkq - d8b6", null, null],
  ["rnbqk1nr/pp2ppbp/2pp2p1/8/2BPP3/2N5/PPP2PPP/R1BQK1NR w KQkq - d1e2", "B06", "Modern Defense: Anti-Modern"],
  ["rnbqk1nr/pp2ppbp/2pp2p1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - c1g5", null, null],
  [
    "rnbqk1nr/pp2ppbp/3p2p1/2P5/2P1P3/2N5/PP3PPP/R1BQKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Central, Quetzalcoatlus Gambit",
  ],
  [
    "rnbqk1nr/pp2ppbp/3p2p1/2P5/2P1P3/5N2/PP3PPP/RNBQKB1R b KQkq - d8a5",
    "A04",
    "Modern Defense: Semi-Averbakh Variation, Pterodactyl Variation Accepted",
  ],
  [
    "rnbqk1nr/pp2ppbp/3p2p1/2p5/2PPP3/2N1B3/PP3PPP/R2QKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Central, Anhanguera",
  ],
  [
    "rnbqk1nr/pp2ppbp/3p2p1/2p5/2PPP3/2N5/PP2NPPP/R1BQKB1R b KQkq - d8a5",
    "A42",
    "Pterodactyl Defense: Central, Bogolubovia",
  ],
  ["rnbqk1nr/pp2ppbp/3p2p1/2p5/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - c1e3", null, null],
  ["rnbqk1nr/pp2ppbp/3p2p1/2p5/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - d4c5", null, null],
  ["rnbqk1nr/pp2ppbp/3p2p1/2p5/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - g1e2", null, null],
  [
    "rnbqk1nr/pp2ppbp/3p2p1/2p5/2PPP3/5N2/PP2BPPP/RNBQK2R b KQkq - d8a5",
    "B06",
    "Modern Defense: Semi-Averbakh Variation, Pterodactyl Variation Declined",
  ],
  ["rnbqk1nr/pp2ppbp/3p2p1/2p5/2PPP3/5N2/PP3PPP/RNBQKB1R w KQkq - d4c5", null, null],
  ["rnbqk1nr/pp2ppbp/3p2p1/2p5/2PPP3/5N2/PP3PPP/RNBQKB1R w KQkq - f1e2", null, null],
  [
    "rnbqk1nr/pp2ppbp/3p2p1/2pP4/2P1P3/2N5/PP3PPP/R1BQKBNR b KQkq - d8a5",
    "B06",
    "Pterodactyl Defense: Central, Benoni Quetzalcoatlus",
  ],
  ["rnbqk1nr/pp2ppbp/3p2p1/2pP4/2P1P3/2N5/PP3PPP/R1BQKBNR b KQkq - g7c3", null, null],
  ["rnbqk1nr/pp2ppbp/3p2p1/2pP4/2P1P3/8/PP3PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqk1nr/pp2ppbp/3p2p1/2pP4/2P5/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqk1nr/pp3pb1/2pp3p/6p1/2BPPp1P/2N2N2/PPP3P1/R1BQK2R w KQkq - h4g5", null, null],
  ["rnbqk1nr/pp3pb1/2pp3p/6P1/2BPPp2/2N2N2/PPP3P1/R1BQK2R b KQkq - h6g5", null, null],
  ["rnbqk1nr/pp3pb1/2pp4/6p1/2BPPp2/2N2N2/PPP3P1/R1BQK2R w KQkq - h1h8", null, null],
  ["rnbqk1nR/pp3pb1/2pp4/6p1/2BPPp2/2N2N2/PPP3P1/R1BQK3 b Qq - g7h8", null, null],
  ["rnbqk1nr/pp3pbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1P1P/R1BQKB1R w KQkq - f1g2", null, null],
  ["rnbqk1nr/pp3pbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQK2R b KQkq - g8e7", null, null],
  [
    "rnbqk1nr/pp3pbp/3p2p1/2pP4/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - g8e7",
    "A40",
    "Benoni Defense: Franco-Sicilian Hybrid",
  ],
  ["rnbqk1nr/pp3pbp/3p2p1/2pP4/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqk1nr/pp3ppp/2p1p3/8/1bPPN3/8/PP1B1PPP/R2QKBNR b KQkq - d8d4", null, null],
  [
    "rnbqk1nr/pp3ppp/2p1p3/8/1bPPN3/8/PP3PPP/R1BQKBNR w KQkq - c1d2",
    "D31",
    "Semi-Slav Defense: Marshall Gambit, Main Line",
  ],
  [
    "rnbqk1nr/pp3ppp/2p1p3/8/1bPPN3/8/PP3PPP/R1BQKBNR w KQkq - e4c3",
    "D31",
    "Semi-Slav Defense: Marshall Gambit, Forgotten Variation",
  ],
  ["rnbqk1nr/pp3ppp/2p1p3/8/P1pP4/2b1PN2/1P3PPP/R1BQKB1R w KQkq - b2c3", null, null],
  ["rnbqk1nr/pp3ppp/2p1p3/8/P1pP4/2P1PN2/5PPP/R1BQKB1R b KQkq - b7b5", null, null],
  ["rnbqk1nr/pp3ppp/2p1p3/8/PbpP4/2N1PN2/1P3PPP/R1BQKB1R b KQkq - b4c3", null, null],
  ["rnbqk1nr/pp3ppp/2p1p3/8/PbpP4/2N1PN2/1P3PPP/R1BQKB1R b KQkq - b7b5", null, null],
  ["rnbqk1nr/pp3ppp/2p1p3/8/PbpP4/2N2N2/1P2PPPP/R1BQKB1R w KQkq - e2e3", null, null],
  [
    "rnbqk1nr/pp3ppp/2pb4/3p4/2PPp1P1/2N4P/PP2PPB1/R1BQK1NR b KQkq - g8e7",
    "A00",
    "Grob Opening: Keene Defense, Main Line",
  ],
  ["rnbqk1nr/pp3ppp/2pb4/3p4/2PPp1P1/7P/PP2PPB1/RNBQK1NR w KQkq - b1c3", null, null],
  ["rnbqk1nr/pp3ppp/4p3/2pP4/1b1P4/2NB4/PPP2PPP/R1BQK1NR b KQkq - d8d5", null, null],
  ["rnbqk1nr/pp3ppp/4p3/2pp4/1b1PP3/2NB4/PPP2PPP/R1BQK1NR w KQkq - e4d5", null, null],
  [
    "rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/2N5/PPP2PPP/R1BQKBNR w KQkq - a2a3",
    "C17",
    "French Defense: Winawer Variation, Advance Variation",
  ],
  [
    "rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/2N5/PPP2PPP/R1BQKBNR w KQkq - c1d2",
    "C17",
    "French Defense: Winawer Variation, Bogoljubow Variation",
  ],
  [
    "rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/2N5/PPP2PPP/R1BQKBNR w KQkq - d1g4",
    "C17",
    "French Defense: Winawer Variation, Advance Variation, Moscow Variation",
  ],
  ["rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/2N5/PPPB1PPP/R2QKBNR b KQkq - g8e7", null, null],
  [
    "rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/P1N5/1PP2PPP/R1BQKBNR b KQkq - b4a5",
    "C17",
    "French Defense: Winawer Variation, Retreat Variation",
  ],
  ["rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/P1N5/1PP2PPP/R1BQKBNR b KQkq - b4c3", null, null],
  ["rnbqk1nr/pp3ppp/4p3/2ppP3/1b1P4/P1N5/1PP2PPP/R1BQKBNR b KQkq - c5d4", null, null],
  [
    "rnbqk1nr/pp3ppp/4p3/2ppP3/3P4/P1b5/1PP2PPP/R1BQKBNR w KQkq - b2c3",
    "C18",
    "French Defense: Winawer Variation, Advance Variation",
  ],
  ["rnbqk1nr/pp3ppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR b KQkq - b8c6", null, null],
  [
    "rnbqk1nr/pp3ppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR b KQkq - d8a5",
    "C18",
    "French Defense: Winawer Variation, Portisch-Hook Variation",
  ],
  [
    "rnbqk1nr/pp3ppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR b KQkq - d8c7",
    "C18",
    "French Defense: Winawer Variation, Classical Variation",
  ],
  [
    "rnbqk1nr/pp3ppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR b KQkq - g8e7",
    "C18",
    "French Defense: Winawer Variation, Advance Variation",
  ],
  ["rnbqk1nr/pp3ppp/4p3/3pP3/1b1p4/P1N5/1PP2PPP/R1BQKBNR w KQkq - a3b4", null, null],
  [
    "rnbqk1nr/pp3ppp/4p3/3pP3/1P1p4/2N5/1PP2PPP/R1BQKBNR b KQkq - d4c3",
    "C17",
    "French Defense: Winawer Variation, Maróczy-Wallis Variation",
  ],
  [
    "rnbqk1nr/pp3ppp/4p3/3pP3/1P6/2p5/1PP2PPP/R1BQKBNR w KQkq - g1f3",
    "C17",
    "French Defense: Winawer Variation, Advance Variation",
  ],
  [
    "rnbqk1nr/pp3ppp/4p3/b1ppP3/1P1P4/P1N5/2P2PPP/R1BQKBNR b KQkq - c5d4",
    "C17",
    "French Defense: Winawer Variation, Retreat Variation, Armenian Line",
  ],
  ["rnbqk1nr/pp3ppp/4p3/b1ppP3/3P4/P1N5/1PP2PPP/R1BQKBNR w KQkq - b2b4", null, null],
  ["rnbqk1nr/pp3ppp/8/2ppp3/8/P2PP3/P1P2PPP/R1BQKBNR w KQkq - a1b1", "A00", "Sodium Attack: Celadon Variation"],
  ["rnbqk1nr/ppp1bppp/3p4/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R w KQkq - c2c3", "C41", "Philidor Defense: Steinitz Variation"],
  ["rnbqk1nr/ppp1bppp/4p3/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - g8f6", null, null],
  ["rnbqk1nr/ppp1bppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqk1nr/ppp1bppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqk1nr/ppp1bppp/4p3/3p4/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - d5e4", null, null],
  ["rnbqk1nr/ppp1bppp/4p3/3pP1B1/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - g5e3", null, null],
  [
    "rnbqk1nr/ppp1bppp/4p3/3pP3/3P4/2N1B3/PPP2PPP/R2QKBNR b KQkq - b7b6",
    "C13",
    "French Defense: Classical Variation, Frankfurt Variation",
  ],
  [
    "rnbqk1nr/ppp1bppp/4p3/8/2PPp3/2N5/PP3PPP/R1BQKBNR w KQkq - f2f3",
    "D31",
    "Queen's Gambit Declined: Charousek Variation, Miladinovic Gambit",
  ],
  ["rnbqk1nr/ppp1bppp/4p3/8/3PN3/P7/1PP1NPPP/R1BQKB1R b KQkq - g8f6", null, null],
  ["rnbqk1nr/ppp1bppp/4p3/8/3Pp3/P1N5/1PP1NPPP/R1BQKB1R w KQkq - c3e4", null, null],
  ["rnbqk1nr/ppp1bppp/8/3p4/4p2N/P5P1/1PPPPP1P/RNBQKB1R w KQkq - d2d3", "A00", "Hungarian Opening: Burk Gambit"],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", "A42", "Modern Defense: Averbakh System"],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e4", null, null],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - b8c6", "A42", "Modern Defense: Kotov Variation"],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - c7c5", null, null],
  [
    "rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - f7f5",
    "A42",
    "Modern Defense: Randspringer Variation",
  ],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/4B3/PP3PPP/RN1QKBNR b KQkq - g8f6", null, null],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/5N2/PP3PPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/5N2/PP3PPP/RNBQKB1R b KQkq - c8g4", "A41", "Robatsch Defense"],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - b1c3", "A42", "Modern Defense: Averbakh System"],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - c1e3", null, null],
  [
    "rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - c7c6",
    "B06",
    "Modern Defense: Two Knights Variation, Suttles Variation",
  ],
  [
    "rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f4",
    "B06",
    "Modern Defense: Pseudo-Austrian Attack",
  ],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", "B06", "Modern Defense: Two Knights Variation"],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c3", "B07", "Modern Defense: Geller's System"],
  ["rnbqk1nr/ppp1ppbp/3p2p1/8/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rnbqk1nr/ppp1ppbp/6p1/3P4/2PP4/8/PP3PPP/RNBQKBNR b KQkq - c7c6", null, null],
  ["rnbqk1nr/ppp1ppbp/6p1/3p4/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - e4d5", null, null],
  ["rnbqk1nr/ppp1ppbp/6p1/3p4/8/5NP1/PPPPPPBP/RNBQ1RK1 b kq - e7e5", null, null],
  ["rnbqk1nr/ppp1ppbp/6p1/3p4/8/5NP1/PPPPPPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqk1nr/ppp2pb1/3p3p/6p1/2BPPp1P/2N2N2/PPP3P1/R1BQK2R b KQkq - c7c6", null, null],
  ["rnbqk1nr/ppp2pb1/3p3p/6p1/2BPPp1P/5N2/PPP3P1/RNBQK2R w KQkq - b1c3", null, null],
  [
    "rnbqk1nr/ppp2pb1/3p3p/6p1/2BPPp1P/5N2/PPP3P1/RNBQK2R w KQkq - d1d3",
    "C38",
    "King's Gambit Accepted: Philidor Gambit, Schultz Variation",
  ],
  ["rnbqk1nr/ppp2pbp/3p4/6p1/2BPPp2/5N2/PPP3PP/RNBQK2R w KQkq - c2c3", "C38", "King's Gambit Accepted: Mayet Gambit"],
  ["rnbqk1nr/ppp2pbp/6p1/3pp3/8/3P1NP1/PPP1PPBP/RNBQ1RK1 b kq - g8e7", "A07", "King's Indian Attack: Pachman System"],
  ["rnbqk1nr/ppp2pbp/6p1/3pp3/8/5NP1/PPPPPPBP/RNBQ1RK1 w kq - d2d3", null, null],
  [
    "rnbqk1nr/ppp2ppp/3b4/8/8/5N2/PPPPP1PP/RNBQKB1R b KQkq - g7g5",
    "A02",
    "Bird Opening: From's Gambit, Lasker Variation",
  ],
  ["rnbqk1nr/ppp2ppp/3b4/8/8/5N2/PPPPP1PP/RNBQKB1R b KQkq - g8h6", null, null],
  ["rnbqk1nr/ppp2ppp/3b4/8/8/8/PPPPP1PP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqk1nr/ppp2ppp/3p4/2b1p3/4PP2/2N2N2/PPPP2PP/R1BQKB1R b KQkq - b8d7",
    "C30",
    "King's Gambit Declined: Classical, Hanham Variation",
  ],
  ["rnbqk1nr/ppp2ppp/3p4/2b1p3/4PP2/2P2N2/PP1P2PP/RNBQKB1R b KQkq - c8g4", null, null],
  [
    "rnbqk1nr/ppp2ppp/3p4/2b1p3/4PP2/2P2N2/PP1P2PP/RNBQKB1R b KQkq - f7f5",
    "C30",
    "King's Gambit Declined: Classical Variation, Rubinstein Countergambit",
  ],
  ["rnbqk1nr/ppp2ppp/3p4/2b1p3/4PP2/5N2/PPPP2PP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqk1nr/ppp2ppp/3p4/2b1p3/4PP2/5N2/PPPP2PP/RNBQKB1R w KQkq - b2b4",
    "C30",
    "King's Gambit Declined: Classical Variation, Rotlewi Countergambit",
  ],
  [
    "rnbqk1nr/ppp2ppp/3p4/2b1p3/4PP2/5N2/PPPP2PP/RNBQKB1R w KQkq - c2c3",
    "C30",
    "King's Gambit Declined: Classical Variation",
  ],
  [
    "rnbqk1nr/ppp2ppp/3p4/2b1p3/4PP2/5N2/PPPP2PP/RNBQKB1R w KQkq - f4e5",
    "C30",
    "King's Gambit Declined: Classical, Soldatenkov Variation",
  ],
  ["rnbqk1nr/ppp2ppp/4p3/3P4/1b1P4/2N5/PPP2PPP/R1BQKBNR b KQkq - e6d5", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP1NPPP/R1BQKB1R b KQkq - d5e4", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP1NPPP/R1BQKB1R b KQkq - g8f6", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - a2a3", null, null],
  [
    "rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1d2",
    "C15",
    "French Defense: Winawer Variation, Fingerslip Variation",
  ],
  [
    "rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - e4d5",
    "C15",
    "French Defense: Winawer Variation, Delayed Exchange Variation",
  ],
  [
    "rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - e4e5",
    "C16",
    "French Defense: Winawer Variation, Advance Variation",
  ],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f1d3", null, null],
  [
    "rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1e2",
    "C15",
    "French Defense: Winawer Variation, Alekhine-Maróczy Gambit",
  ],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPPB1PPP/R2QKBNR b KQkq - d5e4", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2N5/PPPB1PPP/R2QKBNR b KQkq - g8e7", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/2NB4/PPP2PPP/R1BQK1NR b KQkq - c7c5", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/1b1PP3/P1N5/1PP2PPP/R1BQKBNR b KQkq - b4c3", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/3PP3/P1b5/1PP2PPP/R1BQKBNR w KQkq - b2c3", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/3p4/3PP3/P1P5/2P2PPP/R1BQKBNR b KQkq - d5e4", null, null],
  [
    "rnbqk1nr/ppp2ppp/4p3/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR b KQkq - c7c5",
    "C17",
    "French Defense: Winawer Variation, Advance Variation",
  ],
  [
    "rnbqk1nr/ppp2ppp/4p3/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR b KQkq - d8d7",
    "C16",
    "French Defense: Winawer Variation, Petrosian Variation",
  ],
  ["rnbqk1nr/ppp2ppp/4p3/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR b KQkq - g8e7", null, null],
  [
    "rnbqk1nr/ppp2ppp/4p3/8/1b1Pp1Q1/2N5/PPPB1PPP/R3KBNR b KQkq - d8d4",
    "C15",
    "French Defense: Winawer Variation, Fingerslip Variation, Kunin Double Gambit",
  ],
  ["rnbqk1nr/ppp2ppp/4p3/8/1b1Pp1Q1/2N5/PPPB1PPP/R3KBNR b KQkq - g8f6", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/8/1b1Pp3/2N5/PPP1NPPP/R1BQKB1R w KQkq - a2a3", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/8/1b1Pp3/2N5/PPPB1PPP/R2QKBNR w KQkq - d1g4", null, null],
  [
    "rnbqk1nr/ppp2ppp/4p3/8/1b1Pp3/P1N5/1PP1NPPP/R1BQKB1R b KQkq - b4c3",
    "C15",
    "French Defense: Winawer Variation, Alekhine Gambit Accepted",
  ],
  ["rnbqk1nr/ppp2ppp/4p3/8/1b1Pp3/P1N5/1PP1NPPP/R1BQKB1R b KQkq - b4e7", null, null],
  ["rnbqk1nr/ppp2ppp/4p3/8/3Pp3/P1b5/1PP1NPPP/R1BQKB1R w KQkq - e2c3", null, null],
  [
    "rnbqk1nr/ppp2ppp/4p3/8/3Pp3/P1N5/1PP2PPP/R1BQKB1R b KQkq - b8c6",
    "C15",
    "French Defense: Winawer Variation, Alekhine Gambit, Kan Variation",
  ],
  [
    "rnbqk1nr/ppp2ppp/4p3/8/3Pp3/P1P5/2P2PPP/R1BQKBNR w KQkq - f2f3",
    "C15",
    "French Defense: Winawer Variation, Winckelmann-Reimer Gambit",
  ],
  ["rnbqk1nr/ppp2ppp/8/2bBp3/4P3/2P5/PP1P1PPP/RNBQK1NR b KQkq - g8f6", "C23", "Bishop's Opening: Lewis Countergambit"],
  ["rnbqk1nr/ppp2ppp/8/2bpp3/2B1P3/2P5/PP1P1PPP/RNBQK1NR w KQkq - c4d5", null, null],
  ["rnbqk1nr/ppp2ppp/8/3p4/1b1P4/2N5/PPP2PPP/R1BQKBNR w KQkq - f1d3", null, null],
  ["rnbqk1nr/ppp2ppp/8/3p4/1b1P4/2NB4/PPP2PPP/R1BQK1NR b KQkq - g8e7", null, null],
  ["rnbqk1nr/ppp2ppp/8/3pp3/8/P2P4/P1P1PPPP/R1BQKBNR w KQkq - e2e3", null, null],
  ["rnbqk1nr/ppp2ppp/8/3pp3/8/P2PP3/P1P2PPP/R1BQKBNR b KQkq - c7c5", null, null],
  [
    "rnbqk1nr/ppp2ppp/8/4P3/1bPp4/4P3/PP1B1PPP/RN1QKBNR b KQkq - d4e3",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit, Lasker Trap",
  ],
  ["rnbqk1nr/ppp2ppp/8/4P3/1bPp4/4P3/PP3PPP/RNBQKBNR w KQkq - c1d2", null, null],
  [
    "rnbqk1nr/ppp3pp/3b4/3p1P2/3P1p2/5N2/PPP3PP/RNBQKB1R w KQkq - f1d3",
    "C30",
    "King's Gambit Declined: Panteldakis Countergambit, Symmetrical Variation",
  ],
  ["rnbqk1nr/ppp3pp/3p4/2b1Pp2/4P3/2P2N2/PP1P2PP/RNBQKB1R b KQkq - d6e5", null, null],
  ["rnbqk1nr/ppp3pp/3p4/2b1pp2/4PP2/2P2N2/PP1P2PP/RNBQKB1R w KQkq - f4e5", null, null],
  [
    "rnbqk1nr/ppp3pp/4P3/2bp2N1/4p3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3",
    "C41",
    "Philidor Defense: Philidor Countergambit, Berger Variation",
  ],
  ["rnbqk1nr/ppp3pp/8/2b1pp2/3PP3/2P2N2/PP4PP/RNBQKB1R b KQkq - e5d4", null, null],
  ["rnbqk1nr/ppp3pp/8/2b1pp2/4P3/2P2N2/PP1P2PP/RNBQKB1R w KQkq - d2d4", null, null],
  [
    "rnbqk1nr/ppp3pp/8/2b2p2/3pP3/2P2N2/PP4PP/RNBQKB1R w KQkq - f1c4",
    "C30",
    "King's Gambit Declined: Classical, Réti Variation",
  ],
  ["rnbqk1nr/pppp1pb1/7p/6p1/2B1Pp1P/5N2/PPPP2P1/RNBQK2R w KQkq - d2d4", null, null],
  ["rnbqk1nr/pppp1pb1/7p/6p1/2BPPp1P/5N2/PPP3P1/RNBQK2R b KQkq - d7d6", "C34", "King's Gambit Accepted: Greco Gambit"],
  ["rnbqk1nr/pppp1pbp/4p1p1/8/2B1P3/5Q2/PPPP1PPP/RNB1K1NR w KQkq - d2d4", null, null],
  [
    "rnbqk1nr/pppp1pbp/4p1p1/8/2BPP3/5Q2/PPP2PPP/RNB1K1NR b KQkq - g7d4",
    "B06",
    "Modern Defense: Bishop Attack, Monkey's Bum",
  ],
  ["rnbqk1nr/pppp1pbp/8/6p1/2B1Pp1P/5N2/PPPP2P1/RNBQK2R b KQkq - h7h6", null, null],
  ["rnbqk1nr/pppp1pbp/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R w KQkq - d2d4", null, null],
  [
    "rnbqk1nr/pppp1pbp/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R w KQkq - e1g1",
    "C38",
    "King's Gambit Accepted: Hanstein Gambit",
  ],
  [
    "rnbqk1nr/pppp1pbp/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R w KQkq - h2h4",
    "C38",
    "King's Gambit Accepted: Philidor Gambit",
  ],
  ["rnbqk1nr/pppp1pbp/8/6p1/2BPPp2/5N2/PPP3PP/RNBQK2R b KQkq - d7d6", null, null],
  [
    "rnbqk1nr/pppp1ppp/4p3/8/1b2P3/8/P1PP1PPP/RNBQKBNR w KQkq - e4e5",
    "C00",
    "French Defense: Banzai-Leong Gambit, Pinova Gambit",
  ],
  [
    "rnbqk1nr/pppp1ppp/4p3/8/1bPP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3",
    "A40",
    "Kangaroo Defense: Keres Defense, Transpositional Variation",
  ],
  ["rnbqk1nr/pppp1ppp/8/1Bb1p3/4P3/8/PPPP1PPP/RNBQK1NR w KQkq - b2b4", "C20", "Portuguese Opening: Miguel Gambit"],
  [
    "rnbqk1nr/pppp1ppp/8/2b1N3/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - b8c6",
    "C40",
    "King's Pawn Game: Busch-Gass Gambit, Chiodini Gambit",
  ],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/1PB1P3/8/P1PP1PPP/RNBQK1NR b KQkq - c5b4", null, null],
  [
    "rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/2P5/PP1P1PPP/RNBQK1NR b KQkq - d7d5",
    "C23",
    "Bishop's Opening: Lewis Countergambit",
  ],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/2P5/PP1P1PPP/RNBQK1NR b KQkq - d8g5", "C23", "Bishop's Opening: del Rio Variation"],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/2P5/PP1P1PPP/RNBQK1NR b KQkq - g8f6", null, null],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - b2b4", "C23", "Bishop's Opening: McDonnell Gambit"],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - c2c3", "C23", "Bishop's Opening: Philidor Variation"],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - d1e2", "C23", "Bishop's Opening: Lopez Variation"],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - d2d4", "C23", "Bishop's Opening: Lewis Gambit"],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - f2f4", "C23", "Bishop's Opening: Stein Gambit"],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPPQPPP/RNB1K1NR b KQkq - b8c6", null, null],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/2B1P3/8/PPPPQPPP/RNB1K1NR b KQkq - g8f6", null, null],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - c3a4", "C25", "Vienna Game: Hamppe-Meitner Variation"],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d1g4", "C25", "Vienna Game: Giraffe Attack"],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f3e5", null, null],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/4PP2/5N2/PPPP2PP/RNBQKB1R b KQkq - d7d6", null, null],
  [
    "rnbqk1nr/pppp1ppp/8/2b1p3/4PP2/5N2/PPPP2PP/RNBQKB1R b KQkq - g7g5",
    "C30",
    "King's Gambit Declined: Senechaud Countergambit",
  ],
  [
    "rnbqk1nr/pppp1ppp/8/2b1p3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - d1h5",
    "C30",
    "King's Gambit Declined: Classical Variation, Walthoffen Attack",
  ],
  ["rnbqk1nr/pppp1ppp/8/2b1p3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqk1nr/pppp1ppp/8/2b5/3pP3/2P2N2/PP3PPP/RNBQKB1R b KQkq - d4c3", null, null],
  ["rnbqk1nr/pppp1ppp/8/2b5/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c3", "C21", "Center Game: Lanc-Arnold Gambit"],
  ["rnbqk1nr/pppp1ppp/8/2b5/3pPP2/5N2/PPP3PP/RNBQKB1R b KQkq - b8c6", null, null],
  ["rnbqk1nr/pppp1ppp/8/2b5/3pPP2/8/PPP3PP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqk1nr/pppp1ppp/8/2b5/4P3/2p2N2/PP3PPP/RNBQKB1R w KQkq - f1c4",
    "C21",
    "Center Game: Lanc-Arnold Gambit, Schippler Gambit",
  ],
  [
    "rnbqk1nr/pppp1ppp/8/2bPp3/4P3/8/PPP2PPP/RNBQKBNR b KQkq - d8h4",
    "A40",
    "Englund Gambit Declined: Diemer Counterattack",
  ],
  ["rnbqk1nr/pppp1ppp/8/2bPp3/8/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", null, null],
  [
    "rnbqk1nr/pppp1ppp/8/4p3/1b2P1Q1/2N5/PPPP1PPP/R1B1KBNR b KQkq - g8f6",
    "C25",
    "Vienna Game: Zhuravlev Countergambit",
  ],
  ["rnbqk1nr/pppp1ppp/8/4p3/1b2P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d1g4", null, null],
  [
    "rnbqk1nr/pppp1ppp/8/4p3/1bB1P3/8/P1PP1PPP/RNBQK1NR w KQkq - c2c3",
    "C23",
    "Bishop's Opening: McDonnell Gambit, La Bourdonnais-Denker Gambit",
  ],
  [
    "rnbqk1nr/pppp1ppp/8/4p3/1bB1P3/8/P1PP1PPP/RNBQK1NR w KQkq - f2f4",
    "C23",
    "Bishop's Opening: McDonnell Gambit, McDonnell Double Gambit",
  ],
  ["rnbqk1nr/pppp1ppp/8/4p3/1bB1PP2/8/P1PP2PP/RNBQK1NR b KQkq - e5f4", null, null],
  ["rnbqk1nr/pppp1ppp/8/4p3/8/b2P4/PPP1PPPP/R1BQKBNR w KQkq - b2a3", null, null],
  ["rnbqk1nr/pppp1ppp/8/4p3/8/P2P4/P1P1PPPP/R1BQKBNR b KQkq - d7d5", null, null],
  ["rnbqk1nr/pppp1ppp/8/8/1bB1Pp2/5N2/P1PP2PP/RNBQK2R b KQkq - b4e7", null, null],
  ["rnbqk1nr/pppp1ppp/8/8/1bB1Pp2/8/P1PP2PP/RNBQK1NR w KQkq - g1f3", null, null],
  [
    "rnbqk1nr/pppp1ppp/8/8/2B1P2b/5N2/PPPP3p/RNBQ1RK1 w kq - g1h1",
    "C35",
    "King's Gambit Accepted: Cunningham Defense, Bertin Gambit",
  ],
  ["rnbqk1nr/pppp1ppp/8/8/2B1P2b/5Np1/PPPP3P/RNBQ1RK1 b kq - g3h2", null, null],
  ["rnbqk1nr/pppp1ppp/8/8/2B1P2b/5Np1/PPPP3P/RNBQK2R w KQkq - e1g1", null, null],
  [
    "rnbqk1nr/pppp1ppp/8/8/2B1Pp1b/5N2/PPPP2PP/RNBQK2R w KQkq - g2g3",
    "C35",
    "King's Gambit Accepted: Cunningham Defense, Bertin Gambit",
  ],
  ["rnbqk1nr/pppp1ppp/8/8/2B1Pp1b/5NP1/PPPP3P/RNBQK2R b KQkq - f4g3", null, null],
  ["rnbqk1nr/pppp1ppp/8/8/2BPP2b/5N2/P1P4p/RNBQ1RK1 w kq - g1h1", "C23", "Bishop's Opening: Four Pawns Gambit"],
  ["rnbqk1nr/pppp1ppp/8/8/2BPP2b/5Np1/P1P4P/RNBQ1RK1 b kq - g3h2", null, null],
  ["rnbqk1nr/pppp1ppp/8/8/2BPP2b/5Np1/P1P4P/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqk1nr/pppp1ppp/8/8/2BPPp1b/5N2/P1P3PP/RNBQK2R w KQkq - g2g3", null, null],
  ["rnbqk1nr/pppp1ppp/8/8/2BPPp1b/5NP1/P1P4P/RNBQK2R b KQkq - f4g3", null, null],
  ["rnbqk1nr/ppppbppp/8/8/2B1Pp2/5N2/P1PP2PP/RNBQK2R w KQkq - d2d4", null, null],
  ["rnbqk1nr/ppppbppp/8/8/2B1Pp2/5N2/PPPP2PP/RNBQK2R b KQkq - e7h4", null, null],
  [
    "rnbqk1nr/ppppbppp/8/8/2B1Pp2/5N2/PPPP2PP/RNBQK2R b KQkq - g8f6",
    "C35",
    "King's Gambit Accepted: Cunningham Defense, McCormick Defense",
  ],
  ["rnbqk1nr/ppppbppp/8/8/2BPPp2/5N2/P1P3PP/RNBQK2R b KQkq - e7h4", null, null],
  ["rnbqk1nr/ppppbppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - f1c4", null, null],
  [
    "rnbqk1nr/ppppp1bp/6p1/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR w KQkq - g1h3",
    "A81",
    "Dutch Defense: Leningrad Variation, Carlsbad Variation",
  ],
  ["rnbqk1nr/ppppppbp/6p1/8/2B1P3/5Q2/PPPP1PPP/RNB1K1NR b KQkq - e7e6", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - d1f3", null, null],
  [
    "rnbqk1nr/ppppppbp/6p1/8/2BPP3/8/PPP2PPP/RNBQK1NR b KQkq - b7b5",
    "B06",
    "Modern Defense: Bishop Attack, Bücker Gambit",
  ],
  ["rnbqk1nr/ppppppbp/6p1/8/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g2g3", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - c7c5", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d6", "A41", "Modern Defense"],
  ["rnbqk1nr/ppppppbp/6p1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - e7e5", "A41", "Modern Defense: Neo-Modern Defense"],
  ["rnbqk1nr/ppppppbp/6p1/8/3P1B2/5N2/PPP1PPPP/RN1QKB1R b KQkq - c7c5", null, null],
  [
    "rnbqk1nr/ppppppbp/6p1/8/3P4/2N2N2/PPP1PPPP/R1BQKB1R b KQkq - d7d5",
    "D00",
    "Queen's Pawn Game: Chigorin Variation, Fianchetto Defense",
  ],
  ["rnbqk1nr/ppppppbp/6p1/8/3P4/2N5/PPP1PPPP/R1BQKBNR w KQkq - e2e4", "B06", "Modern Defense: Standard Line"],
  ["rnbqk1nr/ppppppbp/6p1/8/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1f4", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - e2e4", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3P4/5NP1/PPP1PP1P/RNBQKB1R b KQkq - c7c5", null, null],
  [
    "rnbqk1nr/ppppppbp/6p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - b7b6",
    "B06",
    "Modern Defense: Mongredien Defense, with Nc3",
  ],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - c7c5", "B06", "Modern Defense: Modern Pterodactyl"],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - c7c6", null, null],
  [
    "rnbqk1nr/ppppppbp/6p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - d7d5",
    "B06",
    "Modern Defense: Lizard Defense, Mittenberger Gambit",
  ],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - d7d6", "B06", "Modern Defense: Standard Defense"],
  [
    "rnbqk1nr/ppppppbp/6p1/8/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - b7b6",
    "B06",
    "Modern Defense: Mongredien Defense, with Nf3",
  ],
  [
    "rnbqk1nr/ppppppbp/6p1/8/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c7c5",
    "B27",
    "Sicilian Defense: Hyperaccelerated Pterodactyl",
  ],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - d7d6", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/6P1/PPP2P1P/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", "B06", "Modern Defense: Standard Line"],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c1d2", "B06", "Modern Defense: Westermann Gambit"],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f1c4", "B06", "Modern Defense: Bishop Attack"],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f1d3", "B06", "Modern Defense: Wind Gambit"],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f2f4", "B06", "Modern Defense: Three Pawns Attack"],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g2g3", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/3PPP2/8/PPP3PP/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f2f4", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqk1nr/ppppppbp/6p1/8/4PP2/2N5/PPPP2PP/R1BQKBNR b KQkq - c7c5", null, null],
  [
    "rnbqk1r1/pp2np1Q/4p3/3pP3/3p4/P1P5/2P2PPP/R1B1KBNR b KQq - b8c6",
    "C18",
    "French Defense: Winawer Variation, Poisoned Pawn Variation",
  ],
  ["rnbqk1r1/pp2npQp/4p3/3pP3/3p4/P1P5/2P2PPP/R1B1KBNR w KQq - g7h7", null, null],
  ["rnbqk1r1/ppp2pP1/4p3/3p2p1/1b1P3P/2N5/PPP2PP1/R2QKBNR b KQq - g5h4", null, null],
  ["rnbqk1r1/ppp2pP1/4p3/3p2p1/1b1P4/2N5/PPP2PPP/R2QKBNR w KQq - h2h4", null, null],
  [
    "rnbqk1r1/ppp2pP1/4p3/3p4/1b1P3p/2N5/PPP2PP1/R2QKBNR w KQq - d1g4",
    "C12",
    "French Defense: McCutcheon Variation, Grigoriev Variation",
  ],
  [
    "rnbqk1r1/ppp2pQp/4pn2/8/1b1Pp3/2N5/PPPB1PPP/R3KBNR w KQq - g7h6",
    "C15",
    "French Defense: Winawer Variation, Fingerslip Variation, Main Line",
  ],
  ["rnbqk2r/1p1p1ppp/p3pn2/8/1bPNP3/2N5/PP3PPP/R1BQKB1R w KQkq - f1d3", null, null],
  [
    "rnbqk2r/1p1p1ppp/p3pn2/8/1bPNP3/2NB4/PP3PPP/R1BQK2R b KQkq - b8c6",
    "B41",
    "Sicilian Defense: Kan Variation, Maróczy Bind, Bronstein Variation",
  ],
  ["rnbqk2r/1p2bpp1/p2ppn1p/6B1/3NPP2/2N2Q2/PPP3PP/R3KB1R w KQkq - g5h4", null, null],
  [
    "rnbqk2r/1p2bpp1/p2ppn1p/8/3NPP1B/2N2Q2/PPP3PP/R3KB1R b KQkq - d8c7",
    "B98",
    "Sicilian Defense: Najdorf Variation, Browne Variation",
  ],
  [
    "rnbqk2r/1p2bpp1/p2ppn1p/8/3NPP1B/2N2Q2/PPP3PP/R3KB1R b KQkq - g7g5",
    "B98",
    "Sicilian Defense: Najdorf Variation, Goteborg Variation",
  ],
  [
    "rnbqk2r/1p2bppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQ1RK1 b kq - c8e6",
    "B92",
    "Sicilian Defense: Najdorf Variation, Opocensky Variation, Modern Line",
  ],
  [
    "rnbqk2r/1p2bppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQ1RK1 b kq - e8g8",
    "B92",
    "Sicilian Defense: Najdorf Variation, Opocensky Variation, Traditional Line",
  ],
  ["rnbqk2r/1p2bppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "rnbqk2r/1p2bppp/p2ppn2/6B1/3NPP2/2N2Q2/PPP3PP/R3KB1R b KQkq - d8c7",
    "B98",
    "Sicilian Defense: Najdorf Variation, Traditional Line",
  ],
  ["rnbqk2r/1p2bppp/p2ppn2/6B1/3NPP2/2N2Q2/PPP3PP/R3KB1R b KQkq - h7h6", null, null],
  ["rnbqk2r/1p2bppp/p2ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R w KQkq - d1f3", null, null],
  ["rnbqk2r/1p3ppp/p3pn2/2b5/2B5/4PN2/PP2QPPP/RNB1K2R w KQkq - e1g1", null, null],
  ["rnbqk2r/1p3ppp/p3pn2/2b5/2B5/4PN2/PP2QPPP/RNB2RK1 b kq - b8c6", null, null],
  ["rnbqk2r/1ppp1ppp/4pn2/p7/1bPP4/5N2/PP1BPPPP/RN1QKB1R w KQkq - g2g3", null, null],
  ["rnbqk2r/1ppp1ppp/4pn2/p7/1bPP4/5NP1/PP1BPP1P/RN1QKB1R b KQkq - b7b6", null, null],
  ["rnbqk2r/2pp1ppp/1p2pn2/p7/1bPP4/5NP1/PP1BPP1P/RN1QKB1R w KQkq - f1g2", null, null],
  [
    "rnbqk2r/2pp1ppp/1p2pn2/p7/1bPP4/5NP1/PP1BPPBP/RN1QK2R b KQkq - c8b7",
    "E16",
    "Queen's Indian Defense: Yates Variation",
  ],
  ["rnbqk2r/p1p1bppp/1p3n2/3p2B1/3P4/2N1PN2/PP3PPP/R2QKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/p1p1bppp/1p3n2/3p2B1/3P4/2N2N2/PP2PPPP/R2QKB1R w KQkq - e2e3", null, null],
  ["rnbqk2r/p1p2ppp/1p1bpn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - c4d5", null, null],
  ["rnbqk2r/p1p2ppp/1p1bpn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f1d3", "E14", "Queen's Indian Defense, with e3"],
  ["rnbqk2r/p1p2ppp/1p1bpn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/p1p2ppp/1p1bpn2/3P4/3P4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - e6d5",
    "D35",
    "Queen's Gambit Declined: Exchange Variation",
  ],
  ["rnbqk2r/p1pp1pp1/1p2pn1p/6B1/1bPP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - g5h4", null, null],
  [
    "rnbqk2r/p1pp1pp1/1p2pn1p/8/1bPP3B/2N2N2/PP2PPPP/R2QKB1R b KQkq - c8b7",
    "E13",
    "Queen's Indian Defense: Kasparov Variation",
  ],
  [
    "rnbqk2r/p1pp1ppp/1p2p3/8/1bPPn3/2N1PN2/PP3PPP/R1BQKB1R w KQkq - d1c2",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  ["rnbqk2r/p1pp1ppp/1p2p3/8/1bPPn3/2N1PN2/PPQ2PPP/R1B1KB1R b KQkq - c8b7", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/6B1/1bPP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - h7h6", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N1P3/PP2NPPP/R1BQKB1R b KQkq - c7c5", null, null],
  [
    "rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N1P3/PP2NPPP/R1BQKB1R b KQkq - c8a6",
    "E45",
    "Nimzo-Indian Defense: St. Petersburg Variation, Fischer Variation",
  ],
  [
    "rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N1P3/PP2NPPP/R1BQKB1R b KQkq - f6e4",
    "E44",
    "Nimzo-Indian Defense: St. Petersburg Variation, American Variation",
  ],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - f1d3", null, null],
  [
    "rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - g1e2",
    "E44",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - f6e4", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/2NBP3/PP3PPP/R1BQK1NR b KQkq - c8b7", null, null],
  [
    "rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/4PN2/PP1N1PPP/R1BQKB1R b KQkq - c8b7",
    "E14",
    "Queen's Indian Defense, with e3, Bb4+ Line",
  ],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/5N2/PP1NPPPP/R1BQKB1R w KQkq - a2a3", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/5N2/PP1NPPPP/R1BQKB1R w KQkq - e2e3", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/1bPP4/P4N2/1P1NPPPP/R1BQKB1R b KQkq - b4d2", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/2PP4/2P1PN2/P4PPP/R1BQKB1R b KQkq - c8b7", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/2PP4/2P2N2/P3PPPP/R1BQKB1R w KQkq - e2e3", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/2PP4/P4N2/1P1bPPPP/R1BQKB1R w KQkq - d1d2", null, null],
  ["rnbqk2r/p1pp1ppp/1p2pn2/8/2PP4/P4N2/1P1QPPPP/R1B1KB1R b KQkq - c8b7", null, null],
  ["rnbqk2r/p1pp2pp/1p2p3/5p2/1bPPn3/2N1PN2/PPQ2PPP/R1B1KB1R w KQkq - f1d3", null, null],
  [
    "rnbqk2r/p1pp2pp/1p2p3/5p2/1bPPn3/2NBPN2/PPQ2PPP/R1B1K2R b KQkq - c8b7",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  ["rnbqk2r/p2p1ppp/1p2pn2/2p5/1bPP4/2N1P3/PP2NPPP/R1BQKB1R w KQkq - a2a3", null, null],
  [
    "rnbqk2r/p2p1ppp/1p2pn2/2p5/1bPP4/P1N1P3/1P2NPPP/R1BQKB1R b KQkq - b4a5",
    "E44",
    "Nimzo-Indian Defense: St. Petersburg Variation, Romanishin–Psakhis Variation",
  ],
  ["rnbqk2r/p4ppp/2pbpn2/1p6/2BP4/2N1PN2/PP3PPP/R1BQK2R w KQkq - c4d3", null, null],
  ["rnbqk2r/p4ppp/2pbpn2/1p6/3P4/2NBPN2/PP3PPP/R1BQK2R b KQkq - b8d7", null, null],
  [
    "rnbqk2r/pp1n1ppp/4p3/2bpP3/5P2/2N5/PPP3PP/R1BQKBNR w KQkq - d1g4",
    "C11",
    "French Defense: Steinitz Variation, Bradford Attack Variation",
  ],
  ["rnbqk2r/pp1p1pp1/4pn1p/2p5/1bPP3B/2N5/PP2PPPP/R2QKBNR w KQkq - d4d5", null, null],
  [
    "rnbqk2r/pp1p1pp1/4pn1p/2pP4/1bP4B/2N5/PP2PPPP/R2QKBNR b KQkq - b7b5",
    "E30",
    "Nimzo-Indian Defense: Leningrad Variation, Averbakh Gambit",
  ],
  [
    "rnbqk2r/pp1p1pp1/4pn1p/2pP4/1bP4B/2N5/PP2PPPP/R2QKBNR b KQkq - d7d6",
    "E31",
    "Nimzo-Indian Defense: Leningrad Variation, Benoni Defense",
  ],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2P5/1bP5/1QN5/PP2PPPP/R1B1KBNR b KQkq - b8c6",
    "E23",
    "Nimzo-Indian Defense: Spielmann Variation, Romanovsky Gambit",
  ],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2P5/1bP5/2N5/PPQ1PPPP/R1B1KBNR b KQkq - b4c3",
    "E38",
    "Nimzo-Indian Defense: Classical Variation, Berlin Variation, Steiner Variation",
  ],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2P5/1bP5/2N5/PPQ1PPPP/R1B1KBNR b KQkq - e8g8",
    "E39",
    "Nimzo-Indian Defense: Classical Variation, Berlin Variation, Pirc Variation",
  ],
  ["rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/1QN5/PP2PPPP/R1B1KBNR w KQkq - d4c5", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N1P3/PP2NPPP/R1BQKB1R b KQkq - c5d4", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - f1d3", null, null],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - g1e2",
    "E42",
    "Nimzo-Indian Defense: Rubinstein System, Rubinstein Variation",
  ],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - d4d5",
    "E21",
    "Nimzo-Indian Defense: Three Knights Variation, Korchnoi Variation",
  ],
  ["rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - c5d4", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2N5/PPQ1PPPP/R1B1KBNR w KQkq - d4c5", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/2p5/1bPP4/2NBP3/PP3PPP/R1BQK1NR b KQkq - b8c6", null, null],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2p5/2PP4/P1P1P3/5PPP/R1BQKBNR b KQkq - b7b6",
    "E26",
    "Nimzo-Indian Defense: Sämisch Variation, O'Kelly Variation",
  ],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2p5/2PP4/P1P5/4PPPP/R1BQKBNR w KQkq - e2e3",
    "E26",
    "Nimzo-Indian Defense: Sämisch Variation",
  ],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2pP4/1bP5/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b7b5",
    "E21",
    "Nimzo-Indian Defense: Three Knights Variation, Shocron Gambit",
  ],
  [
    "rnbqk2r/pp1p1ppp/4pn2/2pP4/1bP5/2N2N2/PP2PPPP/R1BQKB1R b KQkq - f6e4",
    "E21",
    "Nimzo-Indian Defense: Three Knights Variation, Euwe Variation",
  ],
  [
    "rnbqk2r/pp1p1ppp/4pn2/8/1b1NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - e4e5",
    "B40",
    "Sicilian Defense: Pin Variation, Koch Variation",
  ],
  ["rnbqk2r/pp1p1ppp/4pn2/8/1b1NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1d3", null, null],
  [
    "rnbqk2r/pp1p1ppp/4pn2/8/1b1NP3/2NB4/PPP2PPP/R1BQK2R b KQkq - e6e5",
    "B40",
    "Sicilian Defense: Pin Variation, Jaffe Variation",
  ],
  ["rnbqk2r/pp1p1ppp/4pn2/8/1bPN4/2N3P1/PP2PP1P/R1BQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/8/1bPp4/2N1P3/PP2NPPP/R1BQKB1R w KQkq - e3d4", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/8/1bPp4/2N2NP1/PP2PP1P/R1BQKB1R w KQkq - f3d4", null, null],
  ["rnbqk2r/pp1p1ppp/4pn2/8/1bPP4/2N5/PP2NPPP/R1BQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/pp1pppbp/5np1/2p5/2PP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqk2r/pp1pppbp/5np1/2p5/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/pp1pppbp/5np1/2p5/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  [
    "rnbqk2r/pp1pppbp/5np1/2p5/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - d8a5",
    "E64",
    "King's Indian Defense: Fianchetto Variation, Pterodactyl Variation",
  ],
  ["rnbqk2r/pp2bppp/2p1pn2/3p2B1/2PP4/2N1PN2/PP3PPP/R2QKB1R b KQkq - b8d7", null, null],
  ["rnbqk2r/pp2bppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - e2e3", null, null],
  ["rnbqk2r/pp2bppp/2p1pn2/3p4/2P5/1P3NP1/P2PPPBP/RNBQK2R w KQkq - c1b2", "A14", "Réti Opening: Anglo-Slav Variation"],
  ["rnbqk2r/pp2bppp/2p1pn2/3p4/2PP4/5N2/PPQNPPPP/R1B1KB1R w KQkq - g2g3", null, null],
  ["rnbqk2r/pp2bppp/2p1pn2/3p4/2PP4/5NP1/PPQNPP1P/R1B1KB1R b KQkq - b8d7", null, null],
  ["rnbqk2r/pp2bppp/2p2n2/3p2B1/3P4/2N1P3/PPQ2PPP/R3KBNR b KQkq - b8d7", null, null],
  ["rnbqk2r/pp2bppp/2p2n2/3p2B1/3P4/2N1P3/PPQ2PPP/R3KBNR b KQkq - e8g8", null, null],
  ["rnbqk2r/pp2bppp/2p2n2/3p2B1/3P4/2N5/PPQ1PPPP/R3KBNR w KQkq - e2e3", null, null],
  ["rnbqk2r/pp2bppp/3ppn2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/pp2bppp/3ppn2/8/3NP3/2N5/PPP1BPPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "rnbqk2r/pp2bppp/4p3/2pn4/8/2N2NP1/PP1PPPBP/R1BQ1RK1 b kq - b8c6",
    "A14",
    "English Opening: Agincourt Defense, Keres Defense",
  ],
  ["rnbqk2r/pp2bppp/4p3/2pn4/8/5NP1/PP1PPPBP/RNBQ1RK1 w kq - b1c3", null, null],
  ["rnbqk2r/pp2bppp/4pn2/2pp4/2P5/5NP1/PP1PPPBP/RNBQ1RK1 w kq - c4d5", null, null],
  ["rnbqk2r/pp2bppp/4pn2/2pP4/8/5NP1/PP1PPPBP/RNBQ1RK1 b kq - f6d5", null, null],
  ["rnbqk2r/pp2npbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/pp2npbp/2p3p1/3pp3/4P3/3P1NP1/PPPN1PBP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/1b1P4/2N5/PPPB1PPP/R2QKBNR w KQkq - f2f4",
    "C17",
    "French Defense: Winawer Variation, Bogoljubow Variation, Icelandic Defense",
  ],
  ["rnbqk2r/pp2nppp/4p3/2ppP3/3P2Q1/P1P5/2P2PPP/R1B1KBNR b KQkq - c5d4", null, null],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P2Q1/P1P5/2P2PPP/R1B1KBNR b KQkq - d8c7",
    "C18",
    "French Defense: Winawer Variation, Poisoned Pawn Variation",
  ],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P2Q1/P1P5/2P2PPP/R1B1KBNR b KQkq - e8f8",
    "C18",
    "French Defense: Winawer Variation, Eingorn Variation",
  ],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P2Q1/P1P5/2P2PPP/R1B1KBNR b KQkq - e8g8",
    "C18",
    "French Defense: Winawer Variation, Warsaw Variation",
  ],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P3P/P1P5/2P2PP1/R1BQKBNR b KQkq - d8c7",
    "C18",
    "French Defense: Winawer Variation, Advance Variation, with h4",
  ],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P2N2/2P2PPP/R1BQKB1R b KQkq - d8c7",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR w KQkq - a3a4",
    "C19",
    "French Defense: Winawer Variation, Advance Variation, Smyslov Variation",
  ],
  ["rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR w KQkq - d1g4", null, null],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR w KQkq - f1d3",
    "C18",
    "French Defense: Winawer Variation, Advance Variation, with Bd3",
  ],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR w KQkq - g1f3",
    "C19",
    "French Defense: Winawer Variation, Positional Variation",
  ],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1P5/2P2PPP/R1BQKBNR w KQkq - h2h4",
    "C18",
    "French Defense: Winawer Variation, Advance Variation, with h4",
  ],
  ["rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1PB4/2P2PPP/R1BQK1NR b KQkq - b8c6", null, null],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/3P4/P1PB4/2P2PPP/R1BQK1NR b KQkq - d8c7",
    "C18",
    "French Defense: Winawer Variation, Advance Variation, with Bd3",
  ],
  ["rnbqk2r/pp2nppp/4p3/2ppP3/P2P4/2P5/2P2PPP/R1BQKBNR b KQkq - b8c6", null, null],
  [
    "rnbqk2r/pp2nppp/4p3/2ppP3/P2P4/2P5/2P2PPP/R1BQKBNR b KQkq - d8c7",
    "C19",
    "French Defense: Winawer Variation, Advance Variation, Smyslov Variation",
  ],
  [
    "rnbqk2r/pp2nppp/4p3/3pP3/3p2Q1/P1P5/2P2PPP/R1B1KBNR w KQkq - g4g7",
    "C18",
    "French Defense: Winawer Variation, Poisoned Pawn Variation",
  ],
  ["rnbqk2r/pp2npQp/4p3/3pP3/3p4/P1P5/2P2PPP/R1B1KBNR b KQkq - h8g8", null, null],
  ["rnbqk2r/pp2ppbp/1n1p2p1/8/2PP4/2N1B3/PP3PPP/2RQKBNR b Kkq - e8g8", null, null],
  ["rnbqk2r/pp2ppbp/1n1p2p1/8/2PP4/2N1B3/PP3PPP/R2QKBNR w KQkq - a1c1", null, null],
  ["rnbqk2r/pp2ppbp/1n1p2p1/8/2PP4/2N2N1P/PP3PP1/R1BQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/pp2ppbp/1n1p2p1/8/2PP4/2N4P/PP3PP1/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqk2r/pp2ppbp/2p2np1/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f1d3", null, null],
  ["rnbqk2r/pp2ppbp/2p2np1/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - e8g8", null, null],
  ["rnbqk2r/pp2ppbp/3p1np1/2p5/3P1B2/4PN1P/PPP2PP1/RN1QKB1R w KQkq - f1e2", "A48", "London System, with Be2"],
  ["rnbqk2r/pp2ppbp/3p1np1/2pP4/2P1P3/2N2P2/PP4PP/R1BQKBNR b KQkq - e7e6", null, null],
  ["rnbqk2r/pp2ppbp/3p1np1/2pP4/2P1P3/5P2/PP4PP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N1B3/PPP1BPPP/R2QK2R b KQkq - b8c6",
    "B72",
    "Sicilian Defense: Dragon Variation, Classical Variation",
  ],
  [
    "rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - f1e2",
    "B72",
    "Sicilian Defense: Dragon Variation, Classical Variation",
  ],
  [
    "rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - f2f3",
    "B75",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Early Deviations",
  ],
  [
    "rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N1BP2/PPP3PP/R2QKB1R b KQkq - b8c6",
    "B75",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack, Belezky Line",
  ],
  [
    "rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N1BP2/PPP3PP/R2QKB1R b KQkq - e8g8",
    "B76",
    "Sicilian Defense: Dragon Variation, Yugoslav Attack",
  ],
  ["rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 b kq - b8c6", null, null],
  ["rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/pp2ppbp/3p1np1/8/3NP3/2N5/PPP1BPPP/R1BQK2R w KQkq - e1g1", null, null],
  ["rnbqk2r/pp2ppbp/6p1/2p5/2BPP3/2P5/P3NPPP/R1BQK2R b KQkq - b8c6", null, null],
  [
    "rnbqk2r/pp2ppbp/6p1/2p5/2BPP3/2P5/P3NPPP/R1BQK2R b KQkq - e8g8",
    "D87",
    "Grünfeld Defense: Exchange Variation, Spassky Variation",
  ],
  ["rnbqk2r/pp2ppbp/6p1/2p5/2BPP3/2P5/P4PPP/R1BQK1NR w KQkq - g1e2", null, null],
  ["rnbqk2r/pp2ppbp/6p1/2p5/3PP3/2P2N2/P4PPP/1RBQKB1R b Kkq - e8g8", null, null],
  [
    "rnbqk2r/pp2ppbp/6p1/2p5/3PP3/2P2N2/P4PPP/R1BQKB1R w KQkq - a1b1",
    "D85",
    "Grünfeld Defense: Exchange Variation, Modern Exchange Variation",
  ],
  [
    "rnbqk2r/pp2ppbp/6p1/2p5/3PP3/2P2N2/P4PPP/R1BQKB1R w KQkq - h2h3",
    "D85",
    "Grünfeld Defense: Exchange Variation, Modern Exchange Variation, Kramnik's Line",
  ],
  ["rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQK2R b KQkq - e8g8", "A72", "Benoni Defense: Classical Variation"],
  [
    "rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQKB1R w KQkq - c1g5",
    "A71",
    "Benoni Defense: Classical Variation, Averbakh-Grivas Attack",
  ],
  [
    "rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQKB1R w KQkq - f1e2",
    "A70",
    "Benoni Defense: Classical Variation, Traditional Variation",
  ],
  [
    "rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQKB1R w KQkq - h2h3",
    "A70",
    "Benoni Defense: Classical Variation, New York Variation",
  ],
  [
    "rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2P2/PP4PP/R1BQKBNR w KQkq - c1e3",
    "A65",
    "Benoni Defense: King's Pawn Line, with Be3",
  ],
  [
    "rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2P2/PP4PP/R1BQKBNR w KQkq - c1g5",
    "A65",
    "Benoni Defense: King's Pawn Line, with Bg5",
  ],
  [
    "rnbqk2r/pp3pbp/3p1np1/2pP4/4P3/2N2P2/PP4PP/R1BQKBNR w KQkq - g1e2",
    "A65",
    "Benoni Defense: King's Pawn Line, with Nge2",
  ],
  ["rnbqk2r/pp3pbp/3p1np1/2pP4/4PP2/2N2N2/PP4PP/R1BQKB1R b KQkq - e8g8", "A68", "Benoni Defense: Four Pawns Attack"],
  ["rnbqk2r/pp3pbp/3p1np1/2pP4/4PP2/2N5/PP4PP/R1BQKBNR w KQkq - e4e5", "A66", "Benoni Defense: Mikenas Variation"],
  ["rnbqk2r/pp3pbp/3p1np1/2pP4/4PP2/2N5/PP4PP/R1BQKBNR w KQkq - f1b5", "A67", "Benoni Defense: Taimanov Variation"],
  ["rnbqk2r/pp3pbp/3p1np1/2pP4/4PP2/2N5/PP4PP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqk2r/pp3pbp/3p1np1/2pP4/8/2N2NP1/PP2PPBP/R1BQK2R b KQkq - e8g8", "A62", "Benoni Defense: Fianchetto Variation"],
  ["rnbqk2r/pp3pbp/3p1np1/2pP4/8/2N3P1/PP2PPBP/R1BQK1NR w KQkq - g1f3", null, null],
  ["rnbqk2r/pp3pbp/3ppnp1/2pP4/2P1P3/2N1BP2/PP4PP/R2QKBNR b KQkq - e8g8", null, null],
  ["rnbqk2r/pp3pbp/3ppnp1/2pP4/2P1P3/2N2P2/PP4PP/R1BQKBNR w KQkq - c1e3", null, null],
  ["rnbqk2r/pp3ppp/2pb1p2/8/3P4/2P5/PP3PPP/R1BQKBNR w KQkq - f1d3", null, null],
  ["rnbqk2r/pp3ppp/2pb1p2/8/3P4/2PB4/PP3PPP/R1BQK1NR b KQkq - e8g8", null, null],
  ["rnbqk2r/pp3ppp/2pbpn2/3p4/2P5/1PN1PN2/P2P1PPP/R1BQKB1R w KQkq - c1b2", null, null],
  ["rnbqk2r/pp3ppp/2pbpn2/3p4/2P5/1PN1PN2/PB1P1PPP/R2QKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/pp3ppp/2pbpn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f1d3", null, null],
  ["rnbqk2r/pp3ppp/2pbpn2/3p4/2PP4/2NBPN2/PP3PPP/R1BQK2R b KQkq - d5c4", null, null],
  ["rnbqk2r/pp3ppp/2pbpn2/8/2BP4/2N1PN2/PP3PPP/R1BQK2R b KQkq - b7b5", null, null],
  ["rnbqk2r/pp3ppp/2pbpn2/8/2pP4/2NBPN2/PP3PPP/R1BQK2R w KQkq - d3c4", null, null],
  [
    "rnbqk2r/pp3ppp/4p3/2pn4/3P4/P1P2P2/4P1PP/R1BQKBNR w KQkq - d4c5",
    "E25",
    "Nimzo-Indian Defense: Sämisch Variation, Keres Variation",
  ],
  [
    "rnbqk2r/pp3ppp/4p3/2Pn4/8/P1P2P2/4P1PP/R1BQKBNR b KQkq - f7f5",
    "E25",
    "Nimzo-Indian Defense: Sämisch Variation, Romanovsky Variation",
  ],
  ["rnbqk2r/pp3ppp/4p3/8/1b1PP3/5N2/P2B1PPP/R2QKB1R b KQkq - b4d2", null, null],
  [
    "rnbqk2r/pp3ppp/4p3/8/1b1PP3/5N2/P2B1PPP/R2QKB1R b KQkq - d8a5",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, San Sebastian Variation",
  ],
  ["rnbqk2r/pp3ppp/4p3/8/1b1PP3/5N2/P4PPP/R1BQKB1R w KQkq - c1d2", null, null],
  ["rnbqk2r/pp3ppp/4p3/8/3PP3/5N2/P2b1PPP/R2QKB1R w KQkq - d1d2", null, null],
  ["rnbqk2r/pp3ppp/4p3/8/3PP3/5N2/P2Q1PPP/R3KB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/pp3ppp/4pn2/2pp4/2PP4/P1P1PP2/6PP/R1BQKBNR b KQkq - e8g8", null, null],
  [
    "rnbqk2r/pp3ppp/4pn2/2pp4/2PP4/P1P2P2/4P1PP/R1BQKBNR w KQkq - c4d5",
    "E25",
    "Nimzo-Indian Defense: Sämisch Variation",
  ],
  ["rnbqk2r/pp3ppp/4pn2/2pp4/2PP4/P1P2P2/4P1PP/R1BQKBNR w KQkq - e2e3", null, null],
  ["rnbqk2r/pp3ppp/4pn2/2pP4/3P4/P1P2P2/4P1PP/R1BQKBNR b KQkq - f6d5", null, null],
  ["rnbqk2r/ppp1bpp1/4pB1p/3p4/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - e7f6", null, null],
  ["rnbqk2r/ppp1bpp1/4pn1p/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR w KQkq - g5h4", null, null],
  ["rnbqk2r/ppp1bpp1/4pn1p/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - g5f6", null, null],
  ["rnbqk2r/ppp1bpp1/4pn1p/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - g5h4", null, null],
  ["rnbqk2r/ppp1bpp1/4pn1p/3p4/2PP3B/2N1P3/PP3PPP/R2QKBNR b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1bpp1/4pn1p/3p4/2PP3B/2N2N2/PP2PPPP/R2QKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1bpp1/5n1p/3p2B1/3P4/2N1P3/PP3PPP/R2QKBNR w KQkq - g5h4", null, null],
  [
    "rnbqk2r/ppp1bpp1/5n1p/3p4/3P3B/2N1P3/PP3PPP/R2QKBNR b KQkq - c8g4",
    "D35",
    "Queen's Gambit Declined: Exchange Variation, Carlsen Variation",
  ],
  ["rnbqk2r/ppp1bppp/3p1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1bppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1e2", null, null],
  [
    "rnbqk2r/ppp1bppp/4p3/3pP3/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - d1g4",
    "C13",
    "French Defense: Classical Variation, Richter Attack",
  ],
  ["rnbqk2r/ppp1bppp/4pB2/3p4/3PP3/2N5/PPP2PPP/R2QKBNR b KQkq - e7f6", null, null],
  ["rnbqk2r/ppp1bppp/4pB2/8/3PN3/8/PPP2PPP/R2QKBNR b KQkq - e7f6", null, null],
  [
    "rnbqk2r/ppp1bppp/4pB2/8/3PN3/8/PPP2PPP/R2QKBNR b KQkq - g7f6",
    "C11",
    "French Defense: Classical Variation, Burn Variation, Morozevich Line",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR b KQkq - f6e4",
    "D53",
    "Queen's Gambit Declined: Lasker Defense",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N1P3/PP3PPP/R2QKBNR b KQkq - h7h6", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - h7h6", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR w KQkq - e2e3", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR w KQkq - g1f3", "D53", "Queen's Gambit Declined"],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR w KQkq - g5f6",
    "D53",
    "Queen's Gambit Declined: Modern Variation, Heral Variation",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p2B1/3PP3/2N5/PPP2PPP/R2QKBNR w KQkq - e4e5", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p2B1/3PP3/2N5/PPP2PPP/R2QKBNR w KQkq - g5f6",
    "C13",
    "French Defense: Classical Variation, Richter Attack",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2P5/1P2PN2/PB1P1PPP/RN1QKB1R b KQkq - e8g8", "A13", "English Opening: Agincourt Defense"],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2P5/1P3N2/PB1PPPPP/RN1QKB1R w KQkq - e2e3", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/2P5/1P3NP1/P2PPPBP/RNBQK2R b KQkq - b7b6",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined, Early b3",
  ],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/2P5/1P3NP1/P2PPPBP/RNBQK2R b KQkq - c7c5",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined, Early b3",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2P5/2N1PN2/PP1P1PPP/R1BQKB1R w KQkq - d2d4", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQ1RK1 b kq - c7c5", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQ1RK1 b kq - e8g8", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R w KQkq - b2b3",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined, Early b3",
  ],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R w KQkq - e1g1",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP1B2/2N2N2/PP2PPPP/R2QKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/1P2PN2/P4PPP/RNBQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1f4",
    "D37",
    "Queen's Gambit Declined: Harrwitz Attack",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5", "D53", "Queen's Gambit Declined"],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R w KQkq - b2b3", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP1BPP1P/RN1QKB1R w KQkq - f1g2",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1QK2R b KQkq - b8d7", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP1BPPBP/RN1QK2R b KQkq - e8g8",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - f1g2", "E06", "Catalan Opening: Closed"],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/6P1/PP1BPPBP/RN1QK1NR w KQkq - g1f3",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3p4/2PP4/6P1/PP2PPBP/RNBQK1NR w KQkq - g1f3", "E06", "Catalan Opening: Closed"],
  [
    "rnbqk2r/ppp1bppp/4pn2/3p4/8/5NP1/PPPPPPBP/RNBQ1RK1 w kq - c2c4",
    "A14",
    "English Opening: Agincourt Defense, Neo-Catalan Declined",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/3pP1B1/3P4/2N5/PPP2PPP/R2QKBNR b KQkq - f6d7", null, null],
  [
    "rnbqk2r/ppp1bppp/4pn2/3pP1B1/3P4/2N5/PPP2PPP/R2QKBNR b KQkq - f6e4",
    "C13",
    "French Defense: Classical Variation, Tartakower Variation",
  ],
  [
    "rnbqk2r/ppp1bppp/4pn2/3pP1B1/3P4/2N5/PPP2PPP/R2QKBNR b KQkq - f6g8",
    "C13",
    "French Defense: Classical Variation, Vistaneckis Variation",
  ],
  ["rnbqk2r/ppp1bppp/4pn2/6B1/3P4/2N2N2/PPP3PP/R2QKB1R w KQkq - f1d3", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/6B1/3P4/2NB1N2/PPP3PP/R2QK2R b KQkq - b8c6", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/6B1/3PN3/8/PPP2PPP/R2QKBNR w KQkq - g5f6", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/8/3PN3/P5N1/1PP2PPP/R1BQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1bppp/4pn2/8/3PN3/P7/1PP1NPPP/R1BQKB1R w KQkq - e2g3", null, null],
  ["rnbqk2r/ppp1bppp/5n2/3p2B1/3P4/2N1P3/PP3PPP/R2QKBNR b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1bppp/5n2/3p2B1/3P4/2N1P3/PP3PPP/R2QKBNR b KQkq - h7h6", null, null],
  ["rnbqk2r/ppp1bppp/5n2/3p2B1/3P4/2N5/PP2PPPP/R2QKBNR w KQkq - e2e3", null, null],
  ["rnbqk2r/ppp1bppp/8/3p4/3Pn3/3B1N2/PPP2PPP/RNBQ1RK1 b kq - b8c6", null, null],
  [
    "rnbqk2r/ppp1bppp/8/3p4/3Pn3/3B1N2/PPP2PPP/RNBQ1RK1 b kq - e8g8",
    "C42",
    "Petrov's Defense: Classical Attack, Mason Variation",
  ],
  ["rnbqk2r/ppp1bppp/8/3p4/3Pn3/3B1N2/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "rnbqk2r/ppp1nppp/4p3/3p4/1b1PP3/2N5/PPPB1PPP/R2QKBNR w KQkq - c3b1",
    "C15",
    "French Defense: Winawer Variation, Fingerslip Variation, Schwarz's Line",
  ],
  ["rnbqk2r/ppp1nppp/4p3/3pP3/1b1P4/2N5/PPP2PPP/R1BQKBNR w KQkq - a2a3", null, null],
  ["rnbqk2r/ppp1nppp/4p3/3pP3/1b1P4/P1N5/1PP2PPP/R1BQKBNR b KQkq - b4c3", null, null],
  ["rnbqk2r/ppp1nppp/4p3/3pP3/3P4/P1b5/1PP2PPP/R1BQKBNR w KQkq - b2c3", null, null],
  [
    "rnbqk2r/ppp1nppp/4p3/3pP3/3P4/P1P5/2P2PPP/R1BQKBNR b KQkq - c7c5",
    "C18",
    "French Defense: Winawer Variation, Advance Variation",
  ],
  [
    "rnbqk2r/ppp1nppp/8/3p4/1b1P4/2NB4/PPP2PPP/R1BQK1NR w KQkq - d1h5",
    "C15",
    "French Defense: Winawer Variation, Exchange Variation, Canal Attack",
  ],
  [
    "rnbqk2r/ppp1ppbp/1n1p2p1/4P3/3P4/1B3N2/PPP2PPP/RNBQK2R w KQkq - a2a4",
    "B04",
    "Alekhine Defense: Modern Variation, Keres Variation",
  ],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/1PP5/4P3/PB1P1PPP/RN1QKBNR w KQkq - g1f3", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/1PP5/4PN2/PB1P1PPP/RN1QKB1R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5",
    "E61",
    "King's Indian Defense: Smyslov Variation",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - g2g3",
    "E62",
    "King's Indian Defense: Fianchetto Variation, Delayed Fianchetto",
  ],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/2PP4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N2N2/PP3PPP/R1BQKB1R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N2P2/PP4PP/R1BQKBNR b KQkq - e8g8",
    "E81",
    "King's Indian Defense: Sämisch Variation, Normal Defense",
  ],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N3P1/PP3P1P/R1BQKBNR b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N4P/PP3PP1/R1BQKBNR b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP2BPPP/R1BQK1NR b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - c1g5",
    "E70",
    "King's Indian Defense: Accelerated Averbakh Variation",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - f1e2",
    "E73",
    "King's Indian Defense: Normal Variation, Standard Development",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - f2f3",
    "E80",
    "King's Indian Defense: Sämisch Variation",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - f2f4",
    "E76",
    "King's Indian Defense: Four Pawns Attack",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - g1e2",
    "E70",
    "King's Indian Defense: Kramer Variation",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3",
    "E90",
    "King's Indian Defense: Normal Variation, Rare Defenses",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - g2g3",
    "E72",
    "King's Indian Defense: Normal Variation, Deferred Fianchetto",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR w KQkq - h2h3",
    "E71",
    "King's Indian Defense: Makogonov Variation",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPP3/4B3/PP3PPP/RN1QKBNR w KQkq - f2f3",
    "A42",
    "Modern Defense: Averbakh Variation, Pseudo-Sämisch",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/2PPPP2/2N5/PP4PP/R1BQKBNR b KQkq - b8a6",
    "E76",
    "King's Indian Defense: Four Pawns Attack, Modern Defense",
  ],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/2PPPP2/2N5/PP4PP/R1BQKBNR b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3P1B2/4PN1P/PPP2PP1/RN1QKB1R b KQkq - c7c5", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3P1B2/4PN2/PPP1BPPP/RN1QK2R b KQkq - e8g8", "A48", "London System, with Be2"],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3P1B2/4PN2/PPP2PPP/RN1QKB1R w KQkq - f1d3", "A48", "London System, with Bd3"],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3P1B2/4PN2/PPP2PPP/RN1QKB1R w KQkq - f1e2", "A48", "London System, with Be2"],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3P1B2/4PN2/PPP2PPP/RN1QKB1R w KQkq - h2h3", null, null],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP1BPPP/R1BQK2R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f1e2",
    "B08",
    "Pirc Defense: Classical Variation, Quiet System",
  ],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - h2h3",
    "B08",
    "Pirc Defense: Classical Variation, Schlechter Variation",
  ],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3PP3/2N5/PPP1BPPP/R1BQK1NR w KQkq - g2g4", "B07", "Pirc Defense: Chinese Variation"],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3PP3/2N5/PPP1BPPP/R1BQK1NR w KQkq - h2h4", "B07", "Pirc Defense: Bayonet Attack"],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/3PPP2/2N2N2/PPP3PP/R1BQKB1R b KQkq - c7c5",
    "B09",
    "Pirc Defense: Austrian Attack, Dragon Formation",
  ],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3PPP2/2N2N2/PPP3PP/R1BQKB1R b KQkq - e8g8", "B09", "Pirc Defense: Austrian Attack"],
  [
    "rnbqk2r/ppp1ppbp/3p1np1/8/3PPP2/2N5/PPP3PP/R1BQKBNR w KQkq - f1c4",
    "B09",
    "Pirc Defense: Austrian Attack, Ljubojevic Variation",
  ],
  ["rnbqk2r/ppp1ppbp/3p1np1/8/3PPP2/2N5/PPP3PP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqk2r/ppp1ppbp/5np1/3p2B1/3P4/4PN2/PPPN1PPP/R2QKB1R b KQkq - e8g8",
    "A48",
    "Queen's Pawn Game: Torre Attack, Grünfeld Variation, Main Line",
  ],
  ["rnbqk2r/ppp1ppbp/5np1/3p2B1/3P4/5N2/PPPNPPPP/R2QKB1R w KQkq - e2e3", null, null],
  [
    "rnbqk2r/ppp1ppbp/5np1/3p4/2PP1B2/2N1P3/PP3PPP/R2QKBNR b KQkq - e8g8",
    "D83",
    "Grünfeld Defense: Brinckmann Attack, Grünfeld Gambit",
  ],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP1B2/2N2N2/PP2PPPP/R2QKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP1B2/2N5/PP2PPPP/2RQKBNR b Kkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP1B2/2N5/PP2PPPP/R2QKBNR w KQkq - a1c1", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP1B2/2N5/PP2PPPP/R2QKBNR w KQkq - e2e3", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/1QN1P3/PP3PPP/R1B1KBNR b KQkq - d5c4", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/1QN2N2/PP2PPPP/R1B1KB1R b KQkq - d5c4", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - d1b3", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1f4",
    "D92",
    "Grünfeld Defense: Three Knights Variation, Hungarian Attack",
  ],
  [
    "rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5",
    "D91",
    "Grünfeld Defense: Three Knights Variation, Petrosian System",
  ],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c4d5", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - d1a4", "D90", "Grünfeld Defense: Flohr Variation"],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - d1b3", "D96", "Grünfeld Defense: Russian Variation"],
  [
    "rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3",
    "D94",
    "Grünfeld Defense: Three Knights Variation, Burille Variation",
  ],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/2PP4/6P1/PP2PPBP/RNBQK1NR w KQkq - c4d5", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/3P1B2/2N1PN2/PPP2PPP/R2QKB1R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1ppbp/5np1/3p4/3P1B2/2N2N2/PPP1PPPP/R2QKB1R w KQkq - d1d2",
    "A48",
    "Queen's Pawn Game: Barry Attack, Tarzan Attack",
  ],
  ["rnbqk2r/ppp1ppbp/5np1/3p4/3P1B2/2N2N2/PPP1PPPP/R2QKB1R w KQkq - e2e3", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/3P4/3P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - f6d5", null, null],
  [
    "rnbqk2r/ppp1ppbp/5np1/3P4/3P4/6P1/PP2PPBP/RNBQK1NR b KQkq - f6d5",
    "D71",
    "Neo-Grünfeld Defense: Exchange Variation",
  ],
  ["rnbqk2r/ppp1ppbp/5np1/8/2BP4/1QN1P3/PP3PPP/R1B1K1NR b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/8/2BP4/2N2N2/PPP3PP/R1BQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/8/2BP4/2N2N2/PPP3PP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "rnbqk2r/ppp1ppbp/5np1/8/2BP4/2N2N2/PPP3PP/R1BQK2R w KQkq - f3e5",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense, Nimzowitsch Attack",
  ],
  [
    "rnbqk2r/ppp1ppbp/5np1/8/2BP4/2N2N2/PPP3PP/R1BQK2R w KQkq - h2h4",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense, Mad Dog Attack",
  ],
  ["rnbqk2r/ppp1ppbp/5np1/8/2pP4/1QN1P3/PP3PPP/R1B1KBNR w KQkq - f1c4", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/8/2pP4/1QN2N2/PP2PPPP/R1B1KB1R w KQkq - b3c4", null, null],
  ["rnbqk2r/ppp1ppbp/5np1/8/2QP4/2N2N2/PP2PPPP/R1B1KB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp1ppbp/6p1/3n4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e4", null, null],
  ["rnbqk2r/ppp1ppbp/6p1/3n4/3PP3/2N2N2/PP3PPP/R1BQKB1R b KQkq - d5c3", null, null],
  ["rnbqk2r/ppp1ppbp/6p1/3n4/8/2N2NP1/PP1PPP1P/R1BQKB1R w KQkq - f1g2", null, null],
  [
    "rnbqk2r/ppp1ppbp/6p1/3n4/8/2N2NP1/PP1PPPBP/R1BQK2R b KQkq - e7e5",
    "A16",
    "English Opening: Anglo-Grünfeld Defense, Korchnoi Variation",
  ],
  ["rnbqk2r/ppp1ppbp/6p1/8/2BPP3/2P5/P4PPP/R1BQK1NR b KQkq - c7c5", null, null],
  ["rnbqk2r/ppp1ppbp/6p1/8/2BPP3/2P5/P4PPP/R1BQK1NR b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppp1ppbp/6p1/8/3PP3/2n2N2/PP3PPP/R1BQKB1R w KQkq - b2c3",
    "D85",
    "Grünfeld Defense: Exchange Variation, Modern Exchange Variation",
  ],
  [
    "rnbqk2r/ppp1ppbp/6p1/8/3PP3/2P2N2/P4PPP/R1BQKB1R b KQkq - c7c5",
    "D85",
    "Grünfeld Defense: Exchange Variation, Modern Exchange Variation",
  ],
  [
    "rnbqk2r/ppp1ppbp/6p1/8/3PP3/2P5/P4PPP/R1BQKBNR w KQkq - f1c4",
    "D86",
    "Grünfeld Defense: Exchange Variation, Classical Variation",
  ],
  [
    "rnbqk2r/ppp1ppbp/6p1/8/3PP3/2P5/P4PPP/R1BQKBNR w KQkq - g1f3",
    "D85",
    "Grünfeld Defense: Exchange Variation, Modern Exchange Variation",
  ],
  [
    "rnbqk2r/ppp2p1p/3b1n2/3PN3/2B2ppP/8/PPPP2P1/RNBQ1RK1 b kq - d6e5",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Rice Gambit",
  ],
  ["rnbqk2r/ppp2p1p/3b1n2/3PN3/2B2ppP/8/PPPP2P1/RNBQK2R w KQkq - d2d4", null, null],
  [
    "rnbqk2r/ppp2p1p/3b1n2/3PN3/2B2ppP/8/PPPP2P1/RNBQK2R w KQkq - e1g1",
    "C39",
    "King's Gambit Accepted: Kieseritzky, Rice Gambit",
  ],
  ["rnbqk2r/ppp2p1p/3b1n2/3PN3/2BP1ppP/8/PPP3P1/RNBQK2R b KQkq - f6h5", null, null],
  [
    "rnbqk2r/ppp2p1p/3b4/3PN2n/2BP1BpP/8/PPP3P1/RN1QK2R b KQkq - h5f4",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Anderssen-Cordel Gambit",
  ],
  ["rnbqk2r/ppp2p1p/3b4/3PN2n/2BP1ppP/8/PPP3P1/RNBQK2R w KQkq - c1f4", null, null],
  ["rnbqk2r/ppp2pp1/4p2p/3pP3/3Pn1Q1/2P5/P1PB1PPP/R3KBNR b KQkq - e8f8", null, null],
  [
    "rnbqk2r/ppp2pp1/4p2p/3pP3/3Pn1Q1/2P5/P1PB1PPP/R3KBNR b KQkq - g7g6",
    "C12",
    "French Defense: McCutcheon Variation, Lasker Variation",
  ],
  ["rnbqk2r/ppp2pp1/4p2p/3pP3/3Pn3/2P5/P1PB1PPP/R2QKBNR w KQkq - d1g4", null, null],
  ["rnbqk2r/ppp2pP1/4p3/3p2p1/1b1P4/2N5/PPP2PPP/R2QKBNR b KQkq - h8g8", null, null],
  ["rnbqk2r/ppp2pp1/4pb1p/3p4/2PP4/2N1PN2/PP3PPP/R2QKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppp2pp1/4pb1p/3p4/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - e2e3", null, null],
  [
    "rnbqk2r/ppp2pp1/4pn1p/3pP1B1/1b1P4/2N5/PPP2PPP/R2QKBNR w KQkq - e5f6",
    "C12",
    "French Defense: McCutcheon Variation, Chigorin Variation",
  ],
  [
    "rnbqk2r/ppp2pp1/4pn1p/3pP1B1/1b1P4/2N5/PPP2PPP/R2QKBNR w KQkq - g5c1",
    "C12",
    "French Defense: McCutcheon Variation, Dr. Olland Variation",
  ],
  ["rnbqk2r/ppp2pp1/4pn1p/3pP1B1/1b1P4/2N5/PPP2PPP/R2QKBNR w KQkq - g5d2", null, null],
  [
    "rnbqk2r/ppp2pp1/4pn1p/3pP1B1/1b1P4/2N5/PPP2PPP/R2QKBNR w KQkq - g5e3",
    "C12",
    "French Defense: McCutcheon Variation, Janowski Variation",
  ],
  [
    "rnbqk2r/ppp2pp1/4pn1p/3pP1B1/1b1P4/2N5/PPP2PPP/R2QKBNR w KQkq - g5h4",
    "C12",
    "French Defense: McCutcheon Variation, Bernstein Variation",
  ],
  [
    "rnbqk2r/ppp2pp1/4pn1p/3pP3/1b1P4/2N5/PPPB1PPP/R2QKBNR b KQkq - b4c3",
    "C12",
    "French Defense: McCutcheon Variation, Lasker Variation",
  ],
  [
    "rnbqk2r/ppp2pp1/4pn1p/3pP3/1b1P4/2N5/PPPB1PPP/R2QKBNR b KQkq - f6d7",
    "C12",
    "French Defense: McCutcheon Variation, Tartakower Variation",
  ],
  ["rnbqk2r/ppp2pp1/4pn1p/3pP3/3P4/2b5/PPPB1PPP/R2QKBNR w KQkq - b2c3", null, null],
  ["rnbqk2r/ppp2pp1/4pn1p/3pP3/3P4/2P5/P1PB1PPP/R2QKBNR b KQkq - f6e4", null, null],
  ["rnbqk2r/ppp2pp1/4pP1p/3p2B1/1b1P4/2N5/PPP2PPP/R2QKBNR b KQkq - h6g5", null, null],
  ["rnbqk2r/ppp2pp1/4pP2/3p2p1/1b1P4/2N5/PPP2PPP/R2QKBNR w KQkq - f6g7", null, null],
  [
    "rnbqk2r/ppp2ppp/3b3n/8/8/5N2/PPPPP1PP/RNBQKB1R w KQkq - d2d4",
    "A02",
    "Bird Opening: From's Gambit, Lipke Variation",
  ],
  ["rnbqk2r/ppp2ppp/3b4/3p4/3Pn3/3B1N2/PPP2PPP/RNBQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/ppp2ppp/3b4/3p4/3Pn3/3B1N2/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqk2r/ppp2ppp/3b4/3pN3/3Pn3/3B4/PPP2PPP/RNBQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/ppp2ppp/3b4/3pN3/3Pn3/3B4/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqk2r/ppp2ppp/3bpn2/3p4/3P4/3BPN2/PPP2PPP/RNBQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/ppp2ppp/3bpn2/3p4/3P4/3BPN2/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "rnbqk2r/ppp2ppp/4p3/3p4/2PPn3/P1Q5/1P2PPPP/R1B1KBNR w KQkq - c3c2",
    "E37",
    "Nimzo-Indian Defense: Classical Variation, Noa Variation",
  ],
  ["rnbqk2r/ppp2ppp/4p3/3p4/2PPn3/P7/1PQ1PPPP/R1B1KBNR b KQkq - b8c6", null, null],
  [
    "rnbqk2r/ppp2ppp/4p3/3p4/2PPn3/P7/1PQ1PPPP/R1B1KBNR b KQkq - c7c5",
    "E37",
    "Nimzo-Indian Defense: Classical Variation, Modern Variation",
  ],
  ["rnbqk2r/ppp2ppp/4pb2/3p4/3PP3/2N5/PPP2PPP/R2QKBNR w KQkq - e4e5", null, null],
  ["rnbqk2r/ppp2ppp/4pb2/3pP3/3P4/2N5/PPP2PPP/R2QKBNR b KQkq - f6e7", null, null],
  [
    "rnbqk2r/ppp2ppp/4pb2/8/3PN3/5N2/PPP2PPP/R2QKB1R b KQkq - e8g8",
    "C11",
    "French Defense: Classical Variation, Burn Variation, Main Line",
  ],
  ["rnbqk2r/ppp2ppp/4pb2/8/3PN3/8/PPP2PPP/R2QKBNR w KQkq - g1f3", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/3P2B1/1b1P4/2N5/PPP2PPP/R2QKBNR b KQkq - d8d5", null, null],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p2B1/1b1PP3/2N5/PPP2PPP/R2QKBNR w KQkq - e4d5",
    "C12",
    "French Defense: McCutcheon Variation, Exchange Variation",
  ],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p2B1/1b1PP3/2N5/PPP2PPP/R2QKBNR w KQkq - e4e5",
    "C12",
    "French Defense: McCutcheon Variation, Advance Variation",
  ],
  ["rnbqk2r/ppp2ppp/4pn2/3p2B1/1bPP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - b8d7", null, null],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p2B1/1bPP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - d5c4",
    "D39",
    "Queen's Gambit Declined: Ragozin Defense, Vienna Variation",
  ],
  ["rnbqk2r/ppp2ppp/4pn2/3P4/1b1P4/2N5/PPQ1PPPP/R1B1KBNR b KQkq - d8d5", null, null],
  [
    "rnbqk2r/ppp2ppp/4pn2/3P4/1b1P4/2N5/PPQ1PPPP/R1B1KBNR b KQkq - e6d5",
    "E35",
    "Nimzo-Indian Defense: Classical Variation, Noa Variation",
  ],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p4/1b1PP3/2N5/PPP1NPPP/R1BQKB1R w KQkq - c1g5",
    "C15",
    "French Defense: McCutcheon Variation, Wolf Gambit",
  ],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5", null, null],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - d1a4",
    "D38",
    "Queen's Gambit Declined: Ragozin Defense, Alekhine Variation",
  ],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/2N2P2/PP2P1PP/R1BQKBNR w KQkq - a2a3", null, null],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/2N5/PPQ1PPPP/R1B1KBNR w KQkq - a2a3",
    "E36",
    "Nimzo-Indian Defense: Classical Variation, Noa Variation",
  ],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/2N5/PPQ1PPPP/R1B1KBNR w KQkq - c4d5", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/5NP1/PP1BPP1P/RN1QKB1R b KQkq - b4e7", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - c1d2", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/P1N2P2/1P2P1PP/R1BQKBNR b KQkq - b4c3", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/1bPP4/P1N5/1PQ1PPPP/R1B1KBNR b KQkq - b4c3", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/2PP4/P1b2P2/1P2P1PP/R1BQKBNR w KQkq - b2c3", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/2PP4/P1b5/1PQ1PPPP/R1B1KBNR w KQkq - c2c3", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/3p4/2PP4/P1P2P2/4P1PP/R1BQKBNR b KQkq - c7c5", null, null],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p4/2PP4/P1Q5/1P2PPPP/R1B1KBNR b KQkq - b8c6",
    "E36",
    "Nimzo-Indian Defense: Classical Variation, Noa Variation, Botvinnik Variation",
  ],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p4/2PP4/P1Q5/1P2PPPP/R1B1KBNR b KQkq - c7c5",
    "E36",
    "Nimzo-Indian Defense: Classical Variation, Romanishin Gambit",
  ],
  [
    "rnbqk2r/ppp2ppp/4pn2/3p4/2PP4/P1Q5/1P2PPPP/R1B1KBNR b KQkq - f6e4",
    "E36",
    "Nimzo-Indian Defense: Classical Variation, Noa Variation, Main Line",
  ],
  ["rnbqk2r/ppp2ppp/4pn2/3pP1B1/1b1P4/2N5/PPP2PPP/R2QKBNR b KQkq - h7h6", null, null],
  ["rnbqk2r/ppp2ppp/4pn2/8/1b1Pp1Q1/2N5/PPPB1PPP/R3KBNR w KQkq - g4g7", null, null],
  [
    "rnbqk2r/ppp2ppp/5n2/2bBp3/4P3/2P5/PP1P1PPP/RNBQK1NR w KQkq - d2d4",
    "C23",
    "Bishop's Opening: Lewis Countergambit, Walker Variation",
  ],
  ["rnbqk2r/ppp2ppp/5n2/2bpP3/2Bp4/2P5/PP3PPP/RNBQK1NR w KQkq d6 e5f6", null, null],
  ["rnbqk2r/ppp2ppp/5n2/3P4/1b2pP2/2NP4/PPP3PP/R1BQKBNR w KQkq - c1d2", null, null],
  [
    "rnbqk2r/ppp2ppp/5n2/3P4/1b2pP2/2NP4/PPPB2PP/R2QKBNR b KQkq - e4e3",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit, Morphy Defense",
  ],
  [
    "rnbqk2r/ppp2ppp/5n2/3P4/1bBp4/2P2N2/PP3PPP/RNBQK2R b KQkq - d8e7",
    "C24",
    "Bishop's Opening: Urusov Gambit, Panov Variation",
  ],
  ["rnbqk2r/ppp2ppp/5n2/3P4/1bBp4/5N2/PPP2PPP/RNBQK2R w KQkq - c2c3", null, null],
  ["rnbqk2r/ppp2ppp/5P2/2b4Q/2pp4/2P5/PP3PPP/RNB1K1NR b KQkq - e8g8", "C23", "Bishop's Opening: Pratt Variation"],
  ["rnbqk2r/ppp2ppp/5P2/2b5/2pp4/2P5/PP3PPP/RNBQK1NR w KQkq - d1h5", null, null],
  ["rnbqk2r/ppp2ppp/5P2/2bp4/2Bp4/2P5/PP3PPP/RNBQK1NR b KQkq - d5c4", null, null],
  ["rnbqk2r/ppp2ppp/8/2bP4/4nP2/5N2/PPP1Q1PP/RNB1KB1R b KQkq - c5f2", null, null],
  [
    "rnbqk2r/ppp2ppp/8/2bP4/4nP2/5N2/PPP1Q1PP/RNB1KB1R b KQkq - c8f5",
    "C32",
    "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit, Main Line",
  ],
  ["rnbqk2r/ppp2ppp/8/2bP4/4nP2/5N2/PPP3PP/RNBQKB1R w KQkq - d1e2", null, null],
  ["rnbqk2r/ppp2ppp/8/3P4/4nP2/5N2/PPP1QbPP/RNB1KB1R w KQkq - e1d1", null, null],
  ["rnbqk2r/ppp2ppp/8/3P4/4nP2/5N2/PPP1QbPP/RNBK1B1R b kq - d8d5", null, null],
  ["rnbqk2r/ppp2pQp/4pn2/8/1b1Pp3/2N5/PPPB1PPP/R3KBNR b KQkq - h8g8", null, null],
  ["rnbqk2r/pppn1ppp/4p3/3pP1b1/3P3P/2N5/PPP2PP1/R2QKBNR w KQkq - h4g5", null, null],
  [
    "rnbqk2r/pppn1ppp/4p3/3pP1P1/3P4/2N5/PPP2PP1/R2QKBNR b KQkq - d8g5",
    "C13",
    "French Defense: Alekhine-Chatard Attack, Albin-Chatard Gambit",
  ],
  [
    "rnbqk2r/pppnbppp/4p3/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR b KQkq - a7a6",
    "C13",
    "French Defense: Alekhine-Chatard Attack, Maróczy Variation",
  ],
  [
    "rnbqk2r/pppnbppp/4p3/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR b KQkq - c7c5",
    "C13",
    "French Defense: Alekhine-Chatard Attack, Breyer Variation",
  ],
  ["rnbqk2r/pppnbppp/4p3/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR b KQkq - e7g5", null, null],
  [
    "rnbqk2r/pppnbppp/4p3/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR b KQkq - e8g8",
    "C13",
    "French Defense: Alekhine-Chatard Attack, Spielmann Variation",
  ],
  [
    "rnbqk2r/pppnbppp/4p3/3pP1B1/3P3P/2N5/PPP2PP1/R2QKBNR b KQkq - f7f6",
    "C13",
    "French Defense: Alekhine-Chatard Attack, Teichmann Variation",
  ],
  ["rnbqk2r/pppnbppp/4p3/3pP1B1/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - g5e7", null, null],
  [
    "rnbqk2r/pppnbppp/4p3/3pP1B1/3P4/2N5/PPP2PPP/R2QKBNR w KQkq - h2h4",
    "C13",
    "French Defense: Alekhine-Chatard Attack",
  ],
  ["rnbqk2r/pppnBppp/4p3/3pP3/3P4/2N5/PPP2PPP/R2QKBNR b KQkq - d8e7", "C14", "French Defense: Classical Variation"],
  ["rnbqk2r/pppp1pp1/4pn1p/6B1/1bPP4/2N5/PP2PPPP/R2QKBNR w KQkq - g5h4", null, null],
  ["rnbqk2r/pppp1pp1/4pn1p/8/1bPP3B/2N5/PP2PPPP/R2QKBNR b KQkq - c7c5", null, null],
  ["rnbqk2r/pppp1ppp/4p3/8/1bPPn3/2N1P3/PP3PPP/R1BQKBNR w KQkq - d1c2", null, null],
  ["rnbqk2r/pppp1ppp/4p3/8/1bPPn3/2N1P3/PPQ2PPP/R1B1KBNR b KQkq - f7f5", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/6B1/1bPP4/2N5/PP2PPPP/R2QKBNR b KQkq - h7h6", null, null],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bP5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - g2g4",
    "A17",
    "English Opening: Anglo-Indian Defense, Zvjaginsev-Krasenkow Attack",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/1QN5/PP2PPPP/R1B1KBNR b KQkq - c7c5", null, null],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - b7b6",
    "E43",
    "Nimzo-Indian Defense: St. Petersburg Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - b8c6",
    "E40",
    "Nimzo-Indian Defense: Rubinstein System, Taimanov Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - c7c5",
    "E41",
    "Nimzo-Indian Defense: Rubinstein System",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - e8g8",
    "E46",
    "Nimzo-Indian Defense: Normal Variation",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - f6e4", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b4c3", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b7b6", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - c7c5", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N2P2/PP2P1PP/R1BQKBNR b KQkq - d7d5", null, null],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - a2a3",
    "E24",
    "Nimzo-Indian Defense: Sämisch Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - c1g5",
    "E30",
    "Nimzo-Indian Defense: Leningrad Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - d1b3",
    "E22",
    "Nimzo-Indian Defense: Spielmann Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - d1c2",
    "E32",
    "Nimzo-Indian Defense: Classical Variation",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - d1d3", "E20", "Nimzo-Indian Defense: Mikenas Attack"],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e3",
    "E40",
    "Nimzo-Indian Defense: Rubinstein System",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", "E20", "Nimzo-Indian Defense: Dilworth Gambit"],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - f2f3", "E20", "Nimzo-Indian Defense: Kmoch Variation"],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3",
    "E21",
    "Nimzo-Indian Defense: Three Knights Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g2g3",
    "E20",
    "Nimzo-Indian Defense: Romanishin Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR b KQkq - b8c6",
    "E33",
    "Nimzo-Indian Defense: Classical Variation, Zurich Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR b KQkq - c7c5",
    "E38",
    "Nimzo-Indian Defense: Classical Variation, Berlin Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR b KQkq - d7d5",
    "E34",
    "Nimzo-Indian Defense: Classical Variation, Noa Variation",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/2N5/PPQ1PPPP/R1B1KBNR b KQkq - e8g8", null, null],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP1BPPPP/RN1QKB1R b KQkq - a7a5",
    "E11",
    "Bogo-Indian Defense: Wade-Smyslov Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP1BPPPP/RN1QKB1R b KQkq - b4d2",
    "E11",
    "Bogo-Indian Defense: Exchange Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP1BPPPP/RN1QKB1R b KQkq - b4e7",
    "E11",
    "Bogo-Indian Defense: Retreat Variation",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP1BPPPP/RN1QKB1R b KQkq - b8c6", "E11", "Bogo-Indian Defense: Haiti Variation"],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP1BPPPP/RN1QKB1R b KQkq - c7c5",
    "E11",
    "Bogo-Indian Defense: Vitolins Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP1BPPPP/RN1QKB1R b KQkq - d8e7",
    "E11",
    "Bogo-Indian Defense: Nimzowitsch Variation",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP1NPPPP/R1BQKB1R b KQkq - b7b6", null, null],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3",
    "E21",
    "Nimzo-Indian Defense: Three Knights Variation",
  ],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1d2",
    "E11",
    "Bogo-Indian Defense: Grünfeld Variation",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP2PPPP/RNBQKB1R w KQkq - c1d2", null, null],
  [
    "rnbqk2r/pppp1ppp/4pn2/8/1bPP4/5N2/PP2PPPP/RNBQKB1R w KQkq - f3d2",
    "E11",
    "Bogo-Indian Defense: New England Variation",
  ],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/6P1/PP1BPP1P/RN1QKBNR b KQkq - b4e7", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/6P1/PP2PP1P/RNBQKBNR w KQkq - c1d2", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/1bPP4/P1N5/1P2PPPP/R1BQKBNR b KQkq - b4c3", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/2PP4/2b2N2/PP2PPPP/R1BQKB1R w KQkq - b2c3", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/2PP4/2P2N2/P3PPPP/R1BQKB1R b KQkq - b7b6", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/2PP4/P1b5/1P2PPPP/R1BQKBNR w KQkq - b2c3", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/2PP4/P1P5/4PPPP/R1BQKBNR b KQkq - c7c5", null, null],
  ["rnbqk2r/pppp1ppp/4pn2/8/2PP4/P1P5/4PPPP/R1BQKBNR b KQkq - e8g8", "E27", "Nimzo-Indian Defense: Sämisch Variation"],
  [
    "rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR w KQkq - d2d3",
    "C26",
    "Bishop's Opening: Vienna Hybrid, Spielmann Attack",
  ],
  ["rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR w KQkq - g1e2", null, null],
  [
    "rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/2N5/PPPPNPPP/R1BQK2R b KQkq - b7b5",
    "C26",
    "Vienna Game: Stanley Variation, Eifel Gambit",
  ],
  ["rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/2P5/PP1P1PPP/RNBQK1NR w KQkq - d2d4", null, null],
  ["rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/5P2/PPPP2PP/RNBQK1NR w KQkq - g1e2", null, null],
  ["rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/5P2/PPPPN1PP/RNBQK2R b KQkq - b8c6", null, null],
  [
    "rnbqk2r/pppp1ppp/5n2/2b1p3/2B1P3/8/PPPPQPPP/RNB1K1NR w KQkq - f2f4",
    "C23",
    "Bishop's Opening: Lopez Variation, Lopez Gambit",
  ],
  ["rnbqk2r/pppp1ppp/5n2/2b1P3/2Bp4/2P5/PP3PPP/RNBQK1NR b KQkq - d7d5", null, null],
  ["rnbqk2r/pppp1ppp/5n2/2b1p3/2BPP3/2P5/PP3PPP/RNBQK1NR b KQkq - e5d4", null, null],
  ["rnbqk2r/pppp1ppp/5n2/2b1p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  [
    "rnbqk2r/pppp1ppp/5n2/2b1p3/2P5/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - c7c6",
    "A23",
    "English Opening: King's English Variation, Two Knights Variation, Keres Variation",
  ],
  ["rnbqk2r/pppp1ppp/5n2/2b1p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["rnbqk2r/pppp1ppp/5n2/2b1p3/4P3/2N3P1/PPPP1PBP/R1BQK1NR b KQkq - b8c6", null, null],
  ["rnbqk2r/pppp1ppp/5n2/2b5/2BpP3/2P5/PP3PPP/RNBQK1NR w KQkq - e4e5", null, null],
  ["rnbqk2r/pppp1ppp/5n2/4p3/1bP5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["rnbqk2r/pppp1ppp/5n2/4p3/1bP5/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - e8g8", null, null],
  [
    "rnbqk2r/pppp1ppp/5n2/8/1bB1Pp2/2N5/PPPP2PP/R1BQK1NR w KQkq - e4e5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Paulsen Attack",
  ],
  ["rnbqk2r/pppp2pp/4p3/5p2/1bPPn3/2N1P3/PPQ2PPP/R1B1KBNR w KQkq - g1f3", null, null],
  ["rnbqk2r/pppp2pp/4p3/5p2/1bPPn3/2N1PN2/PPQ2PPP/R1B1KB1R b KQkq - b7b6", null, null],
  [
    "rnbqk2r/pppp2pp/4pn2/5p2/1bPP4/6P1/PP1BPPBP/RN1QK1NR b KQkq - b4e7",
    "A90",
    "Dutch Defense: Nimzo-Dutch Variation, Alekhine Variation",
  ],
  ["rnbqk2r/pppp2pp/4pn2/5p2/1bPP4/6P1/PP2PPBP/RNBQK1NR w KQkq - c1d2", null, null],
  ["rnbqk2r/ppppb1pp/4pn2/5p2/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - e8g8", "A92", "Dutch Defense: Classical Variation"],
  ["rnbqk2r/ppppb1pp/4pn2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR w KQkq - g1f3", null, null],
  [
    "rnbqk2r/ppppb1pp/4pn2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR w KQkq - g1h3",
    "A91",
    "Dutch Defense: Classical Variation, Blackburne Attack",
  ],
  ["rnbqk2r/ppppbppp/3n4/4p2Q/8/1BN2N2/PPPP1PPP/R1B1K2R b KQkq - b8c6", null, null],
  ["rnbqk2r/ppppbppp/3n4/4p2Q/8/1BN5/PPPP1PPP/R1B1K1NR w KQkq - g1f3", null, null],
  ["rnbqk2r/ppppbppp/4pn2/8/2PP4/6P1/PP1BPP1P/RN1QKBNR w KQkq - f1g2", null, null],
  ["rnbqk2r/ppppbppp/4pn2/8/2PP4/6P1/PP1BPPBP/RN1QK1NR b KQkq - d7d5", null, null],
  ["rnbqk2r/ppppbppp/4pn2/8/2PP4/6P1/PP2PP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqk2r/ppppbppp/4pn2/8/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - d7d5", null, null],
  ["rnbqk2r/ppppbppp/5n2/4p3/2B1P3/3P1N2/PPP2PPP/RNBQK2R b KQkq - e8g8", "C24", "Bishop's Opening: Kitchener Folly"],
  ["rnbqk2r/ppppbppp/5n2/4p3/2B1P3/3P4/PPP2PPP/RNBQK1NR w KQkq - g1f3", null, null],
  ["rnbqk2r/ppppp1bp/5np1/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR w KQkq - g1f3", "A87", "Dutch Defense: Leningrad Variation"],
  ["rnbqk2r/ppppp1bp/5np1/5p2/3P4/5NP1/PPP1PPBP/RNBQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/ppppp1bp/5np1/5p2/3P4/5NP1/PPP1PPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqk2r/ppppp2p/6pb/5P2/3P4/2N5/PPP2PPP/R2QKBNR b KQkq - e8g8", "B06", "Modern Defense: Masur Gambit"],
  ["rnbqk2r/ppppp2p/6pb/5p2/3PP3/2N5/PPP2PPP/R2QKBNR w KQkq - e4f5", null, null],
  ["rnbqk2r/ppppppbp/5np1/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R w KQkq - b1d2", null, null],
  [
    "rnbqk2r/ppppppbp/5np1/6B1/3P4/5N2/PPPNPPPP/R2QKB1R b KQkq - c7c5",
    "A48",
    "Torre Attack: Fianchetto Defense, Euwe Variation",
  ],
  ["rnbqk2r/ppppppbp/5np1/6B1/3P4/5N2/PPPNPPPP/R2QKB1R b KQkq - d7d5", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/1PP5/4P3/PB1P1PPP/RN1QKBNR b KQkq - d7d6", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/1PP5/8/PB1PPPPP/RN1QKBNR w KQkq - e2e3", null, null],
  [
    "rnbqk2r/ppppppbp/5np1/8/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - e2e4",
    "A15",
    "English Opening: Anglo-Indian Defense, Anti-Anti-Grünfeld",
  ],
  ["rnbqk2r/ppppppbp/5np1/8/2P5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2P5/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - e8g8", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2P5/5NP1/PP1PPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - e8g8", null, null],
  [
    "rnbqk2r/ppppppbp/5np1/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d7d5",
    "D90",
    "Grünfeld Defense: Three Knights Variation",
  ],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d7d6", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", "E70", "King's Indian Defense: Normal Variation"],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqk2r/ppppppbp/5np1/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b2b4",
    "E60",
    "King's Indian Defense: Santasiere Variation",
  ],
  [
    "rnbqk2r/ppppppbp/5np1/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - g2g3",
    "E60",
    "King's Indian Defense: Fianchetto Variation",
  ],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - d7d6", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/6P1/PP2PP1P/RNBQKBNR w KQkq - f1g2", null, null],
  [
    "rnbqk2r/ppppppbp/5np1/8/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - d7d5",
    "E60",
    "Grünfeld Defense: Counterthrust Variation",
  ],
  ["rnbqk2r/ppppppbp/5np1/8/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - e8g8", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - d7d6", "E70", "King's Indian Defense: Normal Variation"],
  ["rnbqk2r/ppppppbp/5np1/8/3P1B2/4PN2/PPP2PPP/RN1QKB1R b KQkq - d7d6", "A48", "London System"],
  ["rnbqk2r/ppppppbp/5np1/8/3P1B2/5N2/PPP1PPPP/RN1QKB1R w KQkq - e2e3", "A48", "London System"],
  [
    "rnbqk2r/ppppppbp/5np1/8/3P4/3BPN2/PPP2PPP/RNBQK2R b KQkq - d7d6",
    "A48",
    "Indian Defense: Colle System, King's Indian Variation",
  ],
  ["rnbqk2r/ppppppbp/5np1/8/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/3P4/5NP1/PPP1PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/3P4/5NP1/PPP1PPBP/RNBQK2R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/8/1P3NP1/P1PPPP1P/RNBQKB1R w KQkq - c1b2", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/8/1P3NP1/PBPPPP1P/RN1QKB1R b KQkq - e8g8", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/8/5NP1/PPPPPPBP/RNBQ1RK1 b kq - e8g8", null, null],
  ["rnbqk2r/ppppppbp/5np1/8/8/5NP1/PPPPPPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqkb1r/1p1p1ppp/p3pn2/8/2PNP3/2N5/PP3PPP/R1BQKB1R b KQkq - f8b4", null, null],
  ["rnbqkb1r/1p1p1ppp/p3pn2/8/2PNP3/8/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/1p1p1ppp/p3pn2/8/3NP3/3B4/PPP2PPP/RNBQ1RK1 b kq - d7d6", null, null],
  ["rnbqkb1r/1p1p1ppp/p3pn2/8/3NP3/3B4/PPP2PPP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "rnbqkb1r/1p2pppp/p1p2n2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - c8f5",
    "D15",
    "Slav Defense: Chebanenko Variation",
  ],
  [
    "rnbqkb1r/1p2pppp/p1p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c4c5",
    "D15",
    "Slav Defense: Chebanenko Variation, Advance System",
  ],
  ["rnbqkb1r/1p2pppp/p1p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/1p2pppp/p2p1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R b KQkq - b8d7", null, null],
  ["rnbqkb1r/1p2pppp/p2p1n2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R b KQkq - e7e6", "B95", "Sicilian Defense: Najdorf Variation"],
  ["rnbqkb1r/1p2pppp/p2p1n2/8/2BNP3/2N5/PPP2PPP/R1BQK2R b KQkq - e7e6", null, null],
  ["rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N1B3/PPP2PPP/R2QKB1R b KQkq - e7e6", null, null],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N1B3/PPP2PPP/R2QKB1R b KQkq - f6g4",
    "B90",
    "Sicilian Defense: Najdorf Variation, English Attack, Anti-English",
  ],
  ["rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - e7e5", null, null],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - e7e6",
    "B84",
    "Sicilian Defense: Scheveningen Variation, Classical Variation",
  ],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - c1e3",
    "B90",
    "Sicilian Defense: Najdorf Variation, English Attack",
  ],
  ["rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - c1g5", "B94", "Sicilian Defense: Najdorf Variation"],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1c4",
    "B90",
    "Sicilian Defense: Najdorf Variation, Lipnitsky Attack",
  ],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1e2",
    "B92",
    "Sicilian Defense: Najdorf Variation, Opocensky Variation",
  ],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f2f4",
    "B93",
    "Sicilian Defense: Najdorf Variation, Amsterdam Variation",
  ],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - g2g3",
    "B91",
    "Sicilian Defense: Najdorf Variation, Zagreb Variation",
  ],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - g2g4",
    "B90",
    "Sicilian Defense: Najdorf Variation, Dekker Gambit",
  ],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - h1g1",
    "B90",
    "Sicilian Defense: Najdorf Variation, Freak Attack",
  ],
  [
    "rnbqkb1r/1p2pppp/p2p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - h2h3",
    "B90",
    "Sicilian Defense: Najdorf Variation, Adams Attack",
  ],
  ["rnbqkb1r/1p2pppp/p2p1n2/8/3NPP2/2N5/PPP3PP/R1BQKB1R b KQkq - e7e6", null, null],
  [
    "rnbqkb1r/1p3p1p/p2p1np1/4pN2/4P1P1/2N1B3/PPP2P1P/R2QKB1R w KQkq - g4g5",
    "B90",
    "Sicilian Defense: Scheveningen Variation, Delayed Keres Attack, Perenyi Gambit",
  ],
  ["rnbqkb1r/1p3ppp/p2p1n2/4p3/3NP1P1/2N1B3/PPP2P1P/R2QKB1R w KQkq - d4f5", null, null],
  ["rnbqkb1r/1p3ppp/p2p1n2/4p3/3NP3/2N5/PPP1BPPP/R1BQK2R w KQkq - d4b3", null, null],
  ["rnbqkb1r/1p3ppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQK2R b KQkq - c8e6", null, null],
  ["rnbqkb1r/1p3ppp/p2p1n2/4p3/4P3/1NN5/PPP1BPPP/R1BQK2R b KQkq - f8e7", null, null],
  ["rnbqkb1r/1p3ppp/p2p1n2/4pN2/4P1P1/2N1B3/PPP2P1P/R2QKB1R b KQkq - g7g6", null, null],
  ["rnbqkb1r/1p3ppp/p2ppn2/6B1/3NP3/2N5/PPP2PPP/R2QKB1R w KQkq - f2f4", "B96", "Sicilian Defense: Najdorf Variation"],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R b KQkq - b7b5",
    "B96",
    "Sicilian Defense: Najdorf Variation, Polugaevsky Variation",
  ],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R b KQkq - b8c6",
    "B96",
    "Sicilian Defense: Najdorf Variation, Neo-Classical Defense",
  ],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R b KQkq - d8b6",
    "B97",
    "Sicilian Defense: Najdorf Variation, Poisoned Pawn Variation",
  ],
  ["rnbqkb1r/1p3ppp/p2ppn2/6B1/3NPP2/2N5/PPP3PP/R2QKB1R b KQkq - f8e7", "B98", "Sicilian Defense: Najdorf Variation"],
  ["rnbqkb1r/1p3ppp/p2ppn2/8/2BNP3/2N5/PPP2PPP/R1BQK2R w KQkq - c4b3", null, null],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/8/2PNP3/3B4/PP3PPP/RNBQ1RK1 b kq - g7g6",
    "B42",
    "Sicilian Defense: Kan Variation, Gipslis Variation",
  ],
  ["rnbqkb1r/1p3ppp/p2ppn2/8/3NP1P1/2N1B3/PPP2P1P/R2QKB1R b KQkq - e6e5", null, null],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/1BN5/PPP2PPP/R1BQK2R b KQkq - b7b5",
    "B87",
    "Sicilian Defense: Sozin Attack, Flank Variation",
  ],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - d1d2",
    "B80",
    "Sicilian Defense: Scheveningen Variation, English Attack, with Qd2",
  ],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - f2f3",
    "B90",
    "Sicilian Defense: Scheveningen Variation, English Attack, with f3",
  ],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N1B3/PPP2PPP/R2QKB1R w KQkq - g2g4",
    "B90",
    "Sicilian Defense: Scheveningen Variation, Delayed Keres Attack",
  ],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 b kq - b8d7",
    "B84",
    "Sicilian Defense: Najdorf Variation, Scheveningen Variation",
  ],
  [
    "rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N5/PPP1BPPP/R1BQ1RK1 b kq - d8c7",
    "B84",
    "Sicilian Defense: Scheveningen Variation, Classical Variation",
  ],
  ["rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/2N5/PPP1BPPP/R1BQK2R w KQkq - e1g1", null, null],
  ["rnbqkb1r/1p3ppp/p2ppn2/8/3NP3/3B4/PPP2PPP/RNBQ1RK1 w kq - c2c4", null, null],
  ["rnbqkb1r/1p3ppp/p2ppn2/8/3NPP2/2N5/PPP1B1PP/R1BQK2R b KQkq - d8c7", null, null],
  ["rnbqkb1r/1p3ppp/p2ppn2/8/3NPP2/2N5/PPP3PP/R1BQKB1R w KQkq - f1e2", null, null],
  ["rnbqkb1r/1p3ppp/p3pn2/2P5/2B5/4PN2/PP2QPPP/RNB1K2R b KQkq - f8c5", null, null],
  [
    "rnbqkb1r/1p3ppp/p3pn2/2P5/2B5/4PN2/PP3PPP/RNBQ1RK1 b kq - f8c5",
    "D27",
    "Queen's Gambit Accepted: Furman Variation",
  ],
  ["rnbqkb1r/1p3ppp/p3pn2/2p5/2BP4/4PN2/PP2QPPP/RNB1K2R w KQkq - d4c5", null, null],
  [
    "rnbqkb1r/1p3ppp/p3pn2/2p5/2BP4/4PN2/PP2QPPP/RNB2RK1 b kq - b7b5",
    "D28",
    "Queen's Gambit Accepted: Classical Defense, Alekhine System",
  ],
  [
    "rnbqkb1r/1p3ppp/p3pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1 w kq - a2a4",
    "D27",
    "Queen's Gambit Accepted: Classical Defense, Rubinstein Variation",
  ],
  [
    "rnbqkb1r/1p3ppp/p3pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1 w kq - d1e2",
    "D28",
    "Queen's Gambit Accepted: Classical Defense, Alekhine System",
  ],
  ["rnbqkb1r/1p3ppp/p3pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1 w kq - d4c5", null, null],
  [
    "rnbqkb1r/1p3ppp/p3pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1 w kq - e3e4",
    "D27",
    "Queen's Gambit Accepted: Classical Defense, Russian Gambit",
  ],
  [
    "rnbqkb1r/1p3ppp/p4n2/1N1pp1B1/2P5/2N5/PP2PPPP/R2QKB1R w KQkq - d1a4",
    "D50",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Krause Variation",
  ],
  [
    "rnbqkb1r/1pp1pppp/p4n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e4",
    "D24",
    "Queen's Gambit Accepted: Bogoljubow Defense",
  ],
  ["rnbqkb1r/1pp2ppp/p3pn2/3p4/3PP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - e4e5", null, null],
  ["rnbqkb1r/1pp2ppp/p3pn2/3pP3/3P4/2N2N2/PPP2PPP/R1BQKB1R b KQkq - f6d7", "C11", "French Defense: Steinitz Variation"],
  ["rnbqkb1r/1ppn1ppp/p3p3/3pP3/3P4/2N2N2/PPP2PPP/R1BQKB1R w KQkq - a2a3", "C11", "French Defense: Steinitz Variation"],
  [
    "rnbqkb1r/1ppn1ppp/p3p3/3pP3/3P4/2N2N2/PPP2PPP/R1BQKB1R w KQkq - c1g5",
    "C14",
    "French Defense: Classical Variation",
  ],
  ["rnbqkb1r/1ppn1ppp/p3p3/3pP3/3P4/2N2N2/PPP2PPP/R1BQKB1R w KQkq - c3e2", "C11", "French Defense: Steinitz Variation"],
  ["rnbqkb1r/1ppp1ppp/4pn2/1P6/8/8/1BPPPPPP/RN1QKBNR b KQkq - a8a1", null, null],
  ["rnbqkb1r/1ppp1ppp/4pn2/1p6/P7/8/1BPPPPPP/RN1QKBNR w KQkq - a4b5", null, null],
  ["rnbqkb1r/1ppp1ppp/p3pn2/1P6/8/8/PBPPPPPP/RN1QKBNR w KQkq - a2a4", null, null],
  ["rnbqkb1r/1ppp1ppp/p3pn2/1P6/P7/8/1BPPPPPP/RN1QKBNR b KQkq - a6b5", null, null],
  ["rnbqkb1r/1ppp1ppp/p3pn2/8/2P5/5NP1/PP1PPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkb1r/1ppp1ppp/p3pn2/8/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - b7b5", "A13", "English Opening: Romanishin Gambit"],
  ["rnbqkb1r/3ppp1p/P4np1/2pP4/8/2N5/PP2PPPP/R1BQKBNR b KQkq - c8a6", null, null],
  ["rnbqkb1r/3ppp1p/P4np1/2pP4/8/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/3ppppp/5n2/1NpP4/1p2P3/8/PP3PPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqkb1r/3ppppp/5n2/1ppP4/4P3/2N5/PP3PPP/R1BQKBNR b KQkq - b5b4", null, null],
  ["rnbqkb1r/3ppppp/5n2/1ppP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  [
    "rnbqkb1r/3ppppp/5n2/2pP4/1p2P3/2N5/PP3PPP/R1BQKBNR w KQkq - c3b5",
    "A57",
    "Benko Gambit: Zaitsev Variation, Nescafe Frappe Attack",
  ],
  ["rnbqkb1r/3ppppp/p4n2/1PpP4/8/2N5/PP2PPPP/R1BQKBNR b KQkq - a6b5", null, null],
  ["rnbqkb1r/3ppppp/p4n2/1PpP4/8/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", "A57", "Benko Gambit: Zaitsev System"],
  [
    "rnbqkb1r/3ppppp/p4n2/1PpP4/8/8/PP2PPPP/RNBQKBNR w KQkq - b5a6",
    "A58",
    "Benko Gambit Accepted: Fully Accepted Variation",
  ],
  [
    "rnbqkb1r/3ppppp/p4n2/1PpP4/8/8/PP2PPPP/RNBQKBNR w KQkq - b5b6",
    "A57",
    "Benko Gambit Accepted: Pawn Return Variation",
  ],
  ["rnbqkb1r/3ppppp/p4n2/1PpP4/8/8/PP2PPPP/RNBQKBNR w KQkq - e2e3", "A57", "Benko Gambit Accepted: Modern Variation"],
  ["rnbqkb1r/3ppppp/p4n2/1PpP4/8/8/PP2PPPP/RNBQKBNR w KQkq - f2f3", "A57", "Benko Gambit Accepted: Dlugy Variation"],
  ["rnbqkb1r/3ppppp/P4n2/2pP4/8/8/PP2PPPP/RNBQKBNR b KQkq - c8a6", null, null],
  ["rnbqkb1r/3ppppp/P4n2/2pP4/8/8/PP2PPPP/RNBQKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/4pppp/3p1n2/1NpP4/1p2P3/8/PP3PPP/R1BQKBNR w KQkq - f1c4", "A57", "Benko Gambit: Nescafe Frappe Attack"],
  ["rnbqkb1r/5ppp/p2ppn2/1p2P1B1/3N1P2/2N5/PPP3PP/R2QKB1R b KQkq - d6e5", null, null],
  ["rnbqkb1r/5ppp/p2ppn2/1p4B1/3NPP2/2N5/PPP3PP/R2QKB1R w KQkq - e4e5", null, null],
  ["rnbqkb1r/5ppp/p3pn2/1p2p1B1/3N1P2/2N5/PPP3PP/R2QKB1R w KQkq - f4e5", null, null],
  ["rnbqkb1r/5ppp/p3pn2/1p2P1B1/3N4/2N5/PPP3PP/R2QKB1R b KQkq - d8c7", null, null],
  ["rnbqkb1r/5ppp/p3pn2/1pp5/2BP4/4PN2/PP2QPPP/RNB2RK1 w kq - c4b3", null, null],
  ["rnbqkb1r/5ppp/p3pn2/1pp5/3P4/1B2PN2/PP2QPPP/RNB2RK1 b kq - b8c6", null, null],
  [
    "rnbqkb1r/5ppp/p3pn2/1pp5/3P4/1B2PN2/PP2QPPP/RNB2RK1 b kq - c8b7",
    "D29",
    "Queen's Gambit Accepted: Classical Defense, Alekhine System, Main Line",
  ],
  ["rnbqkb1r/p1p2ppp/1p2pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - c8b7", "E14", "Queen's Indian Defense, with e3"],
  ["rnbqkb1r/p1p2ppp/1p2pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - f8d6", null, null],
  ["rnbqkb1r/p1p2ppp/1p2pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c4d5", null, null],
  ["rnbqkb1r/p1p2ppp/1p2pn2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/p1p2ppp/1p2pn2/3P4/3P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e6d5", null, null],
  ["rnbqkb1r/p1p2ppp/1p3n2/3p2B1/3P4/2N2N2/PP2PPPP/R2QKB1R b KQkq - f8e7", null, null],
  ["rnbqkb1r/p1p2ppp/1p3n2/3p4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5", null, null],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/2P1P3/2N2N2/PP1P1PPP/R1BQKB1R b KQkq - c8b7", null, null],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - e2e4", null, null],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/2P5/5NP1/PP1PPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - c8b7",
    "A15",
    "English Opening: Anglo-Indian Defense, Queen's Indian Formation",
  ],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - c8b7", null, null],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d7d5", null, null],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - f8b4", null, null],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/4PN2/PP3PPP/RNBQKB1R b KQkq - c8b7",
    "E14",
    "Queen's Indian Defense: Spassky System",
  ],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - a2a3",
    "E12",
    "Queen's Indian Defense: Petrosian Variation",
  ],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3",
    "E12",
    "Queen's Indian Defense: Kasparov Variation",
  ],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - c1f4",
    "E12",
    "Queen's Indian Defense: Miles Variation",
  ],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e3",
    "E14",
    "Queen's Indian Defense: Spassky System",
  ],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - g2g3",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation",
  ],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - c8a6",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Nimzowitsch Variation",
  ],
  [
    "rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - c8b7",
    "E15",
    "Queen's Indian Defense: Fianchetto Variation, Traditional Line",
  ],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/P4N2/1P2PPPP/RNBQKB1R b KQkq - c8a6", null, null],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/2PP4/P4N2/1P2PPPP/RNBQKB1R b KQkq - c8b7", null, null],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/3P4/3BPN2/PPP2PPP/RNBQK2R b KQkq - c8b7", null, null],
  ["rnbqkb1r/p1pp1ppp/1p2pn2/8/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  ["rnbqkb1r/p1pppp1p/1p3np1/8/2P5/5NP1/PP1PPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  [
    "rnbqkb1r/p1pppp1p/1p3np1/8/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - c8b7",
    "A15",
    "English Opening: Anglo-Indian Defense, King's Indian Formation, Double Fianchetto",
  ],
  ["rnbqkb1r/p1pppppp/1p3n2/8/3P4/2P2N2/PP2PPPP/RNBQKB1R b KQkq - e7e5", "A47", "Indian Defense: Schnepper Gambit"],
  ["rnbqkb1r/p1pppppp/1p3n2/8/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - c8b7", null, null],
  ["rnbqkb1r/p1pppppp/1p3n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c2c3", null, null],
  ["rnbqkb1r/p1pppppp/1p3n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/p1pppppp/1p3n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/p1pppppp/1p3n2/8/3P4/5NP1/PPP1PP1P/RNBQKB1R b KQkq - c8b7", null, null],
  [
    "rnbqkb1r/p2p1ppp/1p2pn2/2p3B1/3P4/4PN2/PPP2PPP/RN1QKB1R w KQkq - d4d5",
    "A46",
    "Torre Attack: Classical Defense, Petrosian Gambit",
  ],
  ["rnbqkb1r/p2p1ppp/1p2pn2/2p5/2P5/2N2NP1/PP1PPP1P/R1BQKB1R w KQkq - f1g2", null, null],
  ["rnbqkb1r/p2p1ppp/1p2pn2/2p5/2P5/2N2NP1/PP1PPPBP/R1BQK2R b KQkq - c8b7", null, null],
  ["rnbqkb1r/p2p1ppp/4Pn2/1pp5/2P5/5N2/PP2PPPP/RNBQKB1R b KQkq - f7e6", null, null],
  ["rnbqkb1r/p2p1ppp/4pn2/1ppP2B1/2P5/5N2/PP2PPPP/RN1QKB1R b KQkq - e6d5", null, null],
  [
    "rnbqkb1r/p2p1ppp/4pn2/1ppP4/2P5/5N2/PP2PPPP/RNBQKB1R w KQkq - c1g5",
    "E10",
    "Blumenfeld Countergambit: Duz-Khotimirsky Variation",
  ],
  ["rnbqkb1r/p2p1ppp/4pn2/1ppP4/2P5/5N2/PP2PPPP/RNBQKB1R w KQkq - d5e6", null, null],
  ["rnbqkb1r/p2p1ppp/5n2/1ppp2B1/2P5/5N2/PP2PPPP/RN1QKB1R w KQkq - c4d5", null, null],
  [
    "rnbqkb1r/p2p1ppp/5n2/1ppP2B1/8/5N2/PP2PPPP/RN1QKB1R b KQkq - h7h6",
    "E10",
    "Blumenfeld Countergambit: Spielmann Variation",
  ],
  ["rnbqkb1r/p2p2pp/4pn2/1pp5/2P5/5N2/PP2PPPP/RNBQKB1R w KQkq - c4b5", null, null],
  ["rnbqkb1r/p2p2pp/4pn2/1Pp5/8/5N2/PP2PPPP/RNBQKB1R b KQkq - d7d5", "E10", "Blumenfeld Countergambit Accepted"],
  [
    "rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - a2a4",
    "A57",
    "Benko Gambit Declined: Sosonko Variation",
  ],
  ["rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - b1d2", "A57", "Benko Gambit Declined: Quiet Line"],
  ["rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - c1g5", "A57", "Benko Gambit Declined: Bishop Attack"],
  ["rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - c4b5", null, null],
  [
    "rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - e2e4",
    "A57",
    "Benko Gambit Declined: Hjørring Countergambit",
  ],
  ["rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - f2f3", "A57", "Benko Gambit Declined: Pseudo-Sämisch"],
  ["rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", "A57", "Benko Gambit Declined: Main Line"],
  ["rnbqkb1r/p2ppppp/5n2/1ppP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - g2g4", "A57", "Benko Gambit: Mutkin Countergambit"],
  ["rnbqkb1r/p2ppppp/5n2/1PpP4/8/8/PP2PPPP/RNBQKBNR b KQkq - a7a6", "A57", "Benko Gambit Accepted"],
  ["rnbqkb1r/p3pppp/2p2n2/1p6/2pPP3/2N2N2/PP3PPP/R1BQKB1R w KQkq - e4e5", "D15", "Slav Defense: Geller Gambit"],
  [
    "rnbqkb1r/p4p2/2p1pn1p/1p2P1N1/2pP3B/2N5/PP3PPP/R2QKB1R b KQkq - f6d5",
    "D44",
    "Semi-Slav Defense: Botvinnik Variation, Alatortsev System",
  ],
  ["rnbqkb1r/p4p2/2p1pn1p/1p2P1N1/2pP3B/2N5/PP3PPP/R2QKB1R b KQkq - h6g5", null, null],
  ["rnbqkb1r/p4p2/2p1pn1p/1p2P1p1/2pP3B/2N2N2/PP3PPP/R2QKB1R w KQkq - e5f6", null, null],
  [
    "rnbqkb1r/p4p2/2p1pn1p/1p2P1p1/2pP3B/2N2N2/PP3PPP/R2QKB1R w KQkq - f3g5",
    "D44",
    "Semi-Slav Defense: Botvinnik Variation",
  ],
  ["rnbqkb1r/p4p2/2p1pn2/1p2P1B1/2pP4/2N5/PP3PPP/R2QKB1R b KQkq - b8d7", null, null],
  ["rnbqkb1r/p4p2/2p1pn2/1p2P1p1/2pP3B/2N5/PP3PPP/R2QKB1R w KQkq - h4g5", null, null],
  ["rnbqkb1r/p4p2/2p1pP1p/1p4p1/2pP3B/2N2N2/PP3PPP/R2QKB1R b KQkq - g5h4", null, null],
  [
    "rnbqkb1r/p4p2/2p1pP1p/1p6/2pP3p/2N2N2/PP3PPP/R2QKB1R w KQkq - f3e5",
    "D44",
    "Semi-Slav Defense: Botvinnik Variation, Ekstrom Variation",
  ],
  ["rnbqkb1r/p4pp1/2p1pn1p/1p2P1B1/2pP4/2N2N2/PP3PPP/R2QKB1R w KQkq - g5h4", null, null],
  ["rnbqkb1r/p4pp1/2p1pn1p/1p2P3/2pP3B/2N2N2/PP3PPP/R2QKB1R b KQkq - g7g5", null, null],
  ["rnbqkb1r/p4ppp/2p1pn2/1p2P1B1/2pP4/2N2N2/PP3PPP/R2QKB1R b KQkq - h7h6", null, null],
  ["rnbqkb1r/p4ppp/2p1pn2/1p4B1/2pPP3/2N2N2/PP3PPP/R2QKB1R w KQkq - e4e5", null, null],
  ["rnbqkb1r/p4ppp/2p2n2/1B6/5p2/5N2/PPPP2PP/RNBQK2R w KQkq - b5c4", null, null],
  [
    "rnbqkb1r/p4ppp/2p2n2/8/2B2p2/5N2/PPPP2PP/RNBQK2R b KQkq - f6d5",
    "C36",
    "King's Gambit Accepted: Abbazia Defense, Main Line",
  ],
  ["rnbqkb1r/pp1n1ppp/4p3/2ppP3/3P1P2/2N2N2/PPP3PP/R1BQKB1R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pp1n1ppp/4p3/2ppP3/3P1P2/2N5/PPP3PP/R1BQKBNR w KQkq - d4c5", null, null],
  ["rnbqkb1r/pp1n1ppp/4p3/2ppP3/3P1P2/2N5/PPP3PP/R1BQKBNR w KQkq - g1f3", "C11", "French Defense: Steinitz Variation"],
  [
    "rnbqkb1r/pp1n1ppp/4p3/2ppP3/3P4/2PB4/PP1N1PPP/R1BQK1NR b KQkq - b7b6",
    "C05",
    "French Defense: Tarrasch Variation, Botvinnik Variation",
  ],
  [
    "rnbqkb1r/pp1n1ppp/4p3/2ppP3/3P4/2PB4/PP1N1PPP/R1BQK1NR b KQkq - b8c6",
    "C05",
    "French Defense: Tarrasch Variation, Closed Variation",
  ],
  ["rnbqkb1r/pp1n1ppp/4p3/2ppP3/3P4/3B4/PPPN1PPP/R1BQK1NR w KQkq - c2c3", null, null],
  ["rnbqkb1r/pp1n1ppp/4p3/2PpP3/5P2/2N5/PPP3PP/R1BQKBNR b KQkq - b8c6", "C11", "French Defense: Steinitz Variation"],
  ["rnbqkb1r/pp1n1ppp/4p3/2PpP3/5P2/2N5/PPP3PP/R1BQKBNR b KQkq - f8c5", null, null],
  [
    "rnbqkb1r/pp1npppp/2p5/3pP3/3P4/3B4/PPP2PPP/RNBQK1NR w KQkq - e5e6",
    "B12",
    "Caro-Kann Defense: Mieses Attack, Landau Gambit",
  ],
  [
    "rnbqkb1r/pp1p1ppp/4p3/2pnP3/3P4/2P2N2/PP3PPP/RNBQKB1R b KQkq - b8c6",
    "B40",
    "Sicilian Defense: Alapin Variation, Sherzer Variation",
  ],
  ["rnbqkb1r/pp1p1ppp/4p3/2pnP3/8/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - c3d5", null, null],
  ["rnbqkb1r/pp1p1ppp/4p3/2pnP3/8/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkb1r/pp1p1ppp/4p3/2pNP3/8/5N2/PPPP1PPP/R1BQKB1R b KQkq - e6d5", null, null],
  [
    "rnbqkb1r/pp1p1ppp/4pn2/2p1P3/2P5/2N5/PP1P1PPP/R1BQKBNR b KQkq - f6g8",
    "A19",
    "English Opening: Anglo-Indian Defense, Flohr-Mikenas-Carls Variation, Nei Gambit",
  ],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p1P3/8/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - f6d5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p3B1/3P4/4PN2/PPP2PPP/RN1QKB1R b KQkq - b7b6", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p3B1/3P4/5N2/PPP1PPPP/RN1QKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p3B1/3P4/5N2/PPP1PPPP/RN1QKB1R w KQkq - e2e4", "A46", "Torre Attack: Wagner Gambit"],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2P1P3/2N5/PP1P1PPP/R1BQKBNR w KQkq - e4e5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - d2d4", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2P5/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - b7b6", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - c5d4", null, null],
  [
    "rnbqkb1r/pp1p1ppp/4pn2/2p5/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d7d5",
    "D40",
    "Queen's Gambit Declined: Semi-Tarrasch Defense",
  ],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - d4d5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/2PP4/6P1/PP2PP1P/RNBQKBNR w KQkq - d4d5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/3P4/3BPN2/PPP2PPP/RNBQK2R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - e4e5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2pP4/2P5/2N5/PP2PPPP/R1BQKBNR b KQkq - e6d5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2pP4/2P5/5N2/PP2PPPP/RNBQKB1R b KQkq - b7b5", "E10", "Blumenfeld Countergambit"],
  ["rnbqkb1r/pp1p1ppp/4pn2/2pP4/2P5/5N2/PP2PPPP/RNBQKB1R b KQkq - e6d5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2pP4/2P5/6P1/PP2PP1P/RNBQKBNR b KQkq - e6d5", null, null],
  ["rnbqkb1r/pp1p1ppp/4pn2/2pP4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/pp1p1ppp/4pn2/8/2PN4/2N5/PP2PPPP/R1BQKB1R b KQkq - b8c6",
    "A33",
    "English Opening: Symmetrical Variation, Anti-Benoni Variation, Spielmann Defense",
  ],
  ["rnbqkb1r/pp1p1ppp/4pn2/8/2Pp4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - f3d4", null, null],
  [
    "rnbqkb1r/pp1p1ppp/4pn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - d7d6",
    "B80",
    "Sicilian Defense: Scheveningen Variation",
  ],
  ["rnbqkb1r/pp1p1ppp/4pn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - d8b6", "B40", "Sicilian Defense: Gaw-Paw Variation"],
  ["rnbqkb1r/pp1p1ppp/4pn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - f8b4", "B40", "Sicilian Defense: Pin Variation"],
  ["rnbqkb1r/pp1p1ppp/4pn2/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/pp1p1ppp/5n2/2pp4/2P5/2N5/PP2PPPP/R1BQKBNR w KQkq - c4d5", null, null],
  ["rnbqkb1r/pp1p1ppp/5n2/2pp4/2P5/5N2/PP2PPPP/RNBQKB1R w KQkq - c4d5", null, null],
  ["rnbqkb1r/pp1p1ppp/5n2/2pp4/2P5/6P1/PP2PP1P/RNBQKBNR w KQkq - c4d5", null, null],
  ["rnbqkb1r/pp1p1ppp/5n2/2pP4/8/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d6", null, null],
  [
    "rnbqkb1r/pp1p1ppp/5n2/2pP4/8/2N5/PP2PPPP/R1BQKBNR b KQkq - f8d6",
    "A60",
    "Benoni Defense: Modern Variation, Snake Variation",
  ],
  ["rnbqkb1r/pp1p1ppp/5n2/2pP4/8/5N2/PP2PPPP/RNBQKB1R b KQkq - d7d6", null, null],
  ["rnbqkb1r/pp1p1ppp/5n2/2pP4/8/6P1/PP2PP1P/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqkb1r/pp1p1ppp/5n2/2pPp3/2P5/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqkb1r/pp1p1ppp/5n2/2pPp3/2P5/8/PP2PPPP/RNBQKBNR w KQkq e6 b1c3", null, null],
  [
    "rnbqkb1r/pp1p1ppp/8/2ppP3/3P4/5N2/PPP2PPP/R1BQKB1R b KQkq - b8c6",
    "B29",
    "Sicilian Defense: Nimzowitsch Variation, Main Line",
  ],
  ["rnbqkb1r/pp1p1ppp/8/2ppP3/8/5N2/PPPP1PPP/R1BQKB1R w KQkq - d2d4", null, null],
  ["rnbqkb1r/pp1p2pp/2p1pn2/5p2/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkb1r/pp1p2pp/2p1pn2/5p2/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pp1ppp1p/5np1/2p5/2PP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp1ppp1p/5np1/2p5/2PP4/4P3/PP3PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/pp1ppp1p/5np1/2p5/2PP4/5P2/PP2P1PP/RNBQKBNR w KQkq - d4d5", null, null],
  ["rnbqkb1r/pp1ppp1p/5np1/2pP4/2P5/5P2/PP2P1PP/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqkb1r/pp1ppp1p/5np1/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - d7d6", "B70", "Sicilian Defense: Dragon Variation"],
  ["rnbqkb1r/pp1ppp1p/5np1/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/pp1ppppp/1n6/2p1P3/8/1B6/PPPP1PPP/RNBQK1NR w KQkq - d2d3", "B02", "Alekhine Defense: Kmoch Variation"],
  ["rnbqkb1r/pp1ppppp/2p2n2/8/2P5/1P3N2/P2PPPPP/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pp1ppppp/2p2n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b2b3", null, null],
  ["rnbqkb1r/pp1ppppp/2p2n2/8/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pp1ppppp/2p2n2/8/2P5/6P1/PP1PPP1P/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pp1ppppp/2p2n2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - b7b5", "A40", "Slav Indian: Kudischewitsch Gambit"],
  ["rnbqkb1r/pp1ppppp/2p2n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rnbqkb1r/pp1ppppp/2p5/8/3Pn2B/8/PPP1PPPP/RN1QKBNR w KQkq - b1d2", null, null],
  ["rnbqkb1r/pp1ppppp/2p5/8/3Pn2B/8/PPPNPPPP/R2QKBNR b KQkq - d8a5", null, null],
  ["rnbqkb1r/pp1ppppp/5n2/2p1P3/8/2P5/PP1P1PPP/RNBQKBNR b KQkq - f6d5", null, null],
  ["rnbqkb1r/pp1ppppp/5n2/2p1P3/8/5N2/PPPP1PPP/RNBQKB1R b KQkq - f6d5", null, null],
  ["rnbqkb1r/pp1ppppp/5n2/2p3B1/3P4/8/PPP1PPPP/RN1QKBNR w KQkq - d4d5", null, null],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - b8c6",
    "A35",
    "English Opening: Symmetrical Variation, Four Knights Variation",
  ],
  ["rnbqkb1r/pp1ppppp/5n2/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - d7d5", null, null],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - e7e5",
    "A35",
    "English Opening: Symmetrical Variation",
  ],
  ["rnbqkb1r/pp1ppppp/5n2/2p5/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - d7d5", null, null],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g1f3",
    "A34",
    "English Opening: Symmetrical Variation, Three Knights Variation",
  ],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g2g3",
    "A34",
    "English Opening: Symmetrical Variation, Fianchetto Variation",
  ],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b1c3",
    "A34",
    "English Opening: Symmetrical Variation, Three Knights Variation",
  ],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b2b4",
    "A30",
    "English Opening: Symmetrical Variation, Napolitano Gambit",
  ],
  ["rnbqkb1r/pp1ppppp/5n2/2P5/2P5/8/PP2PPPP/RNBQKBNR b KQkq - e7e6", "A56", "Benoni Defense: Weenink Variation"],
  ["rnbqkb1r/pp1ppppp/5n2/2p5/2PP4/4P3/PP3PPP/RNBQKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/pp1ppppp/5n2/2p5/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4c5", null, null],
  ["rnbqkb1r/pp1ppppp/5n2/2p5/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4d5", null, null],
  ["rnbqkb1r/pp1ppppp/5n2/2p5/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - e2e3", null, null],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3",
    "A31",
    "English Opening: Symmetrical Variation, Anti-Benoni Variation",
  ],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - d4d5",
    "A43",
    "Benoni Defense: Benoni-Indian Defense, Kingside Move Order",
  ],
  ["rnbqkb1r/pp1ppppp/5n2/2p5/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - d7d6", null, null],
  ["rnbqkb1r/pp1ppppp/5n2/2p5/4P3/2P5/PP1P1PPP/RNBQKBNR w KQkq - e4e5", null, null],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3",
    "B29",
    "Sicilian Defense: Nimzowitsch Variation, Closed Variation",
  ],
  [
    "rnbqkb1r/pp1ppppp/5n2/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - e4e5",
    "B29",
    "Sicilian Defense: Nimzowitsch Variation, Advance Variation",
  ],
  ["rnbqkb1r/pp1ppppp/5n2/2pP2B1/8/8/PPP1PPPP/RN1QKBNR b KQkq - d8b6", null, null],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - b7b5", "A57", "Benko Gambit"],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - d7d6", "A56", "Benoni Defense: Hromádka System"],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - e7e5", "A56", "Benoni Defense: Czech Benoni Defense"],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - e7e6", "A60", "Benoni Defense: Modern Variation"],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - f6e4", "A56", "Vulture Defense"],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/8/2N5/PPP1PPPP/R1BQKBNR b KQkq - d8a5", "A43", "Benoni Defense: Woozle"],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/8/5N2/PPP1PPPP/RNBQKB1R b KQkq - b7b5", "A43", "Indian Defense: Pseudo-Benko"],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/8/5N2/PPP1PPPP/RNBQKB1R b KQkq - c5c4", "A43", "Benoni Defense: Hawk Variation"],
  ["rnbqkb1r/pp1ppppp/5n2/2pP4/8/8/PPP1PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/pp1ppppp/5n2/2pP4/8/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3",
    "A43",
    "Benoni Defense: Benoni-Indian Defense, Kingside Move Order",
  ],
  [
    "rnbqkb1r/pp1ppppp/8/2pnP3/3P4/2P5/PP3PPP/RNBQKBNR b KQkq - c5d4",
    "B22",
    "Sicilian Defense: Alapin Variation, Smith-Morra Declined",
  ],
  [
    "rnbqkb1r/pp1ppppp/8/2pnP3/8/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - d5c3",
    "B29",
    "Sicilian Defense: Nimzowitsch Variation, Exchange Variation",
  ],
  ["rnbqkb1r/pp1ppppp/8/2pnP3/8/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - e7e6", null, null],
  ["rnbqkb1r/pp1ppppp/8/2pnP3/8/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pp1ppppp/8/2pnP3/8/2P5/PP1P1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkb1r/pp1ppppp/8/2pnP3/8/2P5/PP1P1PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pp1ppppp/8/2pnP3/8/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/pp2p1pp/2pp1n2/5p2/2PP4/2N3P1/PP2PPBP/R1BQK1NR b KQkq - d8c7",
    "A86",
    "Dutch Defense: Hort-Antoshin System",
  ],
  ["rnbqkb1r/pp2p1pp/2pp1n2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/pp2p1pp/5n2/2p2p2/3p1P2/5N2/PPPPPNPP/R1BQKB1R w KQkq - b2b4",
    "A00",
    "Van Geet Opening: Jendrossek Gambit",
  ],
  ["rnbqkb1r/pp2pp1p/1n1p2p1/8/2PP4/2N1B3/PP3PPP/R2QKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp2pp1p/1n1p2p1/8/2PP4/2N4P/PP3PP1/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp2pp1p/1n1p2p1/8/2PP4/2N5/PP3PPP/R1BQKBNR w KQkq - c1e3", null, null],
  ["rnbqkb1r/pp2pp1p/1n1p2p1/8/2PP4/2N5/PP3PPP/R1BQKBNR w KQkq - h2h3", null, null],
  ["rnbqkb1r/pp2pp1p/2p2np1/3p4/2PP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pp2pp1p/2p2np1/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp2pp1p/2pp1np1/8/3PP3/2N1B3/PPP2PPP/R2QKBNR w KQkq - d1d2", "B07", "Pirc Defense: 150 Attack"],
  [
    "rnbqkb1r/pp2pp1p/2pp1np1/8/3PP3/2N1B3/PPP2PPP/R2QKBNR w KQkq - h2h3",
    "B07",
    "Pirc Defense: 150 Attack, Sveshnikov-Jansa Attack",
  ],
  [
    "rnbqkb1r/pp2pp1p/2pp1np1/8/3PP3/2N1B3/PPPQ1PPP/R3KBNR b KQkq - c8g4",
    "B07",
    "Pirc Defense: 150 Attack, Inner Doll Defense",
  ],
  ["rnbqkb1r/pp2pp1p/3p1np1/2pP4/2P1P3/5P2/PP4PP/RNBQKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp2pp1p/3p1np1/2pP4/2P5/5P2/PP2P1PP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N1B3/PPP2PPP/R2QKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - c1e3", "B72", "Sicilian Defense: Dragon Variation"],
  [
    "rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1e2",
    "B70",
    "Sicilian Defense: Dragon Variation, Classical Variation",
  ],
  [
    "rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f2f4",
    "B71",
    "Sicilian Defense: Dragon Variation, Levenfish Variation",
  ],
  [
    "rnbqkb1r/pp2pp1p/3p1np1/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - g2g3",
    "B70",
    "Sicilian Defense: Dragon Variation, Fianchetto Variation",
  ],
  [
    "rnbqkb1r/pp2pp1p/3p1np1/8/3NPP2/2N5/PPP3PP/R1BQKB1R b KQkq - b8d7",
    "B71",
    "Sicilian Defense: Dragon Variation, Levenfish Variation, Main Line",
  ],
  ["rnbqkb1r/pp2pp1p/5np1/2pp4/2PP4/2N2P2/PP2P1PP/R1BQKBNR w KQkq - c4d5", null, null],
  ["rnbqkb1r/pp2pp1p/5np1/2pP4/3P4/2N2P2/PP2P1PP/R1BQKBNR b KQkq - f6d5", null, null],
  ["rnbqkb1r/pp2pp1p/5np1/3p4/2PP4/2N5/PP3PPP/R1BQKBNR w KQkq - c4d5", null, null],
  [
    "rnbqkb1r/pp2pp1p/5np1/3P4/3P4/2N5/PP3PPP/R1BQKBNR b KQkq - f8g7",
    "B14",
    "Caro-Kann Defense: Panov Attack, Fianchetto Defense, Fianchetto Gambit",
  ],
  ["rnbqkb1r/pp2pp1p/5p2/2p5/3Pp3/2N5/PPP2PPP/R2QKBNR w KQkq - d4d5", "D01", "Richter-Veresov Attack: Malich Gambit"],
  ["rnbqkb1r/pp2pp1p/5p2/2pp4/3P4/2N5/PPP1PPPP/R2QKBNR w KQkq - e2e4", null, null],
  ["rnbqkb1r/pp2pp1p/5p2/2pp4/3PP3/2N5/PPP2PPP/R2QKBNR b KQkq - d5e4", null, null],
  [
    "rnbqkb1r/pp2pp1p/6p1/2pn4/3P4/2N2P2/PP2P1PP/R1BQKBNR w KQkq - c3a4",
    "D80",
    "Grünfeld Defense: Lutikov Variation, Murrey Attack",
  ],
  ["rnbqkb1r/pp2ppp1/2p2n1p/6N1/3P4/8/PPP2PPP/R1BQKBNR w KQkq - g5f7", "B15", "Caro-Kann Defense: Alien Gambit"],
  ["rnbqkb1r/pp2pppp/1n1p4/8/2PP4/2N5/PP3PPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/pp2pppp/1n1p4/8/2PP4/8/PP3PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/1P3N2/P2PPPPP/RNBQKB1R w KQkq - c1b2", null, null],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/1P3N2/PB1PPPPP/RN1QKB1R b KQkq - c8f5",
    "A12",
    "Réti Opening: Anglo-Slav Variation, New York System",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/1P3N2/PB1PPPPP/RN1QKB1R b KQkq - c8g4",
    "A12",
    "Réti Opening: Anglo-Slav Variation, Capablanca Variation",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/1P3NP1/P2PPP1P/RNBQKB1R b KQkq - c8f5",
    "A12",
    "Réti Opening: Anglo-Slav Variation, London Defensive System",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/1P3NP1/P2PPP1P/RNBQKB1R b KQkq - c8g4",
    "A12",
    "Réti Opening: Anglo-Slav Variation, Torre System",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/1P3NP1/P2PPP1P/RNBQKB1R b KQkq - d5c4",
    "A12",
    "Réti Opening: Anglo-Slav Variation, with dxc4",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/1P3NP1/P2PPP1P/RNBQKB1R b KQkq - g7g6",
    "A11",
    "Réti Opening: Anglo-Slav Variation, with g3",
  ],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/2N1PN2/PP1P1PPP/R1BQKB1R b KQkq - b8d7", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/2N1PN2/PP1P1PPP/R1BQKB1R b KQkq - e7e6", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/4PN2/PP1P1PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/4PN2/PP1P1PPP/RNBQKB1R w KQkq - d1c2",
    "A11",
    "Réti Opening: Anglo-Slav Variation, Gurevich System",
  ],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R w KQkq - b2b3", "A12", "Réti Opening: Anglo-Slav Variation"],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R w KQkq - f1g2",
    "A11",
    "Réti Opening: Anglo-Slav Variation, with g3",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - c8f5",
    "A11",
    "Réti Opening: Anglo-Slav Variation, with g3",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - d5c4",
    "A11",
    "Réti Opening: Anglo-Slav Variation, with g3",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - e7e6",
    "A13",
    "English Opening: Agincourt Defense, Catalan Defense, Semi-Slav Defense",
  ],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - e7e6", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - a7a6", "D15", "Slav Defense: Chebanenko Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d5c4", "D15", "Slav Defense: Two Knights Attack"],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d8b6", "D15", "Slav Defense: Süchting Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e7e6", "D43", "Semi-Slav Defense"],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - g7g6", "D15", "Slav Defense: Schlechter Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e3", null, null],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3",
    "D15",
    "Slav Defense: Three Knights Variation",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R b KQkq - c8f5",
    "D12",
    "Slav Defense: Quiet Variation, Schallopp Defense",
  ],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R b KQkq - c8g4",
    "D11",
    "Slav Defense: Quiet Variation, Pin Defense",
  ],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R b KQkq - e7e6", null, null],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3",
    "D15",
    "Slav Defense: Three Knights Variation",
  ],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1d2", "D11", "Slav Defense: Breyer Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - c1g5", "D11", "Slav Defense: Bonet Gambit"],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - c4d5", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - d1c2", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e3", "D11", "Slav Defense: Quiet Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5N2/PPQ1PPPP/RNB1KB1R b KQkq - e7e6", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - d5c4", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3P4/3P4/5N2/PP2PPPP/RNBQKB1R b KQkq - c6d5", "D13", "Slav Defense: Exchange Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/3P4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - d5c6", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/3PP3/3B4/PPP2PPP/RNBQK1NR w KQkq - e4e5", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/8/5NP1/PPPPPPBP/RNBQ1RK1 b kq - c8f5", "A07", "King's Indian Attack, with Bf5"],
  [
    "rnbqkb1r/pp2pppp/2p2n2/3p4/8/5NP1/PPPPPPBP/RNBQ1RK1 b kq - c8g4",
    "A07",
    "King's Indian Attack: Yugoslav Variation",
  ],
  ["rnbqkb1r/pp2pppp/2p2n2/3p4/8/5NP1/PPPPPPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/3pP3/3P4/3B4/PPP2PPP/RNBQK1NR b KQkq - f6d7", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/6N1/3P4/8/PPP2PPP/R1BQKBNR b KQkq - h7h6", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - a2a4", "D16", "Slav Defense: Alapin Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3", "D15", "Slav Defense: Alekhine Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e4", "D15", "Slav Defense: Geller Gambit"],
  ["rnbqkb1r/pp2pppp/2p2n2/8/2pP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/8/2pP4/5NP1/PP2PPBP/RNBQK2R b KQkq - g7g6", "D11", "Slav Defense: Modern Line"],
  ["rnbqkb1r/pp2pppp/2p2n2/8/2pPP3/2N2N2/PP3PPP/R1BQKB1R b KQkq - b7b5", null, null],
  ["rnbqkb1r/pp2pppp/2p2N2/8/3P4/8/PPP2PPP/R1BQKBNR b KQkq - e7f6", "B15", "Caro-Kann Defense: Tartakower Variation"],
  [
    "rnbqkb1r/pp2pppp/2p2N2/8/3P4/8/PPP2PPP/R1BQKBNR b KQkq - g7f6",
    "B16",
    "Caro-Kann Defense: Bronstein-Larsen Variation",
  ],
  ["rnbqkb1r/pp2pppp/2P2n2/8/3P4/8/PPP2PPP/RNBQKBNR b KQkq - e7e5", "B01", "Scandinavian Defense: Kádas Gambit"],
  ["rnbqkb1r/pp2pppp/2p2n2/8/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - e4f6", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/8/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - e4g5", null, null],
  ["rnbqkb1r/pp2pppp/2p2n2/8/3PN3/8/PPP2PPP/R1BQKBNR w KQkq - f1d3", "B15", "Caro-Kann Defense: Alekhine Gambit"],
  ["rnbqkb1r/pp2pppp/2p2n2/8/P1pP4/2N2N2/1P2PPPP/R1BQKB1R b KQkq - b8a6", "D16", "Slav Defense: Smyslov Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/8/P1pP4/2N2N2/1P2PPPP/R1BQKB1R b KQkq - c8f5", "D17", "Slav Defense: Czech Variation"],
  ["rnbqkb1r/pp2pppp/2p2n2/8/P1pP4/2N2N2/1P2PPPP/R1BQKB1R b KQkq - c8g4", "D16", "Slav Defense: Steiner Variation"],
  [
    "rnbqkb1r/pp2pppp/2p2n2/8/P1pP4/2N2N2/1P2PPPP/R1BQKB1R b KQkq - e7e6",
    "D16",
    "Slav Defense: Soultanbeieff Variation",
  ],
  ["rnbqkb1r/pp2pppp/3p1n2/2p5/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - c5d4", null, null],
  ["rnbqkb1r/pp2pppp/3p1n2/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - d4c5", null, null],
  ["rnbqkb1r/pp2pppp/3p1n2/2p5/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - d2d4", null, null],
  ["rnbqkb1r/pp2pppp/3p1n2/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - f1e2", null, null],
  ["rnbqkb1r/pp2pppp/3p1n2/2p5/4P3/2P2N2/PP1PBPPP/RNBQK2R b KQkq - b8c6", null, null],
  [
    "rnbqkb1r/pp2pppp/3p1n2/2P5/4P3/5N2/PPP2PPP/RNBQKB1R b KQkq - f6e4",
    "B50",
    "Sicilian Defense: Modern Variations, Anti-Qxd4 Move Order Accepted",
  ],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - a7a6", "B90", "Sicilian Defense: Najdorf Variation"],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - b8c6", "B56", "Sicilian Defense: Classical Variation"],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - c8d7", "B56", "Sicilian Defense: Kupreichik Variation"],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - e7e5", null, null],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - g7g6", "B70", "Sicilian Defense: Dragon Variation"],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3NP3/5P2/PPP3PP/RNBQKB1R b KQkq - e7e5", null, null],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - f1c4",
    "B54",
    "Sicilian Defense: Modern Variations, Ginsberg Gambit",
  ],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - f2f3", "B54", "Sicilian Defense: Prins Variation"],
  ["rnbqkb1r/pp2pppp/3p1n2/8/3pP3/2N2N2/PPP2PPP/R1BQKB1R w KQkq - f3d4", null, null],
  ["rnbqkb1r/pp2pppp/5B2/2pp4/3P4/2N5/PPP1PPPP/R2QKBNR b KQkq - g7f6", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2p5/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - d4d5", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2p5/3p1P2/1P3N2/PBPPP1PP/RN1QKB1R w KQkq - e2e3", "A03", "Bird Opening: Thomas Gambit"],
  ["rnbqkb1r/pp2pppp/5n2/2pp2B1/3P4/2N5/PPP1PPPP/R2QKBNR w KQkq - g5f6", null, null],
  [
    "rnbqkb1r/pp2pppp/5n2/2pP4/2p1P3/2N5/PP3PPP/R1BQKBNR b KQkq - b7b5",
    "D20",
    "Queen's Gambit Accepted: Linares Variation",
  ],
  ["rnbqkb1r/pp2pppp/5n2/2pP4/2p1P3/8/PP3PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - c4d5", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pP4/2p5/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e7e6", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/2P5/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - c4d5", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/3P1B2/4PN2/PPP2PPP/RN1QKB1R b KQkq - d8b6", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/3P1B2/5N2/PPP1PPPP/RN1QKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - b1d2", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/3P4/4PN2/PPPN1PPP/R1BQKB1R b KQkq - e7e6", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pP4/3P4/8/PP2PPPP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pP4/3PP3/8/PP3PPP/RNBQKBNR b KQkq - f6e4", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/8/1P3N2/PBPPPPPP/RN1QKB1R w KQkq - e2e4", "A06", "Nimzo-Larsen Attack: Norfolk Gambit"],
  ["rnbqkb1r/pp2pppp/5n2/2pP4/8/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - f6d5", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pP4/8/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - f6d5", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/8/5NP1/PPPPPPBP/RNBQ1RK1 b kq - e7e6", null, null],
  ["rnbqkb1r/pp2pppp/5n2/2pp4/8/5NP1/PPPPPPBP/RNBQK2R w KQkq - e1g1", null, null],
  [
    "rnbqkb1r/pp2pppp/5n2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR b KQkq - b8c6",
    "B13",
    "Caro-Kann Defense: Panov Attack, Modern Defense",
  ],
  ["rnbqkb1r/pp2pppp/5n2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR b KQkq - e7e6", "B14", "Caro-Kann Defense: Panov Attack"],
  [
    "rnbqkb1r/pp2pppp/5n2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR b KQkq - g7g6",
    "B14",
    "Caro-Kann Defense: Panov Attack, Fianchetto Defense",
  ],
  ["rnbqkb1r/pp2pppp/5n2/3p4/2PP4/8/PP3PPP/RNBQKBNR w KQkq - b1c3", "B13", "Caro-Kann Defense: Panov Attack"],
  [
    "rnbqkb1r/pp2pppp/5n2/3p4/2PP4/8/PP3PPP/RNBQKBNR w KQkq - c4c5",
    "B13",
    "Caro-Kann Defense: Panov Attack, Gunderam Attack",
  ],
  ["rnbqkb1r/pp2pppp/5n2/3p4/3P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b8c6", null, null],
  [
    "rnbqkb1r/pp2pppp/5n2/3p4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - f2f3",
    "D10",
    "Slav Defense: Exchange Variation, Boor Attack",
  ],
  ["rnbqkb1r/pp2pppp/5n2/3p4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pp2pppp/5n2/3p4/3P4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/pp2pppp/8/2pn4/8/2N1PN2/PP1P1PPP/R1BQKB1R b KQkq - e7e6", "A17", "English Opening: Anglo-Indian Defense"],
  ["rnbqkb1r/pp2pppp/8/2pn4/8/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/pp2pppp/8/2pn4/8/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/pp2pppp/8/2pn4/8/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pp2pppp/8/2pn4/8/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  [
    "rnbqkb1r/pp2pppp/8/2pn4/8/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - d5c7",
    "A34",
    "English Opening: Symmetrical Variation, Rubinstein Variation",
  ],
  ["rnbqkb1r/pp2pppp/8/2pP4/3Pn3/8/PP3PPP/RNBQKBNR w KQkq - d4c5", null, null],
  [
    "rnbqkb1r/pp2pppp/8/2PP4/4n3/8/PP3PPP/RNBQKBNR b KQkq - d8a5",
    "D06",
    "Queen's Gambit Declined: Austrian Defense, Haberditz Variation",
  ],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/4P3/2N2P2/PP4PP/R1BQKBNR b KQkq - f8g7", "A65", "Benoni Defense: King's Pawn Line"],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - f2f3", null, null],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - f2f4", "A66", "Benoni Defense: Pawn Storm Variation"],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3", "A70", "Benoni Defense: Classical Variation"],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/4PP2/2N5/PP4PP/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5", "A61", "Benoni Defense: Uhlmann Variation"],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e4", "A70", "Benoni Defense: Classical Variation"],
  [
    "rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R w KQkq - f3d2",
    "A61",
    "Benoni Defense: Knight's Tour Variation",
  ],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R w KQkq - g2g3", "A61", "Benoni Defense: Fianchetto Variation"],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N3P1/PP2PP1P/R1BQKBNR w KQkq - f1g2", null, null],
  ["rnbqkb1r/pp3p1p/3p1np1/2pP4/8/2N3P1/PP2PPBP/R1BQK1NR b KQkq - f8g7", null, null],
  [
    "rnbqkb1r/pp3pp1/2p1pB1p/3p4/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - d8f6",
    "D43",
    "Semi-Slav Defense: Moscow Variation",
  ],
  ["rnbqkb1r/pp3pp1/2p1pn1p/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - g5f6", null, null],
  [
    "rnbqkb1r/pp3pp1/2p1pn1p/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - g5h4",
    "D43",
    "Semi-Slav Defense: Anti-Moscow Gambit",
  ],
  ["rnbqkb1r/pp3ppp/2p1p3/3p4/2PPn3/2N1PN2/PP3PPP/R1BQKB1R w KQkq - f1d3", null, null],
  [
    "rnbqkb1r/pp3ppp/2p1p3/3p4/2PPn3/2NBPN2/PP3PPP/R1BQK2R b KQkq - f7f5",
    "D45",
    "Semi-Slav Defense: Stonewall Defense",
  ],
  [
    "rnbqkb1r/pp3ppp/2p1p3/3p4/2PPn3/3BPN2/PP1N1PPP/R1BQK2R b KQkq - f7f5",
    "D30",
    "Queen's Gambit Declined: Stonewall Variation",
  ],
  ["rnbqkb1r/pp3ppp/2p1p3/3p4/2PPn3/4PN2/PP1N1PPP/R1BQKB1R w KQkq - f1d3", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - b8d7", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - d5c4", "D44", "Semi-Slav Defense Accepted"],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - f8e7", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - h7h6", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p2B1/2PP4/5N2/PP1NPPPP/R2QKB1R b KQkq - b8d7", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p2B1/2PP4/5N2/PP2PPPP/RN1QKB1R w KQkq - b1d2", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2P5/1P3NP1/P2PPPBP/RNBQK2R b KQkq - f8e7", null, null],
  [
    "rnbqkb1r/pp3ppp/2p1pn2/3p4/2P5/1PN1PN2/P2P1PPP/R1BQKB1R b KQkq - f8d6",
    "A11",
    "Réti Opening: Anglo-Slav Variation, Gurevich System",
  ],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2P5/2N1PN2/PP1P1PPP/R1BQKB1R w KQkq - b2b3", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R w KQkq - b2b3", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - g1f3", "D45", "Semi-Slav Defense: Main Line"],
  [
    "rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - a7a6",
    "D45",
    "Semi-Slav Defense: Accelerated Meran Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - b8d7",
    "D45",
    "Semi-Slav Defense: Normal Variation",
  ],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - f6e4", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - f8d6", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3", "D45", "Semi-Slav Defense: Main Line"],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/4PN2/PP1N1PPP/R1BQKB1R b KQkq - b8d7", "D30", "Semi-Slav Defense: Quiet Variation"],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/4PN2/PP1N1PPP/R1BQKB1R b KQkq - f6e4", null, null],
  [
    "rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/4PN2/PP1N1PPP/R1BQKB1R b KQkq - g7g6",
    "D30",
    "Queen's Gambit Declined: Spielmann Variation",
  ],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R w KQkq - b1c3", "D45", "Semi-Slav Defense: Main Line"],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R w KQkq - b1d2", "D30", "Semi-Slav Defense: Quiet Variation"],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/5N2/PPQ1PPPP/RNB1KB1R w KQkq - b1d2", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/5N2/PPQNPPPP/R1B1KB1R b KQkq - f8e7", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/5NP1/PP2PP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkb1r/pp3ppp/2p1pn2/3p4/2PP4/5NP1/PP2PPBP/RNBQK2R b KQkq - d5c4", "E04", "Catalan Opening: Open Defense"],
  [
    "rnbqkb1r/pp3ppp/2p1pn2/6B1/2pP4/2N2N2/PP2PPPP/R2QKB1R w KQkq - e2e4",
    "D44",
    "Semi-Slav Defense: Botvinnik Variation",
  ],
  ["rnbqkb1r/pp3ppp/2p1pn2/6B1/2pPP3/2N2N2/PP3PPP/R2QKB1R b KQkq - b7b5", null, null],
  ["rnbqkb1r/pp3ppp/2p2n2/1B1P4/5p2/5N2/PPPP2PP/RNBQK2R w KQkq - d5c6", null, null],
  ["rnbqkb1r/pp3ppp/2P2n2/1B6/5p2/5N2/PPPP2PP/RNBQK2R b KQkq - b7c6", null, null],
  [
    "rnbqkb1r/pp3ppp/2p2n2/3p2B1/3P4/2N5/PP2PPPP/R2QKBNR w KQkq - d1c2",
    "D36",
    "Queen's Gambit Declined: Exchange Variation, Reshevsky Variation",
  ],
  ["rnbqkb1r/pp3ppp/2p2n2/3p2B1/3P4/2N5/PPQ1PPPP/R3KBNR b KQkq - f8e7", null, null],
  ["rnbqkb1r/pp3ppp/2p2p2/8/3P4/2P5/PP3PPP/R1BQKBNR b KQkq - f8d6", null, null],
  ["rnbqkb1r/pp3ppp/2p2p2/8/3P4/8/PPP2PPP/R1BQKBNR w KQkq - c2c3", null, null],
  ["rnbqkb1r/pp3ppp/2p2p2/8/3P4/8/PPP2PPP/R1BQKBNR w KQkq - f1c4", "B15", "Caro-Kann Defense: Forgacs Variation"],
  ["rnbqkb1r/pp3ppp/3p1n2/2pP4/4P3/2N5/PP3PPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/pp3ppp/3p1n2/2pP4/8/2N2N2/PP2PPPP/R1BQKB1R b KQkq - g7g6", "A61", "Benoni Defense"],
  ["rnbqkb1r/pp3ppp/3p1n2/2pP4/8/2N3P1/PP2PP1P/R1BQKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/pp3ppp/3p1n2/2pP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", "A65", "Benoni Defense: King's Pawn Line"],
  ["rnbqkb1r/pp3ppp/3p1n2/2pP4/8/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/pp3ppp/3p1n2/2pP4/8/6P1/PP2PP1P/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/pp3ppp/3p1n2/2pPp3/2P1P3/2N5/PP3PPP/R1BQKBNR b KQkq - g7g6",
    "A56",
    "Benoni Defense: King's Indian System",
  ],
  ["rnbqkb1r/pp3ppp/3p1n2/2pPp3/2P5/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqkb1r/pp3ppp/3p1n2/4p3/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1b5", "B56", "Sicilian Defense: Venice Attack"],
  [
    "rnbqkb1r/pp3ppp/3p1n2/4p3/3NP3/5P2/PPP3PP/RNBQKB1R w KQkq - f1b5",
    "B55",
    "Sicilian Defense: Prins Variation, Venice Attack",
  ],
  [
    "rnbqkb1r/pp3ppp/3ppn2/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1 b kq - a7a6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Chicago Defense",
  ],
  ["rnbqkb1r/pp3ppp/3ppn2/8/2B1P3/2N2N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  ["rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP1BPPP/R1BQK2R b KQkq - f8e7", null, null],
  [
    "rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1b5",
    "B80",
    "Sicilian Defense: Scheveningen Variation, Vitolins Variation",
  ],
  ["rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1c4", "B86", "Sicilian Defense: Sozin Attack"],
  [
    "rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1e2",
    "B83",
    "Sicilian Defense: Scheveningen Variation, Classical Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f2f4",
    "B82",
    "Sicilian Defense: Scheveningen Variation, Matanovic Attack",
  ],
  [
    "rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - g2g3",
    "B80",
    "Sicilian Defense: Scheveningen Variation, Fianchetto Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/3ppn2/8/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - g2g4",
    "B81",
    "Sicilian Defense: Scheveningen Variation, Keres Attack",
  ],
  ["rnbqkb1r/pp3ppp/3ppn2/8/3NPP2/2N5/PPP3PP/R1BQKB1R b KQkq - b8c6", null, null],
  [
    "rnbqkb1r/pp3ppp/4p3/2p5/3PP3/2n2N2/PP3PPP/R1BQKB1R w KQkq - b2c3",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Exchange Variation",
  ],
  ["rnbqkb1r/pp3ppp/4p3/2p5/3PP3/2P2N2/P4PPP/R1BQKB1R b KQkq - c5d4", null, null],
  [
    "rnbqkb1r/pp3ppp/4p3/2p5/3PP3/2P5/P4PPP/R1BQKBNR w KQkq - g1f3",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Exchange Variation",
  ],
  ["rnbqkb1r/pp3ppp/4p3/2pn4/3P4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - b8c6", null, null],
  [
    "rnbqkb1r/pp3ppp/4p3/2pn4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Pillsbury Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/4p3/2pn4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e4",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Exchange Variation",
  ],
  ["rnbqkb1r/pp3ppp/4p3/2pn4/3PP3/2N2N2/PP3PPP/R1BQKB1R b KQkq - d5c3", null, null],
  ["rnbqkb1r/pp3ppp/4p3/8/3pP3/2P2N2/P4PPP/R1BQKB1R w KQkq - c3d4", null, null],
  ["rnbqkb1r/pp3ppp/4p3/8/3PP3/5N2/P4PPP/R1BQKB1R b KQkq - f8b4", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2p5/2BP4/4PN2/PP2QPPP/RNB1K2R b KQkq - a7a6", null, null],
  [
    "rnbqkb1r/pp3ppp/4pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1 b kq - a7a6",
    "D27",
    "Queen's Gambit Accepted: Classical Defense, Main Line",
  ],
  [
    "rnbqkb1r/pp3ppp/4pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1 b kq - b8c6",
    "D26",
    "Queen's Gambit Accepted: Classical Defense, Steinitz Variation, Development Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/4pn2/2p5/2BP4/4PN2/PP3PPP/RNBQ1RK1 b kq - c5d4",
    "D26",
    "Queen's Gambit Accepted: Classical Defense, Steinitz Variation, Exchange Variation",
  ],
  ["rnbqkb1r/pp3ppp/4pn2/2p5/2BP4/4PN2/PP3PPP/RNBQK2R w KQkq - d1e2", null, null],
  [
    "rnbqkb1r/pp3ppp/4pn2/2p5/2BP4/4PN2/PP3PPP/RNBQK2R w KQkq - e1g1",
    "D26",
    "Queen's Gambit Accepted: Classical Defense, Normal Line",
  ],
  ["rnbqkb1r/pp3ppp/4pn2/2pp2B1/2PP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - c5d4", null, null],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp2B1/2PP4/2N5/PP2PPPP/R2QKBNR w KQkq - c4d5",
    "D50",
    "Queen's Gambit Declined: Pseudo-Tarrasch Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp2B1/2PP4/2N5/PP2PPPP/R2QKBNR w KQkq - g1f3",
    "D40",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Pillsbury Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pP2B1/3P4/2N5/PP2PPPP/R2QKBNR b KQkq - d8b6",
    "D50",
    "Queen's Gambit Declined: Pseudo-Tarrasch Variation, Canal Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp2B1/3P4/2P1PN2/PP3PPP/RN1QKB1R b KQkq - d8b6",
    "A46",
    "Queen's Pawn Game: Torre Attack, Breyer Variation",
  ],
  ["rnbqkb1r/pp3ppp/4pn2/2pp2B1/3P4/4PN2/PPP2PPP/RN1QKB1R w KQkq - c2c3", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pP4/2p1P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - e6d5", null, null],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp4/2P5/1P3N2/PB1PPPPP/RN1QKB1R w KQkq - e2e3",
    "A13",
    "English Opening: Agincourt Defense, Wimpy System",
  ],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/2P5/1P3NP1/P2PPPBP/RNBQK2R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pP4/2p5/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e4", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/2P5/5NP1/PP1PPPBP/RNBQK2R w KQkq - b2b3", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/2PP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp4/2PP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - b8c6",
    "D32",
    "Tarrasch Defense: Symmetrical Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5",
    "D40",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Pillsbury Variation",
  ],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c4d5",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense",
  ],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/2PP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/3P4/1P1BPN2/P1P2PPP/RNBQK2R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pP4/3P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - c5d4", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pP4/3P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - e6d5", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pP4/3P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - f6d5", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/3P4/3BPN2/PPP2PPP/RNBQK2R w KQkq - b2b3", "D05", "Rubinstein Opening"],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp4/3P4/3BPN2/PPP2PPP/RNBQK2R w KQkq - c2c3",
    "D05",
    "Queen's Pawn Game: Colle System, Traditional Colle",
  ],
  [
    "rnbqkb1r/pp3ppp/4pn2/2pp4/3P4/4PN2/PPPN1PPP/R1BQKB1R w KQkq - b2b3",
    "D05",
    "Queen's Pawn Game: Zukertort Variation",
  ],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/4P3/3P1N2/PPPN1PPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/4P3/3P1NP1/PPPN1P1P/R1BQKB1R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/2pp4/8/5NP1/PPPPPPBP/RNBQ1RK1 w kq - d2d3", "A08", "King's Indian Attack: Sicilian Variation"],
  ["rnbqkb1r/pp3ppp/4pn2/3p2B1/2PN4/2N5/PP2PPPP/R2QKB1R b KQkq - e6e5", null, null],
  [
    "rnbqkb1r/pp3ppp/4pn2/3p2B1/2Pp4/2N2N2/PP2PPPP/R2QKB1R w KQkq - d1d4",
    "D50",
    "Queen's Gambit Declined: Pseudo-Tarrasch Variation, Primitive Pillsbury Variation",
  ],
  ["rnbqkb1r/pp3ppp/4pn2/3p2B1/2Pp4/2N2N2/PP2PPPP/R2QKB1R w KQkq - f3d4", null, null],
  [
    "rnbqkb1r/pp3ppp/4pn2/3p4/2PP4/2N2N2/PP3PPP/R1BQKB1R b KQkq - f8b4",
    "B14",
    "Caro-Kann Defense: Panov Attack, Main Line",
  ],
  ["rnbqkb1r/pp3ppp/4pn2/3p4/2PP4/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/3P4/3p4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - d1d4", null, null],
  ["rnbqkb1r/pp3ppp/4pn2/3P4/3Q4/2N2N2/PP2PPPP/R1B1KB1R b KQkq - e6d5", null, null],
  ["rnbqkb1r/pp3ppp/5n2/1N1pp1B1/2P5/2N5/PP2PPPP/R2QKB1R b KQkq - a7a6", null, null],
  [
    "rnbqkb1r/pp3ppp/5n2/2pp4/2p1P3/2N2N2/PP3PPP/R1BQKB1R w KQkq - e4e5",
    "D24",
    "Queen's Gambit Accepted: Gunsberg Defense, Prianishenmo Gambit",
  ],
  ["rnbqkb1r/pp3ppp/5n2/2pp4/3P4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/pp3ppp/5n2/2pp4/3P4/2N2NP1/PP2PP1P/R1BQKB1R b KQkq - b8c6", "D33", "Tarrasch Defense: Prague Variation"],
  ["rnbqkb1r/pp3ppp/5n2/3p4/3Q4/2N2N2/PP2PPPP/R1B1KB1R w KQkq - e2e4", null, null],
  ["rnbqkb1r/pp3ppp/5n2/3p4/3QP3/2N2N2/PP3PPP/R1B1KB1R b KQkq - d5e4", null, null],
  ["rnbqkb1r/pp3ppp/5n2/3pp1B1/2PN4/2N5/PP2PPPP/R2QKB1R w KQkq - d4b5", null, null],
  [
    "rnbqkb1r/pp3ppp/5n2/8/3Qp3/2N2N2/PP3PPP/R1B1KB1R w KQkq - d4d8",
    "D41",
    "Queen's Gambit Declined: Semi-Tarrasch Defense, Endgame Variation",
  ],
  [
    "rnbqkb1r/pp4pp/2p1pn2/3p1p2/2PP4/5NP1/PP2PPBP/RNBQ1RK1 b kq - f8d6",
    "A90",
    "Dutch Defense: Stonewall Variation, Modern Variation",
  ],
  ["rnbqkb1r/pp4pp/2p1pn2/3p1p2/2PP4/5NP1/PP2PPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqkb1r/ppp1p1pp/3p1n2/5p2/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b8c6", "A84", "Dutch Defense: Krause Variation"],
  ["rnbqkb1r/ppp1p1pp/3p1n2/5p2/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp1p1pp/3p1n2/5p2/2PP4/6P1/PP2PP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkb1r/ppp1p1pp/3p1n2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp1p1pp/5n2/5p2/3p1P2/5N2/PPPPPNPP/R1BQKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp1p1pp/5n2/5p2/3p1P2/8/PPPPPNPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp1pp1p/1n1p2p1/4P3/2BP4/5N2/PPP2PPP/RNBQK2R w KQkq - c4b3", null, null],
  ["rnbqkb1r/ppp1pp1p/1n1p2p1/4P3/3P4/1B3N2/PPP2PPP/RNBQK2R b KQkq - f8g7", null, null],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N1B3/PPP2PPP/R2QKBNR b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - f8g7", "B08", "Pirc Defense: Classical Variation"],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP1BPPP/R1BQK1NR b KQkq - f8g7", null, null],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1e3", null, null],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1g5", "B07", "Pirc Defense: Byrne Variation"],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f1c4", "B07", "Pirc Defense: Kholmov System"],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f1e2", null, null],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f4", "B09", "Pirc Defense: Austrian Attack"],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", "B08", "Pirc Defense: Classical Variation"],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g2g3", "B07", "Pirc Defense: Sveshnikov System"],
  ["rnbqkb1r/ppp1pp1p/3p1np1/8/3PPP2/2N5/PPP3PP/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/ppp1pp1p/3p2p1/3nP3/2BP4/5N2/PPP2PPP/RNBQK2R b KQkq - d5b6", null, null],
  ["rnbqkb1r/ppp1pp1p/3p2p1/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnbqkb1r/ppp1pp1p/5np1/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR b KQkq - f6e4", null, null],
  [
    "rnbqkb1r/ppp1pp1p/5np1/3p4/2P5/1P3N2/PB1PPPPP/RN1QKB1R b KQkq - c7c6",
    "A12",
    "Réti Opening: Anglo-Slav Variation, Bled Variation",
  ],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP1B2/2N5/PP2PPPP/R2QKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - f8g7", null, null],
  [
    "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - f8g7",
    "D90",
    "Grünfeld Defense: Three Knights Variation",
  ],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N2P2/PP2P1PP/R1BQKBNR b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - c1f4", "D82", "Grünfeld Defense: Brinckmann Attack"],
  [
    "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - c1g5",
    "D80",
    "Grünfeld Defense: Stockholm Variation",
  ],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - c4d5", null, null],
  [
    "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - d1b3",
    "D81",
    "Grünfeld Defense: Russian Variation, Accelerated Variation",
  ],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e3", null, null],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - f2f3", "D80", "Grünfeld Defense: Lutikov Variation"],
  [
    "rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3",
    "D90",
    "Grünfeld Defense: Three Knights Variation",
  ],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g2g4", "D80", "Grünfeld Defense: Gibbon Gambit"],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - h2h4", "D80", "Grünfeld Defense: Zaitsev Gambit"],
  [
    "rnbqkb1r/ppp1pp1p/5np1/3P4/2PP4/8/PP3PPP/RNBQKBNR b KQkq - b7b5",
    "B01",
    "Scandinavian Defense: Modern Variation, Wing Gambit",
  ],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/3P1B2/2N2N2/PPP1PPPP/R2QKB1R b KQkq - f8g7", "A48", "Queen's Pawn Game: Barry Attack"],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/3P4/2N2N2/PPP1PPPP/R1BQKB1R w KQkq - c1f4", "A48", "Queen's Pawn Game: Barry Attack"],
  ["rnbqkb1r/ppp1pp1p/5np1/3P4/3P4/2N5/PP2PPPP/R1BQKBNR b KQkq - f6d5", "D85", "Grünfeld Defense: Exchange Variation"],
  [
    "rnbqkb1r/ppp1pp1p/5np1/3p4/3P4/3BPN2/PPP2PPP/RNBQK2R b KQkq - f8g7",
    "D04",
    "Queen's Pawn Game: Colle System, Grünfeld Formation",
  ],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  ["rnbqkb1r/ppp1pp1p/5np1/3P4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkb1r/ppp1pp1p/5np1/3p4/8/1P3N2/PBPPPPPP/RN1QKB1R w KQkq - c2c4", null, null],
  ["rnbqkb1r/ppp1pp1p/5np1/8/2BP4/2N2N2/PPP3PP/R1BQK2R b KQkq - f8g7", null, null],
  ["rnbqkb1r/ppp1pp1p/5np1/8/3P4/2N2N2/PPP3PP/R1BQKB1R w KQkq - f1c4", null, null],
  [
    "rnbqkb1r/ppp1pp1p/6p1/3n4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - c3a4",
    "D85",
    "Grünfeld Defense: Exchange Variation, Nadanian Attack",
  ],
  ["rnbqkb1r/ppp1pp1p/6p1/3n4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqkb1r/ppp1pp1p/6p1/3n4/3PP3/2N5/PP3PPP/R1BQKBNR b KQkq - d5c3", null, null],
  ["rnbqkb1r/ppp1pp1p/6p1/3n4/8/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/ppp1pp1p/6p1/3n4/8/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/ppp1pp1p/6p1/3n4/8/2N3P1/PP1PPP1P/R1BQKBNR w KQkq - f1g2", null, null],
  [
    "rnbqkb1r/ppp1pp1p/6p1/3n4/8/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - d5b6",
    "A16",
    "English Opening: Anglo-Indian Defense, Anglo-Grünfeld Variation",
  ],
  [
    "rnbqkb1r/ppp1pp1p/6p1/3n4/8/2N3P1/PP1PPPBP/R1BQK1NR b KQkq - d5c3",
    "A16",
    "English Opening: Anglo-Indian Defense, Anglo-Grünfeld Variation",
  ],
  ["rnbqkb1r/ppp1pp1p/6p1/3p2B1/2PPn3/2N5/PP2PPPP/R2QKBNR w KQkq - c3e4", null, null],
  ["rnbqkb1r/ppp1pp1p/6p1/3p2B1/2PPN3/8/PP2PPPP/R2QKBNR b KQkq - d5e4", null, null],
  ["rnbqkb1r/ppp1pp1p/6p1/6B1/2PPp3/8/PP1QPPPP/R3KBNR b KQkq - c7c5", "D80", "Grünfeld Defense: Lundin Variation"],
  ["rnbqkb1r/ppp1pp1p/6p1/6B1/2PPp3/8/PP2PPPP/R2QKBNR w KQkq - d1d2", null, null],
  ["rnbqkb1r/ppp1pp1p/6p1/8/3PP3/2n5/PP3PPP/R1BQKBNR w KQkq - b2c3", null, null],
  ["rnbqkb1r/ppp1pp1p/6p1/8/3PP3/2P5/P4PPP/R1BQKBNR b KQkq - f8g7", null, null],
  [
    "rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP1P2/8/PP4PP/RNBQKBNR b KQkq - c8f5",
    "B03",
    "Alekhine Defense: Four Pawns Attack, Trifunovic Variation",
  ],
  ["rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP1P2/8/PP4PP/RNBQKBNR b KQkq - d6e5", null, null],
  [
    "rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP1P2/8/PP4PP/RNBQKBNR b KQkq - g7g5",
    "B03",
    "Alekhine Defense: Four Pawns Attack, Cambridge Gambit",
  ],
  [
    "rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP1P2/8/PP4PP/RNBQKBNR b KQkq - g7g6",
    "B03",
    "Alekhine Defense: Four Pawns Attack, Fianchetto Variation",
  ],
  ["rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP4/5N2/PP3PPP/RNBQKB1R b KQkq - c8g4", null, null],
  ["rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP4/8/PP3PPP/RNBQKBNR w KQkq - c4c5", "B03", "Alekhine Defense: Hunt Variation"],
  ["rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP4/8/PP3PPP/RNBQKBNR w KQkq - e5d6", "B03", "Alekhine Defense: Exchange Variation"],
  ["rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP4/8/PP3PPP/RNBQKBNR w KQkq - f2f4", "B03", "Alekhine Defense: Four Pawns Attack"],
  ["rnbqkb1r/ppp1pppp/1n1p4/4P3/2PP4/8/PP3PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp1pppp/1n1P4/8/2PP4/8/PP3PPP/RNBQKBNR b KQkq - c7d6", null, null],
  ["rnbqkb1r/ppp1pppp/1n6/4p3/2PP1P2/8/PP4PP/RNBQKBNR w KQkq - f4e5", null, null],
  ["rnbqkb1r/ppp1pppp/1n6/4P3/2PP4/8/PP4PP/RNBQKBNR b KQkq - b8c6", null, null],
  ["rnbqkb1r/ppp1pppp/1n6/4P3/2PP4/8/PP4PP/RNBQKBNR b KQkq - c8f5", null, null],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - b8d7", null, null],
  [
    "rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - c7c6",
    "A53",
    "Old Indian Defense: Czech Variation, with Nc3",
  ],
  [
    "rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - c8f5",
    "A53",
    "Old Indian Defense: Janowski Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - e7e5",
    "A54",
    "Old Indian Defense: Ukrainian Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c7c6",
    "A53",
    "Old Indian Defense: Czech Variation, with Nf3",
  ],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c8g4", "A54", "Old Indian Defense: Tartakower-Indian"],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g2g4", "A53", "Old Indian Defense: Aged Gibbon Gambit"],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - b8d7", "B07", "Lion Defense"],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - c7c6", "B07", "Czech Defense"],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - e7e5", null, null],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - g7g6", "B07", "Pirc Defense"],
  [
    "rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/8/PPP1BP1P/RNBQK1NR w KQkq - b1c3",
    "A45",
    "Indian Defense: Gibbins-Weidenhagen Gambit, Stummer Gambit",
  ],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f2f3", "B00", "Lion Defense: Lion's Jaw"],
  ["rnbqkb1r/ppp1pppp/3p1n2/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", "B00", "Pirc Defense: Roscher Gambit"],
  [
    "rnbqkb1r/ppp1pppp/3p4/2P1P3/8/2P5/PP3PPP/R1BQKBNR w KQkq - c1g5",
    "B02",
    "Alekhine Defense: Hunt Variation, Matsukevich Gambit",
  ],
  ["rnbqkb1r/ppp1pppp/3p4/3nP3/2PP4/8/PP3PPP/RNBQKBNR b KQkq - d5b6", null, null],
  [
    "rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - b8c6",
    "B04",
    "Alekhine Defense: Modern Variation, Larsen-Haakert Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - c8g4",
    "B05",
    "Alekhine Defense: Modern Variation, Main Line",
  ],
  [
    "rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - d5b6",
    "B04",
    "Alekhine Defense: Modern Variation, Schmid Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - d6e5",
    "B04",
    "Alekhine Defense: Modern Variation, Larsen Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - g7g6",
    "B04",
    "Alekhine Defense: Modern Variation, Alburt Variation",
  ],
  ["rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - c2c4", "B03", "Alekhine Defense"],
  ["rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - f1c4", "B03", "Alekhine Defense: Balogh Variation"],
  ["rnbqkb1r/ppp1pppp/3p4/3nP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", "B04", "Alekhine Defense: Modern Variation"],
  ["rnbqkb1r/ppp1pppp/3p4/8/3PP1n1/8/PPP1BP1P/RNBQK1NR b KQkq - g4f6", null, null],
  ["rnbqkb1r/ppp1pppp/3p4/8/3PP1n1/8/PPP2P1P/RNBQKBNR w KQkq - f1e2", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p2B1/3P4/2N5/PPP1PPPP/R2QKBNR b KQkq - b8d7", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p2B1/3P4/2N5/PPP1PPPP/R2QKBNR b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p2B1/3P4/2N5/PPP1PPPP/R2QKBNR b KQkq - c8f5", "D01", "Richter-Veresov Attack"],
  [
    "rnbqkb1r/ppp1pppp/5n2/3p2B1/3P4/2N5/PPP1PPPP/R2QKBNR b KQkq - f6e4",
    "D01",
    "Richter-Veresov Attack: Boyce Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/3p2B1/3P4/5N2/PPP1PPPP/RN1QKB1R b KQkq - f6e4",
    "D03",
    "Queen's Pawn Game: Torre Attack, Gossip Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/3p2B1/3P4/5N2/PPP1PPPP/RN1QKB1R b KQkq - g7g6",
    "D03",
    "Queen's Pawn Game: Torre Attack, Grünfeld Variation",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/1P6/8/PBPPPPPP/RN1QKBNR w KQkq - g1f3", "A00", "Polish Opening, with d5"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - c4d5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/2P5/4PN2/PP1P1PPP/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/2P5/4PN2/PP1P1PPP/RNBQKB1R b KQkq - e7e6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - c4d5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3P4/2P5/8/PP1P1PPP/RNBQKBNR b KQkq - c7c6", "B01", "Scandinavian Defense: Panov Transfer"],
  [
    "rnbqkb1r/ppp1pppp/5n2/3P4/2P5/8/PP1P1PPP/RNBQKBNR b KQkq - e7e6",
    "B01",
    "Scandinavian Defense: Icelandic-Palme Gambit",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - b7b5",
    "D02",
    "Queen's Pawn Game: Zilbermints Countergambit",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - e7e6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - c4d5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P1B2/2N5/PPP1PPPP/R2QKBNR b KQkq - e7e6", "D01", "Rapport-Jobava System"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P1B2/2N5/PPP1PPPP/R2QKBNR b KQkq - g7g6", "D01", "Rapport-Jobava System"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P1B2/5N2/PPP1PPPP/RN1QKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P3B/2N2P2/PPP1P1PP/R2QKBNR b KQkq - c8f5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P3B/5P2/PPP1P1PP/RN1QKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR w KQkq - c1f4", "D01", "Rapport-Jobava System"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR w KQkq - c1g5", "D01", "Richter-Veresov Attack"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR w KQkq - d1d3", "A45", "Amazon Attack: Siberian Attack"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR w KQkq - e2e4", "D00", "Queen's Pawn Game: Hübsch Gambit"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/4P3/PPP2PPP/RNBQKBNR w KQkq - f1d3", "D00", "Queen's Pawn Game: Stonewall Attack"],
  [
    "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - c8f5",
    "D04",
    "Queen's Pawn Game: Colle System, Anti-Colle",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - e7e6", "D05", "Queen's Pawn Game: Colle System"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - g7g6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1f4", "D02", "Queen's Pawn Game: London System"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1g5", "D03", "Queen's Pawn Game: Torre Attack"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - e2e3", "D04", "Queen's Pawn Game: Colle System"],
  [
    "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - g2g3",
    "D02",
    "Queen's Pawn Game: Symmetrical Variation, Pseudo-Catalan",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5P2/PPP1P1PP/RNBQKBNR w KQkq - b1c3",
    "A45",
    "Queen's Pawn Game: Veresov, Richter Attack",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5P2/PPP1P1PP/RNBQKBNR w KQkq - e2e4",
    "A45",
    "Indian Defense: Paleface Attack, Blackmar-Diemer Gambit Deferred",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/3P4/5P2/PPP1P1PP/RNBQKBNR w KQkq - g2g4", "A45", "Indian Defense: Gedult Attack"],
  [
    "rnbqkb1r/ppp1pppp/5n2/3P4/3P4/8/PP2PPPP/RNBQKBNR b KQkq - c7c6",
    "D06",
    "Queen's Gambit Declined: Marshall Defense, Tan Gambit",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/3P4/3P4/8/PPP2PPP/RNBQKBNR b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3P4/3P4/8/PPP2PPP/RNBQKBNR b KQkq - c8g4", "B01", "Scandinavian Defense: Portuguese Gambit"],
  ["rnbqkb1r/ppp1pppp/5n2/3P4/3P4/8/PPP2PPP/RNBQKBNR b KQkq - f6d5", "B01", "Scandinavian Defense: Marshall Variation"],
  ["rnbqkb1r/ppp1pppp/5n2/3P4/3P4/8/PPP2PPP/RNBQKBNR b KQkq - g7g6", "B01", "Scandinavian Defense: Richter Variation"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d3", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - e4d5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - e4e5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/4P3/2NP4/PPP2PPP/R1BQKBNR b KQkq - d5e4", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/5P2/1P6/P1PPP1PP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/5P2/1P6/PBPPP1PP/RN1QKBNR b KQkq - d5d4", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/5P2/4PN2/PPPP2PP/RNBQKB1R b KQkq - c7c5", "A03", "Bird Opening: Lasker Variation"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/5P2/5N2/PPPPP1PP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/8/1P3N2/P1PPPPPP/RNBQKB1R w KQkq - c1b2", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/8/1P3N2/PBPPPPPP/RN1QKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/8/1P3N2/PBPPPPPP/RN1QKB1R b KQkq - g7g6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3P4/8/2N5/PP1PPPPP/R1BQKBNR b KQkq - f6d5", null, null],
  [
    "rnbqkb1r/ppp1pppp/5n2/3P4/8/2N5/PPPP1PPP/R1BQKBNR b KQkq - c7c6",
    "B02",
    "Alekhine Defense: Scandinavian Variation, Geschev Gambit",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/8/2NP4/PPP1PPPP/R1BQKBNR w KQkq - g2g3", "A00", "Van Geet Opening: Venezolana Variation"],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/8/4PN2/PPPP1PPP/RNBQKB1R w KQkq - c2c4", null, null],
  [
    "rnbqkb1r/ppp1pppp/5n2/3P4/8/5N2/PP1PPPPP/RNBQKB1R b KQkq - f6d5",
    "A15",
    "English Opening: Anglo-Indian Defense, Scandinavian Defense, Exchange Variation",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/8/5NP1/PPPPPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/8/5NP1/PPPPPPBP/RNBQK2R b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3p4/8/5NP1/PPPPPPBP/RNBQK2R b KQkq - e7e6", "A07", "King's Indian Attack, with e6"],
  ["rnbqkb1r/ppp1pppp/5n2/3P4/8/8/PPPP1PPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/3P4/8/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", "B01", "Scandinavian Defense: Modern Variation"],
  ["rnbqkb1r/ppp1pppp/5n2/3pP3/8/2N5/PPPP1PPP/R1BQKBNR b KQkq - f6d7", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR b KQkq - c8f5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/6N1/4p3/2N5/PPPP1PPP/R1BQKB1R b KQkq - c8f5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/6N1/4p3/8/PPPP1PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/8/2BP4/4P3/PP3PPP/RNBQK1NR b KQkq - e7e6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - a7a6", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/8/2pP4/4P3/PP3PPP/RNBQKBNR w KQkq - f1c4", null, null],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/2pP4/4PN2/PP3PPP/RNBQKB1R b KQkq - c8e6",
    "D25",
    "Queen's Gambit Accepted: Winawer Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/2pP4/4PN2/PP3PPP/RNBQKB1R b KQkq - c8g4",
    "D25",
    "Queen's Gambit Accepted: Janowski-Larsen Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/2pP4/4PN2/PP3PPP/RNBQKB1R b KQkq - e7e6",
    "D26",
    "Queen's Gambit Accepted: Normal Variation, Traditional System",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/2pP4/4PN2/PP3PPP/RNBQKB1R b KQkq - g7g6",
    "D25",
    "Queen's Gambit Accepted: Smyslov Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/2pP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3",
    "D24",
    "Queen's Gambit Accepted: Showalter Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/2pP4/5N2/PP2PPPP/RNBQKB1R w KQkq - d1a4",
    "D23",
    "Queen's Gambit Accepted: Mannheim Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/2pP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e3",
    "D25",
    "Queen's Gambit Accepted: Normal Variation",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/8/3p1P2/1P3N2/PBPPP1PP/RN1QKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/8/3p1P2/1P6/PBPPP1PP/RN1QKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP2PPP/R1BQKB1R b KQkq - c7c6",
    "B01",
    "Scandinavian Defense: Valencian Variation, Ilundain Variation",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP2PPP/R1BQKB1R b KQkq - c8g4",
    "B01",
    "Scandinavian Defense: Valencian Variation, Main Line",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - b7b6",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Ritter Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - b8c6",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Pietrowsky Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - b8d7",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Schlutter Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - c7c5",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Kaulich Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - c7c6",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Ziegler Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - c8f5",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Gunderam Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - c8g4",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Teichmann Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - d8d6",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Holwell Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - e7e6",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Euwe Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2N2/PPP3PP/R1BQKB1R b KQkq - g7g6",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Bogoljubow Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2p2/PPP3PP/R1BQKBNR w KQkq - d1f3",
    "D00",
    "Blackmar-Diemer Gambit Accepted: Ryder Gambit",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/8/3P4/2N2p2/PPP3PP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp1pppp/5n2/8/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - a7a6",
    "D00",
    "Blackmar-Diemer Gambit Declined: Gedult Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - b8c6",
    "D00",
    "Blackmar-Diemer Gambit Declined: Lamb Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - c7c5",
    "D00",
    "Blackmar-Diemer Gambit Declined: Brombacher Countergambit",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - c7c6",
    "D00",
    "Blackmar-Diemer Gambit Declined: O'Kelly Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - c8f5",
    "D00",
    "Blackmar-Diemer Gambit Declined: Vienna Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - e4e3",
    "D00",
    "Blackmar-Diemer Gambit Declined: Langeheinicke Defense",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - e4f3", "D00", "Blackmar-Diemer Gambit Accepted"],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - e7e5",
    "D00",
    "Blackmar-Diemer Gambit Declined: Elbert Countergambit",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N2P2/PPP3PP/R1BQKBNR b KQkq - e7e6",
    "D00",
    "Blackmar-Diemer Gambit Declined: Weinsbach Defense",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1e3",
    "D00",
    "Blackmar-Diemer Gambit: Rasa-Studier Gambit",
  ],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1g5",
    "D00",
    "Blackmar-Diemer Gambit: von Popiel Gambit",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f3", null, null],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/4p3/2NP4/PPP2PPP/R1BQKBNR w KQkq - c1g5",
    "B02",
    "Alekhine Defense: Scandinavian Variation, Myers Gambit",
  ],
  ["rnbqkb1r/ppp1pppp/5n2/8/4pP2/2N5/PPPP2PP/R1BQKBNR w KQkq - d1e2", "A03", "Bird Opening: Williams Gambit"],
  [
    "rnbqkb1r/ppp1pppp/5n2/8/4pP2/2N5/PPPP2PP/R1BQKBNR w KQkq - g1e2",
    "A03",
    "Bird Opening: Williams-Zilbermints Gambit",
  ],
  ["rnbqkb1r/ppp1pppp/8/3n4/2PP4/8/PP3PPP/RNBQKBNR b KQkq - d5b4", "B01", "Scandinavian Defense: Kiel Variation"],
  [
    "rnbqkb1r/ppp1pppp/8/3n4/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - c8g4",
    "B01",
    "Scandinavian Defense: Modern Variation, Gipslis Variation",
  ],
  ["rnbqkb1r/ppp1pppp/8/3n4/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - g7g6", "B01", "Scandinavian Defense: Richter Variation"],
  ["rnbqkb1r/ppp1pppp/8/3n4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkb1r/ppp1pppp/8/3n4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp1pppp/8/3n4/8/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - c7c5", null, null],
  [
    "rnbqkb1r/ppp1pppp/8/3n4/8/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - g7g6",
    "A16",
    "English Opening: Anglo-Indian Defense, Anglo-Grünfeld Variation",
  ],
  ["rnbqkb1r/ppp1pppp/8/3n4/8/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - g7g6", null, null],
  [
    "rnbqkb1r/ppp1pppp/8/3n4/8/2N5/PP1PPPPP/R1BQKBNR w KQkq - g1f3",
    "A16",
    "English Opening: Anglo-Indian Defense, Anglo-Grünfeld Variation",
  ],
  ["rnbqkb1r/ppp1pppp/8/3n4/8/2N5/PP1PPPPP/R1BQKBNR w KQkq - g2g3", null, null],
  ["rnbqkb1r/ppp1pppp/8/3p4/3Pn2B/5P2/PPP1P1PP/RN1QKBNR b KQkq - e4f6", null, null],
  ["rnbqkb1r/ppp1pppp/8/3p4/3Pn2B/8/PPP1PPPP/RN1QKBNR w KQkq - f2f3", null, null],
  ["rnbqkb1r/ppp2Npp/3p1n2/8/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - e8f7", null, null],
  ["rnbqkb1r/ppp2p1p/5n2/3pN3/2B1PppP/8/PPPP2P1/RNBQK2R w KQkq - e4d5", null, null],
  [
    "rnbqkb1r/ppp2p1p/5n2/3PN3/2B2ppP/8/PPPP2P1/RNBQK2R b KQkq - f8d6",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Anderssen Defense",
  ],
  [
    "rnbqkb1r/ppp2p1p/5n2/3PN3/2B2ppP/8/PPPP2P1/RNBQK2R b KQkq - f8g7",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Paulsen Defense Deferred",
  ],
  ["rnbqkb1r/ppp2p1p/5n2/3pN3/3PPBpP/8/PPP3P1/RN1QKB1R b KQkq - f6e4", null, null],
  [
    "rnbqkb1r/ppp2p1p/5n2/3pN3/3PPppP/8/PPP3P1/RNBQKB1R w KQkq - c1f4",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Brentano Defense",
  ],
  [
    "rnbqkb1r/ppp2p1p/8/3pN3/3PnBpP/8/PPP3P1/RN1QKB1R w KQkq - b1d2",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Brentano Defense, Caro Variation",
  ],
  ["rnbqkb1r/ppp2ppp/3p1n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - e5c4", "C42", "Petrov's Defense: Paulsen Attack"],
  [
    "rnbqkb1r/ppp2ppp/3p1n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - e5d3",
    "C42",
    "Petrov's Defense: Karklins-Martinovsky Variation",
  ],
  ["rnbqkb1r/ppp2ppp/3p1n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - e5f3", "C42", "Petrov's Defense"],
  ["rnbqkb1r/ppp2ppp/3p1n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - e5f7", "C42", "Petrov's Defense: Cochrane Gambit"],
  ["rnbqkb1r/ppp2ppp/3p1n2/4p3/2PP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - b8d7", null, null],
  ["rnbqkb1r/ppp2ppp/3p1n2/4p3/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e3", null, null],
  [
    "rnbqkb1r/ppp2ppp/3p1n2/4p3/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3",
    "A54",
    "Old Indian Defense: Two Knights Variation",
  ],
  ["rnbqkb1r/ppp2ppp/3p1n2/4p3/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - b8d7", "C41", "Philidor Defense: Lion Variation"],
  ["rnbqkb1r/ppp2ppp/3p1n2/4p3/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp2ppp/3p1n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/ppp2ppp/3p1n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - d4e5",
    "C41",
    "Philidor Defense: Nimzowitsch Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/3p1n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4",
    "C41",
    "Philidor Defense: Nimzowitsch Variation, Klein Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/3p1n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3g5",
    "C41",
    "Philidor Defense: Nimzowitsch, Locock Variation",
  ],
  ["rnbqkb1r/ppp2ppp/3p1n2/4P3/4P3/5N2/PPP2PPP/RNBQKB1R b KQkq - f6e4", null, null],
  ["rnbqkb1r/ppp2ppp/3p1n2/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - f8e7", null, null],
  ["rnbqkb1r/ppp2ppp/3p1n2/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqkb1r/ppp2ppp/3p1n2/8/3PPp2/5N2/PPP3PP/RNBQKB1R w KQkq - f1d3",
    "C34",
    "King's Gambit Accepted: Fischer Defense, Spanish Variation",
  ],
  ["rnbqkb1r/ppp2ppp/3p1n2/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - f6e4", "C42", "Petrov's Defense"],
  [
    "rnbqkb1r/ppp2ppp/3p4/2PpP3/2B5/8/PP1P1PPP/R1BQK1NR w KQkq - c4d5",
    "B02",
    "Alekhine Defense: Hunt Variation, Mikenas Gambit",
  ],
  [
    "rnbqkb1r/ppp2ppp/3p4/4P3/4n3/5N2/PPP2PPP/RNBQKB1R w KQkq - b1d2",
    "C41",
    "Philidor Defense: Nimzowitsch Variation, Sokolsky Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/3p4/4P3/4n3/5N2/PPP2PPP/RNBQKB1R w KQkq - d1d5",
    "C41",
    "Philidor Defense: Nimzowitsch Variation, Rellstab Variation",
  ],
  ["rnbqkb1r/ppp2ppp/3p4/8/3Pn3/5N2/PPP2PPP/RNBQKB1R b KQkq - d6d5", null, null],
  [
    "rnbqkb1r/ppp2ppp/3p4/8/3Pn3/5N2/PPP2PPP/RNBQKB1R b KQkq - e4f6",
    "C42",
    "Petrov's Defense: Classical Attack, Closed Variation",
  ],
  ["rnbqkb1r/ppp2ppp/3p4/8/4n3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3", "C42", "Petrov's Defense: Nimzowitsch Attack"],
  ["rnbqkb1r/ppp2ppp/3p4/8/4n3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c4", "C42", "Petrov's Defense: Kaufmann Attack"],
  ["rnbqkb1r/ppp2ppp/3p4/8/4n3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d1e2", "C42", "Petrov's Defense: Cozio Attack"],
  ["rnbqkb1r/ppp2ppp/3p4/8/4n3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d3", "C42", "Petrov's Defense: French Attack"],
  ["rnbqkb1r/ppp2ppp/3p4/8/4n3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "C42", "Petrov's Defense: Classical Attack"],
  ["rnbqkb1r/ppp2ppp/3p4/8/4n3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1d3", "C42", "Petrov's Defense: Millennium Attack"],
  ["rnbqkb1r/ppp2ppp/3pp3/2PnP3/2B5/2N5/PP1P1PPP/R1BQK1NR w KQkq - c3d5", null, null],
  ["rnbqkb1r/ppp2ppp/3pp3/2PNP3/2B5/8/PP1P1PPP/R1BQK1NR b KQkq - e6d5", null, null],
  ["rnbqkb1r/ppp2ppp/4p3/3n4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqkb1r/ppp2ppp/4p3/3n4/3PP3/2N5/PP3PPP/R1BQKBNR b KQkq - d5c3", null, null],
  ["rnbqkb1r/ppp2ppp/4p3/8/3PP3/2n5/PP3PPP/R1BQKBNR w KQkq - b2c3", null, null],
  ["rnbqkb1r/ppp2ppp/4p3/8/3PP3/2P5/P4PPP/R1BQKBNR b KQkq - c7c5", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/1P1p4/8/8/PBPPPPPP/RN1QKBNR w KQkq - e2e3",
    "A00",
    "Polish Opening: Schiffler-Sokolsky Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR b KQkq - b8d7",
    "D51",
    "Queen's Gambit Declined: Modern Variation, Knight Defense",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR b KQkq - c7c5",
    "D50",
    "Queen's Gambit Declined: Been-Koomen Variation",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/2N5/PP2PPPP/R2QKBNR b KQkq - f8e7", "D53", "Queen's Gambit Declined"],
  ["rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/5N2/PP2PPPP/RN1QKB1R b KQkq - c7c6", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/5N2/PP2PPPP/RN1QKB1R b KQkq - f8b4",
    "D30",
    "Queen's Gambit Declined: Vienna Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p2B1/2PP4/5N2/PP2PPPP/RN1QKB1R b KQkq - h7h6",
    "D30",
    "Queen's Gambit Declined: Capablanca Variation",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p2B1/3P4/4PN2/PPP2PPP/RN1QKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p2B1/3P4/5N2/PPP1PPPP/RN1QKB1R w KQkq - e2e3", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p2B1/3PP3/2N5/PPP2PPP/R2QKBNR b KQkq - d5e4",
    "C11",
    "French Defense: Classical Variation, Burn Variation",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p2B1/3PP3/2N5/PPP2PPP/R2QKBNR b KQkq - f8b4", "C12", "French Defense: McCutcheon Variation"],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p2B1/3PP3/2N5/PPP2PPP/R2QKBNR b KQkq - f8e7",
    "C13",
    "French Defense: Classical Variation, Normal Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2P1P3/2N5/PP1P1PPP/R1BQKBNR w KQkq - e4e5",
    "A18",
    "English Opening: Mikenas-Carls Variation",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/1P3N2/P2PPPPP/RNBQKB1R w KQkq - c1b2", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/1P3N2/PB1PPPPP/RN1QKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/1P3N2/PB1PPPPP/RN1QKB1R b KQkq - f8e7", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/2N1PN2/PP1P1PPP/R1BQKB1R b KQkq - f8e7", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/4PN2/PP1P1PPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - c7c5", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - c7c6",
    "A13",
    "English Opening: Agincourt Defense, Catalan Defense, Semi-Slav Defense",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - d5c4",
    "A13",
    "English Opening: Agincourt Defense, Catalan Defense Accepted",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - f8d6",
    "A13",
    "English Opening: Agincourt Defense, Bogoljubow Defense",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - f8e7", "A13", "English Opening: Neo-Catalan Declined"],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b8d7",
    "D37",
    "Queen's Gambit Declined: Barmen Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - c7c5",
    "D40",
    "Queen's Gambit Declined: Semi-Tarrasch Defense",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - c7c6", "D43", "Semi-Slav Defense"],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d5c4",
    "D37",
    "Queen's Gambit Declined: Three Knights, Vienna Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - f8b4",
    "D38",
    "Queen's Gambit Declined: Ragozin Defense",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - f8e7", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - c1f4",
    "D35",
    "Queen's Gambit Declined: Harrwitz Attack",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - c1g5",
    "D50",
    "Queen's Gambit Declined: Modern Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - c4d5",
    "D35",
    "Queen's Gambit Declined: Exchange Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3",
    "D37",
    "Queen's Gambit Declined: Three Knights Variation",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R b KQkq - b7b6", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R b KQkq - f8e7", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3",
    "D37",
    "Queen's Gambit Declined: Three Knights Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - c1g5",
    "D30",
    "Queen's Gambit Declined: Traditional Variation",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - f8b4", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - f8e7", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/6P1/PP2PP1P/RNBQKBNR w KQkq - f1g2", "E01", "Catalan Opening: Closed"],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - d5c4", "E02", "Catalan Opening: Open Defense"],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - f8e7", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/3P4/2N2N2/PPP1PPPP/R1BQKB1R w KQkq - c1g5",
    "A46",
    "Queen's Pawn Game: Veresov Attack, Classical Defense",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3P4/3P4/2N5/PP2PPPP/R1BQKBNR b KQkq - e6d5", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3P4/3P4/2N5/PP2PPPP/R1BQKBNR b KQkq - f6d5", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3P4/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - e6d5", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/3P4/3BPN2/PPP2PPP/RNBQK2R b KQkq - f8d6", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/3P4/4PN2/PPP2PPP/RNBQKB1R w KQkq - f1d3", "D05", "Queen's Pawn Game: Colle System"],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1e3", "C11", "French Defense: Henneberger Variation"],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1g5", "C11", "French Defense: Classical Variation"],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - e4d5",
    "C11",
    "French Defense: Classical Variation, Delayed Exchange Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - e4e5",
    "C11",
    "French Defense: Classical Variation, Steinitz Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - f1d3",
    "C11",
    "French Defense: Classical Variation, Swiss Variation",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/3PP3/8/PPPN1PPP/R1BQKBNR w KQkq - e4e5", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/4P3/3P1N2/PPPN1PPP/R1BQKB1R b KQkq - b8c6", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/4P3/3P1N2/PPPN1PPP/R1BQKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/4P3/3P4/PPPN1PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/8/5NP1/PPPPPPBP/RNBQ1RK1 b kq - f8e7", "A07", "King's Indian Attack, with e6"],
  ["rnbqkb1r/ppp2ppp/4pn2/3p4/8/5NP1/PPPPPPBP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3pP3/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - f6d7", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/3pP3/3P4/8/PPPN1PPP/R1BQKBNR b KQkq - f6d7", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/6B1/3P4/2N2N2/PPP3PP/R2QKB1R b KQkq - f8e7", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/6B1/3PN3/8/PPP2PPP/R2QKBNR b KQkq - f8e7", "C13", "French Defense: Classical Variation"],
  ["rnbqkb1r/ppp2ppp/4pn2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR w KQkq - c3e4", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/8/2BP4/4P3/PP3PPP/RNBQK1NR w KQkq - g1f3", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/8/2BP4/4PN2/PP3PPP/RNBQK2R b KQkq - c7c5",
    "D26",
    "Queen's Gambit Accepted: Classical Defense",
  ],
  [
    "rnbqkb1r/ppp2ppp/4pn2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3",
    "D37",
    "Queen's Gambit Declined: Vienna Variation, Quiet Variation",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e4", "D24", "Queen's Gambit Accepted"],
  ["rnbqkb1r/ppp2ppp/4pn2/8/2pP4/4PN2/PP3PPP/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/8/2pP4/5NP1/PP2PPBP/RNBQK2R b KQkq - b8c6", null, null],
  [
    "rnbqkb1r/ppp2ppp/4pn2/8/2pP4/5NP1/PP2PPBP/RNBQK2R b KQkq - f8e7",
    "E05",
    "Catalan Opening: Open Defense, Classical Line",
  ],
  ["rnbqkb1r/ppp2ppp/4pn2/8/2pP4/6P1/PP2PPBP/RNBQK1NR w KQkq - d1a4", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/8/2pP4/6P1/PP2PPBP/RNBQK1NR w KQkq - g1f3", "E04", "Catalan Opening: Open Defense"],
  ["rnbqkb1r/ppp2ppp/4pn2/8/3P4/2N2N2/PPP3PP/R1BQKB1R w KQkq - c1g5", null, null],
  ["rnbqkb1r/ppp2ppp/4pn2/8/Q1pP4/6P1/PP2PPBP/RNB1K1NR b KQkq - b8d7", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/1B1P4/5p2/5N2/PPPP2PP/RNBQK2R b KQkq - c7c6", null, null],
  [
    "rnbqkb1r/ppp2ppp/5n2/3p2B1/3P4/2N5/PP2PPPP/R2QKBNR b KQkq - c7c6",
    "D35",
    "Queen's Gambit Declined: Exchange Variation, Positional Variation",
  ],
  ["rnbqkb1r/ppp2ppp/5n2/3p2B1/3P4/2N5/PP2PPPP/R2QKBNR b KQkq - f8e7", null, null],
  [
    "rnbqkb1r/ppp2ppp/5n2/3p2B1/3P4/2N5/PPP2PPP/R2QKBNR b KQkq - b8c6",
    "C01",
    "French Defense: Exchange Variation, Bogoljubow Variation",
  ],
  ["rnbqkb1r/ppp2ppp/5n2/3P4/2Bp4/5N2/PPP2PPP/RNBQK2R b KQkq - f8b4", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3p4/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - e4d5", null, null],
  [
    "rnbqkb1r/ppp2ppp/5n2/3p4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - c1g5",
    "D35",
    "Queen's Gambit Declined: Exchange Variation, Positional Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/5n2/3p4/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - c1g5",
    "C01",
    "French Defense: Exchange Variation, Svenonius Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/2N5/PPPP2PP/R1BQKBNR w KQkq - d1e2",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Rubinstein Variation",
  ],
  ["rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/2N5/PPPP2PP/R1BQKBNR w KQkq - d2d3", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/2NP4/PPP3PP/R1BQKBNR b KQkq - f8b4", null, null],
  [
    "rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/3P4/PPP3PP/RNBQKBNR w KQkq - b1d2",
    "C32",
    "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit, Keres Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/3P4/PPP3PP/RNBQKBNR w KQkq - d1e2",
    "C32",
    "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit, Old Line",
  ],
  [
    "rnbqkb1r/ppp2ppp/5n2/3P4/4pP2/3P4/PPP3PP/RNBQKBNR w KQkq - d3e4",
    "C32",
    "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit Accepted",
  ],
  ["rnbqkb1r/ppp2ppp/5n2/3P4/4PP2/8/PPP3PP/RNBQKBNR b KQkq - f6e4", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3P4/5p2/5N2/PPPP2PP/RNBQKB1R w KQkq - f1b5", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3pp3/2P5/6P1/PP1PPPBP/RNBQK1NR w KQkq - c4d5", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3pp3/4P3/2N3P1/PPPP1P1P/R1BQKBNR w KQkq - e4d5", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3pP3/4P3/2N5/PPPP2PP/R1BQKBNR b KQkq - f6e4", null, null],
  [
    "rnbqkb1r/ppp2ppp/5n2/3pp3/4PP2/2N5/PPPP2PP/R1BQKBNR w KQkq - d2d3",
    "C29",
    "Vienna Game: Vienna Gambit, Steinitz Variation",
  ],
  ["rnbqkb1r/ppp2ppp/5n2/3pp3/4PP2/2N5/PPPP2PP/R1BQKBNR w KQkq - e4d5", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3pp3/4PP2/2N5/PPPP2PP/R1BQKBNR w KQkq - f4e5", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3Pp3/5P2/2N5/PPPP2PP/R1BQKBNR b KQkq - e5e4", null, null],
  [
    "rnbqkb1r/ppp2ppp/5n2/3Pp3/8/2N3P1/PPPP1P1P/R1BQKBNR b KQkq - c7c6",
    "C26",
    "Vienna Game: Mieses Variation, Erben Gambit",
  ],
  ["rnbqkb1r/ppp2ppp/5n2/3Pp3/8/6P1/PP1PPPBP/RNBQK1NR b KQkq - f6d5", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3pp3/8/P2P2P1/1PP1PPBP/RNBQK1NR b KQkq - b8c6", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3pp3/8/P5P1/1PPPPPBP/RNBQK1NR w KQkq - d2d3", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3pp3/8/PPP5/3PPPPP/RNBQKBNR w KQkq - d2d3", null, null],
  ["rnbqkb1r/ppp2ppp/5n2/3pp3/8/PPPP4/4PPPP/RNBQKBNR b KQkq - b8c6", null, null],
  [
    "rnbqkb1r/ppp2ppp/8/3np3/8/5NP1/PP1PPPBP/RNBQK2R b KQkq - b8c6",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line",
  ],
  ["rnbqkb1r/ppp2ppp/8/3np3/8/6P1/PP1PPPBP/RNBQK1NR w KQkq - g1f3", null, null],
  [
    "rnbqkb1r/ppp2ppp/8/3p4/3Pn3/3B1N2/PPP2PPP/RNBQK2R b KQkq - b8c6",
    "C42",
    "Petrov's Defense: Classical Attack, Mason-Showalter Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/8/3p4/3Pn3/3B1N2/PPP2PPP/RNBQK2R b KQkq - f8d6",
    "C42",
    "Petrov's Defense: Classical Attack, Marshall Variation",
  ],
  ["rnbqkb1r/ppp2ppp/8/3p4/3Pn3/3B1N2/PPP2PPP/RNBQK2R b KQkq - f8e7", null, null],
  ["rnbqkb1r/ppp2ppp/8/3p4/3Pn3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  ["rnbqkb1r/ppp2ppp/8/3P4/4nP2/5N2/PPP3PP/RNBQKB1R b KQkq - f8c5", null, null],
  ["rnbqkb1r/ppp2ppp/8/3P4/4nP2/8/PPP1Q1PP/RNB1KBNR b KQkq - d8d5", null, null],
  [
    "rnbqkb1r/ppp2ppp/8/3P4/4nP2/8/PPP3PP/RNBQKBNR w KQkq - d1e2",
    "C32",
    "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit",
  ],
  ["rnbqkb1r/ppp2ppp/8/3P4/4nP2/8/PPP3PP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp2ppp/8/3pN3/3Pn3/3B4/PPP2PPP/RNBQK2R b KQkq - f8d6", null, null],
  ["rnbqkb1r/ppp2ppp/8/3pp3/3Pn3/3B1N2/PPP2PPP/RNBQK2R w KQkq - f3e5", null, null],
  ["rnbqkb1r/ppp2ppp/8/3pP3/4n3/2N2N2/PPPP2PP/R1BQKB1R b KQkq - c8g4", null, null],
  [
    "rnbqkb1r/ppp2ppp/8/3pP3/4n3/2N2N2/PPPP2PP/R1BQKB1R b KQkq - f8e7",
    "C29",
    "Vienna Game: Vienna Gambit, Breyer Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/8/3pP3/4n3/2N2Q2/PPPP2PP/R1B1KBNR b KQkq - f7f5",
    "C29",
    "Vienna Game: Vienna Gambit, Bardeleben Variation",
  ],
  [
    "rnbqkb1r/ppp2ppp/8/3pP3/4n3/2N5/PPPP2PP/R1BQKBNR w KQkq - d1f3",
    "C29",
    "Vienna Game: Vienna Gambit, Paulsen Attack",
  ],
  [
    "rnbqkb1r/ppp2ppp/8/3pP3/4n3/2N5/PPPP2PP/R1BQKBNR w KQkq - d2d3",
    "C29",
    "Vienna Game: Vienna Gambit, Modern Variation",
  ],
  ["rnbqkb1r/ppp2ppp/8/3pP3/4n3/2N5/PPPP2PP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/ppp2ppp/8/3pP3/4n3/2NP4/PPP3PP/R1BQKBNR b KQkq - d8h4", null, null],
  [
    "rnbqkb1r/ppp3pp/3p3n/5pN1/2BpP3/8/PPP2PPP/RNBQK2R w KQkq - g5h7",
    "C41",
    "Philidor Defense: Lopez Countergambit, Jaenisch Variation",
  ],
  ["rnbqkb1r/ppp3pp/4pn2/3p1p2/2PP4/6P1/PP2PPBP/RNBQK1NR w KQkq - g1f3", "A90", "Dutch Defense: Classical Variation"],
  ["rnbqkb1r/ppp3pp/8/3pPp2/4n3/2N2Q2/PPPP2PP/R1B1KBNR w KQkq f6 d2d4", "C29", "Vienna Game: Heyde Variation"],
  ["rnbqkb1r/pppn1ppp/4p3/3pP3/3P1P2/2N5/PPP3PP/R1BQKBNR b KQkq - c7c5", null, null],
  [
    "rnbqkb1r/pppn1ppp/4p3/3pP3/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - c3e2",
    "C11",
    "French Defense: Classical Variation, Shirov-Anand Variation",
  ],
  [
    "rnbqkb1r/pppn1ppp/4p3/3pP3/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - d1g4",
    "C11",
    "French Defense: Steinitz Variation, Gledhill Attack",
  ],
  ["rnbqkb1r/pppn1ppp/4p3/3pP3/3P4/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f4", null, null],
  ["rnbqkb1r/pppn1ppp/4p3/3pP3/3P4/3B4/PPPN1PPP/R1BQK1NR b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppn1ppp/4p3/3pP3/3P4/8/PPPN1PPP/R1BQKBNR w KQkq - f1d3", null, null],
  [
    "rnbqkb1r/pppn1ppp/4p3/3pP3/3P4/8/PPPN1PPP/R1BQKBNR w KQkq - f2f4",
    "C05",
    "French Defense: Tarrasch Variation, Pawn Center Variation",
  ],
  ["rnbqkb1r/pppnpppp/8/3pP3/8/2N5/PPPP1PPP/R1BQKBNR w KQkq - e5e6", "B02", "Alekhine Defense: Spielmann Gambit"],
  ["rnbqkb1r/pppp1Npp/5n2/8/2B1p3/8/PPPP1PPP/RNBQK2R b KQkq - d8e7", null, null],
  ["rnbqkb1r/pppp1p1p/5n2/4N3/2B1PppP/8/PPPP2P1/RNBQK2R b KQkq - d7d5", null, null],
  [
    "rnbqkb1r/pppp1p1p/5n2/4N3/4PppP/8/PPPP2P1/RNBQKB1R w KQkq - d2d4",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Berlin Defense, Rubinstein Variation",
  ],
  ["rnbqkb1r/pppp1p1p/5n2/4N3/4PppP/8/PPPP2P1/RNBQKB1R w KQkq - e5g4", null, null],
  ["rnbqkb1r/pppp1p1p/5n2/4N3/4PppP/8/PPPP2P1/RNBQKB1R w KQkq - f1c4", null, null],
  [
    "rnbqkb1r/pppp1p1p/5n2/8/4PpNP/8/PPPP2P1/RNBQKB1R b KQkq - d7d5",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Berlin Defense, de Riviere Variation",
  ],
  ["rnbqkb1r/pppp1ppp/3n4/4p2Q/2B5/2N5/PPPP1PPP/R1B1K1NR w KQkq - c4b3", null, null],
  ["rnbqkb1r/pppp1ppp/3n4/4p2Q/8/1BN5/PPPP1PPP/R1B1K1NR b KQkq - b8c6", null, null],
  [
    "rnbqkb1r/pppp1ppp/3n4/4p2Q/8/1BN5/PPPP1PPP/R1B1K1NR b KQkq - f8e7",
    "C27",
    "Vienna Game: Stanley Variation, Monster Declined",
  ],
  [
    "rnbqkb1r/pppp1ppp/4p3/2PnP3/2B5/2N5/PP1P1PPP/R1BQK1NR b KQkq - d7d6",
    "B02",
    "Alekhine Defense: Two Pawns Attack, Mikenas Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/4p3/2PnP3/2B5/8/PP1P1PPP/RNBQK1NR w KQkq - b1c3",
    "B02",
    "Alekhine Defense: Hunt Variation, Lasker Simul Gambit",
  ],
  ["rnbqkb1r/pppp1ppp/4pn2/1P6/8/8/PBPPPPPP/RN1QKBNR b KQkq - a7a6", "A00", "Polish Opening: Queenside Defense"],
  ["rnbqkb1r/pppp1ppp/4pn2/1P6/8/8/PBPPPPPP/RN1QKBNR b KQkq - b7b6", "A00", "Polish Opening: Queen's Indian Variation"],
  ["rnbqkb1r/pppp1ppp/4pn2/1P6/8/8/PBPPPPPP/RN1QKBNR b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R b KQkq - d7d5", null, null],
  [
    "rnbqkb1r/pppp1ppp/4pn2/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R b KQkq - h7h6",
    "A46",
    "Torre Attack: Classical Defense, Nimzowitsch Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/4pn2/6B1/3P4/8/PPP1PPPP/RN1QKBNR w KQkq - e2e4",
    "A45",
    "Trompowsky Attack: Classical Defense, Big Center Variation",
  ],
  ["rnbqkb1r/pppp1ppp/4pn2/8/1P6/8/PBPPPPPP/RN1QKBNR w KQkq - b4b5", null, null],
  [
    "rnbqkb1r/pppp1ppp/4pn2/8/2P1P3/2N5/PP1P1PPP/R1BQKBNR b KQkq - b8c6",
    "A18",
    "English Opening: Mikenas-Carls Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/4pn2/8/2P1P3/2N5/PP1P1PPP/R1BQKBNR b KQkq - c7c5",
    "A19",
    "English Opening: Mikenas-Carls, Sicilian",
  ],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P1P3/2N5/PP1P1PPP/R1BQKBNR b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P5/1P3N2/P2PPPPP/RNBQKB1R b KQkq - d7d5", null, null],
  [
    "rnbqkb1r/pppp1ppp/4pn2/8/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - b7b6",
    "A17",
    "English Opening: Anglo-Indian Defense, Queen's Indian Formation",
  ],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - c7c5", null, null],
  [
    "rnbqkb1r/pppp1ppp/4pn2/8/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - f8b4",
    "A17",
    "English Opening: Anglo-Indian Defense, Nimzo-English",
  ],
  [
    "rnbqkb1r/pppp1ppp/4pn2/8/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - e2e4",
    "A18",
    "English Opening: Mikenas-Carls Variation",
  ],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b2b3", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - g2g3", null, null],
  [
    "rnbqkb1r/pppp1ppp/4pn2/8/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - a7a6",
    "A15",
    "English Opening: Anglo-Indian Defense, Romanishin Variation",
  ],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - b7b6", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - d7d5", "A13", "English Opening: Neo-Catalan"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - c7c5", null, null],
  [
    "rnbqkb1r/pppp1ppp/4pn2/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d5",
    "D35",
    "Queen's Gambit Declined: Normal Defense",
  ],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - f8b4", "E20", "Nimzo-Indian Defense"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - a7a6", "E10", "Indian Defense: Dzindzi-Indian Defense"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - b7b6", "E12", "Queen's Indian Defense"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - f6e4", "E10", "Indian Defense: Döry Indian"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - f8b4", "E11", "Bogo-Indian Defense"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - d7d5", "E00", "Catalan Opening"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - e6e5", "E00", "Catalan Opening: Hungarian Gambit"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - f8b4", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - f8e7", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - c1g5", "E00", "Indian Defense: Seirawan Attack"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d1b3", "E00", "Indian Defense"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", "E10", "Indian Defense: Anti-Nimzo-Indian"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g2g3", "E00", "Catalan Opening"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g2g4", "E00", "Indian Defense: Devin Gambit"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/3P4/2N2N2/PPP1PPPP/R1BQKB1R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - b7b6", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppp1ppp/4pn2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1f4", "A46", "Indian Defense: London System"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1g5", "A46", "Torre Attack: Classical Defense"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c2c4", "E10", "Indian Defense: Anti-Nimzo-Indian"],
  ["rnbqkb1r/pppp1ppp/4pn2/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - e2e3", "A46", "Yusupov-Rubinstein System"],
  ["rnbqkb1r/pppp1ppp/5n2/1B2p3/4P3/8/PPPP1PPP/RNBQK1NR w KQkq - d2d4", "C20", "Portuguese Opening: Portuguese Gambit"],
  ["rnbqkb1r/pppp1ppp/5n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - b8c6", "C42", "Petrov's Defense: Stafford Gambit"],
  ["rnbqkb1r/pppp1ppp/5n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - d7d6", "C42", "Petrov's Defense"],
  ["rnbqkb1r/pppp1ppp/5n2/4N3/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - f6e4", "C42", "Petrov's Defense: Damiano Variation"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR b KQkq - b7b5", "C26", "Bishop's Opening: Horwitz Gambit"],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR b KQkq - f6e4",
    "C27",
    "Vienna Game: Frankenstein-Dracula Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR b KQkq - f8b4",
    "C26",
    "Vienna Game: Stanley Variation, Reversed Spanish",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/2N5/PPPP1PPP/R1BQK1NR b KQkq - f8c5", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/3P4/PPP2PPP/RNBQK1NR b KQkq - b8c6", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/3P4/PPP2PPP/RNBQK1NR b KQkq - c7c6", "C24", "Bishop's Opening: Paulsen Defense"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/3P4/PPP2PPP/RNBQK1NR b KQkq - f8e7", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f6e4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/5P2/PPPP2PP/RNBQK1NR b KQkq - f8c5", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - b1c3", "C26", "Vienna Game: Stanley Variation"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - d2d3", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - d2d4", "C24", "Bishop's Opening: Ponziani Gambit"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - f2f3", "C20", "Barnes Opening: Walkerling"],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - f2f4",
    "C24",
    "Bishop's Opening: Berlin Defense, Greco Gambit",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - g1e2", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2B1P3/8/PPPPNPPP/RNBQK2R b KQkq - f6e4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2BPP3/8/PPP2PPP/RNBQK1NR b KQkq - e5d4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P2P2/4P3/PP1P2PP/RNBQKBNR b KQkq - e5f4", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - b8c6",
    "A28",
    "English Opening: King's English Variation, Four Knights Variation",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - e5e4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - b8c6", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - c7c6",
    "A23",
    "English Opening: King's English Variation, Two Knights Variation, Keres Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - d7d5",
    "A22",
    "English Opening: King's English Variation, Two Knights Variation, Reversed Dragon",
  ],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - f8b4",
    "A22",
    "English Opening: King's English Variation, Two Knights Variation, Smyslov System",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - f8c5", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - g7g6",
    "A24",
    "English Opening: King's English Variation, Two Knights Variation, Fianchetto Line",
  ],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - f2f4",
    "A22",
    "English Opening: King's English, Mazedonisch",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g2g3", "A22", "English Opening: Carls-Bremen System"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P5/4P3/PP1P1PPP/RNBQKBNR w KQkq - f2f4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P5/6P1/PP1PPP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2P5/6P1/PP1PPPBP/RNBQK1NR b KQkq - d7d5", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/4P3/2P5/8/PP2PPPP/RNBQKBNR b KQkq - f6e4",
    "A51",
    "Indian Defense: Budapest Defense, Fajarowicz Variation",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/4P3/2P5/8/PP2PPPP/RNBQKBNR b KQkq - f6g4", "A52", "Indian Defense: Budapest Defense"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4e5", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4P3/3p4/5N2/PPP2PPP/RNBQKB1R b KQkq - f6e4", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - d7d5",
    "C43",
    "Petrov's Defense: Modern Attack, Symmetrical Variation",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - e5d4", "C43", "Petrov's Defense: Modern Attack"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - f6e4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P1Q1/8/PPPP1PPP/RNB1KBNR w KQkq - g4f5", "C20", "King's Pawn Opening: Speers"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - b8c6", "C47", "Four Knights Game"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N3P1/PPPP1P1P/R1BQKBNR b KQkq - f8c5", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - a2a3", "C26", "Vienna Game: Mengarini Variation"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f1c4", "C26", "Vienna Game: Stanley Variation"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f2f4", "C29", "Vienna Game: Vienna Gambit"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - g2g3", "C26", "Vienna Game: Mieses Variation"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/3P4/PPP2PPP/RNBQKBNR w KQkq - f2f4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3", "C42", "Petrov's Defense: Three Knights Game"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d1e2", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "C43", "Petrov's Defense: Modern Attack"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1c4", "C42", "Petrov's Defense: Italian Variation"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f3e5", "C42", "Petrov's Defense"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5N2/PPPPQPPP/RNB1KB1R b KQkq - b8c6", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5P2/PPPP2PP/RNBQKBNR w KQkq - b1c3", "C20", "King's Pawn Game: King's Head Opening"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4P3/5P2/PPPP2PP/RNBQKBNR w KQkq - f1c4", "C20", "Barnes Opening: Walkerling"],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/4PP2/2N5/PPPP2PP/R1BQKBNR b KQkq - d7d5", "C29", "Vienna Game: Vienna Gambit, Main Line"],
  [
    "rnbqkb1r/pppp1ppp/5n2/4p3/4PP2/3P4/PPP3PP/RNBQKBNR b KQkq - f8c5",
    "C20",
    "King's Pawn Game: Clam Variation, Radisch Gambit",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/5P2/2N1P3/PPPP2PP/R1BQKBNR b KQkq - e5f4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4P3/5p2/5N2/PPPP2PP/RNBQKB1R b KQkq - f6h5", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/4p3/8/2N1P3/PPPP1PPP/R1BQKBNR w KQkq - f2f4", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/6N1/2P1p3/2N5/PP1PPPPP/R1BQKB1R b KQkq - b7b5",
    "A22",
    "English Opening: King's English Variation, Bellon Gambit",
  ],
  [
    "rnbqkb1r/pppp1ppp/5n2/6N1/2P1p3/2N5/PP1PPPPP/R1BQKB1R b KQkq - c7c6",
    "A22",
    "English Opening: King's English Variation, Adhiban Gambit",
  ],
  [
    "rnbqkb1r/pppp1ppp/5n2/6N1/2P1p3/2N5/PP1PPPPP/R1BQKB1R b KQkq - f6g4",
    "A22",
    "English Opening: King's English, Erbenheimer Gambit",
  ],
  [
    "rnbqkb1r/pppp1ppp/5n2/8/2B1Pp2/2N5/PPPP2PP/R1BQK1NR b KQkq - c7c6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Bogoljubow Defense",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/8/2B1Pp2/2N5/PPPP2PP/R1BQK1NR b KQkq - f8b4", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/8/2B1Pp2/8/PPPP2PP/RNBQK1NR w KQkq - b1c3",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Bogoljubow Variation",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/8/2BpP3/5N2/PPP2PPP/RNBQK2R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/8/2BpP3/5N2/PPP2PPP/RNBQK2R b KQkq - f6e4", null, null],
  ["rnbqkb1r/pppp1ppp/5n2/8/2BpP3/8/PPP2PPP/RNBQK1NR w KQkq - c2c3", "C24", "Bishop's Opening: Warsaw Gambit"],
  ["rnbqkb1r/pppp1ppp/5n2/8/2BpP3/8/PPP2PPP/RNBQK1NR w KQkq - g1f3", "C43", "Bishop's Opening: Urusov Gambit"],
  ["rnbqkb1r/pppp1ppp/5n2/8/2P1p3/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - f3g5", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/8/2P2p2/4P3/PP1P2PP/RNBQKBNR w KQkq - g1f3",
    "A20",
    "English Opening: King's English Variation, Kahiko-Hula Gambit",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - e4e5", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/8/4p3/6P1/PPPPPP1P/RNBQKBNR w KQkq - b2b4",
    "A00",
    "Hungarian Opening: Reversed Brooklyn Defense, Brooklyn Benko Gambit",
  ],
  ["rnbqkb1r/pppp1ppp/5n2/8/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - e4e5", null, null],
  [
    "rnbqkb1r/pppp1ppp/5n2/8/5p2/2N1P3/PPPP2PP/R1BQKBNR w KQkq - g1f3",
    "A00",
    "Van't Kruijs Opening: Keoni-Hiva Gambit, Akahi Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/2n1P3/3N4/8/PPP1QPPP/RNB1KB1R b KQkq - b8c6",
    "C43",
    "Petrov's Defense: Modern Attack, Bardeleben Variation",
  ],
  ["rnbqkb1r/pppp1ppp/8/2n1P3/3p4/5N2/PPP1QPPP/RNB1KB1R w KQkq - f3d4", null, null],
  ["rnbqkb1r/pppp1ppp/8/4n3/2P1P3/8/PP3PPP/RNBQKBNR w KQkq - f2f4", null, null],
  [
    "rnbqkb1r/pppp1ppp/8/4n3/2P1PP2/8/PP4PP/RNBQKBNR b KQkq - e5c6",
    "A52",
    "Indian Defense: Budapest Defense, Alekhine Variation, Abonyi Variation",
  ],
  ["rnbqkb1r/pppp1ppp/8/4N3/4n3/8/PPPP1PPP/RNBQKB1R w KQkq - d1e2", null, null],
  [
    "rnbqkb1r/pppp1ppp/8/4N3/4n3/8/PPPPQPPP/RNB1KB1R b KQkq - d8e7",
    "C42",
    "Petrov's Defense: Damiano Variation, Kholmov Gambit",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4P2n/5p2/5N2/PPPP2PP/RNBQKB1R w KQkq - g2g4",
    "C34",
    "King's Gambit Accepted: Schallopp Defense, Tashkent Attack",
  ],
  ["rnbqkb1r/pppp1ppp/8/4p2Q/2B1n3/2N5/PPPP1PPP/R1B1K1NR b KQkq - e4d6", null, null],
  [
    "rnbqkb1r/pppp1ppp/8/4p3/2B1n3/2N2N2/PPPP1PPP/R1BQK2R b KQkq - d7d5",
    "C27",
    "Bishop's Opening: Boden-Kieseritzky Gambit, Lichtenhein Defense",
  ],
  ["rnbqkb1r/pppp1ppp/8/4p3/2B1n3/2N5/PPPP1PPP/R1BQK1NR w KQkq - d1h5", null, null],
  [
    "rnbqkb1r/pppp1ppp/8/4p3/2B1n3/5N2/PPPP1PPP/RNBQK2R w KQkq - b1c3",
    "C27",
    "Bishop's Opening: Boden-Kieseritzky Gambit",
  ],
  ["rnbqkb1r/pppp1ppp/8/4p3/2B1n3/8/PPPPNPPP/RNBQK2R w KQkq - e2c3", "C24", "Bishop's Opening: Pachman Gambit"],
  ["rnbqkb1r/pppp1ppp/8/4P3/2P1n3/8/PP2PPPP/RNBQKBNR w KQkq - a2a3", null, null],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/2P1n3/8/PP2PPPP/RNBQKBNR w KQkq - d1c2",
    "A51",
    "Indian Defense: Budapest Defense, Fajarowicz-Steiner Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/2P1n3/P7/1P2PPPP/RNBQKBNR b KQkq - b7b6",
    "A51",
    "Indian Defense: Budapest Defense, Fajarowicz Defense, Bonsdorf Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/2P1P1n1/8/PP3PPP/RNBQKBNR b KQkq - d7d6",
    "A52",
    "Indian Defense: Budapest Defense, Alekhine Variation, Tartakower Defense",
  ],
  ["rnbqkb1r/pppp1ppp/8/4P3/2P1P1n1/8/PP3PPP/RNBQKBNR b KQkq - g4e5", null, null],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/2P3n1/8/PP2PPPP/RNBQKBNR w KQkq - c1f4",
    "A52",
    "Indian Defense: Budapest Defense, Rubinstein Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/2P3n1/8/PP2PPPP/RNBQKBNR w KQkq - e2e4",
    "A52",
    "Indian Defense: Budapest Defense, Alekhine Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/2P3n1/8/PP2PPPP/RNBQKBNR w KQkq - g1f3",
    "A52",
    "Indian Defense: Budapest Defense, Adler Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4p3/3Pn3/3B1N2/PPP2PPP/RNBQK2R b KQkq - b8c6",
    "C43",
    "Petrov's Defense: Modern Attack, Murrey Variation",
  ],
  ["rnbqkb1r/pppp1ppp/8/4p3/3Pn3/3B1N2/PPP2PPP/RNBQK2R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppp1ppp/8/4P3/3pn3/5N2/PPP1QPPP/RNB1KB1R b KQkq - e4c5", null, null],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/3pn3/5N2/PPP2PPP/RNBQKB1R w KQkq - d1d4",
    "C43",
    "Petrov's Defense: Modern Attack, Center Attack",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/3pn3/5N2/PPP2PPP/RNBQKB1R w KQkq - d1e2",
    "C43",
    "Petrov's Defense: Modern Attack, Steinitz Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4P3/3pn3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1b5",
    "C43",
    "Petrov's Defense: Modern Attack, Tal Gambit",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/4p3/3Pn3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1d3",
    "C43",
    "Petrov's Defense: Modern Attack, Center Variation",
  ],
  [
    "rnbqkb1r/pppp1ppp/8/8/2Bpn3/5N2/PPP2PPP/RNBQK2R w KQkq - d1d4",
    "C43",
    "Bishop's Opening: Urusov Gambit, Keidansky Gambit",
  ],
  ["rnbqkb1r/pppp2pp/4pn2/5p2/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/pppp2pp/4pn2/5p2/2PP4/5NP1/PP2PP1P/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkb1r/pppp2pp/4pn2/5p2/2PP4/6P1/PP2PP1P/RNBQKBNR w KQkq - f1g2", "A90", "Dutch Defense: Classical Variation"],
  ["rnbqkb1r/pppp2pp/4pn2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppp2pp/4pn2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - f8b4", "A90", "Dutch Defense: Nimzo-Dutch Variation"],
  ["rnbqkb1r/pppp2pp/4pn2/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - f8e7", "A91", "Dutch Defense: Classical Variation"],
  ["rnbqkb1r/pppp2pp/4pn2/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR w KQkq - g1h3", "A81", "Dutch Defense: Blackburne Variation"],
  ["rnbqkb1r/pppp2pp/5n2/4N3/2B1p3/8/PPPP1PPP/RNBQK2R w KQkq - e5f7", null, null],
  [
    "rnbqkb1r/pppp2pp/5n2/4Np2/2B1P3/8/PPPP1PPP/RNBQK2R b KQkq - f5e4",
    "C40",
    "Latvian Gambit: Corkscrew Countergambit",
  ],
  ["rnbqkb1r/pppp2pp/5n2/4Np2/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/2P1P3/2N5/PP1P1PPP/R1BQKBNR b KQkq - f5e4", null, null],
  [
    "rnbqkb1r/ppppp1pp/5n2/5p2/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - e2e4",
    "A10",
    "English Opening: Anglo-Dutch Variation, Ferenc Gambit",
  ],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - e7e6", null, null],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - g7g6", "A86", "Dutch Defense: Leningrad Variation"],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", "A85", "Dutch Defense: Queen's Knight Variation"],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g2g3", "A86", "Dutch Defense: Fianchetto Variation"],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/3P4/2N5/PPP1PPPP/R1BQKBNR w KQkq - g2g4", "A80", "Dutch Defense: Spielmann Gambit"],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/3P4/6P1/PPP1PP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR b KQkq - e7e6", null, null],
  [
    "rnbqkb1r/ppppp1pp/5n2/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR b KQkq - g7g6",
    "A81",
    "Dutch Defense: Semi-Leningrad Variation",
  ],
  ["rnbqkb1r/ppppp1pp/5n2/5p2/3P4/7P/PPP1PPP1/RNBQKBNR w KQkq - g2g4", "A80", "Dutch Defense: Janzen-Korchnoi Gambit"],
  [
    "rnbqkb1r/ppppp1pp/5n2/5p2/8/3P1N2/PPP1PPPP/RNBQKB1R w KQkq - e2e4",
    "A04",
    "Zukertort Opening: Lisitsyn Gambit Deferred",
  ],
  [
    "rnbqkb1r/ppppp1pp/5n2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR b KQkq - b7b6",
    "A83",
    "Dutch Defense: Staunton Gambit, Nimzowitsch Variation",
  ],
  [
    "rnbqkb1r/ppppp1pp/5n2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR b KQkq - c7c6",
    "A83",
    "Dutch Defense: Staunton Gambit, Chigorin Variation",
  ],
  ["rnbqkb1r/ppppp1pp/5n2/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/ppppp1pp/5n2/8/2P1p3/2N5/PP1P1PPP/R1BQKBNR w KQkq - g2g4", "A10", "English Opening: Porcupine Variation"],
  ["rnbqkb1r/ppppp1pp/5n2/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1g5", "A83", "Dutch Defense: Staunton Gambit"],
  ["rnbqkb1r/ppppp1pp/5n2/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f3", "A82", "Dutch Defense: Blackmar's Second Gambit"],
  [
    "rnbqkb1r/ppppp1pp/5n2/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - g2g4",
    "A82",
    "Dutch Defense: Staunton Gambit, Tartakower Variation",
  ],
  ["rnbqkb1r/ppppp1pp/5n2/8/4pP2/2N5/PPPP2PP/R1BQKBNR w KQkq - g2g4", "A02", "Bird Opening: Swiss Gambit"],
  [
    "rnbqkb1r/ppppp1pp/5p1n/8/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - h6f7",
    "A04",
    "Zukertort Opening: Arctic Defense, Drunken Knight Variation",
  ],
  ["rnbqkb1r/ppppp1pp/5p1n/8/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkb1r/ppppp2p/5np1/5p2/2PP4/6P1/PP2PP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkb1r/ppppp2p/5np1/5p2/2PP4/6P1/PP2PPBP/RNBQK1NR b KQkq - f8g7", null, null],
  ["rnbqkb1r/ppppp2p/5np1/5p2/3P4/5NP1/PPP1PPBP/RNBQK2R b KQkq - f8g7", null, null],
  ["rnbqkb1r/ppppp2p/5np1/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR w KQkq - g1f3", null, null],
  [
    "rnbqkb1r/ppppp2p/5np1/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR w KQkq - f2f3",
    "A83",
    "Dutch Defense: Staunton Gambit, Lasker Variation",
  ],
  [
    "rnbqkb1r/ppppp2p/5np1/6B1/3Pp3/2N5/PPP2PPP/R2QKBNR w KQkq - h2h4",
    "A83",
    "Dutch Defense: Staunton Gambit, Alekhine Variation",
  ],
  ["rnbqkb1r/ppppp2p/6pB/5p2/3PP3/2N5/PPP2PPP/R2QKBNR b KQkq - f8h6", null, null],
  ["rnbqkb1r/ppppp2p/6pn/5p2/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1h6", null, null],
  [
    "rnbqkb1r/pppppp1p/5np1/3P4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - b7b5",
    "E60",
    "Indian Defense: Anti-Grünfeld, Adorjan Gambit",
  ],
  ["rnbqkb1r/pppppp1p/5np1/4P3/3P4/8/PPP2PPP/RNBQKBNR b KQkq - f6h5", null, null],
  ["rnbqkb1r/pppppp1p/5np1/6B1/3P4/5N2/PPP1PPPP/RN1QKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/1P6/5N2/P1PPPPPP/RNBQKB1R w KQkq - c1b2", "A05", "Polish Opening: Zukertort System"],
  ["rnbqkb1r/pppppp1p/5np1/8/1P6/8/PBPPPPPP/RN1QKBNR w KQkq - c2c4", null, null],
  [
    "rnbqkb1r/pppppp1p/5np1/8/1P6/8/PBPPPPPP/RN1QKBNR w KQkq - e2e4",
    "A00",
    "Polish Opening: King's Indian Variation, Schiffler Attack",
  ],
  ["rnbqkb1r/pppppp1p/5np1/8/1PP5/8/PB1PPPPP/RN1QKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b2b4", "A15", "English Orangutan"],
  ["rnbqkb1r/pppppp1p/5np1/8/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - b7b6", null, null],
  [
    "rnbqkb1r/pppppp1p/5np1/8/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - c7c6",
    "A15",
    "English Opening: Anglo-Indian Defense, Slav Formation",
  ],
  [
    "rnbqkb1r/pppppp1p/5np1/8/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - d7d5",
    "A15",
    "English Opening: Anglo-Indian Defense, Grünfeld Formation",
  ],
  ["rnbqkb1r/pppppp1p/5np1/8/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d5", "D80", "Grünfeld Defense"],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - d7d5", "D70", "Neo-Grünfeld Defense: with Nf3"],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/5P2/PP2P1PP/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/5P2/PP2P1PP/RNBQKBNR b KQkq - d7d5", "D70", "Neo-Grünfeld Defense: Goglidze Attack"],
  [
    "rnbqkb1r/pppppp1p/5np1/8/2PP4/5P2/PP2P1PP/RNBQKBNR b KQkq - e7e5",
    "E60",
    "Indian Defense: Anti-Grünfeld, Alekhine Variation, Leko Gambit",
  ],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - d7d5", "D70", "Neo-Grünfeld Defense: with g3"],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/6P1/PP2PP1P/RNBQKBNR b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", "E61", "King's Indian Defense"],
  ["rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d1c2", "E60", "Queen's Pawn, Mengarini Attack"],
  [
    "rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4d5",
    "E60",
    "Indian Defense: Anti-Grünfeld, Advance Variation",
  ],
  [
    "rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - f2f3",
    "E60",
    "Indian Defense: Anti-Grünfeld, Alekhine Variation",
  ],
  [
    "rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3",
    "E60",
    "King's Indian Defense: Normal Variation, King's Knight Variation",
  ],
  [
    "rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g2g3",
    "E60",
    "King's Indian Defense: Fianchetto Variation, Immediate Fianchetto",
  ],
  [
    "rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - h2h4",
    "E60",
    "Indian Defense: Anti-Grünfeld, Basman-Williams Attack",
  ],
  ["rnbqkb1r/pppppp1p/5np1/8/3P1B2/5N2/PPP1PPPP/RN1QKB1R b KQkq - f8g7", null, null],
  [
    "rnbqkb1r/pppppp1p/5np1/8/3P3P/8/PPP1PPP1/RNBQKBNR w KQkq - h4h5",
    "A40",
    "Modern Defense: Lizard Defense, Pirc-Diemer Gambit",
  ],
  ["rnbqkb1r/pppppp1p/5np1/8/3P4/2N2N2/PPP1PPPP/R1BQKB1R b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1f4", "A48", "London System"],
  ["rnbqkb1r/pppppp1p/5np1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1g5", "A48", "Torre Attack: Fianchetto Defense"],
  [
    "rnbqkb1r/pppppp1p/5np1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c2c4",
    "E60",
    "King's Indian Defense: Normal Variation, King's Knight Variation",
  ],
  ["rnbqkb1r/pppppp1p/5np1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - g2g3", "A49", "Indian Defense: Przepiorka Variation"],
  ["rnbqkb1r/pppppp1p/5np1/8/3P4/5NP1/PPP1PP1P/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - e4e5", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/5P2/5N2/PPPPP1PP/RNBQKB1R w KQkq - b2b4", "A02", "Bird Opening: Batavo-Polish Attack"],
  ["rnbqkb1r/pppppp1p/5np1/8/8/1P3NP1/P1PPPP1P/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/8/1P6/PBPPPPPP/RN1QKBNR w KQkq - g2g4", "A01", "Nimzo-Larsen Attack: Spike Variation"],
  ["rnbqkb1r/pppppp1p/5np1/8/8/5NP1/PPPPPP1P/RNBQKB1R w KQkq - b2b3", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/8/5NP1/PPPPPP1P/RNBQKB1R w KQkq - b2b4", "A05", "King's Indian Attack: Smyslov Variation"],
  ["rnbqkb1r/pppppp1p/5np1/8/8/5NP1/PPPPPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/8/5NP1/PPPPPPBP/RNBQK2R b KQkq - f8g7", null, null],
  ["rnbqkb1r/pppppp1p/5np1/8/P7/5N2/1PPPPPPP/RNBQKB1R w KQkq - b2b4", "A05", "Zukertort Opening: Myers Polish Attack"],
  [
    "rnbqkb1r/pppppp1p/6p1/4P2n/3P4/8/PPP1BPPP/RNBQK1NR b KQkq - d7d6",
    "B06",
    "Modern Defense: Norwegian Defense, Norwegian Gambit",
  ],
  ["rnbqkb1r/pppppp1p/6p1/4P2n/3P4/8/PPP2PPP/RNBQKBNR w KQkq - f1e2", null, null],
  ["rnbqkb1r/pppppp1p/6pn/8/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - f7f6", "B00", "Hippopotamus Defense"],
  ["rnbqkb1r/pppppp1p/6pn/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - f7f5", null, null],
  ["rnbqkb1r/pppppp1p/6pn/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppppp1p/6pn/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkb1r/pppppppp/1n6/2P1P3/8/8/PP1P1PPP/RNBQKBNR b KQkq - b6d5", null, null],
  ["rnbqkb1r/pppppppp/1n6/4P3/2B5/8/PPPP1PPP/RNBQK1NR w KQkq - c4b3", null, null],
  [
    "rnbqkb1r/pppppppp/1n6/4P3/2P5/8/PP1P1PPP/RNBQKBNR w KQkq - a2a4",
    "B02",
    "Alekhine Defense: Two Pawns Attack, Tate Variation",
  ],
  ["rnbqkb1r/pppppppp/1n6/4P3/2P5/8/PP1P1PPP/RNBQKBNR w KQkq - b2b3", "B02", "Alekhine Defense: Steiner Variation"],
  [
    "rnbqkb1r/pppppppp/1n6/4P3/2P5/8/PP1P1PPP/RNBQKBNR w KQkq - c4c5",
    "B02",
    "Alekhine Defense: Two Pawns Attack, Lasker Variation",
  ],
  ["rnbqkb1r/pppppppp/1n6/4P3/8/1B6/PPPP1PPP/RNBQK1NR b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppppppp/5n2/3P4/4P3/8/PPP2PPP/RNBQKBNR w KQkq - e4e5", null, null],
  ["rnbqkb1r/pppppppp/5n2/3PP3/8/8/PPP2PPP/RNBQKBNR b KQkq - f6g8", "A40", "Zaire Defense"],
  ["rnbqkb1r/pppppppp/5n2/4P3/8/8/PPPP1PPP/RNBQKBNR b KQkq - f6d5", "B02", "Alekhine Defense: Normal Variation"],
  ["rnbqkb1r/pppppppp/5n2/4P3/8/8/PPPP1PPP/RNBQKBNR b KQkq - f6e4", "B02", "Alekhine Defense: Mokele Mbembe"],
  ["rnbqkb1r/pppppppp/5n2/4P3/8/8/PPPP1PPP/RNBQKBNR b KQkq - f6g8", "B02", "Alekhine Defense: Brooklyn Variation"],
  ["rnbqkb1r/pppppppp/5n2/6B1/3P4/8/PPP1PPPP/RN1QKBNR b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppppppp/5n2/6B1/3P4/8/PPP1PPPP/RN1QKBNR b KQkq - e7e6", "A45", "Trompowsky Attack: Classical Defense"],
  ["rnbqkb1r/pppppppp/5n2/6B1/3P4/8/PPP1PPPP/RN1QKBNR b KQkq - f6e4", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/1P6/5N2/P1PPPPPP/RNBQKB1R b KQkq - g7g6", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/1P6/8/P1PPPPPP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - g7g6", "A00", "Polish Opening: King's Indian Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - f6e4", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - d7d5", "A16", "English Opening: Anglo-Grünfeld Defense"],
  [
    "rnbqkb1r/pppppppp/5n2/8/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - e7e6",
    "A17",
    "English Opening: Anglo-Indian Defense, Hedgehog System",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - g7g6", null, null],
  [
    "rnbqkb1r/pppppppp/5n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - b7b6",
    "A15",
    "English Opening: Anglo-Indian Defense, Queen's Indian Formation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - c7c6", null, null],
  [
    "rnbqkb1r/pppppppp/5n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - d7d5",
    "A15",
    "English Opening: Anglo-Indian Defense, Scandinavian Defense",
  ],
  [
    "rnbqkb1r/pppppppp/5n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - d7d6",
    "A15",
    "English Opening: Anglo-Indian Defense, Old Indian Formation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - e7e6", null, null],
  [
    "rnbqkb1r/pppppppp/5n2/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - g7g6",
    "A15",
    "English Opening: Anglo-Indian Defense, King's Indian Formation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/6P1/PP1PPP1P/RNBQKBNR b KQkq - c7c6", null, null],
  [
    "rnbqkb1r/pppppppp/5n2/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - b1c3",
    "A16",
    "English Opening: Anglo-Indian Defense, Queen's Knight Variation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - b2b4", "A15", "English Orangutan"],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - d2d4", "A50", "Indian Defense: Normal Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - e2e4", "A10", "English Opening: Achilles-Omega Gambit"],
  [
    "rnbqkb1r/pppppppp/5n2/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g1f3",
    "A15",
    "English Opening: Anglo-Indian Defense, King's Knight Variation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g2g3", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - b7b5", "A50", "Indian Defense: Pyrenees Gambit"],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - b7b6", "A50", "Queen's Indian Accelerated"],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - b8c6", "A50", "Mexican Defense"],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - c7c5", "A56", "Benoni Defense"],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - c7c6", "A50", "Slav Indian"],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - d7d6", "A53", "Old Indian Defense"],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e7e5", "A51", "Indian Defense: Budapest Defense"],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e7e6", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - g7g5", "A50", "Indian Defense: Medusa Gambit"],
  ["rnbqkb1r/pppppppp/5n2/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - g7g6", "E60", "Indian Defense: West Indian Defense"],
  [
    "rnbqkb1r/pppppppp/5n2/8/3P2P1/8/PPP1PP1P/RNBQKBNR b KQkq - e7e5",
    "A45",
    "Indian Defense: Gibbins-Weidenhagen Gambit, Oshima Defense",
  ],
  [
    "rnbqkb1r/pppppppp/5n2/8/3P2P1/8/PPP1PP1P/RNBQKBNR b KQkq - f6g4",
    "A45",
    "Indian Defense: Gibbins-Weidenhagen Gambit Accepted",
  ],
  [
    "rnbqkb1r/pppppppp/5n2/8/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - c7c5",
    "A45",
    "Indian Defense: Reversed Chigorin Defense",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - d7d5", "A45", "Queen's Pawn Game: Chigorin Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - e7e5", "A45", "Indian Defense: Maddigan Gambit"],
  [
    "rnbqkb1r/pppppppp/5n2/8/3P4/3B4/PPP2PPP/RNBQK1NR w KQkq - c1g5",
    "A45",
    "Indian Defense: Omega Gambit, Arafat Gambit",
  ],
  [
    "rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - a7a6",
    "A46",
    "Indian Defense: Knights Variation, Alburt-Miles Variation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - b7b5", "A46", "Indian Defense: Polish Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - b7b6", "A47", "Pseudo Queen's Indian Defense"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - c7c5", "A46", "Indian Defense: Spielmann-Indian"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - c7c6", "A46", "Indian Defense: Czech-Indian"],
  [
    "rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - d7d5",
    "D02",
    "Queen's Pawn Game: Symmetrical Variation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - d7d6", "A46", "Indian Defense: Wade-Tartakower Defense"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - e7e6", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - f6e4", "A46", "Döry Defense"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - g7g6", "A48", "East Indian Defense"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/5P2/PPP1P1PP/RNBQKBNR b KQkq - d7d5", null, null],
  [
    "rnbqkb1r/pppppppp/5n2/8/3P4/5P2/PPP1P2P/RNBQKBNR w KQkq - e2e4",
    "A45",
    "Indian Defense: Gibbins-Weidenhagen Gambit, Maltese Falcon",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - b1d2", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c1f4", "A45", "Indian Defense: Accelerated London System"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c1g5", "A45", "Trompowsky Attack"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", "A50", "Indian Defense: Normal Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - d4d5", "A45", "Indian Defense: Pawn Push Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", "A45", "Indian Defense: Omega Gambit"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - f2f3", "A45", "Paleface Attack"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - f2f4", "A45", "Canard Opening"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3", "A46", "Indian Defense: Knights Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g2g3", "A45", "Indian Defense: Tartakower Attack"],
  [
    "rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g2g4",
    "A45",
    "Indian Defense: Gibbins-Weidenhagen Gambit",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/3P4/8/PPPNPPPP/R1BQKBNR b KQkq - e7e5", "A45", "Indian Defense: Lazard Gambit"],
  ["rnbqkb1r/pppppppp/5n2/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f6e4", null, null],
  [
    "rnbqkb1r/pppppppp/5n2/8/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - d7d5",
    "B02",
    "Alekhine Defense: Scandinavian Variation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d3", "B02", "Alekhine Defense: Maróczy Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - e4e5", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1c4", "B02", "Alekhine Defense: Krejcik Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/5P2/5N2/PPPPP1PP/RNBQKB1R b KQkq - g7g6", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - c2c4", "A02", "Bird Opening: Mujannah"],
  ["rnbqkb1r/pppppppp/5n2/8/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/8/1P6/P1PPPPPP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/8/1P6/PBPPPPPP/RN1QKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/8/2N2N2/PPPPPPPP/R1BQKB1R b KQkq - b8c6", "A05", "Zukertort Opening"],
  ["rnbqkb1r/pppppppp/5n2/8/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - g2g4", "A00", "Van Geet Opening: Tübingen Gambit"],
  ["rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - a2a4", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - b2b3", "A05", "Zukertort Opening: Nimzo-Larsen Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - b2b4", null, null],
  [
    "rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - c2c4",
    "A15",
    "English Opening: Anglo-Indian Defense, King's Knight Variation",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - e2e3", "A05", "Zukertort Opening: Quiet System"],
  ["rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - e2e4", "A05", "Zukertort Opening: Lemberger Gambit"],
  ["rnbqkb1r/pppppppp/5n2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkb1r/pppppppp/5n2/8/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - b7b5", "A05", "King's Indian Attack: Spassky Variation"],
  ["rnbqkb1r/pppppppp/5n2/8/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - d7d5", "A05", "King's Indian Attack"],
  [
    "rnbqkb1r/pppppppp/5n2/8/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - g7g6",
    "A05",
    "King's Indian Attack: Symmetrical Defense",
  ],
  ["rnbqkb1r/pppppppp/5n2/8/P7/5N2/1PPPPPPP/RNBQKB1R b KQkq - g7g6", null, null],
  ["rnbqkb1r/pppppppp/7n/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - g7g6", "A04", "Zukertort Defense: Kingside Variation"],
  ["rnbqkb1r/pppppppp/7n/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - g7g6", null, null],
  ["rnbqkb1r/pppppppp/7n/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkb1r/pppppppp/7n/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkb1r/pppppppp/8/2P1P3/8/2n5/PP1P1PPP/R1BQKBNR w KQkq - d2c3", null, null],
  ["rnbqkb1r/pppppppp/8/2P1P3/8/2P5/PP3PPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqkb1r/pppppppp/8/2PnP3/2B5/8/PP1P1PPP/RNBQK1NR b KQkq - e7e6", null, null],
  ["rnbqkb1r/pppppppp/8/2PnP3/8/2N5/PP1P1PPP/R1BQKBNR b KQkq - d5c3", null, null],
  ["rnbqkb1r/pppppppp/8/2PnP3/8/8/PP1P1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkb1r/pppppppp/8/2PnP3/8/8/PP1P1PPP/RNBQKBNR w KQkq - f1c4", null, null],
  ["rnbqkb1r/pppppppp/8/3nP3/2B5/8/PPPP1PPP/RNBQK1NR b KQkq - d5b6", null, null],
  ["rnbqkb1r/pppppppp/8/3nP3/2P5/8/PP1P1PPP/RNBQKBNR b KQkq - d5b6", null, null],
  ["rnbqkb1r/pppppppp/8/3nP3/2P5/8/PP1P1PPP/RNBQKBNR b KQkq - d5f4", "B02", "Alekhine Defense: The Squirrel"],
  ["rnbqkb1r/pppppppp/8/3nP3/3P4/8/PPP2PPP/RNBQKBNR b KQkq - b7b5", "B03", "Alekhine Defense: O'Sullivan Gambit"],
  ["rnbqkb1r/pppppppp/8/3nP3/3P4/8/PPP2PPP/RNBQKBNR b KQkq - d7d6", "B03", "Alekhine Defense"],
  ["rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR w KQkq - b1a3", "B02", "Alekhine Defense: Buckley Attack"],
  ["rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", "B02", "Alekhine Defense: Sämisch Attack"],
  ["rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR w KQkq - b2b3", "B02", "Alekhine Defense: Welling Variation"],
  ["rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR w KQkq - c2c4", "B02", "Alekhine Defense: Two Pawns Attack"],
  ["rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", "B03", "Alekhine Defense"],
  ["rnbqkb1r/pppppppp/8/3nP3/8/8/PPPP1PPP/RNBQKBNR w KQkq - f1c4", null, null],
  [
    "rnbqkb1r/pppppppp/8/4P3/3Pn3/8/PPP2PPP/RNBQKBNR b KQkq - e7e6",
    "B02",
    "Alekhine Defense: Mokele Mbembe, Vavra Defense",
  ],
  [
    "rnbqkb1r/pppppppp/8/4P3/3Pn3/8/PPP2PPP/RNBQKBNR b KQkq - f7f6",
    "B02",
    "Alekhine Defense: Mokele Mbembe, Modern Line",
  ],
  ["rnbqkb1r/pppppppp/8/4P3/4n3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkb1r/pppppppp/8/6B1/3Pn2P/8/PPP1PPP1/RN1QKBNR b KQkq - e4g5", null, null],
  ["rnbqkb1r/pppppppp/8/6B1/3Pn3/8/PPP1PPPP/RN1QKBNR w KQkq - g5f4", null, null],
  ["rnbqkb1r/pppppppp/8/6B1/3Pn3/8/PPP1PPPP/RN1QKBNR w KQkq - g5h4", "A45", "Trompowsky Attack: Edge Variation"],
  ["rnbqkb1r/pppppppp/8/6B1/3Pn3/8/PPP1PPPP/RN1QKBNR w KQkq - h2h4", "A45", "Trompowsky Attack: Raptor Variation"],
  ["rnbqkb1r/pppppppp/8/6n1/3P3P/8/PPP1PPP1/RN1QKBNR w KQkq - h4g5", null, null],
  [
    "rnbqkb1r/pppppppp/8/6P1/3P4/8/PPP1PPP1/RN1QKBNR b KQkq - e7e5",
    "A45",
    "Trompowsky Attack: Raptor Variation, Hergert Gambit",
  ],
  [
    "rnbqkb1r/pppppppp/8/8/2B1n3/8/PPPP1PPP/RNBQK1NR w KQkq - c4f7",
    "B02",
    "Alekhine Defense: Krejcik Variation, Krejcik Gambit",
  ],
  ["rnbqkb1r/pppppppp/8/8/3P2n1/5P2/PPP1P2P/RNBQKBNR b KQkq - g4f6", null, null],
  ["rnbqkb1r/pppppppp/8/8/3P2n1/8/PPP1PP1P/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkb1r/pppppppp/8/8/3P2n1/8/PPP1PP1P/RNBQKBNR w KQkq - f2f3", null, null],
  ["rnbqkb1r/pppppppp/8/8/3Pn2B/8/PPP1PPPP/RN1QKBNR b KQkq - c7c6", null, null],
  ["rnbqkb1r/pppppppp/8/8/3Pn2B/8/PPP1PPPP/RN1QKBNR b KQkq - d7d5", null, null],
  ["rnbqkb1r/pppppppp/8/8/3Pn3/3B4/PPP2PPP/RNBQK1NR b KQkq - e4f6", null, null],
  ["rnbqkb1r/pppppppp/8/8/3Pn3/8/PPP2PPP/RNBQKBNR w KQkq - f1d3", null, null],
  ["rnbqkb1r/pppppppp/8/8/3PnB2/8/PPP1PPPP/RN1QKBNR b KQkq - g7g5", "A45", "Trompowsky Attack: Borg Variation"],
  ["rnbqkb1r/pppppppp/8/8/3PP1n1/8/PPP2P1P/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbn1/pppp1p1r/8/4N2p/2B1PppP/8/PPPP2P1/RNBQK2R w KQq - d2d4", null, null],
  ["rnbqkbn1/pppp1p1r/8/4N2p/2BPPppP/8/PPP3P1/RNBQK2R b KQq - f8h6", null, null],
  ["rnbqkbnr/1p1p1ppp/p3p3/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R w KQkq - g2g3", null, null],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/2p5/2P5/2N2NP1/PP1PPP1P/R1BQKB1R b KQkq - b7b5",
    "A04",
    "Zukertort Opening: Shabalov Gambit",
  ],
  ["rnbqkbnr/1p1p1ppp/p3p3/2p5/4P3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - g2g3", null, null],
  ["rnbqkbnr/1p1p1ppp/p3p3/2p5/4P3/2N2NP1/PPPP1P1P/R1BQKB1R b KQkq - b7b5", null, null],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - g8e7",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Taimanov Formation",
  ],
  ["rnbqkbnr/1p1p1ppp/p3p3/8/2B1P3/2N5/PP3PPP/R1BQK1NR w KQkq - g1f3", null, null],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/8/2PNP3/8/PP3PPP/RNBQKB1R b KQkq - g7g6",
    "B41",
    "Sicilian Defense: Kan Variation, Maróczy Bind, Hedgehog Variation",
  ],
  ["rnbqkbnr/1p1p1ppp/p3p3/8/2PNP3/8/PP3PPP/RNBQKB1R b KQkq - g8f6", null, null],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/2N5/PPP2PPP/R1BQKB1R b KQkq - b7b5",
    "B43",
    "Sicilian Defense: Kan Variation, Wing Attack",
  ],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/3B4/PPP2PPP/RNBQK2R b KQkq - f8c5",
    "B42",
    "Sicilian Defense: Kan Variation, Polugaevsky Variation",
  ],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/3B4/PPP2PPP/RNBQK2R b KQkq - g7g6",
    "B42",
    "Sicilian Defense: Kan Variation, Swiss Cheese Variation",
  ],
  ["rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/3B4/PPP2PPP/RNBQK2R b KQkq - g8f6", null, null],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - b1c3",
    "B43",
    "Sicilian Defense: Kan Variation, Knight Variation",
  ],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - c2c4",
    "B41",
    "Sicilian Defense: Kan Variation, Maróczy Bind, Réti Variation",
  ],
  [
    "rnbqkbnr/1p1p1ppp/p3p3/8/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - f1d3",
    "B42",
    "Sicilian Defense: Kan Variation, Modern Variation",
  ],
  ["rnbqkbnr/1p1ppppp/2p5/p7/1P6/8/PBPPPPPP/RN1QKBNR w KQkq - b4b5", null, null],
  ["rnbqkbnr/1p1ppppp/2p5/pP6/8/8/PBPPPPPP/RN1QKBNR b KQkq - c6b5", null, null],
  ["rnbqkbnr/1p1ppppp/8/pp6/8/8/PBPPPPPP/RN1QKBNR w KQkq - e2e4", "A00", "Polish Opening: Schuehler Gambit"],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/2P1P3/5N2/PP1P1PPP/RNBQKB1R b KQkq - d7d6",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Maróczy Bind, Robatsch Line",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/2P1P3/5N2/PP1P1PPP/RNBQKB1R b KQkq - e7e6",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Maróczy Bind, Paulsen Line",
  ],
  ["rnbqkbnr/1p1ppppp/p7/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c5d4", null, null],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - b7b5",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Venice System, Ljubojevic Line",
  ],
  ["rnbqkbnr/1p1ppppp/p7/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - d7d5", null, null],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - d7d6",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Venice System, Steiner Line",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - g8f6",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Venice System, Barcza Line",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Yerevan System",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b3",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Kieseritzky System",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b4",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Wing Gambit",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c3",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Venice System",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c4",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Maróczy Bind",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d3",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Quiet System",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Normal System",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1e2",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Aronin System",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - g2g3",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Réti System",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - e7e5",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Normal System, Taimanov Line",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c3",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Normal System, Smith-Morra Line",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - d1d4",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Normal System, Zagorovsky Line",
  ],
  [
    "rnbqkbnr/1p1ppppp/p7/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Normal System, Cortlever Gambit",
  ],
  ["rnbqkbnr/1p1ppppp/p7/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3d4", null, null],
  ["rnbqkbnr/1p2pppp/p7/2pp4/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - e4d5", null, null],
  [
    "rnbqkbnr/1p2pppp/p7/2pP4/8/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - g8f6",
    "B28",
    "Sicilian Defense: O'Kelly Variation, Venice System, Gambit Line",
  ],
  ["rnbqkbnr/1p3ppp/p2pp3/8/2B1P3/2N2N2/PP3PPP/R1BQ1RK1 b kq - f8e7", null, null],
  ["rnbqkbnr/1p3ppp/p2pp3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R w KQkq - e1g1", null, null],
  [
    "rnbqkbnr/1pp1pppp/p7/8/2pP4/4PN2/PP3PPP/RNBQKB1R b KQkq - b7b5",
    "D22",
    "Queen's Gambit Accepted: Alekhine Defense, Haberditz Variation",
  ],
  ["rnbqkbnr/1pp1pppp/p7/8/2pP4/4PN2/PP3PPP/RNBQKB1R b KQkq - c8g4", null, null],
  ["rnbqkbnr/1pp1pppp/p7/8/2pP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e3", null, null],
  [
    "rnbqkbnr/1pp1pppp/p7/8/2pP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e4",
    "D21",
    "Queen's Gambit Accepted: Alekhine Defense, Borisenko-Furman Variation",
  ],
  ["rnbqkbnr/1pp2ppp/p3p3/3p4/3PP3/2N2N2/PPP2PPP/R1BQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/1pp2ppp/p3p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/1ppp1ppp/p3p3/8/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - c7c5", null, null],
  ["rnbqkbnr/1ppp1ppp/p3p3/8/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/1ppp1ppp/p3p3/8/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - b7b5",
    "C00",
    "French Defense: St. George Defense, Sanky-George Gambit",
  ],
  ["rnbqkbnr/1ppp1ppp/p3p3/8/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - b7b5", null, null],
  [
    "rnbqkbnr/1ppp1ppp/p3p3/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c2c4",
    "C00",
    "French Defense: St. George Defense, Three Pawn Attack",
  ],
  ["rnbqkbnr/1ppp1ppp/p3p3/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/1ppppppp/8/p7/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - b8c6", "B00", "Ware Defense: Snagglepuss Defense"],
  ["rnbqkbnr/1ppppppp/8/p7/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/1ppppppp/8/p7/8/P7/1PPPPPPP/RNBQKBNR w KQkq - b2b4", "A00", "Anderssen's Opening: Polish Gambit"],
  ["rnbqkbnr/1ppppppp/p7/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - b7b5", null, null],
  ["rnbqkbnr/1ppppppp/p7/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - e7e5", "B00", "St. George Defense: Zilbermints Gambit"],
  ["rnbqkbnr/1ppppppp/p7/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/2pp1ppp/p3p3/1p6/2PPP3/8/PP3PPP/RNBQKBNR w KQkq - c4b5", null, null],
  ["rnbqkbnr/2pp1ppp/p3p3/1p6/3PP3/3B1N2/PPP2PPP/RNBQK2R b KQkq - c7c5", null, null],
  ["rnbqkbnr/2pp1ppp/p3p3/1p6/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1d3", null, null],
  [
    "rnbqkbnr/2pp1ppp/p3p3/1P6/3PP3/8/PP3PPP/RNBQKBNR b KQkq - a6b5",
    "C00",
    "French Defense: St. George Defense, St. George Gambit",
  ],
  ["rnbqkbnr/2pppppp/p7/1p6/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c8b7", null, null],
  ["rnbqkbnr/2pppppp/p7/1p6/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/3p1ppp/p3p3/1p6/3NP3/2N5/PPP2PPP/R1BQKB1R w KQkq - f1d3", null, null],
  ["rnbqkbnr/3p1ppp/p3p3/1p6/3NP3/2NB4/PPP2PPP/R1BQK2R b KQkq - d8b6", null, null],
  [
    "rnbqkbnr/3p1ppp/p3p3/1p6/3pP3/2N2NP1/PPP2P1P/R1BQKB1R w KQkq - f3d4",
    "B40",
    "Sicilian Defense: Kan Variation, Wing Attack, Fianchetto Variation",
  ],
  ["rnbqkbnr/3p1ppp/p3p3/1pp5/3PP3/2N2NP1/PPP2P1P/R1BQKB1R b KQkq - c5d4", null, null],
  ["rnbqkbnr/3p1ppp/p3p3/1pp5/3PP3/2PB1N2/PP3PPP/RNBQK2R b KQkq - c8b7", null, null],
  ["rnbqkbnr/3p1ppp/p3p3/1pp5/3PP3/3B1N2/PPP2PPP/RNBQK2R w KQkq - c2c3", null, null],
  ["rnbqkbnr/3p1ppp/p3p3/1pp5/4P3/2N2NP1/PPPP1P1P/R1BQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/p1p1pppp/1p6/3p4/P2P4/2N5/1PP1PPPP/R1BQKBNR b KQkq - b8d7", "A00", "Ware Opening: Cologne Gambit"],
  ["rnbqkbnr/p1p1pppp/1p6/3p4/P2P4/8/1PP1PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/p1p2ppp/1p2p3/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkbnr/p1p2ppp/1p2p3/3p4/2P5/5NP1/PP1PPPBP/RNBQK2R b KQkq - c8b7", null, null],
  ["rnbqkbnr/p1pp1ppp/1p2p3/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - c8b7", null, null],
  [
    "rnbqkbnr/p1pp1ppp/1p2p3/8/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - d7d5",
    "D31",
    "Queen's Gambit Declined: Alapin Variation",
  ],
  ["rnbqkbnr/p1pp1ppp/1p2p3/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/p1pp1ppp/1p2p3/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/p1pp1ppp/1p2p3/8/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - c8b7", null, null],
  ["rnbqkbnr/p1pp1ppp/8/1B2p3/4P3/8/PPPP1PPP/RNBQK1NR b KQkq - c7c6", "C23", "Bishop's Opening: Anderssen Gambit"],
  ["rnbqkbnr/p1pp1ppp/8/1B2p3/4P3/8/PPPP1PPP/RNBQK1NR b KQkq - f7f5", "C23", "Bishop's Opening: Thorold Gambit"],
  ["rnbqkbnr/p1pp1ppp/8/1p2p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - c4b5", null, null],
  [
    "rnbqkbnr/p1pp1ppp/8/1p2p3/2B5/4P3/PPPP1PPP/RNBQK1NR w KQkq - c4b3",
    "A00",
    "Van't Kruijs Opening: Bouncing Bishop Variation",
  ],
  ["rnbqkbnr/p1ppp1pp/1p3p2/8/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - c8b7", "B00", "Owen Defense: Unicorn Variation"],
  ["rnbqkbnr/p1ppp1pp/1p3p2/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkbnr/p1pppppp/1p6/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - c8b7", null, null],
  ["rnbqkbnr/p1pppppp/1p6/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkbnr/p1pppppp/1p6/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqkbnr/p1pppppp/1p6/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - c8a6", "B00", "Owen Defense: Guatemala Defense"],
  ["rnbqkbnr/p1pppppp/1p6/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - c8b7", null, null],
  ["rnbqkbnr/p1pppppp/1p6/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/p1pppppp/1p6/8/P2P4/8/1PP1PPPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/p1pppppp/1p6/8/P7/8/1PPPPPPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/p1pppppp/8/1p6/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/p1pppppp/8/1p6/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - c8b7", null, null],
  ["rnbqkbnr/p1pppppp/8/1P6/8/8/1PPPPPPP/RNBQKBNR b KQkq - c8b7", "A00", "Ware Opening: Wing Gambit"],
  ["rnbqkbnr/p1pppppp/8/1p6/P7/8/1PPPPPPP/RNBQKBNR w KQkq - a4b5", null, null],
  ["rnbqkbnr/p2ppppp/1p6/2p5/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - d4c5", null, null],
  ["rnbqkbnr/p2ppppp/1p6/2P5/4P3/8/PPP2PPP/RNBQKBNR b KQkq - b8c6", "B00", "Owen Defense: Hekili-Loa Gambit"],
  ["rnbqkbnr/p4ppp/2p1p3/1p6/2pP4/2N1PN2/PP3PPP/R1BQKB1R w KQkq - a2a4", null, null],
  ["rnbqkbnr/p4ppp/2p1p3/1p6/P1pP4/2N1PN2/1P3PPP/R1BQKB1R b KQkq - f8b4", null, null],
  [
    "rnbqkbnr/pp1p1ppp/2p5/4p3/1P2P3/8/P1PP1PPP/RNBQKBNR w KQkq - c1b2",
    "B10",
    "Caro-Kann Defense: Labahn Attack, Polish Variation",
  ],
  ["rnbqkbnr/pp1p1ppp/2p5/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pp1p1ppp/2p5/4p3/2BPP3/8/PPP2PPP/RNBQK1NR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c5d4", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4d5", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - a7a6", "B40", "Sicilian Defense: Drazic Variation"],
  [
    "rnbqkbnr/pp1p1ppp/4p3/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c5d4",
    "B40",
    "Sicilian Defense: French Variation, Open",
  ],
  [
    "rnbqkbnr/pp1p1ppp/4p3/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - d7d5",
    "B40",
    "Sicilian Defense: Marshall Counterattack",
  ],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - d4d5", "A43", "Benoni Defense: French Benoni"],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - a7a6", null, null],
  [
    "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2N3P1/PPPP1P1P/R1BQKBNR b KQkq - d7d5",
    "B23",
    "Sicilian Defense: Closed, Korchnoi Defense",
  ],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - g2g3", "B23", "Sicilian Defense: Closed"],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b3",
    "B40",
    "Sicilian Defense: French Variation, Westerinen Attack",
  ],
  [
    "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b4",
    "B40",
    "Sicilian Defense: Wing Gambit Deferred",
  ],
  [
    "rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c3",
    "B40",
    "Sicilian Defense: Delayed Alapin Variation, with e6",
  ],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c4", "B40", "Sicilian Defense: Kramnik Variation"],
  ["rnbqkbnr/pp1p1ppp/4p3/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/2pP4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - e6d5", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/8/2B1P3/2N5/PP3PPP/R1BQK1NR b KQkq - a7a6", null, null],
  [
    "rnbqkbnr/pp1p1ppp/4p3/8/2PN4/8/PP2PPPP/RNBQKB1R b KQkq - g8f6",
    "A32",
    "English Opening: Symmetrical Variation, Anti-Benoni Variation, Spielmann Defense",
  ],
  ["rnbqkbnr/pp1p1ppp/4p3/8/2Pp4/5N2/PP2PPPP/RNBQKB1R w KQkq - f3d4", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - a7a6", "B41", "Sicilian Defense: Kan Variation"],
  ["rnbqkbnr/pp1p1ppp/4p3/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - b8c6", "B44", "Sicilian Defense: Taimanov Variation"],
  ["rnbqkbnr/pp1p1ppp/4p3/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - d8b6", "B40", "Sicilian Defense: Kveinis Variation"],
  ["rnbqkbnr/pp1p1ppp/4p3/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - f8c5", "B40", "Sicilian Defense: Paulsen-Basman Defense"],
  [
    "rnbqkbnr/pp1p1ppp/4p3/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g8f6",
    "B40",
    "Sicilian Defense: French Variation, Normal",
  ],
  [
    "rnbqkbnr/pp1p1ppp/4p3/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c3",
    "B40",
    "Sicilian Defense: Smith-Morra Gambit Deferred",
  ],
  ["rnbqkbnr/pp1p1ppp/4p3/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3d4", null, null],
  [
    "rnbqkbnr/pp1p1ppp/4p3/8/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - a7a6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Kan Formation",
  ],
  ["rnbqkbnr/pp1p1ppp/4p3/8/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - d7d6", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/8/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - f1c4", null, null],
  ["rnbqkbnr/pp1p1ppp/4p3/8/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp1p1ppp/8/2p5/3p1P2/5N2/PPP1P1PP/RNBQKB1R w KQkq - c2c3", "A02", "Bird Opening: Siegener Gambit"],
  ["rnbqkbnr/pp1p1ppp/8/2p5/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4", "C21", "Center Game: Kieseritzky Variation"],
  ["rnbqkbnr/pp1p1ppp/8/2pp4/2P5/8/PP2PPPP/RNBQKBNR w KQkq - c4d5", null, null],
  ["rnbqkbnr/pp1p1ppp/8/2pP4/8/8/PP2PPPP/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/pp1p1ppp/8/2pPp3/4P3/8/PPP2PPP/RNBQKBNR b KQkq - d7d6", "A44", "Benoni Defense: Semi-Benoni"],
  ["rnbqkbnr/pp1p1ppp/8/2pPp3/8/8/PPP1PPPP/RNBQKBNR w KQkq e6 e2e4", null, null],
  [
    "rnbqkbnr/pp1p1ppp/8/4p3/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c3",
    "B21",
    "Sicilian Defense: Morphy Gambit, Andreaschek Gambit",
  ],
  ["rnbqkbnr/pp1pp1pp/2p5/5p2/3P4/6P1/PPP1PP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkbnr/pp1pp1pp/2p5/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR b KQkq - g7g6", null, null],
  ["rnbqkbnr/pp1pp1pp/8/2p2p2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - e4f5", null, null],
  ["rnbqkbnr/pp1pp1pp/8/2p2P2/8/5N2/PPPP1PPP/RNBQKB1R b KQkq - g8h6", "B27", "Sicilian Defense: Double-Dutch Gambit"],
  ["rnbqkbnr/pp1pp1pp/8/2pP1p2/8/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", "A43", "Benoni Defense: Benoni-Staunton Gambit"],
  ["rnbqkbnr/pp1pp2p/2p3p1/5p2/3P4/5NP1/PPP1PPBP/RNBQK2R b KQkq - f8g7", null, null],
  ["rnbqkbnr/pp1pp2p/2p3p1/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/2P1P3/5N2/PP1P1PPP/RNBQKB1R b KQkq - f8h6", "B27", "Sicilian Defense: Acton Extension"],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/2P5/6P1/PP1PPP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/2P5/6P1/PP1PPPBP/RNBQK1NR b KQkq - f8g7", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c5d4", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - f7f5", "B27", "Sicilian Defense: Frederico Variation"],
  [
    "rnbqkbnr/pp1ppp1p/6p1/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - f8g7",
    "B27",
    "Sicilian Defense: Hyperaccelerated Pterodactyl",
  ],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c3", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c4", null, null],
  [
    "rnbqkbnr/pp1ppp1p/6p1/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4",
    "B27",
    "Sicilian Defense: Hyperaccelerated Dragon",
  ],
  ["rnbqkbnr/pp1ppp1p/6p1/2p5/8/4PN2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp1ppp1p/6p1/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3d4", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/1P2P3/8/P1PP1PPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/1P2P3/8/P1PP1PPP/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/1P6/8/P1PPPPPP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - a7a5", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - d7d5", null, null],
  [
    "rnbqkbnr/pp1ppppp/2p5/8/2P1P3/8/PP1P1PPP/RNBQKBNR b KQkq - d7d5",
    "B10",
    "Caro-Kann Defense: Accelerated Panov Attack",
  ],
  [
    "rnbqkbnr/pp1ppppp/2p5/8/2P1P3/8/PP1P1PPP/RNBQKBNR b KQkq - e7e5",
    "B10",
    "Caro-Kann Defense: Accelerated Panov Attack, Open Variation",
  ],
  ["rnbqkbnr/pp1ppppp/2p5/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - d7d6", "A40", "Queen's Pawn Game: Anglo-Slav Opening"],
  ["rnbqkbnr/pp1ppppp/2p5/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - g8f6", "A46", "Indian Defense: Czech-Indian"],
  ["rnbqkbnr/pp1ppppp/2p5/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - b8a6", "B12", "Caro-Kann Defense: De Bruycker Defense"],
  ["rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d7d5", "B12", "Caro-Kann Defense"],
  ["rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f7f5", "B12", "Caro-Kann Defense: Massachusetts Defense"],
  ["rnbqkbnr/pp1ppppp/2p5/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - g8f6", "B12", "Caro-Kann Defense: Masi Variation"],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P1P1/8/PPPP1P1P/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - d7d5", "B10", "Caro-Kann Defense"],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/3P4/PPP2PPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", "B10", "Caro-Kann Defense"],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b3", "B10", "Caro-Kann Defense: Euwe Attack"],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b4", "B10", "Caro-Kann Defense: Labahn Attack"],
  [
    "rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - c2c4",
    "B10",
    "Caro-Kann Defense: Accelerated Panov Attack",
  ],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d3", "B10", "Caro-Kann Defense: Breyer Variation"],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", "B12", "Caro-Kann Defense"],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1c4", "B10", "Caro-Kann Defense: Hillbilly Attack"],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g2g4", "B10", "Caro-Kann Defense: Spike Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/1P2P3/8/P1PP1PPP/RNBQKBNR b KQkq - c5b4", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P1P3/8/PP1P1PPP/RNBQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P1P3/8/PP1P1PPP/RNBQKBNR b KQkq - d7d6", null, null],
  [
    "rnbqkbnr/pp1ppppp/8/2p5/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - b8c6",
    "A35",
    "English Opening: Symmetrical Variation, Two Knights Variation",
  ],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - g7g6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P5/6P1/PP1PPP1P/RNBQKBNR b KQkq - g7g6", null, null],
  [
    "rnbqkbnr/pp1ppppp/8/2p5/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - b1c3",
    "A34",
    "English Opening: Symmetrical Variation, Normal Variation",
  ],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - b2b4", "A30", "English Opening: Wing Gambit"],
  [
    "rnbqkbnr/pp1ppppp/8/2p5/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - e2e4",
    "B20",
    "Sicilian Defense: Staunton-Cochrane Variation",
  ],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g1f3", "A30", "English Opening: Symmetrical Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g2g3", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - c5d4", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - c5d4", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - c5d4", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - b2b4", "A43", "Benoni Defense: Zilbermints-Benoni Gambit"],
  ["rnbqkbnr/pp1ppppp/8/2p5/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - d4c5", "A43", "Benoni Defense: Benoni Gambit Accepted"],
  ["rnbqkbnr/pp1ppppp/8/2p5/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - d4d5", "A43", "Benoni Defense: Old Benoni"],
  ["rnbqkbnr/pp1ppppp/8/2p5/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - c5d4", null, null],
  [
    "rnbqkbnr/pp1ppppp/8/2p5/4P3/1P6/P1PP1PPP/RNBQKBNR b KQkq - b7b6",
    "B20",
    "Sicilian Defense: Czerniak Attack, Queen Fianchetto Variation",
  ],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/1P6/P1PP1PPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - b8c6", "B23", "Sicilian Defense: Closed, Traditional"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - e7e6", "B23", "Sicilian Defense: Closed"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/2P5/PP1P1PPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/2P5/PP1P1PPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/3P4/PPP2PPP/RNBQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - a7a6", "B28", "Sicilian Defense: O'Kelly Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - b7b5", "B27", "Sicilian Defense: Polish Gambit"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - b7b6", "B27", "Sicilian Defense: Katalimov Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - b8c6", "B30", "Sicilian Defense: Old Sicilian"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d7d6", "B50", "Sicilian Defense: Modern Variations"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d8a5", "B27", "Sicilian Defense: Mongoose Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d8c7", "B27", "Sicilian Defense: Quinteros Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - e7e5", "B27", "Sicilian Defense: Jalalabad Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - e7e6", "B40", "Sicilian Defense: French Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - f7f5", "B27", "Sicilian Defense: Brussels Gambit"],
  [
    "rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - g7g6",
    "B27",
    "Sicilian Defense: Hyperaccelerated Dragon",
  ],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - g8f6", "B29", "Sicilian Defense: Nimzowitsch Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - h7h6", "B27", "Sicilian Defense: Bücker Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - a2a3", "B20", "Sicilian Defense: Mengarini Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - a2a4", "B20", "Sicilian Defense: Myers Attack, with a4"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1a3", "B20", "Sicilian Defense: Kronberger Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", "B23", "Sicilian Defense: Closed"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b3", "B20", "Sicilian Defense: Czerniak Attack"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b4", "B20", "Sicilian Defense: Wing Gambit"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - c2c3", "B22", "Sicilian Defense: Alapin Variation"],
  [
    "rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - c2c4",
    "B20",
    "Sicilian Defense: Staunton-Cochrane Variation",
  ],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d1g4", "B20", "Sicilian Defense: Amazon Attack"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d3", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", "B21", "Sicilian Defense: Smith-Morra Gambit"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - e1e2", "B20", "Sicilian Defense: King David's Opening"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1c4", "B20", "Sicilian Defense: Bowdler Attack"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f2f4", "B21", "Sicilian Defense: McDonnell Attack"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1e2", "B20", "Sicilian Defense: Keres Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1f3", "B27", "Sicilian Defense"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1h3", "B20", "Sicilian Defense: Brick Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g2g3", "B20", "Sicilian Defense: Lasker-Dunne Attack"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g2g4", "B20", "Sicilian Defense: Grob Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - h2h4", "B20", "Sicilian Defense: Myers Attack, with h4"],
  ["rnbqkbnr/pp1ppppp/8/2p5/4P3/N7/PPPP1PPP/R1BQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - e7e5", "C30", "King's Gambit Declined: Mafia Defense"],
  ["rnbqkbnr/pp1ppppp/8/2p5/7P/8/PPPPPPP1/RNBQKBNR w KQkq - b2b4", "A00", "Kádas Opening: Kádas Gambit"],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/2N2N2/PPPPPPPP/R1BQKB1R b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - a1b1", "A00", "Van Geet Opening: Twyble Attack"],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - b2b4", "A00", "Van Geet Opening: Düsseldorf Gambit"],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/2NP4/PPP1PPPP/R1BQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/3P4/PPP1PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/4PN2/PPPP1PPP/RNBQKB1R b KQkq - g7g6", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - c2c4", "A30", "English Opening: Symmetrical Variation"],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/pp1ppppp/8/2p5/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkbnr/pp1ppppp/8/2P5/8/8/PPP1PPPP/RNBQKBNR b KQkq - b7b6", "A43", "Benoni Defense: Cormorant Gambit"],
  [
    "rnbqkbnr/pp1ppppp/8/2P5/8/8/PPP1PPPP/RNBQKBNR b KQkq - b8a6",
    "A43",
    "Benoni Defense: Benoni Gambit, Schlenker Defense",
  ],
  ["rnbqkbnr/pp1ppppp/8/2pP4/8/8/PPP1PPPP/RNBQKBNR b KQkq - b8a6", "A43", "Benoni Defense: Snail Variation"],
  ["rnbqkbnr/pp1ppppp/8/2pP4/8/8/PPP1PPPP/RNBQKBNR b KQkq - d7d6", "A43", "Benoni Defense: Old Benoni"],
  ["rnbqkbnr/pp1ppppp/8/2pP4/8/8/PPP1PPPP/RNBQKBNR b KQkq - e7e5", "A44", "Benoni Defense: Old Benoni"],
  [
    "rnbqkbnr/pp1ppppp/8/2pP4/8/8/PPP1PPPP/RNBQKBNR b KQkq - f7f5",
    "A43",
    "Benoni Defense: Old Benoni, Mujannah Formation",
  ],
  ["rnbqkbnr/pp1ppppp/8/2pP4/8/8/PPP1PPPP/RNBQKBNR b KQkq - g8f6", "A43", "Benoni Defense: Benoni-Indian Defense"],
  [
    "rnbqkbnr/pp1ppppp/8/8/1P1p4/5N2/P1P1PPPP/RNBQKB1R b KQkq - e7e5",
    "A43",
    "Benoni Defense: Zilbermints-Benoni Gambit, Tamarkin Countergambit",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/1p2P3/8/P1PP1PPP/RNBQKBNR w KQkq - a2a3",
    "B20",
    "Sicilian Defense: Wing Gambit, Marshall Variation",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/1p2P3/8/P1PP1PPP/RNBQKBNR w KQkq - c1b2",
    "B20",
    "Sicilian Defense: Wing Gambit, Abrahams Variation",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/1p2P3/8/P1PP1PPP/RNBQKBNR w KQkq - c2c4",
    "B20",
    "Sicilian Defense: Wing Gambit, Santasiere Variation",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/1p2P3/P7/2PP1PPP/RNBQKBNR b KQkq - b4a3",
    "B20",
    "Sicilian Defense: Wing Gambit, Carlsbad Variation",
  ],
  ["rnbqkbnr/pp1ppppp/8/8/1p2P3/P7/2PP1PPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/2Pp4/8/PP2PPPP/RNBQKBNR w KQkq - e2e3", "A43", "Queen's Pawn Game: Liedmann Gambit"],
  ["rnbqkbnr/pp1ppppp/8/8/3p4/2N5/PPP1PPPP/R1BQKBNR w KQkq - d1d4", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/3p4/5N2/PPP1PPPP/RNBQKB1R w KQkq - b2b4", "A43", "Benoni Defense: Zilbermints-Benoni Gambit"],
  ["rnbqkbnr/pp1ppppp/8/8/3p4/5N2/PPP1PPPP/RNBQKB1R w KQkq - e2e3", "A04", "Zukertort Opening: Speelsmet Gambit"],
  [
    "rnbqkbnr/pp1ppppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - d4c3",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - d4d3",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Declined, Push Variation",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - d7d5",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Declined, Scandinavian Formation",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - d8a5",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Declined, Wing Formation",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - e7e5",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Declined, Center Formation",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - g8f6",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Declined, Alapin Formation",
  ],
  ["rnbqkbnr/pp1ppppp/8/8/3pP3/5N2/PPP2PPP/RNBQKB1R b KQkq - e7e5", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - c2c3", "B21", "Sicilian Defense: Smith-Morra Gambit"],
  ["rnbqkbnr/pp1ppppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - d1d4", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - f2f4", "B21", "Sicilian Defense: Halasz Gambit"],
  ["rnbqkbnr/pp1ppppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", "B21", "Sicilian Defense: Morphy Gambit"],
  ["rnbqkbnr/pp1ppppp/8/8/3Q4/2N5/PPP1PPPP/R1B1KBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/3QP3/8/PPP2PPP/RNB1KBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/4P3/2N5/PP3PPP/R1BQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/4P3/2N5/PP3PPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/4P3/2N5/PP3PPP/R1BQKBNR b KQkq - e7e6", null, null],
  ["rnbqkbnr/pp1ppppp/8/8/4P3/2p5/PP3PPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/pp1ppppp/8/8/4P3/2p5/PP3PPP/RNBQKBNR w KQkq - g1f3",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Accepted, Danish Variation",
  ],
  [
    "rnbqkbnr/pp1ppppp/8/8/4P3/2Pp4/PP3PPP/RNBQKBNR w KQkq - c3c4",
    "B21",
    "Sicilian Defense: Smith-Morra Gambit Declined, Dubois Variation",
  ],
  ["rnbqkbnr/pp2pp1p/2p3p1/3p4/4P3/3P1N2/PPPN1PPP/R1BQKB1R b KQkq - f8g7", null, null],
  ["rnbqkbnr/pp2pp1p/2p3p1/3p4/4P3/3P4/PPPN1PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp2ppp1/2p4p/3p2B1/3P4/5N2/PPP1PPPP/RN1QKB1R w KQkq - g5h4", null, null],
  [
    "rnbqkbnr/pp2ppp1/2p4p/3p4/3P3B/5N2/PPP1PPPP/RN1QKB1R b KQkq - d8b6",
    "D02",
    "Queen's Pawn Game: Levitsky Attack, Euwe Variation, Modern Line",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3p2B1/3P4/5N2/PPP1PPPP/RN1QKB1R b KQkq - h7h6", null, null],
  [
    "rnbqkbnr/pp2pppp/2p5/3p4/1P2P3/8/P1PP1PPP/RNBQKBNR w KQkq - b4b5",
    "B10",
    "Caro-Kann Defense: Labahn Attack, Double Gambit",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3p4/1P6/8/PBPPPPPP/RN1QKBNR w KQkq - a2a4", "A00", "Polish Opening: Myers Variation"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - c4b3", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2P1P3/8/PP1P1PPP/RNBQKBNR w KQkq - c4d5", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2P1P3/8/PP1P1PPP/RNBQKBNR w KQkq - e4d5", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2P1P3/8/PP1P1PPP/RNBQKBNR w KQkq - e4e5", "B10", "Caro-Kann Defense: Toikkanen Gambit"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2P3P1/8/PP1PPPBP/RNBQK1NR b KQkq - d5c4", null, null],
  [
    "rnbqkbnr/pp2pppp/2p5/3p4/2P5/1P3N2/P2PPPPP/RNBQKB1R b KQkq - c8f5",
    "A12",
    "Réti Opening: Anglo-Slav Variation, Bogoljubow Variation",
  ],
  [
    "rnbqkbnr/pp2pppp/2p5/3p4/2P5/1P3N2/P2PPPPP/RNBQKB1R b KQkq - c8g4",
    "A12",
    "Réti Opening: Anglo-Slav Variation, Bogoljubow Variation",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2P5/4PN2/PP1P1PPP/RNBQKB1R b KQkq - g8f6", null, null],
  [
    "rnbqkbnr/pp2pppp/2p5/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b2b3",
    "A12",
    "Réti Opening: Anglo-Slav Variation, Bogoljubow Variation",
  ],
  [
    "rnbqkbnr/pp2pppp/2p5/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - e2e3",
    "A11",
    "Réti Opening: Anglo-Slav Variation, Gurevich System",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3P4/2P5/8/PP1P1PPP/RNBQKBNR b KQkq - c6d5", null, null],
  [
    "rnbqkbnr/pp2pppp/2p5/3P4/2P5/8/PP1P1PPP/RNBQKBNR b KQkq - d8d5",
    "B10",
    "Caro-Kann Defense: Accelerated Panov Attack, Pseudo-Scandinavian",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - d5c4", "D10", "Slav Defense"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - e7e5", "D10", "Slav Defense: Winawer Countergambit"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - e7e6", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", "D10", "Slav Defense"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - c4d5", "D10", "Slav Defense: Exchange Variation"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - e2e4", "D10", "Slav Defense: Diemer Gambit"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", "D11", "Slav Defense: Modern Line"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1g5", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3P4/3P4/8/PP2PPPP/RNBQKBNR b KQkq - c6d5", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3P4/3P4/8/PPP2PPP/RNBQKBNR b KQkq - c6d5", "B13", "Caro-Kann Defense: Exchange Variation"],
  [
    "rnbqkbnr/pp2pppp/2p5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - b7b5",
    "B15",
    "Caro-Kann Defense: Gurgenidze Counterattack",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - d5e4", "B15", "Caro-Kann Defense"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - g7g6", "B15", "Caro-Kann Defense: Gurgenidze System"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6", "B15", "Caro-Kann Defense: Campomanes Attack"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/3B4/PPP2PPP/RNBQK1NR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - d5e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/5P2/PPP3PP/RNBQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", "B15", "Caro-Kann Defense"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1d2", "B12", "Caro-Kann Defense: Modern Variation"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c1e3", "B12", "Caro-Kann Defense: Mieses Gambit"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - e4d5", "B13", "Caro-Kann Defense: Exchange Variation"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - e4e5", "B12", "Caro-Kann Defense: Advance Variation"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f1d3", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f2f3", "B12", "Caro-Kann Defense: Maróczy Variation"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - d8b6", "B12", "Caro-Kann Defense: Edinburgh Variation"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P1P1/2N5/PPPP1P1P/R1BQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P1P1/8/PPPP1P1P/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/1B6/PPPP1PPP/RNBQK1NR b KQkq - d5e4", null, null],
  [
    "rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - c8g4",
    "B11",
    "Caro-Kann Defense: Two Knights Attack, Mindeno Variation",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N2N2/PPPP1PPP/R1BQKB1R b KQkq - d5e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d1f3", "B10", "Caro-Kann Defense: Goldman Variation"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d3", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - g1f3", "B10", "Caro-Kann Defense: Two Knights Attack"],
  [
    "rnbqkbnr/pp2pppp/2p5/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - h2h3",
    "B10",
    "Caro-Kann Defense: St. Patrick's Attack",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/2NP4/PPP2PPP/R1BQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/3P1N2/PPP2PPP/RNBQKB1R b KQkq - d5e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/3P4/PPP2PPP/RNBQKBNR w KQkq - b1d2", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/3P4/PPPN1PPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d3", "B10", "Caro-Kann Defense: Endgame Offer"],
  ["rnbqkbnr/pp2pppp/2p5/3p4/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - e4d5", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3P4/4P3/8/PP1P1PPP/RNBQKBNR b KQkq - c6d5", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/6P1/8/PPPPPPBP/RNBQK1NR w KQkq - c2c4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/6P1/8/PPPPPPBP/RNBQK1NR w KQkq - g4g5", "A00", "Grob Opening: Spike Attack"],
  ["rnbqkbnr/pp2pppp/2p5/3P4/8/5N2/PPPP1PPP/RNBQKB1R b KQkq - c6d5", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/8/5NP1/PPPPPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3p4/8/5NP1/PPPPPPBP/RNBQK2R b KQkq - c8g4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/3P4/8/8/PPPP1PPP/RNBQKBNR w KQkq - d5c6", null, null],
  [
    "rnbqkbnr/pp2pppp/2p5/3pP3/3P4/8/PPP2PPP/RNBQKBNR b KQkq - c6c5",
    "B12",
    "Caro-Kann Defense: Advance Variation, Botvinnik-Carls Defense",
  ],
  ["rnbqkbnr/pp2pppp/2p5/3pP3/3P4/8/PPP2PPP/RNBQKBNR b KQkq - c8f5", null, null],
  [
    "rnbqkbnr/pp2pppp/2p5/8/2p3P1/8/PP1PPPBP/RNBQK1NR w KQkq - b2b3",
    "A00",
    "Grob Opening: Grob Gambit, Richter-Grob Gambit",
  ],
  [
    "rnbqkbnr/pp2pppp/2p5/8/2pP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4",
    "D10",
    "Slav Defense: Slav Gambit, Alekhine Attack",
  ],
  ["rnbqkbnr/pp2pppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR b KQkq - b8d7", "B17", "Caro-Kann Defense: Karpov Variation"],
  ["rnbqkbnr/pp2pppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR b KQkq - c8f5", "B18", "Caro-Kann Defense: Classical Variation"],
  ["rnbqkbnr/pp2pppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/2p5/8/3PN3/8/PPP2PPP/R1BQKBNR b KQkq - h7h6", "B16", "Caro-Kann Defense: Finnish Variation"],
  ["rnbqkbnr/pp2pppp/2p5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - c3e4", "B15", "Caro-Kann Defense: Main Line"],
  ["rnbqkbnr/pp2pppp/2p5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - f1c4", "B15", "Caro-Kann Defense: von Hennig Gambit"],
  ["rnbqkbnr/pp2pppp/2p5/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f3", "B15", "Caro-Kann Defense: Rasa-Studier Gambit"],
  ["rnbqkbnr/pp2pppp/2p5/8/3Pp3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3g5", "B12", "Caro-Kann Defense: Ulysses Gambit"],
  ["rnbqkbnr/pp2pppp/2p5/8/3Pp3/5P2/PPP3PP/RNBQKBNR w KQkq - f3e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/8/3PP3/8/PPP3PP/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pp2pppp/2p5/8/3Pp3/8/PPPN1PPP/R1BQKBNR w KQkq - d2e4", "B15", "Caro-Kann Defense: Main Line"],
  [
    "rnbqkbnr/pp2pppp/2p5/8/4p1P1/2N5/PPPP1P1P/R1BQKBNR w KQkq - d2d3",
    "B10",
    "Caro-Kann Defense: Spike Variation, Scorpion-Grob Gambit",
  ],
  [
    "rnbqkbnr/pp2pppp/2p5/8/4p3/1B6/PPPP1PPP/RNBQK1NR w KQkq - d1h5",
    "B10",
    "Caro-Kann Defense: Hillbilly Attack, Schaeffer Gambit",
  ],
  ["rnbqkbnr/pp2pppp/2p5/8/4p3/2N2N2/PPPP1PPP/R1BQKB1R w KQkq - f3g5", "B10", "Caro-Kann Defense: Hector Gambit"],
  ["rnbqkbnr/pp2pppp/2p5/8/4p3/2NP4/PPP2PPP/R1BQKBNR w KQkq - c1g5", "B10", "Caro-Kann Defense: Scorpion-Horus Gambit"],
  ["rnbqkbnr/pp2pppp/2p5/8/4p3/3P1N2/PPP2PPP/RNBQKB1R w KQkq - d3e4", null, null],
  ["rnbqkbnr/pp2pppp/2p5/8/4P3/5N2/PPP2PPP/RNBQKB1R b KQkq - d8d1", null, null],
  ["rnbqkbnr/pp2pppp/2P5/8/8/8/PPPP1PPP/RNBQKBNR b KQkq - b8c6", "B01", "Scandinavian Defense: Blackburne Gambit"],
  ["rnbqkbnr/pp2pppp/2P5/8/8/8/PPPP1PPP/RNBQKBNR b KQkq - e7e5", "B01", "Scandinavian Defense: Kloosterboer Gambit"],
  ["rnbqkbnr/pp2pppp/3p4/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/pp2pppp/3p4/1Bp5/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - c8d7",
    "B52",
    "Sicilian Defense: Moscow Variation, Main Line",
  ],
  ["rnbqkbnr/pp2pppp/3p4/2p5/2P1P3/2N5/PP1P1PPP/R1BQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp2pppp/3p4/2p5/2P1P3/8/PP1P1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pp2pppp/3p4/2p5/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - c5d4", null, null],
  ["rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c5d4", "B50", "Sicilian Defense"],
  [
    "rnbqkbnr/pp2pppp/3p4/2p5/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - g8f6",
    "B50",
    "Sicilian Defense: Modern Variations, Anti-Qxd4 Move Order",
  ],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f2f4", null, null],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4P3/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - g8f6", null, null],
  [
    "rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b4",
    "B50",
    "Sicilian Defense: Wing Gambit, Deferred Variation",
  ],
  [
    "rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c3",
    "B50",
    "Sicilian Defense: Delayed Alapin Variation, with d6",
  ],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "B50", "Sicilian Defense"],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1b5", "B51", "Sicilian Defense: Moscow Variation"],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1d3", "B50", "Sicilian Defense: Kopec System"],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4P3/5NP1/PPPP1P1P/RNBQKB1R b KQkq - b7b5", "B50", "Sicilian Defense: Kotov Gambit"],
  ["rnbqkbnr/pp2pppp/3p4/2p5/4PP2/2N5/PPPP2PP/R1BQKBNR b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/pp2pppp/3p4/2pP4/8/2N5/PPP1PPPP/R1BQKBNR b KQkq - g7g6",
    "A43",
    "Benoni Defense: Old Benoni, Schmid Variation",
  ],
  ["rnbqkbnr/pp2pppp/3p4/2pP4/8/8/PPP1PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/pp2pppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g7g6",
    "B54",
    "Sicilian Defense: Dragon Variation, Accelerated Dragon",
  ],
  [
    "rnbqkbnr/pp2pppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g8f6",
    "B54",
    "Sicilian Defense: Modern Variations, Main Line",
  ],
  ["rnbqkbnr/pp2pppp/3p4/8/3pP3/2N5/PPP2PPP/R1BQKBNR w KQkq - d1d4", null, null],
  [
    "rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c3",
    "B50",
    "Sicilian Defense: Modern Variations, Tartakower",
  ],
  ["rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - d1d4", "B53", "Sicilian Defense: Chekhover Variation"],
  ["rnbqkbnr/pp2pppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3d4", null, null],
  ["rnbqkbnr/pp2pppp/3p4/8/3QP3/2N5/PPP2PPP/R1B1KBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp2pppp/3p4/8/3QP3/5N2/PPP2PPP/RNB1KB1R b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp2pppp/3p4/8/4P3/2N2N2/PP3PPP/R1BQKB1R b KQkq - e7e6", null, null],
  ["rnbqkbnr/pp2pppp/3p4/8/4P3/2N5/PP3PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp2pppp/8/2p5/2p5/1P3N2/P2PPPPP/RNBQKB1R w KQkq - b1c3", "A06", "Zukertort Opening: Regina-Nu Gambit"],
  ["rnbqkbnr/pp2pppp/8/2p5/2p5/4PN2/PP1P1PPP/RNBQKB1R w KQkq - b2b3", "A06", "Zukertort Opening: Pachman Gambit"],
  [
    "rnbqkbnr/pp2pppp/8/2p5/2Pp4/4PN2/PP1P1PPP/RNBQKB1R w KQkq - b2b4",
    "A09",
    "Réti Opening: Reversed Blumenfeld Gambit",
  ],
  ["rnbqkbnr/pp2pppp/8/2p5/2pPP3/8/PP3PPP/RNBQKBNR w KQkq - d4d5", null, null],
  [
    "rnbqkbnr/pp2pppp/8/2pP4/2p1P3/8/PP3PPP/RNBQKBNR b KQkq - b7b5",
    "D20",
    "Queen's Gambit Accepted: Central Variation, Rubinstein Defense, Yefimov Gambit",
  ],
  ["rnbqkbnr/pp2pppp/8/2pP4/2p1P3/8/PP3PPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/2P5/1P3N2/P2PPPPP/RNBQKB1R b KQkq - d5c4", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/2P5/4PN2/PP1P1PPP/RNBQKB1R b KQkq - d5c4", null, null],
  [
    "rnbqkbnr/pp2pppp/8/2Pp4/2P5/8/PP2PPPP/RNBQKBNR b KQkq - d5d4",
    "D06",
    "Queen's Gambit Declined: Austrian Attack, Salvio Countergambit",
  ],
  ["rnbqkbnr/pp2pppp/8/2pp4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - c4d5", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4c5", null, null],
  [
    "rnbqkbnr/pp2pppp/8/2pp4/3P1B2/8/PPP1PPPP/RN1QKBNR w KQkq - d4c5",
    "D00",
    "Queen's Pawn Game: Accelerated London System, Steinitz Countergambit Accepted",
  ],
  [
    "rnbqkbnr/pp2pppp/8/2pp4/3P1B2/8/PPP1PPPP/RN1QKBNR w KQkq - e2e4",
    "D00",
    "Queen's Pawn Game: Accelerated London System, Steinitz Countergambit, Morris Countergambit",
  ],
  ["rnbqkbnr/pp2pppp/8/2pp4/3P3P/5N2/PPP1PPP1/RNBQKB1R b KQkq - c5d4", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/3P3P/8/PPP1PPP1/RNBQKBNR w KQkq - e2e4", "A00", "Kádas Opening: Myers Variation"],
  ["rnbqkbnr/pp2pppp/8/2pp4/3P3P/8/PPP1PPP1/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/3P4/4PN2/PPP2PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/3P4/5NP1/PPP1PP1P/RNBQKB1R b KQkq - c5d4", null, null],
  [
    "rnbqkbnr/pp2pppp/8/2pP4/3P4/8/PP2PPPP/RNBQKBNR b KQkq - g8f6",
    "D06",
    "Queen's Gambit Declined: Austrian Defense, Gusev Countergambit",
  ],
  [
    "rnbqkbnr/pp2pppp/8/2pp4/3PPB2/8/PPP2PPP/RN1QKBNR b KQkq - d5e4",
    "D00",
    "Queen's Pawn Game: Accelerated London System, Steinitz Countergambit, Morris Countergambit Accepted",
  ],
  [
    "rnbqkbnr/pp2pppp/8/2pp4/4P3/1P6/P1PP1PPP/RNBQKBNR w KQkq - c1b2",
    "B20",
    "Sicilian Defense: Euwe Attack, Prins Gambit",
  ],
  ["rnbqkbnr/pp2pppp/8/2pp4/4P3/2P5/PP1P1PPP/RNBQKBNR w KQkq - e4d5", null, null],
  [
    "rnbqkbnr/pp2pppp/8/2pp4/4PP2/5N2/PPPP2PP/RNBQKB1R b KQkq - d5e4",
    "B21",
    "Bird Opening: Dutch Variation, Batavo Gambit",
  ],
  [
    "rnbqkbnr/pp2pppp/8/2pp4/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - b1c3",
    "B21",
    "Sicilian Defense: McDonnell Attack, Toilet Variation",
  ],
  ["rnbqkbnr/pp2pppp/8/2pp4/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - e4d5", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkbnr/pp2pppp/8/2pP4/5P2/8/PPPP2PP/RNBQKBNR b KQkq - g8f6",
    "B21",
    "Sicilian Defense: McDonnell Attack, Tal Gambit",
  ],
  ["rnbqkbnr/pp2pppp/8/2pp4/8/1P3N2/P1PPPPPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/8/1P3N2/P1PPPPPP/RNBQKB1R w KQkq - e2e4", "A06", "Nimzo-Larsen Attack: Norfolk Gambit"],
  [
    "rnbqkbnr/pp2pppp/8/2pP4/8/2P5/PP1P1PPP/RNBQKBNR b KQkq - d8d5",
    "B22",
    "Sicilian Defense: Alapin Variation, Barmen Defense",
  ],
  [
    "rnbqkbnr/pp2pppp/8/2pP4/8/2P5/PP1P1PPP/RNBQKBNR b KQkq - g8f6",
    "B22",
    "Sicilian Defense: Alapin Variation, Anti-Alapin Gambit",
  ],
  ["rnbqkbnr/pp2pppp/8/2pp4/8/4PN2/PPPP1PPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rnbqkbnr/pp2pppp/8/2pp4/8/5NP1/PPPPPP1P/RNBQKB1R w KQkq - f1g2", "A08", "King's Indian Attack: Sicilian Variation"],
  ["rnbqkbnr/pp2pppp/8/2pp4/8/5NP1/PPPPPPBP/RNBQK2R b KQkq - b8c6", "A08", "King's Indian Attack: French Variation"],
  ["rnbqkbnr/pp2pppp/8/2pp4/8/5NP1/PPPPPPBP/RNBQK2R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/8/3p4/1p2P3/P7/2PP1PPP/RNBQKBNR w KQkq - e4d5", null, null],
  ["rnbqkbnr/pp2pppp/8/3P4/1p6/P7/2PP1PPP/RNBQKBNR b KQkq - d8d5", null, null],
  ["rnbqkbnr/pp2pppp/8/3p4/2P5/8/PP1P1PPP/RNBQKBNR w KQkq - c4d5", null, null],
  ["rnbqkbnr/pp2pppp/8/3p4/2PP4/8/PP3PPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/8/3p4/3p3P/5N2/PPP1PPP1/RNBQKB1R w KQkq - c2c3", "A00", "Kádas Opening: Kádas Gambit"],
  ["rnbqkbnr/pp2pppp/8/3p4/3P4/2N5/PP2PPPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp2pppp/8/3p4/3P4/3B4/PPP2PPP/RNBQK1NR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp2pppp/8/3p4/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - b8c6", "B13", "Caro-Kann Defense: Exchange Variation"],
  ["rnbqkbnr/pp2pppp/8/3p4/3p4/5NP1/PPP1PP1P/RNBQKB1R w KQkq - f1g2", "D02", "Queen's Pawn Game: Chandler Gambit"],
  ["rnbqkbnr/pp2pppp/8/3p4/3P4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pp2pppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - c1f4", "B13", "Caro-Kann Defense: Exchange Variation"],
  ["rnbqkbnr/pp2pppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - c2c4", "B13", "Caro-Kann Defense: Panov Attack"],
  ["rnbqkbnr/pp2pppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - f1d3", null, null],
  ["rnbqkbnr/pp2pppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkbnr/pp2pppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g2g4",
    "B13",
    "Caro-Kann Defense: Exchange Variation, Bulla Attack",
  ],
  [
    "rnbqkbnr/pp2pppp/8/3p4/4P3/8/PP1P1PPP/RNBQKBNR w KQkq - d1b3",
    "B10",
    "Caro-Kann Defense: Accelerated Panov Attack, Van Weersel Attack",
  ],
  ["rnbqkbnr/pp2pppp/8/3p4/8/5N2/PPPP1PPP/RNBQKB1R w KQkq - f3e5", "B10", "Caro-Kann Defense: Apocalypse Attack"],
  [
    "rnbqkbnr/pp2pppp/8/3P4/8/8/PP1P1PPP/RNBQKBNR b KQkq - g8f6",
    "B10",
    "Caro-Kann Defense: Accelerated Panov Attack, Modern Variation",
  ],
  ["rnbqkbnr/pp3p1p/3p2p1/2pP4/4P3/2N5/PP3PPP/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkbnr/pp3p1p/3p2p1/2pP4/8/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - f7f5", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - g8f6", null, null],
  [
    "rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - d5c4",
    "D31",
    "Semi-Slav Defense: Noteboom Variation",
  ],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - g8f6", "D43", "Semi-Slav Defense"],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e3", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", "D31", "Semi-Slav Defense: Marshall Gambit"],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/4PN2/PP3PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - b1c3", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/3p4/2PPP3/2N5/PP3PPP/R1BQKBNR b KQkq - d5e4", null, null],
  [
    "rnbqkbnr/pp3ppp/2p1p3/6B1/2pP4/2N2N2/PP2PPPP/R2QKB1R b KQkq - f7f6",
    "D31",
    "Semi-Slav Defense: Noteboom Variation, Anti-Noteboom Variation, Belyavsky Line",
  ],
  ["rnbqkbnr/pp3ppp/2p1p3/8/2pP4/2N1PN2/PP3PPP/R1BQKB1R b KQkq - b7b5", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - a2a4", null, null],
  [
    "rnbqkbnr/pp3ppp/2p1p3/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - c1g5",
    "D31",
    "Semi-Slav Defense: Noteboom Variation, Anti-Noteboom Variation",
  ],
  ["rnbqkbnr/pp3ppp/2p1p3/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - e2e3", null, null],
  [
    "rnbqkbnr/pp3ppp/2p1p3/8/2pP4/2N2N2/PP2PPPP/R1BQKB1R w KQkq - g2g3",
    "D31",
    "Semi-Slav Defense: Noteboom Variation, Anti-Noteboom Gambit",
  ],
  ["rnbqkbnr/pp3ppp/2p1p3/8/2PPN3/8/PP3PPP/R1BQKBNR b KQkq - f8b4", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/8/2PPp3/2N5/PP3PPP/R1BQKBNR w KQkq - c3e4", null, null],
  ["rnbqkbnr/pp3ppp/2p1p3/8/2PPp3/2N5/PP3PPP/R1BQKBNR w KQkq - f2f3", "D31", "Semi-Slav Defense: Gunderam Gambit"],
  ["rnbqkbnr/pp3ppp/2p1p3/8/P1pP4/2N2N2/1P2PPPP/R1BQKB1R b KQkq - f8b4", null, null],
  ["rnbqkbnr/pp3ppp/2p5/3p4/2PPp1P1/7P/PP2PPB1/RNBQK1NR b KQkq - f8d6", null, null],
  ["rnbqkbnr/pp3ppp/2p5/3p4/3Pp1P1/7P/PPP1PPB1/RNBQK1NR w KQkq - c2c4", null, null],
  ["rnbqkbnr/pp3ppp/2p5/3Pp3/2BP4/8/PPP2PPP/RNBQK1NR b KQkq - c6d5", null, null],
  ["rnbqkbnr/pp3ppp/2p5/3pp3/2BPP3/8/PPP2PPP/RNBQK1NR w KQkq - e4d5", null, null],
  [
    "rnbqkbnr/pp3ppp/2p5/3pp3/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4",
    "D10",
    "Slav Defense: Winawer Countergambit, Anti-Winawer Gambit",
  ],
  ["rnbqkbnr/pp3ppp/2p5/3pp3/3P2P1/7P/PPP1PPB1/RNBQK1NR b KQkq - e5e4", null, null],
  ["rnbqkbnr/pp3ppp/2p5/3Pp3/5P2/8/PPPP2PP/RNBQKBNR w KQkq - d5c6", null, null],
  ["rnbqkbnr/pp3ppp/2p5/3pp3/6P1/7P/PPPPPPB1/RNBQK1NR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pp3ppp/2p5/3Pp3/8/3P4/PPP2PPP/RNBQKBNR w KQkq - d5c6", null, null],
  ["rnbqkbnr/pp3ppp/2p5/4p3/3PP3/5N2/PPP3PP/RNBQKB1R b KQkq - e5d4", null, null],
  ["rnbqkbnr/pp3ppp/2p5/4p3/3PP3/8/PPP3PP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkbnr/pp3ppp/2P5/4p3/5P2/8/PPPP2PP/RNBQKBNR b KQkq - f8c5",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Pickler Gambit",
  ],
  ["rnbqkbnr/pp3ppp/2P5/4p3/8/3P4/PPP2PPP/RNBQKBNR b KQkq - b8c6", "C20", "King's Pawn Game: Weber Gambit"],
  [
    "rnbqkbnr/pp3ppp/2p5/8/3pP3/5N2/PPP3PP/RNBQKB1R w KQkq - f1c4",
    "B12",
    "Caro-Kann Defense: Maróczy Variation, Maróczy Gambit",
  ],
  ["rnbqkbnr/pp3ppp/3p4/2pP4/8/2N5/PP2PPPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/pp3ppp/3p4/2pP4/8/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pp3ppp/3pp3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - a7a6", null, null],
  ["rnbqkbnr/pp3ppp/3pp3/8/2B1P3/2N2N2/PP3PPP/R1BQK2R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp3ppp/3pp3/8/4P3/2N2N2/PP3PPP/R1BQKB1R w KQkq - f1c4", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2pp4/2PP4/2N1P3/PP3PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2pp4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - c4d5", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2pp4/2PP4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e3", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2pp4/2PP4/5N2/PP2PPPP/RNBQKB1R w KQkq - c4d5", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2pP4/3P4/2N5/PP2PPPP/R1BQKBNR b KQkq - c5d4", "D32", "Tarrasch Defense: Schara Gambit"],
  [
    "rnbqkbnr/pp3ppp/4p3/2pP4/3P4/2N5/PP2PPPP/R1BQKBNR b KQkq - e6d5",
    "D32",
    "Queen's Gambit Declined: Tarrasch Defense",
  ],
  ["rnbqkbnr/pp3ppp/4p3/2pP4/3P4/5N2/PP2PPPP/RNBQKB1R b KQkq - e6d5", null, null],
  [
    "rnbqkbnr/pp3ppp/4p3/2pP4/3P4/8/PPPN1PPP/R1BQKBNR b KQkq - d8d5",
    "C07",
    "French Defense: Tarrasch Variation, Chistyakov Defense",
  ],
  [
    "rnbqkbnr/pp3ppp/4p3/2pP4/3P4/8/PPPN1PPP/R1BQKBNR b KQkq - e6d5",
    "C08",
    "French Defense: Tarrasch Variation, Open System",
  ],
  [
    "rnbqkbnr/pp3ppp/4p3/2pP4/3P4/8/PPPN1PPP/R1BQKBNR b KQkq - g8f6",
    "C07",
    "French Defense: Tarrasch Variation, Open System, Shaposhnikov Gambit",
  ],
  [
    "rnbqkbnr/pp3ppp/4p3/2pp4/3PP3/8/PPPN1PPP/R1BQKBNR w KQkq - c2c3",
    "C07",
    "French Defense: Tarrasch Variation, Open System, Süchting Line",
  ],
  ["rnbqkbnr/pp3ppp/4p3/2pp4/3PP3/8/PPPN1PPP/R1BQKBNR w KQkq - e4d5", null, null],
  [
    "rnbqkbnr/pp3ppp/4p3/2pp4/3PP3/8/PPPN1PPP/R1BQKBNR w KQkq - g1f3",
    "C07",
    "French Defense: Tarrasch Variation, Open System, Euwe-Keres Line",
  ],
  ["rnbqkbnr/pp3ppp/4p3/2pp4/4P3/2P2N2/PP1P1PPP/RNBQKB1R w KQkq - e4d5", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2pP4/8/2P2N2/PP1P1PPP/RNBQKB1R b KQkq - d8d5", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2ppP3/3P2Q1/8/PPP2PPP/RNB1KBNR b KQkq - c5d4", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/2P5/PP3PPP/RNBQKBNR b KQkq - b8c6", "C02", "French Defense: Advance Variation"],
  ["rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/2P5/PP3PPP/RNBQKBNR b KQkq - d8b6", null, null],
  ["rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/5N2/PPP2PPP/RNBQKB1R b KQkq - c5d4", null, null],
  [
    "rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - b2b4",
    "C02",
    "French Defense: Advance Variation, Frenkel Gambit",
  ],
  ["rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - c2c3", "C02", "French Defense: Advance Variation"],
  [
    "rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - d1g4",
    "C02",
    "French Defense: Advance Variation, Nimzowitsch Attack",
  ],
  [
    "rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - d4c5",
    "C02",
    "French Defense: Advance Variation, Steinitz Variation",
  ],
  [
    "rnbqkbnr/pp3ppp/4p3/2ppP3/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g1f3",
    "C02",
    "French Defense: Advance Variation, Nimzowitsch System",
  ],
  ["rnbqkbnr/pp3ppp/4p3/2ppP3/8/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b4", "C00", "French Defense: Wing Gambit"],
  ["rnbqkbnr/pp3ppp/4p3/3P4/3p4/2N5/PP2PPPP/R1BQKBNR w KQkq - d1d4", null, null],
  ["rnbqkbnr/pp3ppp/4p3/3P4/3Q4/2N5/PP2PPPP/R1B1KBNR b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/pp3ppp/4p3/3pP3/3p2Q1/8/PPP2PPP/RNB1KBNR w KQkq - g1f3",
    "C02",
    "French Defense: Advance Variation, Nimzowitsch Gambit",
  ],
  [
    "rnbqkbnr/pp3ppp/4p3/3pP3/3p4/5N2/PPP2PPP/RNBQKB1R w KQkq - f1d3",
    "C02",
    "French Defense: Advance Variation, Ruisdonk Gambit",
  ],
  ["rnbqkbnr/pp3ppp/8/1B1pp3/3P4/8/PPP2PPP/RNBQK1NR b KQkq - c8d7", null, null],
  ["rnbqkbnr/pp3ppp/8/2P5/3p4/2N5/PP2PPPP/R1BQKBNR w KQkq - c3a4", null, null],
  ["rnbqkbnr/pp3ppp/8/2P5/N2p4/8/PP2PPPP/R1BQKBNR b KQkq - b7b5", "D32", "Tarrasch Defense: Tarrasch Gambit"],
  ["rnbqkbnr/pp3ppp/8/2pp4/3P4/2N2N2/PP2PPPP/R1BQKB1R b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp3ppp/8/2pp4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - d4c5", null, null],
  ["rnbqkbnr/pp3ppp/8/2pp4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - e2e4", "D32", "Tarrasch Defense: Marshall Gambit"],
  ["rnbqkbnr/pp3ppp/8/2pp4/3P4/2N5/PP2PPPP/R1BQKBNR w KQkq - g1f3", "D32", "Tarrasch Defense: Two Knights Variation"],
  [
    "rnbqkbnr/pp3ppp/8/2pp4/3P4/5N2/PP2PPPP/RNBQKB1R w KQkq - c1g5",
    "D30",
    "Queen's Gambit Declined: Tarrasch Defense, Pseudo-Tarrasch Bishop Attack",
  ],
  ["rnbqkbnr/pp3ppp/8/2pp4/3P4/5N2/PP2PPPP/RNBQKB1R w KQkq - g2g3", null, null],
  [
    "rnbqkbnr/pp3ppp/8/2pp4/3P4/5N2/PPPN1PPP/R1BQKB1R b KQkq - b8c6",
    "C09",
    "French Defense: Tarrasch Variation, Open System, Main Line",
  ],
  [
    "rnbqkbnr/pp3ppp/8/2pp4/3P4/5N2/PPPN1PPP/R1BQKB1R b KQkq - c5c4",
    "C08",
    "French Defense: Tarrasch Variation, Open System, Advance Line",
  ],
  ["rnbqkbnr/pp3ppp/8/2pp4/3P4/5NP1/PP2PP1P/RNBQKB1R b KQkq - b8c6", null, null],
  ["rnbqkbnr/pp3ppp/8/2pp4/3P4/8/PPPN1PPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pp3ppp/8/2Pp4/8/2N5/PP2PPPP/R1BQKBNR b KQkq - d5d4", null, null],
  ["rnbqkbnr/pp3ppp/8/3pp3/2BP4/8/PPP2PPP/RNBQK1NR w KQkq - c4b5", null, null],
  [
    "rnbqkbnr/pp4pp/2p1p3/3p1p2/2PP4/2N1P3/PP3PPP/R1BQKBNR w KQkq - g2g4",
    "D31",
    "Semi-Slav Defense: Anti-Noteboom, Stonewall Variation, Portisch Gambit",
  ],
  [
    "rnbqkbnr/ppp1p1pp/3p4/5p2/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - e2e4",
    "A10",
    "English Opening: Anglo-Dutch Variation, Chabanon Gambit",
  ],
  [
    "rnbqkbnr/ppp1p1pp/3p4/5p2/3P4/3Q4/PPP1PPPP/RNB1KBNR w KQkq - g2g4",
    "A80",
    "Dutch Defense: Manhattan Gambit, Anti-Modern",
  ],
  ["rnbqkbnr/ppp1p1pp/8/3p1p2/3P4/2N5/PPP1PPPP/R1BQKBNR w KQkq - e2e4", "A80", "Dutch Defense: Kingfisher Gambit"],
  [
    "rnbqkbnr/ppp1p1pp/8/3p1p2/3P4/3Q4/PPP1PPPP/RNB1KBNR w KQkq - g2g4",
    "A80",
    "Dutch Defense: Manhattan Gambit, Anti-Stonewall",
  ],
  [
    "rnbqkbnr/ppp1p1pp/8/3p4/3PP1p1/8/PPP2P1P/RNBQKBNR w KQkq - b1c3",
    "A80",
    "Dutch Defense: Krejcik Gambit, Tate Gambit",
  ],
  ["rnbqkbnr/ppp1p1pp/8/5p2/3p1P2/8/PPPPPNPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1p1pp/8/5p2/3pNP2/8/PPPPP1PP/R1BQKBNR w KQkq - e4f2", null, null],
  ["rnbqkbnr/ppp1pp1p/3p2p1/8/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkbnr/ppp1pp1p/3p2p1/8/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c2c4", null, null],
  ["rnbqkbnr/ppp1pp1p/3p2p1/8/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - c7c6", "B06", "Rat Defense: Accelerated Gurgenidze"],
  ["rnbqkbnr/ppp1pp1p/3p2p1/8/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/ppp1pp1p/6p1/3p4/3PP3/5P2/PPP3PP/RNBQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/ppp1pp1p/6p1/3p4/4P3/5P2/PPPP2PP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp1pp1p/6p1/3p4/8/5NP1/PPPPPP1P/RNBQKB1R w KQkq - f1g2", null, null],
  ["rnbqkbnr/ppp1pp1p/6p1/3p4/8/5NP1/PPPPPPBP/RNBQK2R b KQkq - f8g7", null, null],
  ["rnbqkbnr/ppp1pp1p/6p1/8/3Pp3/5P2/PPP3PP/RNBQKBNR w KQkq - c2c3", "A00", "Barnes Opening: Gedult Gambit"],
  ["rnbqkbnr/ppp1ppp1/8/3p3p/6P1/8/PPPPPPBP/RNBQK1NR w KQkq - g4h5", "A00", "Grob Opening: Grob Gambit, Basman Gambit"],
  ["rnbqkbnr/ppp1pppp/3p4/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e7e5", "A41", "Rat Defense: English Rat"],
  ["rnbqkbnr/ppp1pppp/3p4/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - c8g4", "A41", "Wade Defense"],
  ["rnbqkbnr/ppp1pppp/3p4/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - e7e5", "A04", "Zukertort Opening: Vos Gambit"],
  ["rnbqkbnr/ppp1pppp/3p4/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - g7g6", null, null],
  ["rnbqkbnr/ppp1pppp/3p4/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", "A41", "Old Indian Defense"],
  ["rnbqkbnr/ppp1pppp/3p4/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/ppp1pppp/3p4/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - b8d7", "B00", "Rat Defense: Antal Defense"],
  ["rnbqkbnr/ppp1pppp/3p4/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - e7e5", "B07", "King's Pawn Game: Maróczy Defense"],
  ["rnbqkbnr/ppp1pppp/3p4/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f7f5", "A82", "Rat Defense: Balogh Defense"],
  ["rnbqkbnr/ppp1pppp/3p4/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - g8f6", "B00", "Pirc Defense"],
  ["rnbqkbnr/ppp1pppp/3p4/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - c8g4", "A04", "Zukertort Opening: Wade Defense"],
  ["rnbqkbnr/ppp1pppp/3p4/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", "B00", "Pirc Defense"],
  ["rnbqkbnr/ppp1pppp/3p4/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f2f4", "B00", "Rat Defense: Harmonist"],
  ["rnbqkbnr/ppp1pppp/3p4/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g2g4", "B00", "Rat Defense: Spike Attack"],
  ["rnbqkbnr/ppp1pppp/3p4/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - h2h4", "B00", "Rat Defense: Petruccioli Attack"],
  ["rnbqkbnr/ppp1pppp/3p4/8/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - d6d5", null, null],
  ["rnbqkbnr/ppp1pppp/3p4/8/5P2/2N5/PPPPP1PP/R1BQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/ppp1pppp/3p4/8/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - f2f4", null, null],
  ["rnbqkbnr/ppp1pppp/3p4/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp1pppp/3p4/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - e2e4", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/3p2B1/3P4/8/PPP1PPPP/RN1QKBNR b KQkq - c8g4",
    "D00",
    "Queen's Pawn Game: Levitsky Attack, Welling Variation",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/1P6/8/P1PPPPPP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/1P6/8/P1PPPPPP/RNBQKBNR w KQkq - g1f3", "A06", "Zukertort Opening: Santasiere's Folly"],
  ["rnbqkbnr/ppp1pppp/8/3p4/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - c7c6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - c8f5", "A00", "Polish Opening: Baltic Defense"],
  ["rnbqkbnr/ppp1pppp/8/3p4/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - d8d6", "A00", "Polish Opening: German Defense"],
  ["rnbqkbnr/ppp1pppp/8/3p4/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - b7b5", "A09", "Réti Opening: Zilbermints Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - d5c4", "A09", "Réti Opening: Réti Accepted"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - d5d4", "A09", "Réti Opening: Advance Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - e7e6", "A13", "English Opening: Agincourt Defense"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - c4d5", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - b7b5",
    "D06",
    "Queen's Gambit Declined: Zilbermints Gambit",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - b8c6", "D07", "Queen's Gambit Declined: Chigorin Defense"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - c7c5", "D06", "Queen's Gambit Declined: Austrian Defense"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - c7c6", "D10", "Slav Defense"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - c8f5", "D06", "Queen's Gambit Declined: Baltic Defense"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - d5c4", "D20", "Queen's Gambit Accepted"],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e7e5",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e7e6", "D30", "Queen's Gambit Declined"],
  ["rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - g8f6", "D06", "Queen's Gambit Declined: Marshall Defense"],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/3P1B2/8/PPP1PPPP/RN1QKBNR b KQkq - c7c5",
    "D00",
    "Queen's Pawn Game: Accelerated London System, Steinitz Countergambit",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P3P/8/PPP1PPP1/RNBQKBNR b KQkq - c7c5", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - c7c5",
    "D00",
    "Queen's Pawn Game: Chigorin Variation, Irish Gambit",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - c8f5",
    "D00",
    "Queen's Pawn Game: Chigorin Variation, Alburt Defense",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - c8g4",
    "D00",
    "Queen's Pawn Game: Chigorin Variation, Anti-Veresov",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - e7e5",
    "D00",
    "Queen's Pawn Game: Chigorin Variation, Shaviliuk Gambit",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - e7e6", "D00", "Queen's Pawn Game: Chigorin Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - g8f6", "A45", "Queen's Pawn Game: Chigorin Variation"],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - h7h5",
    "D00",
    "Queen's Pawn Game: Chigorin Variation, Shropshire Defense",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/4P3/PPP2PPP/RNBQKBNR b KQkq - g8f6", "D00", "Queen's Pawn Game"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - b8c6", "D02", "Queen's Pawn Game: Chigorin Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - c7c5", "D02", "Queen's Pawn Game: Krause Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - c8f5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - c8g4", "D02", "Queen's Pawn Game: Anti-Torre"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - e7e6", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - g8f6",
    "D02",
    "Queen's Pawn Game: Symmetrical Variation",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - b1c3", "D00", "Queen's Pawn Game: Chigorin Variation"],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c1f4",
    "D00",
    "Queen's Pawn Game: Accelerated London System",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c1g5", "D00", "Queen's Pawn Game: Levitsky Attack"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", "D06", "Queen's Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - d1d3", "D00", "Amazon Attack"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - e2e3", "D00", "Queen's Pawn Game"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", "D00", "Blackmar-Diemer Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - f2f4", "D00", "Queen's Pawn Game: Mason Attack"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3", "D02", "Queen's Pawn Game: Zukertort Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g2g4", "D00", "Queen's Pawn Game: Zurich Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P1P1/8/PPPP1P1P/RNBQKBNR b KQkq - d5e4", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/3P4/4p3/2N5/PPP2PPP/R1BQKBNR w KQkq - f2f3",
    "B00",
    "Nimzowitsch Defense: Scandinavian Variation, Bogoljubow Variation, Richter Gambit",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d5e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P3/5P2/PPPP2PP/RNBQKBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b3", "B01", "Scandinavian Defense"],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b4", "B01", "Scandinavian Defense: Zilbermints Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - e4d5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1f3", "A06", "Zukertort Opening: Tennison Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - e4d5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/1P6/P1PPP1PP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/2N5/PPPPP1PP/R1BQKBNR b KQkq - d5d4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/2N5/PPPPP1PP/R1BQKBNR b KQkq - e7e5", "A00", "Van Geet Opening: Damhaug Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/2N5/PPPPP1PP/R1BQKBNR b KQkq - g7g5", "A00", "Van Geet Opening: Warsteiner Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/5N2/PPPPP1PP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3P4/5P2/8/PPPP2PP/RNBQKBNR b KQkq - g8f6", "B00", "Rat Defense: Fuller Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - b2b3", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - c2c4", "A03", "Bird Opening: Sturm Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - e2e4", "A03", "Bird Opening: Williams Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - g2g4",
    "A03",
    "Bird Opening: Dutch Variation, Dudweiler Gambit",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/6P1/7P/PPPPPP2/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/6P1/8/PPPPPP1P/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/6P1/8/PPPPPP1P/RNBQKBNR w KQkq - f1g2", "A00", "Grob Opening: Grob Gambit"],
  ["rnbqkbnr/ppp1pppp/8/3p4/6P1/8/PPPPPP1P/RNBQKBNR w KQkq - h2h3", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/6P1/8/PPPPPPBP/RNBQK1NR b KQkq - c7c6", "A00", "Grob Opening: Grob Gambit Declined"],
  ["rnbqkbnr/ppp1pppp/8/3p4/6P1/8/PPPPPPBP/RNBQK1NR b KQkq - c8g4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/6P1/8/PPPPPPBP/RNBQK1NR b KQkq - e7e5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/6P1/8/PPPPPPBP/RNBQK1NR b KQkq - h7h5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/7P/8/PPPPPPP1/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/7P/8/PPPPPPP1/RNBQKBNR w KQkq - h1h3", "A00", "Kádas Opening: Beginner's Trap"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/1P3N2/P1PPPPPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/1P3N2/P1PPPPPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/1P6/P1PPPPPP/RNBQKBNR w KQkq - c1a3", "A01", "Nimzo-Larsen Attack: Graz Attack"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/2N1P3/PPPP1PPP/R1BQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - d2d3", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - e2e3", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - f2f4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/2NP4/PPP1PPPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/4PN2/PPPP1PPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/4PN2/PPPP1PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - a2a4", "A06", "Zukertort Opening: The Potato"],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - b1c3",
    "A06",
    "Zukertort Opening: Reversed Mexican Defense",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - b2b3", "A06", "Nimzo-Larsen Attack: Classical Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - c2c4", "A09", "Réti Opening"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - d2d3", "A06", "Zukertort Opening: Old Indian Attack"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - d2d4", "D02", "Queen's Pawn Game: Zukertort Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - g2g3", "A07", "King's Indian Attack"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - h1g1", "A06", "Zukertort Opening: Ampel Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - c7c5", "A07", "King's Indian Attack: Sicilian Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - c8g4", "A07", "King's Indian Attack: Keres Variation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - e7e5", "A07", "King's Indian Attack: Omega-Delta Gambit"],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - g7g5",
    "A07",
    "Hungarian Opening: Wiedenhagen-Beta Gambit",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - g7g6", "A07", "King's Indian Attack: Double Fianchetto"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - g8f6", "A05", "King's Indian Attack"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/5P2/PPPPP1PP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/6P1/PPPPPP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/6P1/PPPPPP1P/RNBQKBNR w KQkq - g1f3", "A07", "King's Indian Attack"],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/8/6P1/PPPPPPBP/RNBQK1NR b KQkq - c7c5",
    "A00",
    "Hungarian Opening: Reversed Modern Defense",
  ],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/6P1/PPPPPPBP/RNBQK1NR b KQkq - c7c6", "A00", "Hungarian Opening: Slav Formation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/6P1/PPPPPPBP/RNBQK1NR b KQkq - e7e5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/6P1/PPPPPPBP/RNBQK1NR b KQkq - e7e6", "A00", "Hungarian Opening: Catalan Formation"],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/6PN/PPPPPP1P/RNBQKB1R b KQkq - e7e5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/7N/PPPPPPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkbnr/ppp1pppp/8/3p4/8/7P/PPPPPPP1/RNBQKBNR w KQkq - a2a3", null, null],
  ["rnbqkbnr/ppp1pppp/8/3P4/8/8/PP1PPPPP/RNBQKBNR b KQkq - d8d5", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/3P4/8/8/PP1PPPPP/RNBQKBNR b KQkq - e7e6",
    "A10",
    "English Opening: Anglo-Scandinavian Defense, Löhn Gambit",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/3P4/8/8/PP1PPPPP/RNBQKBNR b KQkq - g8f6",
    "A10",
    "English Opening: Anglo-Scandinavian Defense, Schulz Gambit",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/3P4/8/8/PPPP1PPP/RNBQKBNR b KQkq - c7c6",
    "B01",
    "Scandinavian Defense: Blackburne-Kloosterboer Gambit",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/3P4/8/8/PPPP1PPP/RNBQKBNR b KQkq - d8d5",
    "B01",
    "Scandinavian Defense: Mieses-Kotroc Variation",
  ],
  ["rnbqkbnr/ppp1pppp/8/3P4/8/8/PPPP1PPP/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/ppp1pppp/8/3P4/8/8/PPPP1PPP/RNBQKBNR b KQkq - g8f6", "B01", "Scandinavian Defense: Modern Variation"],
  [
    "rnbqkbnr/ppp1pppp/8/3p4/8/P6P/1PPPPPP1/RNBQKBNR b KQkq - e7e5",
    "A00",
    "Creepy Crawly Formation: Classical Defense",
  ],
  ["rnbqkbnr/ppp1pppp/8/6N1/4p3/8/PPPP1PPP/RNBQKB1R b KQkq - g8f6", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/8/1PPp4/5N2/P2PPPPP/RNBQKB1R b KQkq - c7c5",
    "A09",
    "Réti Opening: Advance Variation, Michel Gambit",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/8/1PPp4/5N2/P2PPPPP/RNBQKB1R b KQkq - g7g5",
    "A09",
    "Réti Opening: Advance Variation, Navara Gambit",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/8/2p5/4PN2/PP1P1PPP/RNBQKB1R b KQkq - c8e6",
    "A09",
    "Réti Opening: Réti Gambit, Keres Variation",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/2p5/5N2/PP1PPPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/4P3/PP3PPP/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/4P3/PP3PPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/2Pp4/4PN2/PP1P1PPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/2Pp4/5N2/PP1PPPPP/RNBQKB1R w KQkq - b2b4", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/2Pp4/5N2/PP1PPPPP/RNBQKB1R w KQkq - e2e3", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/2Pp4/5N2/PP1PPPPP/RNBQKB1R w KQkq - h1g1", "A09", "Réti Opening: Penguin Variation"],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/5N2/PP2PPPP/RNBQKB1R b KQkq - a7a6", "D22", "Queen's Gambit Accepted: Alekhine Defense"],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/5N2/PP2PPPP/RNBQKB1R b KQkq - b7b5", "D21", "Queen's Gambit Accepted: Slav Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/5N2/PP2PPPP/RNBQKB1R b KQkq - b8d7", "D21", "Queen's Gambit Accepted: Godes Variation"],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c7c5", "D21", "Queen's Gambit Accepted: Gunsberg Defense"],
  [
    "rnbqkbnr/ppp1pppp/8/8/2pP4/5N2/PP2PPPP/RNBQKB1R b KQkq - e7e6",
    "D21",
    "Queen's Gambit Accepted: Rosenthal Variation",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/5N2/PP2PPPP/RNBQKB1R b KQkq - g8f6", "D23", "Queen's Gambit Accepted"],
  [
    "rnbqkbnr/ppp1pppp/8/8/2pP4/8/PP2PPPP/RNBQKBNR w KQkq - d1a4",
    "D20",
    "Queen's Gambit Accepted: Accelerated Mannheim Variation",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/8/PP2PPPP/RNBQKBNR w KQkq - e2e3", "D20", "Queen's Gambit Accepted: Old Variation"],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/8/PP2PPPP/RNBQKBNR w KQkq - e2e4", "D20", "Queen's Gambit Accepted: Saduleto Variation"],
  ["rnbqkbnr/ppp1pppp/8/8/2pP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", "D21", "Queen's Gambit Accepted: Normal Variation"],
  [
    "rnbqkbnr/ppp1pppp/8/8/2pPP3/8/PP3PPP/RNBQKBNR b KQkq - b7b5",
    "D20",
    "Queen's Gambit Accepted: Central Variation, Greco Variation",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/8/2pPP3/8/PP3PPP/RNBQKBNR b KQkq - b8c6",
    "D20",
    "Queen's Gambit Accepted: Central Variation, Modern Defense",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/8/2pPP3/8/PP3PPP/RNBQKBNR b KQkq - c7c5",
    "D20",
    "Queen's Gambit Accepted: Central Variation, Rubinstein Defense",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/8/2pPP3/8/PP3PPP/RNBQKBNR b KQkq - e7e5",
    "D20",
    "Queen's Gambit Accepted: Central Variation, McDonnell Defense",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/2pPP3/8/PP3PPP/RNBQKBNR b KQkq - f7f5", "D20", "Queen's Gambit Accepted: Schwartz Defense"],
  [
    "rnbqkbnr/ppp1pppp/8/8/2pPP3/8/PP3PPP/RNBQKBNR b KQkq - g8f6",
    "D20",
    "Queen's Gambit Accepted: Central Variation, Alekhine System",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/3p1P2/2N5/PPPPP1PP/R1BQKBNR w KQkq - c3e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/3pNP2/8/PPPPP1PP/R1BQKBNR b KQkq - c7c5", "A00", "Van Geet Opening: Melleby Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/3pNP2/8/PPPPP1PP/R1BQKBNR b KQkq - e7e5", "A00", "Van Geet Opening: Pfeiffer Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/3pNP2/8/PPPPP1PP/R1BQKBNR b KQkq - f7f5", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/8/3Pp3/2N5/PPP2PPP/R1BQKBNR b KQkq - c7c5",
    "D00",
    "Blackmar-Diemer Gambit: Reversed Albin Countergambit",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/3Pp3/2N5/PPP2PPP/R1BQKBNR b KQkq - c8f5", "D00", "Blackmar-Diemer Gambit: Zeller Defense"],
  [
    "rnbqkbnr/ppp1pppp/8/8/3Pp3/2N5/PPP2PPP/R1BQKBNR b KQkq - e7e5",
    "D00",
    "Blackmar-Diemer Gambit: Lemberger Countergambit",
  ],
  [
    "rnbqkbnr/ppp1pppp/8/8/3Pp3/2N5/PPP2PPP/R1BQKBNR b KQkq - f7f5",
    "D00",
    "Blackmar-Diemer Gambit: Netherlands Variation",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/3Pp3/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6", "D00", "Blackmar-Diemer Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/3Pp3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/8/3Pp3/8/PPP2PPP/RNBQKBNR w KQkq - c1e3",
    "D00",
    "Blackmar-Diemer Gambit: Diemer-Rosenberg Attack",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/3Pp3/8/PPP2PPP/RNBQKBNR w KQkq - f1c4", "D00", "Blackmar-Diemer Gambit: Fritz Attack"],
  ["rnbqkbnr/ppp1pppp/8/8/3Pp3/8/PPP2PPP/RNBQKBNR w KQkq - f2f3", "D00", "Blackmar-Diemer Gambit: Blackmar Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/4N3/8/PPPP1PPP/R1BQKBNR b KQkq - e7e5", "B01", "Van Geet Opening: Grünfeld Defense"],
  ["rnbqkbnr/ppp1pppp/8/8/4p1P1/2N5/PPPP1P1P/R1BQKBNR b KQkq - e7e5", null, null],
  [
    "rnbqkbnr/ppp1pppp/8/8/4p1P1/2N5/PPPP1P1P/R1BQKBNR b KQkq - h7h5",
    "A00",
    "Grob Opening: Zilbermints Gambit, Schiller Defense",
  ],
  ["rnbqkbnr/ppp1pppp/8/8/4p1P1/8/PPPP1P1P/RNBQKBNR w KQkq - b1c3", "A00", "Grob Opening: Zilbermints Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/4p3/2N5/PPPP1PPP/R1BQKBNR w KQkq - c3e4", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/4p3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d3", "A00", "Van Geet Opening: Dunst-Perrenet Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/4p3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f1c4", "A00", "Van Geet Opening: Hector Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/4p3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f2f3", "A00", "Van Geet Opening: Dougherty Gambit"],
  ["rnbqkbnr/ppp1pppp/8/8/4p3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f3g5", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/4pP2/2N5/PPPP2PP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/4pP2/8/PPPP2PP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/ppp1pppp/8/8/8/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp2p1p/3p4/6p1/2B1Pp2/5N2/PPPP2PP/RNBQ1RK1 b kq - c8g4", null, null],
  ["rnbqkbnr/ppp2p1p/3p4/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R w KQkq - e1g1", null, null],
  ["rnbqkbnr/ppp2p1p/8/3pN3/3PPppP/8/PPP3P1/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2p1p/8/3pN3/4PppP/8/PPPP2P1/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp2p2/3p3p/6p1/2BPPp1P/5N2/PPP3P1/RNBQK2R b KQkq - f8g7", "C34", "King's Gambit Accepted: Greco Gambit"],
  ["rnbqkbnr/ppp2p2/3p3p/6p1/2BPPp2/5N2/PPP3PP/RNBQK2R w KQkq - h2h4", null, null],
  ["rnbqkbnr/ppp2pp1/3p3p/8/2B1Pp2/5N2/PPPP2PP/RNBQK2R w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp2pp1/3p3p/8/2BPPp2/5N2/PPP3PP/RNBQK2R b KQkq - g7g5", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f7f5", "C41", "Philidor Defense: Lopez Countergambit"],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f8e7", "C41", "Philidor Defense"],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/2P5/2N1P3/PP1P1PPP/R1BQKBNR b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/ppp2ppp/3p4/4p3/2P5/2N2N2/PP1PPPPP/R1BQKB1R b KQkq - c8g4",
    "A21",
    "English Opening: King's English Variation, Smyslov Defense",
  ],
  [
    "rnbqkbnr/ppp2ppp/3p4/4p3/2P5/2N3P1/PP1PPP1P/R1BQKBNR b KQkq - c7c6",
    "A21",
    "English Opening: King's English Variation, Keres Defense",
  ],
  [
    "rnbqkbnr/ppp2ppp/3p4/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g1f3",
    "A21",
    "English Opening: King's English Variation",
  ],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR w KQkq - g2g3", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/2P5/4P3/PP1P1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/4P3/2P5/8/PP2PPPP/RNBQKBNR b KQkq - b8c6", "A41", "Rat Defense: English Rat, Lisbon Gambit"],
  ["rnbqkbnr/ppp2ppp/3p4/4P3/2P5/8/PP2PPPP/RNBQKBNR b KQkq - c8e6", "A41", "Rat Defense: English Rat, Pounds Gambit"],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4e5", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - b8d7", "C41", "Philidor Defense: Hanham Variation"],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c8d7", "C41", "Philidor Defense: Philidor Gambit"],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c8g4", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - e5d4", "C41", "Philidor Defense: Exchange Variation"],
  [
    "rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - f7f5",
    "C41",
    "Philidor Defense: Philidor Countergambit",
  ],
  [
    "rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - g8f6",
    "C41",
    "Philidor Defense: Nimzowitsch Variation",
  ],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - d4e5", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f2f4", "C25", "Vienna Game: Omaha Gambit"],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "C41", "Philidor Defense"],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1c4", "C41", "Philidor Defense"],
  ["rnbqkbnr/ppp2ppp/3p4/4P3/4P3/8/PPP2PPP/RNBQKBNR b KQkq - c8d7", "C20", "King's Pawn Game: Philidor Gambit"],
  ["rnbqkbnr/ppp2ppp/3p4/4p3/5P2/2N5/PPPPP1PP/R1BQKBNR w KQkq - f4e5", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/4P3/8/2N5/PPPPP1PP/R1BQKBNR b KQkq - b8c6", "A00", "Van Geet Opening: Hergert Gambit"],
  ["rnbqkbnr/ppp2ppp/3p4/4P3/8/8/PPPPP1PP/RNBQKBNR w KQkq - e5d6", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/8/2B1Pp2/5N2/PPPP2PP/RNBQK2R b KQkq - h7h6", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - d6d5", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g7g6", "C41", "Philidor Defense: Larsen Variation"],
  ["rnbqkbnr/ppp2ppp/3p4/8/3NP3/8/PPP2PPP/RNBQKB1R b KQkq - g8f6", "C41", "Philidor Defense: Exchange Variation"],
  ["rnbqkbnr/ppp2ppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - c2c3", "C41", "Philidor Defense: Bird Gambit"],
  ["rnbqkbnr/ppp2ppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - d1d4", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4", "C41", "Philidor Defense: Morphy Gambit"],
  ["rnbqkbnr/ppp2ppp/3p4/8/3pP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3d4", "C41", "Philidor Defense: Exchange Variation"],
  ["rnbqkbnr/ppp2ppp/3p4/8/3PPp2/5N2/PPP3PP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/8/3QP3/5N2/PPP2PPP/RNB1KB1R b KQkq - c8d7", "C41", "Philidor Defense: Boden Variation"],
  [
    "rnbqkbnr/ppp2ppp/3p4/8/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - b2b4",
    "C34",
    "King's Gambit Accepted: Fischer Defense, Schulder Gambit",
  ],
  ["rnbqkbnr/ppp2ppp/3p4/8/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp2ppp/3p4/8/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnbqkbnr/ppp2ppp/3P4/8/8/8/PPPPP1PP/RNBQKBNR b KQkq - f8d6", null, null],
  ["rnbqkbnr/ppp2ppp/3P4/8/8/8/PPPPP1PP/RNBQKBNR b KQkq - g8f6", "A02", "Bird Opening: From's Gambit, Langheld Gambit"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2P1P3/8/PP1P1PPP/RNBQKBNR w KQkq - c4d5", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2P5/1P3N2/P2PPPPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - b2b3", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2P5/5N2/PP1PPPPP/RNBQKB1R w KQkq - g2g3", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - b7b6", null, null],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - c7c5",
    "A13",
    "English Opening: Agincourt Defense, Catalan Defense",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - c7c6",
    "A13",
    "English Opening: Agincourt Defense, Kurajica Defense",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2P5/5NP1/PP1PPP1P/RNBQKB1R b KQkq - g8f6", "A13", "English Opening: Neo-Catalan"],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - a7a6",
    "D31",
    "Queen's Gambit Declined: Janowski Variation",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - c7c5", "D32", "Tarrasch Defense"],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - c7c6",
    "D31",
    "Semi-Slav Defense: Accelerated Move Order",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - f8e7",
    "D31",
    "Queen's Gambit Declined: Charousek Variation",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - g8f6",
    "D35",
    "Queen's Gambit Declined: Normal Defense",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c7c5",
    "D30",
    "Queen's Gambit Declined: Tarrasch Defense, Pseudo-Tarrasch",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - c7c6", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - g8f6", null, null],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3",
    "D31",
    "Queen's Gambit Declined: Queen's Knight Variation",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/2PPP3/8/PP3PPP/RNBQKBNR b KQkq - d5e4",
    "C00",
    "French Defense: Diemer-Duhm Gambit Accepted",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3P4/2N5/PPP1PPPP/R1BQKBNR w KQkq - c1f4", "D01", "Rapport-Jobava System, with e6"],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/3P4/5N2/PPP1PPPP/RNBQKB1R w KQkq - c1f4",
    "D02",
    "Queen's Pawn Game: London System, with e6",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3P4/3P4/8/PPP2PPP/RNBQKBNR b KQkq - e6d5", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - a7a6", null, null],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - b8c6",
    "C10",
    "French Defense: Hecht-Reefschläger Variation",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - c7c5", "C10", "French Defense: Marshall Gambit"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - d5e4", "C10", "French Defense: Rubinstein Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - f8b4", "C15", "French Defense: Winawer Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6", "C11", "French Defense: Classical Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/5N2/PPP2PPP/RNBQKB1R b KQkq - d5e4", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP1QPPP/RNB1KBNR b KQkq - e6e5", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", "C10", "French Defense: Paulsen Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - b1d2", "C03", "French Defense: Tarrasch Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c1e3", "C00", "French Defense: Alapin Gambit"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - c2c4", "C00", "French Defense: Diemer-Duhm Gambit"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - d1e2", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - e4d5", "C01", "French Defense: Exchange Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - e4e5", "C02", "French Defense: Advance Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - f1d3", "C00", "French Defense: Schlechter Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", "C00", "French Defense: Perseus Gambit"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - g1h3", "C00", "French Defense: Morphy Gambit"],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - a7a6",
    "C03",
    "French Defense: Tarrasch Variation, Modern System",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - b8c6",
    "C03",
    "French Defense: Tarrasch Variation, Guimard Defense",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - c7c5",
    "C07",
    "French Defense: Tarrasch Variation, Open System",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - d5e4", null, null],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - f7f5",
    "C03",
    "French Defense: Tarrasch Variation, Haberditz Variation",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - f8e7",
    "C03",
    "French Defense: Tarrasch Variation, Morozevich Variation",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/3PP3/8/PPPN1PPP/R1BQKBNR b KQkq - g8f6",
    "C05",
    "French Defense: Tarrasch Variation, Closed Variation",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/4P3/1P6/P1PP1PPP/RNBQKBNR w KQkq - c1b2",
    "C00",
    "French Defense: Horwitz Attack, Papa-Ticulat Gambit",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d4", "C10", "French Defense: Paulsen Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/4P3/2N5/PPPP1PPP/R1BQKBNR w KQkq - f2f4", "C00", "French Defense: Pelikan Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/4P3/3P4/PPP2PPP/RNBQKBNR w KQkq - b1d2", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/4P3/3P4/PPPN1PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3", "C00", "French Defense: Two Knights Variation"],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - e4e5", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3P4/4P3/8/PP1P1PPP/RNBQKBNR b KQkq - e6d5", null, null],
  [
    "rnbqkbnr/ppp2ppp/4p3/3p4/4PP2/5N2/PPPP2PP/RNBQKB1R b KQkq - d5e4",
    "C00",
    "French Defense: La Bourdonnais Variation, Reuter Gambit",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3p4/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/3pP3/3P4/8/PPP2PPP/RNBQKBNR b KQkq - c7c5", "C02", "French Defense: Advance Variation"],
  [
    "rnbqkbnr/ppp2ppp/4p3/3pP3/3P4/8/PPP2PPP/RNBQKBNR b KQkq - c8d7",
    "C02",
    "French Defense: Advance Variation, Extended Bishop Swap",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/3pP3/8/5N2/PPPP1PPP/RNBQKB1R b KQkq - c7c5", null, null],
  [
    "rnbqkbnr/ppp2ppp/4p3/8/3PN3/8/PPP2PPP/R1BQKBNR b KQkq - b8d7",
    "C10",
    "French Defense: Rubinstein Variation, Blackburne Defense",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/8/3PN3/8/PPP2PPP/R1BQKBNR b KQkq - c8d7", null, null],
  [
    "rnbqkbnr/ppp2ppp/4p3/8/3PN3/8/PPP2PPP/R1BQKBNR b KQkq - d8d5",
    "C10",
    "French Defense: Rubinstein Variation, Maric Variation",
  ],
  [
    "rnbqkbnr/ppp2ppp/4p3/8/3PN3/8/PPP2PPP/R1BQKBNR b KQkq - e6e5",
    "C10",
    "French Defense: Rubinstein Variation, Ellis Gambit",
  ],
  ["rnbqkbnr/ppp2ppp/4p3/8/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - c3e4", null, null],
  ["rnbqkbnr/ppp2ppp/4p3/8/3Pp3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3e5", "C00", "French Defense: Carlson Gambit"],
  ["rnbqkbnr/ppp2ppp/4p3/8/3Pp3/8/PPPN1PPP/R1BQKBNR w KQkq - d2e4", null, null],
  ["rnbqkbnr/ppp2ppp/4P3/8/8/8/PPPP1PPP/RNBQKBNR b KQkq - c8e6", "B01", "Scandinavian Defense: Boehnke Gambit"],
  [
    "rnbqkbnr/ppp2ppp/8/3B4/4Pp2/8/PPPP2PP/RNBQK1NR b KQkq - c7c6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Anderssen Variation",
  ],
  ["rnbqkbnr/ppp2ppp/8/3B4/4Pp2/8/PPPP2PP/RNBQK1NR b KQkq - d8h4", null, null],
  [
    "rnbqkbnr/ppp2ppp/8/3B4/4Pp2/8/PPPP2PP/RNBQK1NR b KQkq - g8f6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Bledow Countergambit",
  ],
  ["rnbqkbnr/ppp2ppp/8/3p4/2B1Pp2/8/PPPP2PP/RNBQK1NR w KQkq - c4d5", null, null],
  ["rnbqkbnr/ppp2ppp/8/3p4/3NP3/8/PPP2PPP/RNBQKB1R w KQkq - e4d5", "C41", "Philidor Defense: Paulsen Attack"],
  ["rnbqkbnr/ppp2ppp/8/3p4/3p2P1/8/PPP1PPBP/RNBQK1NR w KQkq - c2c3", "A00", "Grob Opening: Grob Gambit, Keres Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3p4/3P4/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2ppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", "C01", "French Defense: Exchange Variation"],
  [
    "rnbqkbnr/ppp2ppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - c2c4",
    "C01",
    "French Defense: Exchange Variation, Monte Carlo Variation",
  ],
  ["rnbqkbnr/ppp2ppp/8/3p4/3P4/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", "C01", "French Defense: Exchange Variation"],
  ["rnbqkbnr/ppp2ppp/8/3p4/4p2N/P5P1/1PPPPP1P/RNBQKB1R b KQkq - f8e7", null, null],
  ["rnbqkbnr/ppp2ppp/8/3p4/4P3/8/PP1P1PPP/RNBQKBNR w KQkq - d1b3", "C00", "French Defense: Orthoschnapp Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3p4/4p3/P4NP1/1PPPPP1P/RNBQKB1R w KQkq - f3h4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3P4/4pP2/2N5/PPPP2PP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2ppp/8/3P4/4pP2/3P4/PPP3PP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2ppp/8/3p4/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - e4d5", "C36", "King's Gambit Accepted: Modern Defense"],
  ["rnbqkbnr/ppp2ppp/8/3P4/4pP2/8/PPPP2PP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/ppp2ppp/8/3P4/4pP2/8/PPPP2PP/RNBQKBNR w KQkq - d2d3",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Charousek Gambit",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/3P4/4pP2/8/PPPP2PP/RNBQKBNR w KQkq - f1b5",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Anderssen Attack",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/3p4/5p2/2N1P3/PPPP2PP/R1BQKBNR w KQkq - g1f3",
    "A00",
    "Van't Kruijs Opening: Keoni-Hiva Gambit, Ekolu Variation",
  ],
  ["rnbqkbnr/ppp2ppp/8/3P4/5p2/5N2/PPPP2PP/RNBQKB1R b KQkq - g8f6", "C36", "King's Gambit Accepted: Abbazia Defense"],
  ["rnbqkbnr/ppp2ppp/8/3pN3/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - d5e4", null, null],
  [
    "rnbqkbnr/ppp2ppp/8/3pp2Q/4P3/2P5/PP1P1PPP/RNB1KBNR b KQkq - f8d6",
    "C20",
    "King's Pawn Game: MacLeod Attack, Norwalde Gambit",
  ],
  ["rnbqkbnr/ppp2ppp/8/3pp2Q/8/2N1P3/PPPP1PPP/R1B1KBNR b KQkq - c8e6", "A00", "Van Geet Opening: Hulsemann Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3pp2Q/8/2N1P3/PPPP1PPP/R1B1KBNR b KQkq - g8f6", "A00", "Van Geet Opening: Liebig Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3pp3/2P5/6P1/PP1PPPBP/RNBQK1NR b KQkq - d5c4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pP3/2P5/8/PP2PPPP/RNBQKBNR b KQkq - d5d4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - d4e5", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/3P2P1/8/PPP1PPBP/RNBQK1NR b KQkq - e5d4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/3P4/2N1P3/PPP2PPP/R1BQKBNR b KQkq - f8b4", "A00", "Van Geet Opening: Sleipnir Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3pp3/3PP3/8/PPP1QPPP/RNB1KBNR w KQkq - f2f4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/3PPP2/8/PPP1Q1PP/RNB1KBNR b KQkq - e5f4", "C00", "French Defense: Hoffmann Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3pp3/4P3/1PN5/P1PP1PPP/R1BQKBNR b KQkq - d5e4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/4P3/2P5/PP1P1PPP/RNBQKBNR w KQkq - d1h5", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/4P3/3P4/PPP2PPP/RNBQKBNR w KQkq - e4d5", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - e4d5", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f3e5", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/4PP2/2N5/PPPP2PP/R1BQKBNR b KQkq - d5e4", null, null],
  [
    "rnbqkbnr/ppp2ppp/8/3pp3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - b1c3",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Milner-Barry Variation",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/3pp3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - d2d4",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Hinrichsen Gambit",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/3pp3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - e4d5",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit Accepted",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/3pp3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - g1f3",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Blackburne Attack",
  ],
  ["rnbqkbnr/ppp2ppp/8/3pp3/5P2/2N1P3/PPPP2PP/R1BQKBNR b KQkq - e5f4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/5P2/6PN/PPPPP2P/RNBQKB1R b KQkq - c8h3", null, null],
  [
    "rnbqkbnr/ppp2ppp/8/3Pp3/5P2/8/PPPP2PP/RNBQKBNR b KQkq - c7c6",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Nimzowitsch-Marshall Countergambit",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/3Pp3/5P2/8/PPPP2PP/RNBQKBNR b KQkq - e5e4",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Staunton Line",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/3Pp3/5P2/8/PPPP2PP/RNBQKBNR b KQkq - e5f4",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Modern Transfer",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/3Pp3/5P2/8/PPPP2PP/RNBQKBNR b KQkq - f8c5",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit, Miles Gambit",
  ],
  ["rnbqkbnr/ppp2ppp/8/3pp3/6P1/7P/PPPPPP2/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/6P1/7P/PPPPPPB1/RNBQK1NR b KQkq - c7c6", "A00", "Grob Opening: Keene Defense"],
  ["rnbqkbnr/ppp2ppp/8/3pp3/6P1/8/PPPPPPBP/RNBQK1NR w KQkq - c2c4", "A00", "Grob Opening: Spike, Hurst Attack"],
  ["rnbqkbnr/ppp2ppp/8/3pp3/6P1/8/PPPPPPBP/RNBQK1NR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/1PN5/P1PPPPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/2N1P3/PPPP1PPP/R1BQKBNR w KQkq - d1h5", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/2N1P3/PPPP1PPP/R1BQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/2N1P3/PPPP1PPP/R1BQKBNR w KQkq - f2f4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3Pp3/8/3P4/PPP2PPP/RNBQKBNR b KQkq - c7c6", null, null],
  ["rnbqkbnr/ppp2ppp/8/3Pp3/8/5N2/PPPP1PPP/RNBQKB1R b KQkq - e5e4", "C40", "Elephant Gambit: Paulsen Countergambit"],
  ["rnbqkbnr/ppp2ppp/8/3Pp3/8/5N2/PPPP1PPP/RNBQKB1R b KQkq - f8d6", "C40", "Elephant Gambit: Maróczy Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/6P1/PPPPPPBP/RNBQK1NR w KQkq - b2b4", "A00", "Hungarian Opening: Bücker Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/6P1/PPPPPPBP/RNBQK1NR w KQkq - c2c4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/6PN/PPPPPP1P/RNBQKB1R w KQkq - f2f4", "A00", "Amar Opening: Paris Gambit"],
  ["rnbqkbnr/ppp2ppp/8/3Pp3/8/8/PPPP1PPP/RNBQKBNR w KQkq e6 d5e6", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/P4NP1/1PPPPP1P/RNBQKB1R b KQkq - e5e4", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/P5P1/1PPPPP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/P5P1/1PPPPP1P/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/P5P1/1PPPPPBP/RNBQK1NR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/PP6/2PPPPPP/RNBQKBNR w KQkq - c2c3", null, null],
  ["rnbqkbnr/ppp2ppp/8/3pp3/8/PPP5/3PPPPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppp2ppp/8/4N3/2B1p3/8/PPPP1PPP/RNBQK2R b KQkq - d8g5", "C40", "Elephant Gambit: Wasp Variation"],
  ["rnbqkbnr/ppp2ppp/8/4N3/4p3/8/PPPP1PPP/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnbqkbnr/ppp2ppp/8/4p3/2BP4/4P3/PP3PPP/RNBQK1NR b KQkq - e5d4", null, null],
  ["rnbqkbnr/ppp2ppp/8/4p3/2p5/6P1/PP1PPPBP/RNBQK1NR w KQkq - b2b3", "A00", "Hungarian Opening: Winterberg Gambit"],
  ["rnbqkbnr/ppp2ppp/8/4P3/2Pp4/4P3/PP3PPP/RNBQKBNR b KQkq - f8b4", null, null],
  ["rnbqkbnr/ppp2ppp/8/4p3/2pP4/4P3/PP3PPP/RNBQKBNR w KQkq - f1c4", null, null],
  ["rnbqkbnr/ppp2ppp/8/4P3/2Pp4/5N2/PP2PPPP/RNBQKB1R b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/ppp2ppp/8/4P3/2Pp4/5N2/PP2PPPP/RNBQKB1R b KQkq - c7c5",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit, Tartakower Defense",
  ],
  ["rnbqkbnr/ppp2ppp/8/4P3/2Pp4/8/PP2PPPP/RNBQKBNR w KQkq - e2e3", null, null],
  [
    "rnbqkbnr/ppp2ppp/8/4P3/2Pp4/8/PP2PPPP/RNBQKBNR w KQkq - e2e4",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit, Spassky Variation",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4P3/2Pp4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3",
    "D08",
    "Queen's Gambit Declined: Albin Countergambit, Normal Line",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/2pPP3/8/PP3PPP/RNBQKBNR w KQkq - f1c4",
    "D20",
    "Queen's Gambit Accepted: Central Variation, McDonnell Defense, Somov Gambit",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/3pNP2/8/PPPPP1PP/R1BQKBNR w KQkq - g1f3",
    "A00",
    "Van Geet Opening: Pfeiffer Gambit, Sleipnir Countergambit",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - c1e3",
    "D00",
    "Blackmar-Diemer Gambit: Lemberger Countergambit, Soller Attack",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - c3e4",
    "D00",
    "Blackmar-Diemer Gambit: Lemberger Countergambit, Lange Gambit",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - d1h5",
    "D00",
    "Blackmar-Diemer Gambit: Lemberger Countergambit, Sneiders Attack",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - d4e5",
    "D00",
    "Blackmar-Diemer Gambit: Lemberger Countergambit, Endgame Variation",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/3Pp3/2N5/PPP2PPP/R1BQKBNR w KQkq - g1e2",
    "D00",
    "Blackmar-Diemer Gambit: Lemberger Countergambit, Rasmussen Attack",
  ],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/4p1P1/2N5/PPPP1P1P/R1BQKBNR w KQkq - d2d3",
    "A00",
    "Grob Opening: Zilbermints Gambit, Zilbermints-Hartlaub Gambit",
  ],
  ["rnbqkbnr/ppp2ppp/8/4p3/4p3/1PN5/P1PP1PPP/R1BQKBNR w KQkq - d2d3", "A00", "Van Geet Opening: Gladbacher Gambit"],
  [
    "rnbqkbnr/ppp2ppp/8/4p3/4pP2/2N5/PPPP2PP/R1BQKBNR w KQkq - c3e4",
    "C31",
    "Van Geet Opening: Grünfeld Defense, Steiner Gambit",
  ],
  ["rnbqkbnr/ppp2ppp/8/8/2Bp4/1Q2P3/PP3PPP/RNB1K1NR b KQkq - d8e7", null, null],
  ["rnbqkbnr/ppp2ppp/8/8/2Bp4/4P3/PP3PPP/RNBQK1NR w KQkq - d1b3", null, null],
  ["rnbqkbnr/ppp2ppp/8/P2pp3/8/4P3/1PPP1PPP/RNBQKBNR b KQkq - f7f5", null, null],
  ["rnbqkbnr/ppp2ppp/8/P2pp3/8/8/1PPPPPPP/RNBQKBNR w KQkq - e2e3", null, null],
  ["rnbqkbnr/ppp3pp/3p4/4P1N1/4p3/8/PPP2PPP/RNBQKB1R b KQkq - d6d5", null, null],
  ["rnbqkbnr/ppp3pp/3p4/4P3/4p3/5N2/PPP2PPP/RNBQKB1R w KQkq - f3g5", null, null],
  ["rnbqkbnr/ppp3pp/3p4/4pp2/2BPP3/5N2/PPP2PPP/RNBQK2R b KQkq - e5d4", null, null],
  [
    "rnbqkbnr/ppp3pp/3p4/4pp2/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - b1c3",
    "C41",
    "Philidor Defense: Philidor Countergambit, Zukertort Variation",
  ],
  ["rnbqkbnr/ppp3pp/3p4/4pp2/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - d4e5", null, null],
  ["rnbqkbnr/ppp3pp/3p4/4pp2/3PP3/5N2/PPP2PPP/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnbqkbnr/ppp3pp/3p4/4Pp2/4P3/5N2/PPP2PPP/RNBQKB1R b KQkq - f5e4", null, null],
  ["rnbqkbnr/ppp3pp/3p4/5p2/2BpP3/5N2/PPP2PPP/RNBQK2R w KQkq - f3g5", null, null],
  ["rnbqkbnr/ppp3pp/3p4/5pN1/2BpP3/8/PPP2PPP/RNBQK2R b KQkq - g8h6", null, null],
  ["rnbqkbnr/ppp3pp/4P3/3p2N1/4p3/8/PPP2PPP/RNBQKB1R b KQkq - f8c5", null, null],
  ["rnbqkbnr/ppp3pp/8/3p1P2/3P1p2/5N2/PPP3PP/RNBQKB1R b KQkq - f8d6", null, null],
  ["rnbqkbnr/ppp3pp/8/3p1P2/5p2/5N2/PPPP2PP/RNBQKB1R w KQkq - d2d4", null, null],
  [
    "rnbqkbnr/ppp3pp/8/3pP1N1/4p3/8/PPP2PPP/RNBQKB1R w KQkq - e5e6",
    "C41",
    "Philidor Defense: Philidor Countergambit, del Rio Attack",
  ],
  ["rnbqkbnr/ppp3pp/8/P2ppp2/8/4P3/1PPP1PPP/RNBQKBNR w KQkq - a5a6", "A00", "Ware Opening: Ware Gambit"],
  ["rnbqkbnr/pppp1B1p/8/8/4Ppp1/5N2/PPPP2PP/RNBQK2R b KQkq - e8f7", null, null],
  ["rnbqkbnr/pppp1N2/7p/8/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - e8f7", null, null],
  ["rnbqkbnr/pppp1p1p/8/4N3/2B1Ppp1/8/PPPP2PP/RNBQK2R b KQkq - d8h4", null, null],
  ["rnbqkbnr/pppp1p1p/8/4N3/3PPpp1/8/PPP3PP/RNBQKB1R b KQkq - d8h4", null, null],
  [
    "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - b8c6",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Neumann Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - d7d5",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Brentano Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - d7d6",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Kolisch Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - d8e7",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Rosenthal Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - f8e7",
    "C39",
    "King's Gambit Accepted: Kieseritzky, Polerio Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - f8g7",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Paulsen Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - g8f6",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Berlin Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/4N3/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - h7h5",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Long Whip",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/6N1/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - g8f6",
    "C39",
    "King's Gambit Accepted: Allgaier, Schlechter Defense",
  ],
  ["rnbqkbnr/pppp1p1p/8/6N1/4PppP/8/PPPP2P1/RNBQKB1R b KQkq - h7h6", null, null],
  ["rnbqkbnr/pppp1p1p/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R b KQkq - d7d6", null, null],
  [
    "rnbqkbnr/pppp1p1p/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R b KQkq - f8g7",
    "C38",
    "King's Gambit Accepted: Traditional Variation",
  ],
  ["rnbqkbnr/pppp1p1p/8/6p1/2B1Pp2/5N2/PPPP2PP/RNBQK2R b KQkq - g5g4", null, null],
  ["rnbqkbnr/pppp1p1p/8/6p1/3PPp2/5N2/PPP3PP/RNBQKB1R b KQkq - g5g4", null, null],
  ["rnbqkbnr/pppp1p1p/8/6p1/4Pp1P/5N2/PPPP2P1/RNBQKB1R b KQkq - g5g4", null, null],
  ["rnbqkbnr/pppp1p1p/8/6p1/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - b1c3", "C37", "King's Gambit Accepted: Quaade Gambit"],
  [
    "rnbqkbnr/pppp1p1p/8/6p1/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - d2d4",
    "C37",
    "King's Gambit Accepted: Rosentreter Gambit",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/6p1/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - f1c4",
    "C37",
    "King's Gambit Accepted: King's Knight's Gambit",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/6p1/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - h2h4",
    "C39",
    "King's Gambit Accepted: King's Knight's Gambit",
  ],
  ["rnbqkbnr/pppp1p1p/8/8/2B1Pp2/5p2/PPPP2PP/RNBQ1RK1 w kq - d1f3", null, null],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1 b kq - b8c6",
    "C37",
    "King's Gambit Accepted: Muzio Gambit, Holloway Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1 b kq - d8e7",
    "C37",
    "King's Gambit Accepted: Muzio Gambit Accepted, From's Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Pp2/5Q2/PPPP2PP/RNB2RK1 b kq - d8f6",
    "C37",
    "King's Gambit Accepted: Muzio Gambit, Sarratt Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQ1RK1 b kq - d7d5",
    "C37",
    "King's Gambit Accepted: Muzio Gambit, Brentano Defense",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQ1RK1 b kq - d8e7",
    "C37",
    "King's Gambit Accepted: Muzio Gambit, Kling and Horwitz Counterattack",
  ],
  ["rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQ1RK1 b kq - g4f3", null, null],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQK2R w KQkq - b1c3",
    "C37",
    "King's Gambit Accepted: McDonnell Gambit",
  ],
  ["rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQK2R w KQkq - c4f7", "C37", "King's Gambit Accepted: Lolli Gambit"],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQK2R w KQkq - d2d4",
    "C37",
    "King's Gambit Accepted: Ghulam-Kassim Gambit",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQK2R w KQkq - e1g1",
    "C37",
    "King's Gambit Accepted: Muzio Gambit, Wild Muzio Gambit",
  ],
  ["rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQK2R w KQkq - f3e5", "C37", "King's Gambit Accepted: Salvio Gambit"],
  [
    "rnbqkbnr/pppp1p1p/8/8/2B1Ppp1/5N2/PPPP2PP/RNBQK2R w KQkq - h2h4",
    "C37",
    "King's Gambit Accepted: Australian Gambit",
  ],
  ["rnbqkbnr/pppp1p1p/8/8/2BPPp2/5p2/PPP3PP/RNBQK2R w KQkq - c1f4", "C37", "King's Gambit Accepted: Kotov Gambit"],
  [
    "rnbqkbnr/pppp1p1p/8/8/2BPPp2/5p2/PPP3PP/RNBQK2R w KQkq - d1f3",
    "C37",
    "King's Gambit Accepted: Ghulam-Kassim Gambit",
  ],
  ["rnbqkbnr/pppp1p1p/8/8/2BPPpp1/5N2/PPP3PP/RNBQK2R b KQkq - g4f3", null, null],
  [
    "rnbqkbnr/pppp1p1p/8/8/3PPpp1/5N2/PPP3PP/RNBQKB1R w KQkq - b1c3",
    "C37",
    "King's Gambit Accepted: Rosentreter Gambit, Sörensen Gambit",
  ],
  [
    "rnbqkbnr/pppp1p1p/8/8/3PPpp1/5N2/PPP3PP/RNBQKB1R w KQkq - c1f4",
    "C37",
    "King's Gambit Accepted: Rosentreter Gambit, Testa Variation",
  ],
  ["rnbqkbnr/pppp1p1p/8/8/3PPpp1/5N2/PPP3PP/RNBQKB1R w KQkq - f3e5", "C37", "King's Gambit Accepted: Sörensen Gambit"],
  [
    "rnbqkbnr/pppp1p1p/8/8/4PppP/5N2/PPPP2P1/RNBQKB1R w KQkq - f3e5",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit",
  ],
  ["rnbqkbnr/pppp1p1p/8/8/4PppP/5N2/PPPP2P1/RNBQKB1R w KQkq - f3g5", "C39", "King's Gambit Accepted: Allgaier Gambit"],
  [
    "rnbqkbnr/pppp1p2/7p/6N1/4PppP/8/PPPP2P1/RNBQKB1R w KQkq - g5f7",
    "C39",
    "King's Gambit Accepted: Kieseritzky Gambit, Cotter Gambit",
  ],
  ["rnbqkbnr/pppp1p2/8/4N2p/2B1PppP/8/PPPP2P1/RNBQK2R b KQkq - h8h7", null, null],
  ["rnbqkbnr/pppp1p2/8/4N2p/4PppP/8/PPPP2P1/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnbqkbnr/pppp1pp1/7p/8/2B1Pp2/5N2/PPPP2PP/RNBQK2R b KQkq - d7d6", null, null],
  ["rnbqkbnr/pppp1pp1/7p/8/4Pp2/5N2/PPPP2PP/RNBQKB1R w KQkq - f1c4", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/1P2P3/8/P1PP1PPP/RNBQKBNR b KQkq - f8b4", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/1P6/8/P1PPPPPP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/2P1P3/8/PP1P1PPP/RNBQKBNR b KQkq - d7d5", null, null],
  [
    "rnbqkbnr/pppp1ppp/4p3/8/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - g8f6",
    "A17",
    "English Opening: Anglo-Indian Defense, Hedgehog System",
  ],
  ["rnbqkbnr/pppp1ppp/4p3/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - a7a6", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - d7d5", "A13", "English Opening: Agincourt Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g1f3", "A13", "English Opening: Agincourt Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - b7b6", "A40", "English Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e6e5", "A40", "Horwitz Defense: Zilbermints Gambit"],
  ["rnbqkbnr/pppp1ppp/4p3/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - f8b4", "A40", "Kangaroo Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", "C00", "French Defense: Normal Variation"],
  ["rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - a7a6", "C00", "French Defense: St. George Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - b7b5", "C00", "French Defense: Baeuerle Gambit"],
  ["rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - c7c5", "C00", "French Defense: Franco-Sicilian Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d7d5", "C00", "French Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d7d6", "C00", "Rat Defense: Small Center Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f7f5", "C00", "French Defense: Franco-Hiva Gambit"],
  ["rnbqkbnr/pppp1ppp/4p3/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - g8f6", "C00", "French Defense: Mediterranean Defense"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/1P6/P1PP1PPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/3P4/PPP2PPP/RNBQKBNR b KQkq - d7d5", null, null],
  [
    "rnbqkbnr/pppp1ppp/4p3/8/4P3/3P4/PPP2PPP/RNBQKBNR b KQkq - f7f5",
    "C00",
    "French Defense: King's Indian Attack, Franco-Hiva Gambit",
  ],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d7d5", null, null],
  [
    "rnbqkbnr/pppp1ppp/4p3/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - f7f5",
    "C00",
    "French Defense: Knight Variation, Franco-Hiva Gambit",
  ],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", "C00", "French Defense: Queen's Knight"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b3", "C00", "French Defense: Horwitz Attack"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b4", "C00", "French Defense: Banzai-Leong Gambit"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - c2c4", "C00", "French Defense: Steiner Variation"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d1e2", "C00", "French Defense: Chigorin Variation"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d3", "C00", "French Defense: King's Indian Attack"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", "C00", "French Defense: Normal Variation"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - e4e5", "C00", "French Defense: Steinitz Attack"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1b5", "C00", "French Defense: Bird Invitation"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f2f4", "C00", "French Defense: La Bourdonnais Variation"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1f3", "C00", "French Defense: Knight Variation"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g2g3", "C00", "French Defense: Réti-Spielmann Attack"],
  ["rnbqkbnr/pppp1ppp/4p3/8/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/4p3/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - c2c4", "A13", "English Opening: Agincourt Defense"],
  ["rnbqkbnr/pppp1ppp/8/1B2p3/4P3/8/PPPP1PPP/RNBQK1NR b KQkq - f8c5", null, null],
  ["rnbqkbnr/pppp1ppp/8/1B2p3/4P3/8/PPPP1PPP/RNBQK1NR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/8/3Pp3/8/8/PPP1PPPP/RNBQKBNR b KQkq - f8c5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4N3/8/8/PPPPPPPP/RNBQKB1R b KQkq - b8c6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p2Q/4P3/8/PPPP1PPP/RNB1KBNR b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p2Q/4P3/8/PPPP1PPP/RNB1KBNR b KQkq - g8f6",
    "C20",
    "King's Pawn Game: Wayward Queen Attack, Kiddie Countergambit",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/1P6/8/P1PPPPPP/RNBQKBNR w KQkq - a2a3", "A00", "Polish Opening: Bugayev Attack"],
  ["rnbqkbnr/pppp1ppp/8/4p3/1P6/8/P1PPPPPP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - c7c5", "A00", "Polish Opening: Wolferts Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - d7d6", "A00", "Polish Opening: Czech Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/1P6/8/PBPPPPPP/RN1QKBNR b KQkq - f7f6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - b7b5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - c7c6",
    "C23",
    "Bishop's Opening: Philidor Counterattack",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - d7d5", "C23", "Bishop's Opening: Khan Gambit"],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - f7f5",
    "C23",
    "Bishop's Opening: Calabrese Countergambit",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - f8c5", "C23", "Bishop's Opening: Boi Variation"],
  ["rnbqkbnr/pppp1ppp/8/4p3/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - g8f6", "C24", "Bishop's Opening: Berlin Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/2B5/4P3/PPPP1PPP/RNBQK1NR b KQkq - b7b5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/2N5/8/PPPPPPPP/R1BQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/2P1P3/8/PP1P1PPP/RNBQKBNR b KQkq - d7d5", "C20", "King's Pawn Game: Bavarian Gambit"],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - b8c6",
    "A25",
    "English Opening: King's English Variation, Reversed Closed Sicilian",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - d7d6", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - f8b4",
    "A21",
    "English Opening: King's English Variation, Kramnik-Shirov Counterattack",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - g8f6",
    "A22",
    "English Opening: King's English Variation, Two Knights Variation",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/2P5/4P3/PP1P1PPP/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/2P5/4P3/PP1P1PPP/RNBQKBNR b KQkq - g8f6", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - e5e4",
    "A20",
    "English Opening: King's English Variation, Nimzowitsch-Flohr Variation",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/2P5/6P1/PP1PPP1P/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/2P5/6P1/PP1PPP1P/RNBQKBNR b KQkq - h7h5", "A20", "English Opening: Drill Variation"],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - b1c3",
    "A21",
    "English Opening: King's English Variation, Reversed Sicilian",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - e2e3", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g1f3",
    "A20",
    "English Opening: King's English Variation, Nimzowitsch Variation",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g2g3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/3P1P2/8/PPP1P1PP/RNBQKBNR b KQkq - e5d4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/3P3P/8/PPP1PPP1/RNBQKBNR b KQkq - e5d4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - e5d4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - e5e4", "A40", "Englund Gambit Declined: Reversed Krebs"],
  ["rnbqkbnr/pppp1ppp/8/4p3/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - d4d5", "A40", "Englund Gambit Declined"],
  ["rnbqkbnr/pppp1ppp/8/4p3/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - d4e5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - e2e3", "A40", "Englund Gambit Declined: Reversed French"],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3",
    "A40",
    "Englund Gambit Declined: Reversed Alekhine",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d7d5", "C20", "King's Pawn Game: Beyer Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d7d6", "B07", "King's Pawn Game: Maróczy Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - e5d4", "C21", "Center Game Accepted"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P1Q1/8/PPPP1PPP/RNB1KBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - b8c6", "C25", "Vienna Game: Max Lange Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - f8b4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - f8c5", "C25", "Vienna Game: Anderssen Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - g8f6", "C26", "Vienna Game: Falkbeer Variation"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/2P5/PP1P1PPP/RNBQKBNR b KQkq - d7d5", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/4P3/2P5/PP1P1PPP/RNBQKBNR b KQkq - f7f5",
    "C20",
    "King's Pawn Game: MacLeod Attack, Lasa Gambit",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/3P4/PPP2PPP/RNBQKBNR b KQkq - d7d5", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/4P3/3P4/PPP2PPP/RNBQKBNR b KQkq - f7f5",
    "C20",
    "King's Pawn Game: Clam Variation, King's Gambit Reversed",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/3P4/PPP2PPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - b8c6", "C44", "King's Knight Opening: Normal Variation"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - c7c6", "C40", "King's Pawn Game: Gunderam Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d7d5", "C40", "Elephant Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d7d6", "C41", "Philidor Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d8e7", "C40", "Gunderam Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - d8f6", "C40", "King's Pawn Game: McConnell Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - f7f5", "C40", "Latvian Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - f7f6", "C40", "King's Pawn Game: Damiano Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - f8c5", "C40", "King's Pawn Game: Busch-Gass Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - g8f6", "C42", "Petrov's Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/5P2/PPPP2PP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - a2a3", "C20", "King's Pawn Game: Mengarini's Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", "C25", "Vienna Game"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b2b3", "C20", "King's Pawn Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - c2c3", "C20", "King's Pawn Game: MacLeod Attack"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - c2c4", "C20", "English Opening: The Whale"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d1e2", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d1f3", "C20", "King's Pawn Game: Napoleon Attack"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d1g4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d1h5", "C20", "King's Pawn Game: Wayward Queen Attack"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d3", "C20", "King's Pawn Game: Leonardis Variation"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", "C20", "Center Game"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - e1e2", "C20", "Bongcloud Attack"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1b5", "C20", "Portuguese Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1c4", "C23", "Bishop's Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1d3", "C20", "King's Pawn Game: Tortoise Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f2f3", "C20", "King's Pawn Game: King's Head Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f2f4", "C30", "King's Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1e2", "C20", "King's Pawn Game: Alapin Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1f3", "C40", "King's Knight Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPPQPPP/RNB1KBNR b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - b8c6",
    "C30",
    "King's Gambit Declined: Queen's Knight Defense",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - d7d5",
    "C31",
    "King's Gambit Declined: Falkbeer Countergambit",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - d8f6",
    "C30",
    "King's Gambit Declined: Norwalde Variation",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - d8h4", "C30", "King's Gambit Declined: Keene's Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - e5f4", "C33", "King's Gambit Accepted"],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - f7f5",
    "C30",
    "King's Gambit Declined: Panteldakis Countergambit",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - f7f6", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - f8c5",
    "C30",
    "King's Gambit Declined: Classical Variation",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - g7g5",
    "C30",
    "King's Gambit Declined: Zilbermints Double Countergambit",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - g8f6", "C30", "King's Gambit Declined: Petrov's Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/5P2/2N5/PPPPP1PP/R1BQKBNR b KQkq - e5f4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - b1c3", "A02", "Bird Opening: From's Gambit, Bahr Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - f4e5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/6P1/5P2/PPPPP2P/RNBQKBNR b KQkq - d8h4", "A00", "Barnes Opening: Fool's Mate"],
  ["rnbqkbnr/pppp1ppp/8/4p3/6P1/7P/PPPPPP2/RNBQKBNR b KQkq - b8c6", "A00", "Grob Opening: London Defense"],
  ["rnbqkbnr/pppp1ppp/8/4p3/6P1/8/PPPPPP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/6P1/8/PPPPPP1P/RNBQKBNR w KQkq - h2h3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/6P1/8/PPPPPPBP/RNBQK1NR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/7P/8/PPPPPPP1/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/1P6/P1PPPPPP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/1P6/PBPPPPPP/RN1QKBNR b KQkq - b8c6", "A01", "Nimzo-Larsen Attack: Modern Variation"],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/1PN5/P1PPPPPP/R1BQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N1P3/PPPP1PPP/R1BQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N1P3/PPPP1PPP/R1BQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N1P3/PPPP1PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N2N2/PPPPPPPP/R1BQKB1R b KQkq - b8c6", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/4p3/8/2N2N2/PPPPPPPP/R1BQKB1R b KQkq - f8c5",
    "A00",
    "Van Geet Opening: Billockus-Johansen Gambit",
  ],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - b2b3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - e2e3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - f2f4", "A02", "Bird Opening: From's Gambit, Bahr Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/3P4/PPP1PPPP/RNBQKBNR w KQkq - b1d2", "A00", "Valencia Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/4P3/PPPP1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/4P3/PPPP1PPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/4P3/PPPP1PPP/RNBQKBNR w KQkq - f1c4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - f3e5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - e5e4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/5P2/PPPPP1PP/RNBQKBNR w KQkq - e1f2", "A00", "Barnes Opening: Hammerschlag"],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/5P2/PPPPP1PP/RNBQKBNR w KQkq - e2e4", "C20", "King's Pawn Game: King's Head Opening"],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/5P2/PPPPP1PP/RNBQKBNR w KQkq - g2g4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/6P1/PPPPPP1P/RNBQKBNR w KQkq - a2a3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/6P1/PPPPPP1P/RNBQKBNR w KQkq - g1f3", "A00", "Hungarian Opening: Reversed Alekhine"],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/6P1/PPPPPP1P/RNBQKBNR w KQkq - g1h3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/6PN/PPPPPP1P/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/7P/PPPPPPP1/RNBQKBNR w KQkq - a2a3", "A00", "Global Opening"],
  ["rnbqkbnr/pppp1ppp/8/4P3/8/8/PPP1PPPP/RNBQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4P3/8/8/PPP1PPPP/RNBQKBNR b KQkq - d7d6", "A40", "Englund Gambit: Hartlaub-Charlick Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4P3/8/8/PPP1PPPP/RNBQKBNR b KQkq - d8h4", "A40", "Englund Gambit: Mosquito Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4P3/8/8/PPP1PPPP/RNBQKBNR b KQkq - f7f6", "A40", "Englund Gambit: Soller Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4P3/8/8/PPPPP1PP/RNBQKBNR b KQkq - b8c6", "A02", "Bird Opening: Schlechter Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4P3/8/8/PPPPP1PP/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/pppp1ppp/8/4P3/8/8/PPPPP1PP/RNBQKBNR b KQkq - f7f6", "A02", "Bird Opening: Lasker Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4P3/8/8/PPPPP1PP/RNBQKBNR b KQkq - g8e7", "A02", "Bird Opening: Platz Gambit"],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/N2P4/PPP1PPPP/R1BQKBNR b KQkq - f8a3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/N7/PPPPPPPP/R1BQKBNR w KQkq - a3c4", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/N7/PPPPPPPP/R1BQKBNR w KQkq - d2d3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/P5P1/1PPPPP1P/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/P7/1PPPPPPP/RNBQKBNR w KQkq - b1c3", "A00", "Van Geet Opening: Battambang Variation"],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/P7/1PPPPPPP/RNBQKBNR w KQkq - b2b3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/P7/1PPPPPPP/RNBQKBNR w KQkq - g2g3", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/8/PP6/2PPPPPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/P7/8/1PPPPPPP/RNBQKBNR w KQkq - a1a3", "A00", "Ware Opening: Meadow Hay Trap"],
  ["rnbqkbnr/pppp1ppp/8/4p3/P7/8/1PPPPPPP/RNBQKBNR w KQkq - a4a5", null, null],
  ["rnbqkbnr/pppp1ppp/8/4p3/P7/8/1PPPPPPP/RNBQKBNR w KQkq - h2h4", "A00", "Ware Opening: Crab Variation"],
  ["rnbqkbnr/pppp1ppp/8/8/2B1P3/2p5/PP3PPP/RNBQK1NR b KQkq - c3b2", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/2B1P3/8/PB3PPP/RN1QK1NR b KQkq - d7d5", "C21", "Danish Gambit Accepted: Schlechter Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/2B1P3/8/PB3PPP/RN1QK1NR b KQkq - d8e7", "C21", "Danish Gambit Accepted: Chigorin Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/2B1P3/8/PB3PPP/RN1QK1NR b KQkq - f8b4", "C21", "Danish Gambit Accepted: Copenhagen Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/2B1P3/8/PB3PPP/RN1QK1NR b KQkq - g8f6", "C21", "Danish Gambit Accepted: Classical Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/2B1P3/8/Pp3PPP/RNBQK1NR w KQkq - c1b2", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - b7b5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Kieseritzky Gambit",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - b8c6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Maurian Defense",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - c7c6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Lopez Defense",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - d7d5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Bledow Variation",
  ],
  ["rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - d8h4", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - f7f5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Gianutio Gambit",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - g7g5",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Anderssen Defense",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - g8e7",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Steinitz Defense",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/2B1Pp2/8/PPPP2PP/RNBQK1NR b KQkq - g8f6",
    "C33",
    "King's Gambit Accepted: Bishop's Gambit, Cozio Defense",
  ],
  ["rnbqkbnr/pppp1ppp/8/8/3p1P2/5N2/PPP1P1PP/RNBQKB1R b KQkq - c7c5", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/3p1P2/8/PPP1P1PP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/3p3P/8/PPP1PPP1/RNBQKBNR w KQkq - c2c3", "A00", "Kádas Opening: Kádas Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/3p4/2N5/PPP1PPPP/R1BQKBNR w KQkq - d1d4", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - d4c3", "C21", "Danish Gambit Accepted"],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - d7d5", "C21", "Danish Gambit Declined: Sörensen Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/2P5/PP3PPP/RNBQKBNR b KQkq - g8e7", "C21", "Danish Gambit Accepted: Svenonius Defense"],
  [
    "rnbqkbnr/pppp1ppp/8/8/3Pp3/5N2/PPP1PPPP/RNBQKB1R w KQkq - f3e5",
    "A40",
    "Englund Gambit Declined: Reversed Mokele Mbembe",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/3Pp3/5N2/PPP1PPPP/RNBQKB1R w KQkq - f3g1",
    "A40",
    "Englund Gambit Declined: Reversed Brooklyn",
  ],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/5N2/PPP2PPP/RNBQKB1R b KQkq - c7c5", "C21", "Center Game: Kieseritzky Variation"],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/5N2/PPP2PPP/RNBQKB1R b KQkq - f8c5", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - c2c3", "C21", "Danish Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - d1d4", "C21", "Center Game"],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - f1c4", "C21", "Center Game: von der Lasa Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - f1d3", "C21", "Center Game: Ross Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - f2f4", "C21", "Center Game: Halasz-McDonnell Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/3pP3/8/PPP2PPP/RNBQKBNR w KQkq - g1f3", "C21", "Center Game: Kieseritzky Variation"],
  ["rnbqkbnr/pppp1ppp/8/8/3pPP2/8/PPP3PP/RNBQKBNR b KQkq - f8c5", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/3Q4/2N5/PPP1PPPP/R1B1KBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/3QP3/8/PPP2PPP/RNB1KBNR b KQkq - b8c6", "C22", "Center Game: Normal Variation"],
  ["rnbqkbnr/pppp1ppp/8/8/4P3/2p5/PP3PPP/RNBQKBNR w KQkq - f1c4", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/4p3/5NP1/PPPPPP1P/RNBQKB1R w KQkq - f3g1", null, null],
  [
    "rnbqkbnr/pppp1ppp/8/8/4p3/5NP1/PPPPPP1P/RNBQKB1R w KQkq - f3h4",
    "A00",
    "Hungarian Opening: Reversed Norwegian Defense",
  ],
  ["rnbqkbnr/pppp1ppp/8/8/4p3/6P1/PPPPPP1P/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - b8c6", "C34", "King's Gambit Accepted: MacLeod Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - d7d5", "C36", "King's Gambit Accepted: Modern Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - d7d6", "C34", "King's Gambit Accepted: Fischer Defense"],
  [
    "rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - f7f5",
    "C34",
    "King's Gambit Accepted: Gianutio Countergambit",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - f8e7",
    "C35",
    "King's Gambit Accepted: Cunningham Defense",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - g7g5",
    "C34",
    "King's Gambit Accepted: King's Knight's Gambit",
  ],
  [
    "rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - g8e7",
    "C34",
    "King's Gambit Accepted: Bonsch-Osmolovsky Variation",
  ],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - g8f6", "C34", "King's Gambit Accepted: Schallopp Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - h7h5", "C34", "King's Gambit Accepted: Wagenbach Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/5N2/PPPP2PP/RNBQKB1R b KQkq - h7h6", "C34", "King's Gambit Accepted: Becker Defense"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - b1c3", "C33", "King's Gambit Accepted: Mason-Keres Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - b2b3", "C33", "King's Gambit Accepted: Orsini Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - d1e2", "C33", "King's Gambit Accepted: Basman Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - d1f3", "C33", "King's Gambit Accepted: Breyer Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - d1g4", "C33", "King's Gambit Accepted: Dodo Variation"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - d1h5", "C33", "King's Gambit Accepted: Carrera Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - d2d4", "C33", "King's Gambit Accepted: Villemson Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - e1f2", "C33", "King's Gambit Accepted: Tumbleweed"],
  [
    "rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - f1b5",
    "C33",
    "King's Gambit Accepted: Schurig Gambit, with Bb5",
  ],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - f1c4", "C33", "King's Gambit Accepted: Bishop's Gambit"],
  [
    "rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - f1d3",
    "C33",
    "King's Gambit Accepted: Schurig Gambit, with Bd3",
  ],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - f1e2", "C33", "King's Gambit Accepted: Tartakower Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - g1e2", "C33", "King's Gambit Accepted: Paris Gambit"],
  [
    "rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - g1f3",
    "C34",
    "King's Gambit Accepted: King's Knight's Gambit",
  ],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - g1h3", "C33", "King's Gambit Accepted: Eisenberg Variation"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - g2g3", "C33", "King's Gambit Accepted: Gaga Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPP2PP/RNBQKBNR w KQkq - h2h4", "C33", "King's Gambit Accepted: Stamma Gambit"],
  ["rnbqkbnr/pppp1ppp/8/8/4Pp2/8/PPPPB1PP/RNBQK1NR b KQkq - f7f5", null, null],
  ["rnbqkbnr/pppp1ppp/8/8/5p2/2N5/PPPPP1PP/R1BQKBNR w KQkq - e2e4", "A00", "Van Geet Opening: Nowokunski Gambit"],
  ["rnbqkbnr/pppp1ppp/8/P3p3/8/8/1PPPPPPP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp2pp/4p3/5p2/2PP4/5N2/PP2PPPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp2pp/4p3/5p2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", "A84", "Dutch Defense: Rubinstein Variation"],
  ["rnbqkbnr/pppp2pp/4p3/5p2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - e2e4", "A84", "Dutch Defense: Bellon Gambit"],
  ["rnbqkbnr/pppp2pp/4p3/5p2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pppp2pp/4p3/5p2/3P1B2/8/PPP1PPPP/RN1QKBNR w KQkq - g2g4", "A80", "Dutch Defense: Senechaud Gambit"],
  [
    "rnbqkbnr/pppp2pp/4p3/5p2/3P4/3Q4/PPP1PPPP/RNB1KBNR w KQkq - g2g4",
    "A80",
    "Dutch Defense: Manhattan Gambit, Anti-Classical Line",
  ],
  [
    "rnbqkbnr/pppp2pp/4p3/5p2/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - e4f5",
    "C00",
    "French Defense: Franco-Hiva Gambit Accepted",
  ],
  ["rnbqkbnr/pppp2pp/4p3/5p2/8/1P6/PBPPPPPP/RN1QKBNR w KQkq - e2e4", "A01", "Nimzo-Larsen Attack: Ringelbach Gambit"],
  ["rnbqkbnr/pppp2pp/5p2/4N3/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - d8e7", null, null],
  ["rnbqkbnr/pppp2pp/5p2/4N3/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - f6e5", null, null],
  [
    "rnbqkbnr/pppp2pp/5p2/4p3/1P6/8/PBPPPPPP/RN1QKBNR w KQkq - b4b5",
    "A00",
    "Polish Opening: Bugayev Advance Variation",
  ],
  ["rnbqkbnr/pppp2pp/5p2/4p3/1P6/8/PBPPPPPP/RN1QKBNR w KQkq - e2e4", "A00", "Polish Opening: Tartakower Gambit"],
  ["rnbqkbnr/pppp2pp/5p2/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f3e5", null, null],
  [
    "rnbqkbnr/pppp2pp/5p2/4P3/4P3/8/PPPP2PP/RNBQKBNR b KQkq - b8c6",
    "C30",
    "King's Gambit Declined: Soller-Zilbermints Gambit",
  ],
  ["rnbqkbnr/pppp2pp/5p2/4p3/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - f4e5", null, null],
  [
    "rnbqkbnr/pppp2pp/8/4N3/2B1p3/8/PPPP1PPP/RNBQK2R b KQkq - d7d5",
    "C40",
    "Latvian Gambit: Mayet Attack, Polerio-Svedenborg Variation",
  ],
  ["rnbqkbnr/pppp2pp/8/4N3/2B1p3/8/PPPP1PPP/RNBQK2R b KQkq - d8g5", null, null],
  ["rnbqkbnr/pppp2pp/8/4N3/2B1p3/8/PPPP1PPP/RNBQK2R b KQkq - g8f6", "C40", "Latvian Gambit: Corkscrew Countergambit"],
  ["rnbqkbnr/pppp2pp/8/4Np2/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - b8c6", "C40", "Latvian Gambit: Fraser Defense"],
  ["rnbqkbnr/pppp2pp/8/4Np2/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - d8e7", "C40", "Latvian Gambit: Greco Variation"],
  ["rnbqkbnr/pppp2pp/8/4Np2/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - d8f6", null, null],
  ["rnbqkbnr/pppp2pp/8/4Np2/4P3/8/PPPP1PPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppp2pp/8/4p2Q/4P3/8/PPPP1PPP/RNB1KB1R b KQkq - g7g6", null, null],
  ["rnbqkbnr/pppp2pp/8/4p3/2B1p3/5N2/PPPP1PPP/RNBQK2R w KQkq - f3e5", null, null],
  ["rnbqkbnr/pppp2pp/8/4p3/4P3/8/PPPP1PPP/RNBQKB1R w KQkq - d1h5", null, null],
  [
    "rnbqkbnr/pppp2pp/8/4pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - b7b5",
    "C40",
    "Latvian Gambit: Mayet Attack, Strautins Gambit",
  ],
  ["rnbqkbnr/pppp2pp/8/4pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - f5e4", null, null],
  [
    "rnbqkbnr/pppp2pp/8/4pp2/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - g8f6",
    "C40",
    "Latvian Gambit: Mayet Attack, Morgado Defense",
  ],
  [
    "rnbqkbnr/pppp2pp/8/4pp2/2B1P3/8/PPPP1PPP/RNBQK1NR w KQkq - d2d3",
    "C23",
    "Bishop's Opening: Calabrese Countergambit, Jaenisch Variation",
  ],
  ["rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b1c3", "C40", "Latvian Gambit: Mlotkowski Variation"],
  ["rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - b2b4", "C40", "Latvian Gambit: Senechaud Gambit"],
  [
    "rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - c2c4",
    "C40",
    "Latvian Gambit: Diepstraten Countergambit",
  ],
  ["rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - d2d4", "C40", "Latvian Gambit: Mason Countergambit"],
  ["rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - e4f5", "C40", "Latvian Gambit Accepted"],
  ["rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f1c4", "C40", "Latvian Gambit: Mayet Attack"],
  ["rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - f3e5", null, null],
  ["rnbqkbnr/pppp2pp/8/4pp2/4P3/5N2/PPPP1PPP/RNBQKB1R w KQkq - g2g4", "C40", "Latvian Gambit: Lobster Gambit"],
  ["rnbqkbnr/pppp2pp/8/4pp2/4PP2/8/PPPP2PP/RNBQKBNR w KQkq - e4f5", null, null],
  [
    "rnbqkbnr/pppp2pp/8/4pP2/5P2/8/PPPP2PP/RNBQKBNR b KQkq - d8h4",
    "C30",
    "King's Gambit Declined: Panteldakis Countergambit, Greco Variation",
  ],
  ["rnbqkbnr/pppp2pp/8/4pP2/5P2/8/PPPP2PP/RNBQKBNR b KQkq - e5f4", null, null],
  [
    "rnbqkbnr/pppp2pp/8/4pP2/5P2/8/PPPP2PP/RNBQKBNR b KQkq - f8c5",
    "C30",
    "King's Gambit Declined: Panteldakis Countergambit, Schiller's Defense",
  ],
  [
    "rnbqkbnr/pppp2pp/8/5P1Q/5p2/8/PPPP2PP/RNB1KBNR b KQkq - e8e7",
    "C30",
    "King's Gambit Declined: Panteldakis Countergambit, Shirazi Line",
  ],
  ["rnbqkbnr/pppp2pp/8/5P1Q/5p2/8/PPPP2PP/RNB1KBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/pppp2pp/8/5p2/2B1Pp2/8/PPPP2PP/RNBQK1NR w KQkq - d1e2", null, null],
  ["rnbqkbnr/pppp2pp/8/5p2/2B1Pp2/8/PPPPQ1PP/RNB1K1NR b KQkq - d8h4", null, null],
  ["rnbqkbnr/pppp2pp/8/5p2/4Pp2/8/PPPPB1PP/RNBQK1NR w KQkq - e4f5", null, null],
  ["rnbqkbnr/pppp2pp/8/5P2/5p2/5N2/PPPP2PP/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppp2pp/8/5P2/5p2/8/PPPP2PP/RNBQKBNR w KQkq - d1h5", null, null],
  ["rnbqkbnr/pppp2pp/8/5P2/5p2/8/PPPP2PP/RNBQKBNR w KQkq - g1f3", null, null],
  [
    "rnbqkbnr/pppp2pp/8/5P2/5p2/8/PPPPB1PP/RNBQK1NR b KQkq - d7d6",
    "C33",
    "King's Gambit Accepted: Tartakower Gambit, Weiss Defense",
  ],
  ["rnbqkbnr/pppp3p/6p1/4p2Q/4P3/8/PPPP1PPP/RNB1KB1R w KQkq - h5e5", null, null],
  ["rnbqkbnr/pppp3p/6p1/4Q3/4P3/8/PPPP1PPP/RNB1KB1R b KQkq - d8e7", null, null],
  ["rnbqkbnr/pppp3p/6p1/5P1Q/5p2/8/PPPP2PP/RNB1KBNR w KQkq - f5g6", null, null],
  ["rnbqkbnr/pppp3p/6P1/7Q/5p2/8/PPPP2PP/RNB1KBNR b KQkq - d8e7", null, null],
  ["rnbqkbnr/ppppp1pp/5p2/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - b7b6", null, null],
  ["rnbqkbnr/ppppp1pp/5p2/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - e8f7", "B00", "Fried Fox Defense"],
  ["rnbqkbnr/ppppp1pp/5p2/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - g8h6", null, null],
  ["rnbqkbnr/ppppp1pp/5p2/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppppp1pp/5p2/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/2P5/5N2/PP1PPPPP/RNBQKB1R b KQkq - d7d6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/ppppp1pp/8/5p2/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - e2e4",
    "A10",
    "English Opening: Anglo-Dutch Defense, Hickmann Gambit",
  ],
  ["rnbqkbnr/ppppp1pp/8/5p2/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - g2g4", "A10", "English Opening: Wade Gambit"],
  ["rnbqkbnr/ppppp1pp/8/5p2/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e7e6", "A84", "Dutch Defense: Classical Variation"],
  ["rnbqkbnr/ppppp1pp/8/5p2/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - g8f6", "A84", "Dutch Defense: Normal Variation"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P1B2/8/PPP1PPPP/RN1QKBNR b KQkq - e7e6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P1P2/8/PPP1P1PP/RNBQKBNR b KQkq - d7d5", "A02", "Bird Opening: Double Duck Formation"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P2P1/8/PPP1PP1P/RNBQKBNR b KQkq - e7e5", "A80", "Dutch Defense: Hevendehl Gambit"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P2P1/8/PPP1PP1P/RNBQKBNR b KQkq - f5g4", null, null],
  [
    "rnbqkbnr/ppppp1pp/8/5p2/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - d7d5",
    "A80",
    "Queen's Pawn Game: Veresov Attack, Dutch System",
  ],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/3Q4/PPP1PPPP/RNB1KBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/3Q4/PPP1PPPP/RNB1KBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/3Q4/PPP1PPPP/RNB1KBNR b KQkq - e7e6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/3Q4/PPP1PPPP/RNB1KBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - e7e5", "A80", "Dutch Defense: Omega-Isis Gambit"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/6P1/PPP1PP1P/RNBQKBNR b KQkq - c7c6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/6P1/PPP1PP1P/RNBQKBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/6P1/PPP1PP1P/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/7P/PPP1PPP1/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - b1c3", "A80", "Dutch Defense: Raphael Variation"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c1f4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c1g5", "A80", "Dutch Defense: Hopton Attack"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", "A84", "Dutch Defense"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - d1d3", "A80", "Dutch Defense: Alapin Variation"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", "A82", "Dutch Defense: Staunton Gambit"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g2g3", "A81", "Dutch Defense: Fianchetto Attack"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g2g4", "A80", "Dutch Defense: Krejcik Gambit"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - h2h3", "A80", "Dutch Defense: Korchnoi Attack"],
  ["rnbqkbnr/ppppp1pp/8/5p2/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f5e4", "A82", "Dutch Defense: Staunton Gambit Accepted"],
  ["rnbqkbnr/ppppp1pp/8/5p2/4P2P/8/PPPP1PP1/RNBQKBNR b KQkq - f5e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - f5e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/4P3/5P2/PPPP2PP/RNBQKBNR b KQkq - f5e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/4P3/6P1/PPPP1P1P/RNBQKBNR b KQkq - f5e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/4PP2/8/PPPP2PP/RNBQKBNR b KQkq - f5e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - e2e4", "A02", "Bird Opening: Wagner-Zwitersch Gambit"],
  ["rnbqkbnr/ppppp1pp/8/5p2/7P/8/PPPPPPP1/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/8/1P6/P1PPPPPP/RNBQKBNR w KQkq - c1b2", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/8/1P6/PBPPPPPP/RN1QKBNR b KQkq - e7e6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/8/3P1N2/PPP1PPPP/RNBQKB1R b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - d2d3", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - e2e4", "A04", "Zukertort Opening: Lisitsyn Gambit"],
  ["rnbqkbnr/ppppp1pp/8/5p2/8/5P2/PPPPP1PP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/5p2/8/6P1/PPPPPP1P/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/7Q/4p3/6P1/PPPP1P1P/RNB1KBNR b KQkq - g7g6", "A00", "Hungarian Opening: Pachman Gambit"],
  ["rnbqkbnr/ppppp1pp/8/8/3P2p1/8/PPP1PP1P/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/ppppp1pp/8/8/3PP1p1/8/PPP2P1P/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/ppppp1pp/8/8/3Pp3/2N5/PPP2PPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppppp1pp/8/8/3Pp3/8/PPP2PPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/ppppp1pp/8/8/3Pp3/8/PPP2PPP/RNBQKBNR w KQkq - b1d2",
    "A82",
    "Dutch Defense: Staunton Gambit, American Attack",
  ],
  ["rnbqkbnr/ppppp1pp/8/8/4p2P/8/PPPP1PP1/RNBQKBNR w KQkq - d2d3", "A00", "Kádas Opening: Steinbok Gambit"],
  ["rnbqkbnr/ppppp1pp/8/8/4p3/2N5/PPPP1PPP/R1BQKBNR w KQkq - d2d3", "A00", "Van Geet Opening: Kluever Gambit"],
  ["rnbqkbnr/ppppp1pp/8/8/4p3/5P2/PPPP2PP/RNBQKBNR w KQkq - b1c3", "A00", "Barnes Opening: Gedult Gambit"],
  ["rnbqkbnr/ppppp1pp/8/8/4p3/6P1/PPPP1P1P/RNBQKBNR w KQkq - d1h5", null, null],
  ["rnbqkbnr/ppppp1pp/8/8/4pP2/2N5/PPPP2PP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/ppppp1pp/8/8/4pP2/8/PPPP2PP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/ppppp2p/6p1/5p2/2PP4/2N5/PP2PPPP/R1BQKBNR b KQkq - g8h6", "A84", "Dutch Defense: Bladel Variation"],
  ["rnbqkbnr/ppppp2p/6p1/5p2/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  [
    "rnbqkbnr/ppppp2p/6p1/5p2/3P4/3Q4/PPP1PPPP/RNB1KBNR w KQkq - g2g4",
    "A80",
    "Dutch Defense: Manhattan Gambit, Anti-Leningrad",
  ],
  ["rnbqkbnr/ppppp2p/6p1/5p2/3P4/6P1/PPP1PP1P/RNBQKBNR w KQkq - f1g2", null, null],
  ["rnbqkbnr/ppppp2p/6p1/5p2/3P4/6P1/PPP1PPBP/RNBQK1NR b KQkq - f8g7", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/2B1P3/8/PPPP1PPP/RNBQK1NR b KQkq - f8g7", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/2P1P3/8/PP1P1PPP/RNBQKBNR b KQkq - e7e5", "A10", "English Opening: Adorjan Defense"],
  ["rnbqkbnr/pppppp1p/6p1/8/2P5/2N5/PP1PPPPP/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - f8g7", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3P3P/8/PPP1PPP1/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3P4/2N5/PPP1PPPP/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3P4/5N2/PPP1PPPP/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - c2c4", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3P4/8/PPP1PPPP/RNBQKBNR w KQkq - h2h4", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f7f5", "B06", "Modern Defense: Fianchetto Gambit"],
  ["rnbqkbnr/pppppp1p/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f8g7", "B06", "Modern Defense"],
  ["rnbqkbnr/pppppp1p/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - g8f6", "B06", "Modern Defense: Norwegian Defense"],
  ["rnbqkbnr/pppppp1p/6p1/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - g8h6", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/4P3/2N5/PPPP1PPP/R1BQKBNR b KQkq - f8g7", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/4P3/5N2/PPPP1PPP/RNBQKB1R b KQkq - f8g7", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - b1c3", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - f1c4", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/8/2N5/PPPPPPPP/R1BQKBNR w KQkq - h2h4", "A00", "Van Geet Opening: Myers Attack"],
  ["rnbqkbnr/pppppp1p/6p1/8/8/3P4/PPP1PPPP/RNBQKBNR w KQkq - g2g4", "A00", "Mieses Opening: Myers Spike Attack"],
  ["rnbqkbnr/pppppp1p/6p1/8/8/5N2/PPPPPPPP/RNBQKB1R w KQkq - d2d4", null, null],
  ["rnbqkbnr/pppppp1p/6p1/8/8/N7/PPPPPPPP/R1BQKBNR w KQkq - g2g4", "A00", "Sodium Attack: Chenoboskion Variation"],
  ["rnbqkbnr/pppppp1p/8/6p1/2P5/8/PP1PPPPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pppppp1p/8/6p1/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - e7e5", "A10", "English Opening: Zilbermints Gambit"],
  ["rnbqkbnr/pppppp1p/8/6p1/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - f8g7", "A10", "English Opening: Myers Gambit"],
  ["rnbqkbnr/pppppp1p/8/6p1/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - e7e5", "B00", "Borg Defense: Zilbermints Gambit"],
  ["rnbqkbnr/pppppp1p/8/6p1/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - f8g7", "B00", "Borg Defense: Borg Gambit"],
  ["rnbqkbnr/pppppp1p/8/6p1/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - h7h6", null, null],
  ["rnbqkbnr/pppppp1p/8/6p1/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  [
    "rnbqkbnr/pppppp1p/8/6p1/6P1/8/PPPPPP1P/RNBQKBNR w KQkq - f2f4",
    "A00",
    "Grob Opening: Double Grob, Coca-Cola Gambit",
  ],
  ["rnbqkbnr/pppppp2/7p/6p1/3PP2P/8/PPP2PP1/RNBQKBNR b KQkq - g5g4", "B00", "Borg Defense: Troon Gambit"],
  ["rnbqkbnr/pppppp2/7p/6p1/3PP3/8/PPP2PPP/RNBQKBNR w KQkq - h2h4", null, null],
  ["rnbqkbnr/ppppppp1/7p/8/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - e7e5", "B00", "Carr Defense: Zilbermints Gambit"],
  ["rnbqkbnr/ppppppp1/7p/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppppppp1/7p/8/5P2/5N2/PPPPP1PP/RNBQKB1R b KQkq - g7g5", "A02", "Bird Opening: Hobbs-Zilbermints Gambit"],
  ["rnbqkbnr/ppppppp1/7p/8/5P2/8/PPPPP1PP/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/ppppppp1/8/7p/3PP3/8/PPP2PPP/RNBQKBNR b KQkq - g8f6", "B00", "Goldsmith Defense: Picklepuss Defense"],
  ["rnbqkbnr/ppppppp1/8/7p/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/ppppppp1/8/7p/8/5NP1/PPPPPP1P/RNBQKB1R b KQkq - h5h4", "A00", "Hungarian Opening: Van Kuijk Gambit"],
  ["rnbqkbnr/ppppppp1/8/7p/8/6P1/PPPPPP1P/RNBQKBNR w KQkq - g1f3", null, null],
  ["rnbqkbnr/ppppppp1/8/7p/8/7P/PPPPPPP1/RNBQKBNR w KQkq - g2g4", "A00", "Clemenz Opening: Spike Lee Gambit"],
  ["rnbqkbnr/pppppppp/8/3P4/4P3/8/PPP2PPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppppppp/8/3P4/8/8/PPP1PPPP/RNBQKBNR w KQkq - e2e4", null, null],
  [
    "rnbqkbnr/pppppppp/8/4P3/3P4/8/PPP2PPP/RNBQKBNR b KQkq - f7f5",
    "B02",
    "Alekhine Defense: Brooklyn Variation, Everglades Variation",
  ],
  ["rnbqkbnr/pppppppp/8/4P3/8/8/PPPP1PPP/RNBQKBNR w KQkq - d2d4", null, null],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - b7b5", "A00", "Polish Opening: Symmetrical Variation"],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - b8c6", "A00", "Polish Opening: Grigorian Variation"],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - c7c5", "A00", "Polish Opening: Birmingham Gambit"],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - c7c6", "A00", "Polish Opening: Outflank Variation"],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - d7d5", "A00", "Polish Opening, with d5"],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - e7e6", null, null],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - f7f5", "A00", "Polish Opening: Dutch Defense"],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppppppp/8/8/1P6/8/P1PPPPPP/RNBQKBNR b KQkq - g8h6", "A00", "Polish Opening: Karniewski Variation"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - b7b5", "A10", "English Opening: Jaenisch Gambit"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - b8c6", "A10", "English Opening: Anglo-Lithuanian Variation"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - c7c5", "A30", "English Opening: Symmetrical Variation"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - c7c6", "A11", "English Opening: Caro-Kann Defensive System"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - d7d5", "A10", "English Opening: Anglo-Scandinavian Defense"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - e7e5", "A20", "English Opening: King's English Variation"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - e7e6", "A13", "English Opening: Agincourt Defense"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - f7f5", "A10", "English Opening: Anglo-Dutch Defense"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - g7g5", "A10", "English Opening: Myers Defense"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - g7g6", "A10", "English Opening: Great Snake Variation"],
  ["rnbqkbnr/pppppppp/8/8/2P5/8/PP1PPPPP/RNBQKBNR b KQkq - g8f6", "A15", "English Opening: Anglo-Indian Defense"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - b7b5", "A40", "Polish Defense"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - b7b6", "A40", "English Defense"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - b8a6", "A40", "Australian Defense"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - b8c6", "A40", "Mikenas Defense"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - c7c5", "A43", "Benoni Defense: Old Benoni"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - c7c6", null, null],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - d7d5", "D00", "Queen's Pawn Game"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - d7d6", "A41", "Queen's Pawn Game"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - e7e5", "A40", "Englund Gambit"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - e7e6", "A40", "Horwitz Defense"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - f7f5", "A80", "Dutch Defense"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - g7g5", "A40", "Borg Defense: Borg Gambit"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - g7g6", "A40", "Queen's Pawn Game: Modern Defense"],
  ["rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b KQkq - g8f6", "A45", "Indian Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - a7a5", "B00", "Ware Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - a7a6", "B00", "St. George Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - b7b6", "B00", "Owen Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - b8a6", "B00", "Lemming Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - b8c6", "B00", "Nimzowitsch Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - c7c5", "B20", "Sicilian Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - c7c6", "B10", "Caro-Kann Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - d7d5", "B01", "Scandinavian Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - d7d6", "B00", "Pirc Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - e7e5", "C20", "King's Pawn Game"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - e7e6", "C00", "French Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - f7f5", "B00", "Duras Gambit"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - f7f6", "B00", "Barnes Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - g7g5", "B00", "Borg Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - g7g6", "B06", "Modern Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - g8f6", "B02", "Alekhine Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - g8h6", "B00", "Hippopotamus Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - h7h5", "B00", "Goldsmith Defense"],
  ["rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b KQkq - h7h6", "B00", "Carr Defense"],
  ["rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR b KQkq - b7b5", "A02", "Bird Opening: Myers Defense"],
  ["rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR b KQkq - d7d5", "A03", "Bird Opening: Dutch Variation"],
  ["rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR b KQkq - e7e5", "A02", "Bird Opening: From's Gambit"],
  ["rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR b KQkq - f7f5", null, null],
  ["rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR b KQkq - g7g5", "A02", "Bird Opening: Hobbs Gambit"],
  ["rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR b KQkq - g8h6", "A02", "Bird Opening: Horsefly Defense"],
  ["rnbqkbnr/pppppppp/8/8/5P2/8/PPPPP1PP/RNBQKBNR b KQkq - h7h6", null, null],
  ["rnbqkbnr/pppppppp/8/8/6P1/8/PPPPPP1P/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppppppp/8/8/6P1/8/PPPPPP1P/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/6P1/8/PPPPPP1P/RNBQKBNR b KQkq - f7f5", "A00", "Grob Opening: Alessi Gambit"],
  ["rnbqkbnr/pppppppp/8/8/6P1/8/PPPPPP1P/RNBQKBNR b KQkq - g7g5", "A00", "Grob Opening: Double Grob"],
  ["rnbqkbnr/pppppppp/8/8/7P/8/PPPPPPP1/RNBQKBNR b KQkq - a7a5", "A00", "Kádas Opening: Koola-Koola Variation"],
  ["rnbqkbnr/pppppppp/8/8/7P/8/PPPPPPP1/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqkbnr/pppppppp/8/8/7P/8/PPPPPPP1/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppppppp/8/8/7P/8/PPPPPPP1/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/7P/8/PPPPPPP1/RNBQKBNR b KQkq - f7f5", null, null],
  ["rnbqkbnr/pppppppp/8/8/7P/8/PPPPPPP1/RNBQKBNR b KQkq - g7g5", "A00", "Kádas Opening: Schneider Gambit"],
  ["rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR b KQkq - b7b5", "A01", "Nimzo-Larsen Attack: Polish Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR b KQkq - b7b6", "A01", "Nimzo-Larsen Attack: Symmetrical Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR b KQkq - c7c5", "A01", "Nimzo-Larsen Attack: English Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR b KQkq - d7d5", "A01", "Nimzo-Larsen Attack: Classical Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR b KQkq - e7e5", "A01", "Nimzo-Larsen Attack: Modern Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR b KQkq - f7f5", "A01", "Nimzo-Larsen Attack: Dutch Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/1P6/P1PPPPPP/RNBQKBNR b KQkq - g8f6", "A01", "Nimzo-Larsen Attack: Indian Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR b KQkq - b7b5", "A00", "Van Geet Opening: Laroche Gambit"],
  ["rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR b KQkq - c7c5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR b KQkq - d7d6", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR b KQkq - e7e5", "A00", "Van Geet Opening: Reversed Nimzowitsch"],
  ["rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR b KQkq - f7f5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/2N5/PPPPPPPP/R1BQKBNR b KQkq - g8f6", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/3P4/PPP1PPPP/RNBQKBNR b KQkq - c7c5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/3P4/PPP1PPPP/RNBQKBNR b KQkq - e7e5", "A00", "Mieses Opening: Reversed Rat"],
  ["rnbqkbnr/pppppppp/8/8/8/3P4/PPP1PPPP/RNBQKBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/4P3/PPPP1PPP/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - a7a5", "A04", "Zukertort Opening: Ware Defense"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - a7a6", "A04", "Zukertort Opening: St. George Defense"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - b7b5", "A04", "Zukertort Opening: Polish Defense"],
  [
    "rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - b7b6",
    "A04",
    "Zukertort Opening: Queenside Fianchetto Variation",
  ],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - b8a6", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - b8c6", "A04", "Zukertort Opening: Black Mustang Defense"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - c7c5", "A04", "Zukertort Opening: Sicilian Invitation"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - c7c6", "A04", "Zukertort Opening: Slav Invitation"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - d7d5", "A06", "Zukertort Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - d7d6", "A04", "Zukertort Opening: Pirc Invitation"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - e7e5", "A04", "Zukertort Opening: Ross Gambit"],
  [
    "rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - e7e6",
    "A04",
    "Zukertort Opening: Queen's Gambit Invitation",
  ],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - f7f5", "A04", "Zukertort Opening: Dutch Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - f7f6", "A04", "Zukertort Opening: Arctic Defense"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - g7g5", "A04", "Zukertort Opening: Herrstrom Gambit"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - g7g6", "A04", "Zukertort Opening: Kingside Fianchetto"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - g8f6", "A05", "Zukertort Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - g8h6", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/5N2/PPPPPPPP/RNBQKB1R b KQkq - h7h6", "A04", "Zukertort Opening: Basman Defense"],
  ["rnbqkbnr/pppppppp/8/8/8/5P2/PPPPP1PP/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/5P2/PPPPP1PP/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/5P2/PPPPP1PP/RNBQKBNR b KQkq - f7f5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - b8c6", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - c7c5", "A00", "Hungarian Opening: Sicilian Invitation"],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - f7f5", "A00", "Hungarian Opening: Dutch Defense"],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - g7g5", "A00", "Hungarian Opening: Myers Defense"],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - g7g6", "A00", "Hungarian Opening: Symmetrical Variation"],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - g8f6", "A00", "Hungarian Opening: Indian Defense"],
  ["rnbqkbnr/pppppppp/8/8/8/6P1/PPPPPP1P/RNBQKBNR b KQkq - h7h5", "A00", "Lasker Simul Special"],
  ["rnbqkbnr/pppppppp/8/8/8/7N/PPPPPPPP/RNBQKB1R b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/7P/PPPPPPP1/RNBQKBNR b KQkq - d7d5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/7P/PPPPPPP1/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/7P/PPPPPPP1/RNBQKBNR b KQkq - h7h5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - a2a3", "A00", "Anderssen's Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - a2a4", "A00", "Ware Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - b1a3", "A00", "Sodium Attack"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - b1c3", "A00", "Van Geet Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - b2b3", "A01", "Nimzo-Larsen Attack"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - b2b4", "A00", "Polish Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - c2c3", "A00", "Saragossa Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - c2c4", "A10", "English Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - d2d3", "A00", "Mieses Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - d2d4", "A40", "Queen's Pawn Game"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - e2e3", "A00", "Van't Kruijs Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - e2e4", "B00", "King's Pawn Game"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - f2f3", "A00", "Barnes Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - f2f4", "A02", "Bird Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - g1f3", "A04", "Zukertort Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - g1h3", "A00", "Amar Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - g2g3", "A00", "Hungarian Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - g2g4", "A00", "Grob Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - h2h3", "A00", "Clemenz Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - h2h4", "A00", "Kádas Opening"],
  ["rnbqkbnr/pppppppp/8/8/8/N7/PPPPPPPP/R1BQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/N7/PPPPPPPP/R1BQKBNR b KQkq - g7g6", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/P7/1PPPPPPP/RNBQKBNR b KQkq - a7a5", null, null],
  ["rnbqkbnr/pppppppp/8/8/8/P7/1PPPPPPP/RNBQKBNR b KQkq - e7e5", null, null],
  ["rnbqkbnr/pppppppp/8/8/P7/8/1PPPPPPP/RNBQKBNR b KQkq - a7a5", "A00", "Ware Opening: Symmetric Variation"],
  ["rnbqkbnr/pppppppp/8/8/P7/8/1PPPPPPP/RNBQKBNR b KQkq - b7b5", null, null],
  ["rnbqkbnr/pppppppp/8/8/P7/8/1PPPPPPP/RNBQKBNR b KQkq - b7b6", null, null],
  ["rnbqkbnr/pppppppp/8/8/P7/8/1PPPPPPP/RNBQKBNR b KQkq - e7e5", null, null],
  [
    "rnbqr1k1/pp3pbp/3p1np1/2pP4/4P3/2N2N2/PP2BPPP/R1BQ1RK1 w - - f3d2",
    "A77",
    "Benoni Defense: Classical Variation, Czerniak Defense, Tal Line",
  ],
  [
    "rnbqr1k1/pp3pbp/3p1np1/2pP4/4P3/2N5/PP1NBPPP/R1BQ1RK1 b - - b8a6",
    "A78",
    "Benoni Defense: Classical Variation, Czerniak Defense",
  ],
  ["rnbqr1k1/pppp1ppp/5n2/4p3/1bP5/2N2NP1/PP1PPPBP/R1BQ1RK1 b - - e5e4", null, null],
  ["rnbqr1k1/pppp1ppp/5n2/4p3/1bP5/2N2NP1/PP1PPPBP/R1BQK2R w KQ - e1g1", null, null],
  ["rnbqr1k1/pppp1ppp/5n2/8/1bP1p3/2N2NP1/PP1PPPBP/R1BQ1RK1 w - - f3d4", null, null],
  [
    "rnbqr1k1/pppp1ppp/5n2/8/1bPNp3/2N3P1/PP1PPPBP/R1BQ1RK1 b - - b8c6",
    "A29",
    "English Opening: King's English Variation, Four Knights Variation, Fianchetto Line, Delayed .. Nc6",
  ],
  [
    "rnbr2k1/pp2ppbp/5np1/2p5/2P1P3/2N1BP2/PP4PP/R3KBNR w KQ - e3c5",
    "E81",
    "King's Indian Defense: Sämisch Variation, Sämisch Gambit Accepted",
  ],
  [
    "rnbr2k1/ppp1qpp1/7p/3p4/2PP4/1Q2PN2/P4PPP/R3KB1R b KQ - c8e6",
    "D57",
    "Queen's Gambit Declined: Lasker Defense, Bernstein Variation, Mar del Plata Gambit",
  ],
  ["rnbr2k1/ppp1qpp1/7p/3p4/3P4/1QP1PN2/P4PPP/R3KB1R w KQ - c3c4", null, null],
  ["rnq1kb1r/pp2pppp/5n2/3p1b2/3P4/1Q2PN2/PP1B1PPP/RN2KB1R b KQkq - e7e6", null, null],
  ["rnq1kb1r/pp2pppp/5n2/3p1b2/3P4/1Q2PN2/PP3PPP/RNB1KB1R w KQkq - c1d2", null, null],
  [
    "rnq1kb1r/pp3ppp/4pn2/3p1b2/3P4/1Q2PN2/PP1B1PPP/RN2KB1R w KQkq - b1a3",
    "D12",
    "Slav Defense: Quiet Variation, Landau Variation",
  ],
  [
    "rqb1kbnr/1p1p1ppp/p1n1p3/1N6/4P3/2N1B3/PPP2PPP/R2QKB1R w KQkq - e3b6",
    "B47",
    "Sicilian Defense: Taimanov Variation, Bastrikov Variation, Ponomariov Gambit",
  ],
  ["rqb1kbnr/pp1p1ppp/2n1p3/1N6/4P3/2N1B3/PPP2PPP/R2QKB1R b KQkq - a7a6", null, null],
  ["rqb1kbnr/pp1p1ppp/2n1p3/1N6/4P3/2N5/PPP2PPP/R1BQKB1R w KQkq - c1e3", null, null],
];
